(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory();
	else
		root["index"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 46);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(402)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(408)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_index_of__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_index_of__);



// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// Builds a RegExp
/* harmony default export */ __webpack_exports__["a"] = (function (regex, map, flags) {
  flags = flags || '';

  if (typeof regex !== 'string') {
    if (regex.global && flags.indexOf('g') < 0) {
      flags += 'g';
    }

    if (regex.ignoreCase && flags.indexOf('i') < 0) {
      flags += 'i';
    }

    if (regex.multiline && flags.indexOf('m') < 0) {
      flags += 'm';
    }

    regex = regex.source;
  }

  return new RegExp(regex.replace(/#\{(\w+)\}/g, function (match, name) {
    var newRegex = map[name] || '';

    if (typeof newRegex !== 'string') {
      newRegex = newRegex.source;
    }

    return newRegex;
  }), flags);
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(423).noConflict();

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CONSTS = {
  THEMES: {
    DARK: 'theme-dark',
    LIGHT: 'theme-light'
  },
  MARKDOWN: {
    PREFIX: '#md#',
    SUFFIX: '#/md#'
  },

  URL_REGEXP: '(?:(?:(?:https?|ftp):)\\/\\/|(?:(?:mailto):))' + '(?:\\S+(?::\\S*)?@)?' + '(?:' + '(?!(?:10|127)(?:\\.\\d{1,3}){3})' + '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' + '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' + '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' + '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' + '|' + '(?:' + '(?:' + '[a-z0-9\xA1-\\uffff]' + '[a-z0-9\xA1-\\uffff_-]{0,62}' + ')?' + '[a-z0-9\xA1-\\uffff_-]\\.' + ')+' + '(?:[a-z0-9\xA1-\\uffff_-]{2,}\\.?)' + ')' + '(?::\\d{2,5})?' + '(?:[/?#]\\S*)?',

  HTML_TAGS_REGEXP: '<[^><]*>',
  HTML_END_DIV_REGEXP: '<\\s*\\/div\\s*>',

  LE_EDITOR: {
    SUPPORTED_QUILL_FORMATS: {
      BOLD: 'bold',
      ITALIC: 'italic',
      LE_QUILL_LINK: 'leQuillLink',
      LE_QUILL_AUTOCOMPLETE: 'leQuillAutocomplete',
      UNDERLINE: 'underline',
      DIRECTION: 'direction',
      ALIGN: 'align',
      BULLET: 'bullet',
      LIST: 'list'
    },
    SUPPORTED_HTML_ELEMENTS: {
      STRONG: 'strong',
      I: 'i',
      EM: 'em',
      BOLD: 'b',
      U: 'u',
      A: 'a',
      BR: 'br',
      SPAN: 'span',
      DIV: 'div',
      UL: 'ul',
      OL: 'ol',
      LI: 'li',
      P: 'p'
    },
    WRITE_DIRECTION: {
      LTR: 'ltr',
      RTL: 'rtl',
      AUTO: 'auto'
    },
    WRITE_ALIGN: {
      LEFT: 'left',
      RIGHT: 'right'
    },
    LINE_HEIGHT: 18,
    MIN_ROWS: 3,
    MAX_ROWS: 11,
    SUBMIT_KEY: {
      ENTER: 'enter',
      CTRL_ENTER: 'ctrl+enter'
    }
  },
  LE_DIALOG: {
    VARIANTS: {
      WARNING: 'warning',
      ERROR: 'error'
    }
  },

  LE_BUBBLE: {
    PLACEMENTS: {
      AUTO: 'auto-center',
      AUTO_START: 'auto-start',
      AUTO_END: 'auto-end',
      TOP: 'top-center',
      TOP_START: 'top-start',
      TOP_END: 'top-end',
      RIGHT: 'right-center',
      RIGHT_START: 'right-start',
      RIGHT_END: 'right-end',
      BOTTOM: 'bottom-center',
      BOTTOM_START: 'bottom-start',
      BOTTOM_END: 'bottom-end',
      LEFT: 'left-center',
      LEFT_START: 'left-start',
      LEFT_END: 'left-end'
    },
    THEMES: {
      DARK: 'dark'
    }
  },
  LE_TABLE: {
    SORT_DIRECTION: {
      DESC: 'desc',
      ASC: 'asc'
    },
    EMPTY_ORIENTATION: {
      HORIZONTAL: 'horizontal',
      VERTICAL: 'vertical'
    },
    ROW_HEIGHT: 60,
    HEADER_HEIGHT: 55
  },
  LE_TABS: {
    VARIANTS: {
      PRIMARY: 'primary',
      DEFAULT: 'default',
      SECONDARY: 'secondary'
    }
  },
  LE_BUTTON: {
    VARIANTS: {
      DEFAULT: 'default',
      PRIMARY: 'primary',
      LINK: 'link',
      CANCEL: 'cancel'
    },
    SIZE: {
      SMALL: 'small',
      DEFAULT: 'default',
      LARGE: 'large'
    }
  },
  LE_CHECKBOX: {
    STATES: {
      UNCHECKED: 'unchecked',
      CHECKED: 'checked',
      INDETERMINATE: 'indeterminate'
    }
  },
  LE_SELECT_CONSTS: {
    TYPE: {
      MULTISELECT: 'multiselect',
      SINGLESELECT: 'singleselect',
      DROPDOWN: 'dropdown',
      MENU: 'menu',
      LIST_ONLY: 'listOnly'
    },
    BUBBLE_LIST_ALIGN: {
      LEFT: 'left',
      RIGHT: 'right'
    },
    ERRORS: {
      SINGLE_SELECT: {
        INVALID_ITEM: 'Please select an item from the list.'
      },
      MULTI_SELECT: {
        INVALID_ITEM: 'Please select an item from the list.',
        UNFINISHED_CREATE: 'press ENTER to submit your changes.'
      }
    }
  },
  LE_DATE_CONSTS: {
    TYPE: {
      DATE_INPUT_FIELD: 'dateInputField',
      DATE_AND_TIME_PICKER: 'dateAndTimePicker'
    }
  },
  LE_INPUT_FIELD: {
    TYPE: {
      TEXT: 'text',
      SEARCH: 'search',
      POSITIVE_INTEGER_OR_ZERO: 'positiveIntegerOrZero',
      NEGATIVE_OR_POSITIVE_FLOAT_OR_ZERO: 'negativeOrPositiveFloatOrZero',
      NEGATIVE_OR_POSITIVE_INTEGER_OR_ZERO: 'negativeOrPositiveIntegerOrZero',
      PASSWORD: 'password'
    }
  },
  HOUR_FORMATS: {
    AM_PM: '12',
    24: '24'
  },

  ROLES: {
    AGENT: 'AGENT',
    ASSIGNED_AGENT: 'ASSIGNED_AGENT',
    CONSUMER: 'CONSUMER',
    CONTROLLER: 'CONTROLLER',
    MANAGER: 'MANAGER',
    READER: 'READER'
  },

  EVENT_TYPES: {
    ACCEPT_STATUS: 'AcceptStatusEvent',
    CHAT_STATE: 'ChatStateEvent',
    CONTENT: 'ContentEvent',
    RICH_CONTENT: 'RichContentEvent'
  },
  KEYBOARD_KEYS: {
    TAB: 'Tab',
    ARROW_RIGHT: 'ArrowRight',
    SPACE: ' ',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SHIFT: 'Shift'
  },
  KEY_CODES: {
    TAB: 9,
    ARROW_RIGHT: 39,
    SPACE: 32
  },
  LE_NOTIFIER: {
    VARIANTS: {
      DEFAULT: 'default',
      SUCCESS: 'success',
      ERROR: 'error'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CONSTS);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(52)('wks');
var uid = __webpack_require__(38);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(30);
var hide = __webpack_require__(21);
var redefine = __webpack_require__(18);
var ctx = __webpack_require__(55);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(295);
var toPrimitive = __webpack_require__(78);
var dP = Object.defineProperty;

exports.f = __webpack_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(23);
var advanceStringIndex = __webpack_require__(73);
var regExpExec = __webpack_require__(74);

// @@match logic
__webpack_require__(76)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_bubble_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6a69484_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_bubble_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_bubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6a69484_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_bubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(20);
var toLength = __webpack_require__(23);
var toInteger = __webpack_require__(50);
var advanceStringIndex = __webpack_require__(73);
var regExpExec = __webpack_require__(74);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(76)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var hide = __webpack_require__(21);
var has = __webpack_require__(24);
var SRC = __webpack_require__(38)('src');
var $toString = __webpack_require__(559);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(30).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var HTML_ENTITIES = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#39;'
};
/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  return text && text.replace(/[&"'><]/g, function (character) {
    return HTML_ENTITIES[character];
  });
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(49);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(11) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateUUID; });

var toHashCode = function toHashCode(value) {
  var seed = btoa(value);
  var hash = 0;
  for (var i = 0; i < seed.length; i += 1) {
    hash += seed.charCodeAt(i);
  }
  return hash;
};

var ltrChars = 'A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
var rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
var rtlRgx = new RegExp('^[^' + rtlChars + ']*[' + ltrChars + ']');
var ltrRgx = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

var DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};

var detectTextDirection = function detectTextDirection(str, baseDirection) {
  var targetDirection = baseDirection || DIRECTIONS.LTR;
  var textDirection = null;
  if (targetDirection === DIRECTIONS.LTR) {
    textDirection = !ltrRgx.test(str) ? DIRECTIONS.LTR : DIRECTIONS.RTL;
  } else {
    textDirection = !rtlRgx.test(str) ? DIRECTIONS.RTL : DIRECTIONS.LTR;
  }
  return textDirection;
};

var generateUUID = function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  toHashCode: toHashCode,
  detectTextDirection: detectTextDirection
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(50);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(79);
var defined = __webpack_require__(49);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp_extractUrl__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__regexp_invalidUrlWithoutProtocolPrecedingChars__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_idna__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__regexp_validAsciiDomain__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__regexp_validTcoUrl__ = __webpack_require__(315);




// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





var DEFAULT_PROTOCOL = 'https://';
var DEFAULT_PROTOCOL_OPTIONS = {
  extractUrlsWithoutProtocol: true
};
var MAX_URL_LENGTH = 4096;
var MAX_TCO_SLUG_LENGTH = 40;

var extractUrlsWithIndices = function extractUrlsWithIndices(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PROTOCOL_OPTIONS;

  if (!text || (options.extractUrlsWithoutProtocol ? !text.match(/\./) : !text.match(/:/))) {
    return [];
  }

  var urls = [];

  var _loop = function _loop() {
    var before = RegExp.$2;
    var url = RegExp.$3;
    var protocol = RegExp.$4;
    var domain = RegExp.$5;
    var path = RegExp.$7;
    var endPosition = __WEBPACK_IMPORTED_MODULE_4__regexp_extractUrl__["a" /* default */].lastIndex;
    var startPosition = endPosition - url.length;

    if (!isValidUrl(url, protocol || DEFAULT_PROTOCOL, domain)) {
      return "continue";
    } // extract ASCII-only domains.


    if (!protocol) {
      if (!options.extractUrlsWithoutProtocol || before.match(__WEBPACK_IMPORTED_MODULE_5__regexp_invalidUrlWithoutProtocolPrecedingChars__["a" /* default */])) {
        return "continue";
      }

      var lastUrl = null;
      var asciiEndPosition = 0;
      domain.replace(__WEBPACK_IMPORTED_MODULE_7__regexp_validAsciiDomain__["a" /* default */], function (asciiDomain) {
        var asciiStartPosition = domain.indexOf(asciiDomain, asciiEndPosition);
        asciiEndPosition = asciiStartPosition + asciiDomain.length;
        lastUrl = {
          url: asciiDomain,
          indices: [startPosition + asciiStartPosition, startPosition + asciiEndPosition]
        };
        urls.push(lastUrl);
      }); // no ASCII-only domain found. Skip the entire URL.

      if (lastUrl == null) {
        return "continue";
      } // lastUrl only contains domain. Need to add path and query if they exist.


      if (path) {
        lastUrl.url = url.replace(domain, lastUrl.url);
        lastUrl.indices[1] = endPosition;
      }
    } else {
      // In the case of t.co URLs, don't allow additional path characters.
      if (url.match(__WEBPACK_IMPORTED_MODULE_8__regexp_validTcoUrl__["a" /* default */])) {
        var tcoUrlSlug = RegExp.$1;

        if (tcoUrlSlug && tcoUrlSlug.length > MAX_TCO_SLUG_LENGTH) {
          return "continue";
        } else {
          url = RegExp.lastMatch;
          endPosition = startPosition + url.length;
        }
      }

      urls.push({
        url: url,
        indices: [startPosition, endPosition]
      });
    }
  };

  while (__WEBPACK_IMPORTED_MODULE_4__regexp_extractUrl__["a" /* default */].exec(text)) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return urls;
};

var isValidUrl = function isValidUrl(url, protocol, domain) {
  var urlLength = url.length;
  var punycodeEncodedDomain = __WEBPACK_IMPORTED_MODULE_6__lib_idna__["a" /* default */].toAscii(domain);

  if (!punycodeEncodedDomain || !punycodeEncodedDomain.length) {
    return false;
  }

  urlLength = urlLength + punycodeEncodedDomain.length - domain.length;
  return protocol.length + urlLength <= MAX_URL_LENGTH;
};

/* harmony default export */ __webpack_exports__["a"] = (extractUrlsWithIndices);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_clone__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extractHtmlAttrsFromOptions__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__linkToCashtag__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__linkToHashtag__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__linkToUrl__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__linkToMentionAndList__ = __webpack_require__(332);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0






 // Default CSS class for auto-linked lists (along with the url class)

var DEFAULT_LIST_CLASS = 'tweet-url list-slug'; // Default CSS class for auto-linked usernames (along with the url class)

var DEFAULT_USERNAME_CLASS = 'tweet-url username'; // Default CSS class for auto-linked hashtags (along with the url class)

var DEFAULT_HASHTAG_CLASS = 'tweet-url hashtag'; // Default CSS class for auto-linked cashtags (along with the url class)

var DEFAULT_CASHTAG_CLASS = 'tweet-url cashtag';
/* harmony default export */ __webpack_exports__["a"] = (function (text, entities, options) {
  var options = Object(__WEBPACK_IMPORTED_MODULE_1__lib_clone__["a" /* default */])(options || {});
  options.hashtagClass = options.hashtagClass || DEFAULT_HASHTAG_CLASS;
  options.hashtagUrlBase = options.hashtagUrlBase || 'https://twitter.com/search?q=%23';
  options.cashtagClass = options.cashtagClass || DEFAULT_CASHTAG_CLASS;
  options.cashtagUrlBase = options.cashtagUrlBase || 'https://twitter.com/search?q=%24';
  options.listClass = options.listClass || DEFAULT_LIST_CLASS;
  options.usernameClass = options.usernameClass || DEFAULT_USERNAME_CLASS;
  options.usernameUrlBase = options.usernameUrlBase || 'https://twitter.com/';
  options.listUrlBase = options.listUrlBase || 'https://twitter.com/';
  options.htmlAttrs = Object(__WEBPACK_IMPORTED_MODULE_2__extractHtmlAttrsFromOptions__["a" /* default */])(options);
  options.invisibleTagAttrs = options.invisibleTagAttrs || "style='position:absolute;left:-9999px;'"; // remap url entities to hash

  var urlEntities, i, len;

  if (options.urlEntities) {
    urlEntities = {};

    for (i = 0, len = options.urlEntities.length; i < len; i++) {
      urlEntities[options.urlEntities[i].url] = options.urlEntities[i];
    }

    options.urlEntities = urlEntities;
  }

  var result = '';
  var beginIndex = 0; // sort entities by start index

  entities.sort(function (a, b) {
    return a.indices[0] - b.indices[0];
  });
  var nonEntity = options.htmlEscapeNonEntities ? __WEBPACK_IMPORTED_MODULE_3__htmlEscape__["a" /* default */] : function (text) {
    return text;
  };

  for (var i = 0; i < entities.length; i++) {
    var entity = entities[i];
    result += nonEntity(text.substring(beginIndex, entity.indices[0]));

    if (entity.url) {
      result += Object(__WEBPACK_IMPORTED_MODULE_6__linkToUrl__["a" /* default */])(entity, text, options);
    } else if (entity.hashtag) {
      result += Object(__WEBPACK_IMPORTED_MODULE_5__linkToHashtag__["a" /* default */])(entity, text, options);
    } else if (entity.screenName) {
      result += Object(__WEBPACK_IMPORTED_MODULE_7__linkToMentionAndList__["a" /* default */])(entity, text, options);
    } else if (entity.cashtag) {
      result += Object(__WEBPACK_IMPORTED_MODULE_4__linkToCashtag__["a" /* default */])(entity, text, options);
    }

    beginIndex = entity.indices[1];
  }

  result += nonEntity(text.substring(beginIndex, text.length));
  return result;
});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_text_with_highlight_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45cffbac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_text_with_highlight_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var inheritIfRequired = __webpack_require__(561);
var dP = __webpack_require__(12).f;
var gOPN = __webpack_require__(58).f;
var isRegExp = __webpack_require__(301);
var $flags = __webpack_require__(54);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(11) && (!CORRECT_NEW || __webpack_require__(13)(function () {
  re2[__webpack_require__(7)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(18)(global, 'RegExp', $RegExp);
}

__webpack_require__(563)('RegExp');


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var atSigns = /[@＠]/;
/* harmony default export */ __webpack_exports__["a"] = (atSigns);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTENT_MESSAGE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HISTORY_MESSAGE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNKNOWN_CONTENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAGE_AUDIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PARTICIPANT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NUMBER_OF_COLORS; });
var CONTENT_MESSAGE_TYPES = {
  PLAIN_TEXT: 'text/plain',
  CAROUSEL: 'carousel',
  CARD_HORIZONTAL: 'horizontal',
  CARD_VERTICAL: 'vertical',
  LIST: 'list',
  SECURE_FORM_INVITATION: 'forms/secure-invitation',
  SECURE_FORM_SUBMISSION: 'forms/secure-submission',
  EXTERNAL_FILE: 'external/file',
  HOSTED_FILE: 'hosted/file',
  IMAGE: 'image'
};

var HISTORY_MESSAGE_TYPES = {
  PLAIN_TEXT: 'TEXT_PLAIN',
  RICH_CONTENT: 'RICH_CONTENT',
  SECURE_FORM_INVITATION: 'SECURE_FORM_INVITATION',
  SECURE_FORM_SUBMISSION: 'SECURE_FORM_SUBMIT',
  HOSTED_FILE: 'HOSTED_FILE',
  LINK: 'LINK'
};

var UNKNOWN_CONTENT_TYPE = 'unknown';

var MESSAGE_AUDIENCES = {
  ALL: 'ALL',
  AGENTS_AND_MANAGERS: 'AGENTS_AND_MANAGERS'
};

var MESSAGE_STATUSES = {
  LOADING: 'LOADING',
  SENT: 'SENT',
  ACCEPT: 'ACCEPT',
  READ: 'READ',
  VIEWED: 'VIEWED'
};

var PARTICIPANT_TYPES = {
  CONSUMER: 'Consumer'
};

var NUMBER_OF_COLORS = 19;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_button_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69839bca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_button_vue__ = __webpack_require__(412);
function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69839bca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69839bca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_checkbox_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95497692_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_checkbox_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95497692"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95497692_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var clickOutside = {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (clickOutside);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(544).Buffer))

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(13);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var latinAccentChars = /\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u024F\u0253\u0254\u0256\u0257\u0259\u025B\u0263\u0268\u026F\u0272\u0289\u028B\u02BB\u0300-\u036F\u1E00-\u1EFF/;
/* harmony default export */ __webpack_exports__["a"] = (latinAccentChars);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var nonBmpCodePairs = /[\uD800-\uDBFF][\uDC00-\uDFFF]/gm;
/* harmony default export */ __webpack_exports__["a"] = (nonBmpCodePairs);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
/* harmony default export */ __webpack_exports__["a"] = (function (o) {
  var r = {};

  for (var k in o) {
    if (o.hasOwnProperty(k)) {
      r[k] = o[k];
    }
  }

  return r;
});

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(300);
var enumBugKeys = __webpack_require__(84);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__liveperson_vv_tooltip__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentsIndex__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_2__utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CONSTS", function() { return __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leCheckbox"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leButton", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leButton"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTable", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTable"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leListPlusPreview", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leListPlusPreview"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leBubble", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leBubble"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTabs", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTabs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lePagination", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["lePagination"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leFilter", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leFilter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leSlider", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leSlider"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leSelect", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leSelect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTags", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTags"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leInputField", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leInputField"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leLoader", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leDialog", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leDialog"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTextEditor", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTextEditor"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leEditorToolbarButtons", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leEditorToolbarButtons"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leAccordion", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leAccordion"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leAccordionItem", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leAccordionItem"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leEmojies", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leEmojies"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leToggle", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leToggle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTextWithHighlight", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTextWithHighlight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leRadio", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leRadio"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leEllipsis", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leEllipsis"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leAudio", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leAudio"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leDatepicker", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leDatepicker"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTextarea", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTextarea"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leLinkEditor", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leLinkEditor"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leNotifier", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leNotifier"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTreeview", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTreeview"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTreeviewSimple", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTreeviewSimple"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leTranscript", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leTranscript"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leCombobox", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leCombobox"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leToggleSelectionIcon", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leToggleSelectionIcon"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leStepper", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["leStepper"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clickOutside", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["clickOutside"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "markdownToHtml", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["markdownToHtml"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "htmlToMarkdown", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["htmlToMarkdown"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "markdownToPlainText", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["markdownToPlainText"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dateTimeFilter", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["dateTimeFilter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFullTimeFormat", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["getFullTimeFormat"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getConversationColor", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["getConversationColor"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteTriggerOptionsModel", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["LeQuillAutocompleteTriggerOptionsModel"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteSelectKeysModel", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["LeQuillAutocompleteSelectKeysModel"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteSettingsModel", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["LeQuillAutocompleteSettingsModel"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranscriptTransformers", function() { return __WEBPACK_IMPORTED_MODULE_4__componentsIndex__["TranscriptTransformers"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "store", function() { return __WEBPACK_IMPORTED_MODULE_5__store__; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "moment", function() { return __WEBPACK_IMPORTED_MODULE_0_moment___default.a; });














var objToExport = Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__componentsIndex__, __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */], { CONSTS: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */], VTooltip: __WEBPACK_IMPORTED_MODULE_1__liveperson_vv_tooltip__["a" /* default */], store: __WEBPACK_IMPORTED_MODULE_5__store__, moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a });

/* harmony default export */ __webpack_exports__["default"] = (objToExport);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_input_field_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f01462e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_input_field_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f01462e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_input_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f01462e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_input_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_validCashtag__ = __webpack_require__(298);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  if (!text || text.indexOf('$') === -1) {
    return [];
  }

  var tags = [];
  text.replace(__WEBPACK_IMPORTED_MODULE_2__regexp_validCashtag__["a" /* default */], function (match, before, dollar, cashtag, offset, chunk) {
    var startPosition = offset + before.length;
    var endPosition = startPosition + cashtag.length + 1;
    tags.push({
      cashtag: cashtag,
      indices: [startPosition, endPosition]
    });
  });
  return tags;
});

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(30);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(53) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(56);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $indexOf = __webpack_require__(297)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(40)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(300);
var hiddenKeys = __webpack_require__(84).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_endHashtagMatch__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extractUrlsWithIndices__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp_hashSigns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__removeOverlappingEntities__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__regexp_validHashtag__ = __webpack_require__(316);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0






var extractHashtagsWithIndices = function extractHashtagsWithIndices(text, options) {
  if (!options) {
    options = {
      checkUrlOverlap: true
    };
  }

  if (!text || !text.match(__WEBPACK_IMPORTED_MODULE_4__regexp_hashSigns__["a" /* default */])) {
    return [];
  }

  var tags = [];
  text.replace(__WEBPACK_IMPORTED_MODULE_6__regexp_validHashtag__["a" /* default */], function (match, before, hash, hashText, offset, chunk) {
    var after = chunk.slice(offset + match.length);

    if (after.match(__WEBPACK_IMPORTED_MODULE_2__regexp_endHashtagMatch__["a" /* default */])) {
      return;
    }

    var startPosition = offset + before.length;
    var endPosition = startPosition + hashText.length + 1;
    tags.push({
      hashtag: hashText,
      indices: [startPosition, endPosition]
    });
  });

  if (options.checkUrlOverlap) {
    // also extract URL entities
    var urls = Object(__WEBPACK_IMPORTED_MODULE_3__extractUrlsWithIndices__["a" /* default */])(text);

    if (urls.length > 0) {
      var entities = tags.concat(urls); // remove overlap

      Object(__WEBPACK_IMPORTED_MODULE_5__removeOverlappingEntities__["a" /* default */])(entities); // only push back hashtags

      tags = [];

      for (var i = 0; i < entities.length; i++) {
        if (entities[i].hashtag) {
          tags.push(entities[i]);
        }
      }
    }
  }

  return tags;
};

/* harmony default export */ __webpack_exports__["a"] = (extractHashtagsWithIndices);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var hashSigns = /[#＃]/;
/* harmony default export */ __webpack_exports__["a"] = (hashSigns);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var invalidCharsGroup = /\uFFFE\uFEFF\uFFFF/;
/* harmony default export */ __webpack_exports__["a"] = (invalidCharsGroup);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var aFunction = __webpack_require__(56);
var toObject = __webpack_require__(20);
var fails = __webpack_require__(13);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(40)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_endMentionMatch__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp_validMentionOrList__ = __webpack_require__(103);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  if (!text || !text.match(__WEBPACK_IMPORTED_MODULE_2__regexp_atSigns__["a" /* default */])) {
    return [];
  }

  var possibleNames = [];
  text.replace(__WEBPACK_IMPORTED_MODULE_4__regexp_validMentionOrList__["a" /* default */], function (match, before, atSign, screenName, slashListname, offset, chunk) {
    var after = chunk.slice(offset + match.length);

    if (!after.match(__WEBPACK_IMPORTED_MODULE_3__regexp_endMentionMatch__["a" /* default */])) {
      slashListname = slashListname || '';
      var startPosition = offset + before.length;
      var endPosition = startPosition + screenName.length + slashListname.length + 1;
      possibleNames.push({
        screenName: screenName,
        listSlug: slashListname,
        indices: [startPosition, endPosition]
      });
    }
  });
  return possibleNames;
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__regexp_atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkToText__ = __webpack_require__(104);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



/* harmony default export */ __webpack_exports__["a"] = (function (entity, symbol, text, attributes, options) {
  var taggedSymbol = options.symbolTag ? "<".concat(options.symbolTag, ">").concat(symbol, "</").concat(options.symbolTag, ">") : symbol;
  text = Object(__WEBPACK_IMPORTED_MODULE_2__htmlEscape__["a" /* default */])(text);
  var taggedText = options.textWithSymbolTag ? "<".concat(options.textWithSymbolTag, ">").concat(text, "</").concat(options.textWithSymbolTag, ">") : text;

  if (options.usernameIncludeSymbol || !symbol.match(__WEBPACK_IMPORTED_MODULE_1__regexp_atSigns__["a" /* default */])) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__linkToText__["a" /* default */])(entity, taggedSymbol + taggedText, attributes, options);
  } else {
    return taggedSymbol + Object(__WEBPACK_IMPORTED_MODULE_3__linkToText__["a" /* default */])(entity, taggedText, attributes, options);
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is generated by scripts/buildConfig.js
/* harmony default export */ __webpack_exports__["a"] = ({
  version1: {
    version: 1,
    maxWeightedTweetLength: 140,
    scale: 1,
    defaultWeight: 1,
    transformedURLLength: 23,
    ranges: []
  },
  version2: {
    version: 2,
    maxWeightedTweetLength: 280,
    scale: 100,
    defaultWeight: 200,
    transformedURLLength: 23,
    ranges: [{
      start: 0,
      end: 4351,
      weight: 100
    }, {
      start: 8192,
      end: 8205,
      weight: 100
    }, {
      start: 8208,
      end: 8223,
      weight: 100
    }, {
      start: 8242,
      end: 8247,
      weight: 100
    }]
  },
  version3: {
    version: 3,
    maxWeightedTweetLength: 280,
    scale: 100,
    defaultWeight: 200,
    emojiParsingEnabled: true,
    transformedURLLength: 23,
    ranges: [{
      start: 0,
      end: 4351,
      weight: 100
    }, {
      start: 8192,
      end: 8205,
      weight: 100
    }, {
      start: 8208,
      end: 8223,
      weight: 100
    }, {
      start: 8242,
      end: 8247,
      weight: 100
    }]
  },
  defaults: {
    version: 3,
    maxWeightedTweetLength: 280,
    scale: 100,
    defaultWeight: 200,
    emojiParsingEnabled: true,
    transformedURLLength: 23,
    ranges: [{
      start: 0,
      end: 4351,
      weight: 100
    }, {
      start: 8192,
      end: 8205,
      weight: 100
    }, {
      start: 8208,
      end: 8223,
      weight: 100
    }, {
      start: 8242,
      end: 8247,
      weight: 100
    }]
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlUnreserved__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlPctEncoded__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDelims__ = __webpack_require__(116);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



 // These URL validation pattern strings are based on the ABNF from RFC 3986

var validateUrlPchar = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '#{validateUrlUnreserved}|' + '#{validateUrlPctEncoded}|' + '#{validateUrlSubDelims}|' + '[:|@]' + ')', {
  validateUrlUnreserved: __WEBPACK_IMPORTED_MODULE_1__validateUrlUnreserved__["a" /* default */],
  validateUrlPctEncoded: __WEBPACK_IMPORTED_MODULE_2__validateUrlPctEncoded__["a" /* default */],
  validateUrlSubDelims: __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDelims__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlPchar);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getFullTimeFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(6);




var HOUR_FORMATS = __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].HOUR_FORMATS;


var MOMENT_DATE_FORMAT = 'DD MMM. YYYY';
var MOMENT_24HOURS_FORMAT = 'HH:mm';
var MOMENT_12HOURS_FORMAT = 'hh:mma';
var DEFAULT_SEPARATOR = ' | ';
var MOMENT_FULL_TIME_12HOURS_FORMAT = 'hh:mm:ssa';
var MOMENT_FULL_TIME_24HOURS_FORMAT = 'HH:mm:ss';

function getFullTimeFormat(hoursSettings) {
  var hourFormat = MOMENT_FULL_TIME_24HOURS_FORMAT;
  if (HOUR_FORMATS.AM_PM === hoursSettings) {
    hourFormat = MOMENT_FULL_TIME_12HOURS_FORMAT;
  }

  return hourFormat;
}

function getHourFormat(hoursSettings) {
  var hourFormat = MOMENT_24HOURS_FORMAT;
  if (HOUR_FORMATS.AM_PM === hoursSettings) {
    hourFormat = MOMENT_12HOURS_FORMAT;
  }

  return hourFormat;
}

/* harmony default export */ __webpack_exports__["a"] = (function (hoursSettings, value, requestedFormat) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"])(value)) {
    return '';
  }
  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
  if (!date.isValid()) {
    return '';
  }

  var hourFormat = getHourFormat(hoursSettings);
  var dateFormat = MOMENT_DATE_FORMAT;

  var format = '' + dateFormat + DEFAULT_SEPARATOR + hourFormat;
  if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"])(requestedFormat)) {
    format = requestedFormat;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"])(requestedFormat)) {
    if (requestedFormat.dateOnly) {
      format = '' + dateFormat;
    } else if (requestedFormat.hourOnly) {
      format = '' + hourFormat;
    } else if (requestedFormat.separator) {
      format = format.replace(DEFAULT_SEPARATOR, requestedFormat.separator);
    }
  }

  return date.format(format);
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getConversationColor;
/* harmony export (immutable) */ __webpack_exports__["a"] = getConsumerMessageClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOriginatorNameForDisplay;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return replaceSpecificElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(33);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function getConversationColor(conversationId) {
  var hashValue = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].toHashCode(conversationId);
  return (hashValue % __WEBPACK_IMPORTED_MODULE_2__consts__["e" /* NUMBER_OF_COLORS */]).toString();
}

function getConsumerMessageClassName(conversationId) {
  return 'conversation-custom-background-color-' + getConversationColor(conversationId);
}

function getOriginatorNameForDisplay(originator) {
  var name = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(originator, 'agentNickname') || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(originator, 'agentFullName') || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(originator, 'nickName');
  if (!name) {
    name = (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(originator, 'firstName', '') + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(originator, 'lastName', '')).trim();
  }
  return name;
}

var replaceSpecificElement = function replaceSpecificElement(innerText, sourceElementType, targetElementType) {
  var template = document.createElement('template');
  template.innerHTML = innerText;
  var root = template.content || template;
  [].concat(_toConsumableArray(root.querySelectorAll(sourceElementType))).reverse().forEach(function (srcElementEl) {
    var parent = srcElementEl.parentElement || root;
    var trgElementEl = document.createElement(targetElementType);
    trgElementEl.innerHTML = srcElementEl.innerHTML;
    parent.replaceChild(trgElementEl, srcElementEl);
  });
  return template.innerHTML.toString().trim();
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_loader_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96fd10a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_loader_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b96fd10a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b96fd10a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tags_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a52c833a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tags_vue__ = __webpack_require__(509);
function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a52c833a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Created by danielr on 3/2/16.
 *
 * see the wiki page: https://lpgithub.dev.lprnd.net/security/lp-html-sanitizer
 *
 * ###### usage:
 *
 * $$$ AMD (with requirejs for instance)
 * var HtmlSanitizerUtils = require("HtmlSanitizerUtils");
 * var sanitizer = HtmlSanitizerUtils.sanitizeHtml(text); //text is the code you wish to sanitize
 *
 * $$$ NON-AMD (window global scope)
 * var sanitizer = window.lpTag.HtmlSanitizerUtils.sanitizeHtml(text); //text is the code you wish to sanitize
 *
 * ###### sanitizer output
 *
 * sanitizer.sanitized [boolean] true: malicious code found | false: no malicious code found
 * sanitizer.cleanText [string] the sanitized code to be used in case of sanitizer.sanitized is true
 * sanitizer.errors [array] the list of the sanitized issues found. Use this for validation summary.
 *
 * sanitizer.errors structure:
 * key: the element or the attribute value where the malicious code is targeted. example: onclick
 * type: the type of the malicious code (see the TYPES enum for the list of types). example: attribute
 * html: the original element html where the malicious code resides.  beware to escape the errors.html code in your validation summary first!
 *
 * example: <textarea class="ta request"></textarea><button onclick="alert();">click</button>
 * will ouput:
 * sanitizer.sanitized: true
 * sanitizer.cleanText: <textarea class="ta request"></textarea>
 * sanitizer.errors.key: "onclick"
 * sanitizer.errors.type: "attribute"
 * sanitizer.errors.html: <button onclick="alert();">click</button>
 *
 */
;(function (root, factory) {
    "use strict";

    //<amd>
    /* istanbul ignore next  */
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return factory(root, root);
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    // LE-68611: VX asked the plugin to be always defined in lpTag
    // Browser globals
    root.lpTag = root.lpTag || {};
    factory(root, root.lpTag);
    //usage: window.lpTag.HtmlSanitizerUtils.sanitizeHtml(input);
}(this, function (root, exports) {
    var HtmlSanitizerUtils = (function(){
        "use strict";

        //the list of the html elements to be banned
        var BANNED_ELEMENTS = ["SCRIPT", "STYLE", "LINK", "IFRAME", "META", "OBJECT", "EMBED"];

        //the regex which scans all the attributes which starts with "on"
        var EVENT_ATTRIBUTES_REGEX = /^on\S+|^\S*[^A-Za-z]+on\S*/gi;

        //the regex which scans for banned attributes
        var BANNED_ATTRIBUTES_REGEX = /DIRNAME|SRCDOC|BEGIN|TO/gi;

        //the regex which scans for banned attributes values
        var BANNED_ATTRIBUTES_VALUE_REGEX = /DATA(\s*):|MHTML(\s*):|JAVASCRIPT(\s*):|EXPRESSION(\s*)\([^;]*\)/gi;

        //the regex which scans for banned attributes in style element
        var BANNED_STYLE_ATTRIBUTES_REGEX = /MHTML(\s*):([^;]*)|DATA(\s*):([^;]*)|MASK(\s*):([^;]*)|[\w]+(\s*):(\s*)EXPRESSION\([^;]*/gi;

        //the regex which scans for banned markers
        var BANNED_MARKERS_REGEX = /<\/\/(.*?)>|<[^ $€£A-Za-z0-9\/!](.*?)>/gi;

        //the regex which scans for elements that can not be identified as elements with the virtual DOM
        var NO_DOM_PARSING_ELEMENTS_REGEX = /<(\s*)?SCRIPT\b[^>]*(\s*)?>|<(\s*)?FRAMESET\b[^>]*(\s*)?>|<(\s*)?FRAME\b[^>]*(\s*)?>|<(\s*)?BODY\b[^>]*(\s*)?>/gi;

        //the regex which scans for malicious attributes that are executed asynchronously and not targeted with the virtual DOM. the attribute is: onerror, ontoggle, onload or onloadend (Firefox event)
        var SPECIAL_ATTRIBUTES_REGEX = /ONERROR(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONLOAD(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONTOGGLE(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONRATECHANGE(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']|ONLOADSTART(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONLOADEND(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi;

        //the regex which scans for square brackets marker
        var SQUARE_BRACKETS_REGEX = /\[.]/gi;

        //the regex which matches uris
        var URI_REGEX = /(((ftp|http|https):\/\/)|www[.])(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi;

        //the regex which matches emails - ref: vx email validation rule
        var EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;

        //the regex which scans for all opening tag elements
        var ALL_OPENING_TAGS = /<((\s)?[a-z%]+)\s*[^\/]*?/gi;

        //error.key const for elements that can not be identified as elements with the virtual DOM
        var NO_DOM_PARSING_ELEMENTS_KEY = "SCRIPT/FRAMESET/FRAME/BODY";

        //error.key const for special malicious attribute that can not be targeted by the virtual DOM
        var SPECIAL_ATTRIBUTES_KEY = "ONERROR_ONLOAD_ONTOGGLE_ONRATECHANGE_ONLOADEND";

        var TYPES = {
            ELEMENT: "element",
            ATTRIBUTE: "attribute",
            ATTRIBUTE_VALUE: "attribute_value",
            STYLE_ATTRIBUTE: "style_attribute",
            MARKER: "marker",
            NOT_WELLFORMED: "not_wellformed_html"
        };

        ////////////////////// PUBLIC METHODS /////////////////////

        /**
         * sanitizeHtml is the public method of the HtmlSanitizerUtils
         * @param text [string] the text to be sanitized
         * @returns {sanitized: boolean, cleanText: *, errors: Array}
         */
        function sanitizeHtml(text) {
            var originalCode = text;
            var errors = [];
            var cleanText = text;
            if (cleanText !== '') {
                cleanText = _deepDecodeText(cleanText);
            }

            /* ! do not change the order of the sanitizing steps ! */

            //sanitize banned markers
            var result = _sanitizeMarkers(cleanText);
            updateResult(result);

            //sanitize non parsable elements (script, frameset, frame, body)
            result = _sanitizeNonParsableElements(result.cleanText);
            updateResult(result);

            //sanitize special attributes (onerror)
            result = _sanitizeSpecialAttributes(result.cleanText);
            updateResult(result);

            //sanitize non wellformed tags
            result = _sanitizeNonWellFormedTags(result.cleanText);
            updateResult(result);

            //sanitize elements
            result = _sanitizeElements(result.cleanText);
            updateResult(result);

            //sanitize attributes
            result = _sanitizeAttributes(result.cleanText);
            updateResult(result);

            function updateResult(res) {
                if (res.errors.length > 0){
                    Array.prototype.push.apply(errors, res.errors);
                }
            }

            //output of the HtmlSanitizerUtils
            return {
                sanitized: errors.length > 0, //true if malicious code found
                cleanText: errors.length > 0 ? result.cleanText : originalCode, //the sanitized text
                errors: errors //list of errors found
            };
        }

        /**
         * formatLinks function is used in VX for bare links urls and emails.
         * it scans for any text which has a uri or email format and envelop them with the appropriate <a> tag
         * in order to make them linkable.
         * @param text  - the text to scan
         * @param options - [optional]: the regex to use to scan for emails or uris.
         * example: {
         * uri_regex: /any_uri_regex/g,
         * email_regex: /any_email_regex/g
         * }
         * @returns formatted text
         */
        function formatLinks(text, options){
            var uri_regex = (options && options.uri_regex && _isRegexValid(options.uri_regex)) ? options.uri_regex : URI_REGEX;
            var email_regex = (options && options.email_regex && _isRegexValid(options.email_regex)) ? options.email_regex : EMAIL_REGEX;

            var div = getVirtualDom(text);

            for (var k = 0; k < div.childNodes.length; k++){
                if (div.childNodes[k].nodeType === 3){//text type
                    div.childNodes[k].textContent = _convertTextToLink(div.childNodes[k].textContent, uri_regex, email_regex);
                }
                else {
                    //if the node has already a <a href occurrence we leave the text as is
                    var foundAnchorElement = div.childNodes[k].outerHTML.match(/<a\s+href/g);
                    if (!foundAnchorElement){
                        div.childNodes[k].innerText = _convertTextToLink(div.childNodes[k].innerText, uri_regex, email_regex);
                    }
                }
            }

            //we used textContent and innerText to wrap anchor. In order to make them html tags, we need to replace all the lt; and gt; to < and >
            div.innerHTML = div.innerHTML.replace(new RegExp("&lt;", "g"), "<").replace(new RegExp("&gt;", "g"), ">");
            return div.innerHTML;
        }

        /**
         * sanitizeAndCleanHtml will sanitize the text then apply the whitelist filter to clean the rest of the unsupported elements and attributes
         * @param text - text to sanitize and clean
         * @param allowedHtmlTagsAndAttributes - the allowed tags and attributes. example: {'DIV': ['ID', 'CLASS'], 'A': ['HREF', 'TARGET', 'ID']}
         * @returns {string} - sanitized and clean text
         */
        function sanitizeAndCleanHtml(text, allowedHtmlTagsAndAttributes){
            allowedHtmlTagsAndAttributes = allowedHtmlTagsAndAttributes || {};
            //first we normalize allowedHtmlTagsAndAttributes (structure and lower case of keys and values)
            allowedHtmlTagsAndAttributes = _normalizeWhiteListOptions(allowedHtmlTagsAndAttributes);

            //we first sanitize the text
            var sanitized = sanitizeHtml(text);
            var sanitizedText = sanitized.cleanText;
            var div = getVirtualDom(sanitizedText);
            var result = "";

            if (allowedHtmlTagsAndAttributes === {}) { //if normalizedWhiteListOptions is empty we just do not allow any html tag. we return the innerText
               result = div.innerText;
            }
            else { //clean the text according what is allowed
                _cleanTagAllChildren(div, allowedHtmlTagsAndAttributes);
                result = div.innerHTML;
            }
            return result;
        }

        ////////////////////// PRIVATE METHODS /////////////////////

        function getVirtualDom(code){
            var div = document.createElement("DIV");
            div.innerHTML = code;
            return div;
        }

        function _cleanTagAllChildren(node, allowedHtmlTagsAndAttributes){
            var childNodes = Array.prototype.slice.call(node.childNodes); //need to make a shallow copy of the array because we remove the elements in recursions.
            childNodes.forEach(function(node){
                if (node.hasChildNodes()){
                    _cleanTagAllChildren(node, allowedHtmlTagsAndAttributes);
                }
                if (node.nodeType !== 3) {//not a text type - valid dom element
                    var tagName = node.tagName.toLowerCase();
                    if (typeof allowedHtmlTagsAndAttributes[tagName] === "undefined"){ //not listed in the allowed tags and attributes
                        if (node.parentNode){ //we replace the whole tag html with its inner html code (the tag will not be renderred) - sice the recursion is starting from the end we pass over all the code and clean it any way
                            node.outerHTML = node.innerHTML;
                        }
                    }
                    else { // allowed tag - we check the tag's allowed attributes
                        var allowedAttributes = allowedHtmlTagsAndAttributes[tagName];
                        var attributesToRemove = [];
                        for (var j = 0; j < node.attributes.length; j++){
                            var nodeAttribute = node.attributes[j].name.toLowerCase();
                            if (allowedAttributes.indexOf(nodeAttribute) === -1){ //the node attribute is not in the allowed attributes list - we remove it
                                attributesToRemove.push(nodeAttribute);
                            }
                        }
                        for (var a = 0; a < attributesToRemove.length; a++){
                            node.removeAttribute(attributesToRemove[a]);
                        }
                    }
                }
            });
        }

        function _normalizeWhiteListOptions(allowedHtmlTagsAndAttributes){
            //normalize the structure and set all the keys and values to lower case
            var newAllowedHtmlAttributes = {};
            for (var tag in allowedHtmlTagsAndAttributes){
                var lowerCaseAttributes = [];
                if (allowedHtmlTagsAndAttributes[tag] instanceof Array){
                    lowerCaseAttributes = allowedHtmlTagsAndAttributes[tag].map(function(attribute){
                        attribute = attribute.toLowerCase();
                        return attribute;
                    });
                }
                newAllowedHtmlAttributes[tag.toLowerCase()] = lowerCaseAttributes;
            }
            return newAllowedHtmlAttributes;
        }

        /**
         * _deepDecodeText: the sanitizing process will start only when the code to check can not be decoded more.
         * it will decode itself recursively
         * @param text: the code to decode
         * @returns {string} the decoded code
         * @private
         */
        function _deepDecodeText(text) {
            var currentText = text;
            var decodedText = "";
            var failedToDecode = false;
            while (currentText !== decodedText) {
                try {
                    decodedText = decodeURIComponent(currentText);
                }
                catch (ex) {
                    //decodedText = currentText.replace("%", escape("%")); //wait for answer from Security Dept.
                    decodedText = currentText;
                    failedToDecode = true;
                }
                if (!failedToDecode) {
                    currentText = decodedText;
                }

            }

            return decodedText;
        }

        /**
         * _sanitizeElements: sanitize all elements found
         * @param text : code to sanitize
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeElements(text) {
            var result = {
                errors: [],
                cleanText: text
            };

            //we use the virtual DOM in order to parse all the elements
            var div = getVirtualDom(text);

            var textModified = false;
            for (var i = 0; i < BANNED_ELEMENTS.length; i++) {
                var elements = null;
                elements = div.getElementsByTagName(BANNED_ELEMENTS[i]);
                for (var j = 0; j < elements.length; j++) {
                    textModified = true;
                    result.errors.push({type: TYPES.ELEMENT, key: BANNED_ELEMENTS[i], html: elements[j].outerHTML});
                    var element = elements[j];
                    if (element && element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                }
            }

            if (textModified) {
                result.cleanText = div.innerHTML;
            }

            return result;

        }

        /**
         * _sanitizeAttributes: sanitize all the attributes found
         * @param text: code to sanitize
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeAttributes(text) {
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }

            //we use virtual DOM in order to scan all the attributes
            var allAttributes = [];
            var div = getVirtualDom(resText);
            var allElements = div.getElementsByTagName("*");
            for (var k = 0; k < allElements.length; k++){
                for (var i = 0; i < allElements[k].attributes.length; i++){
                    allAttributes.push({attributeKey: allElements[k].attributes[i].name, attributeValue: allElements[k].attributes[i].value, element:allElements[k]});
                }
            }

            if (allAttributes) {
                //we loop over all the attributes and we scan in malicious attribute types found as well as malicious attribute values
                for (var a = 0; a < allAttributes.length; a++) {

                    var attributeKey = allAttributes[a].attributeKey;
                    var attributeValue = allAttributes[a].attributeValue;
                    var element = allAttributes[a].element;

                    //check for onXXX event attributes
                    _validateRegex(attributeKey, attributeValue, EVENT_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, element);

                    //check for banned attributes
                    _validateRegex(attributeKey, attributeValue, BANNED_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, element);

                    //check for banned attribute values
                    _validateRegex(attributeKey, attributeValue, BANNED_ATTRIBUTES_VALUE_REGEX, TYPES.ATTRIBUTE_VALUE, element);

                    //check for banned style attributes
                    if (attributeKey.toLowerCase() === "style") {
                        _validateRegex(attributeKey, attributeValue, BANNED_STYLE_ATTRIBUTES_REGEX, TYPES.STYLE_ATTRIBUTE, element);
                    }

                }
            }

            /**
             * _validateRegex: validates the code according a regex input
             * @param attributeKey : key attribute
             * @param attributeValue : value attribute
             * @param regExExpr : regular expression
             * @param attributeType : attribute type (one of the TYPES enum)
             * @param element : code context (tag element being tested)
             * @private
             */
            function _validateRegex(attributeKey, attributeValue, regExExpr, attributeType, element){
                var text = (attributeType === TYPES.STYLE_ATTRIBUTE || attributeType === TYPES.ATTRIBUTE_VALUE) ? attributeValue: attributeKey;

                //if we scan for attribute value we temporary remove [*] from the value and check if the resulted value is malicious. if no malicious we will place back the brackets
                //see https://html5sec.org/#101
                if (attributeType === TYPES.ATTRIBUTE_VALUE) {
                    text = text.replace(SQUARE_BRACKETS_REGEX,"");
                }
                var found = text.match(regExExpr);
                if (found){
                    //malicious code found
                    for (var i = 0; i < found.length; i++){
                        result.errors.push({
                            type: attributeType,
                            key: found[i],
                            html: element.outerHTML
                        });
                    }
                    //it has been decided with Security that the whole attribute will be removed even if one of the style property is malicious, the whole style will be removed
                    element.removeAttribute(attributeKey);
                }
            }

            result.cleanText = div.innerHTML;

            return result;
        }

        /**
         * _sanitizeNonWellFormedTags - non well formed tags can be an open gate to malicious code. example: <div onMouseOver=alert("fbff")
         * the virtual DOM does not know really how to handle non well formed tags and usually ignore them.
         * it has been decided that if such an use case occurs we set the errors type with the not_wellformed_html type and the cleanText just ignores the not well formed tag.
         * @param text : the code to test
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeNonWellFormedTags(text){
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }
            //in order to know if the tags are wellformed or not we count the number of the opening tags in the code BEFORE using virtual DOM
            //then we use the virtual DOM and we count the number of opening tags of the resulting code
            //if the totals are different it means that the virtual DOM did not succeed to integrate all the tags obviously because they are not wellformed

            //calculate the total of opening tags before injecting the code in the virtual DOM
            var totalTagsBeforeCleaning = resText.match(ALL_OPENING_TAGS);
            totalTagsBeforeCleaning = (totalTagsBeforeCleaning === null) ? 0 : totalTagsBeforeCleaning.length;

            //inject the code in virtual DOM
            var div = getVirtualDom(resText);

            //calculate the total of opening tags after injecting the code in the virtual DOM
            var totalTagsAfterCleaning = div.innerHTML.match(ALL_OPENING_TAGS);
            totalTagsAfterCleaning = (totalTagsAfterCleaning === null) ? 0 : totalTagsAfterCleaning.length;

            //not wellformed error is outputted if the number of element tags after cleaning the code is less than the number of tags before cleaning it
            if (totalTagsAfterCleaning < totalTagsBeforeCleaning){
                result.errors.push({
                    type: TYPES.NOT_WELLFORMED,
                    key: "",
                    html: text
                });
            }

            result.cleanText = div.innerHTML;

            return result;
        }

        /**
         * _sanitizeMarkers: sanitize code from banned markers like <%%>
         * @param text : the code to sanitize
         * @returns {*}
         * @private
         */
        function _sanitizeMarkers(text) {
            //sanitize markers like <%%> [] <//
            var result = _regexOnlySanitize(text, BANNED_MARKERS_REGEX, TYPES.MARKER, "");
            return result;
        }

        /**
         * _sanitizeNonParsableElements: sanitize elements that are not parsable using the virtual DOM feature
         * @param text : code to sanitize
         * @returns {*}
         * @private
         */
        function _sanitizeNonParsableElements(text) {
            /*
             frameset and frame elements are not detectable in DOM parsing. same as script element if embedded in svg element
             body element is not always detectable in DOM parsing neither if embedded in other elements
             */
            var result = _regexOnlySanitize(text, NO_DOM_PARSING_ELEMENTS_REGEX, TYPES.ELEMENT, NO_DOM_PARSING_ELEMENTS_KEY);
            return result;
        }

        /**
         * _sanitizeSpecialAttributes: sanitize code from special attributes like onerror
         * @param text
         * @returns {*}
         * @private
         */
        function _sanitizeSpecialAttributes(text) {
            /*
             the onerror attribute with an alert value will popup the alert if I use the DOM parsing (append code in a new div).
             */
            var result = _regexOnlySanitize(text, SPECIAL_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, SPECIAL_ATTRIBUTES_KEY);
            return result;
        }

        /**
         * _regexOnlySanitize: this method is used to scan for a specific item in the code using regular expression only
         * we use this method for the few limitations we have with the use of virtual DOM code inject like the onerror attribute, body element, markers
         * @param text : the code to scan
         * @param regExExpr : the regular expression to apply the scan to
         * @param errorType : the error type if malicious code found
         * @param key : the error key if malicious code found
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _regexOnlySanitize(text, regExExpr, errorType, key){
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }

            var banned = resText.match(regExExpr);
            if (banned) {
                for (var i = 0; i < banned.length; i++) {
                    result.errors.push({
                        type: errorType,
                        key: key,
                        html: banned[i]});
                    resText = resText.replace(banned[i], "");
                }
            }

            result.cleanText = resText;

            return result;
        }

        function _isRegexValid(regExValue){
            return regExValue && regExValue.constructor === RegExp;
        }

        function _convertTextToLink(text, uri_regex, email_regex){
            text = _convertUri(text, uri_regex);
            text = text.replace(email_regex,"<a href='mailto:$&'>$&</a>");
            return text;
        }

        function _convertUri(text, uri_regex){//if www.xxx.com found then make the href attribute value to http://xxx.com (without www, so that the remote server will decide to redirect either to the http either to the https)
            text = text.replace(uri_regex, function(match, contents, offset, s){
                var foundWwwRelativeLink = match.match(/^www\./i);
                var hrefValue = foundWwwRelativeLink ? "http://" + match.replace(/www\./i, "") : match;
                return "<a href='" + hrefValue + "'>" + match + "</a>";
            });
            return text;
        }

        //the public methods we expose
        return {
            sanitizeHtml: sanitizeHtml,
            formatLinks: formatLinks,
            sanitizeAndCleanHtml: sanitizeAndCleanHtml
        };
    })();

    exports.HtmlSanitizerUtils = exports.HtmlSanitizerUtils || HtmlSanitizerUtils;

    return HtmlSanitizerUtils;
}));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(294)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(75);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(51);
var TAG = __webpack_require__(7)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(558);
var redefine = __webpack_require__(18);
var hide = __webpack_require__(21);
var fails = __webpack_require__(13);
var defined = __webpack_require__(49);
var wks = __webpack_require__(7);
var regexpExec = __webpack_require__(77);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(54);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(51);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var punct = /\!'#%&'\(\)*\+,\\\-\.\/:;<=>\?@\[\]\^_{|}~\$/;
/* harmony default export */ __webpack_exports__["a"] = (punct);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(82);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(78);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(295);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(52)('keys');
var uid = __webpack_require__(38);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spacesGroup__ = __webpack_require__(86);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/[#{spacesGroup}]/, {
  spacesGroup: __WEBPACK_IMPORTED_MODULE_1__spacesGroup__["a" /* default */]
}));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var spacesGroup = /\x09-\x0D\x20\x85\xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000/;
/* harmony default export */ __webpack_exports__["a"] = (spacesGroup);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validCCTLD = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(RegExp('(?:(?:' + '한국|香港|澳門|新加坡|台灣|台湾|中國|中国|გე|ລາວ|ไทย|ලංකා|ഭാരതം|ಭಾರತ|భారత్|சிங்கப்பூர்|இலங்கை|இந்தியா|ଭାରତ|' + 'ભારત|ਭਾਰਤ|ভাৰত|ভারত|বাংলা|भारोत|भारतम्|भारत|ڀارت|پاکستان|موريتانيا|مليسيا|مصر|قطر|فلسطين|عمان|' + 'عراق|سورية|سودان|تونس|بھارت|بارت|ایران|امارات|المغرب|السعودية|الجزائر|البحرين|الاردن|հայ|қаз|' + 'укр|срб|рф|мон|мкд|ею|бел|бг|ευ|ελ|zw|zm|za|yt|ye|ws|wf|vu|vn|vi|vg|ve|vc|va|uz|uy|us|um|uk|' + 'ug|ua|tz|tw|tv|tt|tr|tp|to|tn|tm|tl|tk|tj|th|tg|tf|td|tc|sz|sy|sx|sv|su|st|ss|sr|so|sn|sm|sl|' + 'sk|sj|si|sh|sg|se|sd|sc|sb|sa|rw|ru|rs|ro|re|qa|py|pw|pt|ps|pr|pn|pm|pl|pk|ph|pg|pf|pe|pa|om|' + 'nz|nu|nr|np|no|nl|ni|ng|nf|ne|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|mn|mm|ml|mk|mh|mg|mf|' + 'me|md|mc|ma|ly|lv|lu|lt|ls|lr|lk|li|lc|lb|la|kz|ky|kw|kr|kp|kn|km|ki|kh|kg|ke|jp|jo|jm|je|it|' + 'is|ir|iq|io|in|im|il|ie|id|hu|ht|hr|hn|hm|hk|gy|gw|gu|gt|gs|gr|gq|gp|gn|gm|gl|gi|gh|gg|gf|ge|' + 'gd|gb|ga|fr|fo|fm|fk|fj|fi|eu|et|es|er|eh|eg|ee|ec|dz|do|dm|dk|dj|de|cz|cy|cx|cw|cv|cu|cr|co|' + 'cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|bz|by|bw|bv|bt|bs|br|bq|bo|bn|bm|bl|bj|bi|bh|bg|bf|be|bd|bb|' + 'ba|az|ax|aw|au|at|as|ar|aq|ao|an|am|al|ai|ag|af|ae|ad|ac' + ')(?=[^0-9a-zA-Z@+-]|$))'));
/* harmony default export */ __webpack_exports__["a"] = (validCCTLD);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invalidDomainChars__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validDomainChars = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/[^#{invalidDomainChars}]/, {
  invalidDomainChars: __WEBPACK_IMPORTED_MODULE_0__invalidDomainChars__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validDomainChars);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// simple string interpolation
/* harmony default export */ __webpack_exports__["a"] = (function (str, map) {
  return str.replace(/#\{(\w+)\}/g, function (match, name) {
    return map[name] || '';
  });
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validGTLD = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(RegExp('(?:(?:' + '삼성|닷컴|닷넷|香格里拉|餐厅|食品|飞利浦|電訊盈科|集团|通販|购物|谷歌|诺基亚|联通|网络|网站|网店|网址|组织机构|移动|珠宝|点看|游戏|淡马锡|机构|書籍|时尚|新闻|' + '政府|政务|招聘|手表|手机|我爱你|慈善|微博|广东|工行|家電|娱乐|天主教|大拿|大众汽车|在线|嘉里大酒店|嘉里|商标|商店|商城|公益|公司|八卦|健康|信息|佛山|企业|' + '中文网|中信|世界|ポイント|ファッション|セール|ストア|コム|グーグル|クラウド|みんな|คอม|संगठन|नेट|कॉम|همراه|موقع|موبايلي|كوم|' + 'كاثوليك|عرب|شبكة|بيتك|بازار|العليان|ارامكو|اتصالات|ابوظبي|קום|сайт|рус|орг|онлайн|москва|ком|' + 'католик|дети|zuerich|zone|zippo|zip|zero|zara|zappos|yun|youtube|you|yokohama|yoga|yodobashi|' + 'yandex|yamaxun|yahoo|yachts|xyz|xxx|xperia|xin|xihuan|xfinity|xerox|xbox|wtf|wtc|wow|world|' + 'works|work|woodside|wolterskluwer|wme|winners|wine|windows|win|williamhill|wiki|wien|whoswho|' + 'weir|weibo|wedding|wed|website|weber|webcam|weatherchannel|weather|watches|watch|warman|' + 'wanggou|wang|walter|walmart|wales|vuelos|voyage|voto|voting|vote|volvo|volkswagen|vodka|' + 'vlaanderen|vivo|viva|vistaprint|vista|vision|visa|virgin|vip|vin|villas|viking|vig|video|' + 'viajes|vet|versicherung|vermögensberatung|vermögensberater|verisign|ventures|vegas|vanguard|' + 'vana|vacations|ups|uol|uno|university|unicom|uconnect|ubs|ubank|tvs|tushu|tunes|tui|tube|trv|' + 'trust|travelersinsurance|travelers|travelchannel|travel|training|trading|trade|toys|toyota|' + 'town|tours|total|toshiba|toray|top|tools|tokyo|today|tmall|tkmaxx|tjx|tjmaxx|tirol|tires|tips|' + 'tiffany|tienda|tickets|tiaa|theatre|theater|thd|teva|tennis|temasek|telefonica|telecity|tel|' + 'technology|tech|team|tdk|tci|taxi|tax|tattoo|tatar|tatamotors|target|taobao|talk|taipei|tab|' + 'systems|symantec|sydney|swiss|swiftcover|swatch|suzuki|surgery|surf|support|supply|supplies|' + 'sucks|style|study|studio|stream|store|storage|stockholm|stcgroup|stc|statoil|statefarm|' + 'statebank|starhub|star|staples|stada|srt|srl|spreadbetting|spot|sport|spiegel|space|soy|sony|' + 'song|solutions|solar|sohu|software|softbank|social|soccer|sncf|smile|smart|sling|skype|sky|' + 'skin|ski|site|singles|sina|silk|shriram|showtime|show|shouji|shopping|shop|shoes|shiksha|shia|' + 'shell|shaw|sharp|shangrila|sfr|sexy|sex|sew|seven|ses|services|sener|select|seek|security|' + 'secure|seat|search|scot|scor|scjohnson|science|schwarz|schule|school|scholarships|schmidt|' + 'schaeffler|scb|sca|sbs|sbi|saxo|save|sas|sarl|sapo|sap|sanofi|sandvikcoromant|sandvik|samsung|' + 'samsclub|salon|sale|sakura|safety|safe|saarland|ryukyu|rwe|run|ruhr|rugby|rsvp|room|rogers|' + 'rodeo|rocks|rocher|rmit|rip|rio|ril|rightathome|ricoh|richardli|rich|rexroth|reviews|review|' + 'restaurant|rest|republican|report|repair|rentals|rent|ren|reliance|reit|reisen|reise|rehab|' + 'redumbrella|redstone|red|recipes|realty|realtor|realestate|read|raid|radio|racing|qvc|quest|' + 'quebec|qpon|pwc|pub|prudential|pru|protection|property|properties|promo|progressive|prof|' + 'productions|prod|pro|prime|press|praxi|pramerica|post|porn|politie|poker|pohl|pnc|plus|' + 'plumbing|playstation|play|place|pizza|pioneer|pink|ping|pin|pid|pictures|pictet|pics|piaget|' + 'physio|photos|photography|photo|phone|philips|phd|pharmacy|pfizer|pet|pccw|pay|passagens|' + 'party|parts|partners|pars|paris|panerai|panasonic|pamperedchef|page|ovh|ott|otsuka|osaka|' + 'origins|orientexpress|organic|org|orange|oracle|open|ooo|onyourside|online|onl|ong|one|omega|' + 'ollo|oldnavy|olayangroup|olayan|okinawa|office|off|observer|obi|nyc|ntt|nrw|nra|nowtv|nowruz|' + 'now|norton|northwesternmutual|nokia|nissay|nissan|ninja|nikon|nike|nico|nhk|ngo|nfl|nexus|' + 'nextdirect|next|news|newholland|new|neustar|network|netflix|netbank|net|nec|nba|navy|natura|' + 'nationwide|name|nagoya|nadex|nab|mutuelle|mutual|museum|mtr|mtpc|mtn|msd|movistar|movie|mov|' + 'motorcycles|moto|moscow|mortgage|mormon|mopar|montblanc|monster|money|monash|mom|moi|moe|moda|' + 'mobily|mobile|mobi|mma|mls|mlb|mitsubishi|mit|mint|mini|mil|microsoft|miami|metlife|merckmsd|' + 'meo|menu|men|memorial|meme|melbourne|meet|media|med|mckinsey|mcdonalds|mcd|mba|mattel|' + 'maserati|marshalls|marriott|markets|marketing|market|map|mango|management|man|makeup|maison|' + 'maif|madrid|macys|luxury|luxe|lupin|lundbeck|ltda|ltd|lplfinancial|lpl|love|lotto|lotte|' + 'london|lol|loft|locus|locker|loans|loan|llp|llc|lixil|living|live|lipsy|link|linde|lincoln|' + 'limo|limited|lilly|like|lighting|lifestyle|lifeinsurance|life|lidl|liaison|lgbt|lexus|lego|' + 'legal|lefrak|leclerc|lease|lds|lawyer|law|latrobe|latino|lat|lasalle|lanxess|landrover|land|' + 'lancome|lancia|lancaster|lamer|lamborghini|ladbrokes|lacaixa|kyoto|kuokgroup|kred|krd|kpn|' + 'kpmg|kosher|komatsu|koeln|kiwi|kitchen|kindle|kinder|kim|kia|kfh|kerryproperties|' + 'kerrylogistics|kerryhotels|kddi|kaufen|juniper|juegos|jprs|jpmorgan|joy|jot|joburg|jobs|jnj|' + 'jmp|jll|jlc|jio|jewelry|jetzt|jeep|jcp|jcb|java|jaguar|iwc|iveco|itv|itau|istanbul|ist|' + 'ismaili|iselect|irish|ipiranga|investments|intuit|international|intel|int|insure|insurance|' + 'institute|ink|ing|info|infiniti|industries|inc|immobilien|immo|imdb|imamat|ikano|iinet|ifm|' + 'ieee|icu|ice|icbc|ibm|hyundai|hyatt|hughes|htc|hsbc|how|house|hotmail|hotels|hoteles|hot|' + 'hosting|host|hospital|horse|honeywell|honda|homesense|homes|homegoods|homedepot|holiday|' + 'holdings|hockey|hkt|hiv|hitachi|hisamitsu|hiphop|hgtv|hermes|here|helsinki|help|healthcare|' + 'health|hdfcbank|hdfc|hbo|haus|hangout|hamburg|hair|guru|guitars|guide|guge|gucci|guardian|' + 'group|grocery|gripe|green|gratis|graphics|grainger|gov|got|gop|google|goog|goodyear|goodhands|' + 'goo|golf|goldpoint|gold|godaddy|gmx|gmo|gmbh|gmail|globo|global|gle|glass|glade|giving|gives|' + 'gifts|gift|ggee|george|genting|gent|gea|gdn|gbiz|gay|garden|gap|games|game|gallup|gallo|' + 'gallery|gal|fyi|futbol|furniture|fund|fun|fujixerox|fujitsu|ftr|frontier|frontdoor|frogans|' + 'frl|fresenius|free|fox|foundation|forum|forsale|forex|ford|football|foodnetwork|food|foo|fly|' + 'flsmidth|flowers|florist|flir|flights|flickr|fitness|fit|fishing|fish|firmdale|firestone|fire|' + 'financial|finance|final|film|fido|fidelity|fiat|ferrero|ferrari|feedback|fedex|fast|fashion|' + 'farmers|farm|fans|fan|family|faith|fairwinds|fail|fage|extraspace|express|exposed|expert|' + 'exchange|everbank|events|eus|eurovision|etisalat|esurance|estate|esq|erni|ericsson|equipment|' + 'epson|epost|enterprises|engineering|engineer|energy|emerck|email|education|edu|edeka|eco|eat|' + 'earth|dvr|dvag|durban|dupont|duns|dunlop|duck|dubai|dtv|drive|download|dot|doosan|domains|' + 'doha|dog|dodge|doctor|docs|dnp|diy|dish|discover|discount|directory|direct|digital|diet|' + 'diamonds|dhl|dev|design|desi|dentist|dental|democrat|delta|deloitte|dell|delivery|degree|' + 'deals|dealer|deal|dds|dclk|day|datsun|dating|date|data|dance|dad|dabur|cyou|cymru|cuisinella|' + 'csc|cruises|cruise|crs|crown|cricket|creditunion|creditcard|credit|cpa|courses|coupons|coupon|' + 'country|corsica|coop|cool|cookingchannel|cooking|contractors|contact|consulting|construction|' + 'condos|comsec|computer|compare|company|community|commbank|comcast|com|cologne|college|coffee|' + 'codes|coach|clubmed|club|cloud|clothing|clinique|clinic|click|cleaning|claims|cityeats|city|' + 'citic|citi|citadel|cisco|circle|cipriani|church|chrysler|chrome|christmas|chloe|chintai|cheap|' + 'chat|chase|charity|channel|chanel|cfd|cfa|cern|ceo|center|ceb|cbs|cbre|cbn|cba|catholic|' + 'catering|cat|casino|cash|caseih|case|casa|cartier|cars|careers|career|care|cards|caravan|car|' + 'capitalone|capital|capetown|canon|cancerresearch|camp|camera|cam|calvinklein|call|cal|cafe|' + 'cab|bzh|buzz|buy|business|builders|build|bugatti|budapest|brussels|brother|broker|broadway|' + 'bridgestone|bradesco|box|boutique|bot|boston|bostik|bosch|boots|booking|book|boo|bond|bom|' + 'bofa|boehringer|boats|bnpparibas|bnl|bmw|bms|blue|bloomberg|blog|blockbuster|blanco|' + 'blackfriday|black|biz|bio|bingo|bing|bike|bid|bible|bharti|bet|bestbuy|best|berlin|bentley|' + 'beer|beauty|beats|bcn|bcg|bbva|bbt|bbc|bayern|bauhaus|basketball|baseball|bargains|barefoot|' + 'barclays|barclaycard|barcelona|bar|bank|band|bananarepublic|banamex|baidu|baby|azure|axa|aws|' + 'avianca|autos|auto|author|auspost|audio|audible|audi|auction|attorney|athleta|associates|asia|' + 'asda|arte|art|arpa|army|archi|aramco|arab|aquarelle|apple|app|apartments|aol|anz|anquan|' + 'android|analytics|amsterdam|amica|amfam|amex|americanfamily|americanexpress|alstom|alsace|' + 'ally|allstate|allfinanz|alipay|alibaba|alfaromeo|akdn|airtel|airforce|airbus|aigo|aig|agency|' + 'agakhan|africa|afl|afamilycompany|aetna|aero|aeg|adult|ads|adac|actor|active|aco|accountants|' + 'accountant|accenture|academy|abudhabi|abogado|able|abc|abbvie|abbott|abb|abarth|aarp|aaa|' + 'onion' + ')(?=[^0-9a-zA-Z@+-]|$))'));
/* harmony default export */ __webpack_exports__["a"] = (validGTLD);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validPunycode = /(?:xn--[\-0-9a-z]+)/;
/* harmony default export */ __webpack_exports__["a"] = (validPunycode);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cyrillicLettersAndMarks__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validGeneralUrlPathChars = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])(/[a-z#{cyrillicLettersAndMarks}0-9!\*';:=\+,\.\$\/%#\[\]\-\u2013_~@\|&#{latinAccentChars}]/i, {
  cyrillicLettersAndMarks: __WEBPACK_IMPORTED_MODULE_0__cyrillicLettersAndMarks__["a" /* default */],
  latinAccentChars: __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validGeneralUrlPathChars);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var cyrillicLettersAndMarks = /\u0400-\u04FF/;
/* harmony default export */ __webpack_exports__["a"] = (cyrillicLettersAndMarks);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validGeneralUrlPathChars__ = __webpack_require__(92);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

 // Allow URL paths to contain up to two nested levels of balanced parens
//  1. Used in Wikipedia URLs like /Primer_(film)
//  2. Used in IIS sessions like /S(dfd346)/
//  3. Used in Rdio URLs like /track/We_Up_(Album_Version_(Edited))/

var validUrlBalancedParens = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('\\(' + '(?:' + '#{validGeneralUrlPathChars}+' + '|' + // allow one nested level of balanced parentheses
'(?:' + '#{validGeneralUrlPathChars}*' + '\\(' + '#{validGeneralUrlPathChars}+' + '\\)' + '#{validGeneralUrlPathChars}*' + ')' + ')' + '\\)', {
  validGeneralUrlPathChars: __WEBPACK_IMPORTED_MODULE_1__validGeneralUrlPathChars__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validUrlBalancedParens);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validUrlQueryChars = /[a-z0-9!?\*'@\(\);:&=\+\$\/%#\[\]\-_\.,~|]/i;
/* harmony default export */ __webpack_exports__["a"] = (validUrlQueryChars);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validUrlQueryEndingChars = /[a-z0-9\-_&=#\/]/i;
/* harmony default export */ __webpack_exports__["a"] = (validUrlQueryEndingChars);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__latinAccentChars__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validCCTLD__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validGTLD__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validPunycode__ = __webpack_require__(91);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





var validAsciiDomain = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/(?:(?:[\-a-z0-9#{latinAccentChars}]+)\.)+(?:#{validGTLD}|#{validCCTLD}|#{validPunycode})/gi, {
  latinAccentChars: __WEBPACK_IMPORTED_MODULE_0__latinAccentChars__["a" /* default */],
  validGTLD: __WEBPACK_IMPORTED_MODULE_3__validGTLD__["a" /* default */],
  validCCTLD: __WEBPACK_IMPORTED_MODULE_2__validCCTLD__["a" /* default */],
  validPunycode: __WEBPACK_IMPORTED_MODULE_4__validPunycode__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validAsciiDomain);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
/* harmony default export */ __webpack_exports__["a"] = (function (entities) {
  entities.sort(function (a, b) {
    return a.indices[0] - b.indices[0];
  });
  var prev = entities[0];

  for (var i = 1; i < entities.length; i++) {
    if (prev.indices[1] > entities[i].indices[0]) {
      entities.splice(i, 1);
      i--;
    } else {
      prev = entities[i];
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// Generated from unicode_regex/unicode_regex_groups.scala, same as objective c's \p{L}\p{M}
var astralLetterAndMarks = /\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\uddfd\ude80-\ude9c\udea0-\uded0\udee0\udf00-\udf1f\udf30-\udf40\udf42-\udf49\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc00-\udc9d\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude33\ude38-\ude3a\ude3f\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee6\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48]|\ud804[\udc00-\udc46\udc7f-\udcba\udcd0-\udce8\udd00-\udd34\udd50-\udd73\udd76\udd80-\uddc4\uddda\ude00-\ude11\ude13-\ude37\udeb0-\udeea\udf01-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3c-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc80-\udcc5\udcc7\udd80-\uddb5\uddb8-\uddc0\ude00-\ude40\ude44\ude80-\udeb7]|\ud806[\udca0-\udcdf\udcff\udec0-\udef8]|\ud808[\udc00-\udf98]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud81a[\udc00-\ude38\ude40-\ude5e\uded0-\udeed\udef0-\udef4\udf00-\udf36\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\udf00-\udf44\udf50-\udf7e\udf8f-\udf9f]|\ud82c[\udc00\udc01]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9d\udc9e]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud83a[\udc00-\udcc4\udcd0-\udcd6]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|\ud87e[\udc00-\ude1d]|\udb40[\udd00-\uddef]/;
/* harmony default export */ __webpack_exports__["a"] = (astralLetterAndMarks);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// Generated from unicode_regex/unicode_regex_groups.scala, same as objective c's \p{L}\p{M}
var bmpLetterAndMarks = /A-Za-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0300-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u0483-\u052f\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u05d0-\u05ea\u05f0-\u05f2\u0610-\u061a\u0620-\u065f\u066e-\u06d3\u06d5-\u06dc\u06df-\u06e8\u06ea-\u06ef\u06fa-\u06fc\u06ff\u0710-\u074a\u074d-\u07b1\u07ca-\u07f5\u07fa\u0800-\u082d\u0840-\u085b\u08a0-\u08b2\u08e4-\u0963\u0971-\u0983\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bc-\u09c4\u09c7\u09c8\u09cb-\u09ce\u09d7\u09dc\u09dd\u09df-\u09e3\u09f0\u09f1\u0a01-\u0a03\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a59-\u0a5c\u0a5e\u0a70-\u0a75\u0a81-\u0a83\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abc-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ad0\u0ae0-\u0ae3\u0b01-\u0b03\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3c-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5c\u0b5d\u0b5f-\u0b63\u0b71\u0b82\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd0\u0bd7\u0c00-\u0c03\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c58\u0c59\u0c60-\u0c63\u0c81-\u0c83\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbc-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0cde\u0ce0-\u0ce3\u0cf1\u0cf2\u0d01-\u0d03\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d-\u0d44\u0d46-\u0d48\u0d4a-\u0d4e\u0d57\u0d60-\u0d63\u0d7a-\u0d7f\u0d82\u0d83\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e01-\u0e3a\u0e40-\u0e4e\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb9\u0ebb-\u0ebd\u0ec0-\u0ec4\u0ec6\u0ec8-\u0ecd\u0edc-\u0edf\u0f00\u0f18\u0f19\u0f35\u0f37\u0f39\u0f3e-\u0f47\u0f49-\u0f6c\u0f71-\u0f84\u0f86-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u103f\u1050-\u108f\u109a-\u109d\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u135d-\u135f\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16f1-\u16f8\u1700-\u170c\u170e-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176c\u176e-\u1770\u1772\u1773\u1780-\u17d3\u17d7\u17dc\u17dd\u180b-\u180d\u1820-\u1877\u1880-\u18aa\u18b0-\u18f5\u1900-\u191e\u1920-\u192b\u1930-\u193b\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a1b\u1a20-\u1a5e\u1a60-\u1a7c\u1a7f\u1aa7\u1ab0-\u1abe\u1b00-\u1b4b\u1b6b-\u1b73\u1b80-\u1baf\u1bba-\u1bf3\u1c00-\u1c37\u1c4d-\u1c4f\u1c5a-\u1c7d\u1cd0-\u1cd2\u1cd4-\u1cf6\u1cf8\u1cf9\u1d00-\u1df5\u1dfc-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u20d0-\u20f0\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2183\u2184\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d7f-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2de0-\u2dff\u2e2f\u3005\u3006\u302a-\u302f\u3031-\u3035\u303b\u303c\u3041-\u3096\u3099\u309a\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua672\ua674-\ua67d\ua67f-\ua69d\ua69f-\ua6e5\ua6f0\ua6f1\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua7ad\ua7b0\ua7b1\ua7f7-\ua827\ua840-\ua873\ua880-\ua8c4\ua8e0-\ua8f7\ua8fb\ua90a-\ua92d\ua930-\ua953\ua960-\ua97c\ua980-\ua9c0\ua9cf\ua9e0-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa36\uaa40-\uaa4d\uaa60-\uaa76\uaa7a-\uaac2\uaadb-\uaadd\uaae0-\uaaef\uaaf2-\uaaf6\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab5f\uab64\uab65\uabc0-\uabea\uabec\uabed\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf870-\uf87f\uf882\uf884-\uf89f\uf8b8\uf8c1-\uf8d6\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe00-\ufe0f\ufe20-\ufe2d\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc/;
/* harmony default export */ __webpack_exports__["a"] = (bmpLetterAndMarks);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__astralNumerals__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bmpLetterAndMarks__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bmpNumerals__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashtagSpecialChars__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nonBmpCodePairs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0







var hashtagAlphaNumeric = Object(__WEBPACK_IMPORTED_MODULE_6__lib_regexSupplant__["a" /* default */])(/(?:[#{bmpLetterAndMarks}#{bmpNumerals}#{hashtagSpecialChars}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}|#{astralNumerals}))/, {
  bmpLetterAndMarks: __WEBPACK_IMPORTED_MODULE_2__bmpLetterAndMarks__["a" /* default */],
  bmpNumerals: __WEBPACK_IMPORTED_MODULE_3__bmpNumerals__["a" /* default */],
  hashtagSpecialChars: __WEBPACK_IMPORTED_MODULE_4__hashtagSpecialChars__["a" /* default */],
  nonBmpCodePairs: __WEBPACK_IMPORTED_MODULE_5__nonBmpCodePairs__["a" /* default */],
  astralLetterAndMarks: __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__["a" /* default */],
  astralNumerals: __WEBPACK_IMPORTED_MODULE_1__astralNumerals__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (hashtagAlphaNumeric);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var endMentionMatch = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])(/^(?:#{atSigns}|[#{latinAccentChars}]|:\/\/)/, {
  atSigns: __WEBPACK_IMPORTED_MODULE_0__atSigns__["a" /* default */],
  latinAccentChars: __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (endMentionMatch);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validMentionPrecedingChars__ = __webpack_require__(323);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validMentionOrList = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])('(#{validMentionPrecedingChars})' + // $1: Preceding character
'(#{atSigns})' + // $2: At mark
'([a-zA-Z0-9_]{1,20})' + // $3: Screen name
'(/[a-zA-Z][a-zA-Z0-9_-]{0,24})?', // $4: List (optional)
{
  validMentionPrecedingChars: __WEBPACK_IMPORTED_MODULE_2__validMentionPrecedingChars__["a" /* default */],
  atSigns: __WEBPACK_IMPORTED_MODULE_0__atSigns__["a" /* default */]
}, 'g');
/* harmony default export */ __webpack_exports__["a"] = (validMentionOrList);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_stringSupplant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tagAttrs__ = __webpack_require__(326);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (entity, text, attributes, options) {
  if (!options.suppressNoFollow) {
    attributes.rel = 'nofollow';
  } // if linkAttributeBlock is specified, call it to modify the attributes


  if (options.linkAttributeBlock) {
    options.linkAttributeBlock(entity, attributes);
  } // if linkTextBlock is specified, call it to get a new/modified link text


  if (options.linkTextBlock) {
    text = options.linkTextBlock(entity, text);
  }

  var d = {
    text: text,
    attr: Object(__WEBPACK_IMPORTED_MODULE_1__tagAttrs__["a" /* default */])(attributes)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0__lib_stringSupplant__["a" /* default */])('<a#{attr}>#{text}</a>', d);
});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(75);
var test = {};
test[__webpack_require__(7)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(51);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_convertUnicodeIndices__ = __webpack_require__(334);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text, entities) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_convertUnicodeIndices__["a" /* default */])(text, entities, true);
});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(582);
var step = __webpack_require__(583);
var Iterators = __webpack_require__(44);
var toIObject = __webpack_require__(25);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(343)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(12).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(7)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regexp_invalidChars__ = __webpack_require__(347);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  return __WEBPACK_IMPORTED_MODULE_0__regexp_invalidChars__["a" /* default */].test(text);
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var urlHasHttps = /^https:\/\//i;
/* harmony default export */ __webpack_exports__["a"] = (urlHasHttps);

/***/ }),
/* 112 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlUnreserved__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlPctEncoded__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDelims__ = __webpack_require__(116);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




var validateUrlUserinfo = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '#{validateUrlUnreserved}|' + '#{validateUrlPctEncoded}|' + '#{validateUrlSubDelims}|' + ':' + ')*', {
  validateUrlUnreserved: __WEBPACK_IMPORTED_MODULE_1__validateUrlUnreserved__["a" /* default */],
  validateUrlPctEncoded: __WEBPACK_IMPORTED_MODULE_2__validateUrlPctEncoded__["a" /* default */],
  validateUrlSubDelims: __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDelims__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUserinfo);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlUnreserved = /[a-z\u0400-\u04FF0-9\-._~]/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnreserved);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlPctEncoded = /(?:%[0-9a-f]{2})/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlPctEncoded);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlSubDelims = /[!$&'()*+,;=]/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlSubDelims);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlIpv4__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlIpv6__ = __webpack_require__(363);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


 // Punting on IPvFuture for now

var validateUrlIp = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '#{validateUrlIpv4}|' + '#{validateUrlIpv6}' + ')', {
  validateUrlIpv4: __WEBPACK_IMPORTED_MODULE_1__validateUrlIpv4__["a" /* default */],
  validateUrlIpv6: __WEBPACK_IMPORTED_MODULE_2__validateUrlIpv6__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlIp);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlPort = /[0-9]{1,5}/;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlPort);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tree_item_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d967544_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tree_item_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tree_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d967544_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tree_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(33);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var LeTranscriptTranslationModel = function LeTranscriptTranslationModel(_ref) {
  var privateMessageIndicator = _ref.privateMessageIndicator,
      messageStatusSent = _ref.messageStatusSent,
      messageStatusAccept = _ref.messageStatusAccept,
      messageStatusRead = _ref.messageStatusRead,
      messageStatusViewed = _ref.messageStatusViewed,
      messageTypeNotSupported = _ref.messageTypeNotSupported,
      NA = _ref.NA,
      messageNotSupportedActionText = _ref.messageNotSupportedActionText,
      secureFormInvitationPrefix = _ref.secureFormInvitationPrefix;

  _classCallCheck(this, LeTranscriptTranslationModel);

  this.messageStatusMap = {};

  this.privateMessageIndicator = privateMessageIndicator || 'Private';
  this.messageTypeNotSupported = messageTypeNotSupported || 'Message of type {type} is not supported';
  this.messageStatusSent = messageStatusSent || 'Consumer has received the message';
  this.messageStatusAccept = messageStatusAccept || 'Consumer has received the message';
  this.messageStatusRead = messageStatusRead || 'Consumer has read the message';
  this.messageStatusViewed = messageStatusViewed || 'Consumer has open the message';
  this.NA = NA || 'N/A';
  this.messageNotSupportedActionText = messageNotSupportedActionText;
  this.secureFormInvitationPrefix = secureFormInvitationPrefix || 'has sent a Secure Form:';

  this.messageStatusMap[__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MESSAGE_STATUSES */].ACCEPT] = this.messageStatusAccept;
  this.messageStatusMap[__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MESSAGE_STATUSES */].READ] = this.messageStatusRead;
  this.messageStatusMap[__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MESSAGE_STATUSES */].VIEWED] = this.messageStatusViewed;
  this.messageStatusMap[__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MESSAGE_STATUSES */].SENT] = this.messageStatusSent;
};

/* harmony default export */ __webpack_exports__["a"] = (LeTranscriptTranslationModel);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters_dateTime__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(22);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





function getMessageStatusClass(messageStatus) {
  switch (messageStatus) {
    case __WEBPACK_IMPORTED_MODULE_1__consts__["d" /* MESSAGE_STATUSES */].ACCEPT:
      return 'ico-7 ico-message-accepted';
    case __WEBPACK_IMPORTED_MODULE_1__consts__["d" /* MESSAGE_STATUSES */].READ:
    case __WEBPACK_IMPORTED_MODULE_1__consts__["d" /* MESSAGE_STATUSES */].VIEWED:
      return 'ico-7 ico-message-read';
    case __WEBPACK_IMPORTED_MODULE_1__consts__["d" /* MESSAGE_STATUSES */].SENT:
    default:
      return 'ico-7 ico-message-sent';
  }
}

var LeTranscriptMessageModel = function LeTranscriptMessageModel(_ref, _ref2) {
  var id = _ref.id,
      audience = _ref.audience,
      text = _ref.text,
      time = _ref.time,
      type = _ref.type,
      status = _ref.status,
      originator = _ref.originator,
      metadata = _ref.metadata,
      content = _ref.content,
      quickReplies = _ref.quickReplies,
      intentData = _ref.intentData;
  var hoursSettings = _ref2.hoursSettings;

  _classCallCheck(this, LeTranscriptMessageModel);

  this.id = id;
  this.audience = audience;
  this.text = text;
  this.messageFullTimeForDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__filters_dateTime__["a" /* default */])(hoursSettings, time, Object(__WEBPACK_IMPORTED_MODULE_0__filters_dateTime__["b" /* getFullTimeFormat */])(hoursSettings));
  this.messageTimeForDisplay = Object(__WEBPACK_IMPORTED_MODULE_0__filters_dateTime__["a" /* default */])(hoursSettings, time, { hourOnly: true });
  this.type = type;
  this.time = time;
  this.status = status;
  this.messageStatusClass = getMessageStatusClass(status);
  this.textDirection = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].detectTextDirection(text.charAt(0));
  this.originator = originator;
  this.metadata = metadata;
  this.content = content;
  this.quickReplies = quickReplies;
  this.intentData = intentData;
};

/* harmony default export */ __webpack_exports__["a"] = (LeTranscriptMessageModel);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeTranscriptModel = function LeTranscriptModel(_ref) {
  var consumerMessageClassName = _ref.consumerMessageClassName,
      hoursSettings = _ref.hoursSettings,
      messages = _ref.messages,
      conversationId = _ref.conversationId;

  _classCallCheck(this, LeTranscriptModel);

  this.consumerMessageClassName = consumerMessageClassName;
  this.hoursSettings = hoursSettings;
  this.messages = messages;
  this.conversationId = conversationId;
};

/* harmony default export */ __webpack_exports__["a"] = (LeTranscriptModel);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_components_le_bubble_le_bubble__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vue_components_le_button_le_button__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_components_le_checkbox_le_checkbox__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vue_components_le_list_plus_preview_le_list_plus_preview__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vue_components_le_table_le_table__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vue_components_le_tabs_le_tabs__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vue_components_le_filter_le_filter__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vue_components_le_pagination_le_pagination__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vue_components_le_select_le_select__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vue_components_le_tags_le_tags__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vue_components_le_input_field_le_input_field__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_vue_components_le_slider_le_slider__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_vue_components_le_loader_le_loader__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_vue_components_le_dialog_le_dialog__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_vue_components_le_text_editor_le_text_editor__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_vue_components_le_text_editor_le_editor_toolbar_buttons_le_editor_toolbar_buttons__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_vue_components_le_collapse_le_accordion__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_vue_components_le_collapse_le_accordion_item__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_vue_components_le_emojies_le_emojies__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_vue_components_le_toggle_le_toggle__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_vue_components_le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_vue_components_le_radio_le_radio__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_vue_components_le_ellipsis_le_ellipsis__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_vue_components_le_audio_le_audio__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_vue_components_le_datepicker_le_datepicker__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_vue_components_le_textarea_le_textarea__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_vue_components_le_text_editor_le_link_editor_le_link_editor__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_vue_components_le_notifier_le_notifier__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_vue_components_le_treeview_le_treeview__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_vue_components_le_treeview_le_treeview_simple__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_vue_components_le_transcript_le_transcript__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_vue_components_le_combobox_le_combobox__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_vue_components_le_toggle_selection_icon_le_toggle_selection_icon__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_vue_components_le_stepper_le_stepper__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__directives_clickOutsideDirective__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_markdownUtil__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__filters_dateTime__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_vue_components_le_transcript_utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_vue_components_le_transcript_transformers_index__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteSettingsModel__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteTriggerOptionsModel__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteSelectKeysModel__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_2__components_vue_components_le_checkbox_le_checkbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leButton", function() { return __WEBPACK_IMPORTED_MODULE_1__components_vue_components_le_button_le_button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTable", function() { return __WEBPACK_IMPORTED_MODULE_4__components_vue_components_le_table_le_table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leListPlusPreview", function() { return __WEBPACK_IMPORTED_MODULE_3__components_vue_components_le_list_plus_preview_le_list_plus_preview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leBubble", function() { return __WEBPACK_IMPORTED_MODULE_0__components_vue_components_le_bubble_le_bubble__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTabs", function() { return __WEBPACK_IMPORTED_MODULE_5__components_vue_components_le_tabs_le_tabs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lePagination", function() { return __WEBPACK_IMPORTED_MODULE_7__components_vue_components_le_pagination_le_pagination__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leFilter", function() { return __WEBPACK_IMPORTED_MODULE_6__components_vue_components_le_filter_le_filter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leSlider", function() { return __WEBPACK_IMPORTED_MODULE_11__components_vue_components_le_slider_le_slider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leSelect", function() { return __WEBPACK_IMPORTED_MODULE_8__components_vue_components_le_select_le_select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTags", function() { return __WEBPACK_IMPORTED_MODULE_9__components_vue_components_le_tags_le_tags__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leInputField", function() { return __WEBPACK_IMPORTED_MODULE_10__components_vue_components_le_input_field_le_input_field__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leLoader", function() { return __WEBPACK_IMPORTED_MODULE_12__components_vue_components_le_loader_le_loader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leDialog", function() { return __WEBPACK_IMPORTED_MODULE_13__components_vue_components_le_dialog_le_dialog__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTextEditor", function() { return __WEBPACK_IMPORTED_MODULE_14__components_vue_components_le_text_editor_le_text_editor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leEditorToolbarButtons", function() { return __WEBPACK_IMPORTED_MODULE_15__components_vue_components_le_text_editor_le_editor_toolbar_buttons_le_editor_toolbar_buttons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leAccordion", function() { return __WEBPACK_IMPORTED_MODULE_16__components_vue_components_le_collapse_le_accordion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leAccordionItem", function() { return __WEBPACK_IMPORTED_MODULE_17__components_vue_components_le_collapse_le_accordion_item__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leEmojies", function() { return __WEBPACK_IMPORTED_MODULE_18__components_vue_components_le_emojies_le_emojies__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leToggle", function() { return __WEBPACK_IMPORTED_MODULE_19__components_vue_components_le_toggle_le_toggle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTextWithHighlight", function() { return __WEBPACK_IMPORTED_MODULE_20__components_vue_components_le_text_with_highlight_le_text_with_highlight__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leRadio", function() { return __WEBPACK_IMPORTED_MODULE_21__components_vue_components_le_radio_le_radio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leEllipsis", function() { return __WEBPACK_IMPORTED_MODULE_22__components_vue_components_le_ellipsis_le_ellipsis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leAudio", function() { return __WEBPACK_IMPORTED_MODULE_23__components_vue_components_le_audio_le_audio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leDatepicker", function() { return __WEBPACK_IMPORTED_MODULE_24__components_vue_components_le_datepicker_le_datepicker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTextarea", function() { return __WEBPACK_IMPORTED_MODULE_25__components_vue_components_le_textarea_le_textarea__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leLinkEditor", function() { return __WEBPACK_IMPORTED_MODULE_26__components_vue_components_le_text_editor_le_link_editor_le_link_editor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leNotifier", function() { return __WEBPACK_IMPORTED_MODULE_27__components_vue_components_le_notifier_le_notifier__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTreeview", function() { return __WEBPACK_IMPORTED_MODULE_28__components_vue_components_le_treeview_le_treeview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTreeviewSimple", function() { return __WEBPACK_IMPORTED_MODULE_29__components_vue_components_le_treeview_le_treeview_simple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leTranscript", function() { return __WEBPACK_IMPORTED_MODULE_30__components_vue_components_le_transcript_le_transcript__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leCombobox", function() { return __WEBPACK_IMPORTED_MODULE_31__components_vue_components_le_combobox_le_combobox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leToggleSelectionIcon", function() { return __WEBPACK_IMPORTED_MODULE_32__components_vue_components_le_toggle_selection_icon_le_toggle_selection_icon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "leStepper", function() { return __WEBPACK_IMPORTED_MODULE_33__components_vue_components_le_stepper_le_stepper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clickOutside", function() { return __WEBPACK_IMPORTED_MODULE_34__directives_clickOutsideDirective__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "markdownToHtml", function() { return __WEBPACK_IMPORTED_MODULE_35__utils_markdownUtil__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "htmlToMarkdown", function() { return __WEBPACK_IMPORTED_MODULE_35__utils_markdownUtil__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "markdownToPlainText", function() { return __WEBPACK_IMPORTED_MODULE_35__utils_markdownUtil__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "dateTimeFilter", function() { return __WEBPACK_IMPORTED_MODULE_36__filters_dateTime__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFullTimeFormat", function() { return __WEBPACK_IMPORTED_MODULE_36__filters_dateTime__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getConversationColor", function() { return __WEBPACK_IMPORTED_MODULE_37__components_vue_components_le_transcript_utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteTriggerOptionsModel", function() { return __WEBPACK_IMPORTED_MODULE_40__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteTriggerOptionsModel__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteSelectKeysModel", function() { return __WEBPACK_IMPORTED_MODULE_41__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteSelectKeysModel__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LeQuillAutocompleteSettingsModel", function() { return __WEBPACK_IMPORTED_MODULE_39__src_components_vue_components_le_text_editor_le_quill_autocomplete_Models_LeQuillAutocompleteSettingsModel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TranscriptTransformers", function() { return __WEBPACK_IMPORTED_MODULE_38__components_vue_components_le_transcript_transformers_index__["a"]; });



























































































/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-bubble',
  props: {
    ariaLabelledBy: {
      type: String,
      default: ''
    },
    closeAriaLabel: {
      type: String,
      required: false,
      default: 'Close'
    },
    isEnabled: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      required: false
    },
    offset: {
      type: Number,
      default: 5
    },
    autoHide: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    trigger: {
      type: String,
      required: false
    },
    html: {
      type: Boolean,
      required: false
    },
    container: {
      type: String,
      required: false
    },
    delay: {
      type: Object,
      required: false
    },
    open: {
      type: Boolean,
      required: false
    },
    hideOnTargetClick: {
      type: Boolean
    },
    bubbleBaseClass: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false
    },
    bubbleInnerClass: {
      type: String,
      required: false
    },
    defaultCloseButton: {
      type: Boolean,
      required: false
    },
    flip: {
      type: Boolean,
      default: true
    },
    boundariesElement: {
      type: String,
      default: 'window'
    }
  },
  data: function data() {
    return {
      hasBeenOpened: false,
      popperOptions: {
        modifiers: {
          flip: {
            enabled: this.flip
          },
          preventOverflow: {
            boundariesElement: this.boundariesElement
          }
        }
      }
    };
  },

  methods: {
    onShow: function onShow() {
      this.$emit('onShow');
      this.hasBeenOpened = true;
    },
    onHide: function onHide() {
      this.$emit('hide');
    },
    onTab: function onTab(event) {
      var focusableNodeList = this.$refs.bubble.$refs.popover.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var focusableArr = Array.prototype.slice.call(focusableNodeList);
      var currentIndex = focusableArr.indexOf(event.target);

      if (this.defaultCloseButton) {
        if (currentIndex === 0 && event.shiftKey) {
          event.preventDefault();
          if (focusableArr.length > 0) {
            focusableArr[focusableArr.length - 1].focus();
          }
        }
        if (currentIndex === focusableArr.length - 1 && !event.shiftKey) {
          event.preventDefault();
          if (focusableArr.length > 0) {
            focusableArr[0].focus();
          }
        }
      }

      if (!this.defaultCloseButton && (currentIndex === 0 && event.shiftKey || currentIndex === focusableArr.length - 1 && !event.shiftKey)) {
        event.preventDefault();
        this.hide();
      }
    },
    onEsc: function onEsc() {
      this.hide();
    },
    show: function show() {
      var _this = this;

      this.$refs.bubble.show();
      this.$refs.bubble.$refs.popover.removeAttribute('tabindex');
      setTimeout(function () {
        if (_this.defaultCloseButton) {
          _this.$refs.closeButton.focus();
        } else {
          var focusableElement = _this.$refs.bubble.$refs.popover.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (focusableElement) {
            focusableElement.focus();
          }
        }
      }, 250);
    },
    hide: function hide() {
      var _this2 = this;

      this.$refs.bubble.hide();
      this.$nextTick(function () {
        var focusableElement = _this2.$refs.bubble.$refs.trigger.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusableElement) {
          focusableElement.focus();
        }
      });
    },
    toggle: function toggle() {
      if (this.open) {
        this.hide();
      } else {
        this.show();
      }
      this.open = !this.open;
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-button',
  props: {
    label: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    variant: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUTTON.VARIANTS.DEFAULT
    },
    size: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUTTON.SIZE.DEFAULT
    },
    tooltip: {
      type: [String, Object],
      required: false,
      default: ''
    },
    focusBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      defaultTooltipOptions: {
        html: false,
        autoHide: false
      }
    };
  },

  computed: {
    hasIcon: function hasIcon() {
      return !!this.icon;
    },
    tooltipOptions: function tooltipOptions() {
      if (typeof this.tooltip === 'string') {
        return _extends({}, this.defaultTooltipOptions, { content: this.tooltip });
      }
      return _extends({}, this.defaultTooltipOptions, this.tooltip);
    },
    hasLabel: function hasLabel() {
      return !!this.label || !!this.$slots.default;
    },
    iconSize: function iconSize() {
      var size = '';
      switch (this.size) {
        case __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUTTON.SIZE.LARGE:
          {
            size = 14;
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUTTON.SIZE.SMALL:
          {
            size = 10;
            break;
          }
        default:
          {
            size = 12;
            break;
          }
      }
      return size;
    },
    focusBorderClass: function focusBorderClass() {
      return this.focusBorder ? 'focus-border' : '';
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    onTab: function onTab(event) {
      this.$emit('clickOnTab', event);
    },
    onMouseOver: function onMouseOver() {
      this.$emit('mouseover');
    },
    onMouseLeave: function onMouseLeave() {
      this.$emit('mouseleave');
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-checkbox',
  props: {
    label: {
      type: String,
      required: false
    },
    state: {
      type: [String, Boolean],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabbable: {
      type: Boolean,
      default: true
    },
    controls: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled) {
        var newState = void 0;
        if (this.state === __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.UNCHECKED || this.state === false) {
          newState = true;
        } else {
          newState = false;
        }
        this.$emit('change', newState);
      }
    },
    onFocus: function onFocus() {
      if (!this.disabled) {
        this.$emit('focus');
      }
    }
  },
  computed: {
    hasLabel: function hasLabel() {
      return !!this.label || !!this.$slots.default;
    },
    checked: function checked() {
      return this.state === true || this.state === __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.CHECKED;
    },
    ariaChecked: function ariaChecked() {
      if (this.checked) {
        return 'true';
      }
      if (this.indeterminate) {
        return 'mixed';
      }
      return 'false';
    },
    indeterminate: function indeterminate() {
      return this.state === __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.INDETERMINATE;
    },
    tabIndex: function tabIndex() {
      return this.tabbable && !this.disabled ? '0' : '-1';
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-list-plus-preview',
  props: {
    items: {
      type: Array,
      required: true
    },
    maxItemsDisplay: {
      type: Number,
      default: 1
    },
    borderPlusItems: {
      type: Boolean,
      default: true
    },
    plusItemsFontClass: {
      type: String,
      default: 'default-font'
    },
    showDisplayedItemsTooltip: {
      type: Boolean,
      default: false
    },
    displayedItemsTooltipText: {
      type: String
    },
    bubblePlacement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    renderHtml: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayedItems: function displayedItems() {
      return this.items.length > 0 ? this.items.slice(0, this.maxItemsDisplay).join(', ') : '';
    },
    plusLabel: function plusLabel() {
      return this.items.length > this.maxItemsDisplay ? '+' + (this.items.length - this.maxItemsDisplay) : '';
    },
    plusItems: function plusItems() {
      return this.items.slice(this.maxItemsDisplay).join(', ');
    },
    plusItemsTooltipOptions: function plusItemsTooltipOptions() {
      return {
        content: this.plusItems,
        placement: this.bubblePlacement,
        html: this.renderHtml,
        autoHide: false
      };
    },
    displayedItemsTooltipOptions: function displayedItemsTooltipOptions() {
      var content = '';
      if (this.showDisplayedItemsTooltip) {
        content = this.displayedItemsTooltipText || this.displayedItems;
      }
      return {
        content: content,
        placement: this.bubblePlacement,
        html: this.renderHtml,
        autoHide: false
      };
    },
    isPlusOnly: function isPlusOnly() {
      return this.maxItemsDisplay === 0;
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_table_column__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_table_row__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_table_loader__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_table_empty__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__le_table_error__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__le_loader_le_loader__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__le_checkbox_le_checkbox__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__le_bubble_le_bubble__ = __webpack_require__(15);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table',
  components: {
    leTableColumn: __WEBPACK_IMPORTED_MODULE_1__le_table_column__["a" /* default */],
    leTableRow: __WEBPACK_IMPORTED_MODULE_2__le_table_row__["a" /* default */],
    leTableLoader: __WEBPACK_IMPORTED_MODULE_3__le_table_loader__["a" /* default */],
    leLoader: __WEBPACK_IMPORTED_MODULE_6__le_loader_le_loader__["a" /* default */],
    leTableEmpty: __WEBPACK_IMPORTED_MODULE_4__le_table_empty__["a" /* default */],
    leCheckbox: __WEBPACK_IMPORTED_MODULE_8__le_checkbox_le_checkbox__["a" /* default */],
    leBubble: __WEBPACK_IMPORTED_MODULE_9__le_bubble_le_bubble__["a" /* default */],
    leTableError: __WEBPACK_IMPORTED_MODULE_5__le_table_error__["a" /* default */]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemIdAttr: {
      type: String,
      required: false,
      default: 'id'
    },
    filterBubblePosition: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    allowRowFocus: {
      type: Boolean,
      required: false
    },
    autoFocusFirstRow: {
      type: Boolean,
      required: false
    },
    allowRowSelection: {
      type: Boolean,
      required: false
    },
    allowMultiSelection: {
      type: Boolean,
      required: false
    },
    showColorsColumn: {
      type: Boolean,
      required: false
    },
    quickSelectionOptions: {
      type: Array,
      required: false
    },
    currentSort: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          column: null,
          sortDirection: ''
        };
      }
    },
    currentFilters: {
      type: Object,
      required: false
    },
    filtersIconSize: {
      type: Number,
      required: false
    },
    headersFontSize: {
      type: Number,
      required: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean
    },

    loaderMinTime: {
      type: Number
    },
    focusedRowId: {
      type: String,
      default: '-1'
    },
    useEmptyDefaultSplashImage: {
      type: Boolean,
      default: true
    },
    emptySplashImageClass: {
      type: String,
      default: ''
    },
    emptyLabel: {
      type: String,
      default: 'No records found'
    },
    emptyLabelClass: {
      type: String
    },
    emptyDescription: {
      type: String,
      default: ''
    },
    emptyOrientation: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.EMPTY_ORIENTATION.HORIZONTAL
    },
    hideTopBorder: {
      type: Boolean,
      default: false
    },
    errorLabel: {
      type: String,
      default: 'An error has occurred'
    },
    hideErrorIcon: {
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    refreshLabel: {
      type: String,
      default: 'Refresh'
    },
    tableRowHeight: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.ROW_HEIGHT
    },
    tableHeaderHeight: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.HEADER_HEIGHT
    },
    isRowActionable: {
      type: Boolean,
      default: false
    },
    editedRowId: {
      type: String,
      default: ''
    },
    ariaLabelledby: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checkedRowIds: [],
      leftScroll: 0,
      initSelectionWrapperOffsetLeft: 0,
      initColorsWrapperOffsetLeft: 0,
      waitingForLoaderTimeout: false,
      hoveredRowId: '',
      currentPosition: { row: 0, column: 0 },
      grid: [],
      focusedCell: {}
    };
  },

  computed: {
    tableStyle: function tableStyle() {
      return {
        paddingTop: this.tableHeaderHeight + 'px',
        height: 'calc(100% - ' + this.tableHeaderHeight + 'px)'
      };
    },
    isEmptyTable: function isEmptyTable() {
      return this.items.length === 0;
    },
    totalNumberOfColumns: function totalNumberOfColumns() {
      var count = this.columns.length;
      if (this.showColorsColumn) {
        count += 1;
      }
      if (this.allowRowSelection) {
        count += 1;
      }
      return count;
    },
    isPartialRowsChecked: function isPartialRowsChecked() {
      var hasMoreRowsToCheck = this.items.length > this.checkedRowIds.length;
      return this.checkedRowIds.length > 0 && hasMoreRowsToCheck;
    },
    isAllRowsChecked: function isAllRowsChecked() {
      return !this.isEmptyTable && this.checkedRowIds.length > 0;
    },
    selectAllCheckboxState: function selectAllCheckboxState() {
      var state = __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.UNCHECKED;
      if (this.isPartialRowsChecked) {
        state = __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.INDETERMINATE;
      } else if (this.isAllRowsChecked) {
        state = __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.CHECKED;
      }
      return state;
    },
    showLoader: function showLoader() {
      return this.isLoading || this.waitingForLoaderTimeout;
    },
    getAriaLabelledby: function getAriaLabelledby() {
      return this.ariaLabelledby ? this.ariaLabelledby : false;
    }
  },
  created: function created() {
    window.addEventListener('resize', this.onResize);
  },
  mounted: function mounted() {
    this.calcInitOffsetSpecialColumns();
    var firstHeaderCell = document.querySelector('thead th:first-of-type .wrapper');
    if (firstHeaderCell) {
      firstHeaderCell.tabIndex = 0;
    }
    this.$emit('mounted');
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.loaderTimeout);
  },

  watch: {
    items: function items() {
      var _this = this;

      if (this.allowRowFocus && this.autoFocusFirstRow && this.focusedRowId === '-1' && !this.isEmptyTable) {
        this.focusRowByIndex(0);
      }

      this.$nextTick(function () {
        _this.repositionColumns();
        _this.BuildTableGrid();
      });
    },
    leftScroll: function leftScroll() {
      this.repositionSelectionColumnHeaders();
      this.repositionColorsColumnHeaders();
    },
    initSelectionWrapperOffsetLeft: function initSelectionWrapperOffsetLeft() {
      this.repositionSelectionColumnHeaders();
    },
    initColorsWrapperOffsetLeft: function initColorsWrapperOffsetLeft() {
      this.repositionColorsColumnHeaders();
    },
    isLoading: function isLoading() {
      var _this2 = this;

      if (this.isLoading && this.loaderMinTime && !this.waitingForLoaderTimeout) {
        this.waitingForLoaderTimeout = true;
        this.loaderTimeout = setTimeout(function () {
          _this2.waitingForLoaderTimeout = false;
        }, this.loaderMinTime);
      }
    }
  },
  methods: {
    onRefreshClick: function onRefreshClick() {
      this.$emit('onRefreshClick');
    },
    repositionColumns: function repositionColumns() {
      var _this3 = this;

      if (!this.showLoader) {
        var currentScroll = this.$refs['table-wrapper'].scrollLeft;
        this.$refs['table-wrapper'].scrollLeft = 0;
        this.calcInitOffsetSpecialColumns();
        this.columns.forEach(function (column) {
          var leTableColumnComponent = _this3.$refs['column-' + column.id + '-wrapper'][0];
          if (leTableColumnComponent && leTableColumnComponent.calculateColumnPosition) {
            leTableColumnComponent.calculateColumnPosition();
          }
        });
        this.$refs['table-wrapper'].scrollLeft = currentScroll;
      }
    },
    calcInitOffsetSpecialColumns: function calcInitOffsetSpecialColumns() {
      if (this.$refs['column-selection-wrapper']) {
        this.initSelectionWrapperOffsetLeft = this.$refs['column-selection-wrapper'].offsetLeft;
      }
      if (this.$refs['column-colors-wrapper']) {
        this.initColorsWrapperOffsetLeft = this.$refs['column-colors-wrapper'].offsetLeft;
      }
    },
    repositionSelectionColumnHeaders: function repositionSelectionColumnHeaders() {
      if (this.$refs['column-selection-wrapper']) {
        var newSelectionOffset = this.initSelectionWrapperOffsetLeft - this.leftScroll;
        this.$refs['column-selection-wrapper'].style.left = newSelectionOffset + 'px';
      }
    },
    repositionColorsColumnHeaders: function repositionColorsColumnHeaders() {
      if (this.$refs['column-colors-wrapper']) {
        var newColorsOffset = this.initColorsWrapperOffsetLeft - this.leftScroll;
        this.$refs['column-colors-wrapper'].style.left = newColorsOffset + 'px';
      }
    },
    isRowCheckboxChecked: function isRowCheckboxChecked(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(this.checkedRowIds, this.getRowId(row));
    },
    isRowFocused: function isRowFocused(row) {
      return this.focusedRowId === this.getRowId(row);
    },
    isRowHovered: function isRowHovered(row) {
      return this.hoveredRowId === this.getRowId(row) && !this.editedRowId;
    },
    isRowEdited: function isRowEdited(row) {
      return this.editedRowId === this.getRowId(row);
    },
    getFilterNameByColumn: function getFilterNameByColumn(column) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(column, 'filter.name', column.id);
    },
    getRowId: function getRowId(row) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(row, this.itemIdAttr);
    },
    getRowColor: function getRowColor(row) {
      var rowColor = '';
      if (this.showColorsColumn) {
        rowColor = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(row, 'color');
      }
      return rowColor;
    },
    getSortConfiguration: function getSortConfiguration(column) {
      return {
        sortable: column.sortable,
        sortableLabel: column.sortableLabel,
        sorted: this.currentSort.column === column.id,
        sortDirection: this.currentSort.sortDirection
      };
    },
    onSelectAllCheckboxChange: function onSelectAllCheckboxChange(isChecked) {
      var _this4 = this;

      this.checkedRowIds = [];
      if (isChecked) {
        var _checkedRowIds;

        (_checkedRowIds = this.checkedRowIds).push.apply(_checkedRowIds, _toConsumableArray(this.items.map(function (item) {
          return _this4.getRowId(item);
        })));
      }
      this.$emit('checkedRowsChanged', this.checkedRowIds);
    },
    onRowCheckboxChange: function onRowCheckboxChange(isChecked, rowId) {
      this.toggleCheckState(isChecked, rowId);
    },
    onQuickSelectionCustomItemClick: function onQuickSelectionCustomItemClick(predicate) {
      this.checkRelevantRows(predicate);
    },
    onQuickSelectionAllItemClick: function onQuickSelectionAllItemClick() {
      this.checkRelevantRows(function () {
        return true;
      });
    },
    onQuickSelectionNoneItemClick: function onQuickSelectionNoneItemClick() {
      this.checkRelevantRows(function () {
        return false;
      });
    },
    checkRelevantRows: function checkRelevantRows(predicate) {
      var _this5 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(predicate)) {
        Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["each"])(this.items, function (item) {
          return _this5.toggleCheckState(!!predicate(item), _this5.getRowId(item));
        });
      }
    },
    onRowClick: function onRowClick(rowId) {
      this.focusRow(rowId);
    },
    onRowHovered: function onRowHovered(rowId) {
      this.hoveredRowId = rowId;
    },
    onFilter: function onFilter(_ref) {
      var filterName = _ref.filterName,
          value = _ref.value;

      this.$emit('filter-change-' + filterName, value);
      this.$emit('filter-change', value);
      this.resetFocus();
    },
    onSort: function onSort(_ref2) {
      var columnId = _ref2.columnId;

      var updatedSort = {};
      updatedSort.column = columnId;
      if (this.currentSort.column !== columnId) {
        updatedSort.sortDirection = __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.ASC;
      } else {
        updatedSort.sortDirection = this.currentSort.sortDirection === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.ASC ? __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.DESC : __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.ASC;
      }
      this.$emit('sortChanged', updatedSort);
      this.BuildTableGrid();
      this.currentPosition.row = 0;
    },
    onActionIconClick: function onActionIconClick(_ref3) {
      var columnId = _ref3.columnId;

      this.$emit('onActionIconClick', columnId);
    },
    onResize: function onResize() {
      var _this6 = this;

      requestAnimationFrame(function () {
        _this6.repositionColumns();
      });
    },
    onColumnMount: function onColumnMount() {
      this.repositionColumns();
    },
    toggleCheckState: function toggleCheckState(isChecked, rowId) {
      this.checkedRowIds = this.allowRowSelection && !this.allowMultiSelection ? [] : this.checkedRowIds;
      var exists = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(this.checkedRowIds, rowId);
      if (isChecked) {
        if (!exists) {
          this.checkedRowIds.push(rowId);
        }
      } else if (exists) {
        this.checkedRowIds.splice(this.checkedRowIds.indexOf(rowId), 1);
      }
      this.$emit('checkedRowsChanged', this.checkedRowIds);
    },
    focusRow: function focusRow(rowId) {
      if (this.allowRowFocus) {
        this.$emit('focusRowChanged', rowId);
      }
    },
    focusRowByIndex: function focusRowByIndex(index) {
      if (index > -1 && this.items.length > index) {
        var rowId = this.getRowId(this.items[index]);
        this.focusRow(rowId);
      }
    },
    scrollTableTop: function scrollTableTop() {
      this.$refs['table-wrapper'].scrollTop = 0;
    },
    onTableScroll: function onTableScroll() {
      this.leftScroll = this.$refs['table-wrapper'].scrollLeft;
    },
    focusColumn: function focusColumn() {
      this.unFocusElement();
      var row = this.grid[this.currentPosition.row];
      var column = row.columns ? row.columns[this.currentPosition.column][0].$el.firstChild : row.rowCells[this.currentPosition.column];
      this.setFocus(column);
    },
    resetFocus: function resetFocus() {
      this.unFocusElement();
      this.currentPosition = { row: 0, column: 0 };
      var column = this.grid[this.currentPosition.row].columns[this.currentPosition.column][0].$el.firstChild;
      this.setFocus(column);
    },
    setFocus: function setFocus(element) {
      this.setTabIndex(element);
      element.focus();
      this.focusedCell = element;
    },
    moveUp: function moveUp() {
      var _currentPosition = this.currentPosition,
          row = _currentPosition.row,
          column = _currentPosition.column;

      var newRow = row - 1;
      if (newRow < 0) return;
      this.updateCurrentPosition(newRow, column);
      this.focusColumn();
    },
    moveDown: function moveDown() {
      var _currentPosition2 = this.currentPosition,
          row = _currentPosition2.row,
          column = _currentPosition2.column;

      var newRow = row + 1;
      if (newRow >= this.grid.length) return;
      this.updateCurrentPosition(newRow, column);
      this.focusColumn();
    },
    updateCurrentPosition: function updateCurrentPosition(newRow, column) {
      var _this7 = this;

      var currentRow = this.grid[this.currentPosition.row];
      var nextRow = this.grid[newRow];
      var targetColumn = currentRow.columns ? currentRow.columns[column][0].$el.firstChild : currentRow.rowCells[column];
      var currentParent = this.findParentElement(targetColumn);
      if (!currentParent) return;

      var currentPosition = currentParent.getAttribute('data-position');
      var currentColumnIndex = parseInt(currentPosition.split(',')[1], 10);
      var nextParent = document.querySelectorAll('[data-position="[' + newRow + ', ' + currentColumnIndex + ']"]');
      this.currentPosition.row = newRow;
      if (newRow === 0) {
        nextRow.columns.forEach(function (column, index) {
          if (nextParent[0].className === column[0].$el.className) {
            _this7.currentPosition.column = index;
          }
        });
      } else {
        var nextElement = this.findFirstChildBySelector(nextParent);
        this.currentPosition.column = nextRow.rowCells.indexOf(nextElement);
      }
    },
    findParentElement: function findParentElement(element) {
      var parent = element.parentNode;
      if (element.hasAttribute('data-position')) {
        return element;
      }
      while (parent) {
        if (parent.hasAttribute('data-position')) {
          return parent;
        }
        parent = parent.parentNode;
      }
      return null;
    },
    findFirstChildBySelector: function findFirstChildBySelector(parentElement) {
      var childElements = parentElement[0].querySelectorAll("[class*='tooltip'] , .le-link , .wrapper");
      return childElements.length > 0 ? childElements[0] : parentElement[0];
    },
    unFocusElement: function unFocusElement() {
      if (this.focusedCell !== null && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.focusedCell)) {
        this.removeTabIndex(this.focusedCell);
      }
    },
    moveLeft: function moveLeft() {
      var newColumn = this.currentPosition.column - 1;
      if (newColumn >= 0) {
        this.currentPosition.column = newColumn;
        this.focusColumn();
      }
    },
    moveRight: function moveRight() {
      var newColumn = this.currentPosition.column + 1;
      var currentRow = this.grid[this.currentPosition.row].rowCells || this.grid[this.currentPosition.row].columns;
      if (newColumn <= currentRow.length - 1) {
        this.currentPosition.column = newColumn;
        this.focusColumn();
      }
    },
    setTabIndex: function setTabIndex(element) {
      if (element) {
        element.setAttribute('tabIndex', '0');
      }
    },
    removeTabIndex: function removeTabIndex(element) {
      if (element) {
        element.setAttribute('tabIndex', '-1');
      }
    },
    handleKeyDown: function handleKeyDown($event) {
      var _this8 = this;

      switch ($event.code) {
        case 'ArrowUp':
          $event.preventDefault();
          this.moveUp();
          break;
        case 'ArrowDown':
          $event.preventDefault();
          this.moveDown();
          break;
        case 'ArrowLeft':
          this.moveLeft();
          break;
        case 'ArrowRight':
          this.moveRight();
          break;

        case 'Tab':
        case 'ShiftTab':
          this.resetFocus();
          var lastFocusedElement = document.querySelectorAll('.le-table [tabindex]:not([tabindex="-1"]):not(.le-table-column:nth-of-type(1) .wrapper)');
          lastFocusedElement.forEach(function (element) {
            _this8.removeTabIndex(element);
          });
          break;
        case 'Home':
          if ($event.ctrlKey) {
            this.currentPosition.row = 0;
          }
          this.currentPosition.column = 0;
          this.focusColumn();
          break;

        case 'End':
          if ($event.ctrlKey) {
            this.currentPosition.row = this.grid.length - 1;
          }
          var currentRow = this.grid[this.currentPosition.row].rowCells || this.grid[this.currentPosition.row].columns;
          this.currentPosition.column = currentRow.length - 1;
          this.focusColumn();
          break;
        default:
          break;
      }
    },
    BuildTableGrid: function BuildTableGrid() {
      var _this9 = this;

      var columns = Object.keys(this.$refs).filter(function (property) {
        return property.includes('column');
      }).map(function (property) {
        return _this9.$refs[property];
      });

      if (!columns) return;

      this.grid[0] = {
        columns: [].concat(_toConsumableArray(columns))
      };

      var rowElements = this.$refs.tableRow;
      if (!rowElements) return;

      rowElements.forEach(function (row, index) {
        var columnGrid = row.$children.reduce(function (acc, column) {
          var ElementsToBeFocused = column.$el.querySelectorAll("[class*='tooltip'] , .le-link");
          if (ElementsToBeFocused.length > 0) {
            var filteredElements = Array.from(ElementsToBeFocused).filter(function (element) {
              return !Array.from(ElementsToBeFocused).some(function (otherElement) {
                return otherElement !== element && otherElement.contains(element);
              });
            });
            return acc.concat(filteredElements);
          }
          return acc.concat([column.$el.parentElement]);
        }, []);

        _this9.grid[index + 1] = {
          row: row,
          rowCells: [].concat(_toConsumableArray(columnGrid))
        };
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_filter_le_filter__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_toggle_selection_icon_le_toggle_selection_icon__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_clickOutsideDirective__ = __webpack_require__(36);








var FILTER_RESET_VALUE = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table-column',
  components: {
    leFilter: __WEBPACK_IMPORTED_MODULE_2__le_filter_le_filter__["a" /* default */],
    leToggleSelectionIcon: __WEBPACK_IMPORTED_MODULE_3__le_toggle_selection_icon_le_toggle_selection_icon__["a" /* default */]
  },
  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_4__directives_clickOutsideDirective__["a" /* default */]
  },
  props: {
    id: {
      type: String,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    filterBubblePosition: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    headerFontSize: {
      type: Number,
      required: false,
      default: 13
    },
    filterConfiguration: {
      type: Object,
      required: false
    },
    filtersIconSize: {
      type: Number,
      required: false,
      default: 13
    },
    sortConfiguration: {
      type: Object,
      required: true
    },
    tableLeftScroll: {
      type: Number,
      required: true
    },
    size: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          width: '50px',
          minWidth: '20%'
        };
      }
    },
    tableHeaderHeight: {
      type: Number
    },
    currentPosition: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      displayFilterAndSortIcons: false,
      initOffsetLeft: 0,
      displayTooltip: false,
      actionIcon: this.header.actionIcon,
      columnHeaderDescriptionId: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqueId"])('title-description-')
    };
  },

  watch: {
    tableLeftScroll: function tableLeftScroll() {
      this.repositionHeader();
    },
    initOffsetLeft: function initOffsetLeft() {
      this.repositionHeader();
    }
  },
  computed: {
    tableColumnWrapperStyle: function tableColumnWrapperStyle() {
      return {
        height: this.tableHeaderHeight + 'px',
        lineHeight: this.tableHeaderHeight + 'px'
      };
    },
    tableColumnStyle: function tableColumnStyle() {
      return {
        minWidth: this.size.minWidth,
        width: this.size.width,
        fontSize: this.headerFontSize + 'px'
      };
    },
    columnTitleMaxWidth: function columnTitleMaxWidth() {
      var iconsWidthInPixels = 0;
      if (this.isSortableColumn) {
        iconsWidthInPixels += 20;
      }
      if (this.hasFilterConfiguration) {
        iconsWidthInPixels += 25;
      }
      if (this.hasActionIcon) {
        iconsWidthInPixels += 20;
      }
      return 'calc(100% - ' + iconsWidthInPixels + 'px)';
    },
    hasIcon: function hasIcon() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.header.icon);
    },
    hasActionIcon: function hasActionIcon() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.actionIcon) && this.actionIcon.showActionIcon;
    },
    actionIconName: function actionIconName() {
      var iconName = this.header.actionIcon.iconName;
      var activeIconName = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.header.actionIcon, 'activeIconName', iconName);
      return this.header.actionIcon.isActive ? activeIconName : iconName;
    },
    hasTitle: function hasTitle() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.header.text);
    },
    isSortableColumn: function isSortableColumn() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.sortConfiguration, 'sortable');
    },
    getSortableLabel: function getSortableLabel() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.sortConfiguration, 'sortableLabel');
    },
    isSorted: function isSorted() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.sortConfiguration, 'sorted');
    },
    getSortedDirectionValue: function getSortedDirectionValue() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.sortConfiguration, 'sortDirection');
    },
    getSortState: function getSortState() {
      if (!this.isSortableColumn) {
        return null;
      }
      if (this.isSorted) {
        return this.getSortedDirectionValue === __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.ASC ? 'ascending' : 'descending';
      }
      return 'none';
    },
    shouldDisplayDescOrderIcon: function shouldDisplayDescOrderIcon() {
      if (this.isSorted) {
        return this.getSortedDirectionValue === __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.DESC || this.displayFilterAndSortIcons;
      }
      return this.isSortableColumn;
    },
    shouldDisplayAscOrderIcon: function shouldDisplayAscOrderIcon() {
      if (this.isSorted) {
        return this.getSortedDirectionValue === __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABLE.SORT_DIRECTION.ASC || this.displayFilterAndSortIcons;
      }
      return this.isSortableColumn;
    },
    hasFilterConfiguration: function hasFilterConfiguration() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.filterConfiguration);
    },
    getColumnDescription: function getColumnDescription() {
      var columnDescription = this.header.tooltip ? this.header.tooltip : '';
      return this.isSortableColumn && this.getSortableLabel ? this.getSortableLabel + '. ' + columnDescription : columnDescription;
    }
  },
  mounted: function mounted() {
    var _this = this;

    requestAnimationFrame(function () {
      _this.calculateColumnPosition();
    });
    this.$nextTick(function () {
      _this.calculateColumnPosition();
      _this.$emit('onColumnMount');
    });
  },

  methods: {
    calculateColumnPosition: function calculateColumnPosition() {
      if (this.$refs['column-th'] && this.$refs['column-wrapper']) {
        var columnClientWidth = this.$refs['column-th'].clientWidth;
        if (columnClientWidth > 0) {
          this.initOffsetLeft = this.$refs['column-th'].offsetLeft;
          this.$refs['column-wrapper'].style.width = columnClientWidth + 'px';
        }
      }
    },
    repositionHeader: function repositionHeader() {
      var newLeftOffset = this.initOffsetLeft - this.tableLeftScroll;
      if (this.$refs['column-wrapper']) {
        this.$refs['column-wrapper'].style.left = newLeftOffset + 'px';
      }
    },
    onSortClick: function onSortClick() {
      if (this.isSortableColumn) {
        this.$emit('sort', { columnId: this.id });
      }
    },
    onFilterClick: function onFilterClick(_ref) {
      var filterName = _ref.filterName,
          value = _ref.value;

      this.$emit('filter', { filterName: filterName, value: value });
    },
    onFilterResetClick: function onFilterResetClick(_ref2) {
      var filterName = _ref2.filterName;

      var value = FILTER_RESET_VALUE;
      this.$emit('filter', { filterName: filterName, value: value });
    },
    onActionIconClick: function onActionIconClick() {
      this.$emit('onActionIconClick', { columnId: this.id });
    },
    onTableHeaderMouseOver: function onTableHeaderMouseOver() {
      this.displayFilterAndSortIcons = true;
    },
    onTableHeaderMouseLeave: function onTableHeaderMouseLeave() {
      this.displayFilterAndSortIcons = false;
    },
    showTooltip: function showTooltip() {
      this.displayTooltip = true;
    },
    hideTooltip: function hideTooltip() {
      this.displayTooltip = false;
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_filter_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3dc7662_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_filter_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3dc7662"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3dc7662_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_button_le_button__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_bubble_le_bubble__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(22);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-filter',
  components: {
    leButton: __WEBPACK_IMPORTED_MODULE_1__le_button_le_button__["a" /* default */],
    leBubble: __WEBPACK_IMPORTED_MODULE_2__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    componentProps: {
      type: Object,
      required: true
    },
    resetButtonLabel: {
      type: String,
      default: 'Reset'
    },
    filterButtonLabel: {
      type: String,
      default: 'Filter'
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    filterBubbleInnerClass: {
      type: String,
      required: false,
      default: ''
    },
    filterContentId: {
      type: String,
      required: false,
      default: 'filter-content-' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* generateUUID */])()
    },
    iconSize: {
      type: Number,
      default: 13
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterIconTooltip: {
      type: String,
      default: ''
    },
    ariaHasPopup: {
      type: String,
      default: 'dialog'
    },
    hideResetButton: {
      type: Boolean,
      default: false
    },

    lazy: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      bubbleOpen: false
    };
  },

  computed: {
    isFiltered: function isFiltered() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.componentProps, 'value'));
    },
    filterButtonAriaLabel: function filterButtonAriaLabel() {
      return this.ariaLabelledBy ? false : this.filterButtonLabel;
    }
  },
  methods: {
    close: function close() {
      this.$refs.bubble.hide();
    },
    onReset: function onReset() {
      this.bubbleOpen = false;
      this.$emit('reset', {
        filterName: this.name
      });
      this.close();
    },
    onFilter: function onFilter() {
      var hasValidMethod = typeof this.$refs.innerComponent.isValid === 'function';
      if (hasValidMethod && !this.$refs.innerComponent.isValid()) {
        return;
      }
      this.bubbleOpen = false;
      this.$emit('filter', {
        filterName: this.name,
        value: this.$refs.innerComponent.getValue()
      });
      this.close();
    },
    onFilterOpenClick: function onFilterOpenClick() {
      this.bubbleOpen = true;
      this.$refs.bubble.toggle();
      this.$emit('open', {
        filterName: this.name
      });
    },
    onHide: function onHide() {
      if (this.bubbleOpen) {
        this.bubbleOpen = false;
        this.$emit('hide', {
          filterName: this.name
        });
        if (typeof this.$refs.innerComponent.updateValue === 'function') {
          this.$refs.innerComponent.updateValue(this.componentProps.value);
        }
      }
      if (this.$refs.innerComponent && typeof this.$refs.innerComponent.resetSelection === 'function') {
        this.$refs.innerComponent.resetSelection();
      }
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_toggle_selection_icon_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33dd6723_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_toggle_selection_icon_vue__ = __webpack_require__(433);
function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33dd6723"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_toggle_selection_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33dd6723_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_toggle_selection_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toggle-selection-icon',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_checkbox_le_checkbox__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table-row',
  components: {
    leCheckbox: __WEBPACK_IMPORTED_MODULE_1__le_checkbox_le_checkbox__["a" /* default */]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rowId: {
      type: String,
      required: true
    },
    isCheckboxChecked: {
      type: Boolean,
      required: false
    },
    isFocused: {
      type: Boolean,
      required: false
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    isEdited: {
      type: Boolean,
      required: false
    },
    showCheckbox: {
      type: Boolean,
      required: false
    },
    rowColor: {
      type: String,
      required: false
    },
    rowHeight: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_TABLE.ROW_HEIGHT
    },
    isActionable: {
      type: Boolean,
      default: false
    },
    currentPosition: {
      type: Object,
      required: true
    }
  },
  methods: {
    onCheckboxChange: function onCheckboxChange(value) {
      this.$emit('checkboxChange', value, this.rowId);
    },
    onColumnClick: function onColumnClick(column, event) {
      if (this.enableFocus(column, event)) {
        this.onRowClick();
      }
    },
    enableFocus: function enableFocus(column, event) {
      if (column.doNotBubbleClick) {
        return false;
      }
      var blockedElements = column.doNotBubbleClickElements;
      var noBlockedElements = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isUndefined"])(blockedElements) || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(blockedElements);
      var path = event.path || event.composedPath && event.composedPath();
      return noBlockedElements ? true : !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(path, function (elem) {
        return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["intersection"])(elem.classList, blockedElements));
      });
    },
    onRowClick: function onRowClick() {
      this.$emit('rowClick', this.rowId);
    },
    onRowMouseEnter: function onRowMouseEnter() {
      this.$emit('rowHovered', this.rowId);
    },
    onRowMouseLeave: function onRowMouseLeave() {
      this.$emit('rowHovered', '');
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__ = __webpack_require__(478);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table-loader',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_0_vue_content_loader__["a" /* ContentLoader */]
  },
  data: function data() {
    return {
      titleHeight: 30,
      lineHeight: 60,
      loaderWidth: 3342,
      loaderSpeed: 5,
      numOfRows: 2,
      rowPrimaryColor: '#f2f2f2',
      rowSecondaryColor: '#dddddd',
      firstRowPrimaryColor: '#ffffff',
      firstRowSecondaryColor: '#f4f4f4',
      firstRowLineHeight: 55
    };
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table-empty',
  props: {
    useDefaultSplashImage: {
      type: Boolean,
      default: true
    },
    splashImageClass: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: 'empty-table-label'
    },
    orientation: {
      type: String,
      required: true
    },
    totalNumberOfColumns: {
      type: Number,
      required: true
    },
    label: {
      type: String
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass: function iconClass() {
      if (this.useDefaultSplashImage) {
        return 'empty-table-image ico-empty-image-' + this.orientation;
      }
      return this.splashImageClass;
    },
    showDescription: function showDescription() {
      return this.description !== '';
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-table-error',
  props: {
    errorLabel: {
      type: String
    },
    hideErrorIcon: {
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    totalNumberOfColumns: {
      type: Number,
      required: true
    },
    refreshLabel: {
      type: String
    }
  },
  methods: {
    onRefreshClick: function onRefreshClick() {
      this.$emit('onRefreshClick');
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-loader',
  props: {
    size: {
      type: Number,
      required: true
    },
    loadingLabel: {
      type: String,
      default: 'Loading'
    }
  },
  data: function data() {
    return {
      awAriaLivePoliteContainer: null,
      ariaLivePoliteId: new Date().getTime()
    };
  },

  computed: {
    loaderStyle: function loaderStyle() {
      return {
        fontSize: this.size + 'px'
      };
    },
    innerAriaLivePolite: function innerAriaLivePolite() {
      return !this.awAriaLivePoliteContainer ? 'polite' : 'off';
    }
  },
  mounted: function mounted() {
    this.awAriaLivePoliteContainer = document.getElementById('aw-aria-live-polite-container');

    if (this.awAriaLivePoliteContainer) {
      this.$root.$emit('aw-aria-live-polite-append-text', {
        id: this.ariaLivePoliteId,
        message: this.loadingLabel
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.awAriaLivePoliteContainer) {
      this.$root.$emit('aw-aria-live-polite-clear-text', this.ariaLivePoliteId);
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    selectedTabId: {
      type: String,
      require: false,
      default: ''
    },
    variant: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABS.VARIANTS.DEFAULT,
      validator: function validator(value) {
        return !value || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(__WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABS.VARIANTS), value);
      }
    }
  },
  computed: {
    iconSize: function iconSize() {
      var size = '';
      switch (this.variant) {
        case __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABS.VARIANTS.SECONDARY:
        case __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_TABS.VARIANTS.PRIMARY:
          {
            size = 14;
            break;
          }
        default:
          {
            size = 12;
            break;
          }
      }
      return size;
    },
    visibleTabs: function visibleTabs() {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(this.tabs, function (tab) {
        return _this.isVisible(tab);
      });
    }
  },
  methods: {
    hasIcon: function hasIcon(tab) {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(tab.icon);
    },
    hasText: function hasText(tab) {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(tab.text);
    },
    hasSubText: function hasSubText(tab) {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(tab.subText);
    },
    isVisible: function isVisible(tab) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(tab, 'isVisible') ? tab.isVisible : true;
    },
    isActive: function isActive(tab) {
      return tab.id === this.selectedTabId;
    },
    tabIndex: function tabIndex(tab) {
      return this.isActive(tab) ? '0' : '-1';
    },
    ariaSelectedTabItem: function ariaSelectedTabItem(tab) {
      return this.isActive(tab) ? 'true' : 'false';
    },
    selectTab: function selectTab(selectedTab) {
      if (!this.isActive(selectedTab)) {
        this.$emit('click', { id: selectedTab.id });
      }
    },
    rightArrowHandler: function rightArrowHandler(index) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(index)) {
        var newIndex = index + 1;
        this.onTabItemFocusByIndex(newIndex);
      }
    },
    leftArrowHandler: function leftArrowHandler(index) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(index)) {
        var newIndex = index - 1;
        this.onTabItemFocusByIndex(newIndex);
      }
    },
    onTabItemFocusByIndex: function onTabItemFocusByIndex(tabIndex) {
      if (tabIndex >= 0 && tabIndex < this.visibleTabs.length) {
        this.$refs['tab-item-' + this.variant + '-' + tabIndex][0].focus();
      }
    },
    onTabClick: function onTabClick(selectedTab) {
      this.selectTab(selectedTab);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-pagination',
  props: {
    itemsPerPage: {
      type: Number,
      required: true
    },
    totalNumOfItems: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsTypeLabel: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    rangeMiddleText: {
      type: String,
      default: 'of'
    }
  },
  computed: {
    isPreviousDisabled: function isPreviousDisabled() {
      return this.disabled || this.currentPage === 1;
    },
    isNextDisabled: function isNextDisabled() {
      return this.disabled || this.currentPage * this.itemsPerPage >= this.totalNumOfItems;
    },
    fromItem: function fromItem() {
      return this.totalNumOfItems ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
    },
    toItem: function toItem() {
      return this.totalNumOfItems ? Math.min(this.currentPage * this.itemsPerPage, this.totalNumOfItems) : 0;
    }
  },
  methods: {
    onNextArrowClicked: function onNextArrowClicked() {
      if (!this.isNextDisabled) {
        this.$emit('change', this.currentPage + 1);
      }
    },
    onPreviousArrowClicked: function onPreviousArrowClicked() {
      if (!this.isPreviousDisabled) {
        this.$emit('change', this.currentPage - 1);
      }
    },
    onLastArrowClicked: function onLastArrowClicked() {
      if (!this.isNextDisabled && this.itemsPerPage > 0) {
        this.$emit('change', Math.ceil(this.totalNumOfItems / this.itemsPerPage));
      }
    },
    onFirstArrowClicked: function onFirstArrowClicked() {
      if (!this.isPreviousDisabled) {
        this.$emit('change', 1);
      }
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49463ef7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_vue__ = __webpack_require__(527);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49463ef7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49463ef7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_tags_le_tags__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_select_list__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_input_field_le_input_field__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_select_dropdown__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__le_select_menu__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_clickOutsideDirective__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consts_consts__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-select',
  components: {
    leSelectList: __WEBPACK_IMPORTED_MODULE_2__le_select_list__["a" /* default */],
    leTags: __WEBPACK_IMPORTED_MODULE_1__le_tags_le_tags__["a" /* default */],
    leInputField: __WEBPACK_IMPORTED_MODULE_3__le_input_field_le_input_field__["a" /* default */],
    leSelectDropdown: __WEBPACK_IMPORTED_MODULE_4__le_select_dropdown__["a" /* default */],
    leSelectMenu: __WEBPACK_IMPORTED_MODULE_5__le_select_menu__["a" /* default */]
  },
  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_6__directives_clickOutsideDirective__["a" /* default */]
  },
  props: {
    id: {
      type: String
    },
    ariaLabelledBy: {
      type: String
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    ariaLabelForSelectList: {
      type: String,
      default: ''
    },
    closeLabel: {
      type: String
    },

    type: {
      required: true,
      validator: function validator(type) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(__WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE), type) > -1;
      }
    },
    theme: {
      type: String,
      default: ''
    },

    items: {
      type: Array,
      required: true
    },

    value: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },

    placeholder: {
      type: String,
      default: 'Select <value>'
    },
    groupIdAttr: {
      type: String,
      default: 'id'
    },

    groupValueAttr: {
      type: String
    },

    groupItemsAttr: {
      type: String
    },

    groupSelectEnable: {
      type: Boolean,
      default: false
    },

    itemIdAttr: {
      type: String,
      default: 'id'
    },

    itemValueAttr: {
      type: String,
      default: 'value'
    },

    itemSubtextAttr: {
      type: String,
      default: 'subtext'
    },
    itemTooltipAttr: {
      type: String,
      default: 'subtext'
    },

    pageSize: {
      type: Number,
      default: 21
    },

    maxItemsToShow: {
      type: Number,
      default: 20
    },

    loadMoreOffset: {
      type: Number,
      default: 20
    },

    itemMinHeight: {
      type: Number,
      default: 32
    },

    floatedList: {
      type: Boolean,
      default: true
    },

    openListOnTop: {
      type: Boolean,
      default: false
    },

    closeOnSelect: {
      type: Boolean
    },

    allowItemCreation: {
      type: Boolean
    },
    itemCreationLabel: {
      type: String,
      default: '+ Create item'
    },

    searchFunc: {
      type: Function,
      default: function _default(items, searchTerm, itemValueAttr) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(items, function (item) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(item[itemValueAttr].toLowerCase().trim(), searchTerm.toLowerCase().trim());
        });
      }
    },
    isGroupSupported: {
      type: Boolean
    },
    noItemsLabel: {
      type: String,
      default: 'No matching value'
    },

    dropdownDefaultSelection: {
      type: Boolean
    },
    displayErrors: {
      type: Boolean,
      default: true
    },
    errorPlacement: {
      type: String
    },

    requestAnimationFrame: {
      type: Boolean,
      default: true
    },

    useIcons: {
      type: Boolean
    },

    useIconsAndText: {
      type: Boolean
    },
    listWithAction: {
      type: Boolean,
      default: false
    },
    actionIconClass: {
      type: String,
      default: ''
    },

    bubbleList: {
      type: Boolean,
      default: false
    },
    bubbleListAlign: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.BUBBLE_LIST_ALIGN.RIGHT
    },

    addItemsSeparator: {
      type: Boolean,
      default: false
    },
    listMinWidth: {
      type: String,
      default: '100%'
    },
    listAlwaysOpen: {
      type: Boolean,
      default: false
    },
    listWithShortcuts: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    },
    container: {
      type: String
    },

    shouldAddPlaceholderItem: {
      type: Boolean,
      default: false
    },
    tooltipPlacement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.RIGHT
    },
    borderRadius: {
      type: Number
    },
    menuIcon: {
      type: String,
      default: ''
    },
    menuIconTooltip: {
      type: String,
      default: ''
    },
    isWarningIconEnable: {
      type: Boolean,
      default: false
    },
    warningIconTooltipText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchTerm: '',
      isListOpen: this.listAlwaysOpen,
      currentPage: 1,
      pointedItemIndex: -1,
      error: null,
      preferredOpenDirection: 'bottom',
      selectListId: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqueId"])('select-list-'),
      arrowKeyText: ''
    };
  },
  created: function created() {
    if (this.isDropdown && !this.value && this.dropdownDefaultSelection) {
      this.$emit('input', this.filteredItems[0]);
    }
    if (this.isSingleSelect && this.selectedItems.length > 0) {
      this.searchTerm = this.selectedItems[0][this.itemValueAttr];
    }
  },

  computed: {
    hasAriaLabelForSelectList: function hasAriaLabelForSelectList() {
      return this.ariaLabelForSelectList !== '';
    },
    mainTabIndex: function mainTabIndex() {
      return this.enabled ? '0' : '-1';
    },
    heightLimit: function heightLimit() {
      var listHeight = this.maxItemsToShow * this.itemMinHeight;
      if (this.pageSize === this.maxItemsToShow) {
        listHeight -= 11;
      }
      return listHeight;
    },
    filteredItems: function filteredItems() {
      var items = void 0;
      if (this.isGroupSupported) {
        items = this.filterAndFlat(this.items, this.searchTerm);
      } else {
        items = this.filterItems(this.items, this.searchTerm);
      }

      this.addItemCreationItem(items);
      this.addPlaceholderItemToList(items);
      this.addNoItemsLabel(items);

      if (this.pageSize) {
        items = items.slice(0, this.pageSize * this.currentPage);
      }
      return items;
    },
    selectedItems: function selectedItems() {
      if (Array.isArray(this.value)) {
        return this.value;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(this.value) ? [] : [this.value];
    },
    selectedItemsIds: function selectedItemsIds() {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.selectedItems, function (item) {
        return item && item[_this.itemIdAttr];
      });
    },
    pointedElementOffsetTop: function pointedElementOffsetTop() {
      return this.pointedItemIndex * this.itemMinHeight;
    },
    shouldOpenListOnTop: function shouldOpenListOnTop() {
      return this.floatedList && (this.preferredOpenDirection === 'top' || this.openListOnTop);
    },
    isMultiSelect: function isMultiSelect() {
      return this.type === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE.MULTISELECT;
    },
    isSingleSelect: function isSingleSelect() {
      return this.type === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE.SINGLESELECT;
    },
    isDropdown: function isDropdown() {
      return this.type === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE.DROPDOWN;
    },
    isActionMenu: function isActionMenu() {
      return this.type === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE.MENU;
    },
    isListOnly: function isListOnly() {
      return this.type === __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.TYPE.LIST_ONLY;
    },
    hasSelectedItems: function hasSelectedItems() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.selectedItemsIds);
    },
    isExpanded: function isExpanded() {
      return this.isListOpen ? 'true' : 'false';
    },
    role: function role() {
      return this.isMultiSelect || this.isSingleSelect || this.isDropdown ? 'combobox' : 'button';
    },
    getSelectListId: function getSelectListId() {
      return this.isMultiSelect || this.isSingleSelect || this.isDropdown ? this.selectListId : null;
    },
    getAriaControlsSelectListId: function getAriaControlsSelectListId() {
      return this.isSingleSelect || this.isDropdown ? this.selectListId : null;
    },
    getAriaOwnsSelectListId: function getAriaOwnsSelectListId() {
      return this.isMultiSelect ? this.selectListId : null;
    }
  },
  watch: {
    searchTerm: function searchTerm() {
      this.$emit('search-change', this.searchTerm);
      this.resetPointedItemIndex();
    },
    isListOpen: function isListOpen() {
      var _this2 = this;

      if (this.isListOpen) {
        this.resetPointedItemIndex();
        this.$nextTick(function () {
          _this2.$refs.itemsList.$el.scrollTop = 0;
        });
      }
    }
  },
  methods: {
    addItemCreationItem: function addItemCreationItem(items) {
      var _this3 = this;

      if (this.allowItemCreation && this.searchTerm.trim() && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(items, function (item) {
        return !item[_this3.itemValueAttr].isGroupLabel && item[_this3.itemValueAttr].toLowerCase().trim() === _this3.searchTerm.toLowerCase().trim();
      })) {
        var _items$unshift;

        items.unshift((_items$unshift = {}, _defineProperty(_items$unshift, this.itemIdAttr, 'leSelectItemCreation'), _defineProperty(_items$unshift, this.itemValueAttr, this.getItemCreationLabel()), _defineProperty(_items$unshift, 'isItemCreation', true), _items$unshift));
      }
    },
    addNoItemsLabel: function addNoItemsLabel(items) {
      if (!items.length) {
        var _items$push;

        items.push((_items$push = {}, _defineProperty(_items$push, this.itemIdAttr, 'leSelectNoItemsLabel'), _defineProperty(_items$push, this.itemValueAttr, this.noItemsLabel), _defineProperty(_items$push, 'isNoItemsLabel', true), _items$push));
      }
    },
    addPlaceholderItemToList: function addPlaceholderItemToList(items) {
      if (this.isDropdown && this.hasSelectedItems && this.shouldAddPlaceholderItem) {
        var _items$unshift2;

        items.unshift((_items$unshift2 = {}, _defineProperty(_items$unshift2, this.itemIdAttr, 'leSelectPlaceholderItem'), _defineProperty(_items$unshift2, this.itemValueAttr, this.placeholder), _defineProperty(_items$unshift2, 'isPlaceholderItem', true), _items$unshift2));
      }
    },
    showList: function showList() {
      var _this4 = this;

      if (this.isListOpen) {
        return;
      }

      this.adjustPosition();

      this.isListOpen = true;

      this.$nextTick(function () {
        if (!(_this4.isSingleSelect || _this4.isMultiSelect)) {
          _this4.$refs.itemsList.$el.focus();
        }
      });
    },
    hideList: function hideList() {
      if (!this.isListOpen || this.listAlwaysOpen) {
        return;
      }

      this.isListOpen = false;
    },

    onListScroll: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["throttle"])(function (event) {
      var totalHeight = this.$refs.itemsList.$el.scrollHeight;
      var currentScrollTop = this.$refs.itemsList.$el.scrollTop;
      var currentHeight = this.$refs.itemsList.$el.clientHeight;
      var bottomLine = currentScrollTop + currentHeight;

      if (this.pageSize && totalHeight - bottomLine <= this.loadMoreOffset) {
        this.currentPage = this.currentPage + 1;
      }
    }, 200),
    onClickOutside: function onClickOutside() {
      if (this.isMultiSelect) {
        this.onMultiselectClickOutside();
      }
      if (this.isSingleSelect) {
        this.onSingleSelectClickOutside();
      }

      this.hideList();
    },
    onMultiselectClickOutside: function onMultiselectClickOutside() {
      var _this5 = this;

      this.searchTerm = this.searchTerm.trim();
      var firstMatchingItem = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(this.filteredItems, function (item) {
        return !item.isGroupLabel && item[_this5.itemValueAttr] === _this5.searchTerm;
      });

      if (this.displayErrors && this.searchTerm && !firstMatchingItem) {
        var error = this.allowItemCreation ? __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.ERRORS.MULTI_SELECT.UNFINISHED_CREATE : __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.ERRORS.MULTI_SELECT.INVALID_ITEM;
        this.setError(true, error);
      } else {
        this.setError(false);
      }
    },
    onSingleSelectClickOutside: function onSingleSelectClickOutside() {
      var _this6 = this;

      this.searchTerm = this.searchTerm.trim();
      var firstMatchingItem = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(this.filteredItems, function (item) {
        return !item.isGroupLabel && item[_this6.itemValueAttr] === _this6.searchTerm;
      });

      if (firstMatchingItem) {
        this.selectItem(firstMatchingItem);
        this.setError(false);
      } else {
        this.$emit('input', null);
        if (this.displayErrors && this.searchTerm) {
          this.setError(true, __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_SELECT_CONSTS.ERRORS.SINGLE_SELECT.INVALID_ITEM);
        } else {
          this.setError(false);
        }
      }
    },
    onListClick: function onListClick() {
      if (!this.isListOpen) {
        this.showList();
      }
    },
    onUnselectItem: function onUnselectItem(item) {
      var _this7 = this;

      if (this.requestAnimationFrame) {
        requestAnimationFrame(function () {
          _this7.unselectItem(item);
        });
      } else {
        this.unselectItem(item);
      }
    },
    unselectItem: function unselectItem(removedItem) {
      var itemIndex = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"])(this.selectedItemsIds, removedItem[this.itemIdAttr]);
      var newSelectedItems = this.selectedItems.slice(0, itemIndex).concat(this.selectedItems.slice(itemIndex + 1));
      this.$emit('input', newSelectedItems);
      this.$emit('unselect', removedItem);
    },
    unselectGroup: function unselectGroup(removedItemsArray) {
      for (var i = 0; i < removedItemsArray.length; i += 1) {
        var itemIndex = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"])(this.selectedItemsIds, removedItemsArray[i][this.itemIdAttr]);
        this.selectedItems.splice(itemIndex, 1);
      }
      this.$emit('input', this.selectedItems);
      this.$emit('unselectGroup', removedItemsArray);
    },
    selectItem: function selectItem(item) {
      var _this8 = this;

      if (this.requestAnimationFrame) {
        requestAnimationFrame(function () {
          _this8.doSelectItem(item);
        });
      } else {
        this.doSelectItem(item);
      }
    },
    selectGroup: function selectGroup(itemsArray) {
      var _this9 = this;

      if (this.requestAnimationFrame) {
        requestAnimationFrame(function () {
          _this9.doSelectGroup(itemsArray);
        });
      } else {
        this.doSelectGroup(itemsArray);
      }
    },
    doSelectGroup: function doSelectGroup(itemsArray) {
      var _this10 = this;

      this.$emit('selectGroup', itemsArray);
      this.searchTerm = '';
      itemsArray.forEach(function (item) {
        _this10.selectedItems.push(item);
      });
      this.$emit('input', this.selectedItems);
    },
    doSelectItem: function doSelectItem(item) {
      this.$emit('select', item);
      if (this.isMultiSelect) {
        this.$emit('input', this.selectedItems.concat([item]));
        this.searchTerm = '';
      } else {
        this.$emit('input', item);
        if (this.isSingleSelect && !this.listAlwaysOpen) {
          this.searchTerm = item[this.itemValueAttr];
        }
      }
    },
    getItemCreationLabel: function getItemCreationLabel() {
      return this.itemCreationLabel + ' "' + this.searchTerm.trim() + '"';
    },
    onListItemHover: function onListItemHover(index) {
      this.pointedItemIndex = index;
    },
    onListGroupHover: function onListGroupHover(index) {
      if (this.groupSelectEnable) {
        this.pointedItemIndex = index;
      }
    },
    onListItemClicked: function onListItemClicked(item) {
      if (item.isGroupLabel) {
        return;
      }

      this.decideActionOnItem(item);

      if (!this.isMultiSelect || this.closeOnSelect) {
        this.$refs.dropdownWrapper.focus();
        this.hideList();
      }
      if (this.isSingleSelect) {
        this.searchTerm = this.searchTerm.trim();
      }
    },
    onListGroupClicked: function onListGroupClicked(_ref) {
      var groupItems = _ref.groupItems,
          groupStatus = _ref.groupStatus,
          selectedGroupItems = _ref.selectedGroupItems;

      switch (groupStatus) {
        case __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.CHECKED:
        case __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.INDETERMINATE:
          this.unselectGroup(selectedGroupItems);
          break;
        case __WEBPACK_IMPORTED_MODULE_7__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.UNCHECKED:
        default:
          this.selectGroup(this.getSelectedGroupComplement(selectedGroupItems, groupItems));
          break;
      }
    },
    getSelectedGroupComplement: function getSelectedGroupComplement(selectedGroupItems, groupItems) {
      var _this11 = this;

      var comparison = function comparison(itemA, itemB) {
        return itemA[_this11.itemIdAttr] !== itemB[_this11.itemIdAttr];
      };
      var result = groupItems.filter(function (itemB) {
        return selectedGroupItems.every(function (itemA) {
          return comparison(itemA, itemB);
        });
      });
      return result;
    },
    decideActionOnItem: function decideActionOnItem(item) {
      if (item.isItemCreation) {
        this.createNewItem();
      } else if (this.isItemSelected(item) && this.isMultiSelect) {
        this.unselectItem(item);
      } else if (item.isPlaceholderItem) {
        var removedItem = this.selectedItems[0];
        this.unselectItem(removedItem);
      } else if (!item.isGroupLabel) {
        this.selectItem(item);
      }
    },
    createNewItem: function createNewItem() {
      this.$emit('create', this.searchTerm);
      this.searchTerm = '';
    },
    selectPointedElement: function selectPointedElement() {
      var pointedItem = this.filteredItems[this.pointedItemIndex];
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(pointedItem, 'disabled')) {
        if (this.filteredItems.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(pointedItem, 'isNoItemsLabel')) {
          this.decideActionOnItem(pointedItem);
        }

        if (!this.isMultiSelect || this.closeOnSelect) {
          this.hideList();
          if (!this.isSingleSelect) {
            this.$refs.dropdownWrapper.focus();
          }
        }
      }
    },
    movePointedElementDown: function movePointedElementDown() {
      var _this12 = this;

      var isNotLastItem = this.pointedItemIndex < this.filteredItems.length - 1;
      var nextItem = this.filteredItems[this.pointedItemIndex + 1];
      var isNextHasNotItemsLabel = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(nextItem, 'isNoItemsLabel');

      if (isNotLastItem && !isNextHasNotItemsLabel && this.hasEnabledItems(this.pointedItemIndex + 1, this.filteredItems.length - 1)) {
        this.pointedItemIndex = this.pointedItemIndex + 1;
        var pointedElementScrollTop = this.pointedElementOffsetTop - (this.maxItemsToShow - 1) * this.itemMinHeight;

        if (this.$refs.itemsList.$el.scrollTop <= pointedElementScrollTop) {
          this.$refs.itemsList.$el.scrollTop = pointedElementScrollTop;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.filteredItems[this.pointedItemIndex], 'isGroupLabel') || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(nextItem, 'disabled')) {
          this.movePointedElementDown();
        }
      }
      setTimeout(function () {
        _this12.arrowKeyAnnouncement();
      }, 500);
    },
    movePointedElementUp: function movePointedElementUp() {
      var _this13 = this;

      var prevItem = this.filteredItems[this.pointedItemIndex - 1];

      if (this.pointedItemIndex === 1 && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(prevItem, 'isGroupLabel') || !this.hasEnabledItems(0, this.pointedItemIndex - 1)) {
        return;
      }
      if (this.pointedItemIndex >= 0) {
        this.pointedItemIndex = this.pointedItemIndex - 1;
        if (this.$refs.itemsList.$el.scrollTop >= this.pointedElementOffsetTop) {
          this.$refs.itemsList.$el.scrollTop = this.pointedElementOffsetTop;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.filteredItems[this.pointedItemIndex], 'isGroupLabel') || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(prevItem, 'disabled')) {
          this.movePointedElementUp();
        }
      }
      setTimeout(function () {
        _this13.arrowKeyAnnouncement();
      }, 500);
    },
    hasEnabledItems: function hasEnabledItems(startIndex, endIndex) {
      for (var i = startIndex; i <= endIndex; i += 1) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.filteredItems[i], 'disabled')) {
          return true;
        }
      }
      return false;
    },
    arrowKeyAnnouncement: function arrowKeyAnnouncement() {
      if (this.$el && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(this.$el.querySelector)) {
        var pointedElement = this.$el.querySelector('.pointed');
        var selectedElement = this.$el.querySelector('.selected');
        var itemText = '';
        if (pointedElement) {
          itemText = pointedElement.innerText;
        } else if (selectedElement) {
          itemText = selectedElement.innerText;
        }
        if (itemText !== '' && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(this.pointedItemIndex) && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(this.filteredItems)) {
          this.arrowKeyText = itemText + ' option ' + (this.pointedItemIndex + 1) + ' of ' + this.filteredItems.length;
        }
      }
    },
    resetPointedItemIndex: function resetPointedItemIndex() {
      this.pointedItemIndex = -1;
    },
    filterAndFlat: function filterAndFlat(items, searchTerm) {
      var filteredItems = this.filterGroups(items, searchTerm);
      return this.flattenItems(filteredItems);
    },
    filterItems: function filterItems(items, searchTerm) {
      return this.searchFunc(items, searchTerm, this.itemValueAttr);
    },
    filterGroups: function filterGroups(items, searchTerm) {
      var _this14 = this;

      var filteredGroups = [];
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(items, function (group) {
        var groupItems = _this14.filterItems(group[_this14.groupItemsAttr], searchTerm);

        if (groupItems.length) {
          var _filteredGroups$push;

          filteredGroups.push((_filteredGroups$push = {}, _defineProperty(_filteredGroups$push, _this14.groupIdAttr, group[_this14.groupIdAttr]), _defineProperty(_filteredGroups$push, _this14.groupValueAttr, group[_this14.groupValueAttr]), _defineProperty(_filteredGroups$push, _this14.groupItemsAttr, groupItems), _filteredGroups$push));
        }
      });
      return filteredGroups;
    },
    flattenItems: function flattenItems(items) {
      var _this15 = this;

      var flattenedItems = [];
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(items, function (group) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(group[_this15.groupItemsAttr])) {
          var _flattenedItems$push;

          flattenedItems.push((_flattenedItems$push = {}, _defineProperty(_flattenedItems$push, _this15.itemIdAttr, group[_this15.groupIdAttr]), _defineProperty(_flattenedItems$push, _this15.itemValueAttr, group[_this15.groupValueAttr]), _defineProperty(_flattenedItems$push, 'isGroupLabel', true), _flattenedItems$push));
          Array.prototype.push.apply(flattenedItems, group[_this15.groupItemsAttr]);
        }
      });
      return flattenedItems;
    },
    onSearchInputChange: function onSearchInputChange(searchTerm) {
      this.error = null;
      this.searchTerm = searchTerm;
    },
    resetSearchTerm: function resetSearchTerm() {
      this.searchTerm = '';
    },
    isItemSelected: function isItemSelected(item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"])(this.selectedItemsIds, item[this.itemIdAttr]) > -1;
    },
    onDropdownToggle: function onDropdownToggle(state) {
      if (state) {
        this.showList();
      } else {
        this.hideList();
      }
    },
    onActionMenuToggle: function onActionMenuToggle(state) {
      if (state) {
        this.showList();
      } else {
        this.hideList();
      }
    },
    adjustPosition: function adjustPosition() {
      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.heightLimit;
      var hasEnoughSpaceAbove = spaceAbove > this.heightLimit;
      if (!hasEnoughSpaceAbove || hasEnoughSpaceBelow) {
        this.preferredOpenDirection = 'bottom';
      } else {
        this.preferredOpenDirection = 'top';
      }
    },
    setError: function setError(showError, error) {
      this.error = showError ? error : '';
      if (this.isSingleSelect) {
        this.$refs.singleSelectInput.setError(showError, this.error);
      }
      if (this.isMultiSelect) {
        this.$refs.tagsInput.setError(showError, this.error);
      }
      if (this.isDropdown) {
        this.$refs.dropdownInput.setError(showError, this.error);
      }
    },
    clearError: function clearError() {
      if (this.isSingleSelect) {
        this.$refs.singleSelectInput.clearError();
      }
      if (this.isMultiSelect) {
        this.$refs.tagsInput.clearError();
      }
      if (this.isDropdown) {
        this.$refs.dropdownInput.clearError();
      }
      this.error = '';
    },
    getError: function getError() {
      return this.error;
    },
    onKeydownDown: function onKeydownDown() {
      this.movePointedElementDown();
    },
    onKeydownUp: function onKeydownUp() {
      this.movePointedElementUp();
    },
    onKeydownEnter: function onKeydownEnter(e) {
      if (!this.isListOpen) {
        this.onDropdownToggle(true);
      } else if (this.isSingleSelect) {
        if (this.pointedItemIndex === -1) {
          return;
        }
        this.selectPointedElement();
      } else if (this.isMultiSelect) {
        if (this.pointedItemIndex === -1) {
          return;
        }
        this.selectPointedElement();
        e.preventDefault();
        e.stopPropagation();
      } else if (this.pointedItemIndex === -1) {
        this.hideList();
        this.$refs.dropdownWrapper.focus();
      } else {
        this.selectPointedElement();
      }
    },
    onKeydownEsc: function onKeydownEsc() {
      this.$refs.dropdownWrapper.focus();
      this.hideList();
    },
    onItemActionClicked: function onItemActionClicked(item) {
      this.$emit('onItemActionClicked', item);
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_tag__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_bubble_le_bubble__ = __webpack_require__(15);






var specialSpace = String.fromCharCode(160);
var regularSpace = String.fromCharCode(32);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-tags',
  components: {
    leTag: __WEBPACK_IMPORTED_MODULE_1__le_tag__["a" /* default */],
    leBubble: __WEBPACK_IMPORTED_MODULE_2__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    searchTerm: {
      type: String,
      default: ''
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select <value>'
    },
    tabbable: {
      type: Boolean,
      default: true
    },
    tagIdAttr: {
      type: String,
      default: 'id'
    },
    tagValueAttr: {
      type: String,
      default: 'value'
    },
    tagSubtextAttr: {
      type: String,
      default: 'subtext'
    },
    errorPlacement: {
      type: String,
      default: 'bottom'
    },
    enabled: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String
    },
    showVerticalScrollbar: {
      type: Boolean
    },
    clearInputOnTagAdded: {
      type: Boolean,
      default: true
    },
    clickableTags: {
      type: Boolean,
      default: false
    },
    controlId: {
      type: String
    },
    isWarningIconEnable: {
      type: Boolean,
      default: false
    },
    warningIconTooltipText: {
      type: String,
      default: ''
    },
    closeLabel: {
      type: String
    }
  },
  data: function data() {
    return {
      searchInputText: this.searchTerm || '',
      searchInputFocused: false,
      errorMsg: '',
      bubbleErrorMsg: '',
      showError: false,
      searchInputHasValue: !!this.searchTerm
    };
  },

  computed: {
    placeholderOnNoSelection: function placeholderOnNoSelection() {
      return this.tags.length === 0 ? this.placeholder : '';
    },
    inputContainerStyle: function inputContainerStyle() {
      return this.placeholderOnNoSelection || this.searchTerm || this.searchInputHasValue ? { width: 'auto' } : { width: 0 };
    },
    hasError: function hasError() {
      return this.errorMsg.length > 0;
    },
    tagsStyle: function tagsStyle() {
      var style = {};
      if (this.maxHeight) {
        style['max-height'] = this.maxHeight;
      }
      if (this.showVerticalScrollbar) {
        style['overflow-y'] = this.showVerticalScrollbar ? 'auto' : 'visible';
      }
      return style;
    },
    tabIndex: function tabIndex() {
      return this.tabbable && this.enabled ? '0' : '-1';
    }
  },
  methods: {
    onUnselect: function onUnselect(id) {
      var removedTag = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(this.tags, { id: id });
      this.$emit('unselect', removedTag);
      this.$refs.searchInput.focus();
    },
    onSelect: function onSelect(id) {
      var selectedTag = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(this.tags, { id: id });
      this.$emit('select', selectedTag);
    },
    scrollToBottom: function scrollToBottom() {
      this.$refs.tagsContainer.scrollTop = this.$refs.tagsContainer.scrollHeight;
    },
    focus: function focus() {
      if (this.enabled) {
        this.$refs.searchInput.focus();
      }
    },
    blur: function blur() {
      this.$refs.searchInput.blur();
      this.searchInputFocused = false;
    },

    onKeyup: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function () {
      this.onTagInputValueChange();
    }, 150),
    onSubmit: function onSubmit() {
      var trimmedValue = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(this.searchTerm);
      if (trimmedValue.length !== this.searchTerm.length) {
        this.$emit('input', trimmedValue);
      }
      if (trimmedValue.length !== 0) {
        this.$emit('searchInputSubmit');
      }
    },
    onCut: function onCut() {
      this.onTagInputValueChange();
    },
    onPaste: function onPaste() {
      this.onTagInputValueChange();
    },
    onTagInputValueChange: function onTagInputValueChange() {
      if (this.enabled) {
        var text = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.$refs, 'searchInput.innerText', '');
        var textWithFixedSpaces = text.replace(specialSpace, regularSpace);
        this.$emit('input', textWithFixedSpaces);
        this.searchInputHasValue = !!this.$refs.searchInput.innerText;
        this.errorMsg = '';
      }
    },
    onOuterFocus: function onOuterFocus() {
      if (this.enabled) {
        this.$refs.searchInput.focus();
      }
    },
    emitFocusEvent: function emitFocusEvent() {
      if (this.enabled) {
        this.searchInputFocused = true;
        this.$emit('focus');
        this.clearError();
      }
    },
    emitBlurEvent: function emitBlurEvent() {
      this.searchInputFocused = false;
      this.$emit('blur');
    },
    setError: function setError(showError, errorMsg) {
      if (showError) {
        this.errorMsg = errorMsg;
        this.bubbleErrorMsg = this.errorMsg;
      } else {
        this.clearError();
      }
      this.toggleErrorBubble(this.hasError && this.searchInputFocused);
    },
    clearError: function clearError() {
      this.toggleErrorBubble(false);
      this.errorMsg = '';
    },
    toggleErrorBubble: function toggleErrorBubble(showBubble) {
      this.showError = showBubble;
    },
    onTab: function onTab() {
      this.$emit('tabout');
    }
  },
  watch: {
    tags: function tags(newTags, oldTags) {
      if (this.clearInputOnTagAdded && newTags.length > oldTags.length) {
        this.$refs.searchInput.innerText = '';
      }
    },
    searchTerm: function searchTerm() {
      if (this.searchTerm === '') {
        this.$refs.searchInput.innerText = '';
        this.searchInputHasValue = false;
      }
    },
    tabbable: function tabbable() {
      if (this.tabbable) {
        this.$refs.searchInput.focus();
      }
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-tag',
  props: {
    tag: {
      type: Object,
      required: true
    },
    closeLabel: {
      type: String
    },
    valueAttr: {
      type: String,
      default: 'value'
    },
    idAttr: {
      type: String,
      default: 'id'
    },
    subtextAttr: {
      type: String,
      default: 'subtext'
    },
    enabled: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tagTooltip: function tagTooltip() {
      return this.tag[this.subtextAttr] ? this.tag[this.valueAttr] + ' - ' + this.tag[this.subtextAttr] : '';
    },
    removeButtonAriaLabel: function removeButtonAriaLabel() {
      return this.closeLabel ? this.closeLabel : 'Remove ' + this.tag[this.valueAttr];
    }
  },
  methods: {
    onUnselectClick: function onUnselectClick() {
      if (this.enabled) {
        this.$emit('unselect');
      }
    },
    onSelectClick: function onSelectClick() {
      if (this.clickable && this.enabled) {
        this.$emit('select');
      }
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_checkbox_le_checkbox__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-select-list',
  components: {
    leCheckbox: __WEBPACK_IMPORTED_MODULE_2__le_checkbox_le_checkbox__["a" /* default */],
    leTextWithHighlight: __WEBPACK_IMPORTED_MODULE_3__le_text_with_highlight_le_text_with_highlight__["a" /* default */]
  },
  props: {
    pointedItemIndex: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemIdAttr: {
      type: String,
      required: true
    },
    itemValueAttr: {
      type: String,
      required: true
    },
    itemSubtextAttr: {
      type: String
    },
    groupSelection: {
      type: Boolean,
      default: false
    },
    itemTooltipAttr: {
      type: String
    },
    hasShortcuts: {
      type: Boolean,
      default: false
    },
    isMultiSelect: {
      type: Boolean,
      default: false
    },
    selectedItemsIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listMaxHeight: {
      type: Number,
      required: true
    },
    itemMinHeight: {
      type: Number,
      required: true
    },
    floatedList: {
      type: Boolean,
      default: false
    },
    openListOnTop: {
      type: Boolean,
      default: false
    },
    hasIconsOnly: {
      type: Boolean
    },
    hasIconsAndText: {
      type: Boolean
    },
    hasAction: {
      type: Boolean,
      default: false
    },
    actionIconClass: {
      type: String,
      default: ''
    },
    bubbleList: {
      type: Boolean,
      default: false
    },
    bubbleListAlign: {
      type: String,
      required: true
    },
    addItemsSeparator: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      required: true
    },
    isOpenList: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    tabIndex: function tabIndex() {
      return this.isMultiSelect ? '-1' : '0';
    }
  },
  methods: {
    isSpecialItem: function isSpecialItem(item) {
      return item.isNoItemsLabel || item.isItemCreation || item.isPlaceholderItem;
    },
    isGroupItem: function isGroupItem(item) {
      return item.isGroupLabel;
    },
    showGroupItemCheckbox: function showGroupItemCheckbox(item) {
      return this.isMultiSelect && this.groupSelection && this.isGroupItem(item);
    },
    showItem: function showItem(item) {
      return !(this.isSpecialItem(item) || this.isGroupItem(item));
    },
    getSpecialItemClass: function getSpecialItemClass(item) {
      var className = '';
      if (item.isNoItemsLabel) {
        className = 'no-items';
      } else if (item.isItemCreation) {
        className = 'item-creation';
      } else if (item.isGroupLabel) {
        className = 'group-item';
      } else if (item.isPlaceholderItem) {
        className = 'placeholder-item';
      }
      return className;
    },
    isPointed: function isPointed(itemIndex, item, totalItems) {
      return this.pointedItemIndex === itemIndex && !this.isSpecialItem(item) && !(this.bubbleList && totalItems <= 1);
    },
    onItemHover: function onItemHover(item, index) {
      if (this.groupSelection && item.isGroupLabel) {
        this.$emit('groupHover', index);
      }
      if (!item.isGroupLabel && !item.isNoItemsLabel) {
        this.$emit('itemHover', index);
      }
    },
    onItemClicked: function onItemClicked(item) {
      if (this.showGroupItemCheckbox(item) && !item.disabled) {
        var groupItems = this.getGroupItems(item);
        var selectedGroupItems = this.getSelectedGroupItems(groupItems);
        var groupStatus = this.getGroupItemState(item);
        this.$emit('groupClicked', { groupItems: groupItems, groupStatus: groupStatus, selectedGroupItems: selectedGroupItems });
      }
      if (!item.isNoItemsLabel && !item.isGroupLabel && !item.disabled) {
        this.$emit('itemClicked', item);
      }
    },
    isItemSelected: function isItemSelected(item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(this.selectedItemsIds, item[this.itemIdAttr]);
    },
    isGroupSelected: function isGroupSelected(item) {
      return this.showGroupItemCheckbox(item) && this.getGroupItemState(item) === __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.CHECKED;
    },
    getGroupItemState: function getGroupItemState(item) {
      if (!this.groupSelection || !item.isGroupLabel) {
        return false;
      }
      var groupItemsArray = this.getGroupItems(item);

      var selectedGroupItems = this.getSelectedGroupItems(groupItemsArray);

      if (selectedGroupItems.length === groupItemsArray.length) {
        return __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.CHECKED;
      }

      return selectedGroupItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.INDETERMINATE : __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_CHECKBOX.STATES.UNCHECKED;
    },
    getSelectedGroupItems: function getSelectedGroupItems(groupItemsArray) {
      var _this = this;

      return groupItemsArray.reduce(function (selectedGroupItems, groupItem) {
        if (_this.isItemSelected(groupItem)) {
          return [].concat(_toConsumableArray(selectedGroupItems), [groupItem]);
        }
        return selectedGroupItems;
      }, []);
    },
    getGroupItems: function getGroupItems(groupItem) {
      var _this2 = this;

      var groupIndices = this.items.filter(function (singleItem) {
        return _this2.isGroupItem(singleItem);
      });
      var groupStartIndex = this.items.indexOf(groupItem);
      var nextGroupItem = groupIndices[groupIndices.indexOf(groupItem) + 1];
      var groupEndIndex = nextGroupItem === undefined ? null : this.items.indexOf(nextGroupItem);
      return groupEndIndex ? this.items.slice(groupStartIndex + 1, groupEndIndex) : this.items.slice(groupStartIndex + 1);
    },
    getItemLabel: function getItemLabel(item) {
      var subtext = this.itemSubtextAttr && item[this.itemSubtextAttr] ? ' (' + item[this.itemSubtextAttr] + ')' : '';
      return '' + item[this.itemValueAttr] + subtext;
    },
    getItemShortcut: function getItemShortcut(item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, 'shortcut', '');
    },
    onListScroll: function onListScroll() {
      this.$emit('scroll');
    },
    getIconClass: function getIconClass(item) {
      return this.hasIconsAndText && item.class ? item.class : null;
    },
    getIconTooltip: function getIconTooltip(item) {
      return item.tooltipText ? item.tooltipText : '';
    },
    isItemActionable: function isItemActionable(item) {
      return this.hasAction && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, 'isActionable', false);
    },
    getActionIconClass: function getActionIconClass(item) {
      return item.actionIconClass || this.actionIconClass;
    },
    onItemActionClick: function onItemActionClick(item) {
      this.$emit('itemActionClicked', item);
    },
    onItemTab: function onItemTab(event, index) {
      if (!event.shiftKey && index === this.items.length - 1) {
        this.$emit('tabout');
      }
    },
    onWrapperTab: function onWrapperTab(event) {
      if (!event.shiftKey) {
        this.$emit('tabout');
      }
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_bubble_le_bubble__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-text-with-highlight',
  components: {
    leBubble: __WEBPACK_IMPORTED_MODULE_1__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    text: {
      type: String,
      required: true
    },
    highlightText: {
      type: [String, RegExp],
      default: ''
    },
    minSearchCharacters: {
      type: Number,
      default: 1
    },
    headingAriaLevel: {
      type: Number,
      default: 2
    }
  },
  render: function render() {
    var vm = this;

    return vm.$createElement('div', {
      staticClass: 'le-text-with-highlight',
      attrs: {
        role: 'heading',
        'aria-level': this.headingAriaLevel
      }
    }, [vm._l(vm.splitStrings, function (splitString) {
      return splitString.text && (splitString.highlight ? vm.$createElement('span', { class: ['text', 'highlight'], 'data-test': 'highlighted_txt' }, [vm._v(splitString.text)]) : vm._v(splitString.text));
    })]);
  },

  computed: {
    splitStrings: function splitStrings() {
      var splitTexts = [];
      if (this.text && this.highlightText && (this.highlightText.length >= this.minSearchCharacters || this.highlightText instanceof RegExp)) {
        var reg = this.highlightText instanceof RegExp ? this.highlightText : new RegExp('(' + Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["escapeRegExp"])(this.highlightText) + ')', 'gim');
        splitTexts = this.text.split(reg).map(function (val, i) {
          return i % 2 === 0 ? {
            text: val
          } : {
            text: val,
            highlight: true
          };
        });
      }
      return splitTexts.length > 0 ? splitTexts : [{ text: this.text }];
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_bubble_le_bubble__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-input-field',
  components: {
    leBubble: __WEBPACK_IMPORTED_MODULE_1__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    id: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: true
    },
    errorPlacement: {
      type: String,
      default: 'right'
    },
    throttle: {
      type: Number
    },
    maxChars: {
      type: Number,
      default: 99999
    },
    minValue: {
      type: Number,
      default: null
    },
    maxValue: {
      type: Number,
      default: null
    },
    showResetInputButton: {
      type: Boolean
    },
    inputHeight: {
      type: String
    },
    inputPaddingLeft: {
      type: Number
    },
    inputPaddingRight: {
      type: Number
    },
    tooltipPlacement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.RIGHT
    },
    inputType: {
      type: String,
      validator: function validator(type) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE), type);
      },
      default: __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE.TEXT
    },
    ariaDescBy: {
      type: String
    },
    ariaLabelledBy: {
      type: String
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    ariaLabelSearchClear: {
      type: String,
      default: 'Clear'
    },
    borderRadius: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showError: false,
      errorMsg: '',
      bubbleErrorMsg: '',
      tooltipText: '',
      previousValue: ''
    };
  },

  computed: {
    hasError: function hasError() {
      return this.errorMsg.length > 0;
    },
    inputStyle: function inputStyle() {
      var style = {};
      if (this.inputHeight) {
        style.height = this.inputHeight;
      }
      return style === {} ? '' : style;
    },
    inputPaddingStyle: function inputPaddingStyle() {
      var style = {};
      if (this.inputPaddingLeft) {
        style['padding-left'] = this.inputPaddingLeft;
      }
      if (this.inputPaddingRight) {
        style['padding-right'] = this.inputPaddingRight;
      }
      return style === {} ? '' : style;
    },
    shouldShowSearchIcon: function shouldShowSearchIcon() {
      return this.inputType === __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE.SEARCH;
    },
    shouldShowResetButton: function shouldShowResetButton() {
      return this.isValueNotEmpty && this.showResetInputButton;
    },
    isValueNotEmpty: function isValueNotEmpty() {
      return this.value !== '' && this.value !== undefined;
    },
    inputTooltip: function inputTooltip() {
      return { content: this.tooltipText, placement: this.tooltipPlacement, html: false, autoHide: false };
    },
    borderRadiusStyle: function borderRadiusStyle() {
      var style = {};
      if (this.borderRadius) {
        style['border-radius'] = this.borderRadius + 'px';
      }
      return style === {} ? '' : style;
    },
    getInputType: function getInputType() {
      return this.inputType === 'password' ? 'password' : 'text';
    }
  },
  created: function created() {
    var _this = this;

    if (this.throttle) {
      this.inputFunc = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["throttle"])(function () {
        _this.emitInputChange();
      }, this.throttle, { leading: false, trailing: true });
    } else {
      this.inputFunc = this.emitInputChange;
    }
  },
  mounted: function mounted() {
    this.updateTooltipText();

    var isValid = this.validateByType(this.value, this.inputType);
    if (isValid) {
      this.previousValue = this.value;
    } else {
      this.clearInputValue();
    }
  },
  updated: function updated() {
    this.updateTooltipText();
  },

  methods: {
    updateTooltipText: function updateTooltipText() {
      var hasEllipsis = this.$refs.inputField && this.$refs.inputField.scrollWidth > this.$refs.inputField.offsetWidth;
      this.tooltipText = hasEllipsis ? this.value : '';
    },
    onResetClick: function onResetClick() {
      this.clearInputValue();
    },
    clearInputValue: function clearInputValue() {
      this.$refs.inputField.value = '';
      this.clearError();
      this.emitInputChange();
    },
    onInput: function onInput() {
      var inputValue = this.$refs.inputField.value;
      var isValid = this.validateByType(inputValue, this.inputType);
      if (this.throttle) {
        this.$emit('typing', true);
      }
      if (isValid) {
        this.previousValue = inputValue;
        this.inputFunc();
      } else {
        this.$refs.inputField.value = this.previousValue;
        this.$emit('type-validation-error');
      }
    },
    validateByType: function validateByType(inputValue, inputType) {
      var isValid = void 0;
      switch (inputType) {
        case __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE.POSITIVE_INTEGER_OR_ZERO:
          isValid = this.validatePositiveIntegerOrZero(inputValue);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE.NEGATIVE_OR_POSITIVE_FLOAT_OR_ZERO:
          isValid = this.validateFloatNegativePositiveOrZero(inputValue);
          break;
        case __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_INPUT_FIELD.TYPE.NEGATIVE_OR_POSITIVE_INTEGER_OR_ZERO:
          isValid = this.validateIntegerNegativePositiveOrZero(inputValue);
          break;
        default:
          isValid = true;
          break;
      }
      return isValid;
    },
    validatePositiveIntegerOrZero: function validatePositiveIntegerOrZero(inputValue) {
      var regex = /^\d+$/g;
      var isValid = false;
      if ((inputValue.length === 0 || regex.test(inputValue)) && this.isNumberRangeValid(inputValue)) {
        isValid = true;
      }
      return isValid;
    },
    validateFloatNegativePositiveOrZero: function validateFloatNegativePositiveOrZero(inputValue) {
      var regex = /^[-]?[\d]+\.?[\d]*$/g;
      var isValid = false;
      if ((inputValue.length === 0 || inputValue.length === 1 && inputValue === '-' || regex.test(inputValue)) && this.isNumberRangeValid(inputValue)) {
        isValid = true;
      }
      return isValid;
    },
    validateIntegerNegativePositiveOrZero: function validateIntegerNegativePositiveOrZero(inputValue) {
      var isValid = false;

      if ((inputValue.length === 0 || inputValue.length === 1 && inputValue === '-' || parseInt(inputValue, 10) == inputValue) && this.isNumberRangeValid(inputValue)) {
        isValid = true;
      }
      return isValid;
    },
    isNumberRangeValid: function isNumberRangeValid(inputValue) {
      var isValid = true;
      if (this.minValue !== null && this.minValue > inputValue) {
        isValid = false;
      }
      if (this.maxValue !== null && this.maxValue < inputValue) {
        isValid = false;
      }
      return isValid;
    },
    onKeyUp: function onKeyUp() {
      this.showError = false;
    },
    emitInputChange: function emitInputChange() {
      if (this.throttle) {
        this.$emit('typing', false);
      }
      this.$emit('input', this.$refs.inputField.value);
    },
    onFocus: function onFocus() {
      this.$emit('focus');
      this.showError = this.hasError;
      this.bubbleErrorMsg = this.errorMsg;
    },
    onBlur: function onBlur(event) {
      this.$emit('blur', event);
      this.showError = false;
    },
    onSubmit: function onSubmit() {
      this.$emit('submit');
    },
    blur: function blur() {
      this.$refs.inputField.blur();
    },
    setError: function setError(showError, errorMsg) {
      if (showError) {
        this.errorMsg = errorMsg;
      } else {
        this.clearError();
      }
    },
    clearError: function clearError() {
      this.showError = false;
      this.errorMsg = '';
    },
    setFocus: function setFocus() {
      var _this2 = this;

      this.$refs.inputField.focus();
      setTimeout(function () {
        _this2.$refs.inputField.focus();
      }, 200);
    }
  },
  watch: {
    value: {
      handler: function handler() {
        if (this.$refs.inputField && this.$refs.inputField.value != this.value) {
          var isValid = this.validateByType(this.value, this.inputType);
          if (isValid) {
            this.previousValue = this.value;
          }
        }
      },

      immediate: true
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-select-dropdown',
  components: {
    leBubble: __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    selectedItem: {
      type: Object
    },
    itemValueAttr: {
      type: String,
      default: 'value'
    },
    itemIconClass: {
      type: String,
      default: ''
    },
    isListOpen: {
      type: Boolean,
      required: true
    },
    useIcons: {
      type: Boolean
    },
    useIconsAndText: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: true
    },
    errorPlacement: {
      type: String,
      default: 'bottom'
    },
    container: {
      type: String
    },
    tooltipPlacement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.RIGHT
    },
    borderRadius: {
      type: Number
    }
  },
  data: function data() {
    return {
      errorMsg: '',
      bubbleErrorMsg: '',
      showError: false,
      tootipText: ''
    };
  },

  computed: {
    selectedItemValue: function selectedItemValue() {
      return this.selectedItem ? this.selectedItem[this.itemValueAttr] : '';
    },
    arrowDirectionClass: function arrowDirectionClass() {
      return this.isListOpen ? 'ico-arrow-up' : 'ico-arrow-down';
    },
    iconClass: function iconClass() {
      var iconClass = '';
      if (this.useIcons) {
        iconClass = this.selectedItemValue;
      } else if (this.useIconsAndText) {
        iconClass = this.itemIconClass;
      }
      return iconClass;
    },
    shouldShowPlaceholder: function shouldShowPlaceholder() {
      return !this.selectedItemValue && this.placeholder;
    },
    hasError: function hasError() {
      return this.errorMsg.length > 0;
    },
    selectedItemTooltip: function selectedItemTooltip() {
      return { content: this.tootipText, placement: this.tooltipPlacement, html: false, autoHide: false };
    },
    borderRadiusStyle: function borderRadiusStyle() {
      var style = {};
      if (this.borderRadius) {
        style['border-radius'] = this.borderRadius + 'px';
      }
      return style === {} ? '' : style;
    }
  },
  mounted: function mounted() {
    this.updateTooltipText();
  },
  updated: function updated() {
    this.updateTooltipText();
  },

  methods: {
    updateTooltipText: function updateTooltipText() {
      var hasEllipsis = this.$refs.label && this.$refs.label.scrollWidth > this.$refs.label.offsetWidth;
      this.tootipText = hasEllipsis ? this.selectedItemValue : '';
    },
    onDropdownClick: function onDropdownClick() {
      this.toggleDropdown(!this.isListOpen);
    },
    onDropdownBlur: function onDropdownBlur() {
      this.toggleDropdown(false);
    },
    onDropdownFocus: function onDropdownFocus() {
      if (this.enabled) {
        this.showError = false;
      }
    },
    toggleDropdown: function toggleDropdown(newState) {
      if (this.enabled) {
        this.showError = false;
        this.$emit('toggle', newState);
      }
    },
    setError: function setError(showError, errorMsg) {
      if (showError) {
        this.errorMsg = errorMsg;
        this.bubbleErrorMsg = this.errorMsg;
      } else {
        this.clearError();
      }
      this.toggleErrorBubble(this.hasError);
    },
    clearError: function clearError() {
      this.toggleErrorBubble(false);
      this.errorMsg = '';
    },
    toggleErrorBubble: function toggleErrorBubble(showBubble) {
      this.showError = showBubble;
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-select-menu',
  components: {},
  props: {
    isListOpen: {
      type: Boolean,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    menuIcon: {
      type: String,
      default: ''
    },
    menuIconTooltip: {
      type: String,
      default: ''
    }
  },
  methods: {
    onActionMenuClick: function onActionMenuClick() {
      this.toggleActionMenu(!this.isListOpen);
    },
    toggleActionMenu: function toggleActionMenu(newState) {
      if (this.enabled) {
        this.$emit('toggle', newState);
      }
    }
  },
  computed: {
    iconClass: function iconClass() {
      return this.menuIcon || 'ico-5 ico-three-dots';
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-slider',
  model: {
    prop: 'selectedRangeValue',
    event: 'change'
  },
  props: {
    selectedRangeValue: {
      type: Number,
      default: 1
    },
    selectedRangeLabel: {
      type: String,
      default: ''
    },
    minimumRangeValue: {
      type: Number,
      default: 1
    },
    minimumRangeLabel: {
      type: String,
      default: ''
    },
    maximumRangeValue: {
      type: Number,
      default: 100
    },
    maximumRangeLabel: {
      type: String,
      default: ''
    },
    filledTrackColor: {
      type: String,
      default: '#5879da'
    },
    trackColor: {
      type: String,
      default: '#d4d4d4'
    }
  },
  created: function created() {
    this.value = this.selectedRangeValue;
  },
  data: function data() {
    return {
      value: null
    };
  },

  watch: {
    selectedRangeValue: function selectedRangeValue() {
      this.value = this.selectedRangeValue;
    }
  },
  computed: {
    selectedPercents: function selectedPercents() {
      return Math.floor(this.getValue / this.maximumRangeValue * 100) + '%';
    },
    linearBackground: function linearBackground() {
      return '--linear-background: linear-gradient(to right, ' + this.filledTrackColor + ' ' + this.selectedPercents + ', ' + this.trackColor + ' 0)';
    },
    selectedOffset: function selectedOffset() {
      var chLength = this.getValue.toString().length;
      return 'left: calc(' + this.selectedPercents + ' - ' + chLength + 'ch)';
    },
    getValue: function getValue() {
      return this.value;
    }
  },
  methods: {
    doneChangingRange: function doneChangingRange() {
      this.$emit('change', this.getValue);
    },
    updateSelectedRange: function updateSelectedRange() {
      this.$emit('change', this.getValue);
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_button_le_button__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(22);







var references = new Set();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-dialog',
  components: {
    leButton: __WEBPACK_IMPORTED_MODULE_1__le_button_le_button__["a" /* default */]
  },
  props: {
    icon: {
      type: String
    },
    header: {
      type: String
    },
    description: {
      type: String
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    primaryButtonText: {
      type: String,
      default: 'Done'
    },
    secondaryButtonText: {
      type: String,
      default: ''
    },
    headerAriaLabelledbyId: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '320'
    },
    minWidth: {
      type: String,
      default: 'unset'
    },
    height: {
      type: String,
      default: 'auto'
    },
    minHeight: {
      type: String,
      default: 'unset'
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    useCancelEventOnClose: {
      type: Boolean,
      default: true
    },
    outerClass: {
      type: String,
      default: ''
    },
    primaryButtonIcon: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_DIALOG.VARIANTS.WARNING,
      validator: function validator(value) {
        return !value || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].LE_DIALOG.VARIANTS), value);
      }
    },
    theme: {
      type: String,
      default: 'theme-light'
    },
    isPrimaryButtonDisabled: {
      type: Boolean,
      default: false
    },
    buttonFocusBorder: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      headerId: 'le-dialog-header-' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* generateUUID */])()
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.dialogBox.focus();
    });
  },
  mounted: function mounted() {
    references.add(this);
    var level = references.size;
    var modalElements = new Set();
    Array.from(this.$el.querySelectorAll('*')).forEach(function (i) {
      return modalElements.add(i);
    });
    var base = 'body *:not([previousTabIndex]):not([tabindex="-1"]):not([previousTabIndexLevel])';
    var focusableElementsInPage = document.querySelectorAll([base + '[tabindex]', base + '[href]', base + '[contenteditable="true"]', base.replace('*', 'input'), base.replace('*', 'button')].join(', '));
    Array.from(focusableElementsInPage).filter(function (element) {
      return !modalElements.has(element);
    }).forEach(function (element) {
      element.setAttribute('previousTabIndex', element.getAttribute('tabindex'));
      element.setAttribute('tabindex', '-1');
      element.setAttribute('previousTabIndexLevel', level);
    });
  },
  beforeDestroy: function beforeDestroy() {
    references.delete(this);
    var level = references.size + 1;
    var elements = document.querySelectorAll('body *[previousTabIndex][previousTabIndexLevel="' + level + '"]');
    Array.from(elements).forEach(function (element) {
      var previousTabIndex = element.getAttribute('previousTabIndex');
      if (Number.isNaN(+previousTabIndex) || previousTabIndex === '') {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', +previousTabIndex);
      }
      element.removeAttribute('previousTabIndex');
      element.removeAttribute('previousTabIndexLevel');
    });
  },

  computed: {
    hasIcon: function hasIcon() {
      return !!this.icon;
    },
    getHeaderAriaLabelledbyId: function getHeaderAriaLabelledbyId() {
      return this.headerAriaLabelledbyId ? this.headerId + ' ' + this.headerAriaLabelledbyId : this.headerId;
    }
  },
  methods: {
    onPrimaryButtonClick: function onPrimaryButtonClick() {
      var _this2 = this;

      this.$emit('primaryButtonClick');
      this.$nextTick(function () {
        if (_this2.$refs && _this2.$refs.dialogBox) {
          _this2.$refs.dialogBox.focus();
        }
      });
    },
    preventDefaultEvent: function preventDefaultEvent(event) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'preventDefault'))) {
        event.preventDefault();
      }
    },
    onCancelButtonTabKeyPressed: function onCancelButtonTabKeyPressed(event) {
      if (this.isPrimaryButtonDisabled && !event.shiftKey) {
        this.preventDefaultEvent(event);
        if (this.$refs && this.$refs.closeButton) {
          this.$refs.closeButton.focus();
        }
      }
    },
    onPrimaryButtonTabKeyPressed: function onPrimaryButtonTabKeyPressed(event) {
      if (!event.shiftKey) {
        this.preventDefaultEvent(event);
        if (this.$refs && this.$refs.closeButton) {
          this.$refs.closeButton.focus();
        }
      }
    },
    onCloseButtonTabKeyPressed: function onCloseButtonTabKeyPressed(event) {
      if (event.shiftKey) {
        this.preventDefaultEvent(event);
        if (this.isPrimaryButtonDisabled) {
          if (this.$refs && this.$refs.cancelButton) {
            var cancelButton = this.$refs.cancelButton.$el.firstChild;
            cancelButton.focus();
          }
        } else if (this.$refs && this.$refs.primaryButton) {
          var primaryButton = this.$refs.primaryButton.$el.firstChild;
          primaryButton.focus();
        }
      }
    },
    onCancelClick: function onCancelClick() {
      this.$emit('cancelClick');
    },
    onCloseClick: function onCloseClick() {
      if (this.useCancelEventOnClose) {
        this.onCancelClick();
      } else {
        this.$emit('closeClick');
      }
    },
    onSecondaryButtonClick: function onSecondaryButtonClick() {
      this.$emit('secondaryButtonClick');
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LE_QUILL_EDITOR_ELEMENT_CLASS_NAME */
/* unused harmony export LE_QUILL_CURSOR_ELEMENT_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_lp_html_sanitizer_src_HtmlSanitizerUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_lp_html_sanitizer_src_HtmlSanitizerUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_lp_html_sanitizer_src_HtmlSanitizerUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExtendedClipboard__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__le_link_editor_le_quill_link__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__le_link_editor_le_link_listeners__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_markdownUtil__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__le_quill_autocomplete_le_quill_autocomplete_module__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__le_quill_autocomplete_le_quill_autocomplete__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__le_quill_autocomplete_Models_LeQuillAutocompleteSettingsModel__ = __webpack_require__(292);
var _CONSTS$LE_EDITOR$SUP3, _CONSTS$LE_EDITOR$SUP4, _CONSTS$LE_EDITOR$SUP6, _CONSTS$LE_EDITOR$SUP7, _QUILL_FORMATS_TO_HTM;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register('modules/clipboard', __WEBPACK_IMPORTED_MODULE_5__ExtendedClipboard__["a" /* default */], true);
__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register('formats/leQuillLink', __WEBPACK_IMPORTED_MODULE_6__le_link_editor_le_quill_link__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register('formats/leQuillAutocomplete', __WEBPACK_IMPORTED_MODULE_10__le_quill_autocomplete_le_quill_autocomplete__["c" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register('modules/leLinkListeners', __WEBPACK_IMPORTED_MODULE_7__le_link_editor_le_link_listeners__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register('modules/leQuillAutocomplete', __WEBPACK_IMPORTED_MODULE_9__le_quill_autocomplete_le_quill_autocomplete_module__["a" /* default */]);

var QUILL_FORMATS_TO_HTML_ELEMENTS = (_QUILL_FORMATS_TO_HTM = {}, _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_AUTOCOMPLETE, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.SPAN, [__WEBPACK_IMPORTED_MODULE_10__le_quill_autocomplete_le_quill_autocomplete__["a" /* LE_QUILL_AUTOCOMPLETE_ATTRIBUTES */].INITIAL_VALUE, __WEBPACK_IMPORTED_MODULE_10__le_quill_autocomplete_le_quill_autocomplete__["a" /* LE_QUILL_AUTOCOMPLETE_ATTRIBUTES */].ID])), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.A, ['href'])), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.ITALIC, (_CONSTS$LE_EDITOR$SUP3 = {}, _defineProperty(_CONSTS$LE_EDITOR$SUP3, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.I, []), _defineProperty(_CONSTS$LE_EDITOR$SUP3, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.EM, []), _CONSTS$LE_EDITOR$SUP3)), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.BOLD, (_CONSTS$LE_EDITOR$SUP4 = {}, _defineProperty(_CONSTS$LE_EDITOR$SUP4, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.STRONG, []), _defineProperty(_CONSTS$LE_EDITOR$SUP4, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.BOLD, []), _CONSTS$LE_EDITOR$SUP4)), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.UNDERLINE, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.U, [])), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.BULLET, (_CONSTS$LE_EDITOR$SUP6 = {}, _defineProperty(_CONSTS$LE_EDITOR$SUP6, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.UL, []), _defineProperty(_CONSTS$LE_EDITOR$SUP6, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.LI, []), _CONSTS$LE_EDITOR$SUP6)), _defineProperty(_QUILL_FORMATS_TO_HTM, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LIST, (_CONSTS$LE_EDITOR$SUP7 = {}, _defineProperty(_CONSTS$LE_EDITOR$SUP7, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.OL, []), _defineProperty(_CONSTS$LE_EDITOR$SUP7, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_HTML_ELEMENTS.LI, []), _CONSTS$LE_EDITOR$SUP7)), _QUILL_FORMATS_TO_HTM);

var SPLITTER_RESIZE_DIRECTION = {
  UP: 'UP',
  DOWN: 'DOWN'
};

var _UP$DOWN = { UP: 'resize-up', DOWN: 'resize-down' },
    UP = _UP$DOWN.UP,
    DOWN = _UP$DOWN.DOWN;

var SPLITTER_RESIZE_CLASSES = { UP: UP, DOWN: DOWN };

var EDITOR_VERTICAL_PADDING = 13;

var LE_QUILL_EDITOR_ELEMENT_CLASS_NAME = 'ql-editor';
var LE_QUILL_CURSOR_ELEMENT_CLASS_NAME = 'ql-cursor';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-text-editor',
  data: function data() {
    return {
      resizing: false,
      x: 0,
      y: 0,
      initialEditorHeight: 0,
      isDragging: false,
      quill: undefined,
      twitterText: null
    };
  },

  props: {
    hasSendButton: {
      type: Boolean,
      default: true
    },
    splitterSupported: {
      type: Boolean,
      default: false
    },
    initialMessage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    allowHtml: {
      type: Boolean,
      default: false
    },
    sanitizeOnPaste: {
      type: Boolean,
      default: false
    },
    formats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    enabled: {
      type: Boolean,
      default: true
    },
    minRows: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.MIN_ROWS
    },
    maxRows: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.MAX_ROWS
    },
    direction: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.AUTO
    },
    lineHeight: {
      type: Number,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.LINE_HEIGHT
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    allowDragAndDrop: {
      type: Boolean,
      default: false
    },
    allowHyperlinks: {
      type: Boolean,
      default: false
    },
    isAutocompleteEnabled: {
      type: Boolean,
      default: false
    },
    autocompleteSettings: {
      type: __WEBPACK_IMPORTED_MODULE_11__le_quill_autocomplete_Models_LeQuillAutocompleteSettingsModel__["a" /* default */],
      required: false
    },
    ariaLabel: {
      type: String,
      default: 'Enter your text message here'
    },
    twitterValidation: {
      type: Boolean,
      default: false
    },
    submitKey: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUBMIT_KEY.ENTER,
      validator: function validator(key) {
        return !!__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUBMIT_KEY[key];
      }
    },
    isRecording: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.initializeEditor();
    this.initializeClipboardMatcher();

    if (!window.document.documentMode) {
      this.twitterText = __webpack_require__(556).default;
    }
  },

  computed: {
    id: function id() {
      return new Date().valueOf();
    },
    minHeight: function minHeight() {
      return this.minRows * this.lineHeight + EDITOR_VERTICAL_PADDING;
    },
    maxHeight: function maxHeight() {
      return Math.max(this.minHeight, this.maxRows * this.lineHeight);
    },
    sanitizedTags: function sanitizedTags() {
      var tags = { div: [], br: [], p: [] };
      Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(this.formats, function (format) {
        if (QUILL_FORMATS_TO_HTML_ELEMENTS[format]) {
          Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["assign"])(tags, QUILL_FORMATS_TO_HTML_ELEMENTS[format]);
        }
      });
      return tags;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
    delete this.quill;
  },

  watch: {
    enabled: {
      handler: function handler(isEnabled) {
        var _this = this;

        if (this.quill) {
          this.quill.enable(isEnabled);
        } else {
          this.$nextTick(function () {
            return _this.quill.enable(isEnabled);
          });
        }
      },

      immediate: true
    },
    direction: function direction(dir) {
      this.setDirection(dir);
    },
    placeholder: function placeholder() {
      this.initializeEditor();
    },

    formats: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.initializeEditor();
        }
      }
    },
    twitterValidation: function twitterValidation() {
      var text = this.quill.getText();
      if (text.trim()) {
        this.setMessage(text);
        this.fireTextChange();
      }
    }
  },
  methods: {
    initializeEditor: function initializeEditor() {
      if (this.isAutocompleteEnabled && !this.autocompleteSettings) {
        console.error('[LeQuillAutocomplete]: You should provide settings to enable autocomplete. Did you forget them?');
      }
      var editorOptions = {
        modules: {
          toolbar: '#le-text-editor-toolbar' + this.id,
          keyboard: {
            bindings: this.getKeyBindings()
          },
          leLinkListeners: this.allowHyperlinks,
          leQuillAutocomplete: this.isAutocompleteEnabled ? this.autocompleteSettings : false
        },
        placeholder: this.placeholder
      };
      if (!this.allowHtml) {
        editorOptions.formats = [];
      } else {
        editorOptions.formats = [].concat(_toConsumableArray(this.formats)) || [];
      }

      editorOptions.formats.push(__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.DIRECTION, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.ALIGN);
      var Parchment = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import('parchment');
      var Block = Parchment.query('block');
      Block.tagName = 'DIV';
      __WEBPACK_IMPORTED_MODULE_0_quill___default.a.register(Block, true);

      editorOptions.scrollingContainer = this.$refs.editorContainer;

      this.quill = new __WEBPACK_IMPORTED_MODULE_0_quill___default.a(this.$refs.editor, editorOptions);

      var qlEditorElement = this.getQlEditorElement();
      if (qlEditorElement) {
        qlEditorElement.setAttribute('role', 'textbox');
        qlEditorElement.setAttribute('aria-label', this.ariaLabel);
      }

      if (this.initialMessage) {
        if (this.allowHtml) {
          this.html(this.initialMessage);
        } else {
          this.setMessage(this.initialMessage);
        }
      }

      this.previousDirection = this.direction;
      this.ctrlKeyIsPressed = false;

      this.bindEvents();

      var TAB_KEY_CODE = '9';
      delete this.quill.keyboard.bindings[TAB_KEY_CODE];

      this.$emit('onReady');
    },
    getKeyBindings: function getKeyBindings() {
      var _this2 = this;

      var self = this;

      var bindings = {
        enter: {
          key: 'enter',
          handler: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["bind"])(function () {
            _this2.$emit('enterKeyPressed');
            if (_this2.submitKey === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUBMIT_KEY.ENTER) {
              _this2.$emit('submitted');
              return false;
            }
            return true;
          }, this)
        },
        customCtrlEnter: {
          key: 'enter',
          shortKey: true,
          handler: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["bind"])(function () {
            _this2.$emit('ctrlEnterKeyPressed');
            if (_this2.submitKey === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUBMIT_KEY.CTRL_ENTER) {
              _this2.$emit('submitted');
              return false;
            }
            return true;
          }, this)
        }
      };

      if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"])(this.$listeners.arrowUpKeyPressed)) {
        bindings.arrowUp = {
          key: 'up',
          handler: function handler() {
            var shouldMakeDefaultAction = true;
            var preventDefault = function preventDefault() {
              shouldMakeDefaultAction = false;
            };

            self.$emit('arrowUpKeyPressed', { preventDefault: preventDefault });
            return shouldMakeDefaultAction;
          }
        };
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"])(this.$listeners.arrowDownKeyPressed)) {
        bindings.arrowDown = {
          key: 'down',
          handler: function handler() {
            var shouldMakeDefaultAction = true;
            var preventDefault = function preventDefault() {
              shouldMakeDefaultAction = false;
            };

            self.$emit('arrowDownKeyPressed', { preventDefault: preventDefault });
            return shouldMakeDefaultAction;
          }
        };
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"])(this.$listeners.arrowRightKeyPressed)) {
        bindings.arrowRight = {
          key: 'right',
          handler: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["bind"])(function () {
            _this2.$emit('arrowRightKeyPressed');
            return true;
          }, this)
        };
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isUndefined"])(this.$listeners.escapeKeyPressed)) {
        bindings.escape = {
          key: 'escape',
          handler: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["bind"])(function () {
            _this2.$emit('escapeKeyPressed');
            return true;
          }, this)
        };
      }

      return bindings;
    },
    bindEvents: function bindEvents() {
      var _this3 = this;

      this.quill.on('selection-change', function (range) {
        if (!range) {
          _this3.$emit('blur');
        } else {
          _this3.$emit('focus');
          var selectionStart = range.index;
          var selectionEnd = selectionStart + range.length;
          var selection = window.getSelection();
          var selectedText = selection.toString();
          if (selectedText.trim().length > 1) {
            _this3.$emit('onTextSelection', selectedText, _this3.quill, selectionStart, selectionEnd);
          }
        }
      });

      this.quill.on('text-change', function (delta, oldDelta, source) {
        _this3.$emit('onInputChange', _this3.quill.getText());
        if (source === 'user' && _this3.direction === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.AUTO) {
          _this3.setDirection();
          _this3.quill.scrollIntoView();
        }
        _this3.fireTextChange();
      });
    },
    fireTextChange: function fireTextChange() {
      var text = this.quill.getText();
      var isValidFlag = true;
      if (this.twitterValidation && this.twitterText) {
        var twitterValidationResult = this.twitterText.parseTweet(text);
        isValidFlag = twitterValidationResult.valid;
        if (!twitterValidationResult.valid) {
          this.quill.formatText(twitterValidationResult.validRangeEnd, twitterValidationResult.displayRangeEnd, 'bold', true);
          this.$refs.editor.classList.add('ql-twitter-highlight');
        }
      }
      this.$emit('change', text, isValidFlag);
    },
    getEditorHtml: function getEditorHtml() {
      var $editor = this.$refs.editor.children;
      var html = '';
      if ($editor.length > 0) {
        html = $editor[0].innerHTML === '<div><br></div>' ? '' : this.quill.getText(0);
      }

      return html;
    },
    initializeClipboardMatcher: function initializeClipboardMatcher() {
      var _this4 = this;

      this.quill.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
        if (!_this4.allowHtml || _this4.sanitizeOnPaste) {
          delta.ops = delta.ops.map(function (op) {
            var sanitizedText = op.insert;
            if (!_this4.allowHtml) {} else {
              sanitizedText = __WEBPACK_IMPORTED_MODULE_2__node_modules_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeHtml(sanitizedText).cleanText;
            }
            return {
              insert: sanitizedText
            };
          });
        }
        return delta;
      });
    },
    setDirection: function setDirection(dir) {
      dir = dir || this.direction;
      if (dir === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.AUTO) {
        dir = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].detectTextDirection(this.quill.getText(0, 1), __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.LTR);
      }

      if (dir !== this.previousDirection) {

        var align = this.quill.getFormat().align;
        if (dir === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.RTL && align !== __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_ALIGN.RIGHT) {
          this.quill.format(__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.ALIGN, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_ALIGN.RIGHT);
        } else if (align !== __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_ALIGN.LEFT) {
          this.quill.format(__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.ALIGN, false);
        }

        if (dir === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.RTL) {
          this.quill.format(__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.DIRECTION, __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.RTL);
        } else {
          this.quill.format(__WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.DIRECTION, false);
        }

        this.previousDirection = dir;
      }
    },
    swapDirection: function swapDirection() {
      var dir = this.previousDirection === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.LTR || this.previousDirection === __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.AUTO ? __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.RTL : __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.WRITE_DIRECTION.LTR;
      this.setDirection(dir);
    },
    getCursorIndex: function getCursorIndex() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var cursorIndex = 0;
      var selection = this.quill.getSelection(focus);
      if (selection) {
        cursorIndex = selection.length ? selection.index : selection.index + selection.length;
      }
      return cursorIndex;
    },
    getDisplayedRowsByEditorHeight: function getDisplayedRowsByEditorHeight(editorH) {
      if (editorH === this.minHeight) {
        return this.minRows;
      } else if (editorH === this.maxHeight) {
        return this.maxRows;
      }
      var deltaH = editorH - this.minHeight;
      return this.minRows + Math.floor(deltaH / this.lineHeight);
    },
    onSplitterMouseDown: function onSplitterMouseDown(event) {
      document.addEventListener('mousemove', this.onSplitterMouseMove);
      document.addEventListener('mouseup', this.stopResize, { once: true });
      this.resizing = true;
      this.initH = this.$refs.editor.clientHeight;
      this.initY = event.clientY;
      this.stepY = this.initY;
      this.deltaH = 0;

      this.initDisplayedRows = this.getDisplayedRowsByEditorHeight(this.initH);
      this.$emit('resizeStart', { displayedRows: this.initDisplayedRows });
    },
    onSplitterMouseMove: function onSplitterMouseMove(event) {
      if (this.resizing) {
        var deltaY = event.clientY - this.stepY;

        var direction = deltaY >= 0 ? 1 : -1;

        var deltaRows = Math.floor(Math.abs(event.clientY - this.initY) / this.lineHeight);

        if (Math.abs(deltaY) > this.lineHeight) {
          this.displayedRows = this.initDisplayedRows - direction * deltaRows;

          if (this.displayedRows >= this.minRows && this.displayedRows <= this.maxRows) {
            this.deltaH = direction * deltaRows * this.lineHeight;

            var editorH = this.initH - this.deltaH;
            this.stepY = event.clientY;

            this.$refs.editor.style.height = editorH + 'px';

            this.$emit('resize', { displayedRows: this.displayedRows, y: this.deltaH });
          }
        }
      }
    },
    stopResize: function stopResize() {
      if (this.resizing) {
        document.removeEventListener('mousemove', this.onSplitterMouseMove);
        this.setFocus();
        this.resizing = false;
        this.applyResizeClass();
        this.$emit('resizeEnd', { displayedRows: this.displayedRows, y: this.deltaH });
      }
    },
    applyResizeClass: function applyResizeClass() {
      var resizerClass = void 0;
      if (this.displayedRows >= this.maxRows) {
        resizerClass = SPLITTER_RESIZE_CLASSES.DOWN;
      } else {
        resizerClass = SPLITTER_RESIZE_CLASSES.UP;
      }

      this.$refs.splitter.classList.remove(SPLITTER_RESIZE_CLASSES.DOWN);
      this.$refs.splitter.classList.remove(SPLITTER_RESIZE_CLASSES.UP);
      if (resizerClass) {
        this.$refs.splitter.classList.add(resizerClass);
      }
    },

    debounceKeyPress: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (event) {
      this.$emit('keyPressed', event);
    }, 150),

    debounceKeyUp: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (event) {
      this.$emit('keyUp', event);
    }, 150),

    debounceKeyDown: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (event) {
      this.$emit('keyDown', event);
    }, 150),

    onKeyDown: function onKeyDown(event) {
      if (this.ctrlKeyIsPressed && event.shiftKey) {
        this.swapDirection();
      }
      this.ctrlKeyIsPressed = event.ctrlKey;
      this.debounceKeyDown(event);
    },
    onKeyUp: function onKeyUp(event) {
      this.ctrlKeyIsPressed = event.ctrlKey;
      this.debounceKeyUp(event);
    },
    clear: function clear() {
      this.quill.setContents([{ insert: '' }]);
      this.previousDirection = this.direction;
    },
    setMessage: function setMessage(msg) {
      this.clear();
      this.html(msg);
      this.quill.setSelection(msg.length);
    },
    write: function write(text) {
      this.html(text);
    },
    html: function html(code) {
      this.setFocus();
      var index = this.getCursorIndex();
      if (this.allowHtml) {
        var cleanText = __WEBPACK_IMPORTED_MODULE_2__node_modules_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeAndCleanHtml(code, this.sanitizedTags);
        this.quill.pasteHTML(index, cleanText);
      } else {
        this.quill.insertText(index, code);
      }
    },
    getHtml: function getHtml() {
      return this.getEditorHtml();
    },
    setFocus: function setFocus() {
      if (this.isRecording) return;
      var isUnderDialog = this.$el.querySelector('*[previousTabIndex],[previousTabIndexLevel]');
      if (!isUnderDialog && !this.quill.hasFocus()) {
        this.quill.focus();
      }
    },
    blur: function blur() {
      this.quill.blur();
    },
    scrollTop: function scrollTop() {
      this.$refs.editor.scrollTop = 0;
    },
    scrollBottom: function scrollBottom() {
      this.$refs.editor.scrollTop = this.$refs.editor.scrollHeight;
    },
    onPaste: function onPaste(event) {
      this.$emit('paste', event);
    },
    onDragEnter: function onDragEnter() {
      if (this.allowDragAndDrop) {
        this.isDragging = true;
      }
    },
    onDragExit: function onDragExit() {
      this.isDragging = false;
    },
    onDrop: function onDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      this.$emit('drop', event);
    },
    onDragOver: function onDragOver(event) {
      event.preventDefault();
    },
    getMarkdown: function getMarkdown() {
      var qlEditorElement = this.getQlEditorElement();

      if (this.isAutocompleteEnabled && qlEditorElement) {
        qlEditorElement = qlEditorElement.cloneNode(true);
        Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["each"])(qlEditorElement.querySelectorAll('.' + LE_QUILL_CURSOR_ELEMENT_CLASS_NAME + ', .' + __WEBPACK_IMPORTED_MODULE_10__le_quill_autocomplete_le_quill_autocomplete__["b" /* LE_QUILL_AUTOCOMPLETE_CLASS_NAME */]), function (node) {
          node.remove();
        });
      }

      var html = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(qlEditorElement, 'innerHTML', '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');

      return Object(__WEBPACK_IMPORTED_MODULE_8__utils_markdownUtil__["a" /* htmlToMarkdown */])(html);
    },
    getQlEditorElement: function getQlEditorElement() {
      var container = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.quill, 'container');

      return container ? container.querySelector('.' + LE_QUILL_EDITOR_ELEMENT_CLASS_NAME) : null;
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlToMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return markdownToHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return markdownToPlainText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts_consts__ = __webpack_require__(6);




var HTML_TAGS_REGEXP = new RegExp(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].HTML_TAGS_REGEXP, 'gim');
var HTML_END_DIV_REGEXP = new RegExp(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].HTML_END_DIV_REGEXP, 'gim');

var FORMATTERS = {
  link: {
    htmlToMarkdown: {
      regexp: new RegExp('<a .*?href=(["\'])(' + __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].URL_REGEXP + ')\\1.*?>(.*?)<\\/a>', 'gim'),

      replacement: __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.PREFIX + '[$3]($2)' + __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.SUFFIX
    },
    markdownToHtml: {
      regexp: [new RegExp(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.PREFIX + '\\[((?!https?://|ftp://).*?)]\\((.*?)\\)' + __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.SUFFIX, 'gim'), new RegExp(__WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.PREFIX + '\\[(.*?)]\\((.*?)\\)' + __WEBPACK_IMPORTED_MODULE_2__consts_consts__["a" /* default */].MARKDOWN.SUFFIX, 'gim')],

      replacement: ['<a class="le-markdown-link" rel="noopener noreferrer" target="_blank" aria-describedby="opens-in-a-new-window" href="$2">$1</a>', '<a class="le-markdown-link" rel="noopener noreferrer" target="_blank" aria-describedby="opens-in-a-new-window" href="$1">$2</a>']
    },
    markdownToPlainText: {
      replacement: ['[$1](Link:$2)', '[$2](Link:$1)']
    }
  },
  lineBreaks: {
    htmlToMarkdown: {
      regexp: new RegExp('(<\\s*div\\s*>)?(<\\s*br\\s*>|<\\s*\\/\\s*br\\s*>|<\\s*br\\s*\\/\\s*>)(<\\/\\s*div\\s*>)?', 'gim'),

      replacement: '\n'
    },
    markdownToHtml: {
      regexp: new RegExp(/\n/, 'gim'),
      replacement: '<br >'
    }
  }
};

var stripHtmlTags = function stripHtmlTags(html) {
  var sanitized = __WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeHtml(html).cleanText;
  return (sanitized || '').replace(HTML_END_DIV_REGEXP, '\n').replace(HTML_TAGS_REGEXP, '');
};

var htmlToMarkdown = function htmlToMarkdown(html) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { stripTags: true },
      stripTags = _ref.stripTags;

  var result = '';
  var errors = [];
  if (html && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"])(html)) {
    var sanitizedObject = __WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeHtml(html);
    result = sanitizedObject.cleanText;
    errors = sanitizedObject.errors;
    var formatters = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(FORMATTERS);
    Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(formatters, function (formatter) {
      if (formatter.htmlToMarkdown) {
        var toMarkdown = formatter.htmlToMarkdown;
        result = result.replace(toMarkdown.regexp, toMarkdown.replacement);
      }
    });
  }

  if (stripTags) {
    result = stripHtmlTags(result);
  }

  return {
    text: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(result) ? '' : result,
    errors: errors
  };
};

var markdownToHtml = function markdownToHtml(markdown) {
  var result = '';
  if (markdown && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"])(markdown)) {
    result = markdown;
    var formatters = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(FORMATTERS);
    Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(formatters, function (formatter) {
      if (formatter.markdownToHtml) {
        var toHtml = formatter.markdownToHtml;
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(toHtml.regexp)) {
          Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(toHtml.regexp, function (regexp, i) {
            result = result.replace(toHtml.regexp[i], toHtml.replacement[i]);
          });
        } else {
          result = result.replace(toHtml.regexp, toHtml.replacement);
        }
      }
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(result) ? '' : __WEBPACK_IMPORTED_MODULE_1_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeHtml(result).cleanText;
};

var markdownToPlainText = function markdownToPlainText(markdown) {
  var result = '';
  if (markdown && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"])(markdown)) {
    result = markdown;
    var formatters = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(FORMATTERS);
    Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(formatters, function (formatter) {
      if (formatter.markdownToHtml && formatter.markdownToPlainText) {
        var toHtml = formatter.markdownToHtml;
        var toPlainText = formatter.markdownToPlainText;

        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(toHtml.regexp)) {
          Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(toHtml.regexp, function (regexp, i) {
            result = result.replace(toHtml.regexp[i], toPlainText.replacement[i]);
          });
        } else {
          result = result.replace(toHtml.regexp, toPlainText.replacement);
        }
      }
    });
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(result) ? '' : result;
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIGGER_OPTIONS; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TRIGGER_OPTIONS = {
  SPACE: 'space',
  TAB: 'tab',
  VOWELS: 'vowels',
  DISPLAYED: 'displayed'
};

var LeQuillAutocompleteTriggerOptionsModel = function LeQuillAutocompleteTriggerOptionsModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { space: false, tab: false, vowels: false },
      space = _ref.space,
      tab = _ref.tab,
      vowels = _ref.vowels;

  _classCallCheck(this, LeQuillAutocompleteTriggerOptionsModel);

  this.space = space;
  this.tab = tab;
  this.vowels = vowels;

  if (!this.space && !this.tab && !this.vowels) {
    console.error('[LeQuillAutocomplete]: Expected at least one trigger option');
  }
};

/* harmony default export */ __webpack_exports__["b"] = (LeQuillAutocompleteTriggerOptionsModel);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SELECT_KEYS; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SELECT_KEYS = {
  ARROW_RIGHT: 'arrowRight',
  TAB: 'tab'
};

var LeQuillAutocompleteSelectKeysModel = function LeQuillAutocompleteSelectKeysModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tab: false, arrowRight: false },
      tab = _ref.tab,
      arrowRight = _ref.arrowRight;

  _classCallCheck(this, LeQuillAutocompleteSelectKeysModel);

  this.tab = tab;
  this.arrowRight = arrowRight;

  if (!this.arrowRight && !this.tab) {
    console.error('[LeQuillAutocomplete]: You should provide at least one select option for autocomplete.');
  }
};

/* harmony default export */ __webpack_exports__["b"] = (LeQuillAutocompleteSelectKeysModel);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LE_QUILL_AUTOCOMPLETE_CLASS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LE_QUILL_AUTOCOMPLETE_ATTRIBUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_quill_autocomplete_scss__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_quill_autocomplete_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__le_quill_autocomplete_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Embed = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import('blots/embed');

var LE_QUILL_AUTOCOMPLETE_CLASS_NAME = 'le-quill-autocomplete';
var LE_QUILL_AUTOCOMPLETE_ATTRIBUTES = {
  INITIAL_VALUE: 'data-autocomplete-initial-value',
  ID: 'data-autocomplete-id'
};

var LeQuillAutocomplete = function (_Embed) {
  _inherits(LeQuillAutocomplete, _Embed);

  function LeQuillAutocomplete() {
    _classCallCheck(this, LeQuillAutocomplete);

    return _possibleConstructorReturn(this, (LeQuillAutocomplete.__proto__ || Object.getPrototypeOf(LeQuillAutocomplete)).apply(this, arguments));
  }

  _createClass(LeQuillAutocomplete, [{
    key: 'updateText',
    value: function updateText(newText) {
      this.contentNode.textContent = newText;
      if (!newText || newText.length === 0) {
        this.remove();
      }
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.contentNode, 1];
    }
  }, {
    key: 'length',
    value: function length() {
      return 1;
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(LeQuillAutocomplete.__proto__ || Object.getPrototypeOf(LeQuillAutocomplete), 'create', this).call(this, value);
      node.setAttribute(LE_QUILL_AUTOCOMPLETE_ATTRIBUTES.INITIAL_VALUE, value.text);
      if (value.id) {
        node.setAttribute(LE_QUILL_AUTOCOMPLETE_ATTRIBUTES.ID, value.id);
      }
      node.textContent = value.text;
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return {
        text: domNode.getAttribute(LE_QUILL_AUTOCOMPLETE_ATTRIBUTES.INITIAL_VALUE),
        id: domNode.getAttribute(LE_QUILL_AUTOCOMPLETE_ATTRIBUTES.ID)
      };
    }
  }]);

  return LeQuillAutocomplete;
}(Embed);

/* harmony default export */ __webpack_exports__["c"] = (LeQuillAutocomplete);


LeQuillAutocomplete.blotName = __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_AUTOCOMPLETE;
LeQuillAutocomplete.tagName = 'span';
LeQuillAutocomplete.className = LE_QUILL_AUTOCOMPLETE_CLASS_NAME;

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DEFAULT_MAX_CACHE_SIZE = 5;

var LeQuillAutocompleteSettingsModel = function LeQuillAutocompleteSettingsModel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fetchAutocompleteAsync: undefined, isDefaultApi: undefined, sendFeedbackDefaultApiAsync: undefined, triggerOptions: {}, selectKeys: {}, maxCacheSize: undefined, smartComposeSelectedKeyFeedback: false },
      fetchAutocompleteAsync = _ref.fetchAutocompleteAsync,
      isDefaultApi = _ref.isDefaultApi,
      sendFeedbackDefaultApiAsync = _ref.sendFeedbackDefaultApiAsync,
      triggerOptions = _ref.triggerOptions,
      selectKeys = _ref.selectKeys,
      maxCacheSize = _ref.maxCacheSize,
      smartComposeSelectedKeyFeedback = _ref.smartComposeSelectedKeyFeedback;

  _classCallCheck(this, LeQuillAutocompleteSettingsModel);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(fetchAutocompleteAsync)) {
    console.error('[LeQuillAutocomplete]: You should provide fetch autocomplete function.');
    return;
  }

  this.fetchAutocompleteAsync = fetchAutocompleteAsync;
  this.isDefaultApi = isDefaultApi;
  this.sendFeedbackDefaultApiAsync = sendFeedbackDefaultApiAsync;
  this.triggerOptions = triggerOptions;
  this.selectKeys = selectKeys;
  this.maxCacheSize = maxCacheSize || DEFAULT_MAX_CACHE_SIZE;
  this.smartComposeSelectedKeyFeedback = smartComposeSelectedKeyFeedback;
};

/* harmony default export */ __webpack_exports__["a"] = (LeQuillAutocompleteSettingsModel);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractCashtagsWithIndices__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractHashtagsWithIndices__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extractMentionsOrListsWithIndices__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extractUrlsWithIndices__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__removeOverlappingEntities__ = __webpack_require__(98);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_3__extractUrlsWithIndices__["a" /* default */])(text, options).concat(Object(__WEBPACK_IMPORTED_MODULE_2__extractMentionsOrListsWithIndices__["a" /* default */])(text)).concat(Object(__WEBPACK_IMPORTED_MODULE_1__extractHashtagsWithIndices__["a" /* default */])(text, {
    checkUrlOverlap: false
  })).concat(Object(__WEBPACK_IMPORTED_MODULE_0__extractCashtagsWithIndices__["a" /* default */])(text));

  if (entities.length == 0) {
    return [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__removeOverlappingEntities__["a" /* default */])(entities);
  return entities;
});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(50);
var defined = __webpack_require__(49);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(11) && !__webpack_require__(13)(function () {
  return Object.defineProperty(__webpack_require__(296)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(25);
var toLength = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(560);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cashtag__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__punct__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spaces__ = __webpack_require__(85);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




var validCashtag = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])('(^|#{spaces})(\\$)(#{cashtag})(?=$|\\s|[#{punct}])', {
  cashtag: __WEBPACK_IMPORTED_MODULE_0__cashtag__["a" /* default */],
  spaces: __WEBPACK_IMPORTED_MODULE_3__spaces__["a" /* default */],
  punct: __WEBPACK_IMPORTED_MODULE_1__punct__["a" /* default */]
}, 'gi');
/* harmony default export */ __webpack_exports__["a"] = (validCashtag);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var cashtag = /[a-z]{1,6}(?:[._][a-z]{1,2})?/i;
/* harmony default export */ __webpack_exports__["a"] = (cashtag);

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(25);
var arrayIndexOf = __webpack_require__(297)(false);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(17);
var cof = __webpack_require__(51);
var MATCH = __webpack_require__(7)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashSigns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var endHashtagMatch = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/^(?:#{hashSigns}|:\/\/)/, {
  hashSigns: __WEBPACK_IMPORTED_MODULE_0__hashSigns__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (endHashtagMatch);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validDomain__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validPortNumber__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validUrlPath__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validUrlPrecedingChars__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validUrlQueryChars__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validUrlQueryEndingChars__ = __webpack_require__(96);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0







var extractUrl = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(' + // $1 total match
'(#{validUrlPrecedingChars})' + // $2 Preceeding chracter
'(' + // $3 URL
'(https?:\\/\\/)?' + // $4 Protocol (optional)
'(#{validDomain})' + // $5 Domain(s)
'(?::(#{validPortNumber}))?' + // $6 Port number (optional)
'(\\/#{validUrlPath}*)?' + // $7 URL Path
'(\\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?' + // $8 Query String
')' + ')', {
  validUrlPrecedingChars: __WEBPACK_IMPORTED_MODULE_4__validUrlPrecedingChars__["a" /* default */],
  validDomain: __WEBPACK_IMPORTED_MODULE_1__validDomain__["a" /* default */],
  validPortNumber: __WEBPACK_IMPORTED_MODULE_2__validPortNumber__["a" /* default */],
  validUrlPath: __WEBPACK_IMPORTED_MODULE_3__validUrlPath__["a" /* default */],
  validUrlQueryChars: __WEBPACK_IMPORTED_MODULE_5__validUrlQueryChars__["a" /* default */],
  validUrlQueryEndingChars: __WEBPACK_IMPORTED_MODULE_6__validUrlQueryEndingChars__["a" /* default */]
}, 'gi');
/* harmony default export */ __webpack_exports__["a"] = (extractUrl);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validCCTLD__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validDomainName__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validGTLD__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validPunycode__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validSubdomain__ = __webpack_require__(308);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0






var validDomain = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:#{validSubdomain}*#{validDomainName}(?:#{validGTLD}|#{validCCTLD}|#{validPunycode}))/, {
  validDomainName: __WEBPACK_IMPORTED_MODULE_2__validDomainName__["a" /* default */],
  validSubdomain: __WEBPACK_IMPORTED_MODULE_5__validSubdomain__["a" /* default */],
  validGTLD: __WEBPACK_IMPORTED_MODULE_3__validGTLD__["a" /* default */],
  validCCTLD: __WEBPACK_IMPORTED_MODULE_1__validCCTLD__["a" /* default */],
  validPunycode: __WEBPACK_IMPORTED_MODULE_4__validPunycode__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validDomain);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validDomainChars__ = __webpack_require__(88);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validDomainName = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:(?:#{validDomainChars}(?:-|#{validDomainChars})*)?#{validDomainChars}\.)/, {
  validDomainChars: __WEBPACK_IMPORTED_MODULE_1__validDomainChars__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validDomainName);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directionalMarkersGroup__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invalidCharsGroup__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__punct__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spacesGroup__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_stringSupplant__ = __webpack_require__(89);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





var invalidDomainChars = Object(__WEBPACK_IMPORTED_MODULE_4__lib_stringSupplant__["a" /* default */])('#{punct}#{spacesGroup}#{invalidCharsGroup}#{directionalMarkersGroup}', {
  punct: __WEBPACK_IMPORTED_MODULE_2__punct__["a" /* default */],
  spacesGroup: __WEBPACK_IMPORTED_MODULE_3__spacesGroup__["a" /* default */],
  invalidCharsGroup: __WEBPACK_IMPORTED_MODULE_1__invalidCharsGroup__["a" /* default */],
  directionalMarkersGroup: __WEBPACK_IMPORTED_MODULE_0__directionalMarkersGroup__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (invalidDomainChars);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var directionalMarkersGroup = /\u202A-\u202E\u061C\u200E\u200F\u2066\u2067\u2068\u2069/;
/* harmony default export */ __webpack_exports__["a"] = (directionalMarkersGroup);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validDomainChars__ = __webpack_require__(88);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validSubdomain = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:(?:#{validDomainChars}(?:[_-]|#{validDomainChars})*)?#{validDomainChars}\.)/, {
  validDomainChars: __WEBPACK_IMPORTED_MODULE_1__validDomainChars__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validSubdomain);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validPortNumber = /[0-9]+/;
/* harmony default export */ __webpack_exports__["a"] = (validPortNumber);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validGeneralUrlPathChars__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validUrlBalancedParens__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validUrlPathEndingChars__ = __webpack_require__(311);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



 // Allow @ in a url, but only in the middle. Catch things like http://example.com/@user/

var validUrlPath = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '(?:' + '#{validGeneralUrlPathChars}*' + '(?:#{validUrlBalancedParens}#{validGeneralUrlPathChars}*)*' + '#{validUrlPathEndingChars}' + ')|(?:@#{validGeneralUrlPathChars}+/)' + ')', {
  validGeneralUrlPathChars: __WEBPACK_IMPORTED_MODULE_1__validGeneralUrlPathChars__["a" /* default */],
  validUrlBalancedParens: __WEBPACK_IMPORTED_MODULE_2__validUrlBalancedParens__["a" /* default */],
  validUrlPathEndingChars: __WEBPACK_IMPORTED_MODULE_3__validUrlPathEndingChars__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validUrlPath);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cyrillicLettersAndMarks__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validUrlBalancedParens__ = __webpack_require__(94);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



 // Valid end-of-path chracters (so /foo. does not gobble the period).
// 1. Allow =&# for empty URL parameters and other URL-join artifacts

var validUrlPathEndingChars = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])(/[\+\-a-z#{cyrillicLettersAndMarks}0-9=_#\/#{latinAccentChars}]|(?:#{validUrlBalancedParens})/i, {
  cyrillicLettersAndMarks: __WEBPACK_IMPORTED_MODULE_0__cyrillicLettersAndMarks__["a" /* default */],
  latinAccentChars: __WEBPACK_IMPORTED_MODULE_1__latinAccentChars__["a" /* default */],
  validUrlBalancedParens: __WEBPACK_IMPORTED_MODULE_3__validUrlBalancedParens__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validUrlPathEndingChars);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directionalMarkersGroup__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invalidCharsGroup__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validUrlPrecedingChars = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])(/(?:[^A-Za-z0-9@＠$#＃#{invalidCharsGroup}]|[#{directionalMarkersGroup}]|^)/, {
  invalidCharsGroup: __WEBPACK_IMPORTED_MODULE_1__invalidCharsGroup__["a" /* default */],
  directionalMarkersGroup: __WEBPACK_IMPORTED_MODULE_0__directionalMarkersGroup__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validUrlPrecedingChars);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var invalidUrlWithoutProtocolPrecedingChars = /[-_.\/]$/;
/* harmony default export */ __webpack_exports__["a"] = (invalidUrlWithoutProtocolPrecedingChars);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(301);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(565);
var advanceStringIndex = __webpack_require__(73);
var toLength = __webpack_require__(23);
var callRegExpExec = __webpack_require__(74);
var regexpExec = __webpack_require__(77);
var fails = __webpack_require__(13);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(76)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validUrlQueryChars__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validUrlQueryEndingChars__ = __webpack_require__(96);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validTcoUrl = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/^https?:\/\/t\.co\/([a-z0-9]+)(?:\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?/, {
  validUrlQueryChars: __WEBPACK_IMPORTED_MODULE_1__validUrlQueryChars__["a" /* default */],
  validUrlQueryEndingChars: __WEBPACK_IMPORTED_MODULE_2__validUrlQueryEndingChars__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validTcoUrl);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashSigns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashtagAlpha__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashtagAlphaNumeric__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashtagBoundary__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





var validHashtag = Object(__WEBPACK_IMPORTED_MODULE_4__lib_regexSupplant__["a" /* default */])(/(#{hashtagBoundary})(#{hashSigns})(?!\uFE0F|\u20E3)(#{hashtagAlphaNumeric}*#{hashtagAlpha}#{hashtagAlphaNumeric}*)/gi, {
  hashtagBoundary: __WEBPACK_IMPORTED_MODULE_3__hashtagBoundary__["a" /* default */],
  hashSigns: __WEBPACK_IMPORTED_MODULE_0__hashSigns__["a" /* default */],
  hashtagAlphaNumeric: __WEBPACK_IMPORTED_MODULE_2__hashtagAlphaNumeric__["a" /* default */],
  hashtagAlpha: __WEBPACK_IMPORTED_MODULE_1__hashtagAlpha__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validHashtag);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bmpLetterAndMarks__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonBmpCodePairs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



 // A hashtag must contain at least one unicode letter or mark, as well as numbers, underscores, and select special characters.

var hashtagAlpha = Object(__WEBPACK_IMPORTED_MODULE_3__lib_regexSupplant__["a" /* default */])(/(?:[#{bmpLetterAndMarks}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}))/, {
  bmpLetterAndMarks: __WEBPACK_IMPORTED_MODULE_1__bmpLetterAndMarks__["a" /* default */],
  nonBmpCodePairs: __WEBPACK_IMPORTED_MODULE_2__nonBmpCodePairs__["a" /* default */],
  astralLetterAndMarks: __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (hashtagAlpha);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var astralNumerals = /\ud801[\udca0-\udca9]|\ud804[\udc66-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udef0-\udef9]|\ud805[\udcd0-\udcd9\ude50-\ude59\udec0-\udec9]|\ud806[\udce0-\udce9]|\ud81a[\ude60-\ude69\udf50-\udf59]|\ud835[\udfce-\udfff]/;
/* harmony default export */ __webpack_exports__["a"] = (astralNumerals);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var bmpNumerals = /0-9\u0660-\u0669\u06f0-\u06f9\u07c0-\u07c9\u0966-\u096f\u09e6-\u09ef\u0a66-\u0a6f\u0ae6-\u0aef\u0b66-\u0b6f\u0be6-\u0bef\u0c66-\u0c6f\u0ce6-\u0cef\u0d66-\u0d6f\u0de6-\u0def\u0e50-\u0e59\u0ed0-\u0ed9\u0f20-\u0f29\u1040-\u1049\u1090-\u1099\u17e0-\u17e9\u1810-\u1819\u1946-\u194f\u19d0-\u19d9\u1a80-\u1a89\u1a90-\u1a99\u1b50-\u1b59\u1bb0-\u1bb9\u1c40-\u1c49\u1c50-\u1c59\ua620-\ua629\ua8d0-\ua8d9\ua900-\ua909\ua9d0-\ua9d9\ua9f0-\ua9f9\uaa50-\uaa59\uabf0-\uabf9\uff10-\uff19/;
/* harmony default export */ __webpack_exports__["a"] = (bmpNumerals);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var hashtagSpecialChars = /_\u200c\u200d\ua67e\u05be\u05f3\u05f4\uff5e\u301c\u309b\u309c\u30a0\u30fb\u3003\u0f0b\u0f0c\xb7/;
/* harmony default export */ __webpack_exports__["a"] = (hashtagSpecialChars);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__codePoint__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashtagAlphaNumeric__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var hashtagBoundary = Object(__WEBPACK_IMPORTED_MODULE_2__lib_regexSupplant__["a" /* default */])(/(?:^|\uFE0E|\uFE0F|$|(?!#{hashtagAlphaNumeric}|&)#{codePoint})/, {
  codePoint: __WEBPACK_IMPORTED_MODULE_0__codePoint__["a" /* default */],
  hashtagAlphaNumeric: __WEBPACK_IMPORTED_MODULE_1__hashtagAlphaNumeric__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (hashtagBoundary);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var codePoint = /(?:[^\uD800-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])/;
/* harmony default export */ __webpack_exports__["a"] = (codePoint);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validMentionPrecedingChars = /(?:^|[^a-zA-Z0-9_!#$%&*@＠]|(?:^|[^a-zA-Z0-9_+~.-])(?:rt|RT|rT|Rt):?)/;
/* harmony default export */ __webpack_exports__["a"] = (validMentionPrecedingChars);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var BOOLEAN_ATTRIBUTES = {
  disabled: true,
  readonly: true,
  multiple: true,
  checked: true
}; // Options which should not be passed as HTML attributes

var OPTIONS_NOT_ATTRIBUTES = {
  urlClass: true,
  listClass: true,
  usernameClass: true,
  hashtagClass: true,
  cashtagClass: true,
  usernameUrlBase: true,
  listUrlBase: true,
  hashtagUrlBase: true,
  cashtagUrlBase: true,
  usernameUrlBlock: true,
  listUrlBlock: true,
  hashtagUrlBlock: true,
  linkUrlBlock: true,
  usernameIncludeSymbol: true,
  suppressLists: true,
  suppressNoFollow: true,
  targetBlank: true,
  suppressDataScreenName: true,
  urlEntities: true,
  symbolTag: true,
  textWithSymbolTag: true,
  urlTarget: true,
  invisibleTagAttrs: true,
  linkAttributeBlock: true,
  linkTextBlock: true,
  htmlEscapeNonEntities: true
};
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var htmlAttrs = {};

  for (var k in options) {
    var v = options[k];

    if (OPTIONS_NOT_ATTRIBUTES[k]) {
      continue;
    }

    if (BOOLEAN_ATTRIBUTES[k]) {
      v = v ? k : null;
    }

    if (v == null) {
      continue;
    }

    htmlAttrs[k] = v;
  }

  return htmlAttrs;
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_clone__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linkToTextWithSymbol__ = __webpack_require__(64);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



/* harmony default export */ __webpack_exports__["a"] = (function (entity, text, options) {
  var cashtag = Object(__WEBPACK_IMPORTED_MODULE_1__htmlEscape__["a" /* default */])(entity.cashtag);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_0__lib_clone__["a" /* default */])(options.htmlAttrs || {});
  attrs.href = options.cashtagUrlBase + cashtag;
  attrs.title = "$".concat(cashtag);
  attrs['class'] = options.cashtagClass;

  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__linkToTextWithSymbol__["a" /* default */])(entity, '$', cashtag, attrs, options);
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_to_string__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__htmlEscape__ = __webpack_require__(19);



// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var BOOLEAN_ATTRIBUTES = {
  disabled: true,
  readonly: true,
  multiple: true,
  checked: true
};
/* harmony default export */ __webpack_exports__["a"] = (function (attributes) {
  var htmlAttrs = '';

  for (var k in attributes) {
    var v = attributes[k];

    if (BOOLEAN_ATTRIBUTES[k]) {
      v = v ? k : null;
    }

    if (v == null) {
      continue;
    }

    htmlAttrs += " ".concat(Object(__WEBPACK_IMPORTED_MODULE_3__htmlEscape__["a" /* default */])(k), "=\"").concat(Object(__WEBPACK_IMPORTED_MODULE_3__htmlEscape__["a" /* default */])(v.toString()), "\"");
  }

  return htmlAttrs;
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_clone__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_rtlChars__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__linkToTextWithSymbol__ = __webpack_require__(64);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




/* harmony default export */ __webpack_exports__["a"] = (function (entity, text, options) {
  var hash = text.substring(entity.indices[0], entity.indices[0] + 1);
  var hashtag = Object(__WEBPACK_IMPORTED_MODULE_2__htmlEscape__["a" /* default */])(entity.hashtag);
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_1__lib_clone__["a" /* default */])(options.htmlAttrs || {});
  attrs.href = options.hashtagUrlBase + hashtag;
  attrs.title = "#".concat(hashtag);
  attrs['class'] = options.hashtagClass;

  if (hashtag.charAt(0).match(__WEBPACK_IMPORTED_MODULE_3__regexp_rtlChars__["a" /* default */])) {
    attrs['class'] += ' rtl';
  }

  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__linkToTextWithSymbol__["a" /* default */])(entity, hash, hashtag, attrs, options);
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var rtlChars = /[\u0600-\u06FF]|[\u0750-\u077F]|[\u0590-\u05FF]|[\uFE70-\uFEFF]/gm;
/* harmony default export */ __webpack_exports__["a"] = (rtlChars);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_clone__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkToText__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__linkTextWithEntity__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__regexp_urlHasProtocol__ = __webpack_require__(331);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0





/* harmony default export */ __webpack_exports__["a"] = (function (entity, text, options) {
  var url = entity.url;
  var displayUrl = url;
  var linkText = Object(__WEBPACK_IMPORTED_MODULE_2__htmlEscape__["a" /* default */])(displayUrl); // If the caller passed a urlEntities object (provided by a Twitter API
  // response with include_entities=true), we use that to render the display_url
  // for each URL instead of it's underlying t.co URL.

  var urlEntity = options.urlEntities && options.urlEntities[url] || entity;

  if (urlEntity.display_url) {
    linkText = Object(__WEBPACK_IMPORTED_MODULE_4__linkTextWithEntity__["a" /* default */])(urlEntity, options);
  }

  var attrs = Object(__WEBPACK_IMPORTED_MODULE_1__lib_clone__["a" /* default */])(options.htmlAttrs || {});

  if (!url.match(__WEBPACK_IMPORTED_MODULE_5__regexp_urlHasProtocol__["a" /* default */])) {
    url = "http://".concat(url);
  }

  attrs.href = url;

  if (options.targetBlank) {
    attrs.target = '_blank';
  } // set class only if urlClass is specified.


  if (options.urlClass) {
    attrs['class'] = options.urlClass;
  } // set target only if urlTarget is specified.


  if (options.urlTarget) {
    attrs.target = options.urlTarget;
  }

  if (!options.title && urlEntity.display_url) {
    attrs.title = urlEntity.expanded_url;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3__linkToText__["a" /* default */])(entity, linkText, attrs, options);
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_stringSupplant__ = __webpack_require__(89);



// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (entity, options) {
  var displayUrl = entity.display_url;
  var expandedUrl = entity.expanded_url; // Goal: If a user copies and pastes a tweet containing t.co'ed link, the resulting paste
  // should contain the full original URL (expanded_url), not the display URL.
  //
  // Method: Whenever possible, we actually emit HTML that contains expanded_url, and use
  // font-size:0 to hide those parts that should not be displayed (because they are not part of display_url).
  // Elements with font-size:0 get copied even though they are not visible.
  // Note that display:none doesn't work here. Elements with display:none don't get copied.
  //
  // Additionally, we want to *display* ellipses, but we don't want them copied.  To make this happen we
  // wrap the ellipses in a tco-ellipsis class and provide an onCopy handler that sets display:none on
  // everything with the tco-ellipsis class.
  //
  // Exception: pic.twitter.com images, for which expandedUrl = "https://twitter.com/#!/username/status/1234/photo/1
  // For those URLs, display_url is not a substring of expanded_url, so we don't do anything special to render the elided parts.
  // For a pic.twitter.com URL, the only elided part will be the "https://", so this is fine.

  var displayUrlSansEllipses = displayUrl.replace(/…/g, ''); // We have to disregard ellipses for matching
  // Note: we currently only support eliding parts of the URL at the beginning or the end.
  // Eventually we may want to elide parts of the URL in the *middle*.  If so, this code will
  // become more complicated.  We will probably want to create a regexp out of display URL,
  // replacing every ellipsis with a ".*".

  if (expandedUrl.indexOf(displayUrlSansEllipses) != -1) {
    var displayUrlIndex = expandedUrl.indexOf(displayUrlSansEllipses);
    var v = {
      displayUrlSansEllipses: displayUrlSansEllipses,
      // Portion of expandedUrl that precedes the displayUrl substring
      beforeDisplayUrl: expandedUrl.substr(0, displayUrlIndex),
      // Portion of expandedUrl that comes after displayUrl
      afterDisplayUrl: expandedUrl.substr(displayUrlIndex + displayUrlSansEllipses.length),
      precedingEllipsis: displayUrl.match(/^…/) ? '…' : '',
      followingEllipsis: displayUrl.match(/…$/) ? '…' : ''
    };

    for (var k in v) {
      if (v.hasOwnProperty(k)) {
        v[k] = Object(__WEBPACK_IMPORTED_MODULE_3__htmlEscape__["a" /* default */])(v[k]);
      }
    } // As an example: The user tweets "hi http://longdomainname.com/foo"
    // This gets shortened to "hi http://t.co/xyzabc", with display_url = "…nname.com/foo"
    // This will get rendered as:
    // <span class='tco-ellipsis'> <!-- This stuff should get displayed but not copied -->
    //   …
    //   <!-- There's a chance the onCopy event handler might not fire. In case that happens,
    //        we include an &nbsp; here so that the … doesn't bump up against the URL and ruin it.
    //        The &nbsp; is inside the tco-ellipsis span so that when the onCopy handler *does*
    //        fire, it doesn't get copied.  Otherwise the copied text would have two spaces in a row,
    //        e.g. "hi  http://longdomainname.com/foo".
    //   <span style='font-size:0'>&nbsp;</span>
    // </span>
    // <span style='font-size:0'>  <!-- This stuff should get copied but not displayed -->
    //   http://longdomai
    // </span>
    // <span class='js-display-url'> <!-- This stuff should get displayed *and* copied -->
    //   nname.com/foo
    // </span>
    // <span class='tco-ellipsis'> <!-- This stuff should get displayed but not copied -->
    //   <span style='font-size:0'>&nbsp;</span>
    //   …
    // </span>


    v['invisible'] = options.invisibleTagAttrs;
    return Object(__WEBPACK_IMPORTED_MODULE_4__lib_stringSupplant__["a" /* default */])("<span class='tco-ellipsis'>#{precedingEllipsis}<span #{invisible}>&nbsp;</span></span><span #{invisible}>#{beforeDisplayUrl}</span><span class='js-display-url'>#{displayUrlSansEllipses}</span><span #{invisible}>#{afterDisplayUrl}</span><span class='tco-ellipsis'><span #{invisible}>&nbsp;</span>#{followingEllipsis}</span>", v);
  }

  return displayUrl;
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var urlHasProtocol = /^https?:\/\//i;
/* harmony default export */ __webpack_exports__["a"] = (urlHasProtocol);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_clone__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linkToTextWithSymbol__ = __webpack_require__(64);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



/* harmony default export */ __webpack_exports__["a"] = (function (entity, text, options) {
  var at = text.substring(entity.indices[0], entity.indices[0] + 1);
  var user = Object(__WEBPACK_IMPORTED_MODULE_1__htmlEscape__["a" /* default */])(entity.screenName);
  var slashListname = Object(__WEBPACK_IMPORTED_MODULE_1__htmlEscape__["a" /* default */])(entity.listSlug);
  var isList = entity.listSlug && !options.suppressLists;
  var attrs = Object(__WEBPACK_IMPORTED_MODULE_0__lib_clone__["a" /* default */])(options.htmlAttrs || {});
  attrs['class'] = isList ? options.listClass : options.usernameClass;
  attrs.href = isList ? options.listUrlBase + user + slashListname : options.usernameUrlBase + user;

  if (!isList && !options.suppressDataScreenName) {
    attrs['data-screen-name'] = user;
  }

  if (options.targetBlank) {
    attrs.target = '_blank';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__linkToTextWithSymbol__["a" /* default */])(entity, at, isList ? user + slashListname : user, attrs, options);
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_convertUnicodeIndices__ = __webpack_require__(334);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text, entities) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_convertUnicodeIndices__["a" /* default */])(text, entities, false);
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/**
 * Copied from https://github.com/twitter/twitter-text/blob/master/js/twitter-text.js
 */
var convertUnicodeIndices = function convertUnicodeIndices(text, entities, indicesInUTF16) {
  if (entities.length === 0) {
    return;
  }

  var charIndex = 0;
  var codePointIndex = 0; // sort entities by start index

  entities.sort(function (a, b) {
    return a.indices[0] - b.indices[0];
  });
  var entityIndex = 0;
  var entity = entities[0];

  while (charIndex < text.length) {
    if (entity.indices[0] === (indicesInUTF16 ? charIndex : codePointIndex)) {
      var len = entity.indices[1] - entity.indices[0];
      entity.indices[0] = indicesInUTF16 ? codePointIndex : charIndex;
      entity.indices[1] = entity.indices[0] + len;
      entityIndex++;

      if (entityIndex === entities.length) {
        // no more entity
        break;
      }

      entity = entities[entityIndex];
    }

    var c = text.charCodeAt(charIndex);

    if (c >= 0xd800 && c <= 0xdbff && charIndex < text.length - 1) {
      // Found high surrogate char
      c = text.charCodeAt(charIndex + 1);

      if (c >= 0xdc00 && c <= 0xdfff) {
        // Found surrogate pair
        charIndex++;
      }
    }

    codePointIndex++;
    charIndex++;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (convertUnicodeIndices);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractHashtagsWithIndices__ = __webpack_require__(59);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var hashtagsOnly = [];
  var hashtagsWithIndices = Object(__WEBPACK_IMPORTED_MODULE_0__extractHashtagsWithIndices__["a" /* default */])(text);

  for (var i = 0; i < hashtagsWithIndices.length; i++) {
    hashtagsOnly.push(hashtagsWithIndices[i].hashtag);
  }

  return hashtagsOnly;
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractMentionsWithIndices__ = __webpack_require__(337);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var screenNamesOnly = [],
      screenNamesWithIndices = Object(__WEBPACK_IMPORTED_MODULE_0__extractMentionsWithIndices__["a" /* default */])(text);

  for (var i = 0; i < screenNamesWithIndices.length; i++) {
    var screenName = screenNamesWithIndices[i].screenName;
    screenNamesOnly.push(screenName);
  }

  return screenNamesOnly;
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractMentionsOrListsWithIndices__ = __webpack_require__(63);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var mentions = [];
  var mentionOrList;
  var mentionsOrLists = Object(__WEBPACK_IMPORTED_MODULE_0__extractMentionsOrListsWithIndices__["a" /* default */])(text);

  for (var i = 0; i < mentionsOrLists.length; i++) {
    mentionOrList = mentionsOrLists[i];

    if (mentionOrList.listSlug === '') {
      mentions.push({
        screenName: mentionOrList.screenName,
        indices: mentionOrList.indices
      });
    }
  }

  return mentions;
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spaces__ = __webpack_require__(85);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validReply = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/^(?:#{spaces})*#{atSigns}([a-zA-Z0-9_]{1,20})/, {
  atSigns: __WEBPACK_IMPORTED_MODULE_0__atSigns__["a" /* default */],
  spaces: __WEBPACK_IMPORTED_MODULE_2__spaces__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validReply);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractUrlsWithIndices__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getCharacterWeight__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifyIndicesFromUTF16ToUnicode__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp_nonBmpCodePairs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parseTweet__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__regexp_urlHasHttps__ = __webpack_require__(111);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0








var getTweetLength = function getTweetLength(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].defaults;
  return Object(__WEBPACK_IMPORTED_MODULE_5__parseTweet__["a" /* default */])(text, options).weightedLength;
};

/* harmony default export */ __webpack_exports__["a"] = (getTweetLength);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array__);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var getCharacterWeight = function getCharacterWeight(ch, options) {
  var defaultWeight = options.defaultWeight,
      ranges = options.ranges;
  var weight = defaultWeight;
  var chCodePoint = ch.charCodeAt(0);

  if (Array.isArray(ranges)) {
    for (var i = 0, length = ranges.length; i < length; i++) {
      var currRange = ranges[i];

      if (chCodePoint >= currRange.start && chCodePoint <= currRange.end) {
        weight = currRange.weight;
        break;
      }
    }
  }

  return weight;
};

/* harmony default export */ __webpack_exports__["a"] = (getCharacterWeight);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_reduce__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extractUrlsWithIndices__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_getCharacterWeight__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hasInvalidCharacters__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modifyIndicesFromUTF16ToUnicode__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_twemoji_parser__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_twemoji_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_twemoji_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__regexp_urlHasHttps__ = __webpack_require__(111);





// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




 // TODO: WEB-19861 Replace with public package after it is open sourced



/**
 * [parseTweet description]
 * @param  {string} text tweet text to parse
 * @param  {Object} options config options to pass
 * @return {Object} Fields in response described below:
 *
 * Response fields:
 * weightedLength {int} the weighted length of tweet based on weights specified in the config
 * valid {bool} If tweet is valid
 * permillage {float} permillage of the tweet over the max length specified in config
 * validRangeStart {int} beginning of valid text
 * validRangeEnd {int} End index of valid part of the tweet text (inclusive) in utf16
 * displayRangeStart {int} beginning index of display text
 * displayRangeEnd {int} end index of display text (inclusive) in utf16
 */

var parseTweet = function parseTweet() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_5__configs__["a" /* default */].defaults;
  var mergedOptions = Object.keys(options).length ? options : __WEBPACK_IMPORTED_MODULE_5__configs__["a" /* default */].defaults;
  var defaultWeight = mergedOptions.defaultWeight,
      emojiParsingEnabled = mergedOptions.emojiParsingEnabled,
      scale = mergedOptions.scale,
      maxWeightedTweetLength = mergedOptions.maxWeightedTweetLength,
      transformedURLLength = mergedOptions.transformedURLLength;
  var normalizedText = typeof String.prototype.normalize === 'function' ? text.normalize() : text; // Hash all entities by their startIndex for fast lookup

  var urlEntitiesMap = transformEntitiesToHash(Object(__WEBPACK_IMPORTED_MODULE_6__extractUrlsWithIndices__["a" /* default */])(normalizedText));
  var emojiEntitiesMap = emojiParsingEnabled ? transformEntitiesToHash(Object(__WEBPACK_IMPORTED_MODULE_10_twemoji_parser__["parse"])(normalizedText)) : [];
  var tweetLength = normalizedText.length;
  var weightedLength = 0;
  var validDisplayIndex = 0;
  var valid = true; // Go through every character and calculate weight

  for (var charIndex = 0; charIndex < tweetLength; charIndex++) {
    // If a url begins at the specified index handle, add constant length
    if (urlEntitiesMap[charIndex]) {
      var _urlEntitiesMap$charI = urlEntitiesMap[charIndex],
          url = _urlEntitiesMap$charI.url,
          indices = _urlEntitiesMap$charI.indices;
      weightedLength += transformedURLLength * scale;
      charIndex += url.length - 1;
    } else if (emojiParsingEnabled && emojiEntitiesMap[charIndex]) {
      var _emojiEntitiesMap$cha = emojiEntitiesMap[charIndex],
          emoji = _emojiEntitiesMap$cha.text,
          _indices = _emojiEntitiesMap$cha.indices;
      weightedLength += defaultWeight;
      charIndex += emoji.length - 1;
    } else {
      charIndex += isSurrogatePair(normalizedText, charIndex) ? 1 : 0;
      weightedLength += Object(__WEBPACK_IMPORTED_MODULE_7__lib_getCharacterWeight__["a" /* default */])(normalizedText.charAt(charIndex), mergedOptions);
    } // Only test for validity of character if it is still valid


    if (valid) {
      valid = !Object(__WEBPACK_IMPORTED_MODULE_8__hasInvalidCharacters__["a" /* default */])(normalizedText.substring(charIndex, charIndex + 1));
    }

    if (valid && weightedLength <= maxWeightedTweetLength * scale) {
      validDisplayIndex = charIndex;
    }
  }

  weightedLength = weightedLength / scale;
  valid = valid && weightedLength > 0 && weightedLength <= maxWeightedTweetLength;
  var permillage = Math.floor(weightedLength / maxWeightedTweetLength * 1000);
  var normalizationOffset = text.length - normalizedText.length;
  validDisplayIndex += normalizationOffset;
  return {
    weightedLength: weightedLength,
    valid: valid,
    permillage: permillage,
    validRangeStart: 0,
    validRangeEnd: validDisplayIndex,
    displayRangeStart: 0,
    displayRangeEnd: text.length > 0 ? text.length - 1 : 0
  };
};

var transformEntitiesToHash = function transformEntitiesToHash(entities) {
  return entities.reduce(function (map, entity) {
    map[entity.indices[0]] = entity;
    return map;
  }, {});
};

var isSurrogatePair = function isSurrogatePair(text, cIndex) {
  // Test if a character is the beginning of a surrogate pair
  if (cIndex < text.length - 1) {
    var c = text.charCodeAt(cIndex);
    var cNext = text.charCodeAt(cIndex + 1);
    return 0xd800 <= c && c <= 0xdbff && 0xdc00 <= cNext && cNext <= 0xdfff;
  }

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (parseTweet);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(108);
var getKeys = __webpack_require__(45);
var redefine = __webpack_require__(18);
var global = __webpack_require__(10);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(44);
var wks = __webpack_require__(7);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(53);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(18);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(44);
var $iterCreate = __webpack_require__(584);
var setToStringTag = __webpack_require__(109);
var getPrototypeOf = __webpack_require__(586);
var ITERATOR = __webpack_require__(7)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(345);
var enumBugKeys = __webpack_require__(84);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(296)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(585).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(45);

module.exports = __webpack_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(20);
var $keys = __webpack_require__(45);

__webpack_require__(587)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invalidCharsGroup__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var invalidChars = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/[#{invalidCharsGroup}]/, {
  invalidCharsGroup: __WEBPACK_IMPORTED_MODULE_0__invalidCharsGroup__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (invalidChars);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__regexp_nonBmpCodePairs__ = __webpack_require__(42);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/**
 * Copied from https://github.com/twitter/twitter-text/blob/master/js/twitter-text.js
 */

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  return text.replace(__WEBPACK_IMPORTED_MODULE_1__regexp_nonBmpCodePairs__["a" /* default */], ' ').length;
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// this essentially does text.split(/<|>/)
// except that won't work in IE, where empty strings are ommitted
// so "<>".split(/<|>/) => [] in IE, but is ["", "", ""] in all others
// but "<<".split("<") => ["", "", ""]
/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var firstSplits = text.split('<'),
      secondSplits,
      allSplits = [],
      split;

  for (var i = 0; i < firstSplits.length; i += 1) {
    split = firstSplits[i];

    if (!split) {
      allSplits.push('');
    } else {
      secondSplits = split.split('>');

      for (var j = 0; j < secondSplits.length; j += 1) {
        allSplits.push(secondSplits[j]);
      }
    }
  }

  return allSplits;
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_properties__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_web_dom_iterable__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_defineProperty__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getTweetLength__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hasInvalidCharacters__ = __webpack_require__(110);












function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_11__configs__["a" /* default */].defaults;

  if (!text) {
    return 'empty';
  }

  var mergedOptions = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_11__configs__["a" /* default */].defaults, {}, options);

  var maxLength = mergedOptions.maxWeightedTweetLength; // Determine max length independent of URL length

  if (Object(__WEBPACK_IMPORTED_MODULE_12__getTweetLength__["a" /* default */])(text, mergedOptions) > maxLength) {
    return 'too_long';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_13__hasInvalidCharacters__["a" /* default */])(text)) {
    return 'invalid_characters';
  }

  return false;
});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(12);
var createDesc = __webpack_require__(39);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(55);
var IObject = __webpack_require__(79);
var toObject = __webpack_require__(20);
var toLength = __webpack_require__(23);
var asc = __webpack_require__(596);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(7);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlUserinfo__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlHost__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlPort__ = __webpack_require__(118);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




var validateUrlAuthority = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])( // $1 userinfo
'(?:(#{validateUrlUserinfo})@)?' + // $2 host
'(#{validateUrlHost})' + // $3 port
'(?::(#{validateUrlPort}))?', {
  validateUrlUserinfo: __WEBPACK_IMPORTED_MODULE_1__validateUrlUserinfo__["a" /* default */],
  validateUrlHost: __WEBPACK_IMPORTED_MODULE_2__validateUrlHost__["a" /* default */],
  validateUrlPort: __WEBPACK_IMPORTED_MODULE_3__validateUrlPort__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlAuthority);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlDomain__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlIp__ = __webpack_require__(117);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validateUrlHost = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '#{validateUrlIp}|' + '#{validateUrlDomain}' + ')', {
  validateUrlIp: __WEBPACK_IMPORTED_MODULE_2__validateUrlIp__["a" /* default */],
  validateUrlDomain: __WEBPACK_IMPORTED_MODULE_1__validateUrlDomain__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlHost);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlDomainSegment__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlDomainTld__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDomainSegment__ = __webpack_require__(360);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




var validateUrlDomain = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:(?:#{validateUrlSubDomainSegment}\.)*(?:#{validateUrlDomainSegment}\.)#{validateUrlDomainTld})/i, {
  validateUrlSubDomainSegment: __WEBPACK_IMPORTED_MODULE_3__validateUrlSubDomainSegment__["a" /* default */],
  validateUrlDomainSegment: __WEBPACK_IMPORTED_MODULE_1__validateUrlDomainSegment__["a" /* default */],
  validateUrlDomainTld: __WEBPACK_IMPORTED_MODULE_2__validateUrlDomainTld__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlDomain);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlDomainSegment = /(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlDomainSegment);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlDomainTld = /(?:[a-z](?:[a-z0-9\-]*[a-z0-9])?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlDomainTld);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlSubDomainSegment = /(?:[a-z0-9](?:[a-z0-9_\-]*[a-z0-9])?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlSubDomainSegment);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlDecOctet__ = __webpack_require__(362);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlIpv4 = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:#{validateUrlDecOctet}(?:\.#{validateUrlDecOctet}){3})/i, {
  validateUrlDecOctet: __WEBPACK_IMPORTED_MODULE_1__validateUrlDecOctet__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlIpv4);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlDecOctet = /(?:[0-9]|(?:[1-9][0-9])|(?:1[0-9]{2})|(?:2[0-4][0-9])|(?:25[0-5]))/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlDecOctet);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// Punting on real IPv6 validation for now
var validateUrlIpv6 = /(?:\[[a-f0-9:\.]+\])/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlIpv6);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__ = __webpack_require__(66);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlFragment = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(#{validateUrlPchar}|\/|\?)*/i, {
  validateUrlPchar: __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlFragment);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__ = __webpack_require__(66);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlPath = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(\/#{validateUrlPchar}*)*/i, {
  validateUrlPchar: __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlPath);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__ = __webpack_require__(66);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var validateUrlQuery = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(#{validateUrlPchar}|\/|\?)*/i, {
  validateUrlPchar: __WEBPACK_IMPORTED_MODULE_1__validateUrlPchar__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlQuery);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlScheme = /(?:[a-z][a-z0-9+\-.]*)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlScheme);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
 // Modified version of RFC 3986 Appendix B

var validateUrlUnencoded = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('^' + // Full URL
'(?:' + '([^:/?#]+):\\/\\/' + // $1 Scheme
')?' + '([^/?#]*)' + // $2 Authority
'([^?#]*)' + // $3 Path
'(?:' + '\\?([^#]*)' + // $4 Query
')?' + '(?:' + '#(.*)' + // $5 Fragment
')?$', 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnencoded);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlUserinfo__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeHost__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlPort__ = __webpack_require__(118);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0




var validateUrlUnicodeAuthority = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])( // $1 userinfo
'(?:(#{validateUrlUserinfo})@)?' + // $2 host
'(#{validateUrlUnicodeHost})' + // $3 port
'(?::(#{validateUrlPort}))?', {
  validateUrlUserinfo: __WEBPACK_IMPORTED_MODULE_1__validateUrlUserinfo__["a" /* default */],
  validateUrlUnicodeHost: __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeHost__["a" /* default */],
  validateUrlPort: __WEBPACK_IMPORTED_MODULE_3__validateUrlPort__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeAuthority);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlIp__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeDomain__ = __webpack_require__(371);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



var validateUrlUnicodeHost = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])('(?:' + '#{validateUrlIp}|' + '#{validateUrlUnicodeDomain}' + ')', {
  validateUrlIp: __WEBPACK_IMPORTED_MODULE_1__validateUrlIp__["a" /* default */],
  validateUrlUnicodeDomain: __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeDomain__["a" /* default */]
}, 'i');
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeHost);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validateUrlUnicodeSubDomainSegment__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeDomainSegment__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validateUrlUnicodeDomainTld__ = __webpack_require__(374);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0



 // Unencoded internationalized domains - this doesn't check for invalid UTF-8 sequences

var validateUrlUnicodeDomain = Object(__WEBPACK_IMPORTED_MODULE_0__lib_regexSupplant__["a" /* default */])(/(?:(?:#{validateUrlUnicodeSubDomainSegment}\.)*(?:#{validateUrlUnicodeDomainSegment}\.)#{validateUrlUnicodeDomainTld})/i, {
  validateUrlUnicodeSubDomainSegment: __WEBPACK_IMPORTED_MODULE_1__validateUrlUnicodeSubDomainSegment__["a" /* default */],
  validateUrlUnicodeDomainSegment: __WEBPACK_IMPORTED_MODULE_2__validateUrlUnicodeDomainSegment__["a" /* default */],
  validateUrlUnicodeDomainTld: __WEBPACK_IMPORTED_MODULE_3__validateUrlUnicodeDomainTld__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeDomain);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlUnicodeSubDomainSegment = /(?:(?:[a-z0-9]|[^\u0000-\u007f])(?:(?:[a-z0-9_\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeSubDomainSegment);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlUnicodeDomainSegment = /(?:(?:[a-z0-9]|[^\u0000-\u007f])(?:(?:[a-z0-9\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeDomainSegment);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
// Unencoded internationalized domains - this doesn't check for invalid UTF-8 sequences
var validateUrlUnicodeDomainTld = /(?:(?:[a-z]|[^\u0000-\u007f])(?:(?:[a-z0-9\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i;
/* harmony default export */ __webpack_exports__["a"] = (validateUrlUnicodeDomainTld);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(376);





var FORMATS = __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-editor-toolbar-buttons',
  props: {
    formats: {
      type: Array,
      required: true
    },
    ariaLabels: {
      type: Object,
      default: {
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        bulletedList: 'Bulleted list',
        numberedList: 'Numbered list',
        clearFormats: 'Clear formats'
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formatsMap: function formatsMap() {
      return this.formats.reduce(function (formatsMap, key) {
        formatsMap[key] = true;
        return formatsMap;
      }, {});
    },
    hasBold: function hasBold() {
      return this.formatsMap[FORMATS.BOLD];
    },
    hasItalic: function hasItalic() {
      return this.formatsMap[FORMATS.ITALIC];
    },
    hasUnderline: function hasUnderline() {
      return this.formatsMap[FORMATS.UNDERLINE];
    },
    hasList: function hasList() {
      return this.formatsMap[FORMATS.LIST];
    },
    hasBullet: function hasBullet() {
      return this.formatsMap[FORMATS.BULLET];
    },

    theme: __WEBPACK_IMPORTED_MODULE_1__store__["getCurrentTheme"],
    themeName: __WEBPACK_IMPORTED_MODULE_1__store__["getCurrentThemeName"]
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createStore"] = createStore;
/* harmony export (immutable) */ __webpack_exports__["getCurrentTheme"] = getCurrentTheme;
/* harmony export (immutable) */ __webpack_exports__["getCurrentThemeName"] = getCurrentThemeName;
/* harmony export (immutable) */ __webpack_exports__["setCurrentTheme"] = setCurrentTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);


var AVAILABLE_THEMES = new Set(Object.values(__WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].THEMES));

var state = null;

function createStore(reactiveFn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? '' : _ref$theme;

  if (!state) {
    state = reactiveFn({
      theme: theme
    });
  }
  return state;
}

function getCurrentTheme() {
  return state.theme;
}

function getCurrentThemeName() {
  return state.theme.replace('theme-', '');
}

function setCurrentTheme(themeName) {
  if (AVAILABLE_THEMES.has(themeName)) {
    state.theme = themeName;
  }
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-accordion',
  props: {
    searchValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    expandAll: function expandAll(silent) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["each"])(this.$children, function (accordionItem) {
        if (accordionItem.$options.name === 'le-accordion-item') {
          accordionItem.expandItem(silent);
        }
      });
    },
    collapseAll: function collapseAll(silent) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["each"])(this.$children, function (accordionItem) {
        if (accordionItem.$options.name === 'le-accordion-item') {
          accordionItem.collapseItem(silent);
        }
      });
    }
  },
  watch: {
    searchValue: function searchValue(value) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["each"])(this.$children, function (accordionItem) {
        if (accordionItem.$options.name === 'le-accordion-item') {
          accordionItem.filterBySearchTerm(value);
        }
      });
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_collapse_mixin__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-accordion-item',
  data: function data() {
    return {
      showItem: true,
      searchTerm: '',
      controlerId: 'controler-' + Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqueId"])()
    };
  },

  components: {
    leTextWithHighlight: __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__le_collapse_mixin__["a" /* default */]],
  props: {
    title: {
      type: String,
      required: true
    },
    textContent: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    dynamicResize: {
      type: Boolean
    },
    transition: {
      type: Boolean,
      default: true
    },
    headingLevel: {
      type: Number,
      default: 0,
      required: false
    },
    itemId: {
      type: String,
      default: 'itemId'
    }
  },
  computed: {
    collapseIcon: function collapseIcon() {
      return this.isCollapsed ? 'ico-arrow-down' : 'ico-arrow-up';
    },
    showHeading: function showHeading() {
      return this.headingLevel > 0;
    }
  },
  mounted: function mounted() {
    if (this.dynamicResize) {
      this.observer = new MutationObserver(this.resizeSlotHeight);
      this.observer.observe(this.$refs.content, { childList: true, subtree: true });
    }
  },

  methods: {
    filterBySearchTerm: function filterBySearchTerm(searchTerm) {
      var searchTermLowerCase = searchTerm.toLowerCase();
      var title = this.title.toLowerCase();
      var content = this.$refs.content.textContent.toLowerCase();

      this.showItem = title.includes(searchTermLowerCase) || content.includes(searchTermLowerCase);

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.searchTerm) && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(searchTermLowerCase)) {
        this.collapseItem();
      } else if (this.showItem) {
        this.expandItem();
      }
      this.searchTerm = searchTerm;
    },
    collapseItem: function collapseItem(silent) {
      this.collapsed = true;
      if (!silent) {
        this.$emit('collapsed');
      }
    },
    expandItem: function expandItem(silent) {
      this.collapsed = false;
      if (!silent) {
        this.$emit('expanded');
      }
    },
    resizeSlotHeight: function resizeSlotHeight() {
      if (!this.collapsed) {
        this.$refs.content.style['max-height'] = this.$refs.content.scrollHeight + 'px';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__ = __webpack_require__(15);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LeBubble: __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__["a" /* default */] },
  name: 'le-emojies',
  data: function data() {
    return {
      emojiesList: [{ name: 'grinning-face', value: '😀' }, { name: 'grinning-face-with-big-eyes', value: '😃' }, { name: 'winking-face', value: '😉' }, { name: 'winking-face-with-tongue', value: '😜' }, { name: 'confused-face', value: '😕' }, { name: 'pensive-face', value: '😔' }, { name: 'grimacing-face', value: '😬' }, { name: 'smiling-face-with-sunglasses', value: '😎' }, { name: 'face-with-tears-of-joy', value: '😂' }, { name: 'grinning-face-with-smiling-eyes', value: '😄' }, { name: 'smiling-face-with-smiling-eyes', value: '😊' }, { name: 'face-savoring-food', value: '😋' }, { name: 'anguished-face', value: '😧' }, { name: 'relieved-face', value: '😌' }, { name: 'flushed-face', value: '😳' }, { name: 'smirking-face', value: '😏' }, { name: 'face-screaming-in-fear', value: '😱' }, { name: 'red heart', value: '❤️' }, { name: 'thumbs-up', value: '👍' }, { name: 'clapping-hands', value: '👏' }, { name: 'OK-hand', value: '👌' }, { name: 'folded-hands', value: '🙏' }, { name: 'bell', value: '🔔' }]
    };
  },

  props: {
    emojiesPerRow: {
      type: Number,
      default: 6
    },
    elementId: {
      type: String,
      required: true
    }
  },
  methods: {
    getContainerWidth: function getContainerWidth() {
      return this.emojiesPerRow * 25;
    },
    getIconWidth: function getIconWidth() {
      return 100 / this.emojiesPerRow;
    },
    onClick: function onClick(emoji) {
      this.$emit('emojiClick', emoji);
    },
    getEmojiLabel: function getEmojiLabel(name) {
      return name.split('-').join(' ');
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-toggle',
  model: {
    prop: 'state',
    event: 'change'
  },
  props: {
    state: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    }
  },
  computed: {
    toggleFrameStateClass: function toggleFrameStateClass() {
      return this.state ? 'toggle-active' : 'toggle-inactive';
    },
    isToggled: function isToggled() {
      return this.state ? 'true' : 'false';
    },
    tabIndex: function tabIndex() {
      return !this.disabled ? '0' : '-1';
    }
  },
  methods: {
    onToggleClick: function onToggleClick() {
      this.$emit('change', !this.state);
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-radio',
  props: {
    id: {
      type: String
    },
    groupName: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      required: true
    },
    itemsAlignment: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    tabbableIndex: function tabbableIndex() {
      return this.checked && !this.disabled === true ? '0' : '-1';
    },
    isSelected: function isSelected() {
      return this.checked === true ? 'true' : 'false';
    },
    topIndicatorStyle: function topIndicatorStyle() {
      return this.itemsAlignment === 'flex-start' ? '8px' : '0px';
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled) {
        this.$emit('change');
      }
    }
  },
  watch: {
    checked: function checked() {
      var _this = this;

      if (this.checked === true) {
        this.$nextTick(function () {
          _this.$refs.radioitem.focus();
        });
      }
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-ellipsis',
  props: {
    content: {
      type: String,
      required: true
    },
    bubblePlacement: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_BUBBLE.PLACEMENTS.BOTTOM
    },
    renderHtml: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showEllipsis: false,
      tootipText: ''
    };
  },

  computed: {
    tooltipOptions: function tooltipOptions() {
      return {
        content: this.tootipText,
        placement: this.bubblePlacement,
        html: this.renderHtml,
        autoHide: false
      };
    }
  },
  created: function created() {
    window.addEventListener('resize', this.onResize);
  },
  mounted: function mounted() {
    this.updateTooltipText();
  },
  updated: function updated() {
    this.updateTooltipText();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize: function onResize() {
      var _this = this;

      this.$nextTick(function () {
        _this.updateTooltipText();
      });
    },
    updateTooltipText: function updateTooltipText() {
      var hasEllipsis = this.$refs.ellipsis && this.$refs.ellipsis.scrollWidth > this.$refs.ellipsis.offsetWidth;
      this.tootipText = hasEllipsis ? this.content : '';
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_loader_le_loader__ = __webpack_require__(70);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-audio',
  components: {
    leLoader: __WEBPACK_IMPORTED_MODULE_1__le_loader_le_loader__["a" /* default */]
  },
  props: {
    src: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: Object,
      default: {
        play: 'Play',
        pause: 'Pause'
      }
    }
  },
  data: function data() {
    return {
      audioControl: null,
      playing: false,
      currentSeconds: 0,
      durationSeconds: 0,
      performedManualTimeChange: false
    };
  },

  computed: {
    currentTime: function currentTime() {
      return this.formatTime(parseInt(this.currentSeconds, 10));
    },
    durationTime: function durationTime() {
      return this.formatTime(parseInt(this.durationSeconds, 10));
    },
    percentComplete: function percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100, 10);
    },
    progressBarIndicationStyle: function progressBarIndicationStyle() {
      var animationStyle = '';
      if (!this.performedManualTimeChange) {
        animationStyle = ' transition: width 0.2s linear;';
      }
      return 'width: ' + this.percentComplete + '%;' + animationStyle;
    },
    playerButtonAriaLabel: function playerButtonAriaLabel() {
      return this.playing ? this.ariaLabel.pause : this.ariaLabel.play;
    }
  },
  mounted: function mounted() {
    this.initAudio();
  },

  methods: {
    onSeekClick: function onSeekClick(e) {
      var progressBarDurationRect = this.$refs.progressBarDuration.getBoundingClientRect();
      var seekPos = (e.clientX - progressBarDurationRect.left) / progressBarDurationRect.width;

      this.performTimeChange(this.audioControl.duration * seekPos);
    },
    onPlayClick: function onPlayClick() {
      if (this.playing) {
        this.pauseAudio();
      } else {
        if (this.audioControl && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.audioControl, 'currentTime') === Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.audioControl, 'duration')) {
          this.performTimeChange(0);
        }
        this.playAudio();
      }
    },
    playAudio: function playAudio() {
      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.playing = true;
                _this.$emit('play');
                _context.next = 4;
                return _this.initAudio();

              case 4:
                if (_this.audioControl) {
                  _this.audioControl.play();
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pauseAudio: function pauseAudio() {
      this.playing = false;
      if (this.audioControl) {
        this.audioControl.pause();
      }
      this.$emit('pause');
    },
    initAudio: function initAudio() {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (!_this2.audioControl && _this2.src) {
          _this2.audioControl = new Audio(_this2.src);

          if (_this2.audioControl.readyState > 3) {
            _this2.onAudioInit();
            resolve();
          } else {
            _this2.audioControl.addEventListener('canplaythrough', function () {
              _this2.onAudioInit();
              resolve();
            });
          }

          _this2.audioControl.addEventListener('timeupdate', _this2.onTimeUpdate.bind(_this2));
          _this2.audioControl.addEventListener('error', _this2.onAudioError.bind(_this2));
          _this2.audioControl.addEventListener('ended', _this2.onAudioEnd.bind(_this2));
        } else {
          resolve();
        }
      });
    },
    onAudioInit: function onAudioInit() {
      this.durationSeconds = this.audioControl.duration;
    },
    onAudioEnd: function onAudioEnd() {
      this.playing = false;
      this.$emit('end');
    },
    onTimeUpdate: function onTimeUpdate() {
      this.currentSeconds = this.audioControl.currentTime;
    },
    onAudioError: function onAudioError(error) {
      this.disposeAudio();
      this.$emit('error', error);
    },
    disposeAudio: function disposeAudio() {
      this.audioControl = null;
    },
    formatTime: function formatTime(val) {
      var hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
      return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
    },
    performTimeChange: function performTimeChange(time) {
      var _this3 = this;

      this.performedManualTimeChange = true;
      this.audioControl.currentTime = time;
      setTimeout(function () {
        _this3.performedManualTimeChange = false;
      }, 20);
    }
  },
  watch: {
    src: function src(newValue, oldValud) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(newValue) && this.playing) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(oldValud)) {
          this.disposeAudio();
        }
        this.initAudio();
        if (this.playing) {
          this.audioControl.play();
        }
      }
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_input_field_le_input_field__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__le_select_le_select__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_consts__ = __webpack_require__(6);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var SUPPORTED_LANGUAGES = { da: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["da"], de: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["de"], en: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["en"], es: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["es"], fr: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["fr"], it: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["it"], pt: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["ptBR"], ro: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["ro"], fi: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["fi"], tr: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["tr"], ru: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["ru"], zh: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["zh"], ja: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["ja"], ko: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["ko"], vi: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["vi"], id: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["id"] };

var MINUTES_IN_HALF_HOUR = 30;

var doSemanticClick = function doSemanticClick(e) {
  if (e && (e.key === 'Enter' || e.key === ' ')) {
    if (e.target) {
      e.target.click();
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-datepicker',
  data: function data() {
    return {
      selectedDate: {},
      selectedTime: {},
      nowItem: { id: '-1', value: this.nowOptionText },
      uniqueId: Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniqueId"])('vue-datepicker-'),
      existingDays: []
    };
  },

  props: {
    id: {
      type: String
    },
    dateLabel: {
      type: String,
      default: ''
    },
    timeLabel: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      validator: function validator(type) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["indexOf"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["values"])(__WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].LE_DATE_CONSTS.TYPE), type) > -1;
      },
      default: __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].LE_DATE_CONSTS.TYPE.DATE_AND_TIME_PICKER
    },
    placeholder: {
      type: String,
      default: 'MM/DD/YYYY'
    },
    theme: {
      type: String,
      default: ''
    },
    dateFromOutside: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    isNowTimeSelectedFromOutside: {
      type: Boolean
    },
    includeNow: {
      type: Boolean,
      default: false
    },
    nowOptionText: {
      type: String,
      default: 'Now'
    },
    inline: {
      type: Boolean
    },
    format: {
      type: String
    },
    disabled: {
      type: Object
    },
    disabledInput: {
      type: Boolean,
      default: false
    },
    highlighted: {
      type: Object
    },
    minimumView: {
      type: String
    },
    maximumView: {
      type: String,
      default: 'day'
    },
    nextMonthAriaLabel: {
      type: String,
      default: 'Next Month'
    },
    prevMonthAriaLabel: {
      type: String,
      default: 'Previous Month'
    }
  },
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    leInputField: __WEBPACK_IMPORTED_MODULE_4__le_input_field_le_input_field__["a" /* default */],
    leSelect: __WEBPACK_IMPORTED_MODULE_5__le_select_le_select__["a" /* default */]
  },
  mounted: function mounted() {
    this.setArrowsEventListeners();
  },

  computed: {
    isDateInputField: function isDateInputField() {
      return this.type === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].LE_DATE_CONSTS.TYPE.DATE_INPUT_FIELD;
    },
    isDateAndTimePicker: function isDateAndTimePicker() {
      return this.type === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].LE_DATE_CONSTS.TYPE.DATE_AND_TIME_PICKER;
    },
    isFutureTimeSelected: function isFutureTimeSelected() {
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var diff = 30 * (Math.floor(now.minute() / 30) + 1);
      var secondsBeforeHalfHour = __WEBPACK_IMPORTED_MODULE_3_moment___default()(now).startOf('hour').add(diff, 'minutes').add(-1, 'seconds');
      return this.calculatedDate.isAfter(secondsBeforeHalfHour);
    },
    calculatedDate: function calculatedDate() {
      if (this.selectedTime.id === '-1') {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      var selectedTimeInMinutes = MINUTES_IN_HALF_HOUR * (this.selectedTime.id - 1);
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.selectedDate).add(selectedTimeInMinutes, 'minutes');
    },
    dateToDisplay: function dateToDisplay() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.calculatedDate).format('DD MMM YYYY');
    },
    dateTimeItems: function dateTimeItems() {
      return Array(48).fill(0).map(function (_, i) {
        return {
          id: '' + (i + 1),
          value: __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(0).hour(i / 2).minute(i % 2 * MINUTES_IN_HALF_HOUR).format('h:mm a')
        };
      });
    },
    timeFrameItems: function timeFrameItems() {
      if (this.includeNow) {
        return [this.nowItem].concat(_toConsumableArray(this.dateTimeItems));
      }
      return this.dateTimeItems;
    },
    wrapperClass: function wrapperClass() {
      var wrapper = '';
      if (this.isDateAndTimePicker) {
        wrapper = 'date-and-time-picker';
      } else if (this.isDateInputField) {
        wrapper = 'date-input-field';
        if (this.disabledInput) {
          wrapper += ' disabled-input';
        }
      }
      return wrapper;
    },
    getDateLabel: function getDateLabel() {
      return this.dateLabel.split(' ').join('-');
    },
    getTimeLabel: function getTimeLabel() {
      return this.timeLabel.split(' ').join('-');
    },
    getDateId: function getDateId() {
      return this.uniqueId + '-' + this.getDateLabel;
    },
    getTimeId: function getTimeId() {
      return this.uniqueId + '-' + this.getTimeLabel;
    },
    languageChosen: function languageChosen() {
      var locale = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale() || 'en';
      var localeKey = locale.slice(0, 2);
      return SUPPORTED_LANGUAGES[localeKey];
    }
  },
  methods: {
    onDateSelected: function onDateSelected(date) {
      this.updateAccessibilityAttributes();
      if (this.isDateAndTimePicker) {
        this.onDateAndTimeSelected(date);
      } else if (this.isDateInputField) {
        this.onDateInputFieldSelected(date);
      }
    },
    onDateInputFieldSelected: function onDateInputFieldSelected(date) {
      var _this = this;

      this.selectedDate = !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNull"])(date) ? new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).startOf('day')).getTime() : null;

      var isIllegalRange = this.disabled && Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.disabled.ranges, function (range) {
        return _this.selectedDate > range.from && _this.selectedDate < range.to;
      });
      if (isIllegalRange) {
        this.selectedDate = null;
      }

      var selectedDate = !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNull"])(this.selectedDate) ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.selectedDate).valueOf() : null;
      this.$emit('selected', selectedDate);
    },
    onDateAndTimeSelected: function onDateAndTimeSelected(date) {
      this.selectedDate = new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).startOf('day')).getTime();
      var diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(this.selectedDate, 'days');
      if (this.selectedTime.id === '-1' && diff !== 0) {
        this.selectedTime = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["last"])(this.dateTimeItems);
      }
      this.$emit('selected', this.calculatedDate.valueOf());
      this.$emit('nowSelected', this.selectedTime.id === '-1' || this.isFutureTimeSelected);
    },
    onTimeSelected: function onTimeSelected(time) {
      if (time.id === '-1') {
        this.selectedDate = new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day')).getTime();
      }
      this.$emit('selected', this.calculatedDate.valueOf());
      this.$emit('nowSelected', time.id === '-1' || this.isFutureTimeSelected);
    },
    timeFromTimestamp: function timeFromTimestamp(date) {
      var idKey = void 0;
      var hour = 2 * date.getHours();
      if (date.getMinutes() < 30) {
        idKey = hour + 1;
      } else if (date.getMinutes() >= 30) {
        idKey = hour + 2;
      }
      var timeFrameObj = this.dateTimeItems.find(function (obj) {
        return obj.id === idKey.toString();
      });
      return timeFrameObj;
    },
    updateAccessibilityAttributes: function updateAccessibilityAttributes() {
      var _this2 = this;

      this.setDaysEventListeners();
      this.$nextTick(function () {
        var monthYear = _this2.$el.querySelector('.day__month_btn');
        var weekdays = _this2.$el.querySelectorAll('.day-header');
        var days = _this2.$el.querySelectorAll('.day');
        if (days.length > 0) {
          days.forEach(function (day, index) {
            day.setAttribute('tabindex', '0');
            day.setAttribute('role', 'button');
            if (day.classList.contains('selected')) {
              day.setAttribute('aria-pressed', 'true');
            } else {
              day.setAttribute('aria-pressed', 'false');
            }
            if (day.classList.contains('today')) {
              day.setAttribute('aria-current', 'date');
            } else {
              day.removeAttribute('aria-current');
            }
            if (day.classList.contains('blank') || day.classList.contains('disabled')) {
              day.setAttribute('disabled', true);
              day.setAttribute('aria-disabled', true);
              day.removeAttribute('tabindex');
            } else {
              day.removeAttribute('disabled');
              day.removeAttribute('aria-disabled');
            }
            if (monthYear && weekdays.length > 0) {
              var highlightedLabel = '';
              if (day.classList.contains('highlighted')) {
                highlightedLabel = ' in range';
              }
              day.setAttribute('aria-label', weekdays[index % 7].textContent + ' ' + day.textContent + ' ' + monthYear.textContent + highlightedLabel);
            }
          });
        }
        var prevArrow = _this2.$el.querySelector('.prev');
        var nextArrow = _this2.$el.querySelector('.next');
        if (prevArrow && nextArrow) {
          prevArrow.setAttribute('role', 'button');
          prevArrow.setAttribute('aria-label', _this2.prevMonthAriaLabel);
          prevArrow.setAttribute('tabindex', '0');
          if (prevArrow.classList.contains('blank') || prevArrow.classList.contains('disabled')) {
            prevArrow.setAttribute('disabled', true);
            prevArrow.setAttribute('aria-disabled', true);
            prevArrow.removeAttribute('tabindex');
          } else {
            prevArrow.removeAttribute('disabled');
            prevArrow.removeAttribute('aria-disabled');
          }
          nextArrow.setAttribute('role', 'button');
          nextArrow.setAttribute('aria-label', _this2.nextMonthAriaLabel);
          nextArrow.setAttribute('tabindex', '0');
          if (nextArrow.classList.contains('blank') || nextArrow.classList.contains('disabled')) {
            nextArrow.setAttribute('disabled', true);
            nextArrow.setAttribute('aria-disabled', true);
            nextArrow.removeAttribute('tabindex');
          } else {
            nextArrow.removeAttribute('disabled');
            nextArrow.removeAttribute('aria-disabled');
          }
        }
      });
    },
    setDaysEventListeners: function setDaysEventListeners() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.existingDays.forEach(function (day) {
          if (day.removeEventListener) {
            day.removeEventListener('keydown', doSemanticClick);
          }
        });
        _this3.existingDays = [];
        var days = _this3.$el.querySelectorAll('.day');
        days.forEach(function (day) {
          if (day.addEventListener) {
            _this3.existingDays.push(day);
            day.addEventListener('keydown', doSemanticClick);
          }
        });
      });
    },
    setArrowsEventListeners: function setArrowsEventListeners() {
      var _this4 = this;

      this.$nextTick(function () {
        var prevArrow = _this4.$el.querySelector('.prev');
        var nextArrow = _this4.$el.querySelector('.next');
        if (prevArrow && nextArrow) {
          prevArrow.addEventListener('keydown', doSemanticClick);
          nextArrow.addEventListener('keydown', doSemanticClick);
        }
      });
    }
  },

  watch: {
    dateFromOutside: {
      handler: function handler() {
        this.selectedDate = !Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNull"])(this.dateFromOutside) ? new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateFromOutside).startOf('day')).getTime() : null;
        if (this.isDateAndTimePicker) {
          var diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(this.dateFromOutside, 'seconds');
          this.selectedTime = diff <= 1 && this.includeNow || this.isNowTimeSelectedFromOutside ? this.nowItem : this.timeFromTimestamp(this.dateFromOutside);
        }
        this.updateAccessibilityAttributes();
      },

      immediate: true
    },
    isNowTimeSelectedFromOutside: {
      handler: function handler() {
        this.selectedDate = new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.dateFromOutside).startOf('day')).getTime();
        var diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(this.dateFromOutside, 'seconds');
        this.selectedTime = diff <= 1 && this.includeNow || this.isNowTimeSelectedFromOutside ? this.nowItem : this.timeFromTimestamp(this.dateFromOutside);
        this.updateAccessibilityAttributes();
      }
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__ = __webpack_require__(15);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-textarea',
  components: {
    leBubble: __WEBPACK_IMPORTED_MODULE_0__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    enabled: {
      type: Boolean,
      default: true
    },
    errorPlacement: {
      type: String,
      default: 'right'
    },
    maxChars: {
      type: Number,
      default: 99999
    },
    inputPaddingLeft: {
      type: Number
    },
    inputPaddingRight: {
      type: Number
    },
    rows: {
      type: Number,
      default: 3
    },
    resizable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showError: false,
      errorMsg: '',
      bubbleErrorMsg: ''
    };
  },

  computed: {
    classes: function classes() {
      return ['input-textarea', { 'has-error': this.hasError }, { disabled: !this.enabled }, { resizable: this.resizable }];
    },
    hasError: function hasError() {
      return this.errorMsg.length > 0;
    },
    inputPaddingStyle: function inputPaddingStyle() {
      var style = {};
      if (this.inputPaddingLeft) {
        style['padding-left'] = (this.inputPaddingLeft || '0') + 'px';
      }
      if (this.inputPaddingRight) {
        style['padding-right'] = (this.inputPaddingRight || '0') + 'px';
      }
      return style === {} ? '' : style;
    }
  },
  methods: {
    onInput: function onInput() {
      this.$emit('input', this.$refs.textarea.value);
    },
    onKeyUp: function onKeyUp() {
      this.showError = false;
    },
    onFocus: function onFocus() {
      this.$emit('focus');
      this.showError = this.hasError;
      this.bubbleErrorMsg = this.errorMsg;
    },
    onBlur: function onBlur() {
      this.$emit('blur');
      this.showError = false;
    },
    blur: function blur() {
      this.$refs.textarea.blur();
    },
    focus: function focus() {
      this.$refs.textarea.focus();
    },
    setError: function setError(showError, errorMsg) {
      if (showError) {
        this.errorMsg = errorMsg;
      } else {
        this.showError = false;
        this.errorMsg = '';
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_input_field_le_input_field__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_button_le_button__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_bubble_le_bubble__ = __webpack_require__(15);








var URL_REGEXP = new RegExp('^\\s*' + __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].URL_REGEXP + '$', 'i');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-link-editor',
  components: {
    leInputField: __WEBPACK_IMPORTED_MODULE_2__le_input_field_le_input_field__["a" /* default */],
    leButton: __WEBPACK_IMPORTED_MODULE_3__le_button_le_button__["a" /* default */],
    leBubble: __WEBPACK_IMPORTED_MODULE_4__le_bubble_le_bubble__["a" /* default */]
  },
  props: {
    tooltipLabel: {
      type: String,
      required: true
    },
    confirmLabel: {
      type: String,
      required: true
    },
    cancelLabel: {
      type: String,
      required: true
    },
    titleLabel: {
      type: String
    },
    hrefLabel: {
      type: String
    },
    titlePlaceholder: {
      type: String,
      required: true
    },
    hrefPlaceholder: {
      type: String,
      required: true
    },
    noURLErrorText: {
      type: String,
      required: true
    },
    badURLFormatErrorText: {
      type: String,
      required: true
    },
    quill: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: 'theme-dark'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      CONSTS: __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */],
      title: '',
      href: '',
      node: null,
      cursorIndex: undefined,
      linkEditorParams: undefined,
      linkEditorOpen: false
    };
  },

  methods: {
    onCancel: function onCancel() {
      this.linkEditorOpen = false;
      this.setLinkEditorParams();
      this.$refs.hrefInput.clearError();
    },
    onConfirm: function onConfirm() {
      var trimmedHref = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(this.href);
      var isInputValid = this.validateInput(trimmedHref);

      if (isInputValid) {
        this.linkEditorOpen = false;
        this.$refs.hrefInput.clearError();

        var title = this.title || trimmedHref;
        var href = trimmedHref;

        if (this.node) {
          this.editNode(title, href);
        } else {
          var selection = this.quill.getSelection(true);
          if (selection && selection.length > 0) {
            this.transformSelectionToLink(selection, title, href);
          } else {
            this.addNewLink(title, href);
          }
        }
        this.setLinkEditorParams();
      }
    },
    addNewLink: function addNewLink(title, href) {
      var cursorIndex = this.cursorIndex || this.getCursorIndex(true);
      this.quill.insertText(cursorIndex, title, __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK, [href]);
    },
    transformSelectionToLink: function transformSelectionToLink(selection, title, href) {
      this.quill.deleteText(selection.index, selection.length);
      this.quill.insertText(selection.index, title);
      this.quill.formatText(selection.index, title.length, __WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK, [href]);
    },
    editNode: function editNode(title, href) {
      this.node.setAttribute('href', href);
      this.node.innerText = title;
    },
    validateInput: function validateInput(trimmedHref) {
      var error = '';
      var res = true;

      if (!trimmedHref) {
        error = this.noURLErrorText;
      } else if (!this.validateUrl(trimmedHref)) {
        error = this.badURLFormatErrorText;
      }

      if (error) {
        this.$refs.hrefInput.setError(true, error);
        res = false;
      }
      return res;
    },
    editLink: function editLink(evt) {
      if (evt && evt.target && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(evt.target.classList, 'le-quill-link')) {
        var node = evt.target;
        this.setLinkEditorParams({
          title: node.innerText,
          href: node.getAttribute('href'),
          node: node
        });
        this.linkEditorOpen = true;
      }
    },
    openLinkEditor: function openLinkEditor() {
      if (this.isDisabled) return;

      var cursorIndex = this.getCursorIndex(true);
      var leafs = this.quill.getLeaf(cursorIndex);
      var leaf = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(leafs, '[0]');
      var node = this.getLeQuillLinkNode(leaf);

      if (node) {
        this.setLinkEditorParams({
          title: node.innerText,
          href: node.getAttribute('href'),
          node: node
        });
      } else {
        var selection = this.quill.getSelection(true);
        if (selection && selection.length > 0) {
          this.setLinkEditorParams({
            title: this.quill.getText(selection.index, selection.length),
            cursorIndex: cursorIndex
          });
        } else {
          this.setLinkEditorParams({
            cursorIndex: cursorIndex
          });
        }
      }
      this.linkEditorOpen = true;
      this.$refs.titleInput.setFocus();
    },
    getLeQuillLinkNode: function getLeQuillLinkNode(leaf) {
      var maxTreeDepth = 50;
      var currentTreeDepth = 0;

      var currentBlot = leaf;
      var node = void 0;
      if (currentBlot) {
        do {
          currentTreeDepth += 1;
          var currentBlotName = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(currentBlot, 'statics.blotName');
          if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"])(currentBlotName) === Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"])(__WEBPACK_IMPORTED_MODULE_1__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK)) {
            node = currentBlot.domNode;
          }
          currentBlot = currentBlot.parent;
        } while (!node && currentBlot.parent && currentTreeDepth < maxTreeDepth);
      }
      return node;
    },
    getCursorIndex: function getCursorIndex() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var cursorIndex = 0;
      var selection = this.quill.getSelection(focus);
      if (selection) {
        cursorIndex = selection.length ? selection.index : selection.index + selection.length;
      }
      return cursorIndex;
    },
    setLinkEditorParams: function setLinkEditorParams(params) {
      if (!params) {
        this.title = '';
        this.href = '';
        this.node = null;
        this.cursorIndex = undefined;
      } else {
        this.title = params.title;
        this.href = params.href;
        this.node = params.node;
        this.cursorIndex = params.cursorIndex;
      }
    },
    onBubbleHide: function onBubbleHide() {
      this.linkEditorOpen = false;
      this.$refs.hrefInput.clearError();
    },
    validateUrl: function validateUrl(url) {
      return URL_REGEXP.test(url);
    }
  },
  watch: {
    quill: function quill(val) {
      if (val) {
        this.quill.container.addEventListener('dblclick', this.editLink);
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-notifier',
  props: {
    closeIconSize: {
      type: Number,
      default: 8
    },
    maxWidth: {
      type: String,
      default: '400px'
    },
    minWidth: {
      type: String,
      default: '216px'
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    contentLabel: {
      type: String
    },
    closeIconLabel: {
      type: String,
      default: 'Close'
    },
    variant: {
      type: String,
      default: __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_NOTIFIER.VARIANTS.DEFAULT
    },
    timer: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      showNotifier: true
    };
  },

  computed: {
    isSuccess: function isSuccess() {
      return this.variant === __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_NOTIFIER.VARIANTS.SUCCESS;
    },
    isError: function isError() {
      return this.variant === __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_NOTIFIER.VARIANTS.ERROR;
    }
  },
  methods: {
    onCloseClick: function onCloseClick() {
      if (this.isSuccess || this.isError) {
        this.showNotifier = false;
      }
      this.$emit('closeClicked');
    }
  },
  created: function created() {
    var _this = this;

    if (this.timer) {
      setTimeout(function () {
        _this.showNotifier = false;
        _this.$emit('close');
      }, this.timer);
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_tags_le_tags__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_tree_item__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_clickOutsideDirective__ = __webpack_require__(36);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ITEM_ACTIONS = {
  SELECT: 'select',
  UNSELECT: 'unselect'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-treeview',
  components: {
    leTags: __WEBPACK_IMPORTED_MODULE_1__le_tags_le_tags__["a" /* default */],
    leTreeItem: __WEBPACK_IMPORTED_MODULE_2__le_tree_item__["a" /* default */]
  },
  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_3__directives_clickOutsideDirective__["a" /* default */]
  },
  props: {
    theme: {
      type: String,
      default: ''
    },
    treeviewData: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Select <value>'
    },
    itemIdAttr: {
      type: String,
      default: 'id'
    },
    itemParentIdAttr: {
      type: String,
      default: 'parentId'
    },
    itemValueAttr: {
      type: String,
      default: 'value'
    },
    itemChildrenAttr: {
      type: String,
      default: 'children'
    },
    enabled: {
      type: Boolean,
      default: true
    },
    tagsMaxHeight: {
      type: String
    },
    tagsShowVerticalScrollbar: {
      type: Boolean
    },
    treeWidth: {
      type: String,
      default: 'auto'
    },
    itemMinHeight: {
      type: Number,
      default: 32
    },
    listMinWidth: {
      type: String,
      default: '100px'
    },
    maxItemsToShow: {
      type: Number,
      default: 10
    },
    useAllItemsSelectedTag: {
      type: Boolean,
      default: true
    },
    allItemsSelectedTagCaption: {
      type: String,
      default: 'All'
    },
    numberOfCharactersStartSearch: {
      type: Number,
      default: 3
    },
    searchNoMatchErrorMessage: {
      type: String,
      default: 'No items match.'
    },
    hasArtificialRoot: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      searchTerm: '',
      isListOpen: false,
      rootId: null,
      treeFlatData: [],
      hashTree: {},
      searchResults: {},
      itemIdToFocus: null,
      allItemsCount: null
    };
  },

  computed: {
    selectedItems: function selectedItems() {
      return Array.isArray(this.value) ? this.value : [];
    },
    selectedItemsTags: function selectedItemsTags() {
      var _this = this;

      var selectedItems = this.selectedItems;
      if (this.useAllItemsSelectedTag && selectedItems.length === this.allItemsCount) {
        var _ref;

        return [(_ref = {}, _defineProperty(_ref, this.itemIdAttr, this.rootId), _defineProperty(_ref, this.itemValueAttr, this.allItemsSelectedTagCaption), _ref)];
      }

      var validTags = this.hasArtificialRoot ? Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(selectedItems, function (item) {
        return item[_this.itemIdAttr] !== _this.rootId;
      }) : selectedItems;
      return validTags;
    },
    selectedItemsIds: function selectedItemsIds() {
      var _this2 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.selectedItems, function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, _this2.itemIdAttr);
      });
    },
    listHeightLimit: function listHeightLimit() {
      return this.maxItemsToShow * this.itemMinHeight;
    },
    itemsToShow: function itemsToShow() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(this.searchResults, this.itemIdAttr);
    }
  },
  watch: {
    treeviewData: {
      handler: function handler() {
        this.initTreeviewData();
      },

      immediate: true,
      deep: true
    }
  },
  methods: {
    initTreeviewData: function initTreeviewData() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.treeviewData)) {
        this.resetSearchResults();
        this.rootId = this.treeviewData[this.itemIdAttr];
        this.treeFlatData = this.flattenTree();
        this.hashTree = this.hashTreeData();
        this.allItemsCount = this.treeFlatData.length;
      }
    },
    resetSearchResults: function resetSearchResults() {
      this.searchResults = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.treeviewData);
      this.assignDefaultShowChildren(this.searchResults);
      this.searchResults.showChildren = true;
      this.itemIdToFocus = this.rootId;
    },
    removeItems: function removeItems(items) {
      var _this3 = this;

      var itemsToRemove = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(items) ? items : [items];
      var selectedItems = [].concat(_toConsumableArray(this.selectedItems));
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["remove"])(selectedItems, function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(itemsToRemove, function (it) {
          return it[_this3.itemIdAttr] === item[_this3.itemIdAttr];
        });
      });
      return selectedItems;
    },
    addItems: function addItems(items) {
      var _this4 = this;

      var selectedIds = new Set(this.selectedItems.map(function (item) {
        return item[_this4.itemIdAttr];
      }));
      var itemsToAdd = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(items) ? items : [items];
      var selectedItems = [].concat(_toConsumableArray(this.selectedItems), _toConsumableArray(itemsToAdd.filter(function (item) {
        return !selectedIds.has(item[_this4.itemIdAttr]);
      })));
      return selectedItems;
    },
    actionOnTree: function actionOnTree(action, params) {
      var _this5 = this;

      var selectedItems = void 0;
      var actionMethod = action === ITEM_ACTIONS.SELECT ? this.addItems : this.removeItems;
      var isRootItem = params.item[this.itemIdAttr] === this.rootId;
      if (params.isIndependentSelection) {
        selectedItems = actionMethod(params.item);
      } else if (isRootItem) {
        selectedItems = action === ITEM_ACTIONS.SELECT ? this.flattenTree() : [];
        this.resetSearchResults();
      } else {
        var allDescendents = this.getItemAndAllDescendents(params.item, []);
        selectedItems = actionMethod(allDescendents);
      }
      this.emitChanges(selectedItems);
      this.$nextTick(function () {
        _this5.$refs.tagsInput.scrollToBottom();
      });
    },
    showList: function showList() {
      var _this6 = this;

      this.$emit('listIsOpen', true);
      if (this.isListOpen) {
        return;
      }
      this.isListOpen = true;
      if (this.searchTerm.length < this.numberOfCharactersStartSearch) {
        this.resetSearchResults();
      }
      this.$nextTick(function () {
        _this6.$refs.tagsInput.focus();
      });
    },
    hideList: function hideList() {
      this.$emit('listIsOpen', false);
      if (!this.isListOpen) {
        return;
      }
      this.isListOpen = false;
      this.$refs.tagsInput.blur();
    },
    getItemAndAllDescendents: function getItemAndAllDescendents(item, itemList) {
      var _itemList$push,
          _this7 = this;

      itemList.push((_itemList$push = {}, _defineProperty(_itemList$push, this.itemIdAttr, item[this.itemIdAttr]), _defineProperty(_itemList$push, this.itemParentIdAttr, item[this.itemParentIdAttr]), _defineProperty(_itemList$push, this.itemValueAttr, item[this.itemValueAttr]), _itemList$push));
      if (!item[this.itemChildrenAttr]) {
        return itemList;
      }
      item[this.itemChildrenAttr].forEach(function (child) {
        _this7.getItemAndAllDescendents(child, itemList);
      });
      return itemList;
    },
    applyShowChildrenForTargetItemId: function applyShowChildrenForTargetItemId(id) {
      var _this8 = this;

      if (id !== this.rootId) {
        var item = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.hashTree, id);

        var firstLevelItemAndPathIds = this.getFirstLevelItemAndPathIds(item);
        var pathIds = firstLevelItemAndPathIds.pathIds;
        var rootItem = this.searchResults;
        var currentItem = null;
        pathIds.reverse().forEach(function (itemId) {
          if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNull"])(currentItem)) {
            currentItem = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(rootItem[_this8.itemChildrenAttr], function (it) {
              return it[_this8.itemIdAttr] === itemId;
            });
          } else if (currentItem) {
            currentItem = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(currentItem[_this8.itemChildrenAttr], function (it) {
              return it[_this8.itemIdAttr] === itemId;
            });
          }
          if (currentItem) {
            currentItem.showChildren = true;
          }
        });
      }
    },
    assignDefaultShowChildren: function assignDefaultShowChildren(item) {
      var _this9 = this;

      item.showChildren = false;
      item[this.itemChildrenAttr].forEach(function (it) {
        return _this9.assignDefaultShowChildren(it);
      });
    },
    getFirstLevelItem: function getFirstLevelItem(id) {
      var _this10 = this;

      var result = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(this.treeviewData[this.itemChildrenAttr], function (item) {
        return item[_this10.itemIdAttr] === id;
      });
      return result;
    },
    getFirstLevelItemAndPathIds: function getFirstLevelItemAndPathIds(item) {
      var pathIds = [item[this.itemIdAttr]];
      var parentId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, this.itemParentIdAttr);
      if (parentId === this.rootId) {
        return { firstLevelItem: item, pathIds: pathIds };
      }
      var parentData = void 0;

      var iterationNumber = 0;
      var maxIterations = 50;
      while (parentId !== this.rootId && iterationNumber <= maxIterations) {
        parentData = this.hashTree[parentId];
        pathIds.push(parentData[this.itemIdAttr]);
        parentId = parentData[this.itemParentIdAttr];
        iterationNumber += 1;
      }
      var firstLevelItem = this.getFirstLevelItem(parentData[this.itemIdAttr]);
      return { firstLevelItem: firstLevelItem, pathIds: pathIds };
    },
    getFirstLevelParentItemAndExpandPath: function getFirstLevelParentItemAndExpandPath(id) {
      var _this11 = this;

      var item = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.hashTree, id);
      var firstLevelItem = void 0;
      var parentId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, this.itemParentIdAttr);
      if (!parentId) {
        return null;
      } else if (parentId === this.rootId) {
        firstLevelItem = this.getFirstLevelItem(item[this.itemIdAttr]);
        if (firstLevelItem[this.itemChildrenAttr].length > 0) {
          firstLevelItem.showChildren = true;
        }
        return firstLevelItem;
      }

      var firstLevelItemAndPathIds = this.getFirstLevelItemAndPathIds(item);
      firstLevelItem = firstLevelItemAndPathIds.firstLevelItem;
      var pathIds = firstLevelItemAndPathIds.pathIds;
      var children = void 0;
      pathIds.reverse().forEach(function (itemId) {
        if (!children) {
          firstLevelItem.showChildren = true;
          children = firstLevelItem[_this11.itemChildrenAttr];
        } else {
          var it = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(children, function (child) {
            return child[_this11.itemIdAttr] === itemId;
          });
          if (it[_this11.itemChildrenAttr].length > 0) {
            it.showChildren = true;
          }
          children = it[_this11.itemChildrenAttr];
        }
      });
      return firstLevelItem;
    },
    flattenTree: function flattenTree() {
      return this.getItemAndAllDescendents(this.treeviewData, []);
    },
    hashTreeData: function hashTreeData() {
      var _this12 = this;

      var hash = {};
      this.treeFlatData.forEach(function (item) {
        var _hash$item$_this12$it;

        hash[item[_this12.itemIdAttr]] = (_hash$item$_this12$it = {}, _defineProperty(_hash$item$_this12$it, _this12.itemIdAttr, item[_this12.itemIdAttr]), _defineProperty(_hash$item$_this12$it, _this12.itemValueAttr, item[_this12.itemValueAttr]), _defineProperty(_hash$item$_this12$it, _this12.itemParentIdAttr, item[_this12.itemParentIdAttr]), _defineProperty(_hash$item$_this12$it, _this12.itemChildrenAttr, []), _hash$item$_this12$it);
      });
      return hash;
    },
    resetSearchTerm: function resetSearchTerm() {
      this.searchTerm = '';
      this.resetSearchResults();
    },
    onSearchInputChange: function onSearchInputChange(searchTerm) {
      var _this13 = this;

      if (searchTerm.length >= this.numberOfCharactersStartSearch) {
        var matchedItems = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(this.treeFlatData, function (item) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(item[_this13.itemValueAttr].toLowerCase().trim(), searchTerm.toLowerCase().trim());
        });
        if (matchedItems.length === 0) {
          this.searchResults = {};
        } else {
          var _searchResults;

          var matchItemsDirectParentIds = new Set();
          var rootChildren = [];

          matchedItems.forEach(function (item) {
            if (!matchItemsDirectParentIds.has(item[_this13.itemParentIdAttr]) || item[_this13.itemParentIdAttr] === _this13.rootId) {
              var firstLevelItem = _this13.getFirstLevelParentItemAndExpandPath(item[_this13.itemIdAttr]);
              if (firstLevelItem) {
                var childExists = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["find"])(rootChildren, function (child) {
                  return child[_this13.itemIdAttr] === firstLevelItem[_this13.itemIdAttr];
                });
                if (!childExists) {
                  rootChildren.push(firstLevelItem);
                }
                matchItemsDirectParentIds.add(item[_this13.itemParentIdAttr]);
              }
            }
          });

          this.searchResults = (_searchResults = {}, _defineProperty(_searchResults, this.itemIdAttr, this.rootId), _defineProperty(_searchResults, this.itemValueAttr, this.treeviewData[this.itemValueAttr]), _defineProperty(_searchResults, this.itemChildrenAttr, rootChildren), _searchResults);

          this.itemIdToFocus = matchedItems[0][this.itemIdAttr];
        }
      } else if (this.searchTerm.length >= this.numberOfCharactersStartSearch) {
        this.resetSearchResults();
      }
      this.searchTerm = searchTerm;
    },
    emitChanges: function emitChanges(selectedItems) {
      this.$emit('input', selectedItems);
      this.$emit('allItemsSelectedCheck', selectedItems.length === this.allItemsCount);
    },
    removeItemsAndEmitChanges: function removeItemsAndEmitChanges(item) {
      var selectedItems = void 0;
      if (item[this.itemValueAttr] === this.allItemsSelectedTagCaption && item[this.itemIdAttr] === this.rootId) {
        selectedItems = [];
      } else {
        selectedItems = this.removeItems(item);
      }
      this.emitChanges(selectedItems);
    },
    onUnselectTagsItem: function onUnselectTagsItem(item) {
      var _this14 = this;

      requestAnimationFrame(function () {
        _this14.removeItemsAndEmitChanges(item);
      });
    },
    onSelectTagsItem: function onSelectTagsItem(item) {
      var _this15 = this;

      requestAnimationFrame(function () {
        var id = item[_this15.itemIdAttr];
        _this15.searchResults.showChildren = true;
        _this15.applyShowChildrenForTargetItemId(id);

        _this15.searchResults = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(_this15.searchResults);
        _this15.itemIdToFocus = id;
      });
    },
    onInputFocus: function onInputFocus() {
      this.showList();
    },
    onListFocus: function onListFocus() {
      this.showList();
    },
    onClickOutside: function onClickOutside() {
      if (this.searchTerm.length >= this.numberOfCharactersStartSearch && Object.keys(this.searchResults).length === 0) {
        this.$refs.tagsInput.setError(true, this.searchNoMatchErrorMessage);
      } else {
        this.$refs.tagsInput.setError(false, '');
      }
      this.hideList();
    },
    onTreeItemValueChanged: function onTreeItemValueChanged(params) {
      if (!params.checked) {
        this.actionOnTree(ITEM_ACTIONS.UNSELECT, params);
      } else {
        this.actionOnTree(ITEM_ACTIONS.SELECT, params);
      }
    },
    onScrollToValueChange: function onScrollToValueChange(options) {
      var requiredScrollOffset = 0;
      if (options.id !== this.rootId) {
        var tagsContainerOffset = this.$refs.tagsInput.$refs.tagsContainer.clientHeight;
        var extraScrollOffset = options.offsetTop - tagsContainerOffset;
        requiredScrollOffset = extraScrollOffset >= 0 ? extraScrollOffset : options.offsetTop;
      }
      this.$refs.treeviewList.scrollTop = requiredScrollOffset;
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_checkbox_le_checkbox__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__le_tree_item__ = __webpack_require__(119);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-tree-item',
  components: {
    leCheckbox: __WEBPACK_IMPORTED_MODULE_1__le_checkbox_le_checkbox__["a" /* default */],
    leTextWithHighlight: __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__["a" /* default */],
    leTreeItem: __WEBPACK_IMPORTED_MODULE_3__le_tree_item__["a" /* default */]
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    selectedItemsIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemIdAttr: {
      type: String,
      default: 'id'
    },
    itemChildrenAttr: {
      type: String,
      default: 'children'
    },
    itemValueAttr: {
      type: String,
      default: 'value'
    },
    searchTerm: {
      type: String,
      default: ''
    },
    isRootItem: {
      type: Boolean,
      default: false
    },
    numberOfCharactersStartSearch: {
      required: true,
      type: Number
    },
    itemIdToFocus: {
      type: [Number, String],
      default: null
    },

    isArtificialItem: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showChildren: false
    };
  },

  computed: {
    isParent: function isParent() {
      var childrenNode = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.item, this.itemChildrenAttr) || [];
      return childrenNode.length > 0;
    },
    allowIndependentSelection: function allowIndependentSelection() {
      return this.isParent && !this.isArtificialItem;
    },
    arrowDirectionClass: function arrowDirectionClass() {
      if (this.isParent) {
        return this.showChildren ? 'ico-plain-down-arrow' : 'ico-plain-right-arrow';
      }
      return '';
    },
    isItemSelected: function isItemSelected() {
      return this.selectedItemsIds.indexOf(this.item[this.itemIdAttr]) > -1;
    },
    getHighlightText: function getHighlightText() {
      return this.searchTerm.length >= this.numberOfCharactersStartSearch ? this.searchTerm : '';
    }
  },
  methods: {
    toggleShowChildren: function toggleShowChildren() {
      this.showChildren = !this.showChildren;
    },
    emitItemValueChanged: function emitItemValueChanged(params) {
      this.$emit('itemValueChanged', params);
    },
    emitScrollToValue: function emitScrollToValue(value) {
      this.$emit('scrollToValue', value);
    },
    onCheckboxClicked: function onCheckboxClicked(state) {
      this.$emit('itemValueChanged', { item: this.item, isIndependentSelection: false, checked: state });
    },
    onItemTextClicked: function onItemTextClicked() {
      if (this.allowIndependentSelection) {
        if (!this.isItemSelected) {
          this.showChildren = true;
        }
        this.$emit('itemValueChanged', { item: this.item, isIndependentSelection: true, checked: !this.isItemSelected });
      }
    }
  },
  watch: {
    item: {
      handler: function handler() {
        this.showChildren = this.item.showChildren || this.isRootItem;
      },

      immediate: true
    },
    itemIdToFocus: {
      handler: function handler() {
        var _this = this;

        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(this.itemIdToFocus) && this.item[this.itemIdAttr] === this.itemIdToFocus) {
          requestAnimationFrame(function () {
            var offsetTop = _this.$refs.treeItem.offsetTop;
            _this.$emit('scrollToValue', { offsetTop: offsetTop, id: _this.itemIdToFocus });
          });
        }
      },

      immediate: true
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_tree_item__ = __webpack_require__(119);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ITEM_ACTIONS = {
  SELECT: 'select',
  UNSELECT: 'unselect'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-treeview-simple',
  components: {
    leTreeItem: __WEBPACK_IMPORTED_MODULE_1__le_tree_item__["a" /* default */]
  },
  props: {
    theme: {
      type: String,
      default: ''
    },
    treeviewData: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemIdAttr: {
      type: String,
      default: 'id'
    },
    itemParentIdAttr: {
      type: String,
      default: 'parentId'
    },
    itemValueAttr: {
      type: String,
      default: 'value'
    },
    itemChildrenAttr: {
      type: String,
      default: 'children'
    },
    enabled: {
      type: Boolean,
      default: true
    },
    treeWidth: {
      type: String,
      default: 'auto'
    },
    itemMinHeight: {
      type: Number,
      default: 32
    },
    listMinWidth: {
      type: String,
      default: '100px'
    },
    maxItemsToShow: {
      type: Number,
      default: 10
    },
    numberOfCharactersStartSearch: {
      type: Number,
      default: 3
    },
    hasArtificialRoot: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      searchResults: {}
    };
  },
  created: function created() {
    this.initTreeviewData();
    this.searchResults = this.treeviewData;
  },

  computed: {
    selectedItems: function selectedItems() {
      return Array.isArray(this.value) ? this.value : [];
    },
    selectedItemsIds: function selectedItemsIds() {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.selectedItems, function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, _this.itemIdAttr);
      });
    },
    listHeightLimit: function listHeightLimit() {
      return this.maxItemsToShow * this.itemMinHeight;
    }
  },
  methods: {
    initTreeviewData: function initTreeviewData() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.treeviewData)) {
        this.rootId = this.treeviewData[this.itemIdAttr];
        this.treeFlatData = this.flattenTree();
        this.hashTree = this.hashTreeData();
        this.allItemsCount = this.treeFlatData.length;
      }
    },
    flattenTree: function flattenTree() {
      return this.getItemAndAllDescendents(this.treeviewData, []);
    },
    getItemAndAllDescendents: function getItemAndAllDescendents(item, itemList) {
      var _itemList$push,
          _this2 = this;

      itemList.push((_itemList$push = {}, _defineProperty(_itemList$push, this.itemIdAttr, item[this.itemIdAttr]), _defineProperty(_itemList$push, this.itemParentIdAttr, item[this.itemParentIdAttr]), _defineProperty(_itemList$push, this.itemValueAttr, item[this.itemValueAttr]), _itemList$push));
      if (!item[this.itemChildrenAttr]) {
        return itemList;
      }
      item[this.itemChildrenAttr].forEach(function (child) {
        _this2.getItemAndAllDescendents(child, itemList);
      });
      return itemList;
    },
    hashTreeData: function hashTreeData() {
      var _this3 = this;

      var hash = {};
      this.treeFlatData.forEach(function (item) {
        var _hash$item$_this3$ite;

        hash[item[_this3.itemIdAttr]] = (_hash$item$_this3$ite = {}, _defineProperty(_hash$item$_this3$ite, _this3.itemIdAttr, item[_this3.itemIdAttr]), _defineProperty(_hash$item$_this3$ite, _this3.itemValueAttr, item[_this3.itemValueAttr]), _defineProperty(_hash$item$_this3$ite, _this3.itemParentIdAttr, item[_this3.itemParentIdAttr]), _defineProperty(_hash$item$_this3$ite, _this3.itemChildrenAttr, []), _hash$item$_this3$ite);
      });
      return hash;
    },
    onTreeItemValueChanged: function onTreeItemValueChanged(params) {
      if (!params.checked) {
        this.actionOnTree(ITEM_ACTIONS.UNSELECT, params);
      } else {
        this.actionOnTree(ITEM_ACTIONS.SELECT, params);
      }
    },
    actionOnTree: function actionOnTree(action, params) {
      var selectedItems = void 0;
      var actionMethod = action === ITEM_ACTIONS.SELECT ? this.addItems : this.removeItems;
      var isRootItem = params.item[this.itemIdAttr] === this.rootId;
      if (params.isIndependentSelection) {
        selectedItems = actionMethod(params.item);
      } else if (isRootItem) {
        selectedItems = action === ITEM_ACTIONS.SELECT ? this.flattenTree() : [];
      } else {
        var allDescendents = this.getItemAndAllDescendents(params.item, []);
        selectedItems = actionMethod(allDescendents);
      }
      this.emitChanges(selectedItems);
    },
    emitChanges: function emitChanges(selectedItems) {
      this.$emit('input', selectedItems);
      this.$emit('allItemsSelectedCheck', selectedItems.length === this.allItemsCount);
    },
    removeItems: function removeItems(items) {
      var _this4 = this;

      var itemsToRemove = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(items) ? items : [items];
      var selectedItems = [].concat(_toConsumableArray(this.selectedItems));
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["remove"])(selectedItems, function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(itemsToRemove, function (it) {
          return it[_this4.itemIdAttr] === item[_this4.itemIdAttr];
        });
      });
      return selectedItems;
    },
    addItems: function addItems(items) {
      var _this5 = this;

      var selectedIds = new Set(this.selectedItems.map(function (item) {
        return item[_this5.itemIdAttr];
      }));
      var itemsToAdd = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(items) ? items : [items];
      var selectedItems = [].concat(_toConsumableArray(this.selectedItems), _toConsumableArray(itemsToAdd.filter(function (item) {
        return !selectedIds.has(item[_this5.itemIdAttr]);
      })));
      return selectedItems;
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_transcript_message__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters_dateTime__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_LeTranscriptModel__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptTranslationModel__ = __webpack_require__(120);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-transcript',
  components: {
    leTranscriptMessage: __WEBPACK_IMPORTED_MODULE_0__le_transcript_message__["a" /* default */]
  },
  props: {
    transcript: {
      type: __WEBPACK_IMPORTED_MODULE_2__models_LeTranscriptModel__["a" /* default */],
      required: true
    },
    translations: {
      type: Object,
      required: true
    },
    focusedMessageId: {
      type: String,
      default: ''
    },
    showLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messages: function messages() {
      return this.transcript.messages;
    },
    translationsMap: function translationsMap() {
      return new __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptTranslationModel__["a" /* default */](this.translations);
    }
  },
  watch: {
    focusedMessageId: {
      handler: function handler() {
        this.scrollMessageIntoView(this.focusedMessageId);
      },

      immediate: true
    }
  },
  methods: {
    scrollMessageIntoView: function scrollMessageIntoView(messageId) {
      var _this = this;

      this.$nextTick(function () {
        var messageRef = _this.$refs['message-' + messageId];
        if (messageRef) {
          messageRef[0].$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },
    needToShowMetaData: function needToShowMetaData(messageIndex) {
      var showMetaData = true;

      if (messageIndex === this.messages.length - 1) {
        return showMetaData;
      }

      var currentMessage = this.messages[messageIndex];
      var nextMessage = this.messages[messageIndex + 1];

      var currentMessageTimestamp = new Date(currentMessage.time);
      var nextMessageTimestamp = new Date(nextMessage.time);

      var currentMessageOriginator = currentMessage.originator.id;
      var nextMessageOriginator = nextMessage.originator.id;

      if (currentMessageOriginator === nextMessageOriginator && currentMessageTimestamp.getFullYear() === nextMessageTimestamp.getFullYear() && currentMessageTimestamp.getMonth() === nextMessageTimestamp.getMonth() && currentMessageTimestamp.getDate() === nextMessageTimestamp.getDate() && currentMessageTimestamp.getHours() === nextMessageTimestamp.getHours() && currentMessageTimestamp.getMinutes() === nextMessageTimestamp.getMinutes() && currentMessage.audience === nextMessage.audience) {
        showMetaData = false;
      }

      return showMetaData;
    },
    getMessageDate: function getMessageDate(messageObject) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__filters_dateTime__["a" /* default */])(this.transcript.hoursSettings, messageObject.time, { dateOnly: true });
    },
    isDateSeparatorNeeded: function isDateSeparatorNeeded(messageIndex) {
      return messageIndex === 0 || this.isMessageInNewDate(messageIndex);
    },
    isMessageInNewDate: function isMessageInNewDate(messageIndex) {
      var previousMessage = this.messages[messageIndex - 1];
      var currentMessage = this.messages[messageIndex];

      var currentMessageTimestamp = new Date(currentMessage.time);
      var previousMessageTimestamp = new Date(previousMessage.time);

      return currentMessageTimestamp.getFullYear() !== previousMessageTimestamp.getFullYear() || currentMessageTimestamp.getMonth() !== previousMessageTimestamp.getMonth() || currentMessageTimestamp.getDate() !== previousMessageTimestamp.getDate();
    },
    onNotSupportedActionClick: function onNotSupportedActionClick(payload) {
      this.$emit('onNotSupportedActionClick', payload);
    },
    onClickIntentName: function onClickIntentName(intentData) {
      this.$emit('onClickIntentName', intentData);
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_transcript_message_meta__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_pollock_component__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chips_component__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters_dateTime__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_LeTranscriptMessageModel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_LeTranscriptTranslationModel__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(68);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-transcript-message',
  components: {
    leTranscriptMessageMeta: __WEBPACK_IMPORTED_MODULE_4__le_transcript_message_meta__["a" /* default */],
    jsonPollockComponent: __WEBPACK_IMPORTED_MODULE_5__json_pollock_component__["a" /* default */],
    chipsComponent: __WEBPACK_IMPORTED_MODULE_6__chips_component__["a" /* default */]
  },
  props: {
    message: {
      type: __WEBPACK_IMPORTED_MODULE_8__models_LeTranscriptMessageModel__["a" /* default */],
      required: true
    },
    consumerMessageClassName: {
      type: String,
      required: true
    },
    showMetaData: {
      type: Boolean,
      required: true
    },
    translations: {
      type: __WEBPACK_IMPORTED_MODULE_9__models_LeTranscriptTranslationModel__["a" /* default */],
      required: true
    },
    isHighlighted: {
      type: Boolean,
      required: true
    },
    showLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerId: function containerId() {
      return 'le-message-container-' + __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].toHashCode(this.message.id);
    },
    isPrivateMessage: function isPrivateMessage() {
      return this.message.audience === __WEBPACK_IMPORTED_MODULE_3__consts__["c" /* MESSAGE_AUDIENCES */].AGENTS_AND_MANAGERS;
    },
    isTypePlainText: function isTypePlainText() {
      return this.message.type === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].PLAIN_TEXT;
    },
    isTypeSecureFormInvitation: function isTypeSecureFormInvitation() {
      return this.message.type === __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].SECURE_FORM_INVITATION;
    },
    isRichContent: function isRichContent() {
      var richContentTypes = [__WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].IMAGE, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CAROUSEL, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].LIST, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_VERTICAL, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_HORIZONTAL];
      return richContentTypes.includes(this.message.type);
    },
    isQuickReplies: function isQuickReplies() {
      return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.message.quickReplies);
    },
    richContentContainerClass: function richContentContainerClass() {
      switch (this.message.type) {
        case __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CAROUSEL:
          return 'carousel-container';
        case __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].IMAGE:
          return 'image-container';
        case __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].LIST:
          return 'list-container';
        case __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_HORIZONTAL:
        case __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_VERTICAL:
          return 'card-container';
        default:
          return 'unknown-rich-content-container';
      }
    },
    secureFormInvitationMessage: function secureFormInvitationMessage() {
      var secureFormName = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.message.metadata, 'title');
      return this.originatorName + ' ' + this.secureFormInvitationPrefixText + ' ' + secureFormName;
    },
    indicatorTooltipConfiguration: function indicatorTooltipConfiguration() {
      return {
        content: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.translations, 'messageStatusMap[' + this.messageStatus + ']', ''),
        html: false,
        autoHide: false,
        container: '#' + this.containerId
      };
    },
    messageText: function messageText() {
      return this.message.text;
    },
    htmlMessageText: function htmlMessageText() {
      var htmlString = Object(__WEBPACK_IMPORTED_MODULE_2____["markdownToHtml"])(this.messageText);
      return this.isConsumer ? Object(__WEBPACK_IMPORTED_MODULE_10__utils__["d" /* replaceSpecificElement */])(htmlString, 'a', 'span') : htmlString;
    },
    messageTime: function messageTime() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__filters_dateTime__["a" /* default */])(this.hoursSettings, this.message.time, { hourOnly: true });
    },
    messageFullTime: function messageFullTime() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__filters_dateTime__["a" /* default */])(this.hoursSettings, this.message.time, this.fullTimeFormat);
    },
    messageStatus: function messageStatus() {
      return this.message.status;
    },
    originatorRole: function originatorRole() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.message, 'originator.role');
    },
    originatorName: function originatorName() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.message, 'originator.nameForDisplay');
    },
    isConsumer: function isConsumer() {
      return this.originatorRole === __WEBPACK_IMPORTED_MODULE_2____["CONSTS"].ROLES.CONSUMER;
    },
    isControllerBot: function isControllerBot() {
      return this.originatorRole === __WEBPACK_IMPORTED_MODULE_2____["CONSTS"].ROLES.CONTROLLER;
    },
    metaDataParams: function metaDataParams() {
      return {
        isControllerBot: this.isControllerBot,
        originatorName: this.originatorName,
        messageFullTime: this.messageFullTime,
        messageTime: this.messageTime
      };
    },
    notSupportedTypeText: function notSupportedTypeText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.translations, 'messageTypeNotSupported', '').replace('{type}', this.message.type);
    },
    messageNotSupportedActionText: function messageNotSupportedActionText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.translations, 'messageNotSupportedActionText');
    },
    secureFormInvitationPrefixText: function secureFormInvitationPrefixText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.translations, 'secureFormInvitationPrefix');
    },
    intentName: function intentName() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.message, 'intentData.intentName');
    },
    intentData: function intentData() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.message, 'intentData');
    }
  },
  methods: {
    onNotSupportedActionClick: function onNotSupportedActionClick() {
      this.$emit('onNotSupportedActionClick', this.message);
    },
    onClickIntentName: function onClickIntentName() {
      this.$emit('onClickIntentName', this.intentData);
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_LeTranscriptTranslationModel__ = __webpack_require__(120);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-meta',
  props: {
    isControllerBot: {
      type: Boolean,
      required: true
    },
    isPrivateMessage: {
      type: Boolean,
      required: true
    },
    originatorName: {
      type: String,
      required: true
    },
    messageFullTime: {
      type: String,
      required: true
    },
    messageTime: {
      type: String,
      required: true
    },
    intentName: {
      type: String,
      required: false
    },
    showLink: {
      type: Boolean,
      default: false
    },
    translations: {
      type: __WEBPACK_IMPORTED_MODULE_0__models_LeTranscriptTranslationModel__["a" /* default */],
      required: true
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_json_pollock_dist_json_pollock_bundle_min__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_json_pollock_dist_json_pollock_bundle_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_json_pollock_dist_json_pollock_bundle_min__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'json-pollock-component',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.updateDom();
  },

  methods: {
    updateDom: function updateDom() {
      try {
        var dom = __WEBPACK_IMPORTED_MODULE_1_json_pollock_dist_json_pollock_bundle_min__["render"](this.content);

        if (dom) {
          Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(dom.querySelectorAll('*'), function (el) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(el.onclick) && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(el.className, 'lp-json-pollock-component-action') && el.tagName !== 'IMG') {
              el.disabled = true;
            }
          });
        }
        this.$refs.jsonPollock.innerText = '';
        this.$refs.jsonPollock.appendChild(dom);
      } catch (e) {
        var div = document.createElement('div');
        var textNode = document.createTextNode(this.$t('aw:myConnections_content_richContent_error'));
        div.appendChild(textNode);
        this.$refs.jsonPollock.appendChild(div);
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__liveperson_chips__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__liveperson_chips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__liveperson_chips__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chips-component',
  props: {
    quickReplies: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.updateDom();
  },

  methods: {
    updateDom: function updateDom() {
      var items = [];
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(this.quickReplies.replies, function (reply) {
        var item = reply;
        item.style = item.style || {};
        if (!item.style['background-color']) {
          item.style['background-color'] = '#ffffff';
        }
        items.push(item);
      });
      var chips = new __WEBPACK_IMPORTED_MODULE_1__liveperson_chips___default.a({
        el: this.$refs.chips,
        items: items,
        rowSize: this.quickReplies.itemsPerRow,
        renderer: __WEBPACK_IMPORTED_MODULE_1__liveperson_chips___default.a.Renderer.StructuredContentButton
      });

      chips.readonly(true);
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_clickOutsideDirective__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_combobox_option__ = __webpack_require__(710);








var EMPTY_INDEX = -1;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-combobox',
  directives: { clickOutside: __WEBPACK_IMPORTED_MODULE_1__directives_clickOutsideDirective__["a" /* default */] },
  components: { leTextWithHighlight: __WEBPACK_IMPORTED_MODULE_2__le_text_with_highlight_le_text_with_highlight__["a" /* default */], leComboboxOption: __WEBPACK_IMPORTED_MODULE_4__le_combobox_option__["a" /* default */] },
  props: {
    initialItem: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    defaultItem: {
      type: Object,
      default: undefined
    },
    theme: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      baseId: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniqueId"])(),
      isOpen: false,
      highlightedIndex: EMPTY_INDEX,
      inputValue: '',
      minSearchCharacters: 2
    };
  },

  computed: {
    inputId: function inputId() {
      return 'le-combobox-input-' + this.baseId;
    },
    menuId: function menuId() {
      return 'le-combobox-menu-' + this.baseId;
    },
    baseMenuItemId: function baseMenuItemId() {
      return 'le-combobox-menu-item-' + this.baseId;
    },
    expandButtonId: function expandButtonId() {
      return 'le-combobox-expand-button-' + this.baseId;
    },
    clearButtonId: function clearButtonId() {
      return 'le-combobox-clear-button-' + this.baseId;
    },
    filteredItems: function filteredItems() {
      var searchTerm = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"])(this.inputValue);
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(this.items, function (item) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"])(item.value), searchTerm);
      });
    },
    ariaExpanded: function ariaExpanded() {
      return this.isOpen ? 'true' : 'false';
    },
    defaultItemIndex: function defaultItemIndex() {
      return this.filteredItems.length;
    },
    itemsNumber: function itemsNumber() {
      return this.defaultItem ? this.filteredItems.length + 1 : this.filteredItems.length;
    },
    isNothingFound: function isNothingFound() {
      return this.filteredItems.length === 0;
    },
    activeDescendant: function activeDescendant() {
      return this.highlightedIndex > EMPTY_INDEX ? this.baseMenuItemId + '-' + this.highlightedIndex : '';
    }
  },
  methods: {
    debounceKeydown: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function (event) {
      if (!this.isOpen && event.key !== __WEBPACK_IMPORTED_MODULE_3__index__["CONSTS"].KEYBOARD_KEYS.ENTER && event.key !== __WEBPACK_IMPORTED_MODULE_3__index__["CONSTS"].KEYBOARD_KEYS.TAB && event.key !== __WEBPACK_IMPORTED_MODULE_3__index__["CONSTS"].KEYBOARD_KEYS.ESCAPE && event.key !== __WEBPACK_IMPORTED_MODULE_3__index__["CONSTS"].KEYBOARD_KEYS.SHIFT && this.inputValue.length > 0) {
        this.onListOpen();
      }
      this.$emit('keyDown', event);
    }, 150),
    onDownKey: function onDownKey() {
      if (!this.filteredItems.length && !this.defaultItem) {
        return;
      }

      if (this.isOpen) {
        this.highlightedIndex = (this.highlightedIndex + 1) % this.itemsNumber;
      } else {
        this.onListOpen();
      }
      this.scrollList();
    },
    onUpKey: function onUpKey() {
      if (!this.filteredItems.length && !this.defaultItem) {
        return;
      }

      if (this.isOpen) {
        this.highlightedIndex = this.highlightedIndex <= 0 ? this.itemsNumber - 1 : this.highlightedIndex - 1 % this.itemsNumber;
      } else {
        this.isOpen = true;
        this.highlightedIndex = this.itemsNumber - 1;
      }
      this.scrollList();
    },
    onEnterKey: function onEnterKey() {
      if (!this.itemsNumber) {
        return;
      }

      if (this.isOpen) {
        var indexToSelect = this.highlightedIndex !== EMPTY_INDEX ? this.highlightedIndex : 0;
        this.onItemClick(indexToSelect);
      }
    },
    onTabKey: function onTabKey() {
      this.onEnterKey();
    },
    onEscKey: function onEscKey() {
      this.handleValueReset(!this.isOpen);
    },
    onFocus: function onFocus() {
      this.onListOpen();
    },
    onClearClick: function onClearClick() {
      if (this.disabled) return;
      this.handleValueReset(true);
    },
    onExpandClick: function onExpandClick() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
    },
    onItemClick: function onItemClick(itemIndex) {
      this.selectedItem = itemIndex === this.defaultItemIndex ? this.defaultItem : this.filteredItems[itemIndex];
      this.inputValue = this.selectedItem.value;
      this.onListClose();
      this.$emit('selected', this.selectedItem);
    },
    onClickOutside: function onClickOutside() {
      if (this.isOpen) {
        this.onListClose();
      }
      this.inputValue = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedItem, 'value', '');
    },
    onItemMouseover: function onItemMouseover(itemIndex) {
      this.highlightedIndex = itemIndex;
    },
    onListOpen: function onListOpen() {
      this.isOpen = true;
      this.highlightedIndex = 0;
    },
    onListClose: function onListClose() {
      this.isOpen = false;
      this.highlightedIndex = EMPTY_INDEX;
    },
    clearSelection: function clearSelection() {
      this.selectedItem = {};
      this.$emit('selected', this.selectedItem);
      this.onListOpen();
      this.$refs.comboboxInput.focus();
    },
    handleValueReset: function handleValueReset() {
      var shouldClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isOpen) {
        this.onListClose();
      }
      if (shouldClear) {
        this.clearSelection();
      }
      this.inputValue = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedItem, 'value', '');
    },
    scrollList: function scrollList() {
      if (this.$refs.comboboxMenu) {
        var itemHeight = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.$refs, 'comboboxMenu.children[0].offsetHeight', 0);
        this.$refs.comboboxMenu.scrollTop = this.highlightedIndex * itemHeight;
      }
    }
  },
  watch: {
    initialItem: {
      handler: function handler() {
        var initialItemValue = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.initialItem, 'value', '');
        var selectedItemValue = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.selectedItem, 'value', '');
        if (initialItemValue !== selectedItemValue) {
          this.selectedItem = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["clone"])(this.initialItem) || {};
          this.inputValue = initialItemValue;
        }
      },

      immediate: true
    },
    isOpen: {
      handler: function handler(isOpenState) {
        this.$emit('toggle', isOpenState);
      }
    }
  },
  created: function created() {
    this.selectedItem = this.initialItem || {};
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_text_with_highlight_le_text_with_highlight__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-combobox-option',
  components: { leTextWithHighlight: __WEBPACK_IMPORTED_MODULE_0__le_text_with_highlight_le_text_with_highlight__["a" /* default */] },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    baseId: {
      type: String,
      required: true
    },
    inputValue: {
      type: String,
      required: true
    },
    highlightedIndex: {
      type: Number,
      required: true
    },
    isDefaultItem: {
      type: Boolean,
      default: false
    },
    minSearchCharacters: {
      type: Number,
      required: true
    }
  },
  computed: {
    highlightRegex: function highlightRegex() {
      return this.inputValue.length >= this.minSearchCharacters ? new RegExp('(' + this.inputValue + ')', 'gim') : '';
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click', this.index);
    },
    onMouseover: function onMouseover() {
      this.$emit('mouseover', this.index);
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__le_stepper_header__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__le_stepper_footer__ = __webpack_require__(722);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-stepper',
  props: {
    name: {
      type: String,
      required: true
    },
    stepperItems: {
      type: Array,
      required: true
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    enableSkip: {
      type: Boolean,
      default: false
    },
    translations: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_1__le_stepper_header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_2__le_stepper_footer__["a" /* default */]
  },
  data: function data() {
    return {
      currentIndex: 0,
      completeIndex: sessionStorage.getItem(this.name + '-stepperCompleteIndex') || 0,
      currentChildIndex: 0,
      completeChildIndex: sessionStorage.getItem(this.name + '-stepperCompleteChildIndex') || 0,
      items: this.processItems(),
      nextLoading: false,
      backLoading: false,
      skipLoading: false
    };
  },

  computed: {
    canGoNext: function canGoNext() {
      return this.isCompleted;
    },
    canSkip: function canSkip() {
      var currentItem = this.items[this.currentIndex];
      if (currentItem && currentItem.isMultiple && currentItem.children) {
        currentItem = this.items[this.currentIndex].children[this.currentChildIndex];
      }
      return currentItem && !!currentItem.canSkip || this.enableSkip;
    }
  },
  methods: {
    processItems: function processItems() {
      var items = void 0;
      if (this.editMode) {
        var filteredItems = [];
        Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(this.stepperItems, function (item) {
          if (item.editable) {
            var children = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["filter"])(item.children, { editable: true });
            var newItem = Object.assign({}, item, { children: children });
            filteredItems.push(newItem);
          }
        });
        items = filteredItems;
      } else {
        items = this.stepperItems;
      }
      this.items = items;
      return items;
    },
    handleNavigation: function handleNavigation(item, index) {
      var childIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (item.isActive || this.completeIndex > index || this.completeIndex === index && this.completeChildIndex >= childIndex) {
        var navItem = item;
        this.currentIndex = index;
        this.currentChildIndex = childIndex;
        if (item.isMultiple && !item.route) {
          navItem = this.items[index].children[childIndex];
        }
        this.$router.push({
          name: navItem.route,
          params: this.params,
          query: this.editMode ? { edit: true } : {}
        });
      }
    },
    next: function next() {
      var currentItem = this.items[this.currentIndex];
      if (currentItem) {
        if (currentItem.isMultiple && currentItem.children) {
          currentItem = this.items[this.currentIndex].children[this.currentChildIndex];
        }
        if (currentItem.asyncSubmit) {
          this.$emit('submitAsync', currentItem.name);
          this.nextLoading = true;
        } else {
          this.goNext();
        }
      }
    },
    skip: function skip() {
      var currentItem = this.items[this.currentIndex];
      if (currentItem.isMultiple && currentItem.children) {
        currentItem = this.items[this.currentIndex].children[this.currentChildIndex];
      }
      if (currentItem.asyncSkip) {
        this.$emit('skipAsync', currentItem.name);
        this.skipLoading = true;
      } else {
        this.goNext();
      }
    },
    goNext: function goNext() {
      var currentItem = this.items[this.currentIndex];
      var nextItem = void 0;

      if (currentItem) {
        if (currentItem.isMultiple && this.currentChildIndex + 1 !== currentItem.children.length) {
          this.currentChildIndex += 1;
          nextItem = currentItem.children[this.currentChildIndex];
        } else {
          this.currentIndex += 1;
          this.currentChildIndex = 0;
          nextItem = this.items[this.currentIndex];
          if (nextItem) {
            nextItem = nextItem.isMultiple ? nextItem.children[this.currentChildIndex] : nextItem;
          }
        }
      }

      if (nextItem && nextItem.route) {
        nextItem.isActive = true;
        this.$router.push({
          name: nextItem.route,
          params: this.params,
          query: this.editMode ? { edit: true } : {}
        });
      } else {
        this.$emit('done');
      }
    },
    back: function back() {
      var currentItem = this.items[this.currentIndex];
      if (currentItem) {
        if (currentItem.isMultiple && currentItem.children) {
          currentItem = this.items[this.currentIndex].children[this.currentChildIndex];
        }
        if (currentItem.asyncBack) {
          this.$emit('backAsync', currentItem.name);
          this.backLoading = true;
        } else {
          this.goBack();
        }
      }
    },
    goBack: function goBack() {
      var currentItem = this.items[this.currentIndex];
      var previousItem = void 0;

      if (currentItem) {
        if (currentItem.isMultiple && currentItem.children && this.currentChildIndex !== 0) {
          this.currentChildIndex -= 1;
          previousItem = currentItem.children[this.currentChildIndex];
        } else {
          this.currentIndex -= 1;
          previousItem = this.items[this.currentIndex];
          if (previousItem) {
            this.currentChildIndex = previousItem.isMultiple ? previousItem.children.length - 1 : 0;
            previousItem = previousItem.isMultiple ? previousItem.children[this.currentChildIndex] : previousItem;
          }
        }
      }
      if (previousItem && previousItem.route) {
        this.$router.push({
          name: previousItem.route,
          params: this.params,
          query: this.editMode ? { edit: true } : {}
        });
      } else {
        this.$emit('cancel');
      }
    },
    setCurrentItem: function setCurrentItem() {
      var _this = this;

      var currentRoute = this.$route.name;
      this.items = this.processItems();
      this.items.some(function (item, i) {
        if (currentRoute === item.route) {
          _this.currentChildIndex = 0;
          _this.completeChildIndex = 0;
          _this.currentIndex = i;
          _this.items[i].isActive = true;
          return true;
        } else if (item.isMultiple && item.children && Array.isArray(item.children)) {
          return item.children.some(function (child, j) {
            if (currentRoute === child.route) {
              _this.currentIndex = i;
              _this.currentChildIndex = j;
              if (_this.completeIndex < i) {
                _this.completeChildIndex = j;
              } else if (_this.completeIndex === i) {
                _this.completeChildIndex = Math.max(_this.completeChildIndex, j);
              }
              _this.items[i].children[j].isActive = true;
              return true;
            }
            return false;
          });
        }
        return false;
      });
      this.completeIndex = Math.max(this.completeIndex, this.currentIndex);
      sessionStorage.setItem(this.name + '-stepperCompleteIndex', this.completeIndex);
      sessionStorage.setItem(this.name + '-stepperCompleteChildIndex', this.completeChildIndex);
    },
    asyncDone: function asyncDone(success) {
      this.nextLoading = false;
      if (success) {
        this.goNext();
      }
    },
    asyncBackDone: function asyncBackDone(success) {
      this.backLoading = false;
      if (success) {
        this.goBack();
      }
    },
    asyncSkipDone: function asyncSkipDone(success) {
      this.skipLoading = false;
      if (success) {
        this.goNext();
      }
    },
    toUpperCase: function toUpperCase(text) {
      if (typeof text === 'string') {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["capitalize"])(text);
      }
      return '';
    },
    iconState: function iconState(index) {
      if (this.currentIndex === index) {
        return 'active';
      } else if (this.completeIndex > index) {
        return 'done';
      }
      return 'inactive';
    }
  },
  watch: {
    $route: function $route() {
      this.setCurrentItem();
    },
    editMode: function editMode() {
      this.setCurrentItem();
    },
    stepperItems: function stepperItems() {
      this.processItems();
    }
  },
  mounted: function mounted() {
    this.setCurrentItem();
  },
  beforeDestroy: function beforeDestroy() {
    sessionStorage.setItem(this.name + '-stepperCompleteIndex', 0);
    sessionStorage.setItem(this.name + '-stepperCompleteChildIndex', 0);
    this.completeIndex = 0;
    this.completeChildIndex = 0;
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'le-stepper-header',
  props: {
    translations: {
      type: Object
    }
  },
  computed: {
    title: function title() {
      return this.translations && this.translations.title;
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__le_button_le_button__ = __webpack_require__(34);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    leButton: __WEBPACK_IMPORTED_MODULE_0__le_button_le_button__["a" /* default */]
  },
  props: {
    canGoNext: {
      type: Boolean,
      default: false
    },
    canSkip: {
      type: Boolean,
      default: false
    },
    nextLoading: {
      type: Boolean,
      default: false
    },
    backLoading: {
      type: Boolean,
      default: false
    },
    skipLoading: {
      type: Boolean,
      default: false
    },
    translations: {
      type: Object,
      required: true
    }
  },

  computed: {
    disableNext: function disableNext() {
      return !this.canGoNext || this.nextLoading || this.skipLoading;
    },
    disableBack: function disableBack() {
      return this.backLoading;
    },
    disableSkip: function disableSkip() {
      return this.nextLoading || this.skipLoading;
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);
var _messageClasses;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var participantRoles = __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].ROLES;
var messageClasses = (_messageClasses = {}, _defineProperty(_messageClasses, participantRoles.CONSUMER, 'consumer'), _defineProperty(_messageClasses, participantRoles.ASSIGNED_AGENT, 'assigned-agent'), _defineProperty(_messageClasses, participantRoles.AGENT, 'agent'), _defineProperty(_messageClasses, participantRoles.MANAGER, 'manager'), _defineProperty(_messageClasses, participantRoles.READER, 'reader'), _defineProperty(_messageClasses, participantRoles.CONTROLLER, 'controller'), _messageClasses);

function getOriginatorClass(role) {
  return messageClasses[role];
}

var LeTranscriptMessageOriginatorModel = function LeTranscriptMessageOriginatorModel(_ref) {
  var id = _ref.id,
      role = _ref.role,
      nameForDisplay = _ref.nameForDisplay;

  _classCallCheck(this, LeTranscriptMessageOriginatorModel);

  this.id = id;
  this.originatorClass = getOriginatorClass(role);
  this.role = role;
  this.nameForDisplay = nameForDisplay;
};

/* harmony default export */ __webpack_exports__["a"] = (LeTranscriptMessageOriginatorModel);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 123,
	"./af.js": 123,
	"./ar": 124,
	"./ar-dz": 125,
	"./ar-dz.js": 125,
	"./ar-kw": 126,
	"./ar-kw.js": 126,
	"./ar-ly": 127,
	"./ar-ly.js": 127,
	"./ar-ma": 128,
	"./ar-ma.js": 128,
	"./ar-sa": 129,
	"./ar-sa.js": 129,
	"./ar-tn": 130,
	"./ar-tn.js": 130,
	"./ar.js": 124,
	"./az": 131,
	"./az.js": 131,
	"./be": 132,
	"./be.js": 132,
	"./bg": 133,
	"./bg.js": 133,
	"./bm": 134,
	"./bm.js": 134,
	"./bn": 135,
	"./bn-bd": 136,
	"./bn-bd.js": 136,
	"./bn.js": 135,
	"./bo": 137,
	"./bo.js": 137,
	"./br": 138,
	"./br.js": 138,
	"./bs": 139,
	"./bs.js": 139,
	"./ca": 140,
	"./ca.js": 140,
	"./cs": 141,
	"./cs.js": 141,
	"./cv": 142,
	"./cv.js": 142,
	"./cy": 143,
	"./cy.js": 143,
	"./da": 144,
	"./da.js": 144,
	"./de": 145,
	"./de-at": 146,
	"./de-at.js": 146,
	"./de-ch": 147,
	"./de-ch.js": 147,
	"./de.js": 145,
	"./dv": 148,
	"./dv.js": 148,
	"./el": 149,
	"./el.js": 149,
	"./en-au": 150,
	"./en-au.js": 150,
	"./en-ca": 151,
	"./en-ca.js": 151,
	"./en-gb": 152,
	"./en-gb.js": 152,
	"./en-ie": 153,
	"./en-ie.js": 153,
	"./en-il": 154,
	"./en-il.js": 154,
	"./en-in": 155,
	"./en-in.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./en-sg": 157,
	"./en-sg.js": 157,
	"./eo": 158,
	"./eo.js": 158,
	"./es": 159,
	"./es-do": 160,
	"./es-do.js": 160,
	"./es-mx": 161,
	"./es-mx.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 159,
	"./et": 163,
	"./et.js": 163,
	"./eu": 164,
	"./eu.js": 164,
	"./fa": 165,
	"./fa.js": 165,
	"./fi": 166,
	"./fi.js": 166,
	"./fil": 167,
	"./fil.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 169,
	"./fr-ca": 170,
	"./fr-ca.js": 170,
	"./fr-ch": 171,
	"./fr-ch.js": 171,
	"./fr.js": 169,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-deva": 176,
	"./gom-deva.js": 176,
	"./gom-latn": 177,
	"./gom-latn.js": 177,
	"./gu": 178,
	"./gu.js": 178,
	"./he": 179,
	"./he.js": 179,
	"./hi": 180,
	"./hi.js": 180,
	"./hr": 181,
	"./hr.js": 181,
	"./hu": 182,
	"./hu.js": 182,
	"./hy-am": 183,
	"./hy-am.js": 183,
	"./id": 184,
	"./id.js": 184,
	"./is": 185,
	"./is.js": 185,
	"./it": 186,
	"./it-ch": 187,
	"./it-ch.js": 187,
	"./it.js": 186,
	"./ja": 188,
	"./ja.js": 188,
	"./jv": 189,
	"./jv.js": 189,
	"./ka": 190,
	"./ka.js": 190,
	"./kk": 191,
	"./kk.js": 191,
	"./km": 192,
	"./km.js": 192,
	"./kn": 193,
	"./kn.js": 193,
	"./ko": 194,
	"./ko.js": 194,
	"./ku": 195,
	"./ku.js": 195,
	"./ky": 196,
	"./ky.js": 196,
	"./lb": 197,
	"./lb.js": 197,
	"./lo": 198,
	"./lo.js": 198,
	"./lt": 199,
	"./lt.js": 199,
	"./lv": 200,
	"./lv.js": 200,
	"./me": 201,
	"./me.js": 201,
	"./mi": 202,
	"./mi.js": 202,
	"./mk": 203,
	"./mk.js": 203,
	"./ml": 204,
	"./ml.js": 204,
	"./mn": 205,
	"./mn.js": 205,
	"./mr": 206,
	"./mr.js": 206,
	"./ms": 207,
	"./ms-my": 208,
	"./ms-my.js": 208,
	"./ms.js": 207,
	"./mt": 209,
	"./mt.js": 209,
	"./my": 210,
	"./my.js": 210,
	"./nb": 211,
	"./nb.js": 211,
	"./ne": 212,
	"./ne.js": 212,
	"./nl": 213,
	"./nl-be": 214,
	"./nl-be.js": 214,
	"./nl.js": 213,
	"./nn": 215,
	"./nn.js": 215,
	"./oc-lnc": 216,
	"./oc-lnc.js": 216,
	"./pa-in": 217,
	"./pa-in.js": 217,
	"./pl": 218,
	"./pl.js": 218,
	"./pt": 219,
	"./pt-br": 220,
	"./pt-br.js": 220,
	"./pt.js": 219,
	"./ro": 221,
	"./ro.js": 221,
	"./ru": 222,
	"./ru.js": 222,
	"./sd": 223,
	"./sd.js": 223,
	"./se": 224,
	"./se.js": 224,
	"./si": 225,
	"./si.js": 225,
	"./sk": 226,
	"./sk.js": 226,
	"./sl": 227,
	"./sl.js": 227,
	"./sq": 228,
	"./sq.js": 228,
	"./sr": 229,
	"./sr-cyrl": 230,
	"./sr-cyrl.js": 230,
	"./sr.js": 229,
	"./ss": 231,
	"./ss.js": 231,
	"./sv": 232,
	"./sv.js": 232,
	"./sw": 233,
	"./sw.js": 233,
	"./ta": 234,
	"./ta.js": 234,
	"./te": 235,
	"./te.js": 235,
	"./tet": 236,
	"./tet.js": 236,
	"./tg": 237,
	"./tg.js": 237,
	"./th": 238,
	"./th.js": 238,
	"./tk": 239,
	"./tk.js": 239,
	"./tl-ph": 240,
	"./tl-ph.js": 240,
	"./tlh": 241,
	"./tlh.js": 241,
	"./tr": 242,
	"./tr.js": 242,
	"./tzl": 243,
	"./tzl.js": 243,
	"./tzm": 244,
	"./tzm-latn": 245,
	"./tzm-latn.js": 245,
	"./tzm.js": 244,
	"./ug-cn": 246,
	"./ug-cn.js": 246,
	"./uk": 247,
	"./uk.js": 247,
	"./ur": 248,
	"./ur.js": 248,
	"./uz": 249,
	"./uz-latn": 250,
	"./uz-latn.js": 250,
	"./uz.js": 249,
	"./vi": 251,
	"./vi.js": 251,
	"./x-pseudo": 252,
	"./x-pseudo.js": 252,
	"./yo": 253,
	"./yo.js": 253,
	"./zh-cn": 254,
	"./zh-cn.js": 254,
	"./zh-hk": 255,
	"./zh-hk.js": 255,
	"./zh-mo": 256,
	"./zh-mo.js": 256,
	"./zh-tw": 257,
	"./zh-tw.js": 257
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export VClosePopover */
/* unused harmony export VPopover */
/* unused harmony export VTooltip */
/* unused harmony export createTooltip */
/* unused harmony export destroyTooltip */
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resize__ = __webpack_require__(405);



function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */

function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */

function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip =
/*#__PURE__*/
function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    _defineProperty(this, "_events", []);

    _defineProperty(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    });

    // apply user options over default ones
    _options = _objectSpread({}, DEFAULT_OPTIONS, _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */


  _createClass(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (this._classes !== classes) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      // create tooltip element
      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', this.hide);
        tooltipNode.addEventListener('click', this.hide);
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this2 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        _this2.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this3._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this3.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this3.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this3._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this3._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this3._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this4 = this;

      // don't show if it's already visible
      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread({}, options.popperOptions, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this4._isDisposed && _this4.popperInstance) {
          _this4.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this4._isDisposed) {
              _this4._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this4.dispose();
            }
          });
        } else {
          _this4.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this5 = this;

      // don't hide if it's already hidden
      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      this.popperInstance.disableEventListeners();
      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this5._tooltipNode) {
            _this5._tooltipNode.removeEventListener('mouseenter', _this5.hide);

            _this5._tooltipNode.removeEventListener('click', _this5.hide); // Don't remove popper instance, just the HTML element


            _this5._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this6 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this6.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this7 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this7._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this7._scheduleShow(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });

      var keyupHandler = function keyupHandler(evt) {
        if (evt.key === 'Escape') {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this7._scheduleHide(reference, options.delay, options, evt);
        }
      };

      reference.addEventListener('keyup', keyupHandler);

      this._events.push({
        event: 'keyup',
        func: keyupHandler
      }); // schedule hide tooltip


      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this7._scheduleHide(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this8 = this;

      // defaults to 0
      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this8._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this9 = this;

      // defaults to 0
      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this9._isOpen === false) {
          return;
        }

        if (!document.body.contains(_this9._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this9._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this9._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices

if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};
function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = _typeof(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}
function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}
function getContent(value) {
  var type = _typeof(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}
function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread({
    title: content
  }, getOptions(_objectSpread({}, value, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}
function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}
function bind(el, _ref) {
  var value = _ref.value,
      oldValue = _ref.oldValue,
      modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread({}, value, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}
var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var script = {
  name: 'VPopover',
  components: {
    ResizeObserver: __WEBPACK_IMPORTED_MODULE_1_vue_resize__["a" /* ResizeObserver */]
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return _defineProperty({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event,
          _ref2$skipDelay = _ref2.skipDelay,
          _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event,
          _ref3$skipDelay = _ref3.skipDelay;

      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread({}, this.popperOptions, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
          arrow: _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this;

      // Already hidden
      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = _typeof(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  };

  // Delay so that close directive has time to set values
  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.popoverId,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover")], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Popover = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    if (isObject_1(srcValue)) {
      stack || (stack = new _Stack);
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css);

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var finalOptions = {};
  merge_1(finalOptions, defaultOptions, options);
  plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('v-popover', Popover);
}
var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = Popover;
var plugin = {
  install: install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserver; });
function getInternetExplorerVersion() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return -1;
}

var isIE = void 0;

function initCompat() {
	if (!initCompat.init) {
		initCompat.init = true;
		isIE = getInternetExplorerVersion() !== -1;
	}
}

var ResizeObserver = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
	}, staticRenderFns: [], _scopeId: 'data-v-b329ee4c',
	name: 'resize-observer',

	methods: {
		compareAndNotify: function compareAndNotify() {
			if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
				this._w = this.$el.offsetWidth;
				this._h = this.$el.offsetHeight;
				this.$emit('notify');
			}
		},
		addResizeHandlers: function addResizeHandlers() {
			this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);
			this.compareAndNotify();
		},
		removeResizeHandlers: function removeResizeHandlers() {
			if (this._resizeObject && this._resizeObject.onload) {
				if (!isIE && this._resizeObject.contentDocument) {
					this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
				}
				delete this._resizeObject.onload;
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		initCompat();
		this.$nextTick(function () {
			_this._w = _this.$el.offsetWidth;
			_this._h = _this.$el.offsetHeight;
		});
		var object = document.createElement('object');
		this._resizeObject = object;
		object.setAttribute('aria-hidden', 'true');
		object.setAttribute('tabindex', -1);
		object.onload = this.addResizeHandlers;
		object.type = 'text/html';
		if (isIE) {
			this.$el.appendChild(object);
		}
		object.data = 'about:blank';
		if (!isIE) {
			this.$el.appendChild(object);
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.removeResizeHandlers();
	}
};

// Install the components
function install(Vue) {
	Vue.component('resize-observer', ResizeObserver);
	Vue.component('ResizeObserver', ResizeObserver);
}

// Plugin
var plugin = {
	// eslint-disable-next-line no-undef
	version: "0.4.5",
	install: install
};

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(407);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("32c67ac6", content, true, {});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-bubble-target .trigger{width:100%}.le-bubble{outline:none;z-index:1999}.le-bubble .le-bubble-inner{height:100%;max-width:568px;overflow:auto;padding:15px;border-radius:3px;line-height:1.4;font-family:Roboto;border:1px solid}.le-bubble .le-bubble-inner.theme-dark,.theme-dark .le-bubble .le-bubble-inner{color:#666;background-color:#f3f6ff;border-color:#ddd}.le-bubble .le-bubble-inner.theme-light,.theme-light .le-bubble .le-bubble-inner{color:#34363b;background-color:#f3f6ff;border-color:#ddd}.le-bubble .close-icon{position:absolute;top:12px;right:12px;cursor:pointer}.le-bubble .close-icon.theme-dark,.theme-dark .le-bubble .close-icon{color:#666}.le-bubble .close-icon.theme-light,.theme-light .le-bubble .close-icon{color:#494b51}.le-bubble .tooltip-arrow{position:absolute;z-index:1;display:block;width:0;height:0;border:7px solid transparent}.le-bubble .tooltip-arrow:after{content:\"\";position:absolute;display:inline-block;border:7px solid transparent}.le-bubble[x-placement^=top] .wrapper{padding-bottom:7px}.le-bubble[x-placement^=top] .tooltip-arrow{bottom:-7px}.le-bubble[x-placement^=top] .tooltip-arrow:after{bottom:-5.5px;left:-7px}.le-bubble.theme-dark[x-placement^=top] .le-bubble-inner,.theme-dark .le-bubble[x-placement^=top] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-dark[x-placement^=top] .tooltip-arrow,.theme-dark .le-bubble[x-placement^=top] .tooltip-arrow{border-top-color:#ddd}.le-bubble.theme-dark[x-placement^=top] .tooltip-arrow:after,.theme-dark .le-bubble[x-placement^=top] .tooltip-arrow:after{border-top-color:#f3f6ff}.le-bubble.theme-light[x-placement^=top] .le-bubble-inner,.theme-light .le-bubble[x-placement^=top] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-light[x-placement^=top] .tooltip-arrow,.theme-light .le-bubble[x-placement^=top] .tooltip-arrow{border-top-color:#ddd}.le-bubble.theme-light[x-placement^=top] .tooltip-arrow:after,.theme-light .le-bubble[x-placement^=top] .tooltip-arrow:after{border-top-color:#f3f6ff}.le-bubble[x-placement^=bottom] .wrapper{padding-top:7px}.le-bubble[x-placement^=bottom] .tooltip-arrow{top:-7px}.le-bubble[x-placement^=bottom] .tooltip-arrow:after{top:-5.5px;left:-7px}.le-bubble.theme-dark[x-placement^=bottom] .le-bubble-inner,.theme-dark .le-bubble[x-placement^=bottom] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-dark[x-placement^=bottom] .tooltip-arrow,.theme-dark .le-bubble[x-placement^=bottom] .tooltip-arrow{border-bottom-color:#ddd}.le-bubble.theme-dark[x-placement^=bottom] .tooltip-arrow:after,.theme-dark .le-bubble[x-placement^=bottom] .tooltip-arrow:after{border-bottom-color:#f3f6ff}.le-bubble.theme-light[x-placement^=bottom] .le-bubble-inner,.theme-light .le-bubble[x-placement^=bottom] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-light[x-placement^=bottom] .tooltip-arrow,.theme-light .le-bubble[x-placement^=bottom] .tooltip-arrow{border-bottom-color:#ddd}.le-bubble.theme-light[x-placement^=bottom] .tooltip-arrow:after,.theme-light .le-bubble[x-placement^=bottom] .tooltip-arrow:after{border-bottom-color:#f3f6ff}.le-bubble[x-placement^=right] .wrapper{padding-left:7px}.le-bubble[x-placement^=right] .tooltip-arrow{left:-7px}.le-bubble[x-placement^=right] .tooltip-arrow:after{top:-7px;left:-5.5px}.le-bubble.theme-dark[x-placement^=right] .le-bubble-inner,.theme-dark .le-bubble[x-placement^=right] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-dark[x-placement^=right] .tooltip-arrow,.theme-dark .le-bubble[x-placement^=right] .tooltip-arrow{border-right-color:#ddd}.le-bubble.theme-dark[x-placement^=right] .tooltip-arrow:after,.theme-dark .le-bubble[x-placement^=right] .tooltip-arrow:after{border-right-color:#f3f6ff}.le-bubble.theme-light[x-placement^=right] .le-bubble-inner,.theme-light .le-bubble[x-placement^=right] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-light[x-placement^=right] .tooltip-arrow,.theme-light .le-bubble[x-placement^=right] .tooltip-arrow{border-right-color:#ddd}.le-bubble.theme-light[x-placement^=right] .tooltip-arrow:after,.theme-light .le-bubble[x-placement^=right] .tooltip-arrow:after{border-right-color:#f3f6ff}.le-bubble[x-placement^=left] .wrapper{padding-right:7px}.le-bubble[x-placement^=left] .tooltip-arrow{right:-7px}.le-bubble[x-placement^=left] .tooltip-arrow:after{top:-7px;right:-5.5px}.le-bubble.theme-dark[x-placement^=left] .le-bubble-inner,.theme-dark .le-bubble[x-placement^=left] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-dark[x-placement^=left] .tooltip-arrow,.theme-dark .le-bubble[x-placement^=left] .tooltip-arrow{border-left-color:#ddd}.le-bubble.theme-dark[x-placement^=left] .tooltip-arrow:after,.theme-dark .le-bubble[x-placement^=left] .tooltip-arrow:after{border-left-color:#f3f6ff}.le-bubble.theme-light[x-placement^=left] .le-bubble-inner,.theme-light .le-bubble[x-placement^=left] .le-bubble-inner{-webkit-box-shadow:0 2px 2px 1px rgba(0,0,0,.2);box-shadow:0 2px 2px 1px rgba(0,0,0,.2)}.le-bubble.theme-light[x-placement^=left] .tooltip-arrow,.theme-light .le-bubble[x-placement^=left] .tooltip-arrow{border-left-color:#ddd}.le-bubble.theme-light[x-placement^=left] .tooltip-arrow:after,.theme-light .le-bubble[x-placement^=left] .tooltip-arrow:after{border-left-color:#f3f6ff}.le-bubble[aria-hidden]{-webkit-transition:opacity .15s,visibility .15s;transition:opacity .15s,visibility .15s}.le-bubble[aria-hidden=true]{visibility:hidden;opacity:0}.le-bubble[aria-hidden=false]{visibility:visible;opacity:1}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-bubble/le-bubble.vue"],"names":[],"mappings":"AAIA,2BACE,UAAY,CACb,AACD,WAIE,aAAc,AACd,YAAc,CAuDf,AACD,4BACI,YAAa,AACb,gBAAiB,AACjB,cAAe,AAEf,aAAc,AACd,kBAAmB,AACnB,gBAAiB,AACjB,mBAAoB,AACpB,gBAAkB,CACrB,AACD,+EAEM,WAAe,AACf,yBAA0B,AAC1B,iBAAsB,CAC3B,AACD,iFAEM,cAAe,AACf,yBAA0B,AAC1B,iBAAsB,CAC3B,AACD,uBACI,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,cAAgB,CACnB,AACD,qEAEM,UAAe,CACpB,AACD,uEAEM,aAAe,CACpB,AACD,0BACI,kBAAmB,AACnB,UAAW,AACX,cAAe,AACf,QAAS,AACT,SAAU,AACV,4BAA8B,CACjC,AACD,gCACM,WAAY,AACZ,kBAAmB,AACnB,qBAAsB,AACtB,4BAA8B,CACnC,AACD,sCACI,kBAAoB,CACvB,AACD,4CACI,WAAa,CAChB,AACD,kDACM,cAAe,AACf,SAAW,CAChB,AACD,mHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,+GAEI,qBAA0B,CAC7B,AACD,2HAEM,wBAA0B,CAC/B,AACD,qHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,iHAEI,qBAA0B,CAC7B,AACD,6HAEM,wBAA0B,CAC/B,AACD,yCACI,eAAiB,CACpB,AACD,+CACI,QAAU,CACb,AACD,qDACM,WAAY,AACZ,SAAW,CAChB,AACD,yHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,qHAEI,wBAA6B,CAChC,AACD,iIAEM,2BAA6B,CAClC,AACD,2HAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,uHAEI,wBAA6B,CAChC,AACD,mIAEM,2BAA6B,CAClC,AACD,wCACI,gBAAkB,CACrB,AACD,8CACI,SAAW,CACd,AACD,oDACM,SAAU,AACV,WAAa,CAClB,AACD,uHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,mHAEI,uBAA4B,CAC/B,AACD,+HAEM,0BAA4B,CACjC,AACD,yHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,qHAEI,uBAA4B,CAC/B,AACD,iIAEM,0BAA4B,CACjC,AACD,uCACI,iBAAmB,CACtB,AACD,6CACI,UAAY,CACf,AACD,mDACM,SAAU,AACV,YAAc,CACnB,AACD,qHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,iHAEI,sBAA2B,CAC9B,AACD,6HAEM,yBAA2B,CAChC,AACD,uHAEI,gDAAqD,AAC7C,uCAA6C,CACxD,AACD,mHAEI,sBAA2B,CAC9B,AACD,+HAEM,yBAA2B,CAChC,AACD,wBACI,gDAAoD,AACpD,uCAA4C,CAC/C,AACD,6BACI,kBAAmB,AACnB,SAAW,CACd,AACD,8BACI,mBAAoB,AACpB,SAAW,CACd","file":"le-bubble.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-bubble-target .trigger {\n  width: 100%;\n}\n.le-bubble {\n  /* free parameters. play with these to change the bubble properties */\n  /* computed variables. no reason to change those */\n  /* close-icon size is hard coded to be 10 pixels (see the template) */\n  outline: none;\n  z-index: 1999;\n  /*\n  &.dark {\n    .le-bubble-inner {\n      border-color: $color-gray-88;\n      color: $color-gray-dd;\n      background-color: $color-gray-32;\n      box-shadow: 0 2px 3px rgba(50, 51, 53, 0.35);\n    }\n\n    .close-icon {\n      color: $color-gray-dd;\n    }\n\n    &[x-placement^=\"top\"] {\n      .tooltip-arrow {\n        border-top-color: $color-gray-88;\n\n        &:after {\n          border-top-color: $color-gray-32;\n        }\n      }\n    }\n\n    &[x-placement^=\"bottom\"] {\n      .tooltip-arrow {\n        border-bottom-color: $color-gray-88;\n\n        &:after {\n          border-bottom-color: $color-gray-32;\n        }\n      }\n    }\n\n    &[x-placement^=\"right\"] {\n      .tooltip-arrow {\n        border-right-color: $color-gray-88;\n\n        &:after {\n          border-right-color: $color-gray-32;\n        }\n      }\n    }\n\n    &[x-placement^=\"left\"] {\n      .tooltip-arrow {\n        border-left-color: $color-gray-88;\n\n        &:after {\n          border-left-color: $color-gray-32;\n        }\n      }\n    }\n  }\n  */\n}\n.le-bubble .le-bubble-inner {\n    height: 100%;\n    max-width: 568px;\n    overflow: auto;\n    /* serves as clearfix for when floating elements inside the bubble are higher than surrounding text */\n    padding: 15px;\n    border-radius: 3px;\n    line-height: 1.4;\n    font-family: Roboto;\n    border: 1px solid;\n}\n.le-bubble .le-bubble-inner.theme-dark,\n    .theme-dark .le-bubble .le-bubble-inner {\n      color: #666666;\n      background-color: #f3f6ff;\n      border-color: #dddddd;\n}\n.le-bubble .le-bubble-inner.theme-light,\n    .theme-light .le-bubble .le-bubble-inner {\n      color: #34363B;\n      background-color: #f3f6ff;\n      border-color: #dddddd;\n}\n.le-bubble .close-icon {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    cursor: pointer;\n}\n.le-bubble .close-icon.theme-dark,\n    .theme-dark .le-bubble .close-icon {\n      color: #666666;\n}\n.le-bubble .close-icon.theme-light,\n    .theme-light .le-bubble .close-icon {\n      color: #494B51;\n}\n.le-bubble .tooltip-arrow {\n    position: absolute;\n    z-index: 1;\n    display: block;\n    width: 0;\n    height: 0;\n    border: 7px solid transparent;\n}\n.le-bubble .tooltip-arrow:after {\n      content: '';\n      position: absolute;\n      display: inline-block;\n      border: 7px solid transparent;\n}\n.le-bubble[x-placement^=\"top\"] .wrapper {\n    padding-bottom: 7px;\n}\n.le-bubble[x-placement^=\"top\"] .tooltip-arrow {\n    bottom: -7px;\n}\n.le-bubble[x-placement^=\"top\"] .tooltip-arrow:after {\n      bottom: -5.5px;\n      left: -7px;\n}\n.le-bubble.theme-dark[x-placement^=\"top\"] .le-bubble-inner,\n  .theme-dark .le-bubble[x-placement^=\"top\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-dark[x-placement^=\"top\"] .tooltip-arrow,\n  .theme-dark .le-bubble[x-placement^=\"top\"] .tooltip-arrow {\n    border-top-color: #dddddd;\n}\n.le-bubble.theme-dark[x-placement^=\"top\"] .tooltip-arrow:after,\n    .theme-dark .le-bubble[x-placement^=\"top\"] .tooltip-arrow:after {\n      border-top-color: #f3f6ff;\n}\n.le-bubble.theme-light[x-placement^=\"top\"] .le-bubble-inner,\n  .theme-light .le-bubble[x-placement^=\"top\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-light[x-placement^=\"top\"] .tooltip-arrow,\n  .theme-light .le-bubble[x-placement^=\"top\"] .tooltip-arrow {\n    border-top-color: #dddddd;\n}\n.le-bubble.theme-light[x-placement^=\"top\"] .tooltip-arrow:after,\n    .theme-light .le-bubble[x-placement^=\"top\"] .tooltip-arrow:after {\n      border-top-color: #f3f6ff;\n}\n.le-bubble[x-placement^=\"bottom\"] .wrapper {\n    padding-top: 7px;\n}\n.le-bubble[x-placement^=\"bottom\"] .tooltip-arrow {\n    top: -7px;\n}\n.le-bubble[x-placement^=\"bottom\"] .tooltip-arrow:after {\n      top: -5.5px;\n      left: -7px;\n}\n.le-bubble.theme-dark[x-placement^=\"bottom\"] .le-bubble-inner,\n  .theme-dark .le-bubble[x-placement^=\"bottom\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-dark[x-placement^=\"bottom\"] .tooltip-arrow,\n  .theme-dark .le-bubble[x-placement^=\"bottom\"] .tooltip-arrow {\n    border-bottom-color: #dddddd;\n}\n.le-bubble.theme-dark[x-placement^=\"bottom\"] .tooltip-arrow:after,\n    .theme-dark .le-bubble[x-placement^=\"bottom\"] .tooltip-arrow:after {\n      border-bottom-color: #f3f6ff;\n}\n.le-bubble.theme-light[x-placement^=\"bottom\"] .le-bubble-inner,\n  .theme-light .le-bubble[x-placement^=\"bottom\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-light[x-placement^=\"bottom\"] .tooltip-arrow,\n  .theme-light .le-bubble[x-placement^=\"bottom\"] .tooltip-arrow {\n    border-bottom-color: #dddddd;\n}\n.le-bubble.theme-light[x-placement^=\"bottom\"] .tooltip-arrow:after,\n    .theme-light .le-bubble[x-placement^=\"bottom\"] .tooltip-arrow:after {\n      border-bottom-color: #f3f6ff;\n}\n.le-bubble[x-placement^=\"right\"] .wrapper {\n    padding-left: 7px;\n}\n.le-bubble[x-placement^=\"right\"] .tooltip-arrow {\n    left: -7px;\n}\n.le-bubble[x-placement^=\"right\"] .tooltip-arrow:after {\n      top: -7px;\n      left: -5.5px;\n}\n.le-bubble.theme-dark[x-placement^=\"right\"] .le-bubble-inner,\n  .theme-dark .le-bubble[x-placement^=\"right\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-dark[x-placement^=\"right\"] .tooltip-arrow,\n  .theme-dark .le-bubble[x-placement^=\"right\"] .tooltip-arrow {\n    border-right-color: #dddddd;\n}\n.le-bubble.theme-dark[x-placement^=\"right\"] .tooltip-arrow:after,\n    .theme-dark .le-bubble[x-placement^=\"right\"] .tooltip-arrow:after {\n      border-right-color: #f3f6ff;\n}\n.le-bubble.theme-light[x-placement^=\"right\"] .le-bubble-inner,\n  .theme-light .le-bubble[x-placement^=\"right\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-light[x-placement^=\"right\"] .tooltip-arrow,\n  .theme-light .le-bubble[x-placement^=\"right\"] .tooltip-arrow {\n    border-right-color: #dddddd;\n}\n.le-bubble.theme-light[x-placement^=\"right\"] .tooltip-arrow:after,\n    .theme-light .le-bubble[x-placement^=\"right\"] .tooltip-arrow:after {\n      border-right-color: #f3f6ff;\n}\n.le-bubble[x-placement^=\"left\"] .wrapper {\n    padding-right: 7px;\n}\n.le-bubble[x-placement^=\"left\"] .tooltip-arrow {\n    right: -7px;\n}\n.le-bubble[x-placement^=\"left\"] .tooltip-arrow:after {\n      top: -7px;\n      right: -5.5px;\n}\n.le-bubble.theme-dark[x-placement^=\"left\"] .le-bubble-inner,\n  .theme-dark .le-bubble[x-placement^=\"left\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-dark[x-placement^=\"left\"] .tooltip-arrow,\n  .theme-dark .le-bubble[x-placement^=\"left\"] .tooltip-arrow {\n    border-left-color: #dddddd;\n}\n.le-bubble.theme-dark[x-placement^=\"left\"] .tooltip-arrow:after,\n    .theme-dark .le-bubble[x-placement^=\"left\"] .tooltip-arrow:after {\n      border-left-color: #f3f6ff;\n}\n.le-bubble.theme-light[x-placement^=\"left\"] .le-bubble-inner,\n  .theme-light .le-bubble[x-placement^=\"left\"] .le-bubble-inner {\n    -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);\n}\n.le-bubble.theme-light[x-placement^=\"left\"] .tooltip-arrow,\n  .theme-light .le-bubble[x-placement^=\"left\"] .tooltip-arrow {\n    border-left-color: #dddddd;\n}\n.le-bubble.theme-light[x-placement^=\"left\"] .tooltip-arrow:after,\n    .theme-light .le-bubble[x-placement^=\"left\"] .tooltip-arrow:after {\n      border-left-color: #f3f6ff;\n}\n.le-bubble[aria-hidden] {\n    -webkit-transition: opacity 0.15s, visibility 0.15s;\n    transition: opacity 0.15s, visibility 0.15s;\n}\n.le-bubble[aria-hidden=\"true\"] {\n    visibility: hidden;\n    opacity: 0;\n}\n.le-bubble[aria-hidden=\"false\"] {\n    visibility: visible;\n    opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{ref:"bubble",staticClass:"le-bubble-target",attrs:{"popoverBaseClass":['le-bubble', _vm.bubbleBaseClass],"popoverInnerClass":['le-bubble-inner', _vm.bubbleInnerClass],"popoverClass":_vm.theme,"popperOptions":_vm.popperOptions,"offset":_vm.offset,"hideOnTargetClick":_vm.hideOnTargetClick,"placement":_vm.placement,"autoHide":_vm.autoHide,"disabled":!_vm.isEnabled,"trigger":_vm.trigger,"container":_vm.container,"html":_vm.html,"delay":_vm.delay,"open":_vm.open},on:{"show":_vm.onShow,"hide":_vm.onHide},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_c('div',{ref:"popoverContainer",attrs:{"role":"dialog","aria-labelledby":_vm.ariaLabelledBy,"data-test":"bubble_container"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.preventDefault();return _vm.onEsc($event)}]}},[_c('span',{directives:[{name:"close-popover",rawName:"v-close-popover"}],attrs:{"data-test":"bubble_close"}},[(_vm.defaultCloseButton)?_c('i',{ref:"closeButton",staticClass:"close-icon ico-10 ico-close",attrs:{"role":"button","tabindex":"0","aria-label":_vm.closeAriaLabel,"data-test":"bubble_close_icon"},on:{"click":_vm.hide,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.hide($event)}}}):_vm._e(),_vm._v(" "),_vm._t("close",null,{"ariaLabel":_vm.closeAriaLabel})],2),_vm._v(" "),(!_vm.lazy || (_vm.lazy && _vm.hasBeenOpened))?_vm._t("content"):_vm._e()],2)]},proxy:true}],null,true)},[_vm._t("target")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2d3ae495", content, true, {});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".align-items-center[data-v-69839bca]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.le-button[data-v-69839bca]{display:inline-block}.le-button.theme-dark button[data-v-69839bca],.theme-dark .le-button button[data-v-69839bca]{font-family:Roboto;cursor:pointer;outline:none}.le-button.theme-dark button[data-v-69839bca]:disabled,.theme-dark .le-button button[data-v-69839bca]:disabled{cursor:default}.le-button.theme-dark button.variant-default[data-v-69839bca],.theme-dark .le-button button.variant-default[data-v-69839bca]{border-radius:15px;background:transparent;border:1px solid #f1f1f1;color:#fff}.le-button.theme-dark button.variant-default[data-v-69839bca]:hover,.theme-dark .le-button button.variant-default[data-v-69839bca]:hover{border:1px solid #fff;background-color:#535677;color:#f0f0f0}.le-button.theme-dark button.variant-default[data-v-69839bca]:active,.le-button.theme-dark button.variant-default[data-v-69839bca]:focus,.theme-dark .le-button button.variant-default[data-v-69839bca]:active,.theme-dark .le-button button.variant-default[data-v-69839bca]:focus{border:1px solid #c5cad6;color:#e3e3e3}.le-button.theme-dark button.variant-default[data-v-69839bca]:disabled,.le-button.theme-dark button.variant-default[data-v-69839bca]:disabled:hover,.theme-dark .le-button button.variant-default[data-v-69839bca]:disabled,.theme-dark .le-button button.variant-default[data-v-69839bca]:disabled:hover{border:1px solid #666;color:#adadad}.le-button.theme-dark button.variant-primary[data-v-69839bca],.theme-dark .le-button button.variant-primary[data-v-69839bca]{border-radius:15px;background:#fb6500;border:1px solid #fb6500;color:#fff;text-shadow:-1px -1px 0 #db3b00,1px -1px 0 #db3b00,-1px 1px 0 #db3b00,1px 1px 0 #db3b00,1px 1px 5px #db3b00}.le-button.theme-dark button.variant-primary[data-v-69839bca]:hover,.theme-dark .le-button button.variant-primary[data-v-69839bca]:hover{background:#c1570a;border:1px solid #c1570a;color:#fff;text-shadow:none}.le-button.theme-dark button.variant-primary[data-v-69839bca]:active,.le-button.theme-dark button.variant-primary[data-v-69839bca]:focus,.theme-dark .le-button button.variant-primary[data-v-69839bca]:active,.theme-dark .le-button button.variant-primary[data-v-69839bca]:focus{background:#a64401;border:1px solid #a64401;color:#fff;text-shadow:none}.le-button.theme-dark button.variant-primary[data-v-69839bca]:disabled,.le-button.theme-dark button.variant-primary[data-v-69839bca]:disabled:hover,.theme-dark .le-button button.variant-primary[data-v-69839bca]:disabled,.theme-dark .le-button button.variant-primary[data-v-69839bca]:disabled:hover{background:#813418;border:1px solid #813418;color:hsla(0,0%,61%,.5);text-shadow:none}.le-button.theme-dark button.variant-link[data-v-69839bca],.theme-dark .le-button button.variant-link[data-v-69839bca]{background-color:transparent;border:1px solid transparent;border-radius:2px;color:#43c6f4}.le-button.theme-dark button.variant-link[data-v-69839bca]:hover,.theme-dark .le-button button.variant-link[data-v-69839bca]:hover{color:#26bdf2}.le-button.theme-dark button.variant-link[data-v-69839bca]:active,.le-button.theme-dark button.variant-link[data-v-69839bca]:focus,.theme-dark .le-button button.variant-link[data-v-69839bca]:active,.theme-dark .le-button button.variant-link[data-v-69839bca]:focus{color:#0eb6f1}.le-button.theme-dark button.variant-link:active.focus-border[data-v-69839bca],.le-button.theme-dark button.variant-link:focus.focus-border[data-v-69839bca],.theme-dark .le-button button.variant-link:active.focus-border[data-v-69839bca],.theme-dark .le-button button.variant-link:focus.focus-border[data-v-69839bca]{border-color:#43c6f4}.le-button.theme-dark button.variant-link[data-v-69839bca]:disabled,.le-button.theme-dark button.variant-link[data-v-69839bca]:disabled:hover,.theme-dark .le-button button.variant-link[data-v-69839bca]:disabled,.theme-dark .le-button button.variant-link[data-v-69839bca]:disabled:hover{color:#adadad}.le-button.theme-dark button.variant-cancel[data-v-69839bca],.theme-dark .le-button button.variant-cancel[data-v-69839bca]{background-color:transparent;border:1px solid transparent;border-radius:2px;color:#fff}.le-button.theme-dark button.variant-cancel[data-v-69839bca]:hover,.theme-dark .le-button button.variant-cancel[data-v-69839bca]:hover{color:#f0f0f0}.le-button.theme-dark button.variant-cancel[data-v-69839bca]:active,.le-button.theme-dark button.variant-cancel[data-v-69839bca]:focus,.theme-dark .le-button button.variant-cancel[data-v-69839bca]:active,.theme-dark .le-button button.variant-cancel[data-v-69839bca]:focus{color:#e3e3e3}.le-button.theme-dark button.variant-cancel:active.focus-border[data-v-69839bca],.le-button.theme-dark button.variant-cancel:focus.focus-border[data-v-69839bca],.theme-dark .le-button button.variant-cancel:active.focus-border[data-v-69839bca],.theme-dark .le-button button.variant-cancel:focus.focus-border[data-v-69839bca]{border-color:#43c6f4}.le-button.theme-dark button.variant-cancel[data-v-69839bca]:disabled,.le-button.theme-dark button.variant-cancel[data-v-69839bca]:disabled:hover,.theme-dark .le-button button.variant-cancel[data-v-69839bca]:disabled,.theme-dark .le-button button.variant-cancel[data-v-69839bca]:disabled:hover{color:#adadad}.le-button.theme-dark button.size-default[data-v-69839bca],.theme-dark .le-button button.size-default[data-v-69839bca]{padding:6.5px 15px}.le-button.theme-dark button.size-default.variant-cancel[data-v-69839bca],.le-button.theme-dark button.size-default.variant-link[data-v-69839bca],.theme-dark .le-button button.size-default.variant-cancel[data-v-69839bca],.theme-dark .le-button button.size-default.variant-link[data-v-69839bca]{padding:0;margin:6.5px 0}.le-button.theme-dark button.size-default .button-label[data-v-69839bca],.theme-dark .le-button button.size-default .button-label[data-v-69839bca]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:13px}.le-button.theme-dark button.size-default .button-icon[data-v-69839bca],.theme-dark .le-button button.size-default .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-dark button.size-default .button-icon+.button-label[data-v-69839bca],.theme-dark .le-button button.size-default .button-icon+.button-label[data-v-69839bca]{padding-left:2px}.le-button.theme-dark button.size-large[data-v-69839bca],.theme-dark .le-button button.size-large[data-v-69839bca]{padding:6.5px 15px}.le-button.theme-dark button.size-large.variant-cancel[data-v-69839bca],.le-button.theme-dark button.size-large.variant-link[data-v-69839bca],.theme-dark .le-button button.size-large.variant-cancel[data-v-69839bca],.theme-dark .le-button button.size-large.variant-link[data-v-69839bca]{padding:0;margin:6.5px 0}.le-button.theme-dark button.size-large .button-label[data-v-69839bca],.theme-dark .le-button button.size-large .button-label[data-v-69839bca]{font-size:16px}.le-button.theme-dark button.size-large .button-icon[data-v-69839bca],.theme-dark .le-button button.size-large .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-dark button.size-large .button-icon+.button-label[data-v-69839bca],.theme-dark .le-button button.size-large .button-icon+.button-label[data-v-69839bca]{padding-left:4px}.le-button.theme-dark button.size-small[data-v-69839bca],.theme-dark .le-button button.size-small[data-v-69839bca]{padding:4.5px 15px}.le-button.theme-dark button.size-small.variant-cancel[data-v-69839bca],.le-button.theme-dark button.size-small.variant-link[data-v-69839bca],.theme-dark .le-button button.size-small.variant-cancel[data-v-69839bca],.theme-dark .le-button button.size-small.variant-link[data-v-69839bca]{padding:0;margin:4.5px 0}.le-button.theme-dark button.size-small .button-label[data-v-69839bca],.theme-dark .le-button button.size-small .button-label[data-v-69839bca]{font-size:11px}.le-button.theme-dark button.size-small .button-icon[data-v-69839bca],.theme-dark .le-button button.size-small .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-dark button.size-small .button-icon+.button-label[data-v-69839bca],.theme-dark .le-button button.size-small .button-icon+.button-label[data-v-69839bca]{padding-left:4px}.le-button.theme-light button[data-v-69839bca],.theme-light .le-button button[data-v-69839bca]{font-family:Roboto;cursor:pointer;outline:none}.le-button.theme-light button[data-v-69839bca]:disabled,.theme-light .le-button button[data-v-69839bca]:disabled{cursor:default}.le-button.theme-light button.variant-default[data-v-69839bca],.theme-light .le-button button.variant-default[data-v-69839bca]{border-radius:15px;background:transparent;border:1px solid #666;color:#666}.le-button.theme-light button.variant-default[data-v-69839bca]:hover,.theme-light .le-button button.variant-default[data-v-69839bca]:hover{border:1px solid #666;background-color:#ebecef;color:#575757}.le-button.theme-light button.variant-default[data-v-69839bca]:active,.le-button.theme-light button.variant-default[data-v-69839bca]:focus,.theme-light .le-button button.variant-default[data-v-69839bca]:active,.theme-light .le-button button.variant-default[data-v-69839bca]:focus{border:1px solid #c5cad6;color:#4a4a4a}.le-button.theme-light button.variant-default[data-v-69839bca]:disabled,.le-button.theme-light button.variant-default[data-v-69839bca]:disabled:hover,.theme-light .le-button button.variant-default[data-v-69839bca]:disabled,.theme-light .le-button button.variant-default[data-v-69839bca]:disabled:hover{border:1px solid #bbc0c9;color:#c1c1c1}.le-button.theme-light button.variant-primary[data-v-69839bca],.theme-light .le-button button.variant-primary[data-v-69839bca]{border-radius:15px;background:#fb6500;border:1px solid #fb6500;color:#fff;text-shadow:-1px -1px 0 #db3b00,1px -1px 0 #db3b00,-1px 1px 0 #db3b00,1px 1px 0 #db3b00,1px 1px 5px #db3b00}.le-button.theme-light button.variant-primary[data-v-69839bca]:hover,.theme-light .le-button button.variant-primary[data-v-69839bca]:hover{background:#c1570a;border:1px solid #c1570a;color:#fff;text-shadow:none}.le-button.theme-light button.variant-primary[data-v-69839bca]:active,.le-button.theme-light button.variant-primary[data-v-69839bca]:focus,.theme-light .le-button button.variant-primary[data-v-69839bca]:active,.theme-light .le-button button.variant-primary[data-v-69839bca]:focus{background:#a64401;border:1px solid #a64401;color:#fff;text-shadow:none}.le-button.theme-light button.variant-primary[data-v-69839bca]:disabled,.le-button.theme-light button.variant-primary[data-v-69839bca]:disabled:hover,.theme-light .le-button button.variant-primary[data-v-69839bca]:disabled,.theme-light .le-button button.variant-primary[data-v-69839bca]:disabled:hover{background:#e79a7e;border:1px solid #e79a7e;color:rgba(252,252,253,.5);text-shadow:none}.le-button.theme-light button.variant-link[data-v-69839bca],.theme-light .le-button button.variant-link[data-v-69839bca]{background-color:transparent;border:1px solid transparent;border-radius:2px;color:#2e59da}.le-button.theme-light button.variant-link[data-v-69839bca]:hover,.theme-light .le-button button.variant-link[data-v-69839bca]:hover{color:#234cc6}.le-button.theme-light button.variant-link[data-v-69839bca]:active,.le-button.theme-light button.variant-link[data-v-69839bca]:focus,.theme-light .le-button button.variant-link[data-v-69839bca]:active,.theme-light .le-button button.variant-link[data-v-69839bca]:focus{color:#1f44b1}.le-button.theme-light button.variant-link:active.focus-border[data-v-69839bca],.le-button.theme-light button.variant-link:focus.focus-border[data-v-69839bca],.theme-light .le-button button.variant-link:active.focus-border[data-v-69839bca],.theme-light .le-button button.variant-link:focus.focus-border[data-v-69839bca]{border-color:#2e59da}.le-button.theme-light button.variant-link[data-v-69839bca]:disabled,.le-button.theme-light button.variant-link[data-v-69839bca]:disabled:hover,.theme-light .le-button button.variant-link[data-v-69839bca]:disabled,.theme-light .le-button button.variant-link[data-v-69839bca]:disabled:hover{color:#adadad}.le-button.theme-light button.variant-cancel[data-v-69839bca],.theme-light .le-button button.variant-cancel[data-v-69839bca]{background-color:transparent;border:1px solid transparent;border-radius:2px;color:#333}.le-button.theme-light button.variant-cancel[data-v-69839bca]:hover,.theme-light .le-button button.variant-cancel[data-v-69839bca]:hover{color:#242424}.le-button.theme-light button.variant-cancel[data-v-69839bca]:active,.le-button.theme-light button.variant-cancel[data-v-69839bca]:focus,.theme-light .le-button button.variant-cancel[data-v-69839bca]:active,.theme-light .le-button button.variant-cancel[data-v-69839bca]:focus{color:#171717}.le-button.theme-light button.variant-cancel:active.focus-border[data-v-69839bca],.le-button.theme-light button.variant-cancel:focus.focus-border[data-v-69839bca],.theme-light .le-button button.variant-cancel:active.focus-border[data-v-69839bca],.theme-light .le-button button.variant-cancel:focus.focus-border[data-v-69839bca]{border-color:#2e59da}.le-button.theme-light button.variant-cancel[data-v-69839bca]:disabled,.le-button.theme-light button.variant-cancel[data-v-69839bca]:disabled:hover,.theme-light .le-button button.variant-cancel[data-v-69839bca]:disabled,.theme-light .le-button button.variant-cancel[data-v-69839bca]:disabled:hover{color:#adadad}.le-button.theme-light button.size-default[data-v-69839bca],.theme-light .le-button button.size-default[data-v-69839bca]{padding:6.5px 15px}.le-button.theme-light button.size-default.variant-cancel[data-v-69839bca],.le-button.theme-light button.size-default.variant-link[data-v-69839bca],.theme-light .le-button button.size-default.variant-cancel[data-v-69839bca],.theme-light .le-button button.size-default.variant-link[data-v-69839bca]{padding:0;margin:6.5px 0}.le-button.theme-light button.size-default .button-label[data-v-69839bca],.theme-light .le-button button.size-default .button-label[data-v-69839bca]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:13px}.le-button.theme-light button.size-default .button-icon[data-v-69839bca],.theme-light .le-button button.size-default .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-light button.size-default .button-icon+.button-label[data-v-69839bca],.theme-light .le-button button.size-default .button-icon+.button-label[data-v-69839bca]{padding-left:2px}.le-button.theme-light button.size-large[data-v-69839bca],.theme-light .le-button button.size-large[data-v-69839bca]{padding:6.5px 15px}.le-button.theme-light button.size-large.variant-cancel[data-v-69839bca],.le-button.theme-light button.size-large.variant-link[data-v-69839bca],.theme-light .le-button button.size-large.variant-cancel[data-v-69839bca],.theme-light .le-button button.size-large.variant-link[data-v-69839bca]{padding:0;margin:6.5px 0}.le-button.theme-light button.size-large .button-label[data-v-69839bca],.theme-light .le-button button.size-large .button-label[data-v-69839bca]{font-size:16px}.le-button.theme-light button.size-large .button-icon[data-v-69839bca],.theme-light .le-button button.size-large .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-light button.size-large .button-icon+.button-label[data-v-69839bca],.theme-light .le-button button.size-large .button-icon+.button-label[data-v-69839bca]{padding-left:4px}.le-button.theme-light button.size-small[data-v-69839bca],.theme-light .le-button button.size-small[data-v-69839bca]{padding:4.5px 15px}.le-button.theme-light button.size-small.variant-cancel[data-v-69839bca],.le-button.theme-light button.size-small.variant-link[data-v-69839bca],.theme-light .le-button button.size-small.variant-cancel[data-v-69839bca],.theme-light .le-button button.size-small.variant-link[data-v-69839bca]{padding:0;margin:4.5px 0}.le-button.theme-light button.size-small .button-label[data-v-69839bca],.theme-light .le-button button.size-small .button-label[data-v-69839bca]{font-size:11px}.le-button.theme-light button.size-small .button-icon[data-v-69839bca],.theme-light .le-button button.size-small .button-icon[data-v-69839bca]{position:relative;top:1px}.le-button.theme-light button.size-small .button-icon+.button-label[data-v-69839bca],.theme-light .le-button button.size-small .button-icon+.button-label[data-v-69839bca]{padding-left:4px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-button/le-button.vue"],"names":[],"mappings":"AAIA,qCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,4BACE,oBAAsB,CACvB,AACD,6FAEI,mBAAoB,AACpB,eAAgB,AAChB,YAAc,CACjB,AACD,+GAEM,cAAgB,CACrB,AACD,6HAEM,mBAAoB,AACpB,uBAAwB,AACxB,yBAA0B,AAC1B,UAAe,CACpB,AACD,yIAEQ,sBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CACtB,AACD,oRAGQ,yBAA0B,AAC1B,aAAe,CACtB,AAMD,0SAEU,sBAA0B,AAC1B,aAAe,CACxB,AACD,6HAEM,mBAAoB,AACpB,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,2GAAiH,CACtH,AACD,yIAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AACD,oRAGQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AAQD,0SALQ,mBAAoB,AACpB,yBAA0B,AAC1B,wBAAgC,AAChC,gBAAkB,CAQzB,AACD,uHAEM,6BAA8B,AAC9B,6BAA8B,AAC9B,kBAAmB,AACnB,aAAe,CACpB,AACD,mIAEQ,aAAe,CACtB,AACD,wQAGQ,aAAe,CACtB,AACD,4TAGU,oBAAsB,CAC/B,AAKD,8RAEU,aAAe,CACxB,AACD,2HAEM,6BAA8B,AAC9B,6BAA8B,AAC9B,kBAAmB,AACnB,UAAe,CACpB,AACD,uIAEQ,aAAe,CACtB,AACD,gRAGQ,aAAe,CACtB,AACD,oUAGU,oBAAsB,CAC/B,AAKD,sSAEU,aAAe,CACxB,AACD,uHAEM,kBAAoB,CACzB,AACD,sSAGQ,UAAW,AACX,cAAgB,CACvB,AACD,mJAEQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAgB,CACvB,AACD,iJAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,6KAEQ,gBAAkB,CACzB,AACD,mHAEM,kBAAoB,CACzB,AACD,8RAGQ,UAAW,AACX,cAAgB,CACvB,AACD,+IAEQ,cAAgB,CACvB,AACD,6IAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,yKAEQ,gBAAkB,CACzB,AACD,mHAEM,kBAAoB,CACzB,AACD,8RAGQ,UAAW,AACX,cAAgB,CACvB,AACD,+IAEQ,cAAgB,CACvB,AACD,6IAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,yKAEQ,gBAAkB,CACzB,AACD,+FAEI,mBAAoB,AACpB,eAAgB,AAChB,YAAc,CACjB,AACD,iHAEM,cAAgB,CACrB,AACD,+HAEM,mBAAoB,AACpB,uBAAwB,AACxB,sBAA0B,AAC1B,UAAe,CACpB,AACD,2IAEQ,sBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CACtB,AACD,wRAGQ,yBAA0B,AAC1B,aAAe,CACtB,AAMD,8SAEU,yBAA0B,AAC1B,aAAe,CACxB,AACD,+HAEM,mBAAoB,AACpB,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,2GAAiH,CACtH,AACD,2IAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AACD,wRAGQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AAQD,8SALQ,mBAAoB,AACpB,yBAA0B,AAC1B,2BAAgC,AAChC,gBAAkB,CAQzB,AACD,yHAEM,6BAA8B,AAC9B,6BAA8B,AAC9B,kBAAmB,AACnB,aAAe,CACpB,AACD,qIAEQ,aAAe,CACtB,AACD,4QAGQ,aAAe,CACtB,AACD,gUAGU,oBAAsB,CAC/B,AAKD,kSAEU,aAAe,CACxB,AACD,6HAEM,6BAA8B,AAC9B,6BAA8B,AAC9B,kBAAmB,AACnB,UAAe,CACpB,AACD,yIAEQ,aAAe,CACtB,AACD,oRAGQ,aAAe,CACtB,AACD,wUAGU,oBAAsB,CAC/B,AAKD,0SAEU,aAAe,CACxB,AACD,yHAEM,kBAAoB,CACzB,AACD,0SAGQ,UAAW,AACX,cAAgB,CACvB,AACD,qJAEQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAgB,CACvB,AACD,mJAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,+KAEQ,gBAAkB,CACzB,AACD,qHAEM,kBAAoB,CACzB,AACD,kSAGQ,UAAW,AACX,cAAgB,CACvB,AACD,iJAEQ,cAAgB,CACvB,AACD,+IAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,2KAEQ,gBAAkB,CACzB,AACD,qHAEM,kBAAoB,CACzB,AACD,kSAGQ,UAAW,AACX,cAAgB,CACvB,AACD,iJAEQ,cAAgB,CACvB,AACD,+IAEQ,kBAAmB,AACnB,OAAS,CAChB,AACD,2KAEQ,gBAAkB,CACzB","file":"le-button.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.align-items-center[data-v-69839bca] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.le-button[data-v-69839bca] {\n  display: inline-block;\n}\n.le-button.theme-dark button[data-v-69839bca],\n  .theme-dark .le-button button[data-v-69839bca] {\n    font-family: Roboto;\n    cursor: pointer;\n    outline: none;\n}\n.le-button.theme-dark button[data-v-69839bca]:disabled,\n    .theme-dark .le-button button[data-v-69839bca]:disabled {\n      cursor: default;\n}\n.le-button.theme-dark button.variant-default[data-v-69839bca],\n    .theme-dark .le-button button.variant-default[data-v-69839bca] {\n      border-radius: 15px;\n      background: transparent;\n      border: 1px solid #f1f1f1;\n      color: #ffffff;\n}\n.le-button.theme-dark button.variant-default[data-v-69839bca]:hover,\n      .theme-dark .le-button button.variant-default[data-v-69839bca]:hover {\n        border: 1px solid #ffffff;\n        background-color: #535677;\n        color: #f0f0f0;\n}\n.le-button.theme-dark button.variant-default[data-v-69839bca]:active, .le-button.theme-dark button.variant-default[data-v-69839bca]:focus,\n      .theme-dark .le-button button.variant-default[data-v-69839bca]:active,\n      .theme-dark .le-button button.variant-default[data-v-69839bca]:focus {\n        border: 1px solid #c5cad6;\n        color: #e3e3e3;\n}\n.le-button.theme-dark button.variant-default[data-v-69839bca]:disabled,\n      .theme-dark .le-button button.variant-default[data-v-69839bca]:disabled {\n        border: 1px solid #666666;\n        color: #adadad;\n}\n.le-button.theme-dark button.variant-default[data-v-69839bca]:disabled:hover,\n        .theme-dark .le-button button.variant-default[data-v-69839bca]:disabled:hover {\n          border: 1px solid #666666;\n          color: #adadad;\n}\n.le-button.theme-dark button.variant-primary[data-v-69839bca],\n    .theme-dark .le-button button.variant-primary[data-v-69839bca] {\n      border-radius: 15px;\n      background: #fb6500;\n      border: 1px solid #fb6500;\n      color: #ffffff;\n      text-shadow: -1px -1px 0 #db3b00, 1px -1px 0 #db3b00, -1px 1px 0 #db3b00, 1px 1px 0 #db3b00, 1px 1px 5px #db3b00;\n}\n.le-button.theme-dark button.variant-primary[data-v-69839bca]:hover,\n      .theme-dark .le-button button.variant-primary[data-v-69839bca]:hover {\n        background: #C1570A;\n        border: 1px solid #C1570A;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-button.theme-dark button.variant-primary[data-v-69839bca]:active, .le-button.theme-dark button.variant-primary[data-v-69839bca]:focus,\n      .theme-dark .le-button button.variant-primary[data-v-69839bca]:active,\n      .theme-dark .le-button button.variant-primary[data-v-69839bca]:focus {\n        background: #A64401;\n        border: 1px solid #A64401;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-button.theme-dark button.variant-primary[data-v-69839bca]:disabled,\n      .theme-dark .le-button button.variant-primary[data-v-69839bca]:disabled {\n        background: #813418;\n        border: 1px solid #813418;\n        color: rgba(155, 155, 155, 0.5);\n        text-shadow: none;\n}\n.le-button.theme-dark button.variant-primary[data-v-69839bca]:disabled:hover,\n        .theme-dark .le-button button.variant-primary[data-v-69839bca]:disabled:hover {\n          background: #813418;\n          border: 1px solid #813418;\n          color: rgba(155, 155, 155, 0.5);\n          text-shadow: none;\n}\n.le-button.theme-dark button.variant-link[data-v-69839bca],\n    .theme-dark .le-button button.variant-link[data-v-69839bca] {\n      background-color: transparent;\n      border: 1px solid transparent;\n      border-radius: 2px;\n      color: #43c6f4;\n}\n.le-button.theme-dark button.variant-link[data-v-69839bca]:hover,\n      .theme-dark .le-button button.variant-link[data-v-69839bca]:hover {\n        color: #26bdf2;\n}\n.le-button.theme-dark button.variant-link[data-v-69839bca]:active, .le-button.theme-dark button.variant-link[data-v-69839bca]:focus,\n      .theme-dark .le-button button.variant-link[data-v-69839bca]:active,\n      .theme-dark .le-button button.variant-link[data-v-69839bca]:focus {\n        color: #0eb6f1;\n}\n.le-button.theme-dark button.variant-link:active.focus-border[data-v-69839bca], .le-button.theme-dark button.variant-link:focus.focus-border[data-v-69839bca],\n        .theme-dark .le-button button.variant-link:active.focus-border[data-v-69839bca],\n        .theme-dark .le-button button.variant-link:focus.focus-border[data-v-69839bca] {\n          border-color: #43c6f4;\n}\n.le-button.theme-dark button.variant-link[data-v-69839bca]:disabled,\n      .theme-dark .le-button button.variant-link[data-v-69839bca]:disabled {\n        color: #adadad;\n}\n.le-button.theme-dark button.variant-link[data-v-69839bca]:disabled:hover,\n        .theme-dark .le-button button.variant-link[data-v-69839bca]:disabled:hover {\n          color: #adadad;\n}\n.le-button.theme-dark button.variant-cancel[data-v-69839bca],\n    .theme-dark .le-button button.variant-cancel[data-v-69839bca] {\n      background-color: transparent;\n      border: 1px solid transparent;\n      border-radius: 2px;\n      color: #ffffff;\n}\n.le-button.theme-dark button.variant-cancel[data-v-69839bca]:hover,\n      .theme-dark .le-button button.variant-cancel[data-v-69839bca]:hover {\n        color: #f0f0f0;\n}\n.le-button.theme-dark button.variant-cancel[data-v-69839bca]:active, .le-button.theme-dark button.variant-cancel[data-v-69839bca]:focus,\n      .theme-dark .le-button button.variant-cancel[data-v-69839bca]:active,\n      .theme-dark .le-button button.variant-cancel[data-v-69839bca]:focus {\n        color: #e3e3e3;\n}\n.le-button.theme-dark button.variant-cancel:active.focus-border[data-v-69839bca], .le-button.theme-dark button.variant-cancel:focus.focus-border[data-v-69839bca],\n        .theme-dark .le-button button.variant-cancel:active.focus-border[data-v-69839bca],\n        .theme-dark .le-button button.variant-cancel:focus.focus-border[data-v-69839bca] {\n          border-color: #43c6f4;\n}\n.le-button.theme-dark button.variant-cancel[data-v-69839bca]:disabled,\n      .theme-dark .le-button button.variant-cancel[data-v-69839bca]:disabled {\n        color: #adadad;\n}\n.le-button.theme-dark button.variant-cancel[data-v-69839bca]:disabled:hover,\n        .theme-dark .le-button button.variant-cancel[data-v-69839bca]:disabled:hover {\n          color: #adadad;\n}\n.le-button.theme-dark button.size-default[data-v-69839bca],\n    .theme-dark .le-button button.size-default[data-v-69839bca] {\n      padding: 6.5px 15px;\n}\n.le-button.theme-dark button.size-default.variant-cancel[data-v-69839bca], .le-button.theme-dark button.size-default.variant-link[data-v-69839bca],\n      .theme-dark .le-button button.size-default.variant-cancel[data-v-69839bca],\n      .theme-dark .le-button button.size-default.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 6.5px 0;\n}\n.le-button.theme-dark button.size-default .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-default .button-label[data-v-69839bca] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        font-size: 13px;\n}\n.le-button.theme-dark button.size-default .button-icon[data-v-69839bca],\n      .theme-dark .le-button button.size-default .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-dark button.size-default .button-icon + .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-default .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 2px;\n}\n.le-button.theme-dark button.size-large[data-v-69839bca],\n    .theme-dark .le-button button.size-large[data-v-69839bca] {\n      padding: 6.5px 15px;\n}\n.le-button.theme-dark button.size-large.variant-cancel[data-v-69839bca], .le-button.theme-dark button.size-large.variant-link[data-v-69839bca],\n      .theme-dark .le-button button.size-large.variant-cancel[data-v-69839bca],\n      .theme-dark .le-button button.size-large.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 6.5px 0;\n}\n.le-button.theme-dark button.size-large .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-large .button-label[data-v-69839bca] {\n        font-size: 16px;\n}\n.le-button.theme-dark button.size-large .button-icon[data-v-69839bca],\n      .theme-dark .le-button button.size-large .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-dark button.size-large .button-icon + .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-large .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 4px;\n}\n.le-button.theme-dark button.size-small[data-v-69839bca],\n    .theme-dark .le-button button.size-small[data-v-69839bca] {\n      padding: 4.5px 15px;\n}\n.le-button.theme-dark button.size-small.variant-cancel[data-v-69839bca], .le-button.theme-dark button.size-small.variant-link[data-v-69839bca],\n      .theme-dark .le-button button.size-small.variant-cancel[data-v-69839bca],\n      .theme-dark .le-button button.size-small.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 4.5px 0;\n}\n.le-button.theme-dark button.size-small .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-small .button-label[data-v-69839bca] {\n        font-size: 11px;\n}\n.le-button.theme-dark button.size-small .button-icon[data-v-69839bca],\n      .theme-dark .le-button button.size-small .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-dark button.size-small .button-icon + .button-label[data-v-69839bca],\n      .theme-dark .le-button button.size-small .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 4px;\n}\n.le-button.theme-light button[data-v-69839bca],\n  .theme-light .le-button button[data-v-69839bca] {\n    font-family: Roboto;\n    cursor: pointer;\n    outline: none;\n}\n.le-button.theme-light button[data-v-69839bca]:disabled,\n    .theme-light .le-button button[data-v-69839bca]:disabled {\n      cursor: default;\n}\n.le-button.theme-light button.variant-default[data-v-69839bca],\n    .theme-light .le-button button.variant-default[data-v-69839bca] {\n      border-radius: 15px;\n      background: transparent;\n      border: 1px solid #666666;\n      color: #666666;\n}\n.le-button.theme-light button.variant-default[data-v-69839bca]:hover,\n      .theme-light .le-button button.variant-default[data-v-69839bca]:hover {\n        border: 1px solid #666666;\n        background-color: #ebecef;\n        color: #575757;\n}\n.le-button.theme-light button.variant-default[data-v-69839bca]:active, .le-button.theme-light button.variant-default[data-v-69839bca]:focus,\n      .theme-light .le-button button.variant-default[data-v-69839bca]:active,\n      .theme-light .le-button button.variant-default[data-v-69839bca]:focus {\n        border: 1px solid #c5cad6;\n        color: #4a4a4a;\n}\n.le-button.theme-light button.variant-default[data-v-69839bca]:disabled,\n      .theme-light .le-button button.variant-default[data-v-69839bca]:disabled {\n        border: 1px solid #bbc0c9;\n        color: #c1c1c1;\n}\n.le-button.theme-light button.variant-default[data-v-69839bca]:disabled:hover,\n        .theme-light .le-button button.variant-default[data-v-69839bca]:disabled:hover {\n          border: 1px solid #bbc0c9;\n          color: #c1c1c1;\n}\n.le-button.theme-light button.variant-primary[data-v-69839bca],\n    .theme-light .le-button button.variant-primary[data-v-69839bca] {\n      border-radius: 15px;\n      background: #fb6500;\n      border: 1px solid #fb6500;\n      color: #ffffff;\n      text-shadow: -1px -1px 0 #db3b00, 1px -1px 0 #db3b00, -1px 1px 0 #db3b00, 1px 1px 0 #db3b00, 1px 1px 5px #db3b00;\n}\n.le-button.theme-light button.variant-primary[data-v-69839bca]:hover,\n      .theme-light .le-button button.variant-primary[data-v-69839bca]:hover {\n        background: #C1570A;\n        border: 1px solid #C1570A;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-button.theme-light button.variant-primary[data-v-69839bca]:active, .le-button.theme-light button.variant-primary[data-v-69839bca]:focus,\n      .theme-light .le-button button.variant-primary[data-v-69839bca]:active,\n      .theme-light .le-button button.variant-primary[data-v-69839bca]:focus {\n        background: #A64401;\n        border: 1px solid #A64401;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-button.theme-light button.variant-primary[data-v-69839bca]:disabled,\n      .theme-light .le-button button.variant-primary[data-v-69839bca]:disabled {\n        background: #e79a7e;\n        border: 1px solid #e79a7e;\n        color: rgba(252, 252, 253, 0.5);\n        text-shadow: none;\n}\n.le-button.theme-light button.variant-primary[data-v-69839bca]:disabled:hover,\n        .theme-light .le-button button.variant-primary[data-v-69839bca]:disabled:hover {\n          background: #e79a7e;\n          border: 1px solid #e79a7e;\n          color: rgba(252, 252, 253, 0.5);\n          text-shadow: none;\n}\n.le-button.theme-light button.variant-link[data-v-69839bca],\n    .theme-light .le-button button.variant-link[data-v-69839bca] {\n      background-color: transparent;\n      border: 1px solid transparent;\n      border-radius: 2px;\n      color: #2e59da;\n}\n.le-button.theme-light button.variant-link[data-v-69839bca]:hover,\n      .theme-light .le-button button.variant-link[data-v-69839bca]:hover {\n        color: #234cc6;\n}\n.le-button.theme-light button.variant-link[data-v-69839bca]:active, .le-button.theme-light button.variant-link[data-v-69839bca]:focus,\n      .theme-light .le-button button.variant-link[data-v-69839bca]:active,\n      .theme-light .le-button button.variant-link[data-v-69839bca]:focus {\n        color: #1f44b1;\n}\n.le-button.theme-light button.variant-link:active.focus-border[data-v-69839bca], .le-button.theme-light button.variant-link:focus.focus-border[data-v-69839bca],\n        .theme-light .le-button button.variant-link:active.focus-border[data-v-69839bca],\n        .theme-light .le-button button.variant-link:focus.focus-border[data-v-69839bca] {\n          border-color: #2e59da;\n}\n.le-button.theme-light button.variant-link[data-v-69839bca]:disabled,\n      .theme-light .le-button button.variant-link[data-v-69839bca]:disabled {\n        color: #adadad;\n}\n.le-button.theme-light button.variant-link[data-v-69839bca]:disabled:hover,\n        .theme-light .le-button button.variant-link[data-v-69839bca]:disabled:hover {\n          color: #adadad;\n}\n.le-button.theme-light button.variant-cancel[data-v-69839bca],\n    .theme-light .le-button button.variant-cancel[data-v-69839bca] {\n      background-color: transparent;\n      border: 1px solid transparent;\n      border-radius: 2px;\n      color: #333333;\n}\n.le-button.theme-light button.variant-cancel[data-v-69839bca]:hover,\n      .theme-light .le-button button.variant-cancel[data-v-69839bca]:hover {\n        color: #242424;\n}\n.le-button.theme-light button.variant-cancel[data-v-69839bca]:active, .le-button.theme-light button.variant-cancel[data-v-69839bca]:focus,\n      .theme-light .le-button button.variant-cancel[data-v-69839bca]:active,\n      .theme-light .le-button button.variant-cancel[data-v-69839bca]:focus {\n        color: #171717;\n}\n.le-button.theme-light button.variant-cancel:active.focus-border[data-v-69839bca], .le-button.theme-light button.variant-cancel:focus.focus-border[data-v-69839bca],\n        .theme-light .le-button button.variant-cancel:active.focus-border[data-v-69839bca],\n        .theme-light .le-button button.variant-cancel:focus.focus-border[data-v-69839bca] {\n          border-color: #2e59da;\n}\n.le-button.theme-light button.variant-cancel[data-v-69839bca]:disabled,\n      .theme-light .le-button button.variant-cancel[data-v-69839bca]:disabled {\n        color: #adadad;\n}\n.le-button.theme-light button.variant-cancel[data-v-69839bca]:disabled:hover,\n        .theme-light .le-button button.variant-cancel[data-v-69839bca]:disabled:hover {\n          color: #adadad;\n}\n.le-button.theme-light button.size-default[data-v-69839bca],\n    .theme-light .le-button button.size-default[data-v-69839bca] {\n      padding: 6.5px 15px;\n}\n.le-button.theme-light button.size-default.variant-cancel[data-v-69839bca], .le-button.theme-light button.size-default.variant-link[data-v-69839bca],\n      .theme-light .le-button button.size-default.variant-cancel[data-v-69839bca],\n      .theme-light .le-button button.size-default.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 6.5px 0;\n}\n.le-button.theme-light button.size-default .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-default .button-label[data-v-69839bca] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        font-size: 13px;\n}\n.le-button.theme-light button.size-default .button-icon[data-v-69839bca],\n      .theme-light .le-button button.size-default .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-light button.size-default .button-icon + .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-default .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 2px;\n}\n.le-button.theme-light button.size-large[data-v-69839bca],\n    .theme-light .le-button button.size-large[data-v-69839bca] {\n      padding: 6.5px 15px;\n}\n.le-button.theme-light button.size-large.variant-cancel[data-v-69839bca], .le-button.theme-light button.size-large.variant-link[data-v-69839bca],\n      .theme-light .le-button button.size-large.variant-cancel[data-v-69839bca],\n      .theme-light .le-button button.size-large.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 6.5px 0;\n}\n.le-button.theme-light button.size-large .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-large .button-label[data-v-69839bca] {\n        font-size: 16px;\n}\n.le-button.theme-light button.size-large .button-icon[data-v-69839bca],\n      .theme-light .le-button button.size-large .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-light button.size-large .button-icon + .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-large .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 4px;\n}\n.le-button.theme-light button.size-small[data-v-69839bca],\n    .theme-light .le-button button.size-small[data-v-69839bca] {\n      padding: 4.5px 15px;\n}\n.le-button.theme-light button.size-small.variant-cancel[data-v-69839bca], .le-button.theme-light button.size-small.variant-link[data-v-69839bca],\n      .theme-light .le-button button.size-small.variant-cancel[data-v-69839bca],\n      .theme-light .le-button button.size-small.variant-link[data-v-69839bca] {\n        padding: 0;\n        margin: 4.5px 0;\n}\n.le-button.theme-light button.size-small .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-small .button-label[data-v-69839bca] {\n        font-size: 11px;\n}\n.le-button.theme-light button.size-small .button-icon[data-v-69839bca],\n      .theme-light .le-button button.size-small .button-icon[data-v-69839bca] {\n        position: relative;\n        top: 1px;\n}\n.le-button.theme-light button.size-small .button-icon + .button-label[data-v-69839bca],\n      .theme-light .le-button button.size-small .button-icon + .button-label[data-v-69839bca] {\n        padding-left: 4px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"le-button"},[_c('button',{class:[("variant-" + _vm.variant), ("size-" + _vm.size), _vm.focusBorderClass, { 'align-items-center': _vm.hasIcon } ],attrs:{"type":"button","aria-label":_vm.tooltipOptions.content,"disabled":_vm.disabled,"data-test":"button_container"},on:{"click":_vm.onClick,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onClick($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();return _vm.onTab($event)}],"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[(_vm.hasIcon)?_c('i',{class:['button-icon', ("ico-" + _vm.iconSize), _vm.icon],attrs:{"data-test":"button_icon"}}):_vm._e(),_vm._v(" "),(_vm.hasLabel)?_c('span',{staticClass:"button-label",attrs:{"data-test":"button_value"}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("11430f14", content, true, {});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-checkbox[data-v-95497692]{font-family:Roboto;display:inline-block;position:relative;cursor:pointer;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.le-checkbox .indicator[data-v-95497692]{position:relative;top:1px;display:inline-block;height:12px;width:12px;border-radius:3px}.le-checkbox .indicator.theme-dark[data-v-95497692],.theme-dark .le-checkbox .indicator[data-v-95497692]{background-color:rgba(71,74,106,.5);border:1px solid #bbc0c9}.le-checkbox .indicator.theme-light[data-v-95497692],.theme-light .le-checkbox .indicator[data-v-95497692]{background-color:#fcfcfd;border:1px solid #8c8d8f}.le-checkbox .indicator:hover.theme-dark[data-v-95497692],.theme-dark .le-checkbox .indicator[data-v-95497692]:hover{border-color:#2d3162}.le-checkbox .indicator:hover.theme-light[data-v-95497692],.theme-light .le-checkbox .indicator[data-v-95497692]:hover{border-color:#8c8d8f}.le-checkbox .indicator.checked.theme-dark[data-v-95497692],.theme-dark .le-checkbox .indicator.checked[data-v-95497692]{border-color:#5879da}.le-checkbox .indicator.checked.theme-dark[data-v-95497692]:after,.theme-dark .le-checkbox .indicator.checked[data-v-95497692]:after{border:solid #5879da;border-width:0 1px 1px 0}.le-checkbox .indicator.checked.theme-light[data-v-95497692],.theme-light .le-checkbox .indicator.checked[data-v-95497692]{border-color:#4661ae}.le-checkbox .indicator.checked.theme-light[data-v-95497692]:after,.theme-light .le-checkbox .indicator.checked[data-v-95497692]:after{border:solid #4661ae;border-width:0 1px 1px 0}.le-checkbox .indicator.checked[data-v-95497692]:after{content:\"\";position:absolute;left:4px;top:1px;width:3px;height:7px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.le-checkbox .indicator.indeterminate.theme-dark[data-v-95497692],.theme-dark .le-checkbox .indicator.indeterminate[data-v-95497692]{border-color:#5879da}.le-checkbox .indicator.indeterminate.theme-dark[data-v-95497692]:after,.theme-dark .le-checkbox .indicator.indeterminate[data-v-95497692]:after{background-color:#5879da}.le-checkbox .indicator.indeterminate.theme-light[data-v-95497692],.theme-light .le-checkbox .indicator.indeterminate[data-v-95497692]{border-color:#4661ae}.le-checkbox .indicator.indeterminate.theme-light[data-v-95497692]:after,.theme-light .le-checkbox .indicator.indeterminate[data-v-95497692]:after{background-color:#4661ae}.le-checkbox .indicator.indeterminate[data-v-95497692]:after{content:\"\";position:absolute;left:2px;top:2px;width:8px;height:8px}.le-checkbox .label[data-v-95497692]{font-size:13px}.le-checkbox.disabled[data-v-95497692]{cursor:default}.le-checkbox.disabled .indicator.theme-dark[data-v-95497692],.theme-dark .le-checkbox.disabled .indicator[data-v-95497692]{background-color:#474a6a;border:1px solid #474a6a}.le-checkbox.disabled .indicator.theme-dark.checked[data-v-95497692]:after,.theme-dark .le-checkbox.disabled .indicator.checked[data-v-95497692]:after{border-width:0 1px 1px 0;border-color:#bbc0c9}.le-checkbox.disabled .indicator.theme-dark.indeterminate[data-v-95497692]:after,.theme-dark .le-checkbox.disabled .indicator.indeterminate[data-v-95497692]:after{background-color:#bbc0c9}.le-checkbox.disabled .indicator.theme-light[data-v-95497692],.theme-light .le-checkbox.disabled .indicator[data-v-95497692]{background-color:#ebecef;border:1px solid #8c8d8f}.le-checkbox.disabled .indicator.theme-light.checked[data-v-95497692]:after,.theme-light .le-checkbox.disabled .indicator.checked[data-v-95497692]:after{border-width:0 1px 1px 0;border-color:#9b9b9b}.le-checkbox.disabled .indicator.theme-light.indeterminate[data-v-95497692]:after,.theme-light .le-checkbox.disabled .indicator.indeterminate[data-v-95497692]:after{background-color:#9b9b9b}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-checkbox/le-checkbox.vue"],"names":[],"mappings":"AAIA,8BACE,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,yCACI,kBAAmB,AACnB,QAAS,AACT,qBAAsB,AACtB,YAAa,AACb,WAAY,AACZ,iBAAmB,CACtB,AACD,yGAEM,oCAAyC,AACzC,wBAA0B,CAC/B,AACD,2GAEM,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,qHAGM,oBAAsB,CAC3B,AACD,uHAGM,oBAAsB,CAC3B,AACD,yHAEM,oBAAsB,CAC3B,AACD,qIAEQ,qBAAsB,AACtB,wBAA0B,CACjC,AACD,2HAEM,oBAAsB,CAC3B,AACD,uIAEQ,qBAAsB,AACtB,wBAA0B,CACjC,AACD,uDACM,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,UAAW,AACX,WAAY,AACZ,gCAAiC,AACzB,uBAAyB,CACtC,AACD,qIAEM,oBAAsB,CAC3B,AACD,iJAEQ,wBAA0B,CACjC,AACD,uIAEM,oBAAsB,CAC3B,AACD,mJAEQ,wBAA0B,CACjC,AACD,6DACM,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,UAAW,AACX,UAAY,CACjB,AACD,qCACI,cAAgB,CACnB,AACD,uCACI,cAAgB,CACnB,AACD,2HAEM,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,uJAEQ,yBAA0B,AAC1B,oBAAsB,CAC7B,AACD,mKAEQ,wBAA0B,CACjC,AACD,6HAEM,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,yJAEQ,yBAA0B,AAC1B,oBAAsB,CAC7B,AACD,qKAEQ,wBAA0B,CACjC","file":"le-checkbox.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-checkbox[data-v-95497692] {\n  font-family: Roboto;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.le-checkbox .indicator[data-v-95497692] {\n    position: relative;\n    top: 1px;\n    display: inline-block;\n    height: 12px;\n    width: 12px;\n    border-radius: 3px;\n}\n.le-checkbox .indicator.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox .indicator[data-v-95497692] {\n      background-color: rgba(71, 74, 106, 0.5);\n      border: solid #bbc0c9 1px;\n}\n.le-checkbox .indicator.theme-light[data-v-95497692],\n    .theme-light .le-checkbox .indicator[data-v-95497692] {\n      background-color: #fcfcfd;\n      border: solid #8C8D8F 1px;\n}\n.le-checkbox .indicator:hover.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox .indicator[data-v-95497692]:hover, .le-checkbox .indicator:hover.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox .indicator[data-v-95497692]:hover {\n      border-color: #2d3162;\n}\n.le-checkbox .indicator:hover.theme-light[data-v-95497692],\n    .theme-light .le-checkbox .indicator[data-v-95497692]:hover, .le-checkbox .indicator:hover.theme-light[data-v-95497692],\n    .theme-light .le-checkbox .indicator[data-v-95497692]:hover {\n      border-color: #8C8D8F;\n}\n.le-checkbox .indicator.checked.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox .indicator.checked[data-v-95497692] {\n      border-color: #5879da;\n}\n.le-checkbox .indicator.checked.theme-dark[data-v-95497692]:after,\n      .theme-dark .le-checkbox .indicator.checked[data-v-95497692]:after {\n        border: solid #5879da;\n        border-width: 0 1px 1px 0;\n}\n.le-checkbox .indicator.checked.theme-light[data-v-95497692],\n    .theme-light .le-checkbox .indicator.checked[data-v-95497692] {\n      border-color: #4661ae;\n}\n.le-checkbox .indicator.checked.theme-light[data-v-95497692]:after,\n      .theme-light .le-checkbox .indicator.checked[data-v-95497692]:after {\n        border: solid #4661ae;\n        border-width: 0 1px 1px 0;\n}\n.le-checkbox .indicator.checked[data-v-95497692]:after {\n      content: '';\n      position: absolute;\n      left: 4px;\n      top: 1px;\n      width: 3px;\n      height: 7px;\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n.le-checkbox .indicator.indeterminate.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox .indicator.indeterminate[data-v-95497692] {\n      border-color: #5879da;\n}\n.le-checkbox .indicator.indeterminate.theme-dark[data-v-95497692]:after,\n      .theme-dark .le-checkbox .indicator.indeterminate[data-v-95497692]:after {\n        background-color: #5879da;\n}\n.le-checkbox .indicator.indeterminate.theme-light[data-v-95497692],\n    .theme-light .le-checkbox .indicator.indeterminate[data-v-95497692] {\n      border-color: #4661ae;\n}\n.le-checkbox .indicator.indeterminate.theme-light[data-v-95497692]:after,\n      .theme-light .le-checkbox .indicator.indeterminate[data-v-95497692]:after {\n        background-color: #4661ae;\n}\n.le-checkbox .indicator.indeterminate[data-v-95497692]:after {\n      content: '';\n      position: absolute;\n      left: 2px;\n      top: 2px;\n      width: 8px;\n      height: 8px;\n}\n.le-checkbox .label[data-v-95497692] {\n    font-size: 13px;\n}\n.le-checkbox.disabled[data-v-95497692] {\n    cursor: default;\n}\n.le-checkbox.disabled .indicator.theme-dark[data-v-95497692],\n    .theme-dark .le-checkbox.disabled .indicator[data-v-95497692] {\n      background-color: #474a6a;\n      border: solid #474a6a 1px;\n}\n.le-checkbox.disabled .indicator.theme-dark.checked[data-v-95497692]:after,\n      .theme-dark .le-checkbox.disabled .indicator.checked[data-v-95497692]:after {\n        border-width: 0 1px 1px 0;\n        border-color: #bbc0c9;\n}\n.le-checkbox.disabled .indicator.theme-dark.indeterminate[data-v-95497692]:after,\n      .theme-dark .le-checkbox.disabled .indicator.indeterminate[data-v-95497692]:after {\n        background-color: #bbc0c9;\n}\n.le-checkbox.disabled .indicator.theme-light[data-v-95497692],\n    .theme-light .le-checkbox.disabled .indicator[data-v-95497692] {\n      background-color: #ebecef;\n      border: solid #8C8D8F 1px;\n}\n.le-checkbox.disabled .indicator.theme-light.checked[data-v-95497692]:after,\n      .theme-light .le-checkbox.disabled .indicator.checked[data-v-95497692]:after {\n        border-width: 0 1px 1px 0;\n        border-color: #9b9b9b;\n}\n.le-checkbox.disabled .indicator.theme-light.indeterminate[data-v-95497692]:after,\n      .theme-light .le-checkbox.disabled .indicator.indeterminate[data-v-95497692]:after {\n        background-color: #9b9b9b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['le-checkbox', {'disabled': _vm.disabled}],attrs:{"aria-checked":_vm.ariaChecked,"tabindex":_vm.tabIndex,"role":"checkbox","aria-controls":_vm.controls,"aria-disabled":_vm.disabled},on:{"click":_vm.onClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onClick($event)},"focus":_vm.onFocus}},[_c('span',{class:['indicator', {'checked': _vm.checked, 'indeterminate': _vm.indeterminate}],attrs:{"data-test":"checkbox_icon"}}),_vm._v(" "),(_vm.hasLabel)?_c('span',{staticClass:"label",attrs:{"data-test":"checkbox_txt"}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_list_plus_preview_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b79cae8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_list_plus_preview_vue__ = __webpack_require__(419);
function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b79cae8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_list_plus_preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b79cae8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_list_plus_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(418);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3e73f206", content, true, {});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-list-plus-preview[data-v-4b79cae8]{font-family:Roboto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.le-list-plus-preview .displayed-items[data-v-4b79cae8]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:calc(100% - 40px)}.le-list-plus-preview .plus-items[data-v-4b79cae8]{margin-left:8px;padding:3px;line-height:normal;cursor:pointer}.le-list-plus-preview .plus-items.plus-only[data-v-4b79cae8]{margin-left:0}.le-list-plus-preview .plus-items.default-font[data-v-4b79cae8]{font-size:11px}.le-list-plus-preview .plus-items.border[data-v-4b79cae8]{border-radius:1px}.le-list-plus-preview .plus-items.border.theme-dark[data-v-4b79cae8],.theme-dark .le-list-plus-preview .plus-items.border[data-v-4b79cae8]{border:1px solid #bbc0c9}.le-list-plus-preview .plus-items.border.theme-light[data-v-4b79cae8],.theme-light .le-list-plus-preview .plus-items.border[data-v-4b79cae8]{border:1px solid #888}.le-list-plus-preview .plus-items:hover.theme-dark[data-v-4b79cae8],.theme-dark .le-list-plus-preview .plus-items[data-v-4b79cae8]:hover{border:1px solid #ced4de;background:rgba(71,74,106,.5)}.le-list-plus-preview .plus-items:hover.theme-light[data-v-4b79cae8],.theme-light .le-list-plus-preview .plus-items[data-v-4b79cae8]:hover{border:1px solid #666;background:transparent}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-list-plus-preview/le-list-plus-preview.vue"],"names":[],"mappings":"AAIA,uCACE,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,wDACI,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,2BAA6B,CAChC,AACD,mDACI,gBAAiB,AACjB,YAAa,AACb,mBAAqB,AACrB,cAAgB,CACnB,AACD,6DACM,aAAe,CACpB,AACD,gEACM,cAAgB,CACrB,AACD,0DACM,iBAAmB,CACxB,AACD,2IAEQ,wBAA0B,CACjC,AACD,6IAEQ,qBAA0B,CACjC,AACD,yIAEM,yBAA0B,AAC1B,6BAAmC,CACxC,AACD,2IAEM,sBAA0B,AAC1B,sBAAwB,CAC7B","file":"le-list-plus-preview.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-list-plus-preview[data-v-4b79cae8] {\n  font-family: Roboto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.le-list-plus-preview .displayed-items[data-v-4b79cae8] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: calc(100% - 40px);\n}\n.le-list-plus-preview .plus-items[data-v-4b79cae8] {\n    margin-left: 8px;\n    padding: 3px;\n    line-height: initial;\n    cursor: pointer;\n}\n.le-list-plus-preview .plus-items.plus-only[data-v-4b79cae8] {\n      margin-left: 0;\n}\n.le-list-plus-preview .plus-items.default-font[data-v-4b79cae8] {\n      font-size: 11px;\n}\n.le-list-plus-preview .plus-items.border[data-v-4b79cae8] {\n      border-radius: 1px;\n}\n.le-list-plus-preview .plus-items.border.theme-dark[data-v-4b79cae8],\n      .theme-dark .le-list-plus-preview .plus-items.border[data-v-4b79cae8] {\n        border: solid 1px #bbc0c9;\n}\n.le-list-plus-preview .plus-items.border.theme-light[data-v-4b79cae8],\n      .theme-light .le-list-plus-preview .plus-items.border[data-v-4b79cae8] {\n        border: solid 1px #888888;\n}\n.le-list-plus-preview .plus-items:hover.theme-dark[data-v-4b79cae8],\n    .theme-dark .le-list-plus-preview .plus-items[data-v-4b79cae8]:hover {\n      border: solid 1px #ced4de;\n      background: rgba(71, 74, 106, 0.5);\n}\n.le-list-plus-preview .plus-items:hover.theme-light[data-v-4b79cae8],\n    .theme-light .le-list-plus-preview .plus-items[data-v-4b79cae8]:hover {\n      border: solid 1px #666666;\n      background: transparent;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-list-plus-preview"},[(!_vm.isPlusOnly)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.displayedItemsTooltipOptions),expression:"displayedItemsTooltipOptions"}],staticClass:"displayed-items",attrs:{"data-test":"list_plus_items"}},[_vm._v(_vm._s(_vm.displayedItems))]):_vm._e(),_vm._v(" "),(_vm.items.length > _vm.maxItemsDisplay)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.plusItemsTooltipOptions),expression:"plusItemsTooltipOptions"}],class:['plus-items', _vm.plusItemsFontClass, {border : _vm.borderPlusItems}, {'plus-only': _vm.isPlusOnly}],attrs:{"data-test":"list_plus_extra"}},[_vm._v(_vm._s(_vm.plusLabel))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b57bca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_vue__ = __webpack_require__(492);
function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71b57bca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("399c0d2f", content, true, {});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".table-loader-container{display:table-cell;height:550px;width:100%}.table-loader{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.table-quick-selection-bubble-inner{font-family:Roboto;padding:0;width:80px;height:40px}.table-quick-selection-bubble-inner.theme-dark,.theme-dark .table-quick-selection-bubble-inner{border-:1px solid #595a80}.table-quick-selection-bubble-inner.theme-light,.theme-light .table-quick-selection-bubble-inner{border-:1px solid #d8d8d8}.table-quick-selection-bubble-inner .quick-selection-item{padding:5px 0;cursor:pointer}.le-table{font-family:Roboto;overflow:hidden;position:relative}.le-table.theme-dark,.theme-dark .le-table{border-top:1px solid #595a80}.le-table.theme-light,.theme-light .le-table{border-top:1px solid #d8d8d8}.le-table.disabled-top-border{border-top:none}.le-table.loading{padding:0;border-top:none}.le-table .table-wrapper{overflow-y:auto;height:calc(100% - 1px);width:100%;display:inline-block}.le-table .table-wrapper.theme-dark,.theme-dark .le-table .table-wrapper{border-top:1px solid #595a80}.le-table .table-wrapper.theme-light,.theme-light .le-table .table-wrapper{border-top:1px solid #d8d8d8}.le-table .table-wrapper table{width:100%;border-spacing:0;border-collapse:collapse}.le-table .table-wrapper table .le-table-columns .le-table-column.colors-column{min-width:10px;width:10px}.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column{min-width:40px;width:40px}.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .multi-select-container{padding-top:3px}.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .quick-selection-wrapper{display:inline-block;position:relative;top:-3px;left:3px}.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .quick-selection-wrapper .ico-arrow-down{cursor:pointer}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table.vue"],"names":[],"mappings":"AAIA,wBACE,mBAAoB,AACpB,aAAc,AACd,UAAY,CACb,AACD,cACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,qBAAsB,AAC1B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,oCACE,mBAAoB,AACpB,UAAW,AACX,WAAY,AACZ,WAAa,CACd,AACD,+FAEI,yBAA2B,CAC9B,AACD,iGAEI,yBAA2B,CAC9B,AACD,0DACI,cAAe,AACf,cAAgB,CACnB,AACD,UACE,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,2CAEI,4BAA8B,CACjC,AACD,6CAEI,4BAA8B,CACjC,AACD,8BACI,eAAiB,CACpB,AACD,kBACI,UAAW,AACX,eAAiB,CACpB,AACD,yBACI,gBAAiB,AACjB,wBAAyB,AAEzB,WAAY,AACZ,oBAAsB,CACzB,AACD,yEAEM,4BAA8B,CACnC,AACD,2EAEM,4BAA8B,CACnC,AACD,+BACM,WAAY,AACZ,iBAAkB,AAClB,wBAA0B,CAC/B,AACD,gFACQ,eAAgB,AAChB,UAAY,CACnB,AACD,mFACQ,eAAgB,AAChB,UAAY,CACnB,AACD,2GACU,eAAiB,CAC1B,AACD,4GACU,qBAAsB,AACtB,kBAAmB,AACnB,SAAU,AACV,QAAU,CACnB,AACD,4HACY,cAAgB,CAC3B","file":"le-table.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.table-loader-container {\n  display: table-cell;\n  height: 550px;\n  width: 100%;\n}\n.table-loader {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.table-quick-selection-bubble-inner {\n  font-family: Roboto;\n  padding: 0;\n  width: 80px;\n  height: 40px;\n}\n.table-quick-selection-bubble-inner.theme-dark,\n  .theme-dark .table-quick-selection-bubble-inner {\n    border-: 1px solid #595a80;\n}\n.table-quick-selection-bubble-inner.theme-light,\n  .theme-light .table-quick-selection-bubble-inner {\n    border-: 1px solid #d8d8d8;\n}\n.table-quick-selection-bubble-inner .quick-selection-item {\n    padding: 5px 0;\n    cursor: pointer;\n}\n.le-table {\n  font-family: Roboto;\n  overflow: hidden;\n  position: relative;\n}\n.le-table.theme-dark,\n  .theme-dark .le-table {\n    border-top: 1px solid #595a80;\n}\n.le-table.theme-light,\n  .theme-light .le-table {\n    border-top: 1px solid #d8d8d8;\n}\n.le-table.disabled-top-border {\n    border-top: none;\n}\n.le-table.loading {\n    padding: 0;\n    border-top: none;\n}\n.le-table .table-wrapper {\n    overflow-y: auto;\n    height: calc(100% - 1px);\n    /* we need to do -1 because we have border-top of 1px */\n    width: 100%;\n    display: inline-block;\n}\n.le-table .table-wrapper.theme-dark,\n    .theme-dark .le-table .table-wrapper {\n      border-top: 1px solid #595a80;\n}\n.le-table .table-wrapper.theme-light,\n    .theme-light .le-table .table-wrapper {\n      border-top: 1px solid #d8d8d8;\n}\n.le-table .table-wrapper table {\n      width: 100%;\n      border-spacing: 0;\n      border-collapse: collapse;\n}\n.le-table .table-wrapper table .le-table-columns .le-table-column.colors-column {\n        min-width: 10px;\n        width: 10px;\n}\n.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column {\n        min-width: 40px;\n        width: 40px;\n}\n.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .multi-select-container {\n          padding-top: 3px;\n}\n.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .quick-selection-wrapper {\n          display: inline-block;\n          position: relative;\n          top: -3px;\n          left: 3px;\n}\n.le-table .table-wrapper table .le-table-columns .le-table-column.selection-column .quick-selection-wrapper .ico-arrow-down {\n            cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(424);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(69)(module)))

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_column_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153b70bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_column_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_column_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153b70bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_column_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(427);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b689b6d4", content, true, {});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-table-column{height:0;line-height:0;padding-top:0;padding-bottom:0}.le-table-column:focus .wrapper{outline:none!important}.le-table-column:focus .wrapper.theme-dark.show-a11y-focus-outline,.theme-dark.show-a11y-focus-outline .le-table-column:focus .wrapper{-webkit-box-shadow:inset 0 0 0 2px #52c7ef!important;box-shadow:inset 0 0 0 2px #52c7ef!important}.le-table-column:focus .wrapper.theme-light.show-a11y-focus-outline,.theme-light.show-a11y-focus-outline .le-table-column:focus .wrapper{-webkit-box-shadow:inset 0 0 0 2px #0c5de6!important;box-shadow:inset 0 0 0 2px #0c5de6!important}.le-table-column .wrapper{position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;top:0;padding-left:15px;text-align:left}.le-table-column .wrapper.theme-dark,.theme-dark .le-table-column .wrapper{background-color:#0c1033;color:#fff}.le-table-column .wrapper.theme-light,.theme-light .le-table-column .wrapper{background-color:#f9f9f9;color:#323436}.le-table-column .wrapper i.theme-dark,.theme-dark .le-table-column .wrapper i{color:#a7acbe}.le-table-column .wrapper i.theme-light,.theme-light .le-table-column .wrapper i{color:#97a0a8}.le-table-column .wrapper .icon{vertical-align:middle;line-height:1}.le-table-column .wrapper .action-icon{vertical-align:middle;line-height:1;margin-left:5px;cursor:pointer}.le-table-column .wrapper.has-title .icon{margin-right:5px}.le-table-column .wrapper .title-description{position:absolute;clip:rect(0 0 0 0);border:0;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden}.le-table-column .wrapper .title{display:inline-block;vertical-align:middle;font-weight:700;line-height:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.le-table-column .wrapper .sort-icons{position:relative;display:inline-block;line-height:1;vertical-align:middle;cursor:pointer;margin-left:3px;margin-right:3px;width:6px;height:11px;font-size:4px}.le-table-column .wrapper .sort-icons .ico-sorting-down{position:absolute;top:6px}.le-table-column .wrapper .sort-icons .ico-sorting-up{position:absolute;top:0}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table-column.vue"],"names":[],"mappings":"AAIA,iBACE,SAAU,AACV,cAAe,AACf,cAAe,AACf,gBAAkB,CACnB,AACD,gCACI,sBAAyB,CAC5B,AACD,uIAEM,qDAAuD,AAC/C,4CAA+C,CAC5D,AACD,yIAEM,qDAAuD,AAC/C,4CAA+C,CAC5D,AACD,0BACI,kBAAmB,AACnB,8BAA+B,AACvB,sBAAuB,AAC/B,MAAO,AACP,kBAAmB,AACnB,eAAiB,CACpB,AACD,2EAEM,yBAA0B,AAC1B,UAAe,CACpB,AACD,6EAEM,yBAA0B,AAC1B,aAAe,CACpB,AACD,+EAEM,aAAe,CACpB,AACD,iFAEM,aAAe,CACpB,AACD,gCACM,sBAAuB,AACvB,aAAe,CACpB,AACD,uCACM,sBAAuB,AACvB,cAAe,AACf,gBAAiB,AACjB,cAAgB,CACrB,AACD,0CACM,gBAAkB,CACvB,AACD,6CACM,kBAAmB,AACnB,mBAAoB,AACpB,SAAU,AACV,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,eAAiB,CACtB,AACD,iCACM,qBAAsB,AACtB,sBAAuB,AACvB,gBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACzB,AACD,sCACM,kBAAmB,AACnB,qBAAsB,AACtB,cAAe,AACf,sBAAuB,AACvB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,UAAW,AACX,YAAa,AACb,aAAe,CACpB,AACD,wDACQ,kBAAmB,AACnB,OAAS,CAChB,AACD,sDACQ,kBAAmB,AACnB,KAAS,CAChB","file":"le-table-column.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-table-column {\n  height: 0;\n  line-height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.le-table-column:focus .wrapper {\n    outline: none !important;\n}\n.le-table-column:focus .wrapper.theme-dark.show-a11y-focus-outline,\n    .theme-dark.show-a11y-focus-outline .le-table-column:focus .wrapper {\n      -webkit-box-shadow: inset 0 0 0 2px #52c7ef !important;\n              box-shadow: inset 0 0 0 2px #52c7ef !important;\n}\n.le-table-column:focus .wrapper.theme-light.show-a11y-focus-outline,\n    .theme-light.show-a11y-focus-outline .le-table-column:focus .wrapper {\n      -webkit-box-shadow: inset 0 0 0 2px #0c5de6 !important;\n              box-shadow: inset 0 0 0 2px #0c5de6 !important;\n}\n.le-table-column .wrapper {\n    position: absolute;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    top: 0;\n    padding-left: 15px;\n    text-align: left;\n}\n.le-table-column .wrapper.theme-dark,\n    .theme-dark .le-table-column .wrapper {\n      background-color: #0c1033;\n      color: #ffffff;\n}\n.le-table-column .wrapper.theme-light,\n    .theme-light .le-table-column .wrapper {\n      background-color: #f9f9f9;\n      color: #323436;\n}\n.le-table-column .wrapper i.theme-dark,\n    .theme-dark .le-table-column .wrapper i {\n      color: #A7ACBE;\n}\n.le-table-column .wrapper i.theme-light,\n    .theme-light .le-table-column .wrapper i {\n      color: #97a0a8;\n}\n.le-table-column .wrapper .icon {\n      vertical-align: middle;\n      line-height: 1;\n}\n.le-table-column .wrapper .action-icon {\n      vertical-align: middle;\n      line-height: 1;\n      margin-left: 5px;\n      cursor: pointer;\n}\n.le-table-column .wrapper.has-title .icon {\n      margin-right: 5px;\n}\n.le-table-column .wrapper .title-description {\n      position: absolute;\n      clip: rect(0 0 0 0);\n      border: 0;\n      width: 1px;\n      height: 1px;\n      margin: -1px;\n      padding: 0;\n      overflow: hidden;\n}\n.le-table-column .wrapper .title {\n      display: inline-block;\n      vertical-align: middle;\n      font-weight: bold;\n      line-height: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.le-table-column .wrapper .sort-icons {\n      position: relative;\n      display: inline-block;\n      line-height: 1;\n      vertical-align: middle;\n      cursor: pointer;\n      margin-left: 3px;\n      margin-right: 3px;\n      width: 6px;\n      height: 11px;\n      font-size: 4px;\n}\n.le-table-column .wrapper .sort-icons .ico-sorting-down {\n        position: absolute;\n        top: 6px;\n}\n.le-table-column .wrapper .sort-icons .ico-sorting-up {\n        position: absolute;\n        top: 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(429);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d82dc43a", content, true, {});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-filter[data-v-d3dc7662]{font-family:Roboto;display:inline-block;line-height:17px;height:17px}.le-filter .filter-button-wrapper[data-v-d3dc7662]{display:inline-block;vertical-align:middle;min-height:16px;min-width:14px;text-align:center;padding:1px;cursor:pointer}.le-filter .filter-button-wrapper:hover .filter-button[data-v-d3dc7662]{display:block}.le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662]{display:block;width:15px}.le-filter .filter-button-wrapper .filter-button.theme-dark[data-v-d3dc7662],.theme-dark .le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662]{color:#a7acbe}.le-filter .filter-button-wrapper .filter-button.theme-light[data-v-d3dc7662],.theme-light .le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662]{color:#97a0a8}.le-filter .filter-button-wrapper .filter-button.filtered.theme-dark[data-v-d3dc7662],.theme-dark .le-filter .filter-button-wrapper .filter-button.filtered[data-v-d3dc7662]{color:#2dbae6}.le-filter .filter-button-wrapper .filter-button.filtered.theme-light[data-v-d3dc7662],.theme-light .le-filter .filter-button-wrapper .filter-button.filtered[data-v-d3dc7662]{color:#4661ae}.le-filter .filter-button-wrapper.disabled[data-v-d3dc7662]{cursor:default}.le-filter .filter-button-wrapper.disabled .filter-button.filtered.theme-dark[data-v-d3dc7662],.le-filter .filter-button-wrapper.disabled .filter-button.theme-dark[data-v-d3dc7662],.theme-dark .le-filter .filter-button-wrapper.disabled .filter-button.filtered[data-v-d3dc7662],.theme-dark .le-filter .filter-button-wrapper.disabled .filter-button[data-v-d3dc7662]{color:#56597a}.le-filter-bubble .filter-content-wrapper[data-v-d3dc7662]{max-width:none}.le-filter-bubble .close[data-v-d3dc7662]{position:absolute;top:10px;right:10px;border:none;font-size:8px;outline:none;padding:0;cursor:pointer;width:8px;height:8px}.le-filter-bubble .filter-bubble-content[data-v-d3dc7662]{padding:5px;font-size:13px}.le-filter-bubble .filter-bubble-content .filter-content[data-v-d3dc7662]{min-width:200px;position:relative;margin-bottom:30px}.le-filter-bubble .filter-bubble-content .footer[data-v-d3dc7662]{height:30px;position:relative}.le-filter-bubble .filter-bubble-content .footer .reset[data-v-d3dc7662]{position:relative}.le-filter-bubble .filter-bubble-content .footer .filter[data-v-d3dc7662]{position:absolute;right:0}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-filter/le-filter.vue"],"names":[],"mappings":"AAIA,4BACE,mBAAoB,AACpB,qBAAsB,AACtB,iBAAkB,AAClB,WAAa,CACd,AACD,mDACI,qBAAsB,AACtB,sBAAuB,AACvB,gBAAiB,AACjB,eAAgB,AAChB,kBAAmB,AACnB,YAAa,AACb,cAAgB,CACnB,AACD,wEACM,aAAe,CACpB,AACD,kEACM,cAAe,AACf,UAAY,CACjB,AACD,2JAEQ,aAAe,CACtB,AACD,6JAEQ,aAAe,CACtB,AACD,6KAEQ,aAAe,CACtB,AACD,+KAEQ,aAAe,CACtB,AACD,4DACM,cAAgB,CACrB,AAKD,4WAEQ,aAAe,CACtB,AACD,2DACE,cAAgB,CACjB,AACD,0CACE,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,YAAa,AACb,cAAe,AACf,aAAc,AACd,UAAW,AACX,eAAgB,AAChB,UAAW,AACX,UAAY,CACb,AACD,0DACE,YAAa,AACb,cAAgB,CACjB,AACD,0EACI,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACvB,AACD,kEACI,YAAa,AACb,iBAAmB,CACtB,AACD,yEACM,iBAAmB,CACxB,AACD,0EACM,kBAAmB,AACnB,OAAS,CACd","file":"le-filter.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-filter[data-v-d3dc7662] {\n  font-family: Roboto;\n  display: inline-block;\n  line-height: 17px;\n  height: 17px;\n}\n.le-filter .filter-button-wrapper[data-v-d3dc7662] {\n    display: inline-block;\n    vertical-align: middle;\n    min-height: 16px;\n    min-width: 14px;\n    text-align: center;\n    padding: 1px;\n    cursor: pointer;\n}\n.le-filter .filter-button-wrapper:hover .filter-button[data-v-d3dc7662] {\n      display: block;\n}\n.le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662] {\n      display: block;\n      width: 15px;\n}\n.le-filter .filter-button-wrapper .filter-button.theme-dark[data-v-d3dc7662],\n      .theme-dark .le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662] {\n        color: #A7ACBE;\n}\n.le-filter .filter-button-wrapper .filter-button.theme-light[data-v-d3dc7662],\n      .theme-light .le-filter .filter-button-wrapper .filter-button[data-v-d3dc7662] {\n        color: #97a0a8;\n}\n.le-filter .filter-button-wrapper .filter-button.filtered.theme-dark[data-v-d3dc7662],\n      .theme-dark .le-filter .filter-button-wrapper .filter-button.filtered[data-v-d3dc7662] {\n        color: #2DBAE6;\n}\n.le-filter .filter-button-wrapper .filter-button.filtered.theme-light[data-v-d3dc7662],\n      .theme-light .le-filter .filter-button-wrapper .filter-button.filtered[data-v-d3dc7662] {\n        color: #4661ae;\n}\n.le-filter .filter-button-wrapper.disabled[data-v-d3dc7662] {\n      cursor: default;\n}\n.le-filter .filter-button-wrapper.disabled .filter-button.theme-dark[data-v-d3dc7662],\n      .theme-dark .le-filter .filter-button-wrapper.disabled .filter-button[data-v-d3dc7662] {\n        color: #56597a;\n}\n.le-filter .filter-button-wrapper.disabled .filter-button.filtered.theme-dark[data-v-d3dc7662],\n      .theme-dark .le-filter .filter-button-wrapper.disabled .filter-button.filtered[data-v-d3dc7662] {\n        color: #56597a;\n}\n.le-filter-bubble .filter-content-wrapper[data-v-d3dc7662] {\n  max-width: none;\n}\n.le-filter-bubble .close[data-v-d3dc7662] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  font-size: 8px;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n  width: 8px;\n  height: 8px;\n}\n.le-filter-bubble .filter-bubble-content[data-v-d3dc7662] {\n  padding: 5px;\n  font-size: 13px;\n}\n.le-filter-bubble .filter-bubble-content .filter-content[data-v-d3dc7662] {\n    min-width: 200px;\n    position: relative;\n    margin-bottom: 30px;\n}\n.le-filter-bubble .filter-bubble-content .footer[data-v-d3dc7662] {\n    height: 30px;\n    position: relative;\n}\n.le-filter-bubble .filter-bubble-content .footer .reset[data-v-d3dc7662] {\n      position: relative;\n}\n.le-filter-bubble .filter-bubble-content .footer .filter[data-v-d3dc7662] {\n      position: absolute;\n      right: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-filter"},[_c('le-bubble',{ref:"bubble",attrs:{"bubbleBaseClass":"le-filter-bubble","bubbleInnerClass":("filter-content-wrapper " + _vm.filterBubbleInnerClass),"ariaLabelledBy":_vm.filterContentId,"placement":_vm.placement,"flip":false,"autoHide":_vm.autoHide,"isEnabled":!_vm.disabled,"trigger":'manual',"defaultCloseButton":true,"lazy":_vm.lazy,"data-test":"filter"},on:{"hide":_vm.onHide}},[_c('div',{ref:"button",class:['filter-button-wrapper', {disabled: _vm.disabled }],attrs:{"slot":"target","tabindex":"0","role":"button","title":_vm.filterIconTooltip,"aria-label":_vm.filterButtonAriaLabel,"aria-labelledby":_vm.ariaLabelledBy,"aria-pressed":_vm.bubbleOpen,"aria-expanded":("" + _vm.bubbleOpen),"aria-haspopup":_vm.ariaHasPopup,"data-test":"filter_btn"},on:{"click":_vm.onFilterOpenClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onFilterOpenClick($event)}},slot:"target"},[_vm._t("target",[_c('i',{class:['filter-button', 'ico-filter', ("ico-" + _vm.iconSize), { filtered: _vm.isFiltered }],attrs:{"data-test":"filter_icon"}})])],2),_vm._v(" "),_c('div',{staticClass:"filter-bubble-content",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"filter-content",attrs:{"data-test":"filter_content"}},[_c(_vm.component,_vm._b({ref:"innerComponent",tag:"component",attrs:{"id":_vm.filterContentId}},'component',_vm.componentProps,false))],1),_vm._v(" "),_c('div',{staticClass:"footer"},[(!_vm.hideResetButton)?_c('le-button',{directives:[{name:"close-popover",rawName:"v-close-popover"}],staticClass:"reset theme-light",attrs:{"variant":"cancel","label":_vm.resetButtonLabel,"data-test":"filter_reset"},on:{"click":_vm.onReset}}):_vm._e(),_vm._v(" "),(_vm.autoHide)?_c('le-button',{directives:[{name:"close-popover",rawName:"v-close-popover"}],staticClass:"filter",attrs:{"variant":"primary","label":_vm.filterButtonLabel,"data-test":"filter_btn"},on:{"click":_vm.onFilter}}):_c('le-button',{staticClass:"filter",attrs:{"variant":"primary","label":_vm.filterButtonLabel,"data-test":"filter_btn"},on:{"click":_vm.onFilter}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(432);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3404936d", content, true, {});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".theme-dark .toggle-selection-icon[data-v-33dd6723] svg [fill],.toggle-selection-icon[data-v-33dd6723] svg [fill].theme-dark{fill:#a7acbe}.theme-light .toggle-selection-icon[data-v-33dd6723] svg [fill],.toggle-selection-icon[data-v-33dd6723] svg [fill].theme-light{fill:#97a0a8}.theme-dark .toggle-selection-icon[data-v-33dd6723] svg [stroke],.toggle-selection-icon[data-v-33dd6723] svg [stroke].theme-dark{stroke:#a7acbe}.theme-light .toggle-selection-icon[data-v-33dd6723] svg [stroke],.toggle-selection-icon[data-v-33dd6723] svg [stroke].theme-light{stroke:#97a0a8}.theme-dark .toggle-selection-icon.active[data-v-33dd6723] svg [fill],.toggle-selection-icon.active[data-v-33dd6723] svg [fill].theme-dark{fill:#2dbae6}.theme-light .toggle-selection-icon.active[data-v-33dd6723] svg [fill],.toggle-selection-icon.active[data-v-33dd6723] svg [fill].theme-light{fill:#4661ae}.theme-dark .toggle-selection-icon.active[data-v-33dd6723] svg [stroke],.toggle-selection-icon.active[data-v-33dd6723] svg [stroke].theme-dark{stroke:#2dbae6}.theme-light .toggle-selection-icon.active[data-v-33dd6723] svg [stroke],.toggle-selection-icon.active[data-v-33dd6723] svg [stroke].theme-light{stroke:#4661ae}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-toggle-selection-icon/le-toggle-selection-icon.vue"],"names":[],"mappings":"AAIA,6HAEE,YAAc,CACf,AACD,+HAEE,YAAc,CACf,AACD,iIAEE,cAAgB,CACjB,AACD,mIAEE,cAAgB,CACjB,AACD,2IAEE,YAAc,CACf,AACD,6IAEE,YAAc,CACf,AACD,+IAEE,cAAgB,CACjB,AACD,iJAEE,cAAgB,CACjB","file":"le-toggle-selection-icon.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.toggle-selection-icon[data-v-33dd6723] svg [fill].theme-dark,\n.theme-dark .toggle-selection-icon[data-v-33dd6723] svg [fill] {\n  fill: #A7ACBE;\n}\n.toggle-selection-icon[data-v-33dd6723] svg [fill].theme-light,\n.theme-light .toggle-selection-icon[data-v-33dd6723] svg [fill] {\n  fill: #97a0a8;\n}\n.toggle-selection-icon[data-v-33dd6723] svg [stroke].theme-dark,\n.theme-dark .toggle-selection-icon[data-v-33dd6723] svg [stroke] {\n  stroke: #A7ACBE;\n}\n.toggle-selection-icon[data-v-33dd6723] svg [stroke].theme-light,\n.theme-light .toggle-selection-icon[data-v-33dd6723] svg [stroke] {\n  stroke: #97a0a8;\n}\n.toggle-selection-icon.active[data-v-33dd6723] svg [fill].theme-dark,\n.theme-dark .toggle-selection-icon.active[data-v-33dd6723] svg [fill] {\n  fill: #2DBAE6;\n}\n.toggle-selection-icon.active[data-v-33dd6723] svg [fill].theme-light,\n.theme-light .toggle-selection-icon.active[data-v-33dd6723] svg [fill] {\n  fill: #4661ae;\n}\n.toggle-selection-icon.active[data-v-33dd6723] svg [stroke].theme-dark,\n.theme-dark .toggle-selection-icon.active[data-v-33dd6723] svg [stroke] {\n  stroke: #2DBAE6;\n}\n.toggle-selection-icon.active[data-v-33dd6723] svg [stroke].theme-light,\n.theme-light .toggle-selection-icon.active[data-v-33dd6723] svg [stroke] {\n  stroke: #4661ae;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"toggle-selection-icon",class:[( _obj = {}, _obj[("le-icon-" + _vm.icon)] = true, _obj['active'] =  _vm.isActive, _obj )],domProps:{"innerHTML":_vm._s(__webpack_require__(434)("./" + _vm.icon + ".svg"))}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alert-configuration-active.svg": 435,
	"./alert-configuration.svg": 436,
	"./bold-dark.svg": 437,
	"./bold-light.svg": 438,
	"./bullets-list-dark.svg": 439,
	"./bullets-list-light.svg": 440,
	"./clear-format-dark.svg": 441,
	"./clear-format-light.svg": 442,
	"./conversation-status-closed.svg": 443,
	"./emoji.svg": 444,
	"./error-notify.svg": 445,
	"./imoji.svg": 446,
	"./indicator.svg": 447,
	"./italic-dark.svg": 448,
	"./italic-light.svg": 449,
	"./ordered-list-dark.svg": 450,
	"./ordered-list-light.svg": 451,
	"./response-time.svg": 452,
	"./source-chrome.svg": 453,
	"./source-email.svg": 454,
	"./source-google.svg": 455,
	"./source-instagram.svg": 456,
	"./source-rcs.svg": 457,
	"./source-safari.svg": 458,
	"./status-away-g.svg": 459,
	"./status-away.svg": 460,
	"./status-back-soon-g.svg": 461,
	"./status-back-soon.svg": 462,
	"./status-online-g.svg": 463,
	"./status-online.svg": 464,
	"./success-notification.svg": 465,
	"./success-notify.svg": 466,
	"./underline-dark.svg": 467,
	"./underline-light.svg": 468,
	"./v-sign.svg": 469
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 434;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"15\" viewBox=\"0 0 16 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C3 0.89543 3.89543 0 5 0C6.10457 0 7 0.895431 7 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H7C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2L3 2ZM5 1C5.55228 1 6 1.44772 6 2V4C6 4.55228 5.55228 5 5 5C4.44772 5 4 4.55228 4 4V2C4 1.44772 4.44772 1 5 1Z\" fill=\"#2DBAE6\"/> <path d=\"M1 10H7.10002C7.03443 10.3231 7 10.6575 7 11C7 11.3425 7.03443 11.6769 7.10002 12H1C0.447715 12 0 11.5523 0 11C0 10.4477 0.447715 10 1 10Z\" fill=\"#2DBAE6\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11ZM14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355L11.5 13.2071L9.64645 11.3536C9.45118 11.1583 9.45118 10.8417 9.64645 10.6464C9.84171 10.4512 10.1583 10.4512 10.3536 10.6464L11.5 11.7929L14.1464 9.14645C14.3417 8.95118 14.6583 8.95118 14.8536 9.14645Z\" fill=\"#2DBAE6\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"14\" viewBox=\"0 0 16 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C3 0.89543 3.89543 0 5 0C6.10457 0 7 0.895431 7 2H15C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H7C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2L3 2ZM5 1C5.55228 1 6 1.44772 6 2V4C6 4.55228 5.55228 5 5 5C4.44772 5 4 4.55228 4 4V2C4 1.44772 4.44772 1 5 1Z\" fill=\"#A7ACBE\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10H1C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12H9C9 13.1046 9.89543 14 11 14C12.1046 14 13 13.1046 13 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H13ZM11 9C10.4477 9 10 9.44772 10 10V12C10 12.5523 10.4477 13 11 13C11.5523 13 12 12.5523 12 12V10C12 9.44772 11.5523 9 11 9Z\" fill=\"#A7ACBE\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M4.5 14C4.22386 14 4 13.7761 4 13.5V2.5C4 2.22386 4.22386 2 4.5 2H8.24214C9.71165 2 10.8262 2.28022 11.586 2.84066C12.3457 3.3956 12.7255 4.21154 12.7255 5.28846C12.7255 5.87637 12.573 6.3956 12.268 6.84615C11.963 7.29121 11.5388 7.61813 10.9954 7.82692C11.6165 7.98077 12.1044 8.29121 12.4593 8.75824C12.8198 9.22527 13 9.7967 13 10.4725C13 11.6264 12.6285 12.5 11.8854 13.0934C11.1423 13.6868 10.0832 13.989 8.70795 14H4.5ZM6.99538 8.77473C6.71924 8.77473 6.49538 8.99858 6.49538 9.27473V11.5137C6.49538 11.7899 6.71924 12.0137 6.99538 12.0137H8.63309C9.22089 12.0137 9.67837 11.8764 10.0055 11.6016C10.3383 11.3214 10.5046 10.9368 10.5046 10.4478C10.5046 9.3489 9.93068 8.79121 8.78281 8.77473H6.99538ZM6.49538 6.52747C6.49538 6.80362 6.71924 7.02747 6.99538 7.02747H8.34196C9.60074 7.00549 10.2301 6.50824 10.2301 5.53571C10.2301 4.99176 10.0693 4.60165 9.74769 4.36538C9.43161 4.12363 8.92976 4.00275 8.24214 4.00275H6.99538C6.71924 4.00275 6.49538 4.2266 6.49538 4.50275V6.52747Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path opacity=\"0.9\" d=\"M4.5 14C4.22386 14 4 13.7761 4 13.5V2.5C4 2.22386 4.22386 2 4.5 2H8.24214C9.71165 2 10.8262 2.28022 11.586 2.84066C12.3457 3.3956 12.7255 4.21154 12.7255 5.28846C12.7255 5.87637 12.573 6.3956 12.268 6.84615C11.963 7.29121 11.5388 7.61813 10.9954 7.82692C11.6165 7.98077 12.1044 8.29121 12.4593 8.75824C12.8198 9.22527 13 9.7967 13 10.4725C13 11.6264 12.6285 12.5 11.8854 13.0934C11.1423 13.6868 10.0832 13.989 8.70795 14H4.5ZM6.99538 8.77473C6.71924 8.77473 6.49538 8.99858 6.49538 9.27473V11.5137C6.49538 11.7899 6.71924 12.0137 6.99538 12.0137H8.63309C9.22089 12.0137 9.67837 11.8764 10.0055 11.6016C10.3383 11.3214 10.5046 10.9368 10.5046 10.4478C10.5046 9.3489 9.93068 8.79121 8.78281 8.77473H6.99538ZM6.49538 6.52747C6.49538 6.80362 6.71924 7.02747 6.99538 7.02747H8.34196C9.60074 7.00549 10.2301 6.50824 10.2301 5.53571C10.2301 4.99176 10.0693 4.60165 9.74769 4.36538C9.43161 4.12363 8.92976 4.00275 8.24214 4.00275H6.99538C6.71924 4.00275 6.49538 4.2266 6.49538 4.50275V6.52747Z\" fill=\"#34363B\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5 1C1.67157 1 1 1.67157 1 2.5C1 3.32843 1.67157 4 2.5 4C3.32843 4 4 3.32843 4 2.5C4 1.67157 3.32843 1 2.5 1ZM6 2.5C6 2.22386 6.22386 2 6.5 2H14.5C14.7761 2 15 2.22386 15 2.5C15 2.77614 14.7761 3 14.5 3H6.5C6.22386 3 6 2.77614 6 2.5ZM2.5 6C1.67157 6 1 6.67157 1 7.5C1 8.32843 1.67157 9 2.5 9C3.32843 9 4 8.32843 4 7.5C4 6.67157 3.32843 6 2.5 6ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H6.5ZM6 12.5C6 12.2239 6.22386 12 6.5 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H6.5C6.22386 13 6 12.7761 6 12.5ZM2.5 11C1.67157 11 1 11.6716 1 12.5C1 13.3284 1.67157 14 2.5 14C3.32843 14 4 13.3284 4 12.5C4 11.6716 3.32843 11 2.5 11Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path opacity=\"0.9\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5 1C1.67157 1 1 1.67157 1 2.5C1 3.32843 1.67157 4 2.5 4C3.32843 4 4 3.32843 4 2.5C4 1.67157 3.32843 1 2.5 1ZM6 2.5C6 2.22386 6.22386 2 6.5 2H14.5C14.7761 2 15 2.22386 15 2.5C15 2.77614 14.7761 3 14.5 3H6.5C6.22386 3 6 2.77614 6 2.5ZM2.5 6C1.67157 6 1 6.67157 1 7.5C1 8.32843 1.67157 9 2.5 9C3.32843 9 4 8.32843 4 7.5C4 6.67157 3.32843 6 2.5 6ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H6.5ZM6 12.5C6 12.2239 6.22386 12 6.5 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H6.5C6.22386 13 6 12.7761 6 12.5ZM2.5 11C1.67157 11 1 11.6716 1 12.5C1 13.3284 1.67157 14 2.5 14C3.32843 14 4 13.3284 4 12.5C4 11.6716 3.32843 11 2.5 11Z\" fill=\"#34363B\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.48725 8.60857L5.72577 13.4219C5.67775 13.7254 5.91233 14 6.21963 14H7.41389C7.65987 14 7.86931 13.8211 7.90775 13.5781L8.39252 10.5138L6.48725 8.60857ZM8.97204 6.85072L9.35585 4.42462C9.39429 4.18166 9.60373 4.00275 9.84971 4.00275H13.2505C13.4958 4.00275 13.7049 3.82475 13.7441 3.58256L13.9062 2.57981C13.9554 2.27577 13.7206 2 13.4127 2H4.12132L6.12407 4.00275H6.63058C6.93788 4.00275 7.17246 4.27735 7.12444 4.58088L7.06676 4.94544L8.97204 6.85072Z\" fill=\"white\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.14645 1.14645C1.34171 0.951184 1.65829 0.951184 1.85355 1.14645L14.8536 14.1464C15.0488 14.3417 15.0488 14.6583 14.8536 14.8536C14.6583 15.0488 14.3417 15.0488 14.1464 14.8536L1.14645 1.85355C0.951184 1.65829 0.951184 1.34171 1.14645 1.14645Z\" fill=\"white\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.48725 8.60857L5.72577 13.4219C5.67775 13.7254 5.91233 14 6.21963 14H7.41389C7.65987 14 7.86931 13.8211 7.90775 13.5781L8.39252 10.5138L6.48725 8.60857ZM8.97204 6.85072L9.35585 4.42462C9.39429 4.18166 9.60373 4.00275 9.84971 4.00275H13.2505C13.4958 4.00275 13.7049 3.82475 13.7441 3.58256L13.9062 2.57981C13.9554 2.27577 13.7206 2 13.4127 2H4.12132L6.12407 4.00275H6.63058C6.93788 4.00275 7.17246 4.27735 7.12444 4.58088L7.06676 4.94544L8.97204 6.85072Z\" fill=\"#34363B\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.14645 1.14645C1.34171 0.951184 1.65829 0.951184 1.85355 1.14645L14.8536 14.1464C15.0488 14.3417 15.0488 14.6583 14.8536 14.8536C14.6583 15.0488 14.3417 15.0488 14.1464 14.8536L1.14645 1.85355C0.951184 1.65829 0.951184 1.34171 1.14645 1.14645Z\" fill=\"#34363B\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"10\" viewBox=\"0 0 16 10\"> <g fill=\"none\" fill-rule=\"evenodd\"> <path fill=\"#D6D6D7\" d=\"M11.96 2.198H9.816L8.158 4.202l3.803-.004v2l4-3-4-3.001z\"/> <path stroke=\"#FFA21B\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M0 5.8l2.56 2.292L8.479 1\"/> <path fill=\"#D6D6D7\" d=\"M4.008 9.046l11.953.015V7.134l-10.25-.01z\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" enable-background=\"new 0 0 64 64\"><circle fill=\"#ffdd67\" cx=\"32\" cy=\"32\" r=\"30\"/><g fill=\"#664e27\"><path d=\"m47.951 27.19c0 2.185-1.85 3.958-4.133 3.958-2.285 0-4.135-1.772-4.137-3.958.001-1.388 8.27-1.388 8.27 0\"/><path d=\"m49.09 24.84c-1.745-.601-3.514-.892-5.273-.899-1.75-.011-3.53.271-5.28.869-1.735.609-3.494 1.529-4.885 2.926 1.938-.222 3.633-.416 5.294-.523 1.66-.115 3.252-.159 4.862-.156 1.61.003 3.215.061 4.873.178 1.669.107 3.366.296 5.305.502-1.405-1.379-3.165-2.286-4.896-2.897\"/><path d=\"m24.318 27.19c0 2.185-1.85 3.958-4.133 3.958-2.285 0-4.135-1.772-4.137-3.958.001-1.388 8.27-1.388 8.27 0\"/><path d=\"m25.455 24.84c-1.747-.601-3.514-.892-5.273-.899-1.748-.012-3.529.271-5.28.869-1.734.609-3.494 1.529-4.885 2.926 1.94-.223 3.633-.416 5.294-.523 1.66-.115 3.251-.159 4.864-.156 1.607.003 3.214.06 4.873.178 1.667.107 3.366.296 5.303.502-1.402-1.38-3.163-2.286-4.896-2.897\"/><path d=\"m40.35 45.46h-16.69c-.873 0-.873-3 0-3h16.689c.874 0 .874 3 .001 3\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"14\" height=\"12\" viewBox=\"0 0 14 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.87952 0.635276C7.50195 -0.0659244 6.49615 -0.0659258 6.11858 0.635275L0.792799 10.526C0.434059 11.1922 0.916595 12.0001 1.67327 12.0001H12.3248C13.0815 12.0001 13.564 11.1922 13.2053 10.526L7.87952 0.635276ZM7.80154 3.37835H6.19681V5.29583L6.62234 8.82318H7.38626L7.80154 5.29583V3.37835ZM7.76053 9.42816H6.2327V10.9098H7.76053V9.42816Z\" fill=\"#EF6161\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.75 17\"><defs><style>.cls-1{fill:#9d9d9d}.cls-2{fill:none;stroke:#9d9d9d;stroke-linecap:round;stroke-linejoin:round}</style></defs><title>Artboard 186</title><g id=\"Layer_25\" data-name=\"Layer 25\"><path class=\"cls-1\" d=\"M8.34,1.47a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-1a8,8,0,1,0,8,8,8,8,0,0,0-8-8\"/><path class=\"cls-1\" d=\"M10.67,5.83a1,1,0,1,0,1,1,1,1,0,0,0-1-1\"/><path class=\"cls-1\" d=\"M6,5.83a1,1,0,1,0,0,2,1,1,0,0,0,0-2\"/><path class=\"cls-2\" d=\"M5.46,10a3,3,0,0,0,5.75,0\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path d=\"M9.34214 11.07V10.3427C9.5434 10.2571 9.81174 10.1716 10.1472 10.086C10.4826 9.9862 10.8382 9.90064 11.2138 9.82934C11.5895 9.75804 11.9585 9.701 12.3208 9.65822C12.6964 9.60118 13.0252 9.57266 13.3069 9.57266L13.6692 9.82934L11.8579 19.0486H13.2667V19.7759C13.0922 19.9042 12.8843 20.0254 12.6428 20.1395C12.4147 20.2536 12.1665 20.3534 11.8981 20.439C11.6432 20.5245 11.3815 20.5887 11.1132 20.6315C10.8449 20.6885 10.5899 20.717 10.3484 20.717C9.83857 20.717 9.48302 20.6172 9.28176 20.4176C9.09392 20.2037 9 19.9755 9 19.7331C9 19.4479 9.02012 19.1698 9.06038 18.8989C9.10063 18.6279 9.1543 18.3285 9.22138 18.0005L10.5899 11.3694L9.34214 11.07ZM11.0327 6.25715C11.0327 5.7723 11.187 5.3944 11.4956 5.12346C11.8042 4.85251 12.1933 4.71704 12.6629 4.71704C13.1727 4.71704 13.5753 4.85251 13.8704 5.12346C14.179 5.3944 14.3333 5.7723 14.3333 6.25715C14.3333 6.71348 14.179 7.07711 13.8704 7.34806C13.5753 7.619 13.1727 7.75448 12.6629 7.75448C12.1933 7.75448 11.8042 7.619 11.4956 7.34806C11.187 7.07711 11.0327 6.71348 11.0327 6.25715Z\" fill=\"#0A0A0A\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1.71704C5.92487 1.71704 0.999999 6.64191 1 12.717C1 18.7922 5.92487 23.717 12 23.717C18.0751 23.717 23 18.7922 23 12.717C23 6.64191 18.0751 1.71704 12 1.71704ZM0 12.717C-5.79387e-07 6.08962 5.37258 0.717042 12 0.717041C18.6274 0.71704 24 6.08962 24 12.717C24 19.3445 18.6274 24.717 12 24.717C5.37258 24.717 5.79387e-07 19.3445 0 12.717Z\" fill=\"#0A0A0A\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M7.77779 13.5941C7.73264 13.8297 7.52658 14 7.28673 14H6.60493C6.29105 14 6.05479 13.7142 6.11387 13.4059L8.22221 2.40588C8.26736 2.17032 8.47342 2 8.71327 2H9.39507C9.70895 2 9.94521 2.28584 9.88613 2.59412L7.77779 13.5941Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path opacity=\"0.9\" d=\"M7.77779 13.5941C7.73264 13.8297 7.52658 14 7.28673 14H6.60493C6.29105 14 6.05479 13.7142 6.11387 13.4059L8.22221 2.40588C8.26736 2.17032 8.47342 2 8.71327 2H9.39507C9.70895 2 9.94521 2.28584 9.88613 2.59412L7.77779 13.5941Z\" fill=\"#34363B\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M3.58757 4.01385H2.99366V1.72452L2.28467 1.94441V1.46147L3.52387 1.01758H3.58757V4.01385Z\" fill=\"#FCFCFD\"/> <path d=\"M6.5 2C6.22386 2 6 2.22386 6 2.5C6 2.77614 6.22386 3 6.5 3H14.5C14.7761 3 15 2.77614 15 2.5C15 2.22386 14.7761 2 14.5 2H6.5Z\" fill=\"#FCFCFD\"/> <path d=\"M6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H6.5Z\" fill=\"#FCFCFD\"/> <path d=\"M6 12.5C6 12.2239 6.22386 12 6.5 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H6.5C6.22386 13 6 12.7761 6 12.5Z\" fill=\"#FCFCFD\"/> <path d=\"M2.05648 9H4V8.52642H2.78092L3.42551 7.81707C3.60208 7.61518 3.72671 7.43835 3.79942 7.28659C3.87212 7.13482 3.90847 6.98577 3.90847 6.83943C3.90847 6.57249 3.82733 6.36585 3.66504 6.21951C3.50406 6.07317 3.27751 6 2.98539 6C2.79455 6 2.62382 6.04268 2.47322 6.12805C2.32262 6.21206 2.20578 6.32859 2.12269 6.47764C2.0409 6.62669 2 6.79133 2 6.97154H2.56475C2.56475 6.82249 2.6011 6.70257 2.67381 6.61179C2.74781 6.51965 2.84843 6.47358 2.97566 6.47358C3.0938 6.47358 3.18468 6.51152 3.2483 6.5874C3.31191 6.66192 3.34372 6.7649 3.34372 6.89634C3.34372 6.99255 3.31321 7.09417 3.25219 7.20122C3.19247 7.30827 3.09964 7.4336 2.97371 7.57724L2.05648 8.59756V9Z\" fill=\"#FCFCFD\"/> <path d=\"M2.95549 12.2433H2.65084V12.6965H2.95351C3.27003 12.6965 3.42829 12.8422 3.42829 13.1337C3.42829 13.254 3.38938 13.3509 3.31157 13.4245C3.23508 13.4967 3.12892 13.5328 2.99308 13.5328C2.87438 13.5328 2.77415 13.498 2.69238 13.4285C2.61194 13.359 2.57171 13.2694 2.57171 13.1598H2C2 13.4124 2.091 13.6156 2.273 13.7694C2.45631 13.9231 2.69172 14 2.97923 14C3.28651 14 3.53314 13.9218 3.71909 13.7654C3.90636 13.609 4 13.4011 4 13.1417C4 12.9813 3.95978 12.8422 3.87933 12.7246C3.8002 12.607 3.67953 12.5187 3.51731 12.4599C3.64787 12.3997 3.75338 12.3135 3.83383 12.2012C3.91428 12.0889 3.9545 11.9659 3.9545 11.8322C3.9545 11.5729 3.86812 11.3697 3.69535 11.2226C3.52258 11.0742 3.28388 11 2.97923 11C2.80382 11 2.64293 11.0341 2.49654 11.1023C2.35147 11.1705 2.23805 11.2654 2.15628 11.387C2.07583 11.5074 2.03561 11.6437 2.03561 11.7961H2.60732C2.60732 11.6985 2.64425 11.6197 2.7181 11.5595C2.79196 11.498 2.88361 11.4672 2.99308 11.4672C3.11441 11.4672 3.20936 11.5 3.27794 11.5655C3.34784 11.631 3.38279 11.7226 3.38279 11.8402C3.38279 11.9619 3.34784 12.0595 3.27794 12.133C3.20804 12.2066 3.10056 12.2433 2.95549 12.2433Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path d=\"M3.58757 4.01385H2.99366V1.72452L2.28467 1.94441V1.46147L3.52387 1.01758H3.58757V4.01385Z\" fill=\"#34363B\"/> <path d=\"M6.5 2C6.22386 2 6 2.22386 6 2.5C6 2.77614 6.22386 3 6.5 3H14.5C14.7761 3 15 2.77614 15 2.5C15 2.22386 14.7761 2 14.5 2H6.5Z\" fill=\"#34363B\"/> <path d=\"M6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H6.5Z\" fill=\"#34363B\"/> <path d=\"M6 12.5C6 12.2239 6.22386 12 6.5 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H6.5C6.22386 13 6 12.7761 6 12.5Z\" fill=\"#34363B\"/> <path d=\"M2.05648 9H4V8.52642H2.78092L3.42551 7.81707C3.60208 7.61518 3.72671 7.43835 3.79942 7.28659C3.87212 7.13482 3.90847 6.98577 3.90847 6.83943C3.90847 6.57249 3.82733 6.36585 3.66504 6.21951C3.50406 6.07317 3.27751 6 2.98539 6C2.79455 6 2.62382 6.04268 2.47322 6.12805C2.32262 6.21206 2.20578 6.32859 2.12269 6.47764C2.0409 6.62669 2 6.79133 2 6.97154H2.56475C2.56475 6.82249 2.6011 6.70257 2.67381 6.61179C2.74781 6.51965 2.84843 6.47358 2.97566 6.47358C3.0938 6.47358 3.18468 6.51152 3.2483 6.5874C3.31191 6.66192 3.34372 6.7649 3.34372 6.89634C3.34372 6.99255 3.31321 7.09417 3.25219 7.20122C3.19247 7.30827 3.09964 7.4336 2.97371 7.57724L2.05648 8.59756V9Z\" fill=\"#34363B\"/> <path d=\"M2.95549 12.2433H2.65084V12.6965H2.95351C3.27003 12.6965 3.42829 12.8422 3.42829 13.1337C3.42829 13.254 3.38938 13.3509 3.31157 13.4245C3.23508 13.4967 3.12892 13.5328 2.99308 13.5328C2.87438 13.5328 2.77415 13.498 2.69238 13.4285C2.61194 13.359 2.57171 13.2694 2.57171 13.1598H2C2 13.4124 2.091 13.6156 2.273 13.7694C2.45631 13.9231 2.69172 14 2.97923 14C3.28651 14 3.53314 13.9218 3.71909 13.7654C3.90636 13.609 4 13.4011 4 13.1417C4 12.9813 3.95978 12.8422 3.87933 12.7246C3.8002 12.607 3.67953 12.5187 3.51731 12.4599C3.64787 12.3997 3.75338 12.3135 3.83383 12.2012C3.91428 12.0889 3.9545 11.9659 3.9545 11.8322C3.9545 11.5729 3.86812 11.3697 3.69535 11.2226C3.52258 11.0742 3.28388 11 2.97923 11C2.80382 11 2.64293 11.0341 2.49654 11.1023C2.35147 11.1705 2.23805 11.2654 2.15628 11.387C2.07583 11.5074 2.03561 11.6437 2.03561 11.7961H2.60732C2.60732 11.6985 2.64425 11.6197 2.7181 11.5595C2.79196 11.498 2.88361 11.4672 2.99308 11.4672C3.11441 11.4672 3.20936 11.5 3.27794 11.5655C3.34784 11.631 3.38279 11.7226 3.38279 11.8402C3.38279 11.9619 3.34784 12.0595 3.27794 12.133C3.20804 12.2066 3.10056 12.2433 2.95549 12.2433Z\" fill=\"#34363B\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.33 14.75\"><defs><style>.cls-1,.cls-2{fill:none;stroke:#979798;stroke-miterlimit:10}.cls-1{stroke-width:.99px}</style></defs><title>Artboard 185</title><g id=\"Layer_25\" data-name=\"Layer 25\"><path class=\"cls-1\" d=\"M13.63,7.29A6.44,6.44,0,1,1,7.19.83,6.45,6.45,0,0,1,13.63,7.29Z\"/><line class=\"cls-2\" x1=\"6.71\" y1=\"3.53\" x2=\"6.71\" y2=\"8.82\"/><line class=\"cls-2\" x1=\"6.22\" y1=\"8.47\" x2=\"10.17\" y2=\"8.47\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=\"13px\" height=\"15px\" viewBox=\"0 0 13 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>Chrome</title> <desc>Created with Sketch.</desc> <defs> <polygon id=\"path-1\" points=\"0.539169231 0 10.9604 0 10.9604 5.607 0.539169231 5.607\"></polygon> </defs> <g id=\"Chrome\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"Group-10\" transform=\"translate(0.000000, 1.000000)\"> <g id=\"Group-3\" transform=\"translate(1.000000, 0.000000)\"> <mask id=\"mask-2\" fill=\"white\"> <use xlink:href=\"#path-1\"></use> </mask> <g id=\"Clip-2\"></g> <path d=\"M2.35586154,5.607 L0.539169231,2.42014286 C1.70263077,0.945857143 3.49309231,-0.000428571429 5.50101538,-0.000428571429 C7.82455385,-0.000428571429 9.85532308,1.26557143 10.9604,3.15214286 L5.78278462,3.15214286 C5.68801538,3.14357143 5.59493846,3.13928571 5.50101538,3.13928571 C3.98893846,3.13928571 2.71716923,4.19014286 2.35586154,5.607\" id=\"Fill-1\" fill=\"#EB3D3E\" mask=\"url(#mask-2)\"></path> </g> <path d=\"M9.10489416,4 L12.5825806,4 C12.8511528,4.7454581 13,5.55772612 13,6.40779449 C13,10.0243212 10.3199407,12.9595624 7,13 L9.48267494,8.33033796 C9.83052447,7.78443055 10.0368073,7.12160578 10.0368073,6.40779449 C10.0368073,5.46542293 9.68005932,4.61183825 9.10489416,4\" id=\"Fill-4\" fill=\"#FADA23\"></path> <path d=\"M4,6.5 C4,5.12201835 5.12130666,4 6.5004588,4 C7.87961094,4 9,5.12201835 9,6.5 C9,7.87889908 7.87961094,9 6.5004588,9 C5.12130666,9 4,7.87889908 4,6.5\" id=\"Fill-6\" fill=\"#2794D7\"></path> <path d=\"M7,9.64744052 L5.23768762,13 C2.27204503,12.5124369 0,9.70421774 0,6.314708 C0,5.11067051 0.286468105,3.9796323 0.788813321,3 L3.30300188,7.78100216 C3.80616792,8.95620043 4.8962242,9.77361211 6.1570122,9.77361211 C6.4467636,9.77361211 6.73241088,9.72945205 7,9.64744052\" id=\"Fill-8\" fill=\"#5BC42A\"></path> </g> </g> </svg>";
// Exports
module.exports = code;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"><defs><style>.cls-1{fill:#4080f2}.cls-2{fill:#fff}.cls-3{fill:none}</style></defs><title>MaaM_icon</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M8,29.48C9,30.11,9.18,35,3.24,37.83c0,0,8.38,1.42,13.71-5.52a36.64,36.64,0,0,0,4.12.63C32.49,32.94,39.5,26,39.5,17.5s-7-15.45-18.43-15.45h0C9.49,2.05.5,9,.5,17.49h0C.5,22.39,3.24,26.64,8,29.48Z\"/><path class=\"cls-2\" d=\"M17.48,18c.92.67,2.14,2,3.05,2h.31c.92,0,2.14-1.33,3.06-2,1.83-1.33,3.66-3,5.8-4.33A4.62,4.62,0,0,0,31.53,10c0-1.33-.61-2-1.83-2h-18a2.19,2.19,0,0,0-2.14,2.33c0,1.34,1.53,2.67,2.14,3.34C13.81,15,15.65,16.67,17.48,18Z\"/><path class=\"cls-2\" d=\"M30.31,15c-1.83,1.58-4,2.84-6.11,4.42a5.26,5.26,0,0,1-3.36,1.89h-.31c-1.22,0-2.44-.94-3.66-1.89-1.84-1.58-4-2.84-5.81-4.42-.61-.32-.91-.63-1.53-.95V24.11A2.07,2.07,0,0,0,11.67,26h18a1.79,1.79,0,0,0,1.83-1.89V14A4.16,4.16,0,0,1,30.31,15Z\"/><rect class=\"cls-3\" width=\"40\" height=\"40\"/></g></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=\"14px\" height=\"15px\" viewBox=\"0 0 14 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>Google</title> <desc>Created with Sketch.</desc> <g id=\"Google\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g fill-rule=\"nonzero\" id=\"Shape\"> <path d=\"M9.76,10.76 C9.95524293,10.633102 10.1362825,10.4855883 10.3,10.32 C10.7209247,9.89460792 11.009266,9.35613937 11.13,8.77 C11.13,8.77 11.13,8.77 11.13,8.77 L7.49,8.77 L7.49,6.08 L13.76,6.08 C13.85,6.08 13.85,6.08 13.87,6.16 C13.9220254,6.40076996 13.9587654,6.64459032 13.98,6.89 C13.9702381,6.96300846 13.9702381,7.03699154 13.98,7.11 L13.98,7.65 C13.98,7.65 13.98,7.65 13.98,7.65 C13.98,7.65 13.98,7.81 13.98,7.89 C13.9568527,8.28353611 13.9033605,8.67469817 13.82,9.06 C13.6935456,9.64500014 13.4883425,10.2101497 13.21,10.74 C12.9400496,11.2397211 12.6036586,11.7005768 12.21,12.11 C12.1141526,12.2174565 12.0105404,12.3177263 11.9,12.41 L11.9,12.41 L10.37,11.22 C10.17,11.08 10,10.93 9.76,10.76 Z\" fill=\"#3E82F6\"></path> <path d=\"M7.28,0.5 L7.7,0.5 C8.57623326,0.527056861 9.43887125,0.72403719 10.24,1.08 C10.8481403,1.35476368 11.4138659,1.71507706 11.92,2.15 C11.9523745,2.15504594 11.9812778,2.17311049 12,2.2 L10,4.2 C9.94353631,4.15196959 9.88334707,4.10849958 9.82,4.07 C9.29045822,3.66323352 8.66238082,3.40441041 8,3.32 C6.10448144,3.0657105 4.294144,4.18879021 3.68,6 L3.68,6.06 L1.36,4.3 C1.37476092,4.26249662 1.39144984,4.225781 1.41,4.19 C2.08893109,2.88249604 3.17300448,1.8299976 4.5,1.19 C5.14718664,0.869647084 5.84350644,0.660075106 6.56,0.57 C6.8,0.536666667 7.04,0.513333333 7.28,0.5 Z\" fill=\"#EC412D\"></path> <path d=\"M7.7,14.15 L7.28,14.15 C6.57427828,14.1251548 5.87637858,13.9936665 5.21,13.76 C4.44308288,13.49517 3.73128931,13.0918203 3.11,12.57 C2.40791124,11.9874493 1.82983713,11.2699573 1.41,10.46 C1.38910645,10.4218952 1.37234462,10.3816668 1.36,10.34 L3.65,8.59 C4.10473735,9.9900025 5.29166057,11.0271199 6.74,11.29 C7.19733632,11.3600083 7.66266368,11.3600083 8.12,11.29 C8.63892511,11.2297687 9.14140221,11.0701982 9.6,10.82 L9.76,10.73 C9.96,10.9 10.17,11.05 10.38,11.21 L11.91,12.4 L11.91,12.4 C11.6616673,12.63229 11.394037,12.8430488 11.11,13.03 C10.3754601,13.5301356 9.5442635,13.8707899 8.67,14.03 C8.34929407,14.0889509 8.02540335,14.1290199 7.7,14.15 Z\" fill=\"#2DA84F\"></path> <path d=\"M3.65,8.59 L1.36,10.34 C1.24566335,10.1165026 1.1454664,9.88604965 1.06,9.65 C0.894077003,9.17305161 0.776813722,8.68054583 0.71,8.18 C0.71,7.97 0.71,7.75 0.66,7.53 L0.66,7.11 C0.685774308,6.27430507 0.865445651,5.45052891 1.19,4.68 C1.23637876,4.5489771 1.29322901,4.42190006 1.36,4.3 L3.65,6.05 C3.47655472,6.59541136 3.41532485,7.17029179 3.47,7.74 C3.50491878,8.02807007 3.56515168,8.31250324 3.65,8.59 Z\" fill=\"#FCBC00\"></path> </g> </g> </svg>";
// Exports
module.exports = code;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16px\" height=\"16px\" viewBox=\"1.75 1.75 28.5 28.5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect x=\"2\" y=\"2\" width=\"28\" height=\"28\" rx=\"6\" fill=\"url(#paint0_radial_87_7153)\"/> <rect x=\"2\" y=\"2\" width=\"28\" height=\"28\" rx=\"6\" fill=\"url(#paint1_radial_87_7153)\"/> <rect x=\"2\" y=\"2\" width=\"28\" height=\"28\" rx=\"6\" fill=\"url(#paint2_radial_87_7153)\"/> <svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-280 -85 1385 1000\"> <defs> <style>.cls-1{fill:#fff}</style> </defs> <path class=\"cls-1\" d=\"M295.42,6c-53.2,2.51-89.53,11-121.29,23.48-32.87,12.81-60.73,30-88.45,57.82S40.89,143,28.17,175.92c-12.31,31.83-20.65,68.19-23,121.42S2.3,367.68,2.56,503.46,3.42,656.26,6,709.6c2.54,53.19,11,89.51,23.48,121.28,12.83,32.87,30,60.72,57.83,88.45S143,964.09,176,976.83c31.8,12.29,68.17,20.67,121.39,23s70.35,2.87,206.09,2.61,152.83-.86,206.16-3.39S799.1,988,830.88,975.58c32.87-12.86,60.74-30,88.45-57.84S964.1,862,976.81,829.06c12.32-31.8,20.69-68.17,23-121.35,2.33-53.37,2.88-70.41,2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45S862,40.87,829.07,28.19c-31.82-12.31-68.17-20.7-121.39-23S637.33,2.3,501.54,2.56,348.75,3.4,295.42,6m5.84,903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29,2.53-202c2.08-48.71,10.23-75.21,17-92.84,9-23.39,19.84-40,37.29-57.57s34.1-28.39,57.43-37.51c17.62-6.88,44.06-15.06,92.79-17.38,52.73-2.5,68.53-3,202-3.29s149.31.21,202.06,2.53c48.71,2.12,75.22,10.19,92.83,17,23.37,9,40,19.81,57.57,37.29s28.4,34.07,37.52,57.45c6.89,17.57,15.07,44,17.37,92.76,2.51,52.73,3.08,68.54,3.32,202s-.23,149.31-2.54,202c-2.13,48.75-10.21,75.23-17,92.89-9,23.35-19.85,40-37.31,57.56s-34.09,28.38-57.43,37.5c-17.6,6.87-44.07,15.07-92.76,17.39-52.73,2.48-68.53,3-202.05,3.29s-149.27-.25-202-2.53m407.6-674.61a60,60,0,1,0,59.88-60.1,60,60,0,0,0-59.88,60.1M245.77,503c.28,141.8,115.44,256.49,257.21,256.22S759.52,643.8,759.25,502,643.79,245.48,502,245.76,245.5,361.22,245.77,503m90.06-.18a166.67,166.67,0,1,1,167,166.34,166.65,166.65,0,0,1-167-166.34\" transform=\"translate(-2.5 -2.5)\"/> </svg> <defs> <radialGradient id=\"paint0_radial_87_7153\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(12 23) rotate(-55.3758) scale(25.5196)\"> <stop stop-color=\"#B13589\"/> <stop offset=\"0.79309\" stop-color=\"#C62F94\"/> <stop offset=\"1\" stop-color=\"#8A3AC8\"/> </radialGradient> <radialGradient id=\"paint1_radial_87_7153\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(11 31) rotate(-65.1363) scale(22.5942)\"> <stop stop-color=\"#E0E8B7\"/> <stop offset=\"0.444662\" stop-color=\"#FB8A2E\"/> <stop offset=\"0.71474\" stop-color=\"#E2425C\"/> <stop offset=\"1\" stop-color=\"#E2425C\" stop-opacity=\"0\"/> </radialGradient> <radialGradient id=\"paint2_radial_87_7153\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)\"> <stop offset=\"0.156701\" stop-color=\"#406ADC\"/> <stop offset=\"0.467799\" stop-color=\"#6A45BE\"/> <stop offset=\"1\" stop-color=\"#6A45BE\" stop-opacity=\"0\"/> </radialGradient> </defs> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=\"15px\" height=\"15px\" viewBox=\"0 0 15 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>RCS</title> <desc>Created with Sketch.</desc> <g id=\"RCS\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"Group-9\" transform=\"translate(1.000000, 1.000000)\"> <path d=\"M6.5,0 L0.266,0 C0.119,0 0,0.119 0,0.266 L0,6.5 C0,10.09 2.91,13 6.5,13 C10.09,13 13,10.09 13,6.5 C13,2.91 10.09,0 6.5,0\" id=\"Fill-1\" fill=\"#C0C0C0\"></path> <path d=\"M4.6597,1.8984 L1.8747,1.8984 C1.8087,1.8984 1.7557,1.9514 1.7557,2.0174 L1.7557,4.8024 C1.7557,6.4064 3.0557,7.7064 4.6597,7.7064 C6.2637,7.7064 7.5637,6.4064 7.5637,4.8024 C7.5637,3.1984 6.2637,1.8984 4.6597,1.8984\" id=\"Fill-3\" fill=\"#484848\"></path> <path d=\"M5.6367,2.8755 L2.8507,2.8755 C2.7857,2.8755 2.7327,2.9285 2.7327,2.9945 L2.7327,5.7795 C2.7327,7.3835 4.0327,8.6835 5.6367,8.6835 C7.2407,8.6835 8.5407,7.3835 8.5407,5.7795 C8.5407,4.1755 7.2407,2.8755 5.6367,2.8755\" id=\"Fill-5\" fill=\"#747474\"></path> <path d=\"M6.6138,3.8525 L3.8278,3.8525 C3.7628,3.8525 3.7098,3.9055 3.7098,3.9715 L3.7098,6.7565 C3.7098,8.3605 5.0098,9.6605 6.6138,9.6605 C8.2178,9.6605 9.5178,8.3605 9.5178,6.7565 C9.5178,5.1525 8.2178,3.8525 6.6138,3.8525\" id=\"Fill-7\" fill=\"#F2F2F2\"></path> </g> </g> </svg>";
// Exports
module.exports = code;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=\"13px\" height=\"15px\" viewBox=\"0 0 13 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <title>Safari</title> <desc>Created with Sketch.</desc> <g id=\"Safari\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"Group-11\"> <path d=\"M6.5,0.875875 C6.17326667,0.875875 5.8526,0.900375 5.5406,0.94675 C5.53713333,0.935375 5.53193333,0.92575 5.52673333,0.916125 C5.70093333,0.77875 5.79193333,0.58975 5.7538,0.4025 C5.70093333,0.16275 5.4496,0 5.1246,0 C5.05266667,0 4.9816,0.00875 4.91053333,0.023625 C4.50233333,0.111125 4.2328,0.415625 4.29433333,0.714875 C4.33333333,0.89775 4.48933333,1.033375 4.70513333,1.089375 C4.70253333,1.1025 4.70426667,1.115625 4.70513333,1.1305 C1.989,1.91625 0,4.442375 0,7.4375 C0,11.062625 2.9094,14 6.5,14 C10.0888667,14 13,11.062625 13,7.4375 C13,3.814125 10.0888667,0.875875 6.5,0.875875\" id=\"Fill-1\" fill=\"#C2C2C3\"></path> <path d=\"M10.39048,11.3894712 C9.7252,12.0539243 8.92,12.5265221 8.04176,12.7817425 L7.40112,11.7406192 L7.2392,12.949836 C6.9972,12.9832787 6.74816,13 6.5,13 C5.02952,13 3.6488,12.4279542 2.6104,11.3894712 C1.94512,10.7241379 1.47256,9.91887351 1.21824,9.04232339 L2.25664,8.40163213 L1.05016,8.23881911 C1.01672,7.99679974 1,7.74949996 1,7.49955996 C1,6.02984239 1.572,4.64989199 2.6104,3.61052884 C3.27568,2.94607569 4.08088,2.47171774 4.95736,2.21825746 L5.598,3.25674054 L5.75992,2.05016401 C6.00368,2.01672134 6.25008,2 6.5,2 C7.96784,2 9.34944,2.57204576 10.39048,3.61052884 C11.05224,4.274982 11.52568,5.07936635 11.78176,5.95679654 L10.74072,6.59836787 L11.94896,6.75942075 C11.98152,7.00320026 12,7.25050004 12,7.49955996 C12,8.96927754 11.428,10.3509881 10.39048,11.3894712\" id=\"Fill-3\" fill=\"#11A4F2\"></path> <path d=\"M6.5,6.4725 L6.5,6.5275 L6.5,6.4725 Z\" id=\"Fill-5\" fill=\"#FFFFFF\"></path> <path d=\"M7.20503921,8.65076508 C7.07725929,8.72907291 6.93508163,8.78667867 6.78120581,8.819982 C6.6858208,8.84068407 6.59223551,8.85148515 6.49955007,8.85148515 C6.4401594,8.85148515 6.38256845,8.84608461 6.32587736,8.83888389 L6.3249775,8.8379838 L6.3249775,8.83888389 C6.20169688,8.82088209 6.08291554,8.79027903 5.97313279,8.74167417 L6.97737498,7.97659766 L7.74225479,6.97119712 C7.77554956,7.04950495 7.80254531,7.13231323 7.82144234,7.21872187 C7.94292325,7.7929793 7.68016455,8.36093609 7.20503921,8.65076508 L7.20503921,8.65076508 Z M5.25774521,8.02880288 C5.2253503,7.95049505 5.1992544,7.86588659 5.17945751,7.77947795 C5.02468184,7.05130513 5.49080859,6.33393339 6.21969405,6.17911791 C6.3141792,6.15931593 6.40866435,6.15031503 6.50134979,6.15031503 C6.55894074,6.15031503 6.61743155,6.1530153 6.67592236,6.16021602 C6.79830312,6.17641764 6.91708446,6.20972097 7.02956678,6.25742574 L6.02352487,7.02070207 L5.25774521,8.02880288 Z M9.5806659,6.84428443 L7.91232806,6.8019802 C7.90602905,6.79117912 7.9006299,6.78037804 7.89523075,6.76867687 L10,4 L7.23023525,6.10531053 C7.02416763,5.99729973 6.79650341,5.93519352 6.56344003,5.92619262 L5.84625273,4.41854185 L5.8012598,6.08640864 C5.61498907,6.17911791 5.44851523,6.30783078 5.31173673,6.46624662 L4.42627587,6.15211521 L5.0732742,6.83438344 C4.9841882,7.02430243 4.93469598,7.22862286 4.92659725,7.43564356 L3.42023396,8.15571557 L5.0885718,8.19891989 C5.09487081,8.20882088 5.10116982,8.21962196 5.10476925,8.22952295 L3,11 L5.76976475,8.89468947 C5.97583237,9.00360036 6.20529631,9.06570657 6.43655997,9.07470747 L7.15554699,10.5814581 L7.19784034,8.91179118 C7.38501093,8.819982 7.55148477,8.69306931 7.68916313,8.53285329 L8.57552385,8.84878488 L7.92852552,8.16381638 C8.01761152,7.97479748 8.06710374,7.77047705 8.07520247,7.56345635 L9.5806659,6.84428443 Z\" id=\"Fill-7\" fill=\"#FFFFFF\"></path> <polygon id=\"Fill-9\" fill=\"#EB3D3E\" points=\"6.960181 8 10 4 6 7.03847895\"></polygon> </g> </g> </svg>";
// Exports
module.exports = code;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\"><defs><style>.cls-1{fill:#aaa99f}.cls-2{fill:#fff}</style></defs><title>Artboard 66 copy 9</title><g id=\"Layer_10\" data-name=\"Layer 10\"><path class=\"cls-1\" d=\"M8.51.57a8,8,0,1,1-8,8,8,8,0,0,1,8-8\"/><path class=\"cls-2\" d=\"M12,9.38H5A.81.81,0,0,1,5,7.76h7a.81.81,0,0,1,0,1.62Z\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <g fill=\"none\" fill-rule=\"evenodd\"> <path fill=\"#EE152F\" d=\"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0\"/> <path fill=\"#FFF\" d=\"M12.108 8.875H3.892a.875.875 0 0 1 0-1.75h8.216a.875.875 0 0 1 0 1.75\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\"><defs><style>.cls-1{fill:#aaa99f}.cls-2{fill:#fff}</style></defs><title>Artboard 66 copy 10</title><g id=\"Layer_10\" data-name=\"Layer 10\"><path class=\"cls-1\" d=\"M8.51.57a8,8,0,1,1-8,8,8,8,0,0,1,8-8\"/><path class=\"cls-2\" d=\"M10.21,11l-2.28-2V5.18a.75.75,0,1,1,1.49,0V8.29l1.87,1.58a.79.79,0,0,1,.12,1.1.92.92,0,0,1-.59.21.89.89,0,0,1-.61-.23\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <g fill=\"none\" fill-rule=\"evenodd\"> <path fill=\"#DA6900\" d=\"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0\"/> <path fill=\"#FFF\" d=\"M8.779 11.504L6.286 9.28V5.193c0-.472.344-.85.815-.85.467 0 .816.378.816.85v3.403l2.049 1.73c.324.336.461.873.126 1.2-.164.155-.436.235-.647.235-.22 0-.497-.084-.666-.257\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\"><defs><style>.cls-1{fill:#aaa99f}.cls-2{fill:#fff}</style></defs><title>Artboard 66 copy 11</title><g id=\"Layer_10\" data-name=\"Layer 10\"><path class=\"cls-1\" d=\"M8.51.57a8,8,0,1,1-8,8,8,8,0,0,1,8-8\"/></g><g id=\"Layer_13\" data-name=\"Layer 13\"><path class=\"cls-2\" d=\"M12.35,6.56l-3.9,4.71a.61.61,0,0,1-.45.27H7.94a.61.61,0,0,1-.44-.18L5.68,9.68a.62.62,0,0,1,.87-.87L7.84,10l3.48-4.08a.62.62,0,1,1,1,.68Z\"/></g></svg>";
// Exports
module.exports = code;

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <g fill=\"none\" fill-rule=\"evenodd\"> <path fill=\"#358E12\" d=\"M7.997 0a7.947 7.947 0 0 0-5.654 2.342A7.96 7.96 0 0 0 0 8c0 2.138.832 4.146 2.343 5.656A7.937 7.937 0 0 0 7.997 16a7.96 7.96 0 0 0 5.661-2.344A7.949 7.949 0 0 0 16 8a7.934 7.934 0 0 0-2.342-5.655A7.96 7.96 0 0 0 7.997 0\"/> <path fill=\"#FFF\" d=\"M11.881 6.302l-4.488 4.76a.723.723 0 0 1-.52.27l-.067.001a.75.75 0 0 1-.503-.18L4.207 9.465a.572.572 0 0 1 0-.881.78.78 0 0 1 1.003 0l1.486 1.152L10.7 5.613c.218-.292.661-.364.986-.174.324.194.41.579.194.863\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#A0C125\" fill-opacity=\"0.47\"/> <path transform=\"translate(6,6.5)\" d=\"M12.242 2.04504L4.92375 9.41706L4.85376 9.47464L4.74628 9.53953L4.66245 9.57454L4.54569 9.60449L4.42062 9.61496L4.32532 9.60859L4.21354 9.58489L4.10649 9.54396L3.97187 9.46128L3.8728 9.36928L0.472223 5.59238C0.195006 5.28448 0.216074 4.80668 0.51928 4.52518C0.788795 4.27495 1.19051 4.26405 1.47116 4.48096L1.57023 4.57296L4.4471 7.7688L11.1942 0.972557C11.4858 0.678731 11.9568 0.680621 12.2462 0.976779C12.5034 1.24003 12.5305 1.64718 12.3285 1.94077L12.242 2.04504Z\" fill=\"#1BC966\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.64645 10.8284L7.64926 10.8256L11.8891 6.58577C12.2796 6.19524 12.2796 5.56208 11.8891 5.17156C11.4986 4.78103 10.8654 4.78103 10.4749 5.17156L6.93933 8.7071L5.52513 7.29289C5.1346 6.90236 4.50144 6.90236 4.11091 7.29289C3.72039 7.68341 3.72039 8.31658 4.11091 8.7071L6.23223 10.8284C6.62276 11.2189 7.25592 11.2189 7.64645 10.8284Z\" fill=\"#7D9E1A\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M4 15.5C4 15.2239 4.22386 15 4.5 15H11.5C11.7761 15 12 15.2239 12 15.5C12 15.7761 11.7761 16 11.5 16H4.5C4.22386 16 4 15.7761 4 15.5Z\" fill=\"#FCFCFD\"/> <path d=\"M11.5 2C11.7761 2 12 2.22386 12 2.5V9.96582C11.9951 11.1058 11.6742 12.0382 11.0374 12.7632C10.4055 13.4881 9.54648 13.8949 8.46042 13.9834L8.02701 14C6.84714 14 5.76732 13.6431 5.06632 12.9292C4.36531 12.2153 4.00987 11.2331 4 9.98242V2.5C4 2.22386 4.22386 2 4.5 2H4.90695C5.18309 2 5.40695 2.22386 5.40695 2.5V9.93262C5.40695 10.807 5.62169 11.4876 6.05118 11.9746C6.48067 12.4561 7.2322 12.6968 8.02701 12.6968C8.83168 12.6968 9.50205 12.4561 9.9266 11.9746C10.3561 11.4932 10.5708 10.8153 10.5708 9.94092V2.5C10.5708 2.22386 10.7947 2 11.0708 2H11.5Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <g opacity=\"0.9\"> <path d=\"M4 15.5C4 15.2239 4.22386 15 4.5 15H11.5C11.7761 15 12 15.2239 12 15.5C12 15.7761 11.7761 16 11.5 16H4.5C4.22386 16 4 15.7761 4 15.5Z\" fill=\"#34363B\"/> <path d=\"M11.5 2C11.7761 2 12 2.22386 12 2.5V9.96582C11.9951 11.1058 11.6742 12.0382 11.0374 12.7632C10.4055 13.4881 9.54648 13.8949 8.46042 13.9834L8.02701 14C6.84714 14 5.76732 13.6431 5.06632 12.9292C4.36531 12.2153 4.00987 11.2331 4 9.98242V2.5C4 2.22386 4.22386 2 4.5 2H4.90695C5.18309 2 5.40695 2.22386 5.40695 2.5V9.93262C5.40695 10.807 5.62169 11.4876 6.05118 11.9746C6.48067 12.4561 7.2322 12.6968 8.02701 12.6968C8.83168 12.6968 9.50205 12.4561 9.9266 11.9746C10.3561 11.4932 10.5708 10.8153 10.5708 9.94092V2.5C10.5708 2.22386 10.7947 2 11.0708 2H11.5Z\" fill=\"#34363B\"/> </g> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// Module
var code = "<svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path opacity=\"0.9\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8535 0.646447C13.0487 0.841709 13.0487 1.15829 12.8535 1.35355L4.49992 9.70711L0.146371 5.35355C-0.0488915 5.15829 -0.0488911 4.84171 0.146371 4.64645C0.341633 4.45118 0.658215 4.45118 0.853478 4.64645L4.49992 8.29289L12.1464 0.646447C12.3416 0.451184 12.6582 0.451184 12.8535 0.646447Z\" fill=\"#FCFCFD\"/> </svg> ";
// Exports
module.exports = code;

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{ref:"column-th",class:['le-table-column', (_vm.id + "-header"), { 'has-icon': _vm.hasIcon }, { 'has-title': _vm.hasTitle} ],style:(_vm.tableColumnStyle),attrs:{"scope":"col","aria-sort":_vm.getSortState,"column-id":_vm.id,"data-position":("[" + (_vm.currentPosition.row) + ", " + (_vm.currentPosition.column) + "]"),"tabindex":"-1","data-test":("le-table-column_" + _vm.id)}},[(_vm.hasTitle)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.header.tooltip, html: true, autoHide: false, show: _vm.displayTooltip }),expression:"{ content: header.tooltip, html: true, autoHide: false, show: displayTooltip }",modifiers:{"bottom":true}},{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideTooltip),expression:"hideTooltip"}],ref:"column-wrapper",staticClass:"wrapper",style:(_vm.tableColumnWrapperStyle),attrs:{"role":_vm.isSortableColumn ? 'button': '',"tabindex":"-1"},on:{"click":_vm.onSortClick,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onSortClick($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"escape",undefined,$event.key,undefined)){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.hideTooltip($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.hideTooltip($event)}],"focus":_vm.showTooltip,"mouseover":_vm.onTableHeaderMouseOver,"mouseleave":_vm.onTableHeaderMouseLeave}},[(_vm.hasIcon)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({ content: _vm.header.tooltip, html: false, autoHide: false, show: _vm.displayTooltip }),expression:"{ content: header.tooltip, html: false, autoHide: false, show: displayTooltip }",modifiers:{"bottom":true}}],class:['icon', 'ico-16', ("" + (_vm.header.icon))],attrs:{"data-test":"le-table-column_icon"}}):_vm._e(),_vm._v(" "),(_vm.hasTitle)?_c('span',{staticClass:"title",style:({ 'max-width': _vm.columnTitleMaxWidth }),attrs:{"data-test":"le-table-column_title_text"}},[_vm._v("\n      "+_vm._s(_vm.header.text)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.isSortableColumn)?_c('div',{staticClass:"sort-icons"},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldDisplayAscOrderIcon),expression:"shouldDisplayAscOrderIcon"}],staticClass:"ico-sorting-up",attrs:{"data-test":"le-table-column_sort_btn_asc"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldDisplayDescOrderIcon),expression:"shouldDisplayDescOrderIcon"}],staticClass:"ico-sorting-down",attrs:{"data-test":"le-table-column_sort_btn_desc"}})]):_vm._e(),_vm._v(" "),(_vm.hasFilterConfiguration)?_c('le-filter',_vm._b({attrs:{"showIcon":_vm.displayFilterAndSortIcons,"iconSize":_vm.filtersIconSize,"placement":_vm.filterBubblePosition},on:{"filter":_vm.onFilterClick,"reset":_vm.onFilterResetClick}},'le-filter',_vm.filterConfiguration,false)):_vm._e(),_vm._v(" "),(_vm.hasActionIcon)?_c('le-toggle-selection-icon',{class:['action-icon', 'ico-14'],attrs:{"icon":_vm.actionIconName,"isActive":_vm.header.actionIcon.isActive,"aria-selected":_vm.header.actionIcon.isActive.toString(),"tabindex":"-1","role":"button","data-test":"table-column_action_icon"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onActionIconClick($event)}},nativeOn:{"click":function($event){return _vm.onActionIconClick($event)}}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_row_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed7cd9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_row_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed7cd9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bc4c010", content, true, {});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-table-row{outline:none}.le-table-row.theme-dark,.theme-dark .le-table-row{border-bottom:1px solid #595a80}.le-table-row.theme-light,.theme-light .le-table-row{border-bottom:1px solid #d8d8d8}.le-table-row.theme-dark,.theme-dark .le-table-row{background-color:transparent;color:#fff}.le-table-row.theme-light,.theme-light .le-table-row{background-color:#fff;color:#666}.le-table-row.focused{outline:none!important}.le-table-row.focused.theme-dark,.theme-dark .le-table-row.focused{background:rgba(169,175,186,.3)}.le-table-row.focused.theme-light,.theme-light .le-table-row.focused{background:hsla(0,0%,87%,.5)}.le-table-row.focused.theme-dark.show-a11y-focus-outline,.theme-dark.show-a11y-focus-outline .le-table-row.focused{-webkit-box-shadow:inset 0 0 0 2px #52c7ef!important;box-shadow:inset 0 0 0 2px #52c7ef!important}.le-table-row.focused.theme-light.show-a11y-focus-outline,.theme-light.show-a11y-focus-outline .le-table-row.focused{-webkit-box-shadow:inset 0 0 0 2px #0c5de6!important;box-shadow:inset 0 0 0 2px #0c5de6!important}.le-table-row.edited.theme-dark,.le-table-row.hovered.theme-dark,.theme-dark .le-table-row.edited,.theme-dark .le-table-row.hovered{background:rgba(169,175,186,.2)}.le-table-row.edited.theme-light,.le-table-row.hovered.theme-light,.theme-light .le-table-row.edited,.theme-light .le-table-row.hovered{background:hsla(0,0%,95%,.8)}.le-table-row.actionable.edited,.le-table-row.actionable.hovered{cursor:pointer}.le-table-row td{padding:0 0 0 15px}.le-table-row td.checkbox-cell{position:relative}.le-table-row td.color-cell{padding:0}.le-table-row td.color-cell .row-color{width:5px;height:57px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table-row.vue"],"names":[],"mappings":"AAIA,cACE,YAAc,CACf,AACD,mDAEI,+BAAiC,CACpC,AACD,qDAEI,+BAAiC,CACpC,AACD,mDAEI,6BAA8B,AAC9B,UAAe,CAClB,AACD,qDAEI,sBAA0B,AAC1B,UAAe,CAClB,AACD,sBACI,sBAAyB,CAC5B,AACD,mEAEM,+BAAqC,CAC1C,AACD,qEAEM,4BAAqC,CAC1C,AACD,mHAEM,qDAAuD,AAC/C,4CAA+C,CAC5D,AACD,qHAEM,qDAAuD,AAC/C,4CAA+C,CAC5D,AACD,oIAGI,+BAAqC,CACxC,AACD,wIAGI,4BAAqC,CACxC,AACD,iEACI,cAAgB,CACnB,AACD,iBACI,kBAAoB,CACvB,AACD,+BACM,iBAAmB,CACxB,AACD,4BACM,SAAW,CAChB,AACD,uCACQ,UAAW,AACX,WAAa,CACpB","file":"le-table-row.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-table-row {\n  outline: none;\n}\n.le-table-row.theme-dark,\n  .theme-dark .le-table-row {\n    border-bottom: 1px solid #595a80;\n}\n.le-table-row.theme-light,\n  .theme-light .le-table-row {\n    border-bottom: 1px solid #d8d8d8;\n}\n.le-table-row.theme-dark,\n  .theme-dark .le-table-row {\n    background-color: transparent;\n    color: #ffffff;\n}\n.le-table-row.theme-light,\n  .theme-light .le-table-row {\n    background-color: #ffffff;\n    color: #666666;\n}\n.le-table-row.focused {\n    outline: none !important;\n}\n.le-table-row.focused.theme-dark,\n    .theme-dark .le-table-row.focused {\n      background: rgba(169, 175, 186, 0.3);\n}\n.le-table-row.focused.theme-light,\n    .theme-light .le-table-row.focused {\n      background: rgba(221, 221, 221, 0.5);\n}\n.le-table-row.focused.theme-dark.show-a11y-focus-outline,\n    .theme-dark.show-a11y-focus-outline .le-table-row.focused {\n      -webkit-box-shadow: inset 0 0 0 2px #52c7ef !important;\n              box-shadow: inset 0 0 0 2px #52c7ef !important;\n}\n.le-table-row.focused.theme-light.show-a11y-focus-outline,\n    .theme-light.show-a11y-focus-outline .le-table-row.focused {\n      -webkit-box-shadow: inset 0 0 0 2px #0c5de6 !important;\n              box-shadow: inset 0 0 0 2px #0c5de6 !important;\n}\n.le-table-row.hovered.theme-dark,\n  .theme-dark .le-table-row.hovered, .le-table-row.edited.theme-dark,\n  .theme-dark .le-table-row.edited {\n    background: rgba(169, 175, 186, 0.2);\n}\n.le-table-row.hovered.theme-light,\n  .theme-light .le-table-row.hovered, .le-table-row.edited.theme-light,\n  .theme-light .le-table-row.edited {\n    background: rgba(242, 242, 242, 0.8);\n}\n.le-table-row.actionable.hovered, .le-table-row.actionable.edited {\n    cursor: pointer;\n}\n.le-table-row td {\n    padding: 0 0 0 15px;\n}\n.le-table-row td.checkbox-cell {\n      position: relative;\n}\n.le-table-row td.color-cell {\n      padding: 0;\n}\n.le-table-row td.color-cell .row-color {\n        width: 5px;\n        height: 57px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:['le-table-row', { hovered: _vm.isHovered, focused: _vm.isFocused, edited: _vm.isEdited, actionable: _vm.isActionable }],style:(("height:" + _vm.rowHeight + "px;")),on:{"mouseenter":_vm.onRowMouseEnter,"mouseleave":_vm.onRowMouseLeave}},[(!!_vm.rowColor)?_c('td',{staticClass:"color-cell",on:{"click":_vm.onRowClick}},[_c('div',{staticClass:"row-color",style:(("background-color:" + _vm.rowColor + ";"))})]):_vm._e(),_vm._v(" "),(_vm.showCheckbox)?_c('td',{staticClass:"checkbox-cell",on:{"click":_vm.onRowClick}},[_c('le-checkbox',{attrs:{"state":_vm.isCheckboxChecked},on:{"change":_vm.onCheckboxChange},nativeOn:{"click":function($event){$event.stopPropagation();}}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return _c('td',{class:column.id + '-cell',attrs:{"data-position":("[" + (_vm.currentPosition.row) + ", " + index + "]")},on:{"click":function($event){return _vm.onColumnClick(column, $event)}}},[_vm._t(column.id)],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_loader_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d7305c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_loader_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21d7305c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(477);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("191a6d86", content, true, {});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-table-loader{width:3350px;overflow:hidden}.le-table-loader .title{height:30px}.le-table-loader .first-line{padding-top:3px}.le-table-loader .first-line .first-line-content{background-color:#f2f2f2;height:55px}.le-table-loader .first-line .first-line-separator{position:relative;height:1px;margin:1.8px 0 0 -10px}.le-table-loader .first-line .first-line-separator .first-line-separator-svg{position:absolute}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table-loader.vue"],"names":[],"mappings":"AAIA,iBACE,aAAc,AACd,eAAiB,CAClB,AACD,wBACI,WAAa,CAChB,AACD,6BACI,eAAiB,CACpB,AACD,iDACM,yBAA0B,AAC1B,WAAa,CAClB,AACD,mDACM,kBAAmB,AACnB,WAAY,AACZ,sBAAwB,CAC7B,AACD,6EACQ,iBAAmB,CAC1B","file":"le-table-loader.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-table-loader {\n  width: 3350px;\n  overflow: hidden;\n}\n.le-table-loader .title {\n    height: 30px;\n}\n.le-table-loader .first-line {\n    padding-top: 3px;\n}\n.le-table-loader .first-line .first-line-content {\n      background-color: #f2f2f2;\n      height: 55px;\n}\n.le-table-loader .first-line .first-line-separator {\n      position: relative;\n      height: 1px;\n      margin: 1.8px 0 0 -10px;\n}\n.le-table-loader .first-line .first-line-separator .first-line-separator-svg {\n        position: absolute;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentLoader; });
/* unused harmony export BulletListLoader */
/* unused harmony export CodeLoader */
/* unused harmony export FacebookLoader */
/* unused harmony export ListLoader */
/* unused harmony export InstagramLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props__);


var uid = (function () {
  return Math.random().toString(36).substring(2);
});

var ContentLoader = {
  name: 'ContentLoader',
  functional: true,
  props: {
    width: {
      type: [Number, String],
      "default": 400
    },
    height: {
      type: [Number, String],
      "default": 130
    },
    speed: {
      type: Number,
      "default": 2
    },
    preserveAspectRatio: {
      type: String,
      "default": 'xMidYMid meet'
    },
    baseUrl: {
      type: String,
      "default": ''
    },
    primaryColor: {
      type: String,
      "default": '#f9f9f9'
    },
    secondaryColor: {
      type: String,
      "default": '#ecebeb'
    },
    primaryOpacity: {
      type: Number,
      "default": 1
    },
    secondaryOpacity: {
      type: Number,
      "default": 1
    },
    uniqueKey: {
      type: String
    },
    animate: {
      type: Boolean,
      "default": true
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var idClip = props.uniqueKey ? props.uniqueKey + "-idClip" : uid();
    var idGradient = props.uniqueKey ? props.uniqueKey + "-idGradient" : uid();
    return h("svg", __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([data, {
      attrs: {
        viewBox: "0 0 " + props.width + " " + props.height,
        version: "1.1",
        preserveAspectRatio: props.preserveAspectRatio
      }
    }]), [h("rect", {
      style: {
        fill: "url(" + props.baseUrl + "#" + idGradient + ")"
      },
      attrs: {
        "clip-path": "url(" + props.baseUrl + "#" + idClip + ")",
        x: "0",
        y: "0",
        width: props.width,
        height: props.height
      }
    }), h("defs", [h("clipPath", {
      attrs: {
        id: idClip
      }
    }, [children || h("rect", {
      attrs: {
        x: "0",
        y: "0",
        rx: "5",
        ry: "5",
        width: props.width,
        height: props.height
      }
    })]), h("linearGradient", {
      attrs: {
        id: idGradient
      }
    }, [h("stop", {
      attrs: {
        offset: "0%",
        "stop-color": props.primaryColor,
        "stop-opacity": props.primaryOpacity
      }
    }, [props.animate ? h("animate", {
      attrs: {
        attributeName: "offset",
        values: "-2; 1",
        dur: props.speed + "s",
        repeatCount: "indefinite"
      }
    }) : null]), h("stop", {
      attrs: {
        offset: "50%",
        "stop-color": props.secondaryColor,
        "stop-opacity": props.secondaryOpacity
      }
    }, [props.animate ? h("animate", {
      attrs: {
        attributeName: "offset",
        values: "-1.5; 1.5",
        dur: props.speed + "s",
        repeatCount: "indefinite"
      }
    }) : null]), h("stop", {
      attrs: {
        offset: "100%",
        "stop-color": props.primaryColor,
        "stop-opacity": props.primaryOpacity
      }
    }, [props.animate ? h("animate", {
      attrs: {
        attributeName: "offset",
        values: "-1; 2",
        dur: props.speed + "s",
        repeatCount: "indefinite"
      }
    }) : null])])])]);
  }
};

var BulletListLoader = {
  name: 'BulletListLoader',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    return h(ContentLoader, data, [h("circle", {
      attrs: {
        cx: "10",
        cy: "20",
        r: "8"
      }
    }), h("rect", {
      attrs: {
        x: "25",
        y: "15",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
      }
    }), h("circle", {
      attrs: {
        cx: "10",
        cy: "50",
        r: "8"
      }
    }), h("rect", {
      attrs: {
        x: "25",
        y: "45",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
      }
    }), h("circle", {
      attrs: {
        cx: "10",
        cy: "80",
        r: "8"
      }
    }), h("rect", {
      attrs: {
        x: "25",
        y: "75",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
      }
    }), h("circle", {
      attrs: {
        cx: "10",
        cy: "110",
        r: "8"
      }
    }), h("rect", {
      attrs: {
        x: "25",
        y: "105",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
      }
    })]);
  }
};

var CodeLoader = {
  name: 'CodeLoader',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    return h(ContentLoader, data, [h("rect", {
      attrs: {
        x: "0",
        y: "0",
        rx: "3",
        ry: "3",
        width: "70",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "80",
        y: "0",
        rx: "3",
        ry: "3",
        width: "100",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "190",
        y: "0",
        rx: "3",
        ry: "3",
        width: "10",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "15",
        y: "20",
        rx: "3",
        ry: "3",
        width: "130",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "155",
        y: "20",
        rx: "3",
        ry: "3",
        width: "130",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "15",
        y: "40",
        rx: "3",
        ry: "3",
        width: "90",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "115",
        y: "40",
        rx: "3",
        ry: "3",
        width: "60",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "185",
        y: "40",
        rx: "3",
        ry: "3",
        width: "60",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "60",
        rx: "3",
        ry: "3",
        width: "30",
        height: "10"
      }
    })]);
  }
};

var FacebookLoader = {
  name: 'FacebookLoader',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    return h(ContentLoader, data, [h("rect", {
      attrs: {
        x: "70",
        y: "15",
        rx: "4",
        ry: "4",
        width: "117",
        height: "6.4"
      }
    }), h("rect", {
      attrs: {
        x: "70",
        y: "35",
        rx: "3",
        ry: "3",
        width: "85",
        height: "6.4"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "80",
        rx: "3",
        ry: "3",
        width: "350",
        height: "6.4"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "100",
        rx: "3",
        ry: "3",
        width: "380",
        height: "6.4"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "120",
        rx: "3",
        ry: "3",
        width: "201",
        height: "6.4"
      }
    }), h("circle", {
      attrs: {
        cx: "30",
        cy: "30",
        r: "30"
      }
    })]);
  }
};

var ListLoader = {
  name: 'ListLoader',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    return h(ContentLoader, data, [h("rect", {
      attrs: {
        x: "0",
        y: "0",
        rx: "3",
        ry: "3",
        width: "250",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "20",
        y: "20",
        rx: "3",
        ry: "3",
        width: "220",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "20",
        y: "40",
        rx: "3",
        ry: "3",
        width: "170",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "60",
        rx: "3",
        ry: "3",
        width: "250",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "20",
        y: "80",
        rx: "3",
        ry: "3",
        width: "200",
        height: "10"
      }
    }), h("rect", {
      attrs: {
        x: "20",
        y: "100",
        rx: "3",
        ry: "3",
        width: "80",
        height: "10"
      }
    })]);
  }
};

var InstagramLoader = {
  name: 'InstagramLoader',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data;
    return h(ContentLoader, __WEBPACK_IMPORTED_MODULE_0_babel_helper_vue_jsx_merge_props___default()([data, {
      attrs: {
        height: 480
      }
    }]), [h("circle", {
      attrs: {
        cx: "30",
        cy: "30",
        r: "30"
      }
    }), h("rect", {
      attrs: {
        x: "75",
        y: "13",
        rx: "4",
        ry: "4",
        width: "100",
        height: "13"
      }
    }), h("rect", {
      attrs: {
        x: "75",
        y: "37",
        rx: "4",
        ry: "4",
        width: "50",
        height: "8"
      }
    }), h("rect", {
      attrs: {
        x: "0",
        y: "70",
        rx: "5",
        ry: "5",
        width: "400",
        height: "400"
      }
    })]);
  }
};




/***/ }),
/* 479 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-table-loader"},[_c('div',{staticClass:"svg-container title"},[_c('ContentLoader',{attrs:{"height":_vm.titleHeight,"width":_vm.loaderWidth,"speed":_vm.loaderSpeed,"primaryColor":_vm.rowPrimaryColor,"secondaryColor":_vm.rowSecondaryColor}},[_c('rect',{attrs:{"x":"0","y":"0","width":"3342","height":"1"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"29","width":"3342","height":"1"}})])],1),_vm._v(" "),_c('div',{staticClass:"svg-container first-line"},[_c('div',{staticClass:"first-line-content"},[_c('ContentLoader',{attrs:{"height":_vm.firstRowLineHeight,"width":_vm.loaderWidth,"speed":_vm.loaderSpeed,"primaryColor":_vm.firstRowPrimaryColor,"secondaryColor":_vm.firstRowSecondaryColor}},[_c('rect',{attrs:{"x":"19.6","y":"22","width":"13.5","height":"13.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"63.6","cy":"31","r":"17"}}),_vm._v(" "),_c('rect',{attrs:{"x":"96.6","y":"15","width":"78.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"96.6","y":"33","width":"142","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"309.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"409.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"508.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"608.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"707.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"807.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"906.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1005.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1105.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1204.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1304.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1403.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1503.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1602.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1701.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1801.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1900.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2000.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2099.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2199.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2298.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2397.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2497.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2596.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2696.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2795.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2895.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2994.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3093.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3193.6","y":"24","width":"50.7","height":"10"}})])],1),_vm._v(" "),_c('div',{staticClass:"first-line-separator"},[_c('ContentLoader',{staticClass:"first-line-separator-svg",attrs:{"height":1,"width":_vm.loaderWidth,"speed":_vm.loaderSpeed,"primaryColor":_vm.rowPrimaryColor,"secondaryColor":_vm.rowSecondaryColor}},[_c('rect',{attrs:{"x":"0","y":"0","width":"3342","height":"1"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"svg-container other-lines"},_vm._l((_vm.numOfRows),function(rowIndex){return _c('ContentLoader',{key:rowIndex,attrs:{"height":_vm.lineHeight,"width":_vm.loaderWidth,"speed":_vm.loaderSpeed,"primaryColor":_vm.rowPrimaryColor,"secondaryColor":_vm.rowSecondaryColor}},[_c('rect',{attrs:{"x":"19.6","y":"22","width":"13.5","height":"13.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"63.6","cy":"31","r":"17"}}),_vm._v(" "),_c('rect',{attrs:{"x":"96.6","y":"15","width":"78.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"96.6","y":"33","width":"142","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"309.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"409.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"508.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"608.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"707.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"807.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"906.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1005.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1105.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1204.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1304.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1403.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1503.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1602.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1701.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1801.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1900.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2000.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2099.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2199.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2298.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2397.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2497.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2596.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2696.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2795.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2895.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2994.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3093.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3193.6","y":"24","width":"50.7","height":"10"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"59","width":"3342","height":"1"}})])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_empty_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16694235_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_empty_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_empty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16694235_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_empty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(483);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("74f38f3d", content, true, {});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-table-empty td{text-align:center}.le-table-empty td .empty-table-image{margin-top:100px;width:100%;background-position:50%}.le-table-empty td .empty-table-image.ico-empty-image-horizontal{height:120px}.le-table-empty td .empty-table-image.ico-empty-image-vertical{height:162px}.le-table-empty td .empty-table-label{margin-top:45px;font-family:Roboto;font-size:16px}.le-table-empty td .empty-table-label.theme-dark,.theme-dark .le-table-empty td .empty-table-label{color:#fff}.le-table-empty td .empty-table-label.theme-light,.theme-light .le-table-empty td .empty-table-label{color:#656a7a}.le-table-empty td .description{margin-top:10px;font-size:14px;text-align:center}.le-table-empty td .description.theme-dark,.theme-dark .le-table-empty td .description{color:#b1b5bc}.le-table-empty td .description.theme-light,.theme-light .le-table-empty td .description{color:#9b9b9b}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table-empty.vue"],"names":[],"mappings":"AAIA,mBACE,iBAAmB,CACpB,AACD,sCACI,iBAAkB,AAClB,WAAY,AACZ,uBAAmC,CACtC,AACD,iEACM,YAAc,CACnB,AACD,+DACM,YAAc,CACnB,AACD,sCACI,gBAAiB,AACjB,mBAAoB,AACpB,cAAgB,CACnB,AACD,mGAEM,UAAe,CACpB,AACD,qGAEM,aAAe,CACpB,AACD,gCACI,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACtB,AACD,uFAEM,aAAe,CACpB,AACD,yFAEM,aAAe,CACpB","file":"le-table-empty.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-table-empty td {\n  text-align: center;\n}\n.le-table-empty td .empty-table-image {\n    margin-top: 100px;\n    width: 100%;\n    background-position: center center;\n}\n.le-table-empty td .empty-table-image.ico-empty-image-horizontal {\n      height: 120px;\n}\n.le-table-empty td .empty-table-image.ico-empty-image-vertical {\n      height: 162px;\n}\n.le-table-empty td .empty-table-label {\n    margin-top: 45px;\n    font-family: Roboto;\n    font-size: 16px;\n}\n.le-table-empty td .empty-table-label.theme-dark,\n    .theme-dark .le-table-empty td .empty-table-label {\n      color: #ffffff;\n}\n.le-table-empty td .empty-table-label.theme-light,\n    .theme-light .le-table-empty td .empty-table-label {\n      color: #656a7a;\n}\n.le-table-empty td .description {\n    margin-top: 10px;\n    font-size: 14px;\n    text-align: center;\n}\n.le-table-empty td .description.theme-dark,\n    .theme-dark .le-table-empty td .description {\n      color: #b1b5bc;\n}\n.le-table-empty td .description.theme-light,\n    .theme-light .le-table-empty td .description {\n      color: #9b9b9b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"le-table-empty"},[_c('td',{attrs:{"colspan":_vm.totalNumberOfColumns}},[_c('div',{class:_vm.iconClass,attrs:{"data-test":"le-table-empty_icon"}}),_vm._v(" "),_c('div',{class:_vm.labelClass,attrs:{"data-test":"le-table-empty_label"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),(_vm.showDescription)?_c('div',{staticClass:"description",attrs:{"data-test":"le-table-empty_description"}},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_error_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2710c3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_error_vue__ = __webpack_require__(488);
function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_table_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2710c3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_table_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(487);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7b78bda4", content, true, {});

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-table-error{height:300px}.le-table-error.no-icon{height:500px}.le-table-error.no-icon .error-message .ico-warning-triangle{display:none}.le-table-error.no-icon .error-message .label{font-size:20px}.le-table-error td{text-align:center}.le-table-error .error-message .ico-warning-triangle{margin-bottom:15px;vertical-align:middle}.le-table-error .error-message .ico-warning-triangle.theme-dark,.theme-dark .le-table-error .error-message .ico-warning-triangle{color:#ff1820}.le-table-error .error-message .ico-warning-triangle.theme-light,.theme-light .le-table-error .error-message .ico-warning-triangle{color:#d0021b}.le-table-error .error-message .label{margin-left:5px;vertical-align:middle;font-size:18px;display:block}.le-table-error .le-link{display:inline-block;margin-top:40px;font-size:14px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-table/le-table-error.vue"],"names":[],"mappings":"AAIA,gBACE,YAAc,CACf,AACD,wBACI,YAAc,CACjB,AACD,6DACM,YAAc,CACnB,AACD,8CACM,cAAgB,CACrB,AACD,mBACI,iBAAmB,CACtB,AACD,qDACI,mBAAoB,AACpB,qBAAuB,CAC1B,AACD,iIAEM,aAAe,CACpB,AACD,mIAEM,aAAe,CACpB,AACD,sCACI,gBAAiB,AACjB,sBAAuB,AACvB,eAAgB,AAChB,aAAe,CAClB,AACD,yBACI,qBAAsB,AACtB,gBAAiB,AACjB,cAAgB,CACnB","file":"le-table-error.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-table-error {\n  height: 300px;\n}\n.le-table-error.no-icon {\n    height: 500px;\n}\n.le-table-error.no-icon .error-message .ico-warning-triangle {\n      display: none;\n}\n.le-table-error.no-icon .error-message .label {\n      font-size: 20px;\n}\n.le-table-error td {\n    text-align: center;\n}\n.le-table-error .error-message .ico-warning-triangle {\n    margin-bottom: 15px;\n    vertical-align: middle;\n}\n.le-table-error .error-message .ico-warning-triangle.theme-dark,\n    .theme-dark .le-table-error .error-message .ico-warning-triangle {\n      color: #ff1820;\n}\n.le-table-error .error-message .ico-warning-triangle.theme-light,\n    .theme-light .le-table-error .error-message .ico-warning-triangle {\n      color: #d0021b;\n}\n.le-table-error .error-message .label {\n    margin-left: 5px;\n    vertical-align: middle;\n    font-size: 18px;\n    display: block;\n}\n.le-table-error .le-link {\n    display: inline-block;\n    margin-top: 40px;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"le-table-error",class:{ 'no-icon': _vm.hideErrorIcon }},[_c('td',{attrs:{"colspan":_vm.totalNumberOfColumns}},[_c('div',{staticClass:"error-message"},[_c('i',{staticClass:"ico-32 ico-warning-triangle",attrs:{"data-test":"le-table-error_warning-icon"}}),_vm._v(" "),_c('span',{staticClass:"label",attrs:{"data-test":"le-table-error_label"}},[_vm._v("\n        "+_vm._s(_vm.errorLabel)+"\n      ")])]),_vm._v(" "),(_vm.showRefresh)?_c('span',{staticClass:"le-link",attrs:{"data-test":"le-table-error_refresh-link"},on:{"click":_vm.onRefreshClick}},[_vm._v("\n      "+_vm._s(_vm.refreshLabel)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(490);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f523950", content, true, {});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-loader[data-v-b96fd10a]{border-radius:50%;width:1em;height:1em;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:loaderAnimation-data-v-b96fd10a 1.1s infinite linear;animation:loaderAnimation-data-v-b96fd10a 1.1s infinite linear}.le-loader.theme-dark[data-v-b96fd10a],.theme-dark .le-loader[data-v-b96fd10a]{border:.1em solid #fff;border-left-color:transparent}.le-loader.theme-light[data-v-b96fd10a],.theme-light .le-loader[data-v-b96fd10a]{border:.1em solid #161c4f;border-left-color:transparent}@-webkit-keyframes loaderAnimation-data-v-b96fd10a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loaderAnimation-data-v-b96fd10a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-loader/le-loader.vue"],"names":[],"mappings":"AAIA,4BACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,gCAAiC,AACjC,wBAAyB,AACzB,uEAAwE,AACxE,8DAAgE,CACjE,AACD,+EAEI,uBAA4B,AAC5B,6BAA+B,CAClC,AACD,iFAEI,0BAA4B,AAC5B,6BAA+B,CAClC,AACD,mDACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,2CACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA","file":"le-loader.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-loader[data-v-b96fd10a] {\n  border-radius: 50%;\n  width: 1em;\n  height: 1em;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-animation: loaderAnimation-data-v-b96fd10a 1.1s infinite linear;\n  animation: loaderAnimation-data-v-b96fd10a 1.1s infinite linear;\n}\n.le-loader.theme-dark[data-v-b96fd10a],\n  .theme-dark .le-loader[data-v-b96fd10a] {\n    border: 0.1em solid #ffffff;\n    border-left-color: transparent;\n}\n.le-loader.theme-light[data-v-b96fd10a],\n  .theme-light .le-loader[data-v-b96fd10a] {\n    border: 0.1em solid #161c4f;\n    border-left-color: transparent;\n}\n@-webkit-keyframes loaderAnimation-data-v-b96fd10a {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes loaderAnimation-data-v-b96fd10a {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-loader'],style:(_vm.loaderStyle),attrs:{"role":"img","aria-live":_vm.innerAriaLivePolite,"aria-label":_vm.loadingLabel,"data-test":"le-loader"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-table",class:[{ 'disabled-top-border' : _vm.hideTopBorder }],style:(_vm.tableStyle),attrs:{"data-test":"le-table"}},[_c('div',{ref:"table-wrapper",staticClass:"table-wrapper",on:{"scroll":_vm.onTableScroll}},[_c('table',{attrs:{"role":"grid","aria-labelledby":_vm.getAriaLabelledby},on:{"!keydown":function($event){return _vm.handleKeyDown($event)}}},[_c('thead',{staticClass:"le-table-columns"},[_c('tr',[(_vm.showColorsColumn)?_c('th',{ref:"column-colors-th",staticClass:"le-table-column colors-column"},[_c('div',{ref:"column-colors-wrapper",staticClass:"wrapper"})]):_vm._e(),_vm._v(" "),(_vm.allowRowSelection)?_c('th',{ref:"column-selection-th",staticClass:"le-table-column selection-column"},[_c('div',{ref:"column-selection-wrapper",staticClass:"wrapper"},[(_vm.allowMultiSelection)?_c('div',{staticClass:"multi-select-container"},[_c('le-checkbox',{attrs:{"state":_vm.selectAllCheckboxState,"data-test":"column-multiselect-checkbox"},on:{"change":_vm.onSelectAllCheckboxChange}}),_vm._v(" "),_c('div',{staticClass:"quick-selection-wrapper"},[_c('le-bubble',{attrs:{"placement":"bottom-start","autoHide":true,"bubbleInnerClass":"table-quick-selection-bubble-inner"}},[_c('template',{slot:"target"},[_c('span',{staticClass:"ico-6 ico-arrow-down"})]),_vm._v(" "),_c('template',{slot:"content"},[_c('div',{directives:[{name:"close-popover",rawName:"v-close-popover"}],staticClass:"quick-selection-item all",attrs:{"data-test":"column-multiselect-all"},on:{"click":_vm.onQuickSelectionAllItemClick}},[_vm._v("All")]),_vm._v(" "),_c('div',{directives:[{name:"close-popover",rawName:"v-close-popover"}],staticClass:"quick-selection-item none",attrs:{"data-test":"column-multiselect-none"},on:{"click":_vm.onQuickSelectionNoneItemClick}},[_vm._v("None")]),_vm._v(" "),_vm._l((_vm.quickSelectionOptions),function(quickSelectionItem){return _c('div',{directives:[{name:"close-popover",rawName:"v-close-popover"}],staticClass:"quick-selection-item",on:{"click":function($event){return _vm.onQuickSelectionCustomItemClick(quickSelectionItem.predicate)}}},[_vm._v("\n                      "+_vm._s(quickSelectionItem.title)+"\n                    ")])})],2)],2)],1)],1):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return _c('le-table-column',{key:column.id,ref:("column-" + (column.id) + "-wrapper"),refInFor:true,attrs:{"filterBubblePosition":_vm.filterBubblePosition,"id":column.id,"header":column.header,"tableLeftScroll":_vm.leftScroll,"size":column.size,"filterConfiguration":column.filter,"filtersIconSize":_vm.filtersIconSize,"headerFontSize":_vm.headersFontSize,"tableHeaderHeight":_vm.tableHeaderHeight,"sortConfiguration":_vm.getSortConfiguration(column),"currentPosition":{ row: 0, column: index }},on:{"filter":_vm.onFilter,"sort":_vm.onSort,"onColumnMount":_vm.onColumnMount,"onActionIconClick":_vm.onActionIconClick}})})],2)]),_vm._v(" "),(_vm.showLoader)?_c('tbody',[_c('tr',[_c('th',{staticClass:"table-loader-container",attrs:{"colspan":"10","rowspan":"0"}},[_c('div',{staticClass:"table-loader"},[_c('le-loader',{attrs:{"size":40}})],1)])])]):(_vm.isError)?_c('tbody',[_c('le-table-error',{attrs:{"totalNumberOfColumns":_vm.totalNumberOfColumns,"errorLabel":_vm.errorLabel,"hideErrorIcon":_vm.hideErrorIcon,"showRefresh":_vm.showRefresh,"refreshLabel":_vm.refreshLabel},on:{"onRefreshClick":_vm.onRefreshClick}})],1):_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('le-table-row',{key:_vm.getRowId(item),ref:"tableRow",refInFor:true,attrs:{"rowId":_vm.getRowId(item),"columns":_vm.columns,"rowColor":_vm.getRowColor(item),"rowHeight":_vm.tableRowHeight,"isFocused":_vm.isRowFocused(item),"isHovered":_vm.isRowHovered(item),"isEdited":_vm.isRowEdited(item),"showCheckbox":_vm.allowRowSelection,"isCheckboxChecked":_vm.isRowCheckboxChecked(item),"data-test":("table_row_" + index),"isActionable":_vm.isRowActionable,"currentPosition":{ row: index + 1 }},on:{"checkboxChange":_vm.onRowCheckboxChange,"rowClick":_vm.onRowClick,"rowHovered":_vm.onRowHovered}},[_vm._l((_vm.columns),function(column){return _c('template',{slot:column.id},[_vm._t(column.id,null,{"item":item,"isHovered":_vm.isRowHovered(item),"isFocused":_vm.isRowFocused(item),"editedRowId":_vm.editedRowId})],2)})],2)}),_vm._v(" "),(_vm.isEmptyTable)?_c('le-table-empty',{attrs:{"totalNumberOfColumns":_vm.totalNumberOfColumns,"label":_vm.emptyLabel,"orientation":_vm.emptyOrientation,"useDefaultSplashImage":_vm.useEmptyDefaultSplashImage,"splashImageClass":_vm.emptySplashImageClass,"labelClass":_vm.emptyLabelClass,"description":_vm.emptyDescription}}):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tabs_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68da389b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tabs_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68da389b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68da389b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(495);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("60346cf1", content, true, {});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-tabs[data-v-68da389b]{display:-webkit-box;display:-ms-flexbox;display:flex;font-family:Roboto}.le-tabs .tab-item[data-v-68da389b]{position:relative;background:none;color:inherit;border:none;font:inherit;cursor:pointer;outline:inherit;padding:0;margin:0 16px 0 15px}.le-tabs .tab-item[data-v-68da389b]:after{content:\"\";position:absolute;top:0;bottom:0;right:-16px;width:1px;z-index:1}.le-tabs .tab-item[data-v-68da389b]:first-child{margin-left:0}.le-tabs .tab-item[data-v-68da389b]:last-child{margin-right:0}.le-tabs .tab-item[data-v-68da389b]:last-child:after{display:none}.le-tabs .tab-item.theme-dark[data-v-68da389b]:after,.theme-dark .le-tabs .tab-item[data-v-68da389b]:after{background:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(hsla(0,0%,100%,.5)),to(transparent));background:linear-gradient(transparent,hsla(0,0%,100%,.5),transparent)}.le-tabs .tab-item.theme-light[data-v-68da389b]:after,.theme-light .le-tabs .tab-item[data-v-68da389b]:after{background:-webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(hsla(0,0%,53%,.5)),to(transparent));background:linear-gradient(transparent,hsla(0,0%,53%,.5),transparent)}.le-tabs .tab-item .tab-icon.theme-dark[data-v-68da389b],.le-tabs .tab-item .tab-subtext.theme-dark[data-v-68da389b],.le-tabs .tab-item .tab-text.theme-dark[data-v-68da389b],.theme-dark .le-tabs .tab-item .tab-icon[data-v-68da389b],.theme-dark .le-tabs .tab-item .tab-subtext[data-v-68da389b],.theme-dark .le-tabs .tab-item .tab-text[data-v-68da389b]{color:#b1b5bc}.le-tabs .tab-item .tab-icon.theme-light[data-v-68da389b],.le-tabs .tab-item .tab-subtext.theme-light[data-v-68da389b],.le-tabs .tab-item .tab-text.theme-light[data-v-68da389b],.theme-light .le-tabs .tab-item .tab-icon[data-v-68da389b],.theme-light .le-tabs .tab-item .tab-subtext[data-v-68da389b],.theme-light .le-tabs .tab-item .tab-text[data-v-68da389b]{color:#161c4f}.le-tabs .tab-item .tab-subtext[data-v-68da389b],.le-tabs .tab-item .tab-text[data-v-68da389b]{display:inline-block;font-weight:700}.le-tabs .tab-item.is-active[data-v-68da389b]{cursor:default}.le-tabs .tab-item.is-active.theme-dark[data-v-68da389b],.theme-dark .le-tabs .tab-item.is-active[data-v-68da389b]{border-bottom:1px solid #43c6f4}.le-tabs .tab-item.is-active.theme-light[data-v-68da389b],.theme-light .le-tabs .tab-item.is-active[data-v-68da389b]{border-bottom:1px solid #0c5de6}.le-tabs .tab-item.is-active .tab-icon.theme-dark[data-v-68da389b],.le-tabs .tab-item.is-active .tab-subtext.theme-dark[data-v-68da389b],.le-tabs .tab-item.is-active .tab-text.theme-dark[data-v-68da389b],.theme-dark .le-tabs .tab-item.is-active .tab-icon[data-v-68da389b],.theme-dark .le-tabs .tab-item.is-active .tab-subtext[data-v-68da389b],.theme-dark .le-tabs .tab-item.is-active .tab-text[data-v-68da389b]{color:#43c6f4}.le-tabs .tab-item.is-active .tab-icon.theme-light[data-v-68da389b],.le-tabs .tab-item.is-active .tab-subtext.theme-light[data-v-68da389b],.le-tabs .tab-item.is-active .tab-text.theme-light[data-v-68da389b],.theme-light .le-tabs .tab-item.is-active .tab-icon[data-v-68da389b],.theme-light .le-tabs .tab-item.is-active .tab-subtext[data-v-68da389b],.theme-light .le-tabs .tab-item.is-active .tab-text[data-v-68da389b]{color:#0c5de6}.le-tabs.le-tabs-default .tab-item[data-v-68da389b]{padding:3px 0}.le-tabs.le-tabs-default .tab-item .tab-icon[data-v-68da389b]{position:relative;top:1px}.le-tabs.le-tabs-default .tab-item .tab-text[data-v-68da389b]{font-size:12px}.le-tabs.le-tabs-default .tab-item .tab-subtext[data-v-68da389b]{font-size:10px}.le-tabs.le-tabs-primary .tab-item[data-v-68da389b]{padding:5px 0}.le-tabs.le-tabs-primary .tab-item .tab-icon[data-v-68da389b]{position:relative;top:2px}.le-tabs.le-tabs-primary .tab-item .tab-text[data-v-68da389b]{font-size:14px}.le-tabs.le-tabs-primary .tab-item .tab-subtext[data-v-68da389b]{font-size:12px}.le-tabs.le-tabs-secondary .tab-item[data-v-68da389b]{margin:0;padding:0 12px}.le-tabs.le-tabs-secondary .tab-item[data-v-68da389b]:after{display:none}.le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b]{font-size:16px}.le-tabs.le-tabs-secondary .tab-item .tab-text.theme-dark[data-v-68da389b],.theme-dark .le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b]{color:#dbdce1}.le-tabs.le-tabs-secondary .tab-item .tab-text.theme-light[data-v-68da389b],.theme-light .le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b]{color:#6f737c}.le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon.theme-dark[data-v-68da389b],.le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext.theme-dark[data-v-68da389b],.le-tabs.le-tabs-secondary .tab-item.is-active .tab-text.theme-dark[data-v-68da389b],.theme-dark .le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon[data-v-68da389b],.theme-dark .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext[data-v-68da389b],.theme-dark .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text[data-v-68da389b]{color:#fcfcfd}.le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon.theme-light[data-v-68da389b],.le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext.theme-light[data-v-68da389b],.le-tabs.le-tabs-secondary .tab-item.is-active .tab-text.theme-light[data-v-68da389b],.theme-light .le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon[data-v-68da389b],.theme-light .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext[data-v-68da389b],.theme-light .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text[data-v-68da389b]{color:#161c4f}.le-tabs.le-tabs-secondary .tab-item .tab-icon[data-v-68da389b]{position:relative;top:0}.le-tabs.le-tabs-secondary .tab-item .tab-subtext[data-v-68da389b]{font-size:12px;position:relative;bottom:1px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-tabs/le-tabs.vue"],"names":[],"mappings":"AAIA,0BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAoB,CACrB,AACD,oCACI,kBAAmB,AACnB,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,UAAW,AACX,oBAAsB,CACzB,AACD,0CACM,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,YAAa,AACb,UAAW,AACX,SAAW,CAChB,AACD,gDACM,aAAe,CACpB,AACD,+CACM,cAAgB,CACrB,AACD,qDACQ,YAAc,CACrB,AACD,2GAEM,0HAAsI,AACtI,sEAAgF,CACrF,AACD,6GAEM,yHAAsI,AACtI,qEAAgF,CACrF,AACD,+VAQM,aAAe,CACpB,AACD,qWAQM,aAAe,CACpB,AAKD,+FACM,qBAAsB,AACtB,eAAkB,CACvB,AACD,8CACM,cAAgB,CACrB,AACD,mHAEQ,+BAAiC,CACxC,AACD,qHAEQ,+BAAiC,CACxC,AACD,2ZAQQ,aAAe,CACtB,AACD,iaAQQ,aAAe,CACtB,AACD,oDACI,aAAe,CAClB,AACD,8DACM,kBAAmB,AACnB,OAAS,CACd,AACD,8DACM,cAAgB,CACrB,AACD,iEACM,cAAgB,CACrB,AACD,oDACI,aAAe,CAClB,AACD,8DACM,kBAAmB,AACnB,OAAS,CACd,AACD,8DACM,cAAgB,CACrB,AACD,iEACM,cAAgB,CACrB,AACD,sDACI,SAAY,AACZ,cAAkB,CACrB,AACD,4DACM,YAAc,CACnB,AACD,gEACM,cAAgB,CACrB,AACD,uJAEQ,aAAe,CACtB,AACD,yJAEQ,aAAe,CACtB,AACD,ugBAQM,aAAe,CACpB,AACD,6gBAQM,aAAe,CACpB,AACD,gEACM,kBAAmB,AACnB,KAAS,CACd,AACD,mEACM,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACjB","file":"le-tabs.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-tabs[data-v-68da389b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: Roboto;\n}\n.le-tabs .tab-item[data-v-68da389b] {\n    position: relative;\n    background: none;\n    color: inherit;\n    border: none;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit;\n    padding: 0;\n    margin: 0 16px 0 15px;\n}\n.le-tabs .tab-item[data-v-68da389b]:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      right: -16px;\n      width: 1px;\n      z-index: 1;\n}\n.le-tabs .tab-item[data-v-68da389b]:first-child {\n      margin-left: 0;\n}\n.le-tabs .tab-item[data-v-68da389b]:last-child {\n      margin-right: 0;\n}\n.le-tabs .tab-item[data-v-68da389b]:last-child:after {\n        display: none;\n}\n.le-tabs .tab-item.theme-dark[data-v-68da389b]:after,\n    .theme-dark .le-tabs .tab-item[data-v-68da389b]:after {\n      background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(rgba(255, 255, 255, 0.5)), to(transparent));\n      background: linear-gradient(transparent, rgba(255, 255, 255, 0.5), transparent);\n}\n.le-tabs .tab-item.theme-light[data-v-68da389b]:after,\n    .theme-light .le-tabs .tab-item[data-v-68da389b]:after {\n      background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(rgba(136, 136, 136, 0.5)), to(transparent));\n      background: linear-gradient(transparent, rgba(136, 136, 136, 0.5), transparent);\n}\n.le-tabs .tab-item .tab-icon.theme-dark[data-v-68da389b],\n    .theme-dark .le-tabs .tab-item .tab-icon[data-v-68da389b],\n    .le-tabs .tab-item .tab-text.theme-dark[data-v-68da389b],\n    .theme-dark\n    .le-tabs .tab-item .tab-text[data-v-68da389b],\n    .le-tabs .tab-item .tab-subtext.theme-dark[data-v-68da389b],\n    .theme-dark\n    .le-tabs .tab-item .tab-subtext[data-v-68da389b] {\n      color: #b1b5bc;\n}\n.le-tabs .tab-item .tab-icon.theme-light[data-v-68da389b],\n    .theme-light .le-tabs .tab-item .tab-icon[data-v-68da389b],\n    .le-tabs .tab-item .tab-text.theme-light[data-v-68da389b],\n    .theme-light\n    .le-tabs .tab-item .tab-text[data-v-68da389b],\n    .le-tabs .tab-item .tab-subtext.theme-light[data-v-68da389b],\n    .theme-light\n    .le-tabs .tab-item .tab-subtext[data-v-68da389b] {\n      color: #161c4f;\n}\n.le-tabs .tab-item .tab-text[data-v-68da389b] {\n      display: inline-block;\n      font-weight: bold;\n}\n.le-tabs .tab-item .tab-subtext[data-v-68da389b] {\n      display: inline-block;\n      font-weight: bold;\n}\n.le-tabs .tab-item.is-active[data-v-68da389b] {\n      cursor: default;\n}\n.le-tabs .tab-item.is-active.theme-dark[data-v-68da389b],\n      .theme-dark .le-tabs .tab-item.is-active[data-v-68da389b] {\n        border-bottom: 1px solid #43c6f4;\n}\n.le-tabs .tab-item.is-active.theme-light[data-v-68da389b],\n      .theme-light .le-tabs .tab-item.is-active[data-v-68da389b] {\n        border-bottom: 1px solid #0c5de6;\n}\n.le-tabs .tab-item.is-active .tab-icon.theme-dark[data-v-68da389b],\n      .theme-dark .le-tabs .tab-item.is-active .tab-icon[data-v-68da389b],\n      .le-tabs .tab-item.is-active .tab-text.theme-dark[data-v-68da389b],\n      .theme-dark\n      .le-tabs .tab-item.is-active .tab-text[data-v-68da389b],\n      .le-tabs .tab-item.is-active .tab-subtext.theme-dark[data-v-68da389b],\n      .theme-dark\n      .le-tabs .tab-item.is-active .tab-subtext[data-v-68da389b] {\n        color: #43c6f4;\n}\n.le-tabs .tab-item.is-active .tab-icon.theme-light[data-v-68da389b],\n      .theme-light .le-tabs .tab-item.is-active .tab-icon[data-v-68da389b],\n      .le-tabs .tab-item.is-active .tab-text.theme-light[data-v-68da389b],\n      .theme-light\n      .le-tabs .tab-item.is-active .tab-text[data-v-68da389b],\n      .le-tabs .tab-item.is-active .tab-subtext.theme-light[data-v-68da389b],\n      .theme-light\n      .le-tabs .tab-item.is-active .tab-subtext[data-v-68da389b] {\n        color: #0c5de6;\n}\n.le-tabs.le-tabs-default .tab-item[data-v-68da389b] {\n    padding: 3px 0;\n}\n.le-tabs.le-tabs-default .tab-item .tab-icon[data-v-68da389b] {\n      position: relative;\n      top: 1px;\n}\n.le-tabs.le-tabs-default .tab-item .tab-text[data-v-68da389b] {\n      font-size: 12px;\n}\n.le-tabs.le-tabs-default .tab-item .tab-subtext[data-v-68da389b] {\n      font-size: 10px;\n}\n.le-tabs.le-tabs-primary .tab-item[data-v-68da389b] {\n    padding: 5px 0;\n}\n.le-tabs.le-tabs-primary .tab-item .tab-icon[data-v-68da389b] {\n      position: relative;\n      top: 2px;\n}\n.le-tabs.le-tabs-primary .tab-item .tab-text[data-v-68da389b] {\n      font-size: 14px;\n}\n.le-tabs.le-tabs-primary .tab-item .tab-subtext[data-v-68da389b] {\n      font-size: 12px;\n}\n.le-tabs.le-tabs-secondary .tab-item[data-v-68da389b] {\n    margin: 0px;\n    padding: 0px 12px;\n}\n.le-tabs.le-tabs-secondary .tab-item[data-v-68da389b]:after {\n      display: none;\n}\n.le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b] {\n      font-size: 16px;\n}\n.le-tabs.le-tabs-secondary .tab-item .tab-text.theme-dark[data-v-68da389b],\n      .theme-dark .le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b] {\n        color: #DBDCE1;\n}\n.le-tabs.le-tabs-secondary .tab-item .tab-text.theme-light[data-v-68da389b],\n      .theme-light .le-tabs.le-tabs-secondary .tab-item .tab-text[data-v-68da389b] {\n        color: #6F737C;\n}\n.le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon.theme-dark[data-v-68da389b],\n    .theme-dark .le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon[data-v-68da389b],\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text.theme-dark[data-v-68da389b],\n    .theme-dark\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text[data-v-68da389b],\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext.theme-dark[data-v-68da389b],\n    .theme-dark\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext[data-v-68da389b] {\n      color: #fcfcfd;\n}\n.le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon.theme-light[data-v-68da389b],\n    .theme-light .le-tabs.le-tabs-secondary .tab-item.is-active .tab-icon[data-v-68da389b],\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text.theme-light[data-v-68da389b],\n    .theme-light\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-text[data-v-68da389b],\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext.theme-light[data-v-68da389b],\n    .theme-light\n    .le-tabs.le-tabs-secondary .tab-item.is-active .tab-subtext[data-v-68da389b] {\n      color: #161c4f;\n}\n.le-tabs.le-tabs-secondary .tab-item .tab-icon[data-v-68da389b] {\n      position: relative;\n      top: 0px;\n}\n.le-tabs.le-tabs-secondary .tab-item .tab-subtext[data-v-68da389b] {\n      font-size: 12px;\n      position: relative;\n      bottom: 1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-tabs', ("le-tabs-" + _vm.variant)],attrs:{"role":"tablist","data-test":"tabs"}},_vm._l((_vm.visibleTabs),function(tab,index){return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: tab.tooltip, html: false, autoHide: false }),expression:"{ content: tab.tooltip, html: false, autoHide: false }"}],key:tab.id,ref:("tab-item-" + _vm.variant + "-" + index),refInFor:true,class:['tab-item', { 'is-active': _vm.isActive(tab) }],attrs:{"id":("tab-id-" + (tab.id)),"data-id":tab.id,"data-test":("tab_" + (tab.id)),"type":"button","role":"tab","aria-selected":_vm.ariaSelectedTabItem(tab),"aria-controls":("tabpanel-id-" + (tab.id)),"tabindex":_vm.tabIndex(tab)},on:{"click":function($event){return _vm.onTabClick(tab)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.rightArrowHandler(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.leftArrowHandler(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onTabClick(tab)}]}},[(_vm.hasIcon(tab))?_c('i',{class:['tab-icon', ("ico-" + _vm.iconSize), tab.icon],attrs:{"data-test":("tab_" + (tab.id) + "_icon")}}):_vm._e(),_vm._v(" "),(_vm.hasText(tab))?_c('span',{staticClass:"tab-text",attrs:{"data-test":("tab_" + (tab.id) + "_txt")}},[_vm._v(_vm._s(tab.text))]):_vm._e(),_vm._v(" "),(_vm.hasSubText(tab))?_c('span',{staticClass:"tab-subtext",attrs:{"data-test":("tab_" + (tab.id) + "_subtxt")}},[_vm._v(_vm._s(tab.subText))]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_pagination_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f93c522_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_pagination_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f93c522"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f93c522_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2929fe97", content, true, {});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-pagination[data-v-7f93c522]{font-family:Roboto;font-size:12px;height:12px}.le-pagination.theme-dark[data-v-7f93c522],.theme-dark .le-pagination[data-v-7f93c522]{color:#fff}.le-pagination.theme-light[data-v-7f93c522],.theme-light .le-pagination[data-v-7f93c522]{color:#000}.le-pagination .text-container[data-v-7f93c522]{display:inline-block;margin-left:3px;margin-right:6px;vertical-align:middle;letter-spacing:.2px}.le-pagination .text-container .font-bold[data-v-7f93c522]{font-weight:700}.le-pagination .text-container .label.theme-dark[data-v-7f93c522],.theme-dark .le-pagination .text-container .label[data-v-7f93c522]{color:#b1b5bc}.le-pagination .text-container .label.theme-light[data-v-7f93c522],.theme-light .le-pagination .text-container .label[data-v-7f93c522]{color:#666}.le-pagination .text-container .middle-text.theme-dark[data-v-7f93c522],.theme-dark .le-pagination .text-container .middle-text[data-v-7f93c522]{color:#b1b5bc}.le-pagination .text-container .middle-text.theme-light[data-v-7f93c522],.theme-light .le-pagination .text-container .middle-text[data-v-7f93c522]{color:#666}.le-pagination .page-navigation-icon[data-v-7f93c522]{cursor:pointer;vertical-align:middle}.le-pagination .page-navigation-icon.theme-dark[data-v-7f93c522],.theme-dark .le-pagination .page-navigation-icon[data-v-7f93c522]{color:#fff}.le-pagination .page-navigation-icon.theme-light[data-v-7f93c522],.theme-light .le-pagination .page-navigation-icon[data-v-7f93c522]{color:#888}.le-pagination .page-navigation-icon [data-v-7f93c522]:focus{outline:none!important}.le-pagination .page-navigation-icon :focus.theme-dark.show-a11y-focus-outline[data-v-7f93c522],.theme-dark.show-a11y-focus-outline .le-pagination .page-navigation-icon [data-v-7f93c522]:focus{-webkit-box-shadow:inset 0 0 0 2px #52c7ef!important;box-shadow:inset 0 0 0 2px #52c7ef!important}.le-pagination .page-navigation-icon :focus.theme-light.show-a11y-focus-outline[data-v-7f93c522],.theme-light.show-a11y-focus-outline .le-pagination .page-navigation-icon [data-v-7f93c522]:focus{-webkit-box-shadow:inset 0 0 0 2px #0c5de6!important;box-shadow:inset 0 0 0 2px #0c5de6!important}.le-pagination .page-navigation-icon.disabled[data-v-7f93c522]{cursor:default}.le-pagination .page-navigation-icon.disabled.theme-dark[data-v-7f93c522],.theme-dark .le-pagination .page-navigation-icon.disabled[data-v-7f93c522]{color:#63627a}.le-pagination .page-navigation-icon.disabled.theme-light[data-v-7f93c522],.theme-light .le-pagination .page-navigation-icon.disabled[data-v-7f93c522]{color:#c3c3c3}.le-pagination .previous-icon[data-v-7f93c522]{margin-left:3px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-pagination/le-pagination.vue"],"names":[],"mappings":"AAIA,gCACE,mBAAoB,AACpB,eAAgB,AAChB,WAAa,CACd,AACD,uFAEI,UAAe,CAClB,AACD,yFAEI,UAAe,CAClB,AACD,gDACI,qBAAsB,AACtB,gBAAiB,AACjB,iBAAkB,AAClB,sBAAuB,AACvB,mBAAsB,CACzB,AACD,2DACM,eAAkB,CACvB,AACD,qIAEM,aAAe,CACpB,AACD,uIAEM,UAAe,CACpB,AACD,iJAEM,aAAe,CACpB,AACD,mJAEM,UAAe,CACpB,AACD,sDACI,eAAgB,AAChB,qBAAuB,CAC1B,AACD,mIAEM,UAAe,CACpB,AACD,qIAEM,UAAe,CACpB,AACD,6DACM,sBAAyB,CAC9B,AACD,iMAEQ,qDAAuD,AAC/C,4CAA+C,CAC9D,AACD,mMAEQ,qDAAuD,AAC/C,4CAA+C,CAC9D,AACD,+DACM,cAAgB,CACrB,AACD,qJAEQ,aAAe,CACtB,AACD,uJAEQ,aAAe,CACtB,AACD,+CACI,eAAiB,CACpB","file":"le-pagination.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-pagination[data-v-7f93c522] {\n  font-family: Roboto;\n  font-size: 12px;\n  height: 12px;\n}\n.le-pagination.theme-dark[data-v-7f93c522],\n  .theme-dark .le-pagination[data-v-7f93c522] {\n    color: #ffffff;\n}\n.le-pagination.theme-light[data-v-7f93c522],\n  .theme-light .le-pagination[data-v-7f93c522] {\n    color: #000000;\n}\n.le-pagination .text-container[data-v-7f93c522] {\n    display: inline-block;\n    margin-left: 3px;\n    margin-right: 6px;\n    vertical-align: middle;\n    letter-spacing: 0.2px;\n}\n.le-pagination .text-container .font-bold[data-v-7f93c522] {\n      font-weight: bold;\n}\n.le-pagination .text-container .label.theme-dark[data-v-7f93c522],\n    .theme-dark .le-pagination .text-container .label[data-v-7f93c522] {\n      color: #b1b5bc;\n}\n.le-pagination .text-container .label.theme-light[data-v-7f93c522],\n    .theme-light .le-pagination .text-container .label[data-v-7f93c522] {\n      color: #666666;\n}\n.le-pagination .text-container .middle-text.theme-dark[data-v-7f93c522],\n    .theme-dark .le-pagination .text-container .middle-text[data-v-7f93c522] {\n      color: #b1b5bc;\n}\n.le-pagination .text-container .middle-text.theme-light[data-v-7f93c522],\n    .theme-light .le-pagination .text-container .middle-text[data-v-7f93c522] {\n      color: #666666;\n}\n.le-pagination .page-navigation-icon[data-v-7f93c522] {\n    cursor: pointer;\n    vertical-align: middle;\n}\n.le-pagination .page-navigation-icon.theme-dark[data-v-7f93c522],\n    .theme-dark .le-pagination .page-navigation-icon[data-v-7f93c522] {\n      color: #ffffff;\n}\n.le-pagination .page-navigation-icon.theme-light[data-v-7f93c522],\n    .theme-light .le-pagination .page-navigation-icon[data-v-7f93c522] {\n      color: #888888;\n}\n.le-pagination .page-navigation-icon *[data-v-7f93c522]:focus {\n      outline: none !important;\n}\n.le-pagination .page-navigation-icon *:focus.theme-dark.show-a11y-focus-outline[data-v-7f93c522],\n      .theme-dark.show-a11y-focus-outline .le-pagination .page-navigation-icon *[data-v-7f93c522]:focus {\n        -webkit-box-shadow: inset 0 0 0 2px #52c7ef !important;\n                box-shadow: inset 0 0 0 2px #52c7ef !important;\n}\n.le-pagination .page-navigation-icon *:focus.theme-light.show-a11y-focus-outline[data-v-7f93c522],\n      .theme-light.show-a11y-focus-outline .le-pagination .page-navigation-icon *[data-v-7f93c522]:focus {\n        -webkit-box-shadow: inset 0 0 0 2px #0c5de6 !important;\n                box-shadow: inset 0 0 0 2px #0c5de6 !important;\n}\n.le-pagination .page-navigation-icon.disabled[data-v-7f93c522] {\n      cursor: default;\n}\n.le-pagination .page-navigation-icon.disabled.theme-dark[data-v-7f93c522],\n      .theme-dark .le-pagination .page-navigation-icon.disabled[data-v-7f93c522] {\n        color: #63627a;\n}\n.le-pagination .page-navigation-icon.disabled.theme-light[data-v-7f93c522],\n      .theme-light .le-pagination .page-navigation-icon.disabled[data-v-7f93c522] {\n        color: #c3c3c3;\n}\n.le-pagination .previous-icon[data-v-7f93c522] {\n    margin-left: 3px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-pagination"},[_c('i',{staticClass:"page-navigation-icon first-icon ico-11 ico-double-arrow-left",class:{disabled: _vm.isPreviousDisabled},attrs:{"data-test":"page_first","role":"button","tabindex":"0"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onFirstArrowClicked($event)},"click":_vm.onFirstArrowClicked}}),_vm._v(" "),_c('i',{staticClass:"page-navigation-icon previous-icon ico-11 ico-single-arrow-left",class:{disabled: _vm.isPreviousDisabled},attrs:{"data-test":"page_previous","role":"button","tabindex":"-1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onFirstArrowClicked($event)},"click":_vm.onPreviousArrowClicked}}),_vm._v(" "),_c('div',{staticClass:"text-container"},[(_vm.totalNumOfItems)?_c('span',{staticClass:"prefix-text font-bold",attrs:{"data-test":"page_range_from"}},[_vm._v(_vm._s(_vm.fromItem)+"-"+_vm._s(_vm.toItem)+" ")]):_vm._e(),_vm._v(" "),(_vm.totalNumOfItems)?_c('span',{staticClass:"middle-text",attrs:{"data-test":"page_range_middle_txt"}},[_vm._v(" "+_vm._s(_vm.rangeMiddleText)+" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"suffix-text font-bold",attrs:{"data-test":"page_range_to"}},[_vm._v(" "+_vm._s(_vm.totalNumOfItems)+" ")]),_vm._v(" "),_c('span',{staticClass:"label",attrs:{"data-test":"page_range_label"}},[_vm._v(_vm._s(_vm.itemsTypeLabel))])]),_vm._v(" "),_c('i',{staticClass:"page-navigation-icon next-icon ico-11 ico-single-arrow-right",class:{disabled: _vm.isNextDisabled},attrs:{"data-test":"page_next","role":"button","tabindex":"-1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onNextArrowClicked($event)},"click":_vm.onNextArrowClicked}}),_vm._v(" "),_c('i',{staticClass:"page-navigation-icon last-icon ico-11 ico-double-arrow-right",class:{disabled: _vm.isNextDisabled},attrs:{"data-test":"page_last","role":"button","tabindex":"-1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onLastArrowClicked($event)},"click":_vm.onLastArrowClicked}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3a0a3e0e", content, true, {});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-select[data-v-49463ef7]{font-family:Roboto;position:relative;width:100%}.le-select .a11y_live_region[data-v-49463ef7]{position:absolute;clip:rect(0 0 0 0);border:0;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden}.le-select:active.theme-dark[data-v-49463ef7],.le-select:focus.theme-dark[data-v-49463ef7],.theme-dark .le-select[data-v-49463ef7]:active,.theme-dark .le-select[data-v-49463ef7]:focus{-webkit-box-shadow:0 0 0 2px #5879da!important;box-shadow:0 0 0 2px #5879da!important}.le-select:active.theme-light[data-v-49463ef7],.le-select:focus.theme-light[data-v-49463ef7],.theme-light .le-select[data-v-49463ef7]:active,.theme-light .le-select[data-v-49463ef7]:focus{-webkit-box-shadow:0 0 0 2px #4661ae!important;box-shadow:0 0 0 2px #4661ae!important}.le-select .trigger[data-v-49463ef7]{width:100%}.le-select.le-select-type-menu[data-v-49463ef7]{width:18px}.le-select.is-open:not(.open-list) .le-select-dropdown.theme-dark[data-v-49463ef7],.theme-dark .le-select.is-open:not(.open-list) .le-select-dropdown[data-v-49463ef7]{border-color:#5879da}.le-select.is-open:not(.open-list) .le-select-dropdown.theme-light[data-v-49463ef7],.theme-light .le-select.is-open:not(.open-list) .le-select-dropdown[data-v-49463ef7]{border-color:#4661ae}.le-select.open-list[data-v-49463ef7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}.le-select.open-list .select-list[data-v-49463ef7]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;height:100%;overflow-y:auto}.le-select.open-list .space[data-v-49463ef7]{display:table-row;height:3px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-select/le-select.vue"],"names":[],"mappings":"AAIA,4BACE,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CACb,AACD,8CACI,kBAAmB,AACnB,mBAAoB,AACpB,SAAU,AACV,UAAW,AACX,WAAY,AACZ,YAAa,AACb,UAAW,AACX,eAAiB,CACpB,AACD,wLAGI,+CAAiD,AACzC,sCAAyC,CACpD,AACD,4LAGI,+CAAiD,AACzC,sCAAyC,CACpD,AACD,qCACI,UAAY,CACf,AACD,gDACI,UAAY,CACf,AACD,uKAEI,oBAAsB,CACzB,AACD,yKAEI,oBAAsB,CACzB,AACD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAa,CAChB,AACD,mDACM,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,YAAa,AACb,eAAiB,CACtB,AACD,6CACM,kBAAmB,AACnB,UAAY,CACjB","file":"le-select.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-select[data-v-49463ef7] {\n  font-family: Roboto;\n  position: relative;\n  width: 100%;\n}\n.le-select .a11y_live_region[data-v-49463ef7] {\n    position: absolute;\n    clip: rect(0 0 0 0);\n    border: 0;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n}\n.le-select:focus.theme-dark[data-v-49463ef7],\n  .theme-dark .le-select[data-v-49463ef7]:focus, .le-select:active.theme-dark[data-v-49463ef7],\n  .theme-dark .le-select[data-v-49463ef7]:active {\n    -webkit-box-shadow: 0 0 0 2px #5879da !important;\n            box-shadow: 0 0 0 2px #5879da !important;\n}\n.le-select:focus.theme-light[data-v-49463ef7],\n  .theme-light .le-select[data-v-49463ef7]:focus, .le-select:active.theme-light[data-v-49463ef7],\n  .theme-light .le-select[data-v-49463ef7]:active {\n    -webkit-box-shadow: 0 0 0 2px #4661ae !important;\n            box-shadow: 0 0 0 2px #4661ae !important;\n}\n.le-select .trigger[data-v-49463ef7] {\n    width: 100%;\n}\n.le-select.le-select-type-menu[data-v-49463ef7] {\n    width: 18px;\n}\n.le-select.is-open:not(.open-list) .le-select-dropdown.theme-dark[data-v-49463ef7],\n  .theme-dark .le-select.is-open:not(.open-list) .le-select-dropdown[data-v-49463ef7] {\n    border-color: #5879da;\n}\n.le-select.is-open:not(.open-list) .le-select-dropdown.theme-light[data-v-49463ef7],\n  .theme-light .le-select.is-open:not(.open-list) .le-select-dropdown[data-v-49463ef7] {\n    border-color: #4661ae;\n}\n.le-select.open-list[data-v-49463ef7] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: 100%;\n}\n.le-select.open-list .select-list[data-v-49463ef7] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      height: 100%;\n      overflow-y: auto;\n}\n.le-select.open-list .space[data-v-49463ef7] {\n      display: table-row;\n      height: 3px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bb07e6c4", content, true, {});

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-tags{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;outline:none;min-height:26px;max-height:135px;overflow-x:hidden;border-radius:2px;padding:4px 5px 0 8px;font-family:Roboto}.le-tags.theme-dark,.theme-dark .le-tags{background-color:rgba(71,74,106,.5);border:1px solid #474a6a}.le-tags.theme-light,.theme-light .le-tags{background-color:#fcfcfd;border:1px solid #8c8d8f}.le-tags.active.theme-dark,.theme-dark .le-tags.active{border-color:#5879da}.le-tags.active.theme-light,.theme-light .le-tags.active{border-color:#4661ae}.le-tags.disabled.theme-dark,.theme-dark .le-tags.disabled{border-color:#474a6a;background-color:#474a6a}.le-tags.disabled.theme-light,.theme-light .le-tags.disabled{border-color:#8c8d8f;background-color:#ebecef}.le-tags.disabled.add-icon{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.le-tags .search-container{display:inline-block;margin:1px 6px 5px 0;height:18px}.le-tags .search-container .search-input{line-height:18px;border-radius:1px;outline:none;font-size:12px;font-weight:500;word-break:break-all;margin-left:2px;padding:0 5px 0 0}.le-tags .search-container .search-input.theme-dark,.theme-dark .le-tags .search-container .search-input{border:1px dashed #bbc0c9;color:#ccc}.le-tags .search-container .search-input.theme-light,.theme-light .le-tags .search-container .search-input{border:1px dashed #8c8d8f;color:#6f737c}.le-tags .search-container .search-input:empty{border:none;height:20px;line-height:20px}.le-tags .search-container .search-input.has-error.theme-dark,.theme-dark .le-tags .search-container .search-input.has-error{border-color:#ff1820}.le-tags .search-container .search-input.has-error.theme-light,.theme-light .le-tags .search-container .search-input.has-error{border-color:#d0021b}.le-tags .search-container.theme-dark,.theme-dark .le-tags .search-container{padding:0}.le-tags .search-container.theme-dark :not(:focus):empty:before,.theme-dark .le-tags .search-container :not(:focus):empty:before{content:attr(placeholder);display:block;font-size:12px;font-style:italic;color:#666;border:0}.le-tags .search-container.theme-dark.disabled :focus:empty:before,.le-tags .search-container.theme-dark.disabled :not(:focus):empty:before,.theme-dark .le-tags .search-container.disabled :focus:empty:before,.theme-dark .le-tags .search-container.disabled :not(:focus):empty:before{content:attr(placeholder);font-style:italic;color:#f9f9f9}.le-tags .search-container.theme-light,.theme-light .le-tags .search-container{padding:0}.le-tags .search-container.theme-light :not(:focus):empty:before,.theme-light .le-tags .search-container :not(:focus):empty:before{content:attr(placeholder);display:block;font-size:12px;font-style:italic;color:#6f737c;border:0}.le-tags .search-container.theme-light.disabled :focus:empty:before,.le-tags .search-container.theme-light.disabled :not(:focus):empty:before,.theme-light .le-tags .search-container.disabled :focus:empty:before,.theme-light .le-tags .search-container.disabled :not(:focus):empty:before{content:attr(placeholder);font-style:italic;color:hsla(222,6%,46%,.5)}.icon-position{position:absolute;float:right;top:9px;right:6px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-tags/le-tags.vue"],"names":[],"mappings":"AAIA,SACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,aAAc,AACd,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,sBAAuB,AACvB,kBAAoB,CACrB,AACD,yCAEI,oCAAyC,AACzC,wBAA0B,CAC7B,AACD,2CAEI,yBAA0B,AAC1B,wBAA0B,CAC7B,AACD,uDAEI,oBAAsB,CACzB,AACD,yDAEI,oBAAsB,CACzB,AACD,2DAEI,qBAAsB,AACtB,wBAA0B,CAC7B,AACD,6DAEI,qBAAsB,AACtB,wBAA0B,CAC7B,AACD,2BACI,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,2BACI,qBAAsB,AACtB,qBAAsB,AACtB,WAAa,CAChB,AACD,yCACM,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,qBAAsB,AACtB,gBAAiB,AACjB,iBAAmB,CACxB,AACD,yGAEQ,0BAA2B,AAC3B,UAAe,CACtB,AACD,2GAEQ,0BAA2B,AAC3B,aAAe,CACtB,AACD,+CACQ,YAAa,AACb,YAAa,AACb,gBAAkB,CACzB,AACD,6HAEQ,oBAAsB,CAC7B,AACD,+HAEQ,oBAAsB,CAC7B,AACD,6EAEM,SAAW,CAChB,AACD,iIAEQ,0BAA2B,AAC3B,cAAe,AAEf,eAAgB,AAChB,kBAAmB,AACnB,WAAe,AACf,QAAU,CACjB,AACD,0RAIQ,0BAA2B,AAC3B,kBAAmB,AACnB,aAAe,CACtB,AACD,+EAEM,SAAW,CAChB,AACD,mIAEQ,0BAA2B,AAC3B,cAAe,AAEf,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,QAAU,CACjB,AACD,8RAIQ,0BAA2B,AAC3B,kBAAmB,AACnB,yBAAgC,CACvC,AACD,eACE,kBAAmB,AACnB,YAAa,AACb,QAAS,AACT,SAAW,CACZ","file":"le-tags.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-tags {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  outline: none;\n  min-height: 26px;\n  max-height: 135px;\n  overflow-x: hidden;\n  border-radius: 2px;\n  padding: 4px 5px 0 8px;\n  font-family: Roboto;\n}\n.le-tags.theme-dark,\n  .theme-dark .le-tags {\n    background-color: rgba(71, 74, 106, 0.5);\n    border: 1px solid #474a6a;\n}\n.le-tags.theme-light,\n  .theme-light .le-tags {\n    background-color: #fcfcfd;\n    border: 1px solid #8C8D8F;\n}\n.le-tags.active.theme-dark,\n  .theme-dark .le-tags.active {\n    border-color: #5879da;\n}\n.le-tags.active.theme-light,\n  .theme-light .le-tags.active {\n    border-color: #4661ae;\n}\n.le-tags.disabled.theme-dark,\n  .theme-dark .le-tags.disabled {\n    border-color: #474a6a;\n    background-color: #474a6a;\n}\n.le-tags.disabled.theme-light,\n  .theme-light .le-tags.disabled {\n    border-color: #8C8D8F;\n    background-color: #ebecef;\n}\n.le-tags.disabled.add-icon {\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.le-tags .search-container {\n    display: inline-block;\n    margin: 1px 6px 5px 0;\n    height: 18px;\n}\n.le-tags .search-container .search-input {\n      line-height: 18px;\n      border-radius: 1px;\n      outline: none;\n      font-size: 12px;\n      font-weight: 500;\n      word-break: break-all;\n      margin-left: 2px;\n      padding: 0 5px 0 0;\n}\n.le-tags .search-container .search-input.theme-dark,\n      .theme-dark .le-tags .search-container .search-input {\n        border: 1px dashed #bbc0c9;\n        color: #cccccc;\n}\n.le-tags .search-container .search-input.theme-light,\n      .theme-light .le-tags .search-container .search-input {\n        border: 1px dashed #8C8D8F;\n        color: #6F737C;\n}\n.le-tags .search-container .search-input:empty {\n        border: none;\n        height: 20px;\n        line-height: 20px;\n}\n.le-tags .search-container .search-input.has-error.theme-dark,\n      .theme-dark .le-tags .search-container .search-input.has-error {\n        border-color: #ff1820;\n}\n.le-tags .search-container .search-input.has-error.theme-light,\n      .theme-light .le-tags .search-container .search-input.has-error {\n        border-color: #d0021b;\n}\n.le-tags .search-container.theme-dark,\n    .theme-dark .le-tags .search-container {\n      padding: 0;\n}\n.le-tags .search-container.theme-dark :not(:focus):empty::before,\n      .theme-dark .le-tags .search-container :not(:focus):empty::before {\n        content: attr(placeholder);\n        display: block;\n        /* For Firefox */\n        font-size: 12px;\n        font-style: italic;\n        color: #666666;\n        border: 0;\n}\n.le-tags .search-container.theme-dark.disabled :focus:empty::before,\n      .le-tags .search-container.theme-dark.disabled :not(:focus):empty::before,\n      .theme-dark .le-tags .search-container.disabled :focus:empty::before,\n      .theme-dark .le-tags .search-container.disabled :not(:focus):empty::before {\n        content: attr(placeholder);\n        font-style: italic;\n        color: #f9f9f9;\n}\n.le-tags .search-container.theme-light,\n    .theme-light .le-tags .search-container {\n      padding: 0;\n}\n.le-tags .search-container.theme-light :not(:focus):empty::before,\n      .theme-light .le-tags .search-container :not(:focus):empty::before {\n        content: attr(placeholder);\n        display: block;\n        /* For Firefox */\n        font-size: 12px;\n        font-style: italic;\n        color: #6F737C;\n        border: 0;\n}\n.le-tags .search-container.theme-light.disabled :focus:empty::before,\n      .le-tags .search-container.theme-light.disabled :not(:focus):empty::before,\n      .theme-light .le-tags .search-container.disabled :focus:empty::before,\n      .theme-light .le-tags .search-container.disabled :not(:focus):empty::before {\n        content: attr(placeholder);\n        font-style: italic;\n        color: rgba(111, 115, 124, 0.5);\n}\n.icon-position {\n  position: absolute;\n  float: right;\n  top: 9px;\n  right: 6px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tag_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3241e012_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tag_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_tag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3241e012_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_tag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(507);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3c9129c4", content, true, {});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-tag{border-radius:2px;padding:0 7px 0 4px;font-size:11px;display:inline-block;line-height:18px;margin:1px 6px 5px 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;word-break:break-all}.le-tag.theme-dark,.theme-dark .le-tag{border:1px solid #bbc0c9;color:#ccc}.le-tag.theme-light,.theme-light .le-tag{border:1px solid #8c8d8f;color:#0a0a0a}.le-tag .label{vertical-align:middle}.le-tag .label.clickable{cursor:pointer}.le-tag .ico-close{border:none;outline:none;cursor:pointer;margin-left:2px}.le-tag .ico-close.theme-dark,.theme-dark .le-tag .ico-close{color:#bbc0c9}.le-tag .ico-close.theme-light,.theme-light .le-tag .ico-close{color:#6f737c}.le-tag.disabled.theme-dark,.theme-dark .le-tag.disabled{border-color:#ddd;background-color:#474a6a;color:#888}.le-tag.disabled.theme-light,.theme-light .le-tag.disabled{border-color:#8c8d8f;background-color:#ebecef;color:hsla(0,0%,4%,.5)}.le-tag.disabled .ico-close,.le-tag.disabled .label{cursor:default}.le-tag.disabled .ico-close.theme-dark,.theme-dark .le-tag.disabled .ico-close{color:#ddd}.le-tag.disabled .ico-close.theme-light,.theme-light .le-tag.disabled .ico-close{color:#6f737c}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-tags/le-tag.vue"],"names":[],"mappings":"AAIA,QACE,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,iBAAkB,AAClB,qBAAsB,AACtB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,iBAAkB,AAClB,oBAAsB,CACvB,AACD,uCAEI,yBAA0B,AAC1B,UAAe,CAClB,AACD,yCAEI,yBAA0B,AAC1B,aAAe,CAClB,AACD,eACI,qBAAuB,CAC1B,AACD,yBACM,cAAgB,CACrB,AACD,mBACI,YAAa,AACb,aAAc,AACd,eAAgB,AAChB,eAAiB,CACpB,AACD,6DAEM,aAAe,CACpB,AACD,+DAEM,aAAe,CACpB,AACD,yDAEI,kBAAsB,AACtB,yBAA0B,AAC1B,UAAe,CAClB,AACD,2DAEI,qBAAsB,AACtB,yBAA0B,AAC1B,sBAA6B,CAChC,AAID,oDACI,cAAgB,CACnB,AACD,+EAEM,UAAe,CACpB,AACD,iFAEM,aAAe,CACpB","file":"le-tag.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-tag {\n  border-radius: 2px;\n  padding: 0 7px 0 4px;\n  font-size: 11px;\n  display: inline-block;\n  line-height: 18px;\n  margin: 1px 6px 5px 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  word-break: break-all;\n}\n.le-tag.theme-dark,\n  .theme-dark .le-tag {\n    border: 1px solid #bbc0c9;\n    color: #cccccc;\n}\n.le-tag.theme-light,\n  .theme-light .le-tag {\n    border: 1px solid #8C8D8F;\n    color: #0A0A0A;\n}\n.le-tag .label {\n    vertical-align: middle;\n}\n.le-tag .label.clickable {\n      cursor: pointer;\n}\n.le-tag .ico-close {\n    border: none;\n    outline: none;\n    cursor: pointer;\n    margin-left: 2px;\n}\n.le-tag .ico-close.theme-dark,\n    .theme-dark .le-tag .ico-close {\n      color: #bbc0c9;\n}\n.le-tag .ico-close.theme-light,\n    .theme-light .le-tag .ico-close {\n      color: #6F737C;\n}\n.le-tag.disabled.theme-dark,\n  .theme-dark .le-tag.disabled {\n    border-color: #dddddd;\n    background-color: #474a6a;\n    color: #888888;\n}\n.le-tag.disabled.theme-light,\n  .theme-light .le-tag.disabled {\n    border-color: #8C8D8F;\n    background-color: #ebecef;\n    color: rgba(10, 10, 10, 0.5);\n}\n.le-tag.disabled .label {\n    cursor: default;\n}\n.le-tag.disabled .ico-close {\n    cursor: default;\n}\n.le-tag.disabled .ico-close.theme-dark,\n    .theme-dark .le-tag.disabled .ico-close {\n      color: #dddddd;\n}\n.le-tag.disabled .ico-close.theme-light,\n    .theme-light .le-tag.disabled .ico-close {\n      color: #6F737C;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tagTooltip, html: false, autoHide: false }),expression:"{ content: tagTooltip, html: false, autoHide: false }"}],class:['le-tag', {'disabled': !_vm.enabled}],attrs:{"role":"listitem"}},[_c('span',{class:['label', { clickable: _vm.clickable }],attrs:{"aria-label":_vm.tag[_vm.valueAttr],"data-test":"tag_value"},on:{"click":_vm.onSelectClick}},[_vm._v("\n    "+_vm._s(_vm.tag[_vm.valueAttr])+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"remove-button",attrs:{"role":"button","tabindex":"0","aria-label":_vm.removeButtonAriaLabel,"data-test":"tag_close_icon"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onUnselectClick($event)},"click":_vm.onUnselectClick}},[_c('i',{staticClass:"ico-6 ico-close"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('le-bubble',{attrs:{"theme":"dark","trigger":"manual","open":_vm.showError,"placement":_vm.errorPlacement,"hideOnTargetClick":true,"aria-disabled":!_vm.enabled}},[_c('template',{slot:"target"},[_c('div',{ref:"tagsContainer",class:['le-tags', { 'active': _vm.searchInputFocused }, { 'disabled': !_vm.enabled }, {'add-icon': _vm.isWarningIconEnable}],style:(_vm.tagsStyle),attrs:{"tabindex":"-1","data-test":"tags"},on:{"focus":_vm.onOuterFocus}},[_vm._l((_vm.tags),function(tag){return _c('le-tag',{key:tag[_vm.tagIdAttr],attrs:{"idAttr":_vm.tagIdAttr,"valueAttr":_vm.tagValueAttr,"closeLabel":_vm.closeLabel,"subtextAttr":_vm.tagSubtextAttr,"tag":tag,"enabled":_vm.enabled,"clickable":_vm.clickableTags,"data-test":("tag_" + _vm.tagIdAttr)},on:{"unselect":function($event){return _vm.onUnselect(tag[_vm.tagIdAttr])},"select":function($event){return _vm.onSelect(tag[_vm.tagIdAttr])}}})}),_vm._v(" "),_c('div',{class:['search-container', { 'disabled': !_vm.enabled }],style:(_vm.inputContainerStyle)},[_c('div',{ref:"searchInput",class:['search-input', { 'has-error': _vm.hasError }],attrs:{"aria-autocomplete":"list","role":"textbox","contenteditable":_vm.enabled,"tabindex":_vm.tabIndex,"placeholder":_vm.placeholderOnNoSelection,"aria-controls":_vm.controlId,"aria-labelledby":_vm.ariaLabelledBy,"aria-label":_vm.ariaLabel,"data-test":"tag_search"},on:{"keyup":_vm.onKeyup,"cut":_vm.onCut,"paste":_vm.onPaste,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onSubmit($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab($event)}],"focus":function($event){$event.preventDefault();return _vm.emitFocusEvent($event)},"blur":_vm.emitBlurEvent}},[_vm._v(_vm._s(_vm.searchInputText))])]),_vm._v(" "),(_vm.isWarningIconEnable)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.warningIconTooltipText, html: true, autoHide: false,placement:'bottom' }),expression:"{ content: warningIconTooltipText, html: true, autoHide: false,placement:'bottom' }"}],staticClass:"ico-14 ico-indicator icon-position",attrs:{"role":"img","aria-label":_vm.warningIconTooltipText}}):_vm._e()],2)]),_vm._v(" "),_c('template',{slot:"content"},[_c('span',{attrs:{"data-test":"tag_bubble_error"}},[_vm._v(_vm._s(_vm.bubbleErrorMsg))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_list_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a74ed6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_list_vue__ = __webpack_require__(515);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a74ed6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("68767870", content, true, {});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-select-list{font-size:12px;padding-left:0;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;margin:0;list-style:none;overflow-x:hidden;overflow-y:auto;z-index:999}.le-select-list.theme-dark,.theme-dark .le-select-list{color:#fff;background-color:#141a42;border:1px solid #474a6a}.le-select-list.theme-light,.theme-light .le-select-list{color:#666;background-color:#fff;border:1px solid #ddd}.le-select-list:focus .list-item-container{width:calc(100% - 4px);margin:0 auto}.le-select-list:focus .list-item-container:last-child.theme-dark.show-a11y-focus-outline,.theme-dark.show-a11y-focus-outline .le-select-list:focus .list-item-container:last-child{border-bottom:2px solid #52c7ef!important}.le-select-list:focus .list-item-container:last-child.theme-light.show-a11y-focus-outline,.theme-light.show-a11y-focus-outline .le-select-list:focus .list-item-container:last-child{border-bottom:2px solid #0c5de6!important}.le-select-list.floated-list{position:absolute}.le-select-list.floated-list.top-direction{bottom:100%}.le-select-list.has-items-separator .list-item-container.theme-dark,.theme-dark .le-select-list.has-items-separator .list-item-container{border-bottom:1px solid #474a6a}.le-select-list.has-items-separator .list-item-container.theme-light,.theme-light .le-select-list.has-items-separator .list-item-container{border-bottom:1px solid #ddd}.le-select-list .list-item-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;padding:8px 10px 8px 0}.le-select-list .list-item-container.pointed.theme-dark,.theme-dark .le-select-list .list-item-container.pointed{background-color:#2d3162}.le-select-list .list-item-container.pointed.theme-light,.theme-light .le-select-list .list-item-container.pointed{background-color:#f2f2f2}.le-select-list .list-item-container.selected{font-weight:700}.le-select-list .list-item-container.disabled{opacity:.5;cursor:default}.le-select-list .list-item-container .item.item-creation .item-content.theme-dark,.theme-dark .le-select-list .list-item-container .item.item-creation .item-content{color:#0c5de6}.le-select-list .list-item-container .item.item-creation .item-content.theme-light,.theme-light .le-select-list .list-item-container .item.item-creation .item-content{color:#349ec3}.le-select-list .list-item-container .item.placeholder-item .item-content.theme-dark,.theme-dark .le-select-list .list-item-container .item.placeholder-item .item-content{color:#b1b5bc}.le-select-list .list-item-container .item.placeholder-item .item-content.theme-light,.theme-light .le-select-list .list-item-container .item.placeholder-item .item-content{color:#888}.le-select-list .list-item-container .item.icon-item{width:100%}.le-select-list .list-item-container .item.icon-item .item-content{padding:0 8px;line-height:unset}.le-select-list .list-item-container .item .item-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;padding:0 12px;line-height:12px}.le-select-list .list-item-container .item .item-content.theme-dark,.theme-dark .le-select-list .list-item-container .item .item-content{color:#fff}.le-select-list .list-item-container .item .item-content.theme-light,.theme-light .le-select-list .list-item-container .item .item-content{color:#666}.le-select-list .list-item-container .item .item-content.under-group{margin-left:15px}.le-select-list .list-item-container .item .item-content .icon-with-text{display:inline-block;vertical-align:top;margin-right:5px}.le-select-list .list-item-container .item .item-content .le-checkbox{line-height:14px}.le-select-list .list-item-container .item .item-content .le-checkbox .indicator{vertical-align:top;margin-right:6px}.le-select-list .list-item-container .item .item-content .le-checkbox .label{font-size:12px;vertical-align:middle}.le-select-list .list-item-container .item .item-content .single-value{display:inline-block}.le-select-list .list-item-container .item .item-content.has-shortcut{padding-right:65px}.le-select-list .list-item-container .item .item-content.has-shortcut .shortcut{position:absolute;font-size:10px;display:inline-block;right:10px;padding-top:2px}.le-select-list .list-item-container .item .item-content.has-action .single-value{padding-right:23px}.le-select-list .list-item-container .item .item-content.has-action .action{position:absolute;right:5px}.le-select-list.bubble-list{overflow:visible;top:calc(100% + 10px);border-radius:4px}.le-select-list.bubble-list.theme-dark,.theme-dark .le-select-list.bubble-list{color:#666;background-color:#f3f6ff;border:1px solid #ddd;-webkit-box-shadow:0 2px 6px 1px rgba(0,0,0,.2);box-shadow:0 2px 6px 1px rgba(0,0,0,.2)}.le-select-list.bubble-list.theme-light,.theme-light .le-select-list.bubble-list{color:#666;background-color:#fff;border:1px solid #ddd;-webkit-box-shadow:0 2px 6px 1px rgba(0,0,0,.2);box-shadow:0 2px 6px 1px rgba(0,0,0,.2)}.le-select-list.bubble-list.has-items-separator .list-item-container.theme-dark,.le-select-list.bubble-list.has-items-separator .list-item-container.theme-light,.theme-dark .le-select-list.bubble-list.has-items-separator .list-item-container,.theme-light .le-select-list.bubble-list.has-items-separator .list-item-container{border-bottom:1px solid #ddd}.le-select-list.bubble-list.has-items-separator .list-item-container:last-child{border-bottom:none}.le-select-list.bubble-list.bubble-list-align-left.theme-dark:before,.le-select-list.bubble-list.bubble-list-align-right.theme-dark:before,.theme-dark .le-select-list.bubble-list.bubble-list-align-left:before,.theme-dark .le-select-list.bubble-list.bubble-list-align-right:before{border-bottom-color:#ddd;border-width:0 7px 7px}.le-select-list.bubble-list.bubble-list-align-left.theme-dark:after,.le-select-list.bubble-list.bubble-list-align-right.theme-dark:after,.theme-dark .le-select-list.bubble-list.bubble-list-align-left:after,.theme-dark .le-select-list.bubble-list.bubble-list-align-right:after{border-bottom-color:#f3f6ff;border-width:0 6px 6px}.le-select-list.bubble-list.bubble-list-align-left.theme-light:before,.le-select-list.bubble-list.bubble-list-align-right.theme-light:before,.theme-light .le-select-list.bubble-list.bubble-list-align-left:before,.theme-light .le-select-list.bubble-list.bubble-list-align-right:before{border-bottom-color:#ddd;border-width:0 7px 7px}.le-select-list.bubble-list.bubble-list-align-left.theme-light:after,.le-select-list.bubble-list.bubble-list-align-right.theme-light:after,.theme-light .le-select-list.bubble-list.bubble-list-align-left:after,.theme-light .le-select-list.bubble-list.bubble-list-align-right:after{border-bottom-color:#fff;border-width:0 6px 6px}.le-select-list.bubble-list.bubble-list-align-left{left:-20px}.le-select-list.bubble-list.bubble-list-align-left:before{left:21px}.le-select-list.bubble-list.bubble-list-align-left:after{left:22px;top:-5px}.le-select-list.bubble-list.bubble-list-align-right{right:-20px}.le-select-list.bubble-list.bubble-list-align-right:before{right:20px}.le-select-list.bubble-list.bubble-list-align-right:after{right:21px;top:-5px}.le-select-list.bubble-list.bubble-list-align-right .item .item-content.has-shortcut{padding-right:85px}.le-select-list.bubble-list.bubble-list-align-right .item .item-content.has-shortcut .shortcut{right:12px}.le-select-list.bubble-list:after,.le-select-list.bubble-list:before{bottom:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.le-select-list.bubble-list.top-direction:after,.le-select-list.bubble-list.top-direction:before{bottom:auto;top:100%}.le-select-list.bubble-list.top-direction.theme-dark:before,.theme-dark .le-select-list.bubble-list.top-direction:before{border-top-color:#ddd;border-width:7px 7px 0}.le-select-list.bubble-list.top-direction.theme-dark:after,.theme-dark .le-select-list.bubble-list.top-direction:after{border-top-color:#f3f6ff;border-width:6px 6px 0}.le-select-list.bubble-list.top-direction.theme-light:before,.theme-light .le-select-list.bubble-list.top-direction:before{border-top-color:#ddd;border-width:7px 7px 0}.le-select-list.bubble-list.top-direction.theme-light:after,.theme-light .le-select-list.bubble-list.top-direction:after{border-top-color:#fff;border-width:6px 6px 0}.le-select-list.bubble-list .list-item-container.pointed.theme-dark,.le-select-list.bubble-list .list-item-container.pointed.theme-light,.theme-dark .le-select-list.bubble-list .list-item-container.pointed,.theme-light .le-select-list.bubble-list .list-item-container.pointed{background-color:#e6e8ed}.le-select-list.bubble-list .list-item-container .item.item-creation .item-content.theme-dark,.le-select-list.bubble-list .list-item-container .item.item-creation .item-content.theme-light,.theme-dark .le-select-list.bubble-list .list-item-container .item.item-creation .item-content,.theme-light .le-select-list.bubble-list .list-item-container .item.item-creation .item-content{color:#0c5de6}.le-select-list.bubble-list .list-item-container .item .item-content.theme-dark,.le-select-list.bubble-list .list-item-container .item .item-content.theme-light,.le-select-list.bubble-list .list-item-container .item.no-items.theme-dark,.le-select-list.bubble-list .list-item-container .item.no-items.theme-light,.theme-dark .le-select-list.bubble-list .list-item-container .item .item-content,.theme-dark .le-select-list.bubble-list .list-item-container .item.no-items,.theme-light .le-select-list.bubble-list .list-item-container .item .item-content,.theme-light .le-select-list.bubble-list .list-item-container .item.no-items{color:#666}.le-select-list.bubble-list li{list-style-type:none}.le-select-list.bubble-list li .icon{padding-top:2px}.le-select-list.always-open{position:relative;margin-top:2px;-webkit-box-shadow:none;box-shadow:none}.le-select-list.always-open:after,.le-select-list.always-open:before{border:none}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-select/le-select-list.vue"],"names":[],"mappings":"AAIA,gBACE,eAAgB,AAChB,eAAgB,AAChB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,SAAU,AACV,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,WAAa,CACd,AACD,uDAEI,WAAe,AACf,yBAA0B,AAC1B,wBAA0B,CAC7B,AACD,yDAEI,WAAe,AACf,sBAA0B,AAC1B,qBAA0B,CAC7B,AACD,2CACI,uBAAwB,AACxB,aAAe,CAClB,AACD,mLAEM,yCAA4C,CACjD,AACD,qLAEM,yCAA4C,CACjD,AACD,6BACI,iBAAmB,CACtB,AACD,2CACM,WAAa,CAClB,AACD,yIAEI,+BAAiC,CACpC,AACD,2IAEI,4BAAiC,CACpC,AACD,qCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,8BAA+B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,sBAA0B,CAC7B,AACD,iHAEM,wBAA0B,CAC/B,AACD,mHAEM,wBAA0B,CAC/B,AACD,8CACM,eAAkB,CACvB,AACD,8CACM,WAAa,AACb,cAAgB,CACrB,AACD,qKAEM,aAAe,CACpB,AACD,uKAEM,aAAe,CACpB,AACD,2KAEM,aAAe,CACpB,AACD,6KAEM,UAAe,CACpB,AACD,qDACM,UAAY,CACjB,AACD,mEACQ,cAAe,AACf,iBAAmB,CAC1B,AACD,yDACM,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,iBAAkB,AAClB,mBAAoB,AACpB,eAAgB,AAChB,gBAAkB,CACvB,AACD,yIAEQ,UAAe,CACtB,AACD,2IAEQ,UAAe,CACtB,AACD,qEACQ,gBAAkB,CACzB,AACD,yEACQ,qBAAsB,AACtB,mBAAoB,AACpB,gBAAkB,CACzB,AACD,sEACQ,gBAAkB,CACzB,AACD,iFACU,mBAAoB,AACpB,gBAAkB,CAC3B,AACD,6EACU,eAAgB,AAChB,qBAAuB,CAChC,AACD,uEACQ,oBAAsB,CAC7B,AACD,sEACQ,kBAAoB,CAC3B,AACD,gFACU,kBAAmB,AACnB,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,eAAiB,CAC1B,AACD,kFACQ,kBAAoB,CAC3B,AACD,4EACQ,kBAAmB,AACnB,SAAW,CAClB,AACD,4BACI,iBAAkB,AAClB,sBAAuB,AACvB,iBAAmB,CACtB,AACD,+EAEM,WAAe,AACf,yBAA0B,AAC1B,sBAA0B,AAC1B,gDAAqD,AAC7C,uCAA6C,CAC1D,AACD,iFAEM,WAAe,AACf,sBAA0B,AAC1B,sBAA0B,AAC1B,gDAAqD,AAC7C,uCAA6C,CAC1D,AAKD,oUAEM,4BAAiC,CACtC,AACD,gFACM,kBAAoB,CACzB,AACD,wRAGM,yBAA6B,AAC7B,sBAA4B,CACjC,AACD,oRAGM,4BAA6B,AAC7B,sBAA4B,CACjC,AACD,4RAGM,yBAA6B,AAC7B,sBAA4B,CACjC,AACD,wRAGM,yBAA6B,AAC7B,sBAA4B,CACjC,AACD,mDACM,UAAkB,CACvB,AACD,0DACQ,SAAW,CAClB,AACD,yDACQ,UAAW,AACX,QAAU,CACjB,AACD,oDACM,WAAmB,CACxB,AACD,2DACQ,UAAY,CACnB,AACD,0DACQ,WAAY,AACZ,QAAU,CACjB,AACD,qFACQ,kBAAiC,CACxC,AACD,+FACU,UAAY,CACrB,AACD,qEACM,YAAa,AACb,yBAA0B,AAC1B,YAAa,AACb,SAAU,AACV,QAAS,AACT,kBAAmB,AACnB,mBAAqB,CAC1B,AACD,iGACM,YAAa,AACb,QAAU,CACf,AACD,yHAEM,sBAA0B,AAC1B,sBAA4B,CACjC,AACD,uHAEM,yBAA0B,AAC1B,sBAA4B,CACjC,AACD,2HAEM,sBAA0B,AAC1B,sBAA4B,CACjC,AACD,yHAEM,sBAA0B,AAC1B,sBAA4B,CACjC,AAKD,oRAEM,wBAA0B,CAC/B,AAKD,4XAEM,aAAe,CACpB,AAaD,onBAEM,UAAe,CACpB,AACD,+BACM,oBAAsB,CAC3B,AACD,qCACQ,eAAiB,CACxB,AACD,4BACI,kBAAmB,AACnB,eAAgB,AAChB,wBAAyB,AACjB,eAAiB,CAC5B,AAID,qEACM,WAAa,CAClB","file":"le-select-list.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-select-list {\n  font-size: 12px;\n  padding-left: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n  margin: 0;\n  list-style: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 999;\n}\n.le-select-list.theme-dark,\n  .theme-dark .le-select-list {\n    color: #ffffff;\n    background-color: #141a42;\n    border: 1px solid #474a6a;\n}\n.le-select-list.theme-light,\n  .theme-light .le-select-list {\n    color: #666666;\n    background-color: #ffffff;\n    border: 1px solid #dddddd;\n}\n.le-select-list:focus .list-item-container {\n    width: calc(100% - 4px);\n    margin: 0 auto;\n}\n.le-select-list:focus .list-item-container:last-child.theme-dark.show-a11y-focus-outline,\n    .theme-dark.show-a11y-focus-outline .le-select-list:focus .list-item-container:last-child {\n      border-bottom: 2px solid #52c7ef !important;\n}\n.le-select-list:focus .list-item-container:last-child.theme-light.show-a11y-focus-outline,\n    .theme-light.show-a11y-focus-outline .le-select-list:focus .list-item-container:last-child {\n      border-bottom: 2px solid #0c5de6 !important;\n}\n.le-select-list.floated-list {\n    position: absolute;\n}\n.le-select-list.floated-list.top-direction {\n      bottom: 100%;\n}\n.le-select-list.has-items-separator .list-item-container.theme-dark,\n  .theme-dark .le-select-list.has-items-separator .list-item-container {\n    border-bottom: 1px solid #474a6a;\n}\n.le-select-list.has-items-separator .list-item-container.theme-light,\n  .theme-light .le-select-list.has-items-separator .list-item-container {\n    border-bottom: 1px solid #dddddd;\n}\n.le-select-list .list-item-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    cursor: pointer;\n    padding: 8px 10px 8px 0px;\n}\n.le-select-list .list-item-container.pointed.theme-dark,\n    .theme-dark .le-select-list .list-item-container.pointed {\n      background-color: #2d3162;\n}\n.le-select-list .list-item-container.pointed.theme-light,\n    .theme-light .le-select-list .list-item-container.pointed {\n      background-color: #f2f2f2;\n}\n.le-select-list .list-item-container.selected {\n      font-weight: bold;\n}\n.le-select-list .list-item-container.disabled {\n      opacity: 0.5;\n      cursor: default;\n}\n.le-select-list .list-item-container .item.item-creation .item-content.theme-dark,\n    .theme-dark .le-select-list .list-item-container .item.item-creation .item-content {\n      color: #0c5de6;\n}\n.le-select-list .list-item-container .item.item-creation .item-content.theme-light,\n    .theme-light .le-select-list .list-item-container .item.item-creation .item-content {\n      color: #349ec3;\n}\n.le-select-list .list-item-container .item.placeholder-item .item-content.theme-dark,\n    .theme-dark .le-select-list .list-item-container .item.placeholder-item .item-content {\n      color: #b1b5bc;\n}\n.le-select-list .list-item-container .item.placeholder-item .item-content.theme-light,\n    .theme-light .le-select-list .list-item-container .item.placeholder-item .item-content {\n      color: #888888;\n}\n.le-select-list .list-item-container .item.icon-item {\n      width: 100%;\n}\n.le-select-list .list-item-container .item.icon-item .item-content {\n        padding: 0 8px;\n        line-height: unset;\n}\n.le-select-list .list-item-container .item .item-content {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      white-space: nowrap;\n      padding: 0 12px;\n      line-height: 12px;\n}\n.le-select-list .list-item-container .item .item-content.theme-dark,\n      .theme-dark .le-select-list .list-item-container .item .item-content {\n        color: #ffffff;\n}\n.le-select-list .list-item-container .item .item-content.theme-light,\n      .theme-light .le-select-list .list-item-container .item .item-content {\n        color: #666666;\n}\n.le-select-list .list-item-container .item .item-content.under-group {\n        margin-left: 15px;\n}\n.le-select-list .list-item-container .item .item-content .icon-with-text {\n        display: inline-block;\n        vertical-align: top;\n        margin-right: 5px;\n}\n.le-select-list .list-item-container .item .item-content .le-checkbox {\n        line-height: 14px;\n}\n.le-select-list .list-item-container .item .item-content .le-checkbox .indicator {\n          vertical-align: top;\n          margin-right: 6px;\n}\n.le-select-list .list-item-container .item .item-content .le-checkbox .label {\n          font-size: 12px;\n          vertical-align: middle;\n}\n.le-select-list .list-item-container .item .item-content .single-value {\n        display: inline-block;\n}\n.le-select-list .list-item-container .item .item-content.has-shortcut {\n        padding-right: 65px;\n}\n.le-select-list .list-item-container .item .item-content.has-shortcut .shortcut {\n          position: absolute;\n          font-size: 10px;\n          display: inline-block;\n          right: 10px;\n          padding-top: 2px;\n}\n.le-select-list .list-item-container .item .item-content.has-action .single-value {\n        padding-right: 23px;\n}\n.le-select-list .list-item-container .item .item-content.has-action .action {\n        position: absolute;\n        right: 5px;\n}\n.le-select-list.bubble-list {\n    overflow: visible;\n    top: calc(100% + 10px);\n    border-radius: 4px;\n}\n.le-select-list.bubble-list.theme-dark,\n    .theme-dark .le-select-list.bubble-list {\n      color: #666666;\n      background-color: #f3f6ff;\n      border: 1px solid #dddddd;\n      -webkit-box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n}\n.le-select-list.bubble-list.theme-light,\n    .theme-light .le-select-list.bubble-list {\n      color: #666666;\n      background-color: #ffffff;\n      border: 1px solid #dddddd;\n      -webkit-box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n}\n.le-select-list.bubble-list.has-items-separator .list-item-container.theme-dark,\n    .theme-dark .le-select-list.bubble-list.has-items-separator .list-item-container {\n      border-bottom: 1px solid #dddddd;\n}\n.le-select-list.bubble-list.has-items-separator .list-item-container.theme-light,\n    .theme-light .le-select-list.bubble-list.has-items-separator .list-item-container {\n      border-bottom: 1px solid #dddddd;\n}\n.le-select-list.bubble-list.has-items-separator .list-item-container:last-child {\n      border-bottom: none;\n}\n.le-select-list.bubble-list.bubble-list-align-left.theme-dark:before,\n    .theme-dark .le-select-list.bubble-list.bubble-list-align-left:before, .le-select-list.bubble-list.bubble-list-align-right.theme-dark:before,\n    .theme-dark .le-select-list.bubble-list.bubble-list-align-right:before {\n      border-bottom-color: #dddddd;\n      border-width: 0 7px 7px 7px;\n}\n.le-select-list.bubble-list.bubble-list-align-left.theme-dark:after,\n    .theme-dark .le-select-list.bubble-list.bubble-list-align-left:after, .le-select-list.bubble-list.bubble-list-align-right.theme-dark:after,\n    .theme-dark .le-select-list.bubble-list.bubble-list-align-right:after {\n      border-bottom-color: #f3f6ff;\n      border-width: 0 6px 6px 6px;\n}\n.le-select-list.bubble-list.bubble-list-align-left.theme-light:before,\n    .theme-light .le-select-list.bubble-list.bubble-list-align-left:before, .le-select-list.bubble-list.bubble-list-align-right.theme-light:before,\n    .theme-light .le-select-list.bubble-list.bubble-list-align-right:before {\n      border-bottom-color: #dddddd;\n      border-width: 0 7px 7px 7px;\n}\n.le-select-list.bubble-list.bubble-list-align-left.theme-light:after,\n    .theme-light .le-select-list.bubble-list.bubble-list-align-left:after, .le-select-list.bubble-list.bubble-list-align-right.theme-light:after,\n    .theme-light .le-select-list.bubble-list.bubble-list-align-right:after {\n      border-bottom-color: #ffffff;\n      border-width: 0 6px 6px 6px;\n}\n.le-select-list.bubble-list.bubble-list-align-left {\n      left: calc(-20px);\n}\n.le-select-list.bubble-list.bubble-list-align-left:before {\n        left: 21px;\n}\n.le-select-list.bubble-list.bubble-list-align-left:after {\n        left: 22px;\n        top: -5px;\n}\n.le-select-list.bubble-list.bubble-list-align-right {\n      right: calc(-20px);\n}\n.le-select-list.bubble-list.bubble-list-align-right:before {\n        right: 20px;\n}\n.le-select-list.bubble-list.bubble-list-align-right:after {\n        right: 21px;\n        top: -5px;\n}\n.le-select-list.bubble-list.bubble-list-align-right .item .item-content.has-shortcut {\n        padding-right: calc(65px + 20px);\n}\n.le-select-list.bubble-list.bubble-list-align-right .item .item-content.has-shortcut .shortcut {\n          right: 12px;\n}\n.le-select-list.bubble-list:before, .le-select-list.bubble-list:after {\n      bottom: 100%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n}\n.le-select-list.bubble-list.top-direction:before, .le-select-list.bubble-list.top-direction:after {\n      bottom: auto;\n      top: 100%;\n}\n.le-select-list.bubble-list.top-direction.theme-dark:before,\n    .theme-dark .le-select-list.bubble-list.top-direction:before {\n      border-top-color: #dddddd;\n      border-width: 7px 7px 0 7px;\n}\n.le-select-list.bubble-list.top-direction.theme-dark:after,\n    .theme-dark .le-select-list.bubble-list.top-direction:after {\n      border-top-color: #f3f6ff;\n      border-width: 6px 6px 0 6px;\n}\n.le-select-list.bubble-list.top-direction.theme-light:before,\n    .theme-light .le-select-list.bubble-list.top-direction:before {\n      border-top-color: #dddddd;\n      border-width: 7px 7px 0 7px;\n}\n.le-select-list.bubble-list.top-direction.theme-light:after,\n    .theme-light .le-select-list.bubble-list.top-direction:after {\n      border-top-color: #ffffff;\n      border-width: 6px 6px 0 6px;\n}\n.le-select-list.bubble-list .list-item-container.pointed.theme-dark,\n    .theme-dark .le-select-list.bubble-list .list-item-container.pointed {\n      background-color: #e6e8ed;\n}\n.le-select-list.bubble-list .list-item-container.pointed.theme-light,\n    .theme-light .le-select-list.bubble-list .list-item-container.pointed {\n      background-color: #e6e8ed;\n}\n.le-select-list.bubble-list .list-item-container .item.item-creation .item-content.theme-dark,\n    .theme-dark .le-select-list.bubble-list .list-item-container .item.item-creation .item-content {\n      color: #0c5de6;\n}\n.le-select-list.bubble-list .list-item-container .item.item-creation .item-content.theme-light,\n    .theme-light .le-select-list.bubble-list .list-item-container .item.item-creation .item-content {\n      color: #0c5de6;\n}\n.le-select-list.bubble-list .list-item-container .item.no-items.theme-dark,\n    .theme-dark .le-select-list.bubble-list .list-item-container .item.no-items {\n      color: #666666;\n}\n.le-select-list.bubble-list .list-item-container .item.no-items.theme-light,\n    .theme-light .le-select-list.bubble-list .list-item-container .item.no-items {\n      color: #666666;\n}\n.le-select-list.bubble-list .list-item-container .item .item-content.theme-dark,\n    .theme-dark .le-select-list.bubble-list .list-item-container .item .item-content {\n      color: #666666;\n}\n.le-select-list.bubble-list .list-item-container .item .item-content.theme-light,\n    .theme-light .le-select-list.bubble-list .list-item-container .item .item-content {\n      color: #666666;\n}\n.le-select-list.bubble-list li {\n      list-style-type: none;\n}\n.le-select-list.bubble-list li .icon {\n        padding-top: 2px;\n}\n.le-select-list.always-open {\n    position: relative;\n    margin-top: 2px;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n.le-select-list.always-open:before {\n      border: none;\n}\n.le-select-list.always-open:after {\n      border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8322e5b2", content, true, {});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-text-with-highlight[data-v-45cffbac]{display:inline-block;word-break:break-word;word-wrap:break-word;white-space:pre-wrap}.le-text-with-highlight .text.highlight.theme-dark[data-v-45cffbac],.le-text-with-highlight .text.highlight.theme-light[data-v-45cffbac],.theme-dark .le-text-with-highlight .text.highlight[data-v-45cffbac],.theme-light .le-text-with-highlight .text.highlight[data-v-45cffbac]{background-color:rgba(12,93,230,.5)}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-with-highlight/le-text-with-highlight.vue"],"names":[],"mappings":"AAIA,yCACE,qBAAsB,AACtB,sBAAuB,AACvB,qBAAsB,AACtB,oBAAsB,CACvB,AAKD,oRAEI,mCAAyC,CAC5C","file":"le-text-with-highlight.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-text-with-highlight[data-v-45cffbac] {\n  display: inline-block;\n  word-break: break-word;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n.le-text-with-highlight .text.highlight.theme-dark[data-v-45cffbac],\n  .theme-dark .le-text-with-highlight .text.highlight[data-v-45cffbac] {\n    background-color: rgba(12, 93, 230, 0.5);\n}\n.le-text-with-highlight .text.highlight.theme-light[data-v-45cffbac],\n  .theme-light .le-text-with-highlight .text.highlight[data-v-45cffbac] {\n    background-color: rgba(12, 93, 230, 0.5);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('ul',{ref:"list",class:['le-select-list',("bubble-list-align-" + _vm.bubbleListAlign),
  { 'floated-list': _vm.floatedList, 'top-direction': _vm.openListOnTop, 'bubble-list': _vm.bubbleList, 'has-items-separator': _vm.addItemsSeparator, 'always-open': _vm.isOpenList}],style:({ 'max-height': (_vm.listMaxHeight + "px"), 'min-width': ("" + _vm.minWidth)}),attrs:{"role":"listbox","aria-label":_vm.ariaLabel,"tabindex":_vm.tabIndex},on:{"mousedown":function($event){$event.preventDefault();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onWrapperTab($event)},"scroll":_vm.onListScroll}},_vm._l((_vm.items),function(item,index){return _c('li',{key:item[_vm.itemIdAttr],class:['list-item-container', item.className, { pointed: _vm.isPointed(index, item, _vm.items.length) }, { selected: _vm.isItemSelected(item) || _vm.isGroupSelected(item) }, { disabled: item.disabled }],style:({ minHeight: (_vm.itemMinHeight + "px")}),attrs:{"role":"option","aria-selected":_vm.isItemSelected(item).toString(),"disabled":item.disabled,"data-test":("list_item_" + index)},on:{"click":function($event){return _vm.onItemClicked(item)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onItemClicked(item)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onItemTab(_vm.event, index)}],"mouseover":function($event){return _vm.onItemHover(item, index)}}},[(_vm.isSpecialItem(item) || _vm.isGroupItem(item))?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: item[_vm.itemTooltipAttr], html: false, autoHide: false }),expression:"{ content: item[itemTooltipAttr], html: false, autoHide: false }"}],class:['item', _vm.getSpecialItemClass(item)],attrs:{"data-test":("list_item_" + index + "_special")}},[_c('div',{staticClass:"item-content"},[(_vm.showGroupItemCheckbox(item))?_c('le-checkbox',{attrs:{"tabbable":false,"label":_vm.getItemLabel(item),"state":_vm.getGroupItemState(item),"data-test":("list_item_" + index + "_special_checkbox")}},[_c('le-text-with-highlight',{attrs:{"text":_vm.getItemLabel(item),"highlightText":_vm.searchTerm,"data-test":("list_item_" + index + "_special_highlight")}})],1):_c('span',{attrs:{"data-test":("list_item_" + index + "_special_txt")}},[_vm._v(_vm._s(item[_vm.itemValueAttr]))])],1)]):_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: item[_vm.itemTooltipAttr], html: false, autoHide: false }),expression:"{ content: item[itemTooltipAttr], html: false, autoHide: false }"}],class:['item', { 'icon-item': _vm.hasIconsOnly } ],attrs:{"data-test":("list_item_" + index + "_content")}},[_c('div',{class:['item-content', {'has-shortcut': _vm.hasShortcuts, 'under-group': _vm.isMultiSelect && _vm.groupSelection, 'has-action': _vm.hasAction  }]},[(_vm.isMultiSelect)?_c('le-checkbox',{attrs:{"tabbable":false,"label":_vm.getItemLabel(item),"state":_vm.isItemSelected(item),"data-test":("list_item_" + index + "_checkbox")},on:{"focus":function($event){return _vm.onItemHover(item, index)}}},[_c('le-text-with-highlight',{attrs:{"text":_vm.getItemLabel(item),"highlightText":_vm.searchTerm,"data-test":("list_item_" + index + "_highlight")}})],1):_vm._e(),_vm._v(" "),(_vm.hasIconsOnly)?_c('i',{class:[item[_vm.itemValueAttr], 'icon'],attrs:{"data-test":("list_item_" + index + "_icon_only")}}):(_vm.hasIconsAndText)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.getIconTooltip(item), html: false, autoHide: false }),expression:"{ content: getIconTooltip(item), html: false, autoHide: false }"}],staticClass:"icon-with-text",class:_vm.getIconClass(item),attrs:{"data-test":("list_item_" + index + "_icon_and_txt")}}):_vm._e(),_vm._v(" "),(!_vm.isMultiSelect && (_vm.hasIconsAndText || !_vm.hasIconsOnly))?_c('le-text-with-highlight',{staticClass:"single-value",attrs:{"text":_vm.getItemLabel(item),"highlightText":_vm.searchTerm,"data-test":("list_item_" + index + "_highlight_single_value")}}):_vm._e(),_vm._v(" "),(_vm.hasShortcuts)?_c('span',{staticClass:"shortcut",attrs:{"data-test":("list_item_" + index + "_shortcut_txt")}},[_vm._v(_vm._s(_vm.getItemShortcut(item)))]):_vm._e(),_vm._v(" "),(_vm.isItemActionable(item))?_c('i',{staticClass:"action",class:_vm.getActionIconClass(item),attrs:{"data-test":("list_item_" + index + "_action_icon")},on:{"click":function($event){$event.stopPropagation();return _vm.onItemActionClick(item)}}}):_vm._e()],1)])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6d7817b3", content, true, {});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-combobox-input-container[data-v-8f01462e],.le-input-field[data-v-8f01462e]{position:relative}.le-combobox-input-container .reset-button[data-v-8f01462e],.le-combobox-input-container .right-icon[data-v-8f01462e],.le-input-field .reset-button[data-v-8f01462e],.le-input-field .right-icon[data-v-8f01462e]{cursor:pointer;position:absolute;right:0;padding:10px;top:0;bottom:0;margin:auto}.le-combobox-input-container .reset-button.theme-dark[data-v-8f01462e],.le-combobox-input-container .right-icon.theme-dark[data-v-8f01462e],.le-input-field .reset-button.theme-dark[data-v-8f01462e],.le-input-field .right-icon.theme-dark[data-v-8f01462e],.theme-dark .le-combobox-input-container .reset-button[data-v-8f01462e],.theme-dark .le-combobox-input-container .right-icon[data-v-8f01462e],.theme-dark .le-input-field .reset-button[data-v-8f01462e],.theme-dark .le-input-field .right-icon[data-v-8f01462e]{color:#a9afba}.le-combobox-input-container .reset-button.theme-light[data-v-8f01462e],.le-combobox-input-container .right-icon.theme-light[data-v-8f01462e],.le-input-field .reset-button.theme-light[data-v-8f01462e],.le-input-field .right-icon.theme-light[data-v-8f01462e],.theme-light .le-combobox-input-container .reset-button[data-v-8f01462e],.theme-light .le-combobox-input-container .right-icon[data-v-8f01462e],.theme-light .le-input-field .reset-button[data-v-8f01462e],.theme-light .le-input-field .right-icon[data-v-8f01462e]{color:#888}.le-combobox-input-container .left-icon[data-v-8f01462e],.le-combobox-input-container .search-icon[data-v-8f01462e],.le-input-field .left-icon[data-v-8f01462e],.le-input-field .search-icon[data-v-8f01462e]{position:absolute;left:9px;top:1px;bottom:0;margin:auto}.le-combobox-input-container .left-icon.theme-dark[data-v-8f01462e],.le-combobox-input-container .search-icon.theme-dark[data-v-8f01462e],.le-input-field .left-icon.theme-dark[data-v-8f01462e],.le-input-field .search-icon.theme-dark[data-v-8f01462e],.theme-dark .le-combobox-input-container .left-icon[data-v-8f01462e],.theme-dark .le-combobox-input-container .search-icon[data-v-8f01462e],.theme-dark .le-input-field .left-icon[data-v-8f01462e],.theme-dark .le-input-field .search-icon[data-v-8f01462e]{color:#a9afba}.le-combobox-input-container .left-icon.theme-light[data-v-8f01462e],.le-combobox-input-container .search-icon.theme-light[data-v-8f01462e],.le-input-field .left-icon.theme-light[data-v-8f01462e],.le-input-field .search-icon.theme-light[data-v-8f01462e],.theme-light .le-combobox-input-container .left-icon[data-v-8f01462e],.theme-light .le-combobox-input-container .search-icon[data-v-8f01462e],.theme-light .le-input-field .left-icon[data-v-8f01462e],.theme-light .le-input-field .search-icon[data-v-8f01462e]{color:#888}.le-combobox-input-container.theme-dark .input[data-v-8f01462e],.le-input-field.theme-dark .input[data-v-8f01462e],.theme-dark .le-combobox-input-container .input[data-v-8f01462e],.theme-dark .le-input-field .input[data-v-8f01462e]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border-radius:2px;border:1px solid #474a6a;background-color:rgba(71,74,106,.5);color:#fff}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]:hover,.le-input-field.theme-dark .input[data-v-8f01462e]:hover,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]:hover,.theme-dark .le-input-field .input[data-v-8f01462e]:hover{border-color:#2d3162}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]:focus,.le-input-field.theme-dark .input[data-v-8f01462e]:focus,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]:focus,.theme-dark .le-input-field .input[data-v-8f01462e]:focus{border-color:#5879da}.le-combobox-input-container.theme-dark .input.has-left-icon[data-v-8f01462e],.le-input-field.theme-dark .input.has-left-icon[data-v-8f01462e],.theme-dark .le-combobox-input-container .input.has-left-icon[data-v-8f01462e],.theme-dark .le-input-field .input.has-left-icon[data-v-8f01462e]{padding-left:25px}.le-combobox-input-container.theme-dark .input.has-right-icon[data-v-8f01462e],.le-input-field.theme-dark .input.has-right-icon[data-v-8f01462e],.theme-dark .le-combobox-input-container .input.has-right-icon[data-v-8f01462e],.theme-dark .le-input-field .input.has-right-icon[data-v-8f01462e]{padding-right:25px}.le-combobox-input-container.theme-dark .input.has-error[data-v-8f01462e],.le-input-field.theme-dark .input.has-error[data-v-8f01462e],.theme-dark .le-combobox-input-container .input.has-error[data-v-8f01462e],.theme-dark .le-input-field .input.has-error[data-v-8f01462e]{border-color:#ff1820}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-webkit-input-placeholder,.le-input-field.theme-dark .input[data-v-8f01462e]::-webkit-input-placeholder,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]::-webkit-input-placeholder,.theme-dark .le-input-field .input[data-v-8f01462e]::-webkit-input-placeholder{font-style:italic;color:#fff}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-moz-placeholder,.le-input-field.theme-dark .input[data-v-8f01462e]::-moz-placeholder,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]::-moz-placeholder,.theme-dark .le-input-field .input[data-v-8f01462e]::-moz-placeholder{font-style:italic;color:#fff}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-ms-input-placeholder,.le-input-field.theme-dark .input[data-v-8f01462e]::-ms-input-placeholder,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]::-ms-input-placeholder,.theme-dark .le-input-field .input[data-v-8f01462e]::-ms-input-placeholder{font-style:italic;color:#fff}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]::placeholder,.le-input-field.theme-dark .input[data-v-8f01462e]::placeholder,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]::placeholder,.theme-dark .le-input-field .input[data-v-8f01462e]::placeholder{font-style:italic;color:#fff}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,.le-input-field.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder,.theme-dark .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder{font-style:italic;color:#fff}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e],.le-input-field.theme-dark .input.disabled[data-v-8f01462e],.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e],.theme-dark .le-input-field .input.disabled[data-v-8f01462e]{border:1px solid transparent;background-color:#474a6a;color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-webkit-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-moz-placeholder,.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-moz-placeholder,.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e]::-moz-placeholder,.theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-moz-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::placeholder,.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::placeholder,.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e]::placeholder,.theme-dark .le-input-field .input.disabled[data-v-8f01462e]::placeholder{color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.le-input-field.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.theme-dark .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.theme-dark .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-ms-clear,.le-input-field.theme-dark .input[data-v-8f01462e]::-ms-clear,.theme-dark .le-combobox-input-container .input[data-v-8f01462e]::-ms-clear,.theme-dark .le-input-field .input[data-v-8f01462e]::-ms-clear{display:none;width:0;height:0}.le-combobox-input-container.theme-light .input[data-v-8f01462e],.le-input-field.theme-light .input[data-v-8f01462e],.theme-light .le-combobox-input-container .input[data-v-8f01462e],.theme-light .le-input-field .input[data-v-8f01462e]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border-radius:2px;border:1px solid #8c8d8f;background-color:#fcfcfd;color:#0a0a0a}.le-combobox-input-container.theme-light .input[data-v-8f01462e]:hover,.le-input-field.theme-light .input[data-v-8f01462e]:hover,.theme-light .le-combobox-input-container .input[data-v-8f01462e]:hover,.theme-light .le-input-field .input[data-v-8f01462e]:hover{border-color:#8c8d8f}.le-combobox-input-container.theme-light .input[data-v-8f01462e]:focus,.le-input-field.theme-light .input[data-v-8f01462e]:focus,.theme-light .le-combobox-input-container .input[data-v-8f01462e]:focus,.theme-light .le-input-field .input[data-v-8f01462e]:focus{border-color:#666}.le-combobox-input-container.theme-light .input.has-left-icon[data-v-8f01462e],.le-input-field.theme-light .input.has-left-icon[data-v-8f01462e],.theme-light .le-combobox-input-container .input.has-left-icon[data-v-8f01462e],.theme-light .le-input-field .input.has-left-icon[data-v-8f01462e]{padding-left:25px}.le-combobox-input-container.theme-light .input.has-right-icon[data-v-8f01462e],.le-input-field.theme-light .input.has-right-icon[data-v-8f01462e],.theme-light .le-combobox-input-container .input.has-right-icon[data-v-8f01462e],.theme-light .le-input-field .input.has-right-icon[data-v-8f01462e]{padding-right:25px}.le-combobox-input-container.theme-light .input.has-error[data-v-8f01462e],.le-input-field.theme-light .input.has-error[data-v-8f01462e],.theme-light .le-combobox-input-container .input.has-error[data-v-8f01462e],.theme-light .le-input-field .input.has-error[data-v-8f01462e]{border-color:#d0021b}.le-combobox-input-container.theme-light .input[data-v-8f01462e]::-webkit-input-placeholder,.le-input-field.theme-light .input[data-v-8f01462e]::-webkit-input-placeholder,.theme-light .le-combobox-input-container .input[data-v-8f01462e]::-webkit-input-placeholder,.theme-light .le-input-field .input[data-v-8f01462e]::-webkit-input-placeholder{font-style:italic;color:#6f737c}.le-combobox-input-container.theme-light .input[data-v-8f01462e]::-moz-placeholder,.le-input-field.theme-light .input[data-v-8f01462e]::-moz-placeholder,.theme-light .le-combobox-input-container .input[data-v-8f01462e]::-moz-placeholder,.theme-light .le-input-field .input[data-v-8f01462e]::-moz-placeholder{font-style:italic;color:#6f737c}.le-combobox-input-container.theme-light .input[data-v-8f01462e]::-ms-input-placeholder,.le-input-field.theme-light .input[data-v-8f01462e]::-ms-input-placeholder,.theme-light .le-combobox-input-container .input[data-v-8f01462e]::-ms-input-placeholder,.theme-light .le-input-field .input[data-v-8f01462e]::-ms-input-placeholder{font-style:italic;color:#6f737c}.le-combobox-input-container.theme-light .input[data-v-8f01462e]::placeholder,.le-input-field.theme-light .input[data-v-8f01462e]::placeholder,.theme-light .le-combobox-input-container .input[data-v-8f01462e]::placeholder,.theme-light .le-input-field .input[data-v-8f01462e]::placeholder{font-style:italic;color:#6f737c}.le-combobox-input-container.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,.le-input-field.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,.theme-light .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder,.theme-light .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder{font-style:italic;color:#6f737c}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e],.le-input-field.theme-light .input.disabled[data-v-8f01462e],.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e],.theme-light .le-input-field .input.disabled[data-v-8f01462e]{border:1px solid #8c8d8f;background-color:#ebecef;color:hsla(0,0%,4%,.5)}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,.theme-light .le-input-field .input.disabled[data-v-8f01462e]::-webkit-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-moz-placeholder,.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-moz-placeholder,.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e]::-moz-placeholder,.theme-light .le-input-field .input.disabled[data-v-8f01462e]::-moz-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e]::-ms-input-placeholder,.theme-light .le-input-field .input.disabled[data-v-8f01462e]::-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::placeholder,.le-input-field.theme-light .input.disabled[data-v-8f01462e]::placeholder,.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e]::placeholder,.theme-light .le-input-field .input.disabled[data-v-8f01462e]::placeholder{color:hsla(222,6%,46%,.5)}.le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.le-input-field.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.theme-light .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder,.theme-light .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox-input-container.theme-light .input[data-v-8f01462e]::-ms-clear,.le-input-field.theme-light .input[data-v-8f01462e]::-ms-clear,.theme-light .le-combobox-input-container .input[data-v-8f01462e]::-ms-clear,.theme-light .le-input-field .input[data-v-8f01462e]::-ms-clear{display:none;width:0;height:0}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-input-field/le-input-field.vue"],"names":[],"mappings":"AAIA,+EAEE,iBAAmB,CACpB,AACD,kNAII,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,aAAc,AACd,MAAO,AACP,SAAU,AACV,WAAa,CAChB,AACD,ggBAWM,aAAe,CACpB,AACD,wgBAWM,UAAe,CACpB,AACD,8MAII,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,SAAU,AACV,WAAa,CAChB,AACD,wfAWM,aAAe,CACpB,AACD,ggBAWM,UAAe,CACpB,AACD,wOAKI,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,yBAA0B,AAC1B,oCAAyC,AACzC,UAAe,CAClB,AACD,gQAKM,oBAAsB,CAC3B,AACD,gQAKM,oBAAsB,CAC3B,AACD,gSAKM,iBAAmB,CACxB,AACD,oSAKM,kBAAoB,CACzB,AACD,gRAKM,oBAAsB,CAC3B,AACD,oVAKM,kBAAmB,AACnB,UAAe,CACpB,AACD,gTAKM,kBAAmB,AACnB,UAAe,CACpB,AACD,oUAKM,kBAAmB,AACnB,UAAe,CACpB,AACD,4RAKM,kBAAmB,AACnB,UAAe,CACpB,AAUD,gUAMM,kBAAmB,AACnB,UAAe,CACpB,AACD,4QAKM,6BAA8B,AAC9B,yBAA0B,AAC1B,wBAAgC,CACrC,AACD,wXAKQ,wBAAgC,CACvC,AACD,oVAKQ,wBAAgC,CACvC,AACD,wWAKQ,wBAAgC,CACvC,AACD,gUAKQ,wBAAgC,CACvC,AASD,oWAMQ,wBAAgC,CACvC,AACD,oRAMM,aAAc,AACd,QAAS,AACT,QAAU,CACf,AACD,4OAKI,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,yBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CAClB,AACD,oQAKM,oBAAsB,CAC3B,AACD,oQAKM,iBAAsB,CAC3B,AACD,oSAKM,iBAAmB,CACxB,AACD,wSAKM,kBAAoB,CACzB,AACD,oRAKM,oBAAsB,CAC3B,AACD,wVAKM,kBAAmB,AACnB,aAAe,CACpB,AACD,oTAKM,kBAAmB,AACnB,aAAe,CACpB,AACD,wUAKM,kBAAmB,AACnB,aAAe,CACpB,AACD,gSAKM,kBAAmB,AACnB,aAAe,CACpB,AAUD,oUAMM,kBAAmB,AACnB,aAAe,CACpB,AACD,gRAKM,yBAA0B,AAC1B,yBAA0B,AAC1B,sBAA6B,CAClC,AACD,4XAKQ,yBAAgC,CACvC,AACD,wVAKQ,yBAAgC,CACvC,AACD,4WAKQ,yBAAgC,CACvC,AACD,oUAKQ,yBAAgC,CACvC,AASD,wWAMQ,yBAAgC,CACvC,AACD,wRAMM,aAAc,AACd,QAAS,AACT,QAAU,CACf","file":"le-input-field.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-input-field[data-v-8f01462e],\n.le-combobox-input-container[data-v-8f01462e] {\n  position: relative;\n}\n.le-input-field .right-icon[data-v-8f01462e],\n  .le-input-field .reset-button[data-v-8f01462e],\n  .le-combobox-input-container .right-icon[data-v-8f01462e],\n  .le-combobox-input-container .reset-button[data-v-8f01462e] {\n    cursor: pointer;\n    position: absolute;\n    right: 0;\n    padding: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n}\n.le-input-field .right-icon.theme-dark[data-v-8f01462e],\n    .theme-dark .le-input-field .right-icon[data-v-8f01462e],\n    .le-input-field .reset-button.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-input-field .reset-button[data-v-8f01462e],\n    .le-combobox-input-container .right-icon.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .right-icon[data-v-8f01462e],\n    .le-combobox-input-container .reset-button.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .reset-button[data-v-8f01462e] {\n      color: #a9afba;\n}\n.le-input-field .right-icon.theme-light[data-v-8f01462e],\n    .theme-light .le-input-field .right-icon[data-v-8f01462e],\n    .le-input-field .reset-button.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-input-field .reset-button[data-v-8f01462e],\n    .le-combobox-input-container .right-icon.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .right-icon[data-v-8f01462e],\n    .le-combobox-input-container .reset-button.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .reset-button[data-v-8f01462e] {\n      color: #888888;\n}\n.le-input-field .left-icon[data-v-8f01462e],\n  .le-input-field .search-icon[data-v-8f01462e],\n  .le-combobox-input-container .left-icon[data-v-8f01462e],\n  .le-combobox-input-container .search-icon[data-v-8f01462e] {\n    position: absolute;\n    left: 9px;\n    top: 1px;\n    bottom: 0;\n    margin: auto;\n}\n.le-input-field .left-icon.theme-dark[data-v-8f01462e],\n    .theme-dark .le-input-field .left-icon[data-v-8f01462e],\n    .le-input-field .search-icon.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-input-field .search-icon[data-v-8f01462e],\n    .le-combobox-input-container .left-icon.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .left-icon[data-v-8f01462e],\n    .le-combobox-input-container .search-icon.theme-dark[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .search-icon[data-v-8f01462e] {\n      color: #a9afba;\n}\n.le-input-field .left-icon.theme-light[data-v-8f01462e],\n    .theme-light .le-input-field .left-icon[data-v-8f01462e],\n    .le-input-field .search-icon.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-input-field .search-icon[data-v-8f01462e],\n    .le-combobox-input-container .left-icon.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .left-icon[data-v-8f01462e],\n    .le-combobox-input-container .search-icon.theme-light[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .search-icon[data-v-8f01462e] {\n      color: #888888;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e],\n  .theme-dark .le-input-field .input[data-v-8f01462e],\n  .le-combobox-input-container.theme-dark .input[data-v-8f01462e],\n  .theme-dark\n  .le-combobox-input-container .input[data-v-8f01462e] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    outline: none;\n    height: 32px;\n    padding: 0 9px;\n    width: 100%;\n    line-height: 32px;\n    font-size: 12px;\n    font-family: Roboto;\n    border-radius: 2px;\n    border: 1px solid #474a6a;\n    background-color: rgba(71, 74, 106, 0.5);\n    color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]:hover,\n    .theme-dark .le-input-field .input[data-v-8f01462e]:hover,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]:hover,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]:hover {\n      border-color: #2d3162;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]:focus,\n    .theme-dark .le-input-field .input[data-v-8f01462e]:focus,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]:focus,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]:focus {\n      border-color: #5879da;\n}\n.le-input-field.theme-dark .input.has-left-icon[data-v-8f01462e],\n    .theme-dark .le-input-field .input.has-left-icon[data-v-8f01462e],\n    .le-combobox-input-container.theme-dark .input.has-left-icon[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .input.has-left-icon[data-v-8f01462e] {\n      padding-left: 25px;\n}\n.le-input-field.theme-dark .input.has-right-icon[data-v-8f01462e],\n    .theme-dark .le-input-field .input.has-right-icon[data-v-8f01462e],\n    .le-combobox-input-container.theme-dark .input.has-right-icon[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .input.has-right-icon[data-v-8f01462e] {\n      padding-right: 25px;\n}\n.le-input-field.theme-dark .input.has-error[data-v-8f01462e],\n    .theme-dark .le-input-field .input.has-error[data-v-8f01462e],\n    .le-combobox-input-container.theme-dark .input.has-error[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .input.has-error[data-v-8f01462e] {\n      border-color: #ff1820;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]::-webkit-input-placeholder {\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]::-moz-placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]::-moz-placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-moz-placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]::-moz-placeholder {\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]::-ms-input-placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]::-ms-input-placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-ms-input-placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]::-ms-input-placeholder {\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]::placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]::placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]::placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]::placeholder {\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-dark .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder {\n      /* Microsoft Edge */\n      font-style: italic;\n      color: #ffffff;\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e],\n    .theme-dark .le-input-field .input.disabled[data-v-8f01462e],\n    .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e],\n    .theme-dark\n    .le-combobox-input-container .input.disabled[data-v-8f01462e] {\n      border: 1px solid transparent;\n      background-color: #474a6a;\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-webkit-input-placeholder {\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-moz-placeholder {\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-ms-input-placeholder {\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]::placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]::placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]::placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::placeholder {\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder {\n        /* Internet Explorer 10-11 */\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-dark .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .le-combobox-input-container.theme-dark .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-dark\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder {\n        /* Microsoft Edge */\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-input-field.theme-dark .input[data-v-8f01462e]::-ms-clear,\n    .theme-dark .le-input-field .input[data-v-8f01462e]::-ms-clear,\n    .le-combobox-input-container.theme-dark .input[data-v-8f01462e]::-ms-clear,\n    .theme-dark\n    .le-combobox-input-container .input[data-v-8f01462e]::-ms-clear {\n      /* Internet Explorer 10-11 */\n      display: none;\n      width: 0;\n      height: 0;\n}\n.le-input-field.theme-light .input[data-v-8f01462e],\n  .theme-light .le-input-field .input[data-v-8f01462e],\n  .le-combobox-input-container.theme-light .input[data-v-8f01462e],\n  .theme-light\n  .le-combobox-input-container .input[data-v-8f01462e] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    outline: none;\n    height: 32px;\n    padding: 0 9px;\n    width: 100%;\n    line-height: 32px;\n    font-size: 12px;\n    font-family: Roboto;\n    border-radius: 2px;\n    border: 1px solid #8C8D8F;\n    background-color: #fcfcfd;\n    color: #0A0A0A;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]:hover,\n    .theme-light .le-input-field .input[data-v-8f01462e]:hover,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]:hover,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]:hover {\n      border-color: #8C8D8F;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]:focus,\n    .theme-light .le-input-field .input[data-v-8f01462e]:focus,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]:focus,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]:focus {\n      border-color: #666666;\n}\n.le-input-field.theme-light .input.has-left-icon[data-v-8f01462e],\n    .theme-light .le-input-field .input.has-left-icon[data-v-8f01462e],\n    .le-combobox-input-container.theme-light .input.has-left-icon[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .input.has-left-icon[data-v-8f01462e] {\n      padding-left: 25px;\n}\n.le-input-field.theme-light .input.has-right-icon[data-v-8f01462e],\n    .theme-light .le-input-field .input.has-right-icon[data-v-8f01462e],\n    .le-combobox-input-container.theme-light .input.has-right-icon[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .input.has-right-icon[data-v-8f01462e] {\n      padding-right: 25px;\n}\n.le-input-field.theme-light .input.has-error[data-v-8f01462e],\n    .theme-light .le-input-field .input.has-error[data-v-8f01462e],\n    .le-combobox-input-container.theme-light .input.has-error[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .input.has-error[data-v-8f01462e] {\n      border-color: #d0021b;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]::-webkit-input-placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]::-webkit-input-placeholder {\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]::-moz-placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]::-moz-placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]::-moz-placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]::-moz-placeholder {\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]::-ms-input-placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]::-ms-input-placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]::-ms-input-placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]::-ms-input-placeholder {\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]::placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]::placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]::placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]::placeholder {\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-light .le-input-field .input[data-v-8f01462e]:-ms-input-placeholder,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]:-ms-input-placeholder,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]:-ms-input-placeholder {\n      /* Microsoft Edge */\n      font-style: italic;\n      color: #6F737C;\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e],\n    .theme-light .le-input-field .input.disabled[data-v-8f01462e],\n    .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e],\n    .theme-light\n    .le-combobox-input-container .input.disabled[data-v-8f01462e] {\n      border: 1px solid #8C8D8F;\n      background-color: #ebecef;\n      color: rgba(10, 10, 10, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-webkit-input-placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-webkit-input-placeholder {\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-moz-placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-moz-placeholder {\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::-ms-input-placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::-ms-input-placeholder {\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]::placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]::placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]::placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]::placeholder {\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder {\n        /* Internet Explorer 10-11 */\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-light .le-input-field .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .le-combobox-input-container.theme-light .input.disabled[data-v-8f01462e]:-ms-input-placeholder,\n      .theme-light\n      .le-combobox-input-container .input.disabled[data-v-8f01462e]:-ms-input-placeholder {\n        /* Microsoft Edge */\n        color: rgba(111, 115, 124, 0.5);\n}\n.le-input-field.theme-light .input[data-v-8f01462e]::-ms-clear,\n    .theme-light .le-input-field .input[data-v-8f01462e]::-ms-clear,\n    .le-combobox-input-container.theme-light .input[data-v-8f01462e]::-ms-clear,\n    .theme-light\n    .le-combobox-input-container .input[data-v-8f01462e]::-ms-clear {\n      /* Internet Explorer 10-11 */\n      display: none;\n      width: 0;\n      height: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.inputTooltip),expression:"inputTooltip"}],staticClass:"le-input-field"},[_c('le-bubble',{attrs:{"theme":"dark","trigger":"manual","open":_vm.showError,"placement":_vm.errorPlacement,"hideOnTargetClick":true,"data-test":"input_bubble"}},[_c('template',{slot:"target"},[_c('input',{ref:"inputField",class:[
          'input',
          {
            'has-error': _vm.hasError,
            'disabled': !_vm.enabled,
            'has-left-icon': _vm.shouldShowSearchIcon,
            'has-right-icon': _vm.shouldShowResetButton
          }
        ],style:([_vm.inputStyle, _vm.inputPaddingStyle, _vm.borderRadiusStyle]),attrs:{"type":_vm.getInputType,"placeholder":_vm.placeholder,"disabled":!_vm.enabled,"maxlength":_vm.maxChars,"id":_vm.id,"aria-describedby":_vm.ariaDescBy,"aria-labelledby":_vm.ariaLabelledBy,"aria-label":_vm.ariaLabel,"data-test":"input_value"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onSubmit($event)}}})]),_vm._v(" "),_c('template',{slot:"content"},[_c('span',{attrs:{"data-test":"input_error_toolTip_text"}},[_vm._v(_vm._s(_vm.bubbleErrorMsg))])])],2),_vm._v(" "),(_vm.shouldShowSearchIcon)?_c('i',{staticClass:"ico-12 ico-search search-icon",attrs:{"data-test":"input_search"}}):_vm._e(),_vm._v(" "),(_vm.shouldShowResetButton)?_c('i',{staticClass:"ico-8 ico-input-field-reset reset-button",attrs:{"role":"button","aria-label":_vm.ariaLabelSearchClear,"tabindex":"0","data-test":"input_reset"},on:{"click":_vm.onResetClick}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_dropdown_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b854092_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_dropdown_vue__ = __webpack_require__(522);
function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b854092_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(521);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("75445416", content, true, {});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-select-dropdown{border-radius:2px;cursor:pointer;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;height:32px}.le-select-dropdown.theme-dark,.theme-dark .le-select-dropdown{border:1px solid #474a6a;background-color:rgba(71,74,106,.5)}.le-select-dropdown.theme-light,.theme-light .le-select-dropdown{border:1px solid #8c8d8f;background-color:#fcfcfd}.le-select-dropdown.active.theme-dark,.theme-dark .le-select-dropdown.active{border-color:#5879da}.le-select-dropdown.active.theme-light,.theme-light .le-select-dropdown.active{border-color:#4661ae}.le-select-dropdown.icon-mode{text-align:center;border:none;padding:0;background:none}.le-select-dropdown.icon-mode.theme-dark,.theme-dark .le-select-dropdown.icon-mode{color:#fff}.le-select-dropdown.icon-mode.theme-light,.theme-light .le-select-dropdown.icon-mode{color:#161c4f}.le-select-dropdown.icon-mode .ico-arrow{padding-left:5px;right:auto}.le-select-dropdown.icon-mode .ico-arrow.theme-dark,.theme-dark .le-select-dropdown.icon-mode .ico-arrow{color:#fff}.le-select-dropdown.icon-mode .ico-arrow.theme-light,.theme-light .le-select-dropdown.icon-mode .ico-arrow{color:#161c4f}.le-select-dropdown.icon-text-item .label{padding-left:5px;max-width:calc(100% - 61px)}.le-select-dropdown.icon-text-item .icon-item{margin-left:10px;display:inline-block;vertical-align:top}.le-select-dropdown.has-error.theme-dark,.theme-dark .le-select-dropdown.has-error{border-color:#ff1820}.le-select-dropdown.has-error.theme-light,.theme-light .le-select-dropdown.has-error{border-color:#d0021b}.le-select-dropdown .placeholder{padding-left:9px;font-size:12px;line-height:32px;max-width:calc(100% - 30px);vertical-align:middle;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.le-select-dropdown .placeholder.theme-dark,.theme-dark .le-select-dropdown .placeholder{color:hsla(0,0%,100%,.7)}.le-select-dropdown .placeholder.theme-light,.theme-light .le-select-dropdown .placeholder{color:#6f737c}.le-select-dropdown .label{padding-left:9px;font-size:12px;line-height:32px;max-width:calc(100% - 30px);vertical-align:middle;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.le-select-dropdown .label.theme-dark,.theme-dark .le-select-dropdown .label{color:#fff}.le-select-dropdown .label.theme-light,.theme-light .le-select-dropdown .label{color:#0a0a0a}.le-select-dropdown .icon-item{line-height:32px}.le-select-dropdown .ico-arrow{position:absolute;right:10px;top:2px;vertical-align:middle;padding-top:1px;line-height:32px}.le-select-dropdown .ico-arrow.theme-dark,.theme-dark .le-select-dropdown .ico-arrow{color:#bbc0c9}.le-select-dropdown .ico-arrow.theme-light,.theme-light .le-select-dropdown .ico-arrow{color:#888}.le-select-dropdown.disabled{cursor:default}.le-select-dropdown.disabled.theme-dark,.theme-dark .le-select-dropdown.disabled{border-color:#474a6a;background-color:#474a6a}.le-select-dropdown.disabled.theme-light,.theme-light .le-select-dropdown.disabled{border-color:#888;background-color:#ebecef}.le-select-dropdown.disabled .label.theme-dark,.theme-dark .le-select-dropdown.disabled .label{color:hsla(0,0%,100%,.6)}.le-select-dropdown.disabled .label.theme-light,.theme-light .le-select-dropdown.disabled .label{color:hsla(0,0%,4%,.5)}.le-select-dropdown.disabled .ico-arrow.theme-dark,.theme-dark .le-select-dropdown.disabled .ico-arrow{color:hsla(0,0%,100%,.6)}.le-select-dropdown.disabled .ico-arrow.theme-light,.theme-light .le-select-dropdown.disabled .ico-arrow{color:#888}.le-select-dropdown.disabled .icon-item{opacity:.3}.le-select-dropdown.disabled .placeholder.theme-dark,.theme-dark .le-select-dropdown.disabled .placeholder{color:hsla(0,0%,100%,.6)}.le-select-dropdown.disabled .placeholder.theme-light,.theme-light .le-select-dropdown.disabled .placeholder{color:hsla(222,6%,46%,.5)}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-select/le-select-dropdown.vue"],"names":[],"mappings":"AAIA,oBACE,kBAAmB,AACnB,eAAgB,AAChB,aAAc,AACd,WAAY,AACZ,8BAA+B,AACvB,sBAAuB,AAC/B,WAAa,CACd,AACD,+DAEI,yBAA0B,AAC1B,mCAAyC,CAC5C,AACD,iEAEI,yBAA0B,AAC1B,wBAA0B,CAC7B,AACD,6EAEI,oBAAsB,CACzB,AACD,+EAEI,oBAAsB,CACzB,AACD,8BACI,kBAAmB,AACnB,YAAa,AACb,UAAa,AACb,eAAiB,CACpB,AACD,mFAEM,UAAe,CACpB,AACD,qFAEM,aAAe,CACpB,AACD,yCACM,iBAAkB,AAClB,UAAY,CACjB,AACD,yGAEQ,UAAe,CACtB,AACD,2GAEQ,aAAe,CACtB,AACD,0CACI,iBAAkB,AAClB,2BAA6B,CAChC,AACD,8CACI,iBAAkB,AAClB,qBAAsB,AACtB,kBAAoB,CACvB,AACD,mFAEI,oBAAsB,CACzB,AACD,qFAEI,oBAAsB,CACzB,AACD,iCACI,iBAAkB,AAClB,eAAgB,AAChB,iBAAkB,AAClB,4BAA6B,AAC7B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,yFAEM,wBAAgC,CACrC,AACD,2FAEM,aAAe,CACpB,AACD,2BACI,iBAAkB,AAClB,eAAgB,AAChB,iBAAkB,AAClB,4BAA6B,AAC7B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,6EAEM,UAAe,CACpB,AACD,+EAEM,aAAe,CACpB,AACD,+BACI,gBAAkB,CACrB,AACD,+BACI,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,sBAAuB,AACvB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,qFAEM,aAAe,CACpB,AACD,uFAEM,UAAe,CACpB,AACD,6BACI,cAAgB,CACnB,AACD,iFAEM,qBAAsB,AACtB,wBAA0B,CAC/B,AACD,mFAEM,kBAAsB,AACtB,wBAA0B,CAC/B,AACD,+FAEM,wBAAgC,CACrC,AACD,iGAEM,sBAA6B,CAClC,AACD,uGAEM,wBAAgC,CACrC,AACD,yGAEM,UAAe,CACpB,AACD,wCACM,UAAY,CACjB,AACD,2GAEM,wBAAgC,CACrC,AACD,6GAEM,yBAAgC,CACrC","file":"le-select-dropdown.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-select-dropdown {\n  border-radius: 2px;\n  cursor: pointer;\n  outline: none;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 32px;\n}\n.le-select-dropdown.theme-dark,\n  .theme-dark .le-select-dropdown {\n    border: 1px solid #474a6a;\n    background-color: rgba(71, 74, 106, 0.5);\n}\n.le-select-dropdown.theme-light,\n  .theme-light .le-select-dropdown {\n    border: 1px solid #8C8D8F;\n    background-color: #fcfcfd;\n}\n.le-select-dropdown.active.theme-dark,\n  .theme-dark .le-select-dropdown.active {\n    border-color: #5879da;\n}\n.le-select-dropdown.active.theme-light,\n  .theme-light .le-select-dropdown.active {\n    border-color: #4661ae;\n}\n.le-select-dropdown.icon-mode {\n    text-align: center;\n    border: none;\n    padding: 0px;\n    background: none;\n}\n.le-select-dropdown.icon-mode.theme-dark,\n    .theme-dark .le-select-dropdown.icon-mode {\n      color: #ffffff;\n}\n.le-select-dropdown.icon-mode.theme-light,\n    .theme-light .le-select-dropdown.icon-mode {\n      color: #161c4f;\n}\n.le-select-dropdown.icon-mode .ico-arrow {\n      padding-left: 5px;\n      right: auto;\n}\n.le-select-dropdown.icon-mode .ico-arrow.theme-dark,\n      .theme-dark .le-select-dropdown.icon-mode .ico-arrow {\n        color: #ffffff;\n}\n.le-select-dropdown.icon-mode .ico-arrow.theme-light,\n      .theme-light .le-select-dropdown.icon-mode .ico-arrow {\n        color: #161c4f;\n}\n.le-select-dropdown.icon-text-item .label {\n    padding-left: 5px;\n    max-width: calc(100% - 61px);\n}\n.le-select-dropdown.icon-text-item .icon-item {\n    margin-left: 10px;\n    display: inline-block;\n    vertical-align: top;\n}\n.le-select-dropdown.has-error.theme-dark,\n  .theme-dark .le-select-dropdown.has-error {\n    border-color: #ff1820;\n}\n.le-select-dropdown.has-error.theme-light,\n  .theme-light .le-select-dropdown.has-error {\n    border-color: #d0021b;\n}\n.le-select-dropdown .placeholder {\n    padding-left: 9px;\n    font-size: 12px;\n    line-height: 32px;\n    max-width: calc(100% - 30px);\n    vertical-align: middle;\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.le-select-dropdown .placeholder.theme-dark,\n    .theme-dark .le-select-dropdown .placeholder {\n      color: rgba(255, 255, 255, 0.7);\n}\n.le-select-dropdown .placeholder.theme-light,\n    .theme-light .le-select-dropdown .placeholder {\n      color: #6F737C;\n}\n.le-select-dropdown .label {\n    padding-left: 9px;\n    font-size: 12px;\n    line-height: 32px;\n    max-width: calc(100% - 30px);\n    vertical-align: middle;\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.le-select-dropdown .label.theme-dark,\n    .theme-dark .le-select-dropdown .label {\n      color: #ffffff;\n}\n.le-select-dropdown .label.theme-light,\n    .theme-light .le-select-dropdown .label {\n      color: #0A0A0A;\n}\n.le-select-dropdown .icon-item {\n    line-height: 32px;\n}\n.le-select-dropdown .ico-arrow {\n    position: absolute;\n    right: 10px;\n    top: 2px;\n    vertical-align: middle;\n    padding-top: 1px;\n    line-height: 32px;\n}\n.le-select-dropdown .ico-arrow.theme-dark,\n    .theme-dark .le-select-dropdown .ico-arrow {\n      color: #bbc0c9;\n}\n.le-select-dropdown .ico-arrow.theme-light,\n    .theme-light .le-select-dropdown .ico-arrow {\n      color: #888888;\n}\n.le-select-dropdown.disabled {\n    cursor: default;\n}\n.le-select-dropdown.disabled.theme-dark,\n    .theme-dark .le-select-dropdown.disabled {\n      border-color: #474a6a;\n      background-color: #474a6a;\n}\n.le-select-dropdown.disabled.theme-light,\n    .theme-light .le-select-dropdown.disabled {\n      border-color: #888888;\n      background-color: #ebecef;\n}\n.le-select-dropdown.disabled .label.theme-dark,\n    .theme-dark .le-select-dropdown.disabled .label {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-select-dropdown.disabled .label.theme-light,\n    .theme-light .le-select-dropdown.disabled .label {\n      color: rgba(10, 10, 10, 0.5);\n}\n.le-select-dropdown.disabled .ico-arrow.theme-dark,\n    .theme-dark .le-select-dropdown.disabled .ico-arrow {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-select-dropdown.disabled .ico-arrow.theme-light,\n    .theme-light .le-select-dropdown.disabled .ico-arrow {\n      color: #888888;\n}\n.le-select-dropdown.disabled .icon-item {\n      opacity: .3;\n}\n.le-select-dropdown.disabled .placeholder.theme-dark,\n    .theme-dark .le-select-dropdown.disabled .placeholder {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-select-dropdown.disabled .placeholder.theme-light,\n    .theme-light .le-select-dropdown.disabled .placeholder {\n      color: rgba(111, 115, 124, 0.5);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('le-bubble',{attrs:{"theme":"dark","trigger":"manual","open":_vm.showError,"placement":_vm.errorPlacement,"hideOnTargetClick":true,"container":_vm.container}},[_c('template',{slot:"target"},[_c('div',{class:['le-select-dropdown', { 'icon-mode': _vm.useIcons }, {'icon-text-item': _vm.useIconsAndText}, { 'active': _vm.isListOpen }, { 'disabled': !_vm.enabled }, { 'has-error': _vm.hasError }],style:([_vm.borderRadiusStyle]),attrs:{"data-test":"dropdown_container"},on:{"click":_vm.onDropdownClick,"focus":function($event){$event.preventDefault();return _vm.onDropdownFocus($event)}}},[(_vm.shouldShowPlaceholder)?_c('div',{staticClass:"placeholder",attrs:{"data-test":"dropdown_placeholder"}},[_vm._v(_vm._s(_vm.placeholder))]):_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.selectedItemTooltip),expression:"selectedItemTooltip"}],staticClass:"content",attrs:{"data-test":"dropdown_content"}},[(_vm.useIcons || _vm.useIconsAndText)?_c('i',{staticClass:"icon-item",class:_vm.iconClass,attrs:{"data-test":"dropdown_icon"}}):_vm._e(),_vm._v(" "),(_vm.useIconsAndText || !_vm.useIcons)?_c('span',{ref:"label",staticClass:"label",attrs:{"data-test":"dropdown_txt"}},[_vm._v(_vm._s(_vm.selectedItemValue))]):_vm._e()]),_vm._v(" "),_c('i',{class:['ico-9', 'ico-arrow', _vm.arrowDirectionClass],attrs:{"data-test":"dropdown_direction_icon"}})])]),_vm._v(" "),_c('span',{attrs:{"slot":"content","data-test":"dropdown_bubble_err_txt"},slot:"content"},[_vm._v("\n    "+_vm._s(_vm.bubbleErrorMsg)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_menu_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3341d92a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_menu_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_select_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3341d92a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_select_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(525);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26afeb94", content, true, {});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-select-menu{width:18px}.le-select-menu .ico-three-dots{height:7px;width:18px}.le-select-menu .ico{cursor:pointer}.le-select-menu .ico.theme-dark,.theme-dark .le-select-menu .ico{color:#fff}.le-select-menu .ico.theme-light,.theme-light .le-select-menu .ico{color:#161c4f}.le-select-menu.disabled .ico{cursor:default}.le-select-menu.disabled .ico.theme-dark,.le-select-menu.disabled .ico.theme-light,.theme-dark .le-select-menu.disabled .ico,.theme-light .le-select-menu.disabled .ico{color:#ddd}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-select/le-select-menu.vue"],"names":[],"mappings":"AAIA,gBACE,UAAY,CACb,AACD,gCACI,WAAY,AACZ,UAAY,CACf,AACD,qBACI,cAAgB,CACnB,AACD,iEAEM,UAAe,CACpB,AACD,mEAEM,aAAe,CACpB,AACD,8BACI,cAAgB,CACnB,AAKD,wKAEM,UAAe,CACpB","file":"le-select-menu.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-select-menu {\n  width: 18px;\n}\n.le-select-menu .ico-three-dots {\n    height: 7px;\n    width: 18px;\n}\n.le-select-menu .ico {\n    cursor: pointer;\n}\n.le-select-menu .ico.theme-dark,\n    .theme-dark .le-select-menu .ico {\n      color: #ffffff;\n}\n.le-select-menu .ico.theme-light,\n    .theme-light .le-select-menu .ico {\n      color: #161c4f;\n}\n.le-select-menu.disabled .ico {\n    cursor: default;\n}\n.le-select-menu.disabled .ico.theme-dark,\n    .theme-dark .le-select-menu.disabled .ico {\n      color: #dddddd;\n}\n.le-select-menu.disabled .ico.theme-light,\n    .theme-light .le-select-menu.disabled .ico {\n      color: #dddddd;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button",staticClass:"le-select-menu",class:{'disabled': !_vm.enabled},on:{"click":_vm.onActionMenuClick}},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.menuIconTooltip, html: false, autoHide: true }),expression:"{ content: menuIconTooltip, html: false, autoHide: true }"}],staticClass:"ico",class:_vm.iconClass})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],ref:"dropdownWrapper",class:['le-select', ("le-select-type-" + _vm.type), { 'is-open': _vm.isListOpen }, { 'open-list' : this.listAlwaysOpen }, _vm.theme],attrs:{"id":_vm.id,"aria-labelledby":_vm.ariaLabelledBy,"aria-label":_vm.ariaLabel,"aria-expanded":_vm.isExpanded,"aria-controls":_vm.getAriaControlsSelectListId,"aria-owns":_vm.getAriaOwnsSelectListId,"role":_vm.role,"aria-haspopup":"listbox","aria-disabled":!_vm.enabled,"tabindex":_vm.mainTabIndex,"data-test":"select_container"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.onKeydownEnter($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onKeydownDown($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onKeydownUp($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onKeydownEsc($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if(!$event.shiftKey){ return null; }return _vm.onClickOutside($event)}]}},[_c('div',{staticClass:"a11y_live_region",attrs:{"aria-live":"polite","data-test":"select_arrow_key_txt"}},[_vm._v(_vm._s(_vm.arrowKeyText))]),_vm._v(" "),(_vm.isMultiSelect)?_c('le-tags',{ref:"tagsInput",attrs:{"tabindex":"-1","tabbable":_vm.isListOpen,"tags":_vm.selectedItems,"placeholder":_vm.placeholder,"searchTerm":_vm.searchTerm,"tagIdAttr":_vm.itemIdAttr,"tagValueAttr":_vm.itemValueAttr,"errorPlacement":_vm.errorPlacement,"enabled":_vm.enabled,"controlId":_vm.getAriaOwnsSelectListId,"closeLabel":_vm.closeLabel,"aria-labelledby":_vm.ariaLabelledBy,"aria-label":_vm.ariaLabel,"data-test":"select_tags","isWarningIconEnable":_vm.isWarningIconEnable,"warningIconTooltipText":_vm.warningIconTooltipText},on:{"focus":_vm.onListClick,"input":_vm.onSearchInputChange,"unselect":_vm.onUnselectItem,"tabout":_vm.onClickOutside}}):_vm._e(),_vm._v(" "),(_vm.isSingleSelect)?_c('le-input-field',{ref:"singleSelectInput",staticClass:"input-field",attrs:{"tabindex":"-1","aria-labelledby":_vm.ariaLabelledBy,"aria-label":_vm.ariaLabel,"errorPlacement":_vm.errorPlacement,"placeholder":_vm.placeholder,"value":_vm.searchTerm,"enabled":_vm.enabled,"data-test":"select_input"},on:{"focus":_vm.onListClick,"input":_vm.onSearchInputChange}}):_vm._e(),_vm._v(" "),(_vm.listAlwaysOpen)?_c('div',{staticClass:"space"}):_vm._e(),_vm._v(" "),(_vm.isDropdown)?_c('le-select-dropdown',{ref:"dropdownInput",attrs:{"tabindex":"-1","selectedItem":_vm.selectedItems[0],"itemIconClass":_vm.selectedItems[0] && _vm.selectedItems[0].class,"itemValueAttr":_vm.itemValueAttr,"isListOpen":_vm.isListOpen,"useIcons":_vm.useIcons,"useIconsAndText":_vm.useIconsAndText,"enabled":_vm.enabled,"errorPlacement":_vm.errorPlacement,"container":_vm.container,"placeholder":_vm.placeholder,"tooltipPlacement":_vm.tooltipPlacement,"borderRadius":_vm.borderRadius,"data-test":"select_dropdown"},on:{"toggle":_vm.onDropdownToggle}}):_vm._e(),_vm._v(" "),(_vm.isActionMenu)?_c('le-select-menu',{attrs:{"isListOpen":_vm.isListOpen,"enabled":_vm.enabled,"menuIcon":_vm.menuIcon,"menuIconTooltip":_vm.menuIconTooltip,"data-test":"select_menu"},on:{"toggle":_vm.onActionMenuToggle}}):_vm._e(),_vm._v(" "),_c('le-select-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isListOpen && _vm.enabled),expression:"isListOpen && enabled"}],ref:"itemsList",class:['select-list', _vm.theme],attrs:{"id":_vm.getSelectListId,"aria-label":_vm.hasAriaLabelForSelectList ? _vm.ariaLabelForSelectList : _vm.ariaLabel,"aria-multiselectable":_vm.isMultiSelect,"items":_vm.filteredItems,"itemIdAttr":_vm.itemIdAttr,"itemValueAttr":_vm.itemValueAttr,"itemTooltipAttr":_vm.itemTooltipAttr,"itemSubtextAttr":_vm.itemSubtextAttr,"groupSelection":_vm.groupSelectEnable,"hasShortcuts":_vm.listWithShortcuts,"isMultiSelect":_vm.isMultiSelect,"selectedItemsIds":_vm.selectedItemsIds,"listMaxHeight":_vm.heightLimit,"itemMinHeight":_vm.itemMinHeight,"pointedItemIndex":_vm.pointedItemIndex,"floatedList":_vm.floatedList,"openListOnTop":_vm.shouldOpenListOnTop,"hasIconsOnly":_vm.useIcons,"hasIconsAndText":_vm.useIconsAndText,"hasAction":_vm.listWithAction,"actionIconClass":_vm.actionIconClass,"bubbleList":_vm.bubbleList,"bubbleListAlign":_vm.bubbleListAlign,"addItemsSeparator":_vm.addItemsSeparator,"minWidth":_vm.listMinWidth,"isOpenList":_vm.listAlwaysOpen,"searchTerm":_vm.searchTerm,"data-test":"select_list"},on:{"scroll":_vm.onListScroll,"itemClicked":_vm.onListItemClicked,"groupClicked":_vm.onListGroupClicked,"itemHover":_vm.onListItemHover,"groupHover":_vm.onListGroupHover,"tabout":_vm.onClickOutside,"onItemCreateClick":_vm.createNewItem,"itemActionClicked":_vm.onItemActionClicked}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_slider_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571937fd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_slider_vue__ = __webpack_require__(531);
function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-571937fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_571937fd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("521ab33b", content, true, {});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-slider__selected-input[data-v-571937fd]{font-size:12px;position:relative;margin-top:-1em;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.le-slider__selected-input.theme-dark[data-v-571937fd],.theme-dark .le-slider__selected-input[data-v-571937fd]{color:#323436}.le-slider__selected-input.theme-light[data-v-571937fd],.theme-light .le-slider__selected-input[data-v-571937fd]{color:#888}.le-slider input[data-v-571937fd]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:20px;overflow:hidden;width:100%}.le-slider input[data-v-571937fd]:focus{-webkit-box-shadow:none;box-shadow:none;outline:none}.le-slider input[data-v-571937fd]::-webkit-slider-runnable-track{background:var(--linear-background);content:\"\";height:2px;pointer-events:none}.le-slider input[data-v-571937fd]::-webkit-slider-thumb{height:11px;width:11px;-webkit-appearance:none;appearance:none;background:#fff;border-radius:6px;margin-top:-6.5px;border:0 solid #fff;-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.14);box-shadow:0 1px 4px 0 rgba(0,0,0,.14)}.le-slider input[data-v-571937fd]::-moz-range-track{background:var(--linear-background);height:2px}.le-slider input[data-v-571937fd]::-moz-range-thumb{height:11px;width:11px;background:#fff;border-radius:6px;border:0 solid #fff;position:relative;box-shadow:0 1px 4px 0 rgba(0,0,0,.14)}.le-slider input[data-v-571937fd]::-ms-track{background:#d4d4d4;border-radius:0;border:0 transparent;color:transparent;height:2px;margin-top:10px}.le-slider input[data-v-571937fd]::-ms-fill-lower{background:#5879da}.le-slider input[data-v-571937fd]::-ms-fill-upper{background:#d4d4d4}.le-slider input[data-v-571937fd]::-ms-thumb{height:11px;width:11px;background:#fff;border-radius:6px;border:0 solid #fff;box-shadow:0 1px 4px 0 rgba(0,0,0,.14)}.le-slider input[data-v-571937fd]::-ms-tooltip{display:none}.le-slider__text[data-v-571937fd]{display:inline-block;font-size:12px;text-align:center;width:100%}.le-slider__text.theme-dark[data-v-571937fd],.theme-dark .le-slider__text[data-v-571937fd]{color:#888}.le-slider__text.theme-light[data-v-571937fd],.theme-light .le-slider__text[data-v-571937fd]{color:#b1b1b1}.le-slider__text__minimum[data-v-571937fd]{float:left}.le-slider__text__maximum[data-v-571937fd]{float:right}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-slider/le-slider.vue"],"names":[],"mappings":"AAIA,4CACE,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,+GAEI,aAAe,CAClB,AACD,iHAEI,UAAe,CAClB,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACtB,qBAAsB,AACjB,gBAAiB,AACzB,gBAAiB,AACjB,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,gBAAiB,AACjB,UAAY,CACb,AACD,wCACI,wBAAyB,AACjB,gBAAiB,AACzB,YAAc,CACjB,AACD,iEACI,oCAAqC,AACrC,WAAY,AACZ,WAAY,AACZ,mBAAqB,CACxB,AACD,wDACI,YAAa,AACb,WAAY,AACZ,wBAAyB,AACjB,gBAAiB,AACzB,gBAAoB,AACpB,kBAAmB,AACnB,kBAAmB,AACnB,oBAA0B,AAC1B,+CAAoD,AAC5C,sCAA4C,CACvD,AACD,oDACI,oCAAqC,AACrC,UAAY,CACf,AACD,oDACI,YAAa,AACb,WAAY,AACZ,gBAAoB,AACpB,kBAAmB,AACnB,oBAA0B,AAC1B,kBAAmB,AACnB,sCAA4C,CAC/C,AACD,6CACI,mBAAoB,AACpB,gBAAiB,AACjB,qBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,eAAiB,CACpB,AACD,kDACI,kBAAoB,CACvB,AACD,kDACI,kBAAoB,CACvB,AACD,6CACI,YAAa,AACb,WAAY,AACZ,gBAAoB,AACpB,kBAAmB,AACnB,oBAA0B,AAC1B,sCAA4C,CAC/C,AACD,+CACI,YAAc,CACjB,AACD,kCACE,qBAAsB,AACtB,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACb,AACD,2FAEI,UAAe,CAClB,AACD,6FAEI,aAAe,CAClB,AACD,2CACI,UAAY,CACf,AACD,2CACI,WAAa,CAChB","file":"le-slider.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-slider__selected-input[data-v-571937fd] {\n  font-size: 12px;\n  position: relative;\n  margin-top: -1em;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.le-slider__selected-input.theme-dark[data-v-571937fd],\n  .theme-dark .le-slider__selected-input[data-v-571937fd] {\n    color: #323436;\n}\n.le-slider__selected-input.theme-light[data-v-571937fd],\n  .theme-light .le-slider__selected-input[data-v-571937fd] {\n    color: #888888;\n}\n.le-slider input[data-v-571937fd] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background: none;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 20px;\n  overflow: hidden;\n  width: 100%;\n}\n.le-slider input[data-v-571937fd]:focus {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    outline: none;\n}\n.le-slider input[data-v-571937fd]::-webkit-slider-runnable-track {\n    background: var(--linear-background);\n    content: '';\n    height: 2px;\n    pointer-events: none;\n}\n.le-slider input[data-v-571937fd]::-webkit-slider-thumb {\n    height: 11px;\n    width: 11px;\n    -webkit-appearance: none;\n            appearance: none;\n    background: #ffffff;\n    border-radius: 6px;\n    margin-top: -6.5px;\n    border: 0px solid #ffffff;\n    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n}\n.le-slider input[data-v-571937fd]::-moz-range-track {\n    background: var(--linear-background);\n    height: 2px;\n}\n.le-slider input[data-v-571937fd]::-moz-range-thumb {\n    height: 11px;\n    width: 11px;\n    background: #ffffff;\n    border-radius: 6px;\n    border: 0px solid #ffffff;\n    position: relative;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n}\n.le-slider input[data-v-571937fd]::-ms-track {\n    background: #d4d4d4;\n    border-radius: 0;\n    border: 0 transparent;\n    color: transparent;\n    height: 2px;\n    margin-top: 10px;\n}\n.le-slider input[data-v-571937fd]::-ms-fill-lower {\n    background: #5879da;\n}\n.le-slider input[data-v-571937fd]::-ms-fill-upper {\n    background: #d4d4d4;\n}\n.le-slider input[data-v-571937fd]::-ms-thumb {\n    height: 11px;\n    width: 11px;\n    background: #ffffff;\n    border-radius: 6px;\n    border: 0px solid #ffffff;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n}\n.le-slider input[data-v-571937fd]::-ms-tooltip {\n    display: none;\n}\n.le-slider__text[data-v-571937fd] {\n  display: inline-block;\n  font-size: 12px;\n  text-align: center;\n  width: 100%;\n}\n.le-slider__text.theme-dark[data-v-571937fd],\n  .theme-dark .le-slider__text[data-v-571937fd] {\n    color: #888888;\n}\n.le-slider__text.theme-light[data-v-571937fd],\n  .theme-light .le-slider__text[data-v-571937fd] {\n    color: #b1b1b1;\n}\n.le-slider__text__minimum[data-v-571937fd] {\n    float: left;\n}\n.le-slider__text__maximum[data-v-571937fd] {\n    float: right;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-slider"},[_c('div',{staticClass:"le-slider__selected-input",style:(_vm.selectedOffset)},[_vm._v(_vm._s(_vm.getValue)+_vm._s(_vm.selectedRangeLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:(_vm.linearBackground),attrs:{"type":"range","min":_vm.minimumRangeValue,"max":_vm.maximumRangeValue},domProps:{"value":(_vm.value)},on:{"input":_vm.updateSelectedRange,"mouseup":_vm.doneChangingRange,"__r":function($event){_vm.value=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"le-slider__text"},[_c('div',{staticClass:"le-slider__text__minimum"},[_vm._v(_vm._s(_vm.minimumRangeLabel))]),_vm._v(" "),_c('div',{staticClass:"le-slider__text__maximum"},[_vm._v(_vm._s(_vm.maximumRangeLabel))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_dialog_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294f06ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_dialog_vue__ = __webpack_require__(535);
function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-294f06ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294f06ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27e192db", content, true, {});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-dialog[data-v-294f06ac]{position:absolute;top:0;right:0;left:0;bottom:0}.le-dialog.theme-dark[data-v-294f06ac],.theme-dark .le-dialog[data-v-294f06ac]{background-color:rgba(3,0,47,.5)}.le-dialog.theme-light[data-v-294f06ac],.theme-light .le-dialog[data-v-294f06ac]{background-color:rgba(230,235,245,.7)}.le-dialog .dialog-box[data-v-294f06ac]{position:absolute;max-height:100%;top:50%;left:50%;margin-right:-50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:5px}.le-dialog .dialog-box.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box[data-v-294f06ac]{-webkit-box-shadow:0 2px 6px 1px rgba(0,0,0,.2);box-shadow:0 2px 6px 1px rgba(0,0,0,.2);background-color:#2c3249;color:#fcfcfd}.le-dialog .dialog-box.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box[data-v-294f06ac]{-webkit-box-shadow:0 2px 6px 1px rgba(0,0,0,.2);box-shadow:0 2px 6px 1px rgba(0,0,0,.2);background-color:#f3f6ff;color:#666}.le-dialog .dialog-box .inner-dialog[data-v-294f06ac]{padding:20px}.le-dialog .dialog-box .inner-dialog .dialog-content[data-v-294f06ac]{width:100%;display:table}.le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac]{cursor:pointer;position:absolute;top:10px;right:10px}.le-dialog .dialog-box .inner-dialog .dialog-content .close.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac]{color:#fcfcfd}.le-dialog .dialog-box .inner-dialog .dialog-content .close.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac]{color:#888}.le-dialog .dialog-box .inner-dialog .dialog-content .text[data-v-294f06ac]{display:table-cell;vertical-align:top}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac]{font-size:13px;font-weight:700;padding-bottom:5px;margin-bottom:10px}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac]{color:#fcfcfd;border-bottom:1px solid #fcfcfd}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac]{color:#323436;border-bottom:1px solid #888}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon[data-v-294f06ac]{margin-right:5px;vertical-align:bottom;margin-bottom:2px}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning[data-v-294f06ac]{color:#dcbb0d}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning[data-v-294f06ac]{color:#f5a623}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error[data-v-294f06ac]{color:#ff1820}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error[data-v-294f06ac]{color:#d0021b}.le-dialog .dialog-box .inner-dialog .dialog-content .text .header span[data-v-294f06ac]{line-height:18px}.le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac]{font-size:12px;line-height:1.3}.le-dialog .dialog-box .inner-dialog .dialog-content .text .description.theme-dark[data-v-294f06ac],.theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac]{color:#fcfcfd}.le-dialog .dialog-box .inner-dialog .dialog-content .text .description.theme-light[data-v-294f06ac],.theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac]{color:#666}.le-dialog .dialog-box .inner-dialog .footer[data-v-294f06ac]{text-align:right;margin-top:25px}.le-dialog .dialog-box .inner-dialog .footer .secondary-button[data-v-294f06ac]{margin-right:10px}.le-dialog .dialog-box .inner-dialog .footer .cancel[data-v-294f06ac]{float:left}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-dialog/le-dialog.vue"],"names":[],"mappings":"AAIA,4BACE,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,OAAQ,AACR,QAAU,CACX,AACD,+EAEI,gCAAsC,CACzC,AACD,iFAEI,qCAA2C,CAC9C,AACD,wCACI,kBAAmB,AACnB,gBAAiB,AACjB,QAAS,AACT,SAAU,AACV,kBAAmB,AACnB,uCAAyC,AACjC,+BAAiC,AACzC,8BAA+B,AACvB,sBAAuB,AAC/B,iBAAmB,CACtB,AACD,uGAEM,gDAAqD,AAC7C,wCAA6C,AACrD,yBAA0B,AAC1B,aAAe,CACpB,AACD,yGAEM,gDAAqD,AAC7C,wCAA6C,AACrD,yBAA0B,AAC1B,UAAe,CACpB,AACD,sDACM,YAAc,CACnB,AACD,sEACQ,WAAY,AACZ,aAAe,CACtB,AACD,6EACU,eAAgB,AAChB,kBAAmB,AACnB,SAAU,AACV,UAAY,CACrB,AACD,iLAEY,aAAe,CAC1B,AACD,mLAEY,UAAe,CAC1B,AACD,4EACU,mBAAoB,AACpB,kBAAoB,CAC7B,AACD,oFACY,eAAgB,AAChB,gBAAkB,AAClB,mBAAoB,AACpB,kBAAoB,CAC/B,AACD,+LAEc,cAAe,AACf,+BAAiC,CAC9C,AACD,iMAEc,cAAe,AACf,4BAAiC,CAC9C,AACD,iGACc,iBAAkB,AAClB,sBAAuB,AACvB,iBAAmB,CAChC,AACD,yPAEgB,aAAe,CAC9B,AACD,2PAEgB,aAAe,CAC9B,AACD,qPAEgB,aAAe,CAC9B,AACD,uPAEgB,aAAe,CAC9B,AACD,yFACc,gBAAkB,CAC/B,AACD,yFACY,eAAgB,AAChB,eAAiB,CAC5B,AACD,yMAEc,aAAe,CAC5B,AACD,2MAEc,UAAe,CAC5B,AACD,8DACQ,iBAAkB,AAClB,eAAiB,CACxB,AACD,gFACU,iBAAmB,CAC5B,AACD,sEACU,UAAY,CACrB","file":"le-dialog.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-dialog[data-v-294f06ac] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.le-dialog.theme-dark[data-v-294f06ac],\n  .theme-dark .le-dialog[data-v-294f06ac] {\n    background-color: rgba(3, 0, 47, 0.5);\n}\n.le-dialog.theme-light[data-v-294f06ac],\n  .theme-light .le-dialog[data-v-294f06ac] {\n    background-color: rgba(230, 235, 245, 0.7);\n}\n.le-dialog .dialog-box[data-v-294f06ac] {\n    position: absolute;\n    max-height: 100%;\n    top: 50%;\n    left: 50%;\n    margin-right: -50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 5px;\n}\n.le-dialog .dialog-box.theme-dark[data-v-294f06ac],\n    .theme-dark .le-dialog .dialog-box[data-v-294f06ac] {\n      -webkit-box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n      background-color: #2c3249;\n      color: #fcfcfd;\n}\n.le-dialog .dialog-box.theme-light[data-v-294f06ac],\n    .theme-light .le-dialog .dialog-box[data-v-294f06ac] {\n      -webkit-box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.2);\n      background-color: #f3f6ff;\n      color: #666666;\n}\n.le-dialog .dialog-box .inner-dialog[data-v-294f06ac] {\n      padding: 20px;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content[data-v-294f06ac] {\n        width: 100%;\n        display: table;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac] {\n          cursor: pointer;\n          position: absolute;\n          top: 10px;\n          right: 10px;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .close.theme-dark[data-v-294f06ac],\n          .theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac] {\n            color: #fcfcfd;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .close.theme-light[data-v-294f06ac],\n          .theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .close[data-v-294f06ac] {\n            color: #888888;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text[data-v-294f06ac] {\n          display: table-cell;\n          vertical-align: top;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac] {\n            font-size: 13px;\n            font-weight: bold;\n            padding-bottom: 5px;\n            margin-bottom: 10px;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header.theme-dark[data-v-294f06ac],\n            .theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac] {\n              color: #fcfcfd;\n              border-bottom: 1px solid #fcfcfd;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header.theme-light[data-v-294f06ac],\n            .theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header[data-v-294f06ac] {\n              color: #323436;\n              border-bottom: 1px solid #888888;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon[data-v-294f06ac] {\n              margin-right: 5px;\n              vertical-align: bottom;\n              margin-bottom: 2px;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning.theme-dark[data-v-294f06ac],\n              .theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning[data-v-294f06ac] {\n                color: #dcbb0d;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning.theme-light[data-v-294f06ac],\n              .theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-warning[data-v-294f06ac] {\n                color: #f5a623;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error.theme-dark[data-v-294f06ac],\n              .theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error[data-v-294f06ac] {\n                color: #ff1820;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error.theme-light[data-v-294f06ac],\n              .theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .header .dialog-icon.variant-error[data-v-294f06ac] {\n                color: #d0021b;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .header span[data-v-294f06ac] {\n              line-height: 18px;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac] {\n            font-size: 12px;\n            line-height: 1.3;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .description.theme-dark[data-v-294f06ac],\n            .theme-dark .le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac] {\n              color: #fcfcfd;\n}\n.le-dialog .dialog-box .inner-dialog .dialog-content .text .description.theme-light[data-v-294f06ac],\n            .theme-light .le-dialog .dialog-box .inner-dialog .dialog-content .text .description[data-v-294f06ac] {\n              color: #666666;\n}\n.le-dialog .dialog-box .inner-dialog .footer[data-v-294f06ac] {\n        text-align: right;\n        margin-top: 25px;\n}\n.le-dialog .dialog-box .inner-dialog .footer .secondary-button[data-v-294f06ac] {\n          margin-right: 10px;\n}\n.le-dialog .dialog-box .inner-dialog .footer .cancel[data-v-294f06ac] {\n          float: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-dialog', _vm.outerClass],style:(("z-index: " + _vm.zIndex)),attrs:{"role":"dialog","aria-describedby":"header-text"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"escape",undefined,$event.key,undefined)){ return null; }return _vm.onCloseClick($event)}}},[_c('div',{ref:"dialogBox",class:['dialog-box', _vm.theme],style:(("width: " + _vm.width + "; height: " + _vm.height + "; min-width: " + _vm.minWidth + "; min-height: " + _vm.minHeight + ";")),attrs:{"tabindex":"-1"}},[_vm._t("default",[_c('div',{staticClass:"inner-dialog"},[_c('div',{class:['dialog-content', _vm.theme]},[(_vm.showCloseButton)?_c('i',{ref:"closeButton",class:['close', 'ico-close', 'ico-10', _vm.theme],attrs:{"role":"button","tabindex":"0","aria-label":_vm.cancelText,"data-test":"close_button","focusBorder":_vm.buttonFocusBorder},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onCloseClick($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onCloseButtonTabKeyPressed($event)}],"click":_vm.onCloseClick}}):_vm._e(),_vm._v(" "),_c('div',{class:['text', _vm.theme]},[(_vm.header)?_c('div',{class:['header', _vm.theme]},[(_vm.hasIcon)?_c('i',{class:['dialog-icon', 'ico-18', _vm.icon, ("variant-" + _vm.variant)],attrs:{"role":"img","aria-label":_vm.variant}}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"id":_vm.headerId,"aria-labelledby":_vm.getHeaderAriaLabelledbyId,"role":"heading","aria-level":"2"}},[_vm._v("\n                "+_vm._s(_vm.header)+"\n              ")])]):_vm._e(),_vm._v(" "),_vm._t("content",[_c('div',{class:['description', _vm.theme]},[_vm._v(_vm._s(_vm.description))])])],2)]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('le-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCancelButton),expression:"showCancelButton"}],ref:"cancelButton",class:['cancel', _vm.theme],attrs:{"variant":"cancel","label":_vm.cancelText,"data-test":"cancel_button","focusBorder":_vm.buttonFocusBorder},on:{"click":_vm.onCancelClick,"clickOnTab":_vm.onCancelButtonTabKeyPressed}}),_vm._v(" "),_c('le-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.secondaryButtonText),expression:"secondaryButtonText"}],class:['secondary-button', _vm.theme],attrs:{"variant":"default","label":_vm.secondaryButtonText,"data-test":"secondary_button"},on:{"click":_vm.onSecondaryButtonClick}}),_vm._v(" "),_c('le-button',{ref:"primaryButton",class:['primary-button', _vm.theme],attrs:{"icon":_vm.primaryButtonIcon,"variant":"primary","label":_vm.primaryButtonText,"data-test":"primary_button","disabled":_vm.isPrimaryButtonDisabled},on:{"clickOnTab":_vm.onPrimaryButtonTabKeyPressed,"click":_vm.onPrimaryButtonClick}})],1)])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_text_editor_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fe554e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_text_editor_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(537)
  __webpack_require__(542)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54fe554e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_text_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fe554e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_text_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("064eb5d8", content, true, {});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports
exports.i(__webpack_require__(539), "");
exports.i(__webpack_require__(540), "");
exports.i(__webpack_require__(541), "");

// module
exports.push([module.i, ".le-text-editor[data-v-54fe554e]{height:100%;position:relative;margin:0}.le-text-editor .splitter-container[data-v-54fe554e]{position:relative;left:0;right:0}.le-text-editor .splitter-container .splitter[data-v-54fe554e]{width:12px;height:3px;position:relative;top:3px;margin:auto}.le-text-editor .splitter-container .splitter.resize-up[data-v-54fe554e]{cursor:n-resize}.le-text-editor .splitter-container .splitter.resize-down[data-v-54fe554e]{cursor:s-resize}.le-text-editor .editor-container[data-v-54fe554e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.le-text-editor .editor-container .editor-control-container[data-v-54fe554e]{width:100%;overflow-y:auto;cursor:text;margin:10px}.le-text-editor .editor-container .editor-control-container .editor-control[data-v-54fe554e]{height:auto}.le-text-editor .editor-container .editor-control-container .ql-editor[data-v-54fe554e]{line-height:inherit;padding:0}.le-text-editor .editor-container .editor-control-container .ql-editor.ql-blank[data-v-54fe554e]:before{left:0}.le-text-editor .editor-container .editor-control-container.editor-slot[data-v-54fe554e]{cursor:default}.le-text-editor .editor-container .action-container[data-v-54fe554e]{padding-right:20px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.le-text-editor.disabled[data-v-54fe554e]{opacity:.3}.le-text-editor.disabled .editor-container .editor-control-container .ql-editor>[data-v-54fe554e],.le-text-editor.disabled .editor-container .editor-control-container[data-v-54fe554e]{cursor:default}.le-text-editor .overlay[data-v-54fe554e]{position:absolute;top:-10px;left:0;width:calc(100% + -2px);height:calc(100% + 9px);border-style:dashed;border-width:1px;border-radius:5px;z-index:2}.le-text-editor .overlay>[data-v-54fe554e]{pointer-events:none}.le-text-editor .overlay.theme-dark[data-v-54fe554e],.theme-dark .le-text-editor .overlay[data-v-54fe554e]{background-color:#474a6a}.le-text-editor .overlay.theme-light[data-v-54fe554e],.theme-light .le-text-editor .overlay[data-v-54fe554e]{background-color:#ebecef}.le-text-editor .overlay .drop-area[data-v-54fe554e]{position:absolute;display:block;z-index:2;left:0;right:0;margin:auto;top:0;bottom:0}.le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e]{left:50%;top:50%;-webkit-transform:translateY(-50%) translateX(-50%);transform:translateY(-50%) translateX(-50%);border-radius:50%;text-align:center;font-size:30px;border:2px solid;position:relative;width:25px;height:25px;line-height:25px;padding-bottom:1px;opacity:.8}.le-text-editor .overlay .drop-area .drop-area-icon.theme-dark[data-v-54fe554e],.le-text-editor .overlay .drop-area .drop-area-icon.theme-light[data-v-54fe554e],.theme-dark .le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e],.theme-light .le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e]{border-color:#ccc;color:#ccc}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-text-editor.vue"],"names":[],"mappings":"AAOA,iCACE,YAAa,AACb,kBAAmB,AACnB,QAAU,CACX,AACD,qDACI,kBAAmB,AACnB,OAAQ,AACR,OAAS,CACZ,AACD,+DACM,WAAY,AACZ,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,WAAa,CAClB,AACD,yEACQ,eAAiB,CACxB,AACD,2EACQ,eAAiB,CACxB,AACD,mDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,yBAA0B,AACtB,qBAAsB,AAC9B,YAAa,AACb,8BAA+B,AACvB,qBAAuB,CAClC,AACD,6EACM,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,WAAa,CAClB,AACD,6FACQ,WAAa,CACpB,AACD,wFACQ,oBAAqB,AACrB,SAAW,CAClB,AACD,wGACU,MAAQ,CACjB,AACD,yFACQ,cAAgB,CACvB,AACD,qEACM,mBAAoB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACnB,AACD,0CACI,UAAa,CAChB,AAID,wLACQ,cAAgB,CACvB,AACD,0CACI,kBAAmB,AACnB,UAAW,AACX,OAAU,AACV,wBAAyB,AACzB,wBAAyB,AACzB,oBAAqB,AACrB,iBAAkB,AAClB,kBAAmB,AACnB,SAAW,CACd,AACD,2CACM,mBAAqB,CAC1B,AACD,2GAEM,wBAA0B,CAC/B,AACD,6GAEM,wBAA0B,CAC/B,AACD,qDACM,kBAAmB,AACnB,cAAe,AACf,UAAW,AACX,OAAQ,AACR,QAAS,AACT,YAAa,AACb,MAAO,AACP,QAAU,CACf,AACD,qEACQ,SAAU,AACV,QAAS,AACT,oDAAqD,AAC7C,4CAA6C,AACrD,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,mBAAoB,AACpB,UAAa,CACpB,AAMD,oUAEU,kBAAsB,AACtB,UAAe,CACxB","file":"le-text-editor.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n@import url(../../../../node_modules/quill/dist/quill.core.css);\n@import url(../../../../node_modules/quill/dist/quill.snow.css);\n@import url(../../../../node_modules/quill/dist/quill.bubble.css);\n.le-text-editor[data-v-54fe554e] {\n  height: 100%;\n  position: relative;\n  margin: 0;\n}\n.le-text-editor .splitter-container[data-v-54fe554e] {\n    position: relative;\n    left: 0;\n    right: 0;\n}\n.le-text-editor .splitter-container .splitter[data-v-54fe554e] {\n      width: 12px;\n      height: 3px;\n      position: relative;\n      top: 3px;\n      margin: auto;\n}\n.le-text-editor .splitter-container .splitter.resize-up[data-v-54fe554e] {\n        cursor: n-resize;\n}\n.le-text-editor .splitter-container .splitter.resize-down[data-v-54fe554e] {\n        cursor: s-resize;\n}\n.le-text-editor .editor-container[data-v-54fe554e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n            flex-flow: row nowrap;\n    height: 100%;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.le-text-editor .editor-container .editor-control-container[data-v-54fe554e] {\n      width: 100%;\n      overflow-y: auto;\n      cursor: text;\n      margin: 10px;\n}\n.le-text-editor .editor-container .editor-control-container .editor-control[data-v-54fe554e] {\n        height: auto;\n}\n.le-text-editor .editor-container .editor-control-container .ql-editor[data-v-54fe554e] {\n        line-height: inherit;\n        padding: 0;\n}\n.le-text-editor .editor-container .editor-control-container .ql-editor.ql-blank[data-v-54fe554e]:before {\n          left: 0;\n}\n.le-text-editor .editor-container .editor-control-container.editor-slot[data-v-54fe554e] {\n        cursor: default;\n}\n.le-text-editor .editor-container .action-container[data-v-54fe554e] {\n      padding-right: 20px;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.le-text-editor.disabled[data-v-54fe554e] {\n    opacity: 0.3;\n}\n.le-text-editor.disabled .editor-container .editor-control-container[data-v-54fe554e] {\n      cursor: default;\n}\n.le-text-editor.disabled .editor-container .editor-control-container .ql-editor > *[data-v-54fe554e] {\n        cursor: default;\n}\n.le-text-editor .overlay[data-v-54fe554e] {\n    position: absolute;\n    top: -10px;\n    left: 0px;\n    width: calc(100% + -2px);\n    height: calc(100% + 9px);\n    border-style: dashed;\n    border-width: 1px;\n    border-radius: 5px;\n    z-index: 2;\n}\n.le-text-editor .overlay > *[data-v-54fe554e] {\n      pointer-events: none;\n}\n.le-text-editor .overlay.theme-dark[data-v-54fe554e],\n    .theme-dark .le-text-editor .overlay[data-v-54fe554e] {\n      background-color: #474a6a;\n}\n.le-text-editor .overlay.theme-light[data-v-54fe554e],\n    .theme-light .le-text-editor .overlay[data-v-54fe554e] {\n      background-color: #ebecef;\n}\n.le-text-editor .overlay .drop-area[data-v-54fe554e] {\n      position: absolute;\n      display: block;\n      z-index: 2;\n      left: 0;\n      right: 0;\n      margin: auto;\n      top: 0;\n      bottom: 0;\n}\n.le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e] {\n        left: 50%;\n        top: 50%;\n        -webkit-transform: translateY(-50%) translateX(-50%);\n                transform: translateY(-50%) translateX(-50%);\n        border-radius: 50%;\n        text-align: center;\n        font-size: 30px;\n        border: 2px solid;\n        position: relative;\n        width: 25px;\n        height: 25px;\n        line-height: 25px;\n        padding-bottom: 1px;\n        opacity: 0.8;\n}\n.le-text-editor .overlay .drop-area .drop-area-icon.theme-dark[data-v-54fe554e],\n        .theme-dark .le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e] {\n          border-color: #cccccc;\n          color: #cccccc;\n}\n.le-text-editor .overlay .drop-area .drop-area-icon.theme-light[data-v-54fe554e],\n        .theme-light .le-text-editor .overlay .drop-area .drop-area-icon[data-v-54fe554e] {\n          border-color: #cccccc;\n          color: #cccccc;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/node_modules/quill/dist/quill.core.css"],"names":[],"mappings":"AAAA;;;;;GAKG,AACH,cACE,sBAAuB,AACvB,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,sBAAuB,AACvB,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb","file":"quill.core.css","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow.ql-toolbar:after,.ql-snow .ql-toolbar:after{clear:both;content:\"\";display:table}.ql-snow.ql-toolbar button,.ql-snow .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow.ql-toolbar button svg,.ql-snow .ql-toolbar button svg{float:left;height:100%}.ql-snow.ql-toolbar button:active:hover,.ql-snow .ql-toolbar button:active:hover{outline:none}.ql-snow.ql-toolbar input.ql-image[type=file],.ql-snow .ql-toolbar input.ql-image[type=file]{display:none}.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow .ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover,.ql-snow .ql-toolbar button:hover{color:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow.ql-toolbar button:hover:not(.ql-active),.ql-snow .ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow,.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:\"\";display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label:before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item:before,.ql-snow .ql-picker.ql-header .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:\"Heading 1\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:\"Heading 2\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:\"Heading 3\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Heading 4\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:\"Heading 5\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:\"Heading 6\"}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item:before,.ql-snow .ql-picker.ql-font .ql-picker-label:before{content:\"Sans Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:\"Serif\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:\"Monospace\"}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item:before,.ql-snow .ql-picker.ql-size .ql-picker-label:before{content:\"Normal\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:\"Small\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:\"Large\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:\"Huge\"}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:0 2px 8px rgba(0,0,0,.2)}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip:before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action:after{border-right:1px solid #ccc;content:\"Edit\";margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove:before{content:\"Remove\";margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action:after{border-right:0;content:\"Save\";padding-right:0}.ql-snow .ql-tooltip[data-mode=link]:before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]:before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]:before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/node_modules/quill/dist/quill.snow.css"],"names":[],"mappings":"AAAA;;;;;GAKG,AACH,cACE,sBAAuB,AACvB,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,sBAAuB,AACvB,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb,AACD,qDAEE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,uDAEE,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,UAAY,CACb,AACD,+DAEE,WAAY,AACZ,WAAa,CACd,AACD,iFAEE,YAAc,CACf,AACD,6FAEE,YAAc,CACf,AACD,6jBAcE,UAAY,CACb,AACD,kgDA4BE,SAAW,CACZ,AACD,kgDA4BE,WAAa,CACd,AACD,wBACE,mGAEE,UAAY,CACb,AACD,8PAIE,SAAW,CACZ,AACD,8PAIE,WAAa,CACd,CACF,AAID,oBACE,qBAAuB,CACxB,AACD,oBACE,YAAc,CACf,AACD,6CAEE,iBAAmB,CACpB,AACD,qBACE,kBAAmB,AACnB,0BAA4B,CAC7B,AACD,uBACE,eAAgB,AAChB,oBAAsB,CACvB,AACD,6BACE,2BAA6B,CAC9B,AACD,qBACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,2BACE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,oBACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,sBAAuB,AACvB,cAAgB,CACjB,AACD,0BACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,cAAgB,CACjB,AACD,8CAEE,SAAW,CACZ,AACD,mBACE,SAAW,CACZ,AACD,kBACE,iBAAmB,CACpB,AACD,8CAEE,cAAgB,CACjB,AACD,yBACE,UAAa,CACd,AACD,sCACE,YAAc,CACf,AACD,gDACE,cAAgB,CACjB,AACD,iDACE,YAAc,CACf,AACD,uBACE,aAAe,CAChB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,aAAe,CAChB,AACD,uBACE,eAAkB,CACnB,AACD,uBACE,eAAkB,CACnB,AACD,sBACE,yBAA2B,CAC5B,AACD,+BACE,2BAA4B,AAC5B,kBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACpB,AACD,iDAEE,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,wBACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACnB,AACD,yBACE,cAAe,AACf,eAAiB,CAClB,AACD,kCACE,yBAA0B,AAC1B,cAAe,AACf,gBAAkB,CACnB,AACD,wBACE,cAAgB,CACjB,AACD,oBACE,WAAY,AACZ,qBAAsB,AACtB,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,qBAAuB,CACxB,AACD,0BACE,eAAgB,AAChB,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,UAAY,CACb,AACD,iCACE,qBAAsB,AACtB,gBAAkB,CACnB,AACD,4BACE,sBAAuB,AACvB,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4CACE,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,iDACE,WAAY,AACZ,SAAW,CACZ,AACD,0DACE,SAAW,CACZ,AACD,4DACE,WAAa,CACd,AACD,mDACE,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,mDAEE,UAAY,CACb,AACD,qFAEE,eAAiB,CAClB,AACD,6FAEE,SAAW,CACZ,AACD,4CACE,aAAiB,CAClB,AACD,yCACE,YAAa,AACb,WAAY,AACZ,eAAiB,CAClB,AACD,6CACE,gBAAiB,AACjB,WAAa,CACd,AACD,0CACE,6BAA8B,AAC9B,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,UAAa,AACb,UAAY,CACb,AACD,mEACE,kBAAmB,AACnB,gBAAiB,AACjB,QAAS,AACT,QAAS,AACT,UAAY,CACb,AACD,+fAME,wBAA0B,CAC3B,AACD,8BACE,UAAY,CACb,AACD,2GAEE,gBAAkB,CACnB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,2IAEE,mBAAqB,CACtB,AACD,qEACE,aAAe,CAChB,AACD,qEACE,eAAiB,CAClB,AACD,qEACE,gBAAkB,CACnB,AACD,qEACE,aAAe,CAChB,AACD,qEACE,eAAkB,CACnB,AACD,qEACE,eAAkB,CACnB,AACD,4BACE,WAAa,CACd,AACD,uGAEE,oBAAsB,CACvB,AACD,2IAEE,eAAiB,CAClB,AACD,mJAEE,mBAAqB,CACtB,AACD,qEACE,yCAA6C,CAC9C,AACD,yEACE,wCAA4C,CAC7C,AACD,4BACE,UAAY,CACb,AACD,uGAEE,gBAAkB,CACnB,AACD,2IAEE,eAAiB,CAClB,AACD,2IAEE,eAAiB,CAClB,AACD,yIAEE,cAAgB,CACjB,AACD,qEACE,cAAgB,CACjB,AACD,qEACE,cAAgB,CACjB,AACD,oEACE,cAAgB,CACjB,AACD,wDACE,qBAAuB,CACxB,AACD,mDACE,qBAAuB,CACxB,AACD,oBACE,sBAAuB,AACvB,sBAAuB,AACvB,sDAAgE,AAChE,WAAa,CACd,AACD,gCACE,iBAAmB,CACpB,AACD,qCACE,4BAA8B,CAC/B,AACD,uCACE,6BAA8B,AAC9B,mCAAsC,CACvC,AAID,0HACE,iBAAmB,CACpB,AACD,4HAEE,iBAAmB,CACpB,AACD,0CACE,YAAgB,CACjB,AACD,qBACE,sBAAuB,AACvB,sBAAuB,AACvB,wBAA6B,AAC7B,WAAY,AACZ,iBAAkB,AAClB,kBAAoB,CACrB,AACD,4BACE,qBAAsB,AACtB,iBAAkB,AAClB,gBAAkB,CACnB,AACD,sCACE,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,gBAAiB,AACjB,WAAa,CACd,AACD,kCACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,uCACE,4BAA6B,AAC7B,eAAgB,AAChB,iBAAkB,AAClB,iBAAmB,CACpB,AACD,wCACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,yFAEE,YAAc,CACf,AACD,iDACE,oBAAsB,CACvB,AACD,kDACE,eAAkB,AAClB,eAAgB,AAChB,eAAmB,CACpB,AACD,4CACE,qBAAuB,CACxB,AACD,+CACE,wBAA0B,CAC3B,AACD,6CACE,sBAAwB,CACzB,AACD,WACE,UAAY,CACb,AACD,sBACE,qBAAuB,CACxB","file":"quill.snow.css","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type=file],\n.ql-snow .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n  color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #06c;\n}\n@media (pointer: coarse) {\n  .ql-snow.ql-toolbar button:hover:not(.ql-active),\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n    color: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #444;\n  }\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #444;\n  }\n}\n.ql-snow {\n  box-sizing: border-box;\n}\n.ql-snow * {\n  box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n  display: none;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n  visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n  position: absolute;\n  transform: translateY(10px);\n}\n.ql-snow .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n  transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-snow .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-snow .ql-stroke {\n  fill: none;\n  stroke: #444;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-snow .ql-stroke-miter {\n  fill: none;\n  stroke: #444;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n  fill: #444;\n}\n.ql-snow .ql-empty {\n  fill: none;\n}\n.ql-snow .ql-even {\n  fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n  opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n  display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-snow .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-snow .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-snow .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-snow .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n  text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-snow .ql-editor img {\n  max-width: 100%;\n}\n.ql-snow .ql-picker {\n  color: #444;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-snow .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-snow .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #ccc;\n  z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n  width: 28px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  padding: 8px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-picker-label {\n  border: 1px solid transparent;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n  border: 1px solid transparent;\n  box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n  border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n  border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n  border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0px 0px 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n  content: \"Visit URL:\";\n  line-height: 26px;\n  margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type=text] {\n  display: none;\n  border: 1px solid #ccc;\n  font-size: 13px;\n  height: 26px;\n  margin: 0px;\n  padding: 3px 5px;\n  width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n  display: inline-block;\n  max-width: 200px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n  border-right: 1px solid #ccc;\n  content: 'Edit';\n  margin-left: 16px;\n  padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n  content: 'Remove';\n  margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n  line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type=text] {\n  display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n  border-right: 0px;\n  content: 'Save';\n  padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode=link]::before {\n  content: \"Enter link:\";\n}\n.ql-snow .ql-tooltip[data-mode=formula]::before {\n  content: \"Enter formula:\";\n}\n.ql-snow .ql-tooltip[data-mode=video]::before {\n  content: \"Enter video:\";\n}\n.ql-snow a {\n  color: #06c;\n}\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-bubble.ql-toolbar:after,.ql-bubble .ql-toolbar:after{clear:both;content:\"\";display:table}.ql-bubble.ql-toolbar button,.ql-bubble .ql-toolbar button{background:none;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-bubble.ql-toolbar button svg,.ql-bubble .ql-toolbar button svg{float:left;height:100%}.ql-bubble.ql-toolbar button:active:hover,.ql-bubble .ql-toolbar button:active:hover{outline:none}.ql-bubble.ql-toolbar input.ql-image[type=file],.ql-bubble .ql-toolbar input.ql-image[type=file]{display:none}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected,.ql-bubble.ql-toolbar .ql-picker-item:hover,.ql-bubble .ql-toolbar .ql-picker-item:hover,.ql-bubble.ql-toolbar .ql-picker-label.ql-active,.ql-bubble .ql-toolbar .ql-picker-label.ql-active,.ql-bubble.ql-toolbar .ql-picker-label:hover,.ql-bubble .ql-toolbar .ql-picker-label:hover,.ql-bubble.ql-toolbar button.ql-active,.ql-bubble .ql-toolbar button.ql-active,.ql-bubble.ql-toolbar button:focus,.ql-bubble .ql-toolbar button:focus,.ql-bubble.ql-toolbar button:hover,.ql-bubble .ql-toolbar button:hover{color:#fff}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:focus .ql-fill,.ql-bubble .ql-toolbar button:focus .ql-fill,.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:hover .ql-fill,.ql-bubble .ql-toolbar button:hover .ql-fill,.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill{fill:#fff}.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble.ql-toolbar button.ql-active .ql-stroke,.ql-bubble .ql-toolbar button.ql-active .ql-stroke,.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar button:focus .ql-stroke,.ql-bubble .ql-toolbar button:focus .ql-stroke,.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,.ql-bubble.ql-toolbar button:hover .ql-stroke,.ql-bubble .ql-toolbar button:hover .ql-stroke,.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover .ql-stroke-miter{stroke:#fff}@media (pointer:coarse){.ql-bubble.ql-toolbar button:hover:not(.ql-active),.ql-bubble .ql-toolbar button:hover:not(.ql-active){color:#ccc}.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#ccc}.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#ccc}}.ql-bubble,.ql-bubble *{box-sizing:border-box}.ql-bubble .ql-hidden{display:none}.ql-bubble .ql-out-bottom,.ql-bubble .ql-out-top{visibility:hidden}.ql-bubble .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-bubble .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-bubble .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-bubble .ql-formats{display:inline-block;vertical-align:middle}.ql-bubble .ql-formats:after{clear:both;content:\"\";display:table}.ql-bubble .ql-stroke{fill:none;stroke:#ccc;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-bubble .ql-stroke-miter{fill:none;stroke:#ccc;stroke-miterlimit:10;stroke-width:2}.ql-bubble .ql-fill,.ql-bubble .ql-stroke.ql-fill{fill:#ccc}.ql-bubble .ql-empty{fill:none}.ql-bubble .ql-even{fill-rule:evenodd}.ql-bubble .ql-stroke.ql-thin,.ql-bubble .ql-thin{stroke-width:1}.ql-bubble .ql-transparent{opacity:.4}.ql-bubble .ql-direction svg:last-child{display:none}.ql-bubble .ql-direction.ql-active svg:last-child{display:inline}.ql-bubble .ql-direction.ql-active svg:first-child{display:none}.ql-bubble .ql-editor h1{font-size:2em}.ql-bubble .ql-editor h2{font-size:1.5em}.ql-bubble .ql-editor h3{font-size:1.17em}.ql-bubble .ql-editor h4{font-size:1em}.ql-bubble .ql-editor h5{font-size:.83em}.ql-bubble .ql-editor h6{font-size:.67em}.ql-bubble .ql-editor a{text-decoration:underline}.ql-bubble .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-bubble .ql-editor code,.ql-bubble .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-bubble .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-bubble .ql-editor code{font-size:85%;padding:2px 4px}.ql-bubble .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-bubble .ql-editor img{max-width:100%}.ql-bubble .ql-picker{color:#ccc;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-bubble .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-bubble .ql-picker-label:before{display:inline-block;line-height:22px}.ql-bubble .ql-picker-options{background-color:#444;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-bubble .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-bubble .ql-picker.ql-expanded .ql-picker-label{color:#777;z-index:2}.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#777}.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#777}.ql-bubble .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-bubble .ql-color-picker,.ql-bubble .ql-icon-picker{width:28px}.ql-bubble .ql-color-picker .ql-picker-label,.ql-bubble .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-bubble .ql-color-picker .ql-picker-label svg,.ql-bubble .ql-icon-picker .ql-picker-label svg{right:4px}.ql-bubble .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-bubble .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-bubble .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-bubble .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\"\"]):before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\"\"]):before{content:attr(data-label)}.ql-bubble .ql-picker.ql-header{width:98px}.ql-bubble .ql-picker.ql-header .ql-picker-item:before,.ql-bubble .ql-picker.ql-header .ql-picker-label:before{content:\"Normal\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]:before{content:\"Heading 1\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]:before{content:\"Heading 2\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]:before{content:\"Heading 3\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Heading 4\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]:before{content:\"Heading 5\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before,.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]:before{content:\"Heading 6\"}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]:before{font-size:2em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]:before{font-size:1.5em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]:before{font-size:1.17em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before{font-size:1em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]:before{font-size:.83em}.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]:before{font-size:.67em}.ql-bubble .ql-picker.ql-font{width:108px}.ql-bubble .ql-picker.ql-font .ql-picker-item:before,.ql-bubble .ql-picker.ql-font .ql-picker-label:before{content:\"Sans Serif\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]:before{content:\"Serif\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]:before{content:\"Monospace\"}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]:before{font-family:Georgia,Times New Roman,serif}.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]:before{font-family:Monaco,Courier New,monospace}.ql-bubble .ql-picker.ql-size{width:98px}.ql-bubble .ql-picker.ql-size .ql-picker-item:before,.ql-bubble .ql-picker.ql-size .ql-picker-label:before{content:\"Normal\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]:before{content:\"Small\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]:before{content:\"Large\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]:before{content:\"Huge\"}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]:before{font-size:10px}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]:before{font-size:18px}.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]:before{font-size:32px}.ql-bubble .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-bubble .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-bubble .ql-toolbar .ql-formats{margin:8px 12px 8px 0}.ql-bubble .ql-toolbar .ql-formats:first-child{margin-left:12px}.ql-bubble .ql-color-picker svg{margin:1px}.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,.ql-bubble .ql-color-picker .ql-picker-item:hover{border-color:#fff}.ql-bubble .ql-tooltip{background-color:#444;border-radius:25px;color:#fff}.ql-bubble .ql-tooltip-arrow{border-left:6px solid transparent;border-right:6px solid transparent;content:\" \";display:block;left:50%;margin-left:-6px;position:absolute}.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow{border-bottom:6px solid #444;top:-6px}.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow{border-top:6px solid #444;bottom:-6px}.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor{display:block}.ql-bubble .ql-tooltip.ql-editing .ql-formats{visibility:hidden}.ql-bubble .ql-tooltip-editor{display:none}.ql-bubble .ql-tooltip-editor input[type=text]{background:transparent;border:none;color:#fff;font-size:13px;height:100%;outline:none;padding:10px 20px;position:absolute;width:100%}.ql-bubble .ql-tooltip-editor a{top:10px;position:absolute;right:20px}.ql-bubble .ql-tooltip-editor a:before{color:#ccc;content:\"\\D7\";font-size:16px;font-weight:700}.ql-container.ql-bubble:not(.ql-disabled) a{position:relative;white-space:nowrap}.ql-container.ql-bubble:not(.ql-disabled) a:before{background-color:#444;border-radius:15px;top:-5px;font-size:12px;color:#fff;content:attr(href);font-weight:400;overflow:hidden;padding:5px 15px;text-decoration:none;z-index:1}.ql-container.ql-bubble:not(.ql-disabled) a:after{border-top:6px solid #444;border-left:6px solid transparent;border-right:6px solid transparent;top:0;content:\" \";height:0;width:0}.ql-container.ql-bubble:not(.ql-disabled) a:after,.ql-container.ql-bubble:not(.ql-disabled) a:before{left:0;margin-left:50%;position:absolute;transform:translate(-50%,-100%);transition:visibility 0s ease .2s;visibility:hidden}.ql-container.ql-bubble:not(.ql-disabled) a:hover:after,.ql-container.ql-bubble:not(.ql-disabled) a:hover:before{visibility:visible}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/node_modules/quill/dist/quill.bubble.css"],"names":[],"mappings":"AAAA;;;;;GAKG,AACH,cACE,sBAAuB,AACvB,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,sBAAuB,AACvB,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb,AACD,yDAEE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,2DAEE,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,UAAY,CACb,AACD,mEAEE,WAAY,AACZ,WAAa,CACd,AACD,qFAEE,YAAc,CACf,AACD,iGAEE,YAAc,CACf,AACD,ylBAcE,UAAY,CACb,AACD,0jDA4BE,SAAW,CACZ,AACD,0jDA4BE,WAAa,CACd,AACD,wBACE,uGAEE,UAAY,CACb,AACD,sQAIE,SAAW,CACZ,AACD,sQAIE,WAAa,CACd,CACF,AAID,wBACE,qBAAuB,CACxB,AACD,sBACE,YAAc,CACf,AACD,iDAEE,iBAAmB,CACpB,AACD,uBACE,kBAAmB,AACnB,0BAA4B,CAC7B,AACD,yBACE,eAAgB,AAChB,oBAAsB,CACvB,AACD,+BACE,2BAA6B,CAC9B,AACD,uBACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,6BACE,WAAY,AACZ,WAAY,AACZ,aAAe,CAChB,AACD,sBACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,sBAAuB,AACvB,cAAgB,CACjB,AACD,4BACE,UAAW,AACX,YAAa,AACb,qBAAsB,AACtB,cAAgB,CACjB,AACD,kDAEE,SAAW,CACZ,AACD,qBACE,SAAW,CACZ,AACD,oBACE,iBAAmB,CACpB,AACD,kDAEE,cAAgB,CACjB,AACD,2BACE,UAAa,CACd,AACD,wCACE,YAAc,CACf,AACD,kDACE,cAAgB,CACjB,AACD,mDACE,YAAc,CACf,AACD,yBACE,aAAe,CAChB,AACD,yBACE,eAAiB,CAClB,AACD,yBACE,gBAAkB,CACnB,AACD,yBACE,aAAe,CAChB,AACD,yBACE,eAAkB,CACnB,AACD,yBACE,eAAkB,CACnB,AACD,wBACE,yBAA2B,CAC5B,AACD,iCACE,2BAA4B,AAC5B,kBAAmB,AACnB,eAAgB,AAChB,iBAAmB,CACpB,AACD,qDAEE,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,0BACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,gBAAkB,CACnB,AACD,2BACE,cAAe,AACf,eAAiB,CAClB,AACD,oCACE,yBAA0B,AAC1B,cAAe,AACf,gBAAkB,CACnB,AACD,0BACE,cAAgB,CACjB,AACD,sBACE,WAAY,AACZ,qBAAsB,AACtB,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,qBAAuB,CACxB,AACD,4BACE,eAAgB,AAChB,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,UAAY,CACb,AACD,mCACE,qBAAsB,AACtB,gBAAkB,CACnB,AACD,8BACE,sBAAuB,AACvB,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,8CACE,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,eAAiB,CAClB,AACD,mDACE,WAAY,AACZ,SAAW,CACZ,AACD,4DACE,SAAW,CACZ,AACD,8DACE,WAAa,CACd,AACD,qDACE,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,SAAW,CACZ,AACD,uDAEE,UAAY,CACb,AACD,yFAEE,eAAiB,CAClB,AACD,iGAEE,SAAW,CACZ,AACD,8CACE,aAAiB,CAClB,AACD,2CACE,YAAa,AACb,WAAY,AACZ,eAAiB,CAClB,AACD,+CACE,gBAAiB,AACjB,WAAa,CACd,AACD,4CACE,6BAA8B,AAC9B,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,UAAa,AACb,UAAY,CACb,AACD,qEACE,kBAAmB,AACnB,gBAAiB,AACjB,QAAS,AACT,QAAS,AACT,UAAY,CACb,AACD,2gBAME,wBAA0B,CAC3B,AACD,gCACE,UAAY,CACb,AACD,+GAEE,gBAAkB,CACnB,AACD,+IAEE,mBAAqB,CACtB,AACD,+IAEE,mBAAqB,CACtB,AACD,+IAEE,mBAAqB,CACtB,AACD,+IAEE,mBAAqB,CACtB,AACD,+IAEE,mBAAqB,CACtB,AACD,+IAEE,mBAAqB,CACtB,AACD,uEACE,aAAe,CAChB,AACD,uEACE,eAAiB,CAClB,AACD,uEACE,gBAAkB,CACnB,AACD,uEACE,aAAe,CAChB,AACD,uEACE,eAAkB,CACnB,AACD,uEACE,eAAkB,CACnB,AACD,8BACE,WAAa,CACd,AACD,2GAEE,oBAAsB,CACvB,AACD,+IAEE,eAAiB,CAClB,AACD,uJAEE,mBAAqB,CACtB,AACD,uEACE,yCAA6C,CAC9C,AACD,2EACE,wCAA4C,CAC7C,AACD,8BACE,UAAY,CACb,AACD,2GAEE,gBAAkB,CACnB,AACD,+IAEE,eAAiB,CAClB,AACD,+IAEE,eAAiB,CAClB,AACD,6IAEE,cAAgB,CACjB,AACD,uEACE,cAAgB,CACjB,AACD,uEACE,cAAgB,CACjB,AACD,sEACE,cAAgB,CACjB,AACD,0DACE,qBAAuB,CACxB,AACD,qDACE,qBAAuB,CACxB,AACD,mCACE,qBAAyB,CAC1B,AACD,+CACE,gBAAkB,CACnB,AACD,gCACE,UAAY,CACb,AACD,0GAEE,iBAAmB,CACpB,AACD,uBACE,sBAAuB,AACvB,mBAAoB,AACpB,UAAY,CACb,AACD,6BACE,kCAAmC,AACnC,mCAAoC,AACpC,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uDACE,6BAA8B,AAC9B,QAAU,CACX,AACD,iDACE,0BAA2B,AAC3B,WAAa,CACd,AACD,qDACE,aAAe,CAChB,AACD,8CACE,iBAAmB,CACpB,AACD,8BACE,YAAc,CACf,AACD,+CACE,uBAAwB,AACxB,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,kBAAmB,AACnB,UAAY,CACb,AACD,gCACE,SAAU,AACV,kBAAmB,AACnB,UAAY,CACb,AACD,uCACE,WAAY,AACZ,cAAe,AACf,eAAgB,AAChB,eAAkB,CACnB,AACD,4CACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,mDACE,sBAAuB,AACvB,mBAAoB,AACpB,SAAU,AACV,eAAgB,AAChB,WAAY,AACZ,mBAAoB,AACpB,gBAAoB,AACpB,gBAAiB,AACjB,iBAAkB,AAClB,qBAAsB,AACtB,SAAW,CACZ,AACD,kDACE,0BAA2B,AAC3B,kCAAmC,AACnC,mCAAoC,AACpC,MAAO,AACP,YAAa,AACb,SAAU,AACV,OAAS,CACV,AACD,qGAEE,OAAQ,AACR,gBAAiB,AACjB,kBAAmB,AACnB,gCAAkC,AAClC,kCAAqC,AACrC,iBAAmB,CACpB,AACD,iHAEE,kBAAoB,CACrB","file":"quill.bubble.css","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n.ql-container {\n  box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.ql-bubble.ql-toolbar:after,\n.ql-bubble .ql-toolbar:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-bubble.ql-toolbar button,\n.ql-bubble .ql-toolbar button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  float: left;\n  height: 24px;\n  padding: 3px 5px;\n  width: 28px;\n}\n.ql-bubble.ql-toolbar button svg,\n.ql-bubble .ql-toolbar button svg {\n  float: left;\n  height: 100%;\n}\n.ql-bubble.ql-toolbar button:active:hover,\n.ql-bubble .ql-toolbar button:active:hover {\n  outline: none;\n}\n.ql-bubble.ql-toolbar input.ql-image[type=file],\n.ql-bubble .ql-toolbar input.ql-image[type=file] {\n  display: none;\n}\n.ql-bubble.ql-toolbar button:hover,\n.ql-bubble .ql-toolbar button:hover,\n.ql-bubble.ql-toolbar button:focus,\n.ql-bubble .ql-toolbar button:focus,\n.ql-bubble.ql-toolbar button.ql-active,\n.ql-bubble .ql-toolbar button.ql-active,\n.ql-bubble.ql-toolbar .ql-picker-label:hover,\n.ql-bubble .ql-toolbar .ql-picker-label:hover,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active,\n.ql-bubble.ql-toolbar .ql-picker-item:hover,\n.ql-bubble .ql-toolbar .ql-picker-item:hover,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected {\n  color: #fff;\n}\n.ql-bubble.ql-toolbar button:hover .ql-fill,\n.ql-bubble .ql-toolbar button:hover .ql-fill,\n.ql-bubble.ql-toolbar button:focus .ql-fill,\n.ql-bubble .ql-toolbar button:focus .ql-fill,\n.ql-bubble.ql-toolbar button.ql-active .ql-fill,\n.ql-bubble .ql-toolbar button.ql-active .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n  fill: #fff;\n}\n.ql-bubble.ql-toolbar button:hover .ql-stroke,\n.ql-bubble .ql-toolbar button:hover .ql-stroke,\n.ql-bubble.ql-toolbar button:focus .ql-stroke,\n.ql-bubble .ql-toolbar button:focus .ql-stroke,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar button:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,\n.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n  stroke: #fff;\n}\n@media (pointer: coarse) {\n  .ql-bubble.ql-toolbar button:hover:not(.ql-active),\n  .ql-bubble .ql-toolbar button:hover:not(.ql-active) {\n    color: #ccc;\n  }\n  .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n  .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n  .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n    fill: #ccc;\n  }\n  .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n  .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n  .ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n    stroke: #ccc;\n  }\n}\n.ql-bubble {\n  box-sizing: border-box;\n}\n.ql-bubble * {\n  box-sizing: border-box;\n}\n.ql-bubble .ql-hidden {\n  display: none;\n}\n.ql-bubble .ql-out-bottom,\n.ql-bubble .ql-out-top {\n  visibility: hidden;\n}\n.ql-bubble .ql-tooltip {\n  position: absolute;\n  transform: translateY(10px);\n}\n.ql-bubble .ql-tooltip a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.ql-bubble .ql-tooltip.ql-flip {\n  transform: translateY(-10px);\n}\n.ql-bubble .ql-formats {\n  display: inline-block;\n  vertical-align: middle;\n}\n.ql-bubble .ql-formats:after {\n  clear: both;\n  content: '';\n  display: table;\n}\n.ql-bubble .ql-stroke {\n  fill: none;\n  stroke: #ccc;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n.ql-bubble .ql-stroke-miter {\n  fill: none;\n  stroke: #ccc;\n  stroke-miterlimit: 10;\n  stroke-width: 2;\n}\n.ql-bubble .ql-fill,\n.ql-bubble .ql-stroke.ql-fill {\n  fill: #ccc;\n}\n.ql-bubble .ql-empty {\n  fill: none;\n}\n.ql-bubble .ql-even {\n  fill-rule: evenodd;\n}\n.ql-bubble .ql-thin,\n.ql-bubble .ql-stroke.ql-thin {\n  stroke-width: 1;\n}\n.ql-bubble .ql-transparent {\n  opacity: 0.4;\n}\n.ql-bubble .ql-direction svg:last-child {\n  display: none;\n}\n.ql-bubble .ql-direction.ql-active svg:last-child {\n  display: inline;\n}\n.ql-bubble .ql-direction.ql-active svg:first-child {\n  display: none;\n}\n.ql-bubble .ql-editor h1 {\n  font-size: 2em;\n}\n.ql-bubble .ql-editor h2 {\n  font-size: 1.5em;\n}\n.ql-bubble .ql-editor h3 {\n  font-size: 1.17em;\n}\n.ql-bubble .ql-editor h4 {\n  font-size: 1em;\n}\n.ql-bubble .ql-editor h5 {\n  font-size: 0.83em;\n}\n.ql-bubble .ql-editor h6 {\n  font-size: 0.67em;\n}\n.ql-bubble .ql-editor a {\n  text-decoration: underline;\n}\n.ql-bubble .ql-editor blockquote {\n  border-left: 4px solid #ccc;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding-left: 16px;\n}\n.ql-bubble .ql-editor code,\n.ql-bubble .ql-editor pre {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n.ql-bubble .ql-editor pre {\n  white-space: pre-wrap;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  padding: 5px 10px;\n}\n.ql-bubble .ql-editor code {\n  font-size: 85%;\n  padding: 2px 4px;\n}\n.ql-bubble .ql-editor pre.ql-syntax {\n  background-color: #23241f;\n  color: #f8f8f2;\n  overflow: visible;\n}\n.ql-bubble .ql-editor img {\n  max-width: 100%;\n}\n.ql-bubble .ql-picker {\n  color: #ccc;\n  display: inline-block;\n  float: left;\n  font-size: 14px;\n  font-weight: 500;\n  height: 24px;\n  position: relative;\n  vertical-align: middle;\n}\n.ql-bubble .ql-picker-label {\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  padding-left: 8px;\n  padding-right: 2px;\n  position: relative;\n  width: 100%;\n}\n.ql-bubble .ql-picker-label::before {\n  display: inline-block;\n  line-height: 22px;\n}\n.ql-bubble .ql-picker-options {\n  background-color: #444;\n  display: none;\n  min-width: 100%;\n  padding: 4px 8px;\n  position: absolute;\n  white-space: nowrap;\n}\n.ql-bubble .ql-picker-options .ql-picker-item {\n  cursor: pointer;\n  display: block;\n  padding-bottom: 5px;\n  padding-top: 5px;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label {\n  color: #777;\n  z-index: 2;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n  fill: #777;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n  stroke: #777;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-options {\n  display: block;\n  margin-top: -1px;\n  top: 100%;\n  z-index: 1;\n}\n.ql-bubble .ql-color-picker,\n.ql-bubble .ql-icon-picker {\n  width: 28px;\n}\n.ql-bubble .ql-color-picker .ql-picker-label,\n.ql-bubble .ql-icon-picker .ql-picker-label {\n  padding: 2px 4px;\n}\n.ql-bubble .ql-color-picker .ql-picker-label svg,\n.ql-bubble .ql-icon-picker .ql-picker-label svg {\n  right: 4px;\n}\n.ql-bubble .ql-icon-picker .ql-picker-options {\n  padding: 4px 0px;\n}\n.ql-bubble .ql-icon-picker .ql-picker-item {\n  height: 24px;\n  width: 24px;\n  padding: 2px 4px;\n}\n.ql-bubble .ql-color-picker .ql-picker-options {\n  padding: 3px 5px;\n  width: 152px;\n}\n.ql-bubble .ql-color-picker .ql-picker-item {\n  border: 1px solid transparent;\n  float: left;\n  height: 16px;\n  margin: 2px;\n  padding: 0px;\n  width: 16px;\n}\n.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  top: 50%;\n  width: 18px;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n  content: attr(data-label);\n}\n.ql-bubble .ql-picker.ql-header {\n  width: 98px;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  content: 'Heading 1';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  content: 'Heading 2';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  content: 'Heading 3';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  content: 'Heading 4';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  content: 'Heading 5';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  content: 'Heading 6';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n  font-size: 2em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n  font-size: 1.5em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n  font-size: 1.17em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n  font-size: 1em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n  font-size: 0.83em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n  font-size: 0.67em;\n}\n.ql-bubble .ql-picker.ql-font {\n  width: 108px;\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item::before {\n  content: 'Sans Serif';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  content: 'Serif';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  content: 'Monospace';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-bubble .ql-picker.ql-size {\n  width: 98px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item::before {\n  content: 'Normal';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  content: 'Small';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  content: 'Large';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  content: 'Huge';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n  font-size: 10px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n  font-size: 18px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n  font-size: 32px;\n}\n.ql-bubble .ql-color-picker.ql-background .ql-picker-item {\n  background-color: #fff;\n}\n.ql-bubble .ql-color-picker.ql-color .ql-picker-item {\n  background-color: #000;\n}\n.ql-bubble .ql-toolbar .ql-formats {\n  margin: 8px 12px 8px 0px;\n}\n.ql-bubble .ql-toolbar .ql-formats:first-child {\n  margin-left: 12px;\n}\n.ql-bubble .ql-color-picker svg {\n  margin: 1px;\n}\n.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,\n.ql-bubble .ql-color-picker .ql-picker-item:hover {\n  border-color: #fff;\n}\n.ql-bubble .ql-tooltip {\n  background-color: #444;\n  border-radius: 25px;\n  color: #fff;\n}\n.ql-bubble .ql-tooltip-arrow {\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  content: \" \";\n  display: block;\n  left: 50%;\n  margin-left: -6px;\n  position: absolute;\n}\n.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {\n  border-bottom: 6px solid #444;\n  top: -6px;\n}\n.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {\n  border-top: 6px solid #444;\n  bottom: -6px;\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {\n  display: block;\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-formats {\n  visibility: hidden;\n}\n.ql-bubble .ql-tooltip-editor {\n  display: none;\n}\n.ql-bubble .ql-tooltip-editor input[type=text] {\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  height: 100%;\n  outline: none;\n  padding: 10px 20px;\n  position: absolute;\n  width: 100%;\n}\n.ql-bubble .ql-tooltip-editor a {\n  top: 10px;\n  position: absolute;\n  right: 20px;\n}\n.ql-bubble .ql-tooltip-editor a:before {\n  color: #ccc;\n  content: \"\\D7\";\n  font-size: 16px;\n  font-weight: bold;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a {\n  position: relative;\n  white-space: nowrap;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a::before {\n  background-color: #444;\n  border-radius: 15px;\n  top: -5px;\n  font-size: 12px;\n  color: #fff;\n  content: attr(href);\n  font-weight: normal;\n  overflow: hidden;\n  padding: 5px 15px;\n  text-decoration: none;\n  z-index: 1;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a::after {\n  border-top: 6px solid #444;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  top: 0;\n  content: \" \";\n  height: 0;\n  width: 0;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a::before,\n.ql-container.ql-bubble:not(.ql-disabled) a::after {\n  left: 0;\n  margin-left: 50%;\n  position: absolute;\n  transform: translate(-50%, -100%);\n  transition: visibility 0s ease 200ms;\n  visibility: hidden;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:hover::before,\n.ql-container.ql-bubble:not(.ql-disabled) a:hover::after {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7c89b498", content, true, {});

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".ql-twitter-highlight .ql-editor strong{font-weight:400}.ql-twitter-highlight .ql-editor strong.theme-dark,.theme-dark .ql-twitter-highlight .ql-editor strong{background:#b04c61}.ql-twitter-highlight .ql-editor strong.theme-light,.theme-light .ql-twitter-highlight .ql-editor strong{background:#ffbcc3}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-text-editor.vue"],"names":[],"mappings":"AAIA,wCACE,eAAoB,CACrB,AACD,uGAEI,kBAAoB,CACvB,AACD,yGAEI,kBAAoB,CACvB","file":"le-text-editor.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.ql-twitter-highlight .ql-editor strong {\n  font-weight: normal;\n}\n.ql-twitter-highlight .ql-editor strong.theme-dark,\n  .theme-dark .ql-twitter-highlight .ql-editor strong {\n    background: #B04C61;\n}\n.ql-twitter-highlight .ql-editor strong.theme-light,\n  .theme-light .ql-twitter-highlight .ql-editor strong {\n    background: #FFBCC3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(545)
var ieee754 = __webpack_require__(546)
var isArray = __webpack_require__(547)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 547 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Clipboard = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import('modules/clipboard');
var Delta = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import('delta');

var ExtendedClipboard = function (_Clipboard) {
  _inherits(ExtendedClipboard, _Clipboard);

  function ExtendedClipboard() {
    _classCallCheck(this, ExtendedClipboard);

    return _possibleConstructorReturn(this, (ExtendedClipboard.__proto__ || Object.getPrototypeOf(ExtendedClipboard)).apply(this, arguments));
  }

  _createClass(ExtendedClipboard, [{
    key: 'initialOnPaste',
    value: function initialOnPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;

      var range = this.quill.getSelection();
      var delta = new Delta().retain(range.index);

      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(__WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, __WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.USER);

        _this2.quill.setSelection(delta.length() - range.length, __WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'onPaste',
    value: function onPaste(event) {
      var pastedEvent = ExtendedClipboard.getPastedEvent(event);
      this.quill.container.dispatchEvent(pastedEvent);
      this.initialOnPaste(event);
    }
  }], [{
    key: 'getPastedEvent',
    value: function getPastedEvent(event) {
      var pastedEvent = void 0;
      if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isFunction"])(window.CustomEvent)) {
          pastedEvent = new CustomEvent('pasted', { detail: event });
        } else {
        pastedEvent = document.createEvent('Event');
        pastedEvent.initEvent('pasted', true, true);
        pastedEvent.detail = event;
      }
      return pastedEvent;
    }
  }]);

  return ExtendedClipboard;
}(Clipboard);

/* harmony default export */ __webpack_exports__["a"] = (ExtendedClipboard);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LeQuillLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lp_html_sanitizer_src_HtmlSanitizerUtils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lp_html_sanitizer_src_HtmlSanitizerUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lp_html_sanitizer_src_HtmlSanitizerUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts_consts__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_quill_link_scss__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__le_quill_link_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__le_quill_link_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Inline = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import('blots/inline');

var prefixes = {
  HTTP: 'http://',
  HTTPS: 'https://',
  FTP: 'ftp://',
  MAILTO: 'mailto:'
};

var LeQuillLink = function (_Inline) {
  _inherits(LeQuillLink, _Inline);

  function LeQuillLink() {
    _classCallCheck(this, LeQuillLink);

    return _possibleConstructorReturn(this, (LeQuillLink.__proto__ || Object.getPrototypeOf(LeQuillLink)).apply(this, arguments));
  }

  _createClass(LeQuillLink, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value || !Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(value)) {
        _get(LeQuillLink.prototype.__proto__ || Object.getPrototypeOf(LeQuillLink.prototype), 'format', this).call(this, name, value);
      } else {
        var sanitizedValue = LeQuillLink.sanitize(value[0]);
        if (!LeQuillLink.hasPrefix(sanitizedValue)) {
          sanitizedValue = LeQuillLink.appendPrefix(sanitizedValue);
        }
        this.domNode.setAttribute('href', sanitizedValue);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(LeQuillLink.__proto__ || Object.getPrototypeOf(LeQuillLink), 'create', this).call(this, value);

      var sanitizedValue = this.sanitize(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(value) && value[0]);

      if (!this.hasPrefix(sanitizedValue)) {
        sanitizedValue = this.appendPrefix(sanitizedValue);
      }

      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      node.setAttribute('href', sanitizedValue);
      node.classList.add('le-quill-link');
      return node;
    }
  }, {
    key: 'sanitize',
    value: function sanitize(str) {
      return __WEBPACK_IMPORTED_MODULE_2_lp_html_sanitizer_src_HtmlSanitizerUtils___default.a.sanitizeHtml(str).cleanText;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return [domNode.getAttribute('href')];
    }
  }, {
    key: 'hasPrefix',
    value: function hasPrefix(value) {
      var lowerValue = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["toLower"])(value);
      return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["some"])(prefixes, function (prefix) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["startsWith"])(lowerValue, prefix);
      });
    }
  }, {
    key: 'appendPrefix',
    value: function appendPrefix(value) {
      return '' + prefixes.HTTP + value;
    }
  }]);

  return LeQuillLink;
}(Inline);

LeQuillLink.blotName = __WEBPACK_IMPORTED_MODULE_3__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK;
LeQuillLink.tagName = 'a';



/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(551);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ffe64cfa", content, true, {});

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-quill-link{text-decoration:underline}.le-quill-link.theme-dark,.theme-dark .le-quill-link{color:#43c6f4}.le-quill-link.theme-light,.theme-light .le-quill-link{color:#2e59da}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-link-editor/src/components/vue-components/le-text-editor/le-link-editor/_le-quill-link.scss","/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-link-editor/src/sass/palettes/_dark.scss","/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-link-editor/src/sass/palettes/_light.scss"],"names":[],"mappings":"AAwWA,eAIE,yBAA0B,CAC3B,AAhOO,qDA6NJ,aCxVgB,CDsIX,AAXD,uDA6NJ,aEtWgB,CFoJX","file":"_le-quill-link.scss","sourcesContent":["$font-family-Roboto: Roboto;\n\n/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n\n$color-white: #ffffff;\n$color-gray-f2: #f2f2f2;\n$color-gray-dd: #dddddd;\n$color-gray-cc: #cccccc;\n$color-gray-88: #888888;\n$color-gray-66: #666666;\n$color-gray-52: #525355;\n$color-gray-32: #323436;\n$color-gray-76: #767678;\n$color-gray-b1: #b1b1b1;\n$color-black: #000000;\n\n$color-green-8b: #8bbb4b;\n$color-red-ed: #ed1c24;\n$color-red-ff: #ff7a7a;\n$color-blue-4b: #4b91b9;\n$color-blue-58: #5879da;\n$color-blue-5d: #5daedc;\n$color-blue-bb: #bbecfb;\n\n$color-orange-f5: #f5a623;\n$color-orange-de: #de961e;\n$color-orange-d1: #d1880e;\n\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n\n$icon-size-small: 4px;\n\n$font-size-xxxsmall: 9px;\n$font-size-xxsmall: 10px;\n$font-size-xsmall: 11px;\n$font-size-small: 12px;\n$font-size-medium: 13px;\n$font-size-large: 14px;\n$font-size-xlarge: 15px;\n$font-size-xxlarge: 16px;\n\n$palettes: () !default;\n$themes: () !default;\n$colorsMap: () !default;\n$sizesMap: () !default;\n$attrsMap: () !default;\n\n@mixin ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@mixin disable-user-select() {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n@mixin transform-translateZ($x) {\n  -webkit-transform: translateZ($x);\n  -ms-transform: translateZ($x);\n  transform: translateZ($x);\n}\n\n@mixin transform-rotate($x) {\n  -webkit-transform: rotate($x);\n  -ms-transform: rotate($x);\n  transform: rotate($x);\n}\n\n@mixin a11y-focus-outline() {\n  outline: none !important;\n  @include themify(null, 'show-a11y-focus-outline') {\n      box-shadow: inset 0 0 0 2px getColor('a11yFocusIndicator') !important;\n  }\n}\n\n@mixin a11y-visually-hidden() {\n  position: absolute;\n  clip: rect(0 0 0 0);\n  border: 0;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n}\n\n@mixin themify($specific-theme:null, $conditionalClass:null) {\n  @if ($specific-theme) {\n    $themeValues: map-get($themes, $specific-theme);\n    @if ($conditionalClass) {\n      &.theme-#{$specific-theme}.#{$conditionalClass},\n      .theme-#{$specific-theme}.#{$conditionalClass} & {\n        $colorsMap: map-get($themeValues, 'colors') !global;\n        $sizesMap: map-get($themeValues, 'sizes') !global;\n        $attrsMap: map-get($themeValues, 'attrs') !global;\n\n        @content;\n\n        $colorsMap: () !global;\n        $sizesMap: () !global;\n        $attrsMap: () !global;\n      }\n    }\n    @else {\n      &.theme-#{$specific-theme},\n      .theme-#{$specific-theme} & {\n        $colorsMap: map-get($themeValues, 'colors') !global;\n        $sizesMap: map-get($themeValues, 'sizes') !global;\n        $attrsMap: map-get($themeValues, 'attrs') !global;\n\n        @content;\n\n        $colorsMap: () !global;\n        $sizesMap: () !global;\n        $attrsMap: () !global;\n      }\n    }\n  }\n  @else {\n    @each $theme, $themeValues in $themes {\n      @if ($conditionalClass) {\n        &.theme-#{$theme}.#{$conditionalClass},\n        .theme-#{$theme}.#{$conditionalClass} & {\n          $colorsMap: map-get($themeValues, 'colors') !global;\n          $sizesMap: map-get($themeValues, 'sizes') !global;\n          $attrsMap: map-get($themeValues, 'attrs') !global;\n\n          @content;\n\n          $colorsMap: () !global;\n          $sizesMap: () !global;\n          $attrsMap: () !global;\n        }\n      }\n      @else {\n        &.theme-#{$theme},\n        .theme-#{$theme} & {\n          $colorsMap: map-get($themeValues, 'colors') !global;\n          $sizesMap: map-get($themeValues, 'sizes') !global;\n          $attrsMap: map-get($themeValues, 'attrs') !global;\n\n          @content;\n\n          $colorsMap: () !global;\n          $sizesMap: () !global;\n          $attrsMap: () !global;\n        }\n      }\n    }\n  }\n}\n\n@mixin addTheme($themeName, $themeValues) {\n  @include addPrivateTheme('self', $themeName, $themeValues);\n}\n\n@mixin addPrivateTheme($moduleName, $themeName, $themeValues) {\n  $moduleThemeColors: map-get($themeValues, 'colors');\n  $moduleThemeSizes: map-get($themeValues, 'sizes');\n  $moduleThemeAttrs: map-get($themeValues, 'attrs');\n\n  @if (not map-has-key($themes, $themeName)) {\n    $emptyTheme: ('colors':(), 'sizes':(), 'attrs':());\n    $themes: map-merge($themes, ($themeName: $emptyTheme)) !global;\n  }\n\n  $currentThemeColors: map-get(map-get($themes, $themeName), 'colors');\n  $currentThemeSizes: map-get(map-get($themes, $themeName), 'sizes');\n  $currentThemeAttrs: map-get(map-get($themes, $themeName), 'attrs');\n\n  $newThemeColors: map-merge($currentThemeColors, ($moduleName: $moduleThemeColors));\n  $newThemeSizes: map-merge($currentThemeSizes, ($moduleName: $moduleThemeSizes));\n  $newThemeAttrs: map-merge($currentThemeAttrs, ($moduleName: $moduleThemeAttrs));\n\n  $newThemeValues: ('colors': $newThemeColors, 'sizes': $newThemeSizes, 'attrs': $newThemeAttrs);\n\n  $themes: map-merge($themes, ($themeName: $newThemeValues)) !global;\n}\n\n\n@function getColor($colorName, $moduleName:'self') {\n  @if (map-has-key($colorsMap, $moduleName)) {\n    @return map-get(map-get($colorsMap, $moduleName), $colorName);\n  }\n  @else {\n    @return #ff0000; // return red as a default error\n  }\n}\n\n@function getSize($sizeName, $moduleName:'self') {\n  @if (map-has-key($sizesMap, $moduleName)) {\n    @return map-get(map-get($sizesMap, $moduleName), $sizeName);\n  }\n  @else {\n    @return 13px; // return 13px as a default error\n  }\n}\n\n@function getAttr($attrName, $moduleName:'self') {\n  @if (map-has-key($attrsMap, $moduleName)) {\n    @return map-get(map-get($attrsMap, $moduleName), $attrName);\n  }\n  @else {\n    @return ''; // return empty string as default error\n  }\n}\n\n@function getImagePath($pathToRoot, $imageName, $img-folder: \"/assets/img/\") {\n  @if ($imageName) {\n    @return quote($pathToRoot + $img-folder + $imageName);\n  }\n  @else {\n    @return quote('');\n  }\n}\n\n@mixin registerSwitcherImage($moduleSelector, $attrImageRegular, $attrImageSelected , $namespaceName, $imageFolderPath) {\n  $moduleSelectorRes: '.switcher-' + $moduleSelector;\n  .le {\n    @include themify {\n      $getImagePathReg: getAttr($attrImageRegular, $namespaceName);\n      $getImagePathSelected: getAttr($attrImageSelected, $namespaceName);\n      #{$moduleSelectorRes} {\n        &:before {\n          background: url(quote($imageFolderPath + $getImagePathSelected)) + ' 0 0 no-repeat';\n          visibility: hidden;\n          height: 0;\n          content: '';\n        };\n        .switcher-item {\n          .icon {\n            background: url(quote($imageFolderPath + $getImagePathReg)) + ' 0 0 no-repeat';\n          }\n        }\n        &.active {\n          .switcher-item {\n            .icon {\n              background: url(quote($imageFolderPath + $getImagePathSelected)) + ' 0 0 no-repeat';\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n\n@mixin addPalette($paletteName, $paletteColors) {\n  $palettes: map-merge($palettes, ($paletteName: $paletteColors)) !global;\n}\n\n@function getPaletteColor($paletteName, $colorName) {\n  @return map-get(map-get($palettes, $paletteName), $colorName);\n}\n\n@function getThemeColor($themeName, $colorName) {\n  $theme: map-get($themes, $themeName);\n  $colors: map-get($theme, 'colors');\n\n  @return map-get($colors, $colorName);\n}\n\n@mixin table-border($direction) {\n  $separatedDirection: $direction;\n  @if ($direction) {\n    @if (not str-index($direction, '-')) {\n      $separatedDirection: '-' + $direction;\n    }\n  }\n  @include themify {\n    border#{$separatedDirection}: 1px solid getColor('tableBorder');\n  }\n}\n\n@mixin add-scrollbar($moduleSelector) {\n  #{$moduleSelector} {\n    * {\n      @include themify {\n        // IE\n        scrollbar-track-color: getColor('scrollbarTrack');\n        scrollbar-base-color: getColor('scrollbarThumb');\n        scrollbar-arrow-color: getColor('scrollbarTrack');\n        scrollbar-shadow-color: getColor('scrollbarTrack');\n        scrollbar-dark-shadow-color: getColor('scrollbarTrack');\n        scrollbar-3dlight-color: getColor('scrollbarTrack');\n        scrollbar-highlight-color: getColor('scrollbarTrack');\n        // FF\n        scrollbar-color: getColor('scrollbarThumb') getColor('scrollbarTrack');\n        scrollbar-width: thin;\n        // chrome safari\n        &::-webkit-scrollbar-track,\n        &::-webkit-scrollbar-corner {\n          background-color: getColor('scrollbarTrack');\n        }\n        &::-webkit-scrollbar-thumb {\n          background-color: getColor('scrollbarThumb');\n          border: 4.7px solid transparent;\n          border-radius: 9px;\n          background-clip: content-box;\n        }\n        &::-webkit-scrollbar {\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n@mixin font-smoothing($value: antialiased) {\n  @if $value == antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  @else {\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n  }\n}\n\n@mixin add-antialiased($moduleSelector) {\n  #{$moduleSelector} {\n    * {\n      @include font-smoothing(antialiased);\n    }\n  }\n}\n\n@mixin rm-default-button-style() {\n  background: none;\n  color: inherit;\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  padding: 0;\n}\n\n@import \"../../../../sass/palettes/dark\";\n@import \"../../../../sass/palettes/light\";\n\n\n\n\n\n\n@import \"../../../../sass/themes/dark\";\n@import \"../../../../sass/themes/light\";\n\n\n\n\n\n\n.le-quill-link{\n  @include themify {\n    color: getColor('link');\n  }\n  text-decoration: underline;\n}\n","@include addPalette('dark', (\n  'blue-00': #00577C,\n  'blue-03': #03002f,\n  'blue-09': #090c43,\n  'blue-0c': #0c1033,\n  'blue-0d': #0d1149,\n  'blue-13': #131952,\n  'blue-14': #141a42,\n  'blue-1d2': #1D2E87,\n  'blue-1d5': #1D5287,\n  'blue-2b': #2B4862,\n  'blue-2c': #2c3249,\n  'blue-2d': #2d3162,\n  'blue-2db': #2DBAE6,\n  'blue-30': #30437e,\n  'blue-32': #0c5de6, // updated for a11y\n  'blue-34': #349ec3,\n  'blue-3f': #3f5b92,\n  'blue-43': #43c6f4,\n  'blue-46': #4661ae,\n  'blue-47': #474a6a,\n  'blue-4b': #4b91b9,\n  'blue-52': #52c7ef,\n  'blue-53': #535677,\n  'blue-56': #56597a,\n  'blue-58': #5879da,\n  'blue-59': #595a80,\n  'blue-597': #5970AB,\n  'blue-5b': #5b667c,\n  'blue-63': #63627a,\n  'blue-65': #656a7a,\n  'blue-8b': #8BA3EA,\n  'blue-b1': #b1b5bc,\n  'blue-b8': #b8bfd4,\n  'blue-c9': #C9D3F3,\n  'blue-e6': #e6e8ed,\n  'blue-f3': #f3f6ff,\n  'black': #000000,\n  'gray-32': #323436,\n  'gray-33': #333333,\n  'gray-66': #666666,\n  'gray-75': #757575,\n  'gray-88': #888888,\n  'gray-a7': #A7ACBE,\n  'gray-a9': #a9afba,\n  'gray-b1': #b1b1b1,\n  'gray-bb': #bbc0c9,\n  'gray-bd': #bdc4dc,\n  'gray-ce': #ced4de,\n  'gray-c5': #c5c5c5,\n  'gray-cc': #cccccc,\n  'gray-d8': #d8d8d8,\n  'gray-dd': #dddddd,\n  'gray-f1': #f1f1f1,\n  'gray-f2': #f2f2f2,\n  'gray-f3': #f3f6ff,\n  'gray-f4': #f4f4f4,\n  'gray-fc': #fcfcfd,\n  'gray-f9': #f9f9f9,\n  'gray-9b': #9b9b9b,\n  'gray-db': #DBDCE1,\n  'white': #ffffff,\n  'red-dd': #dd1f27,\n  'red-e8': #e85851,\n  'red-ff': #ff1820,\n  'green-13': #135C5F,\n  'green-16': #164D51,\n  'green-98': #98c002,\n  'green-52': #525402,\n  'green-2b': #2B5C04,\n  'green-37': #375240,\n  'orange-81': #813418,\n  'orange-a6': #A64401,\n  'orange-c1': #C1570A,\n  'orange-fb': #fb6500,\n  'orange-db': #db3b00,\n  'orange-f5': #f5a623,\n  'orange-f6': #f6720e,\n  'orange-9a': #9a4709,\n  'orange-99': #993800,\n  'purple-54': #542658,\n  'purple-58': #584580,\n  'purple-6b': #6B1D87,\n  'purple-84': #8493d6,\n  'purple-87': #871D69,\n  'purple-88': #8894bc,\n  'brown-7d': #7D5231,\n  'brown-63': #634127,\n  'purple-68': #687092,\n  'brown-6f': #6F513B,\n  'brown-85': #854618,\n  'yellow-dc': #dcbb0d,\n  'pink-b0': #B04C61,\n  'gray-2A2B2E': #2A2B2E,\n  'green-7D9E1A': #7D9E1A,\n  'red-EF6161': #EF6161,\n  'red-70': #700A0A,\n  'red-85': #850040,\n  'red-8a': #8A3444,\n  'periwinkle-39': #3955a7,\n  'periwinkle-46': #4667C8,\n));\n\n\n","@include addPalette('light', (\n  'blue-0d': #0d1149,\n  'blue-ad': #ADC6D6,\n  'blue-13': #131952,\n  'blue-2e': #2e59da,\n  'blue-30': #30437e,\n  'blue-32': #0c5de6, // changed for a11y\n  'blue-34': #349ec3,\n  'blue-3f': #3f5b92,\n  'blue-46': #4661ae,\n  'blue-4a': #4a90e2,\n  'blue-43-a11y': #0c5de6,\n  'blue-52': #52c7ef,\n  'blue-58': #4661ae, /* was #5879da - changed due to a11y */\n  'blue-5b': #5b667c,\n  'blue-b8': #b8bfd4,\n  'blue-e6': #e6e8ed,\n  'blue-e6eb': #e6ebf5,\n  'blue-e3': #e3e9f9,\n  'blue-d0': #d0d9f2,\n  'blue-ed': #edf2f8,\n  'blue-ec': #ecf2f8,\n  'blue-4b': #4b91b9,\n  'blue-07': #070a3a,\n  'blue-03': #03002f,\n  'blue-06': #060736,\n  'blue-0b': #0b9fcd,\n  'blue-8b': #8BA3EA,\n  'blue-c7': #C7D4E9,\n  'blue-c9': #C9D3F3,\n  'blue-1d': #1D2553,\n  'blue-16': #161c4f,\n  'blue-56': #56597a,\n  'blue-597': #5970AB,\n  'blue-40': #4061AB,\n  'black': #000000,\n  'gray-34': #34363B,\n  'gray-49': #494B51,\n  'gray-65': #656a7a,\n  'gray-66': #666666,\n  'gray-75': #757575,\n  'gray-88': #888888,\n  'gray-8c8': #8C8D8F,\n  'gray-97': #97a0a8,\n  'gray-8c': #8c9097,\n  'gray-9b': #9b9b9b,\n  'gray-b1': #b1b1b1,\n  'gray-a0': #A0A0A0,\n  'gray-a3': #A3B0BF,\n  'gray-a9': #a9afba,\n  'gray-bd': #bdc4dc,\n  'gray-cc': #cccccc,\n  'gray-c3': #c3c3c3,\n  'gray-dd': #dddddd,\n  'gray-e5': #e5e5e5,\n  'gray-e6': #e6ebf5,\n  'gray-eb': #ebecef,\n  'gray-f2': #f2f2f2,\n  'gray-f3': #f3f6ff,\n  'gray-f9': #f9f9f9,\n  'gray-fe': #fefeff,\n  'white': #ffffff,\n  'white-f8': #F8FBFF,\n  'red-ed': #ed1c24,\n  'gray-32': #323436,\n  'gray-33': #333333,\n  'gray-39': #39393d,\n  'gray-bb': #bbc0c9,\n  'gray-c4': #C4C4C4,\n  'gray-c5': #c5c5c5,\n  'gray-d8': #d8d8d8,\n  'gray-f1': #f1f1f1,\n  'gray-f4': #f4f4f4,\n  'gray-fc': #fcfcfd,\n  'gray-6f': #6F737C,\n  'gray-0A': #0A0A0A,\n  'red-dd': #dd1f27,\n  'red-d0': #d0021b,\n  'red-e7': #e79a7e,\n  'red-e8': #e85851,\n  'red-ff': #ff7a7a,\n  'green-98': #98c002,\n  'green-a3': #A3B79E,\n  'green-a7': #A7B4B3,\n  'green-b2': #B2B49D,\n  'orange-9a': #9a4709,\n  'green-9b': #9BB7BF,\n  'green-9c': #9CB2B9,\n  'orange-a6': #A64401,\n  'orange-c1': #C1570A,\n  'orange-fb': #fb6500,\n  'blue-09': #090c43,\n  'blue-76': #7691DE,\n  'blue-bc': #BCC9F0,\n  'orange-db': #db3b00,\n  'orange-f5': #f5a623,\n  'orange-f6': #f6720e,\n  'purple-9e': #9EA7CD,\n  'purple-bb': #BBA1CD,\n  'purple-b2': #B2A4BC,\n  'purple-b3': #B3AFCA,\n  'purple-c4a': #C4A1C2,\n  'purple-c49': #C496B3,\n  'purple-68': #687092,\n  'purple-84': #8493d6,\n  'purple-88': #8894bc,\n  'burple-c5': #C5A9B4,\n  'brown-7d': #7D5231,\n  'brown-63': #634127,\n  'brown-bc': #BC9AA0,\n  'brown-cb': #CBAB9C,\n  'brown-c4': #C4B0A5,\n  'brown-e6': #E6CDBB,\n  'pink-ff': #FFBCC3,\n  'periwinkle-39': #3955a7,\n  'periwinkle-46': #4667C8,\n));\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts_consts__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var DEFAULT = {
  paste: true,
  type: true
};

var URL_REGEXP = new RegExp(__WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].URL_REGEXP, 'gi');
var PREFIX = new RegExp('(?:\\s|^)' + __WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].URL_REGEXP, 'i');

function onPaste(quill) {
  quill.clipboard.addMatcher(Node.TEXT_NODE, function (node, delta) {
    if (typeof node.data !== 'string') {
      return;
    }
    var matches = node.data.match(URL_REGEXP);
    if (matches && matches.length > 0) {
      var ops = [];
      var str = node.data;
      matches.forEach(function (match) {
        var split = str.split(match);
        var before = split.shift();
        ops.push({ insert: before });
        var attributes = {};
        attributes[__WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK] = [match];
        ops.push({ insert: match, attributes: attributes });
        str = split.join(match);
      });
      ops.push({ insert: str });

      delta.ops = ops;
    }

    return delta;
  });
}

var lastWhitespaceSlice = function lastWhitespaceSlice(str) {
  var lastWhitespaceIndex = str.lastIndexOf(' ');
  var piece = lastWhitespaceIndex === -1 ? 0 : lastWhitespaceIndex + 1;
  return str.slice(piece);
};

function onTyping(quill) {
  quill.keyboard.addBinding({
    collapsed: true,
    key: ' ',
    prefix: PREFIX,
    handler: function handler(range, context) {
      var url = lastWhitespaceSlice(context.prefix);
      var retain = range.index - url.length;
      var ops = retain ? [{ retain: retain }] : [];
      var attributes = {};
      attributes[__WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK] = [url];
      ops.push({ delete: url.length }, { insert: url, attributes: attributes });
      quill.updateContents({ ops: ops });
      return true;
    }
  });
}

function onSpace(quill) {
  quill.keyboard.addBinding({
    key: ' ',
    handler: function handler(range, context) {
      if (!context.suffix) {
        quill.format(__WEBPACK_IMPORTED_MODULE_0__consts_consts__["a" /* default */].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_LINK, false);
      }

      return true;
    }
  });
}

var LeLinkListeners = function LeLinkListeners(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, LeLinkListeners);

  var opts = _extends({}, DEFAULT, options);

  if (opts.type) {
    onTyping(quill);
  }
  if (opts.paste) {
    onPaste(quill);
  }

  onSpace(quill);
};

/* harmony default export */ __webpack_exports__["a"] = (LeLinkListeners);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Models_LeQuillAutocompleteTriggerOptionsModel__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__le_quill_autocomplete__ = __webpack_require__(291);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var vowelsIndex = 'aeiou';

var isVowel = function isVowel(char) {
  return char.length === 1 && vowelsIndex.indexOf(char) >= 0;
};

var getOpenAutocompleteLeaf = function getOpenAutocompleteLeaf(quill) {
  var res = null;
  var autocompleteNode = quill.container.querySelector('.' + __WEBPACK_IMPORTED_MODULE_5__le_quill_autocomplete__["b" /* LE_QUILL_AUTOCOMPLETE_CLASS_NAME */]);
  if (autocompleteNode) {
    res = __WEBPACK_IMPORTED_MODULE_1_quill___default.a.find(autocompleteNode);
  }
  return res;
};

var isAutocompleteDisplayed = function isAutocompleteDisplayed(quill) {
  return getOpenAutocompleteLeaf(quill) !== null;
};

var getOverlap = function getOverlap(input, autocomplete) {
  var trimmedInput = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(input);
  if (!trimmedInput || !autocomplete || autocomplete.length === 0) {
    return '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"])(input, ' \n')) {
    trimmedInput = trimmedInput + ' ';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"])(trimmedInput, ' ' + autocomplete)) {
      return autocomplete;
    }

  return getOverlap(input, autocomplete.substring(0, autocomplete.length - 1));
};

var getIsCursorAtValidPosition = function getIsCursorAtValidPosition(quill) {
  var res = false;
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(quill.getSelection(), 'index');
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(index)) {
    var prefix = quill.getText(0, index).replace(/ /g, '');
    var suffix = quill.getText(index, quill.getLength());
    res = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(suffix).length === 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"])(prefix, '\n');
  }
  return res;
};

var removeLeaf = function removeLeaf(leaf) {
  if (leaf) {
    leaf.remove();
  }
};

var LeQuillAutocompleteModule = function () {
  function LeQuillAutocompleteModule(quill, settings) {
    _classCallCheck(this, LeQuillAutocompleteModule);

    if (!settings || !settings.fetchAutocompleteAsync || !settings.triggerOptions || !settings.selectKeys) {
      console.error('[LeQuillAutocomplete]: You should provide settings for autocomplete.');
    } else {
      this.quill = quill;
      this.fetchAutocompleteAsync = settings.fetchAutocompleteAsync;
      this.isDefaultApi = settings.isDefaultApi;
      this.sendFeedbackDefaultApiAsync = settings.sendFeedbackDefaultApiAsync;
      this.triggerOptions = settings.triggerOptions;
      this.selectKeys = settings.selectKeys;
      this.cache = [];
      this.maxCacheSize = settings.maxCacheSize;
      this.smartComposeSelectedKeyFeedback = settings.smartComposeSelectedKeyFeedback;

      this.initBindings();
    }
  }

  _createClass(LeQuillAutocompleteModule, [{
    key: 'initBindings',
    value: function initBindings() {
      var _this = this;

      var quill = this.quill;


      quill.root.addEventListener('keydown', function (event) {
        if (isAutocompleteDisplayed(quill)) {
          _this.handleKeyboardEventWhenAutocompleteIsDisplayed(event);
        }
      });

      quill.root.addEventListener('keyup', function (event) {
        if (quill.getLength() > 3 && !event.metaKey && !event.ctrlKey) {
            _this.handleKeyboardEventWhenAutocompleteIsNotExists(event);
          }
      });

      quill.on('selection-change', function (range) {
        _this.handleSelectionChange(range);
      });

      quill.on('text-change', function () {
        _this.handleTextChange();
      });
    }
  }, {
    key: 'addToCache',
    value: function addToCache(autocomplete) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(autocomplete, 'text')) {
        var existingAutocompleteIndex = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["findIndex"])(this.cache, function (cachedAutocomplete) {
          return cachedAutocomplete.text === autocomplete.text;
        });
        if (existingAutocompleteIndex > -1) {
          this.cache.splice(existingAutocompleteIndex, 1);
        }
        this.cache.push(autocomplete);

        this.cache = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["takeRight"])(this.cache, this.maxCacheSize);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this.cache = [];
    }
  }, {
    key: 'markDisplayed',
    value: function markDisplayed(autocomplete) {
      if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(autocomplete, 'text')) {
        var existingAutocompleteIndex = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["findIndex"])(this.cache, function (cachedAutocomplete) {
          return cachedAutocomplete.id === autocomplete.id;
        });
        if (existingAutocompleteIndex > -1) {
          var foundAutocomplete = this.cache[existingAutocompleteIndex];
          this.cache.splice(existingAutocompleteIndex, 1, _extends({}, foundAutocomplete, {
            wasDisplayed: true
          }));
        }
      }
    }
  }, {
    key: 'getFromCache',
    value: function getFromCache() {
      var input = this.quill.getText();
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["findLast"])(this.cache, function (autocomplete) {
        var res = false;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["includes"])(input, autocomplete.text)) {
          var overlapLength = getOverlap(input, autocomplete.text).length;
          res = overlapLength > 0 && overlapLength !== autocomplete.text.length;
        }
        return res;
      });
    }
  }, {
    key: 'handleSelectionChange',
    value: function handleSelectionChange(range) {
      var isCursorAtValidPosition = getIsCursorAtValidPosition(this.quill);

      if (!range || range.length > 0 || !isCursorAtValidPosition) {
        var autocompleteLeaf = getOpenAutocompleteLeaf(this.quill);
        removeLeaf(autocompleteLeaf);
      } else if (range.length === 0) {
        this.insertAutocomplete();
      }
    }
  }, {
    key: 'handleKeyboardEventWhenAutocompleteIsDisplayed',
    value: function handleKeyboardEventWhenAutocompleteIsDisplayed(event) {
      var selectKey = void 0;
      if (this.selectKeys.tab && (event.key === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEYBOARD_KEYS.TAB || event.keyCode === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEY_CODES.TAB)) {
        selectKey = __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__["a" /* SELECT_KEYS */].TAB;
      } else if (this.selectKeys.arrowRight && (event.key === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEYBOARD_KEYS.ARROW_RIGHT || event.keyCode === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEY_CODES.ARROW_RIGHT)) {
        selectKey = __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__["a" /* SELECT_KEYS */].ARROW_RIGHT;
      }

      if (selectKey) {
        var id = getOpenAutocompleteLeaf(this.quill).domNode.getAttribute(__WEBPACK_IMPORTED_MODULE_5__le_quill_autocomplete__["a" /* LE_QUILL_AUTOCOMPLETE_ATTRIBUTES */].ID);
        this.handleAutocompleteSelected({ selectKey: selectKey, id: id });
        event.preventDefault();
        if (this.isDefaultApi) {
          this.sendFeedbackDefaultApiAsync({ id: id });
        }
      }
    }
  }, {
    key: 'handleKeyboardEventWhenAutocompleteIsNotExists',
    value: function handleKeyboardEventWhenAutocompleteIsNotExists(event) {
      if (getIsCursorAtValidPosition(this.quill)) {
        var triggeredBy = void 0;
        if (this.triggerOptions.space && (event.key === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEYBOARD_KEYS.SPACE || event.keyCode === __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].KEY_CODES.SPACE)) {
          triggeredBy = __WEBPACK_IMPORTED_MODULE_3__Models_LeQuillAutocompleteTriggerOptionsModel__["a" /* TRIGGER_OPTIONS */].SPACE;
        } else if (this.triggerOptions.vowels) {
          var char = event.key || String.fromCharCode(event.keyCode || '').toLowerCase();
          if (isVowel(char)) {
            triggeredBy = __WEBPACK_IMPORTED_MODULE_3__Models_LeQuillAutocompleteTriggerOptionsModel__["a" /* TRIGGER_OPTIONS */].VOWELS;
          }
        }

        if (triggeredBy) {
          this.handleTriggeredBy({ triggeredBy: triggeredBy });
        }
      }
    }
  }, {
    key: 'handleTextChange',
    value: function handleTextChange() {
      var autocompleteLeaf = getOpenAutocompleteLeaf(this.quill);
      var input = this.quill.getText();
      if (autocompleteLeaf) {
        var initialAutocompleteValue = autocompleteLeaf.domNode.getAttribute(__WEBPACK_IMPORTED_MODULE_5__le_quill_autocomplete__["a" /* LE_QUILL_AUTOCOMPLETE_ATTRIBUTES */].INITIAL_VALUE);
        var overlap = getOverlap(input, initialAutocompleteValue);
        if (!overlap || !autocompleteLeaf.prev) {
          setTimeout(function () {
            return removeLeaf(autocompleteLeaf);
          }, 0);
        } else {
          autocompleteLeaf.updateText(initialAutocompleteValue.replace(overlap, ''));
        }
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(input)) {
        this.clearCache();
      }
    }
  }, {
    key: 'handleAutocompleteSelected',
    value: function handleAutocompleteSelected(_ref) {
      var selectKey = _ref.selectKey,
          id = _ref.id;

      var openAutocompleteLeaf = getOpenAutocompleteLeaf(this.quill);
      var index = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.quill.getSelection(), 'index');
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(index) && openAutocompleteLeaf) {
        var text = openAutocompleteLeaf.domNode.getElementsByTagName('span')[0].textContent;
        removeLeaf(openAutocompleteLeaf);
        var hasSpaceAtTheEnd = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.quill.getContents(index, 1), 'ops[0].insert') === ' ';
        this.quill.insertText(index - (selectKey === __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__["a" /* SELECT_KEYS */].ARROW_RIGHT ? 1 : 0), hasSpaceAtTheEnd ? ' ' + text : text);
        var triggeredBy = void 0;
        if (!this.smartComposeSelectedKeyFeedback || this.isDefaultApi) {
          if (this.triggerOptions.tab && selectKey === __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__["a" /* SELECT_KEYS */].TAB) {
            triggeredBy = __WEBPACK_IMPORTED_MODULE_3__Models_LeQuillAutocompleteTriggerOptionsModel__["a" /* TRIGGER_OPTIONS */].TAB;
          }
        } else {
          triggeredBy = selectKey === __WEBPACK_IMPORTED_MODULE_4__Models_LeQuillAutocompleteSelectKeysModel__["a" /* SELECT_KEYS */].ARROW_RIGHT ? 'Selected - Right Arrow' : 'Selected - Tab';
        }
        if (triggeredBy) {
          this.handleTriggeredBy({ triggeredBy: triggeredBy, id: id });
        }
      }
    }
  }, {
    key: 'handleTriggeredBy',
    value: function handleTriggeredBy(_ref2) {
      var _this2 = this;

      var triggeredBy = _ref2.triggeredBy,
          id = _ref2.id;

      this.fetchAutocompleteAsync({ triggeredBy: triggeredBy, id: id }).then(function (autocomplete) {
        _this2.addToCache(autocomplete);
        _this2.insertAutocomplete();
      });
    }
  }, {
    key: 'insertAutocomplete',
    value: function insertAutocomplete() {
      var quill = this.quill;

      var index = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(quill.getSelection(), 'index');

      if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"])(index) && !isAutocompleteDisplayed(quill) && getIsCursorAtValidPosition(this.quill)) {
          var autocomplete = this.getFromCache();
          if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(autocomplete, 'text')) {
              quill.insertEmbed(index, __WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_AUTOCOMPLETE, autocomplete);
              quill.format(__WEBPACK_IMPORTED_MODULE_2__index__["CONSTS"].LE_EDITOR.SUPPORTED_QUILL_FORMATS.LE_QUILL_AUTOCOMPLETE, false);
              quill.removeFormat(index - 1, 1);
              if (autocomplete.id && !autocomplete.wasDisplayed) {
                this.markDisplayed(autocomplete);
                if (!this.isDefaultApi) {
                  this.handleTriggeredBy({ triggeredBy: __WEBPACK_IMPORTED_MODULE_3__Models_LeQuillAutocompleteTriggerOptionsModel__["a" /* TRIGGER_OPTIONS */].DISPLAYED, id: autocomplete.id });
                }
              }
            }
        }
    }
  }]);

  return LeQuillAutocompleteModule;
}();

/* harmony default export */ __webpack_exports__["a"] = (LeQuillAutocompleteModule);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(555);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0e5883dd", content, true, {});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-quill-autocomplete{opacity:.5;user-select:none;user-focus:none}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-quill-autocomplete/src/components/vue-components/le-text-editor/le-quill-autocomplete/_le-quill-autocomplete.scss"],"names":[],"mappings":"AAwWA,uBACE,WAAY,AACZ,iBAAiB,AACjB,eAAgB,CACjB","file":"_le-quill-autocomplete.scss","sourcesContent":["$font-family-Roboto: Roboto;\n\n/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n\n$color-white: #ffffff;\n$color-gray-f2: #f2f2f2;\n$color-gray-dd: #dddddd;\n$color-gray-cc: #cccccc;\n$color-gray-88: #888888;\n$color-gray-66: #666666;\n$color-gray-52: #525355;\n$color-gray-32: #323436;\n$color-gray-76: #767678;\n$color-gray-b1: #b1b1b1;\n$color-black: #000000;\n\n$color-green-8b: #8bbb4b;\n$color-red-ed: #ed1c24;\n$color-red-ff: #ff7a7a;\n$color-blue-4b: #4b91b9;\n$color-blue-58: #5879da;\n$color-blue-5d: #5daedc;\n$color-blue-bb: #bbecfb;\n\n$color-orange-f5: #f5a623;\n$color-orange-de: #de961e;\n$color-orange-d1: #d1880e;\n\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n\n$icon-size-small: 4px;\n\n$font-size-xxxsmall: 9px;\n$font-size-xxsmall: 10px;\n$font-size-xsmall: 11px;\n$font-size-small: 12px;\n$font-size-medium: 13px;\n$font-size-large: 14px;\n$font-size-xlarge: 15px;\n$font-size-xxlarge: 16px;\n\n$palettes: () !default;\n$themes: () !default;\n$colorsMap: () !default;\n$sizesMap: () !default;\n$attrsMap: () !default;\n\n@mixin ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@mixin disable-user-select() {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n@mixin transform-translateZ($x) {\n  -webkit-transform: translateZ($x);\n  -ms-transform: translateZ($x);\n  transform: translateZ($x);\n}\n\n@mixin transform-rotate($x) {\n  -webkit-transform: rotate($x);\n  -ms-transform: rotate($x);\n  transform: rotate($x);\n}\n\n@mixin a11y-focus-outline() {\n  outline: none !important;\n  @include themify(null, 'show-a11y-focus-outline') {\n      box-shadow: inset 0 0 0 2px getColor('a11yFocusIndicator') !important;\n  }\n}\n\n@mixin a11y-visually-hidden() {\n  position: absolute;\n  clip: rect(0 0 0 0);\n  border: 0;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n}\n\n@mixin themify($specific-theme:null, $conditionalClass:null) {\n  @if ($specific-theme) {\n    $themeValues: map-get($themes, $specific-theme);\n    @if ($conditionalClass) {\n      &.theme-#{$specific-theme}.#{$conditionalClass},\n      .theme-#{$specific-theme}.#{$conditionalClass} & {\n        $colorsMap: map-get($themeValues, 'colors') !global;\n        $sizesMap: map-get($themeValues, 'sizes') !global;\n        $attrsMap: map-get($themeValues, 'attrs') !global;\n\n        @content;\n\n        $colorsMap: () !global;\n        $sizesMap: () !global;\n        $attrsMap: () !global;\n      }\n    }\n    @else {\n      &.theme-#{$specific-theme},\n      .theme-#{$specific-theme} & {\n        $colorsMap: map-get($themeValues, 'colors') !global;\n        $sizesMap: map-get($themeValues, 'sizes') !global;\n        $attrsMap: map-get($themeValues, 'attrs') !global;\n\n        @content;\n\n        $colorsMap: () !global;\n        $sizesMap: () !global;\n        $attrsMap: () !global;\n      }\n    }\n  }\n  @else {\n    @each $theme, $themeValues in $themes {\n      @if ($conditionalClass) {\n        &.theme-#{$theme}.#{$conditionalClass},\n        .theme-#{$theme}.#{$conditionalClass} & {\n          $colorsMap: map-get($themeValues, 'colors') !global;\n          $sizesMap: map-get($themeValues, 'sizes') !global;\n          $attrsMap: map-get($themeValues, 'attrs') !global;\n\n          @content;\n\n          $colorsMap: () !global;\n          $sizesMap: () !global;\n          $attrsMap: () !global;\n        }\n      }\n      @else {\n        &.theme-#{$theme},\n        .theme-#{$theme} & {\n          $colorsMap: map-get($themeValues, 'colors') !global;\n          $sizesMap: map-get($themeValues, 'sizes') !global;\n          $attrsMap: map-get($themeValues, 'attrs') !global;\n\n          @content;\n\n          $colorsMap: () !global;\n          $sizesMap: () !global;\n          $attrsMap: () !global;\n        }\n      }\n    }\n  }\n}\n\n@mixin addTheme($themeName, $themeValues) {\n  @include addPrivateTheme('self', $themeName, $themeValues);\n}\n\n@mixin addPrivateTheme($moduleName, $themeName, $themeValues) {\n  $moduleThemeColors: map-get($themeValues, 'colors');\n  $moduleThemeSizes: map-get($themeValues, 'sizes');\n  $moduleThemeAttrs: map-get($themeValues, 'attrs');\n\n  @if (not map-has-key($themes, $themeName)) {\n    $emptyTheme: ('colors':(), 'sizes':(), 'attrs':());\n    $themes: map-merge($themes, ($themeName: $emptyTheme)) !global;\n  }\n\n  $currentThemeColors: map-get(map-get($themes, $themeName), 'colors');\n  $currentThemeSizes: map-get(map-get($themes, $themeName), 'sizes');\n  $currentThemeAttrs: map-get(map-get($themes, $themeName), 'attrs');\n\n  $newThemeColors: map-merge($currentThemeColors, ($moduleName: $moduleThemeColors));\n  $newThemeSizes: map-merge($currentThemeSizes, ($moduleName: $moduleThemeSizes));\n  $newThemeAttrs: map-merge($currentThemeAttrs, ($moduleName: $moduleThemeAttrs));\n\n  $newThemeValues: ('colors': $newThemeColors, 'sizes': $newThemeSizes, 'attrs': $newThemeAttrs);\n\n  $themes: map-merge($themes, ($themeName: $newThemeValues)) !global;\n}\n\n\n@function getColor($colorName, $moduleName:'self') {\n  @if (map-has-key($colorsMap, $moduleName)) {\n    @return map-get(map-get($colorsMap, $moduleName), $colorName);\n  }\n  @else {\n    @return #ff0000; // return red as a default error\n  }\n}\n\n@function getSize($sizeName, $moduleName:'self') {\n  @if (map-has-key($sizesMap, $moduleName)) {\n    @return map-get(map-get($sizesMap, $moduleName), $sizeName);\n  }\n  @else {\n    @return 13px; // return 13px as a default error\n  }\n}\n\n@function getAttr($attrName, $moduleName:'self') {\n  @if (map-has-key($attrsMap, $moduleName)) {\n    @return map-get(map-get($attrsMap, $moduleName), $attrName);\n  }\n  @else {\n    @return ''; // return empty string as default error\n  }\n}\n\n@function getImagePath($pathToRoot, $imageName, $img-folder: \"/assets/img/\") {\n  @if ($imageName) {\n    @return quote($pathToRoot + $img-folder + $imageName);\n  }\n  @else {\n    @return quote('');\n  }\n}\n\n@mixin registerSwitcherImage($moduleSelector, $attrImageRegular, $attrImageSelected , $namespaceName, $imageFolderPath) {\n  $moduleSelectorRes: '.switcher-' + $moduleSelector;\n  .le {\n    @include themify {\n      $getImagePathReg: getAttr($attrImageRegular, $namespaceName);\n      $getImagePathSelected: getAttr($attrImageSelected, $namespaceName);\n      #{$moduleSelectorRes} {\n        &:before {\n          background: url(quote($imageFolderPath + $getImagePathSelected)) + ' 0 0 no-repeat';\n          visibility: hidden;\n          height: 0;\n          content: '';\n        };\n        .switcher-item {\n          .icon {\n            background: url(quote($imageFolderPath + $getImagePathReg)) + ' 0 0 no-repeat';\n          }\n        }\n        &.active {\n          .switcher-item {\n            .icon {\n              background: url(quote($imageFolderPath + $getImagePathSelected)) + ' 0 0 no-repeat';\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n\n@mixin addPalette($paletteName, $paletteColors) {\n  $palettes: map-merge($palettes, ($paletteName: $paletteColors)) !global;\n}\n\n@function getPaletteColor($paletteName, $colorName) {\n  @return map-get(map-get($palettes, $paletteName), $colorName);\n}\n\n@function getThemeColor($themeName, $colorName) {\n  $theme: map-get($themes, $themeName);\n  $colors: map-get($theme, 'colors');\n\n  @return map-get($colors, $colorName);\n}\n\n@mixin table-border($direction) {\n  $separatedDirection: $direction;\n  @if ($direction) {\n    @if (not str-index($direction, '-')) {\n      $separatedDirection: '-' + $direction;\n    }\n  }\n  @include themify {\n    border#{$separatedDirection}: 1px solid getColor('tableBorder');\n  }\n}\n\n@mixin add-scrollbar($moduleSelector) {\n  #{$moduleSelector} {\n    * {\n      @include themify {\n        // IE\n        scrollbar-track-color: getColor('scrollbarTrack');\n        scrollbar-base-color: getColor('scrollbarThumb');\n        scrollbar-arrow-color: getColor('scrollbarTrack');\n        scrollbar-shadow-color: getColor('scrollbarTrack');\n        scrollbar-dark-shadow-color: getColor('scrollbarTrack');\n        scrollbar-3dlight-color: getColor('scrollbarTrack');\n        scrollbar-highlight-color: getColor('scrollbarTrack');\n        // FF\n        scrollbar-color: getColor('scrollbarThumb') getColor('scrollbarTrack');\n        scrollbar-width: thin;\n        // chrome safari\n        &::-webkit-scrollbar-track,\n        &::-webkit-scrollbar-corner {\n          background-color: getColor('scrollbarTrack');\n        }\n        &::-webkit-scrollbar-thumb {\n          background-color: getColor('scrollbarThumb');\n          border: 4.7px solid transparent;\n          border-radius: 9px;\n          background-clip: content-box;\n        }\n        &::-webkit-scrollbar {\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n@mixin font-smoothing($value: antialiased) {\n  @if $value == antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  @else {\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n  }\n}\n\n@mixin add-antialiased($moduleSelector) {\n  #{$moduleSelector} {\n    * {\n      @include font-smoothing(antialiased);\n    }\n  }\n}\n\n@mixin rm-default-button-style() {\n  background: none;\n  color: inherit;\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  padding: 0;\n}\n\n@import \"../../../../sass/palettes/dark\";\n@import \"../../../../sass/palettes/light\";\n\n\n\n\n\n\n@import \"../../../../sass/themes/dark\";\n@import \"../../../../sass/themes/light\";\n\n\n\n\n\n\n.le-quill-autocomplete {\n  opacity: 0.5;\n  user-select: none;\n  user-focus: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoLink__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoLinkCashtags__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autoLinkEntities__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__autoLinkHashtags__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__autoLinkUrlsCustom__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__autoLinkUsernamesOrLists__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__autoLinkWithJSON__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__convertUnicodeIndices__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extractCashtags__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extractCashtagsWithIndices__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__extractEntitiesWithIndices__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__extractHashtags__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__extractHashtagsWithIndices__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__extractHtmlAttrsFromOptions__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__extractMentions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__extractMentionsOrListsWithIndices__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__extractMentionsWithIndices__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__extractReplies__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__extractUrls__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__extractUrlsWithIndices__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getTweetLength__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getUnicodeTextLength__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hasInvalidCharacters__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hitHighlight__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__htmlEscape__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isInvalidTweet__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isValidHashtag__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isValidList__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValidTweetText__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isValidUrl__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__isValidUsername__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__linkTextWithEntity__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__linkToCashtag__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__linkToHashtag__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__linkToMentionAndList__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__linkToText__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__linkToTextWithSymbol__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__linkToUrl__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modifyIndicesFromUTF16ToUnicode__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modifyIndicesFromUnicodeToUTF16__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__regexp_index__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__removeOverlappingEntities__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__parseTweet__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__splitTags__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__standardizeIndices__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__tagAttrs__ = __webpack_require__(326);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0















































/* harmony default export */ __webpack_exports__["default"] = ({
  autoLink: __WEBPACK_IMPORTED_MODULE_0__autoLink__["a" /* default */],
  autoLinkCashtags: __WEBPACK_IMPORTED_MODULE_1__autoLinkCashtags__["a" /* default */],
  autoLinkEntities: __WEBPACK_IMPORTED_MODULE_2__autoLinkEntities__["a" /* default */],
  autoLinkHashtags: __WEBPACK_IMPORTED_MODULE_3__autoLinkHashtags__["a" /* default */],
  autoLinkUrlsCustom: __WEBPACK_IMPORTED_MODULE_4__autoLinkUrlsCustom__["a" /* default */],
  autoLinkUsernamesOrLists: __WEBPACK_IMPORTED_MODULE_5__autoLinkUsernamesOrLists__["a" /* default */],
  autoLinkWithJSON: __WEBPACK_IMPORTED_MODULE_6__autoLinkWithJSON__["a" /* default */],
  configs: __WEBPACK_IMPORTED_MODULE_7__configs__["a" /* default */],
  convertUnicodeIndices: __WEBPACK_IMPORTED_MODULE_8__convertUnicodeIndices__["a" /* default */],
  extractCashtags: __WEBPACK_IMPORTED_MODULE_9__extractCashtags__["a" /* default */],
  extractCashtagsWithIndices: __WEBPACK_IMPORTED_MODULE_10__extractCashtagsWithIndices__["a" /* default */],
  extractEntitiesWithIndices: __WEBPACK_IMPORTED_MODULE_11__extractEntitiesWithIndices__["a" /* default */],
  extractHashtags: __WEBPACK_IMPORTED_MODULE_12__extractHashtags__["a" /* default */],
  extractHashtagsWithIndices: __WEBPACK_IMPORTED_MODULE_13__extractHashtagsWithIndices__["a" /* default */],
  extractHtmlAttrsFromOptions: __WEBPACK_IMPORTED_MODULE_14__extractHtmlAttrsFromOptions__["a" /* default */],
  extractMentions: __WEBPACK_IMPORTED_MODULE_15__extractMentions__["a" /* default */],
  extractMentionsOrListsWithIndices: __WEBPACK_IMPORTED_MODULE_16__extractMentionsOrListsWithIndices__["a" /* default */],
  extractMentionsWithIndices: __WEBPACK_IMPORTED_MODULE_17__extractMentionsWithIndices__["a" /* default */],
  extractReplies: __WEBPACK_IMPORTED_MODULE_18__extractReplies__["a" /* default */],
  extractUrls: __WEBPACK_IMPORTED_MODULE_19__extractUrls__["a" /* default */],
  extractUrlsWithIndices: __WEBPACK_IMPORTED_MODULE_20__extractUrlsWithIndices__["a" /* default */],
  getTweetLength: __WEBPACK_IMPORTED_MODULE_21__getTweetLength__["a" /* default */],
  getUnicodeTextLength: __WEBPACK_IMPORTED_MODULE_22__getUnicodeTextLength__["a" /* default */],
  hasInvalidCharacters: __WEBPACK_IMPORTED_MODULE_23__hasInvalidCharacters__["a" /* default */],
  hitHighlight: __WEBPACK_IMPORTED_MODULE_24__hitHighlight__["a" /* default */],
  htmlEscape: __WEBPACK_IMPORTED_MODULE_25__htmlEscape__["a" /* default */],
  isInvalidTweet: __WEBPACK_IMPORTED_MODULE_26__isInvalidTweet__["a" /* default */],
  isValidHashtag: __WEBPACK_IMPORTED_MODULE_27__isValidHashtag__["a" /* default */],
  isValidList: __WEBPACK_IMPORTED_MODULE_28__isValidList__["a" /* default */],
  isValidTweetText: __WEBPACK_IMPORTED_MODULE_29__isValidTweetText__["a" /* default */],
  isValidUrl: __WEBPACK_IMPORTED_MODULE_30__isValidUrl__["a" /* default */],
  isValidUsername: __WEBPACK_IMPORTED_MODULE_31__isValidUsername__["a" /* default */],
  linkTextWithEntity: __WEBPACK_IMPORTED_MODULE_32__linkTextWithEntity__["a" /* default */],
  linkToCashtag: __WEBPACK_IMPORTED_MODULE_33__linkToCashtag__["a" /* default */],
  linkToHashtag: __WEBPACK_IMPORTED_MODULE_34__linkToHashtag__["a" /* default */],
  linkToMentionAndList: __WEBPACK_IMPORTED_MODULE_35__linkToMentionAndList__["a" /* default */],
  linkToText: __WEBPACK_IMPORTED_MODULE_36__linkToText__["a" /* default */],
  linkToTextWithSymbol: __WEBPACK_IMPORTED_MODULE_37__linkToTextWithSymbol__["a" /* default */],
  linkToUrl: __WEBPACK_IMPORTED_MODULE_38__linkToUrl__["a" /* default */],
  modifyIndicesFromUTF16ToUnicode: __WEBPACK_IMPORTED_MODULE_39__modifyIndicesFromUTF16ToUnicode__["a" /* default */],
  modifyIndicesFromUnicodeToUTF16: __WEBPACK_IMPORTED_MODULE_40__modifyIndicesFromUnicodeToUTF16__["a" /* default */],
  regexen: __WEBPACK_IMPORTED_MODULE_41__regexp_index__["a" /* default */],
  removeOverlappingEntities: __WEBPACK_IMPORTED_MODULE_42__removeOverlappingEntities__["a" /* default */],
  parseTweet: __WEBPACK_IMPORTED_MODULE_43__parseTweet__["a" /* default */],
  splitTags: __WEBPACK_IMPORTED_MODULE_44__splitTags__["a" /* default */],
  standardizeIndices: __WEBPACK_IMPORTED_MODULE_45__standardizeIndices__["a" /* default */],
  tagAttrs: __WEBPACK_IMPORTED_MODULE_46__tagAttrs__["a" /* default */]
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractEntitiesWithIndices__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__ = __webpack_require__(27);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_0__extractEntitiesWithIndices__["a" /* default */])(text, {
    extractUrlsWithoutProtocol: false
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(77);
__webpack_require__(8)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52)('native-function-to-string', Function.toString);


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(50);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var setPrototypeOf = __webpack_require__(562).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(55)(Function.call, __webpack_require__(81).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(10);
var dP = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(11);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_punycode__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_punycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_punycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_validAsciiDomain__ = __webpack_require__(97);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var MAX_DOMAIN_LABEL_LENGTH = 63;
var PUNYCODE_ENCODED_DOMAIN_PREFIX = 'xn--'; // This is an extremely lightweight implementation of domain name validation according to RFC 3490
// Our regexes handle most of the cases well enough
// See https://tools.ietf.org/html/rfc3490#section-4.1 for details

var idna = {
  toAscii: function toAscii(domain) {
    if (domain.substring(0, 4) === PUNYCODE_ENCODED_DOMAIN_PREFIX && !domain.match(__WEBPACK_IMPORTED_MODULE_3__regexp_validAsciiDomain__["a" /* default */])) {
      // Punycode encoded url cannot contain non ASCII characters
      return;
    }

    var labels = domain.split('.');

    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var punycodeEncodedLabel = __WEBPACK_IMPORTED_MODULE_2_punycode___default.a.toASCII(label);

      if (punycodeEncodedLabel.length < 1 || punycodeEncodedLabel.length > MAX_DOMAIN_LABEL_LENGTH) {
        // DNS label has invalid length
        return;
      }
    }

    return labels.join('.');
  }
};
/* harmony default export */ __webpack_exports__["a"] = (idna);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(56);
var SPECIES = __webpack_require__(7)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module), __webpack_require__(28)))

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(568);
var anObject = __webpack_require__(9);
var $flags = __webpack_require__(54);
var DESCRIPTORS = __webpack_require__(11);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(13)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(11) && /./g.flags != 'g') __webpack_require__(12).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(54)
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractCashtagsWithIndices__ = __webpack_require__(48);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_1__extractCashtagsWithIndices__["a" /* default */])(text);
  return Object(__WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractHashtagsWithIndices__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__ = __webpack_require__(27);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_0__extractHashtagsWithIndices__["a" /* default */])(text);
  return Object(__WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractUrlsWithIndices__ = __webpack_require__(26);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_1__extractUrlsWithIndices__["a" /* default */])(text, {
    extractUrlsWithoutProtocol: false
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractMentionsOrListsWithIndices__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__ = __webpack_require__(27);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var entities = Object(__WEBPACK_IMPORTED_MODULE_0__extractMentionsOrListsWithIndices__["a" /* default */])(text);
  return Object(__WEBPACK_IMPORTED_MODULE_1__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifyIndicesFromUnicodeToUTF16__ = __webpack_require__(333);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text, json, options) {
  // map JSON entity to twitter-text entity
  if (json.user_mentions) {
    for (var i = 0; i < json.user_mentions.length; i++) {
      // this is a @mention
      json.user_mentions[i].screenName = json.user_mentions[i].screen_name;
    }
  }

  if (json.hashtags) {
    for (var i = 0; i < json.hashtags.length; i++) {
      // this is a #hashtag
      json.hashtags[i].hashtag = json.hashtags[i].text;
    }
  }

  if (json.symbols) {
    for (var i = 0; i < json.symbols.length; i++) {
      // this is a $CASH tag
      json.symbols[i].cashtag = json.symbols[i].text;
    }
  } // concatenate all entities


  var entities = [];

  for (var key in json) {
    entities = entities.concat(json[key]);
  } // modify indices to UTF-16


  Object(__WEBPACK_IMPORTED_MODULE_1__modifyIndicesFromUnicodeToUTF16__["a" /* default */])(text, entities);
  return Object(__WEBPACK_IMPORTED_MODULE_0__autoLinkEntities__["a" /* default */])(text, entities, options);
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_sort__);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
/* harmony default export */ __webpack_exports__["a"] = (function (text, entities, indicesInUTF16) {
  if (entities.length == 0) {
    return;
  }

  var charIndex = 0;
  var codePointIndex = 0; // sort entities by start index

  entities.sort(function (a, b) {
    return a.indices[0] - b.indices[0];
  });
  var entityIndex = 0;
  var entity = entities[0];

  while (charIndex < text.length) {
    if (entity.indices[0] == (indicesInUTF16 ? charIndex : codePointIndex)) {
      var len = entity.indices[1] - entity.indices[0];
      entity.indices[0] = indicesInUTF16 ? codePointIndex : charIndex;
      entity.indices[1] = entity.indices[0] + len;
      entityIndex++;

      if (entityIndex == entities.length) {
        // no more entity
        break;
      }

      entity = entities[entityIndex];
    }

    var c = text.charCodeAt(charIndex);

    if (c >= 0xd800 && c <= 0xdbff && charIndex < text.length - 1) {
      // Found high surrogate char
      c = text.charCodeAt(charIndex + 1);

      if (c >= 0xdc00 && c <= 0xdfff) {
        // Found surrogate pair
        charIndex++;
      }
    }

    codePointIndex++;
    charIndex++;
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractCashtagsWithIndices__ = __webpack_require__(48);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  var cashtagsOnly = [],
      cashtagsWithIndices = Object(__WEBPACK_IMPORTED_MODULE_0__extractCashtagsWithIndices__["a" /* default */])(text);

  for (var i = 0; i < cashtagsWithIndices.length; i++) {
    cashtagsOnly.push(cashtagsWithIndices[i].cashtag);
  }

  return cashtagsOnly;
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_endMentionMatch__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_validReply__ = __webpack_require__(338);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  if (!text) {
    return null;
  }

  var possibleScreenName = text.match(__WEBPACK_IMPORTED_MODULE_3__regexp_validReply__["a" /* default */]);

  if (!possibleScreenName || RegExp.rightContext.match(__WEBPACK_IMPORTED_MODULE_2__regexp_endMentionMatch__["a" /* default */])) {
    return null;
  }

  return possibleScreenName[1];
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractUrlsWithIndices__ = __webpack_require__(26);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  var urlsOnly = [];
  var urlsWithIndices = Object(__WEBPACK_IMPORTED_MODULE_0__extractUrlsWithIndices__["a" /* default */])(text, options);

  for (var i = 0; i < urlsWithIndices.length; i++) {
    urlsOnly.push(urlsWithIndices[i].url);
  }

  return urlsOnly;
});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(8);

$export($export.S, 'Array', { isArray: __webpack_require__(106) });


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(581);

$export($export.P + $export.F * !__webpack_require__(40)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(56);
var toObject = __webpack_require__(20);
var IObject = __webpack_require__(79);
var toLength = __webpack_require__(23);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(7)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(344);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(109);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(21)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(20);
var IE_PROTO = __webpack_require__(83)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(30);
var fails = __webpack_require__(13);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeName = undefined;
exports.parse = parse;
exports.toCodePoints = toCodePoints;

var _regex = __webpack_require__(589);

var _regex2 = _interopRequireDefault(_regex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeName = exports.TypeName = 'emoji';
// Copyright Twitter Inc. Licensed under MIT
// https://github.com/twitter/twemoji-parser/blob/master/LICENSE.md
function parse(text, options) {
  var assetType = options && options.assetType ? options.assetType : 'svg';
  var getTwemojiUrl = options && options.buildUrl ? options.buildUrl : function (codepoints, assetType) {
    return assetType === 'png' ? 'https://twemoji.maxcdn.com/2/72x72/' + codepoints + '.png' : 'https://twemoji.maxcdn.com/2/svg/' + codepoints + '.svg';
  };

  var entities = [];

  _regex2.default.lastIndex = 0;
  while (true) {
    var result = _regex2.default.exec(text);
    if (!result) {
      break;
    }

    var emojiText = result[0];
    var codepoints = toCodePoints(removeVS16s(emojiText)).join('-');

    entities.push({
      url: codepoints ? getTwemojiUrl(codepoints, assetType) : '',
      indices: [result.index, _regex2.default.lastIndex],
      text: emojiText,
      type: TypeName
    });
  }
  return entities;
}

var vs16RegExp = /\uFE0F/g;
// avoid using a string literal like '\u200D' here because minifiers expand it inline
var zeroWidthJoiner = String.fromCharCode(0x200d);

var removeVS16s = function removeVS16s(rawEmoji) {
  return rawEmoji.indexOf(zeroWidthJoiner) < 0 ? rawEmoji.replace(vs16RegExp, '') : rawEmoji;
};

function toCodePoints(unicodeSurrogates) {
  var points = [];
  var char = 0;
  var previous = 0;
  var i = 0;
  while (i < unicodeSurrogates.length) {
    char = unicodeSurrogates.charCodeAt(i++);
    if (previous) {
      points.push((0x10000 + (previous - 0xd800 << 10) + (char - 0xdc00)).toString(16));
      previous = 0;
    } else if (char > 0xd800 && char <= 0xdbff) {
      previous = char;
    } else {
      points.push(char.toString(16));
    }
  }
  return points;
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright Twitter Inc. Licensed under MIT
// https://github.com/twitter/twemoji-parser/blob/master/LICENSE.md

// This file is auto-generated
exports.default = /(?:\ud83d[\udc68\udc69])(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddb0-\uddb3])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\uddb5\uddb6\uddb8\uddb9\uddd1-\udddd]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a-\udc6d\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\udeeb\udeec\udef4-\udef9]|\ud83e[\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd40-\udd45\udd47-\udd70\udd73-\udd76\udd7a\udd7c-\udda2\uddb4\uddb7\uddc0-\uddc2\uddd0\uddde-\uddff]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g;

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splitTags__ = __webpack_require__(349);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text, hits, options) {
  var defaultHighlightTag = 'em';
  hits = hits || [];
  options = options || {};

  if (hits.length === 0) {
    return text;
  }

  var tagName = options.tag || defaultHighlightTag,
      tags = ["<".concat(tagName, ">"), "</".concat(tagName, ">")],
      chunks = Object(__WEBPACK_IMPORTED_MODULE_0__splitTags__["a" /* default */])(text),
      i,
      j,
      result = '',
      chunkIndex = 0,
      chunk = chunks[0],
      prevChunksLen = 0,
      chunkCursor = 0,
      startInChunk = false,
      chunkChars = chunk,
      flatHits = [],
      index,
      hit,
      tag,
      placed,
      hitSpot;

  for (i = 0; i < hits.length; i += 1) {
    for (j = 0; j < hits[i].length; j += 1) {
      flatHits.push(hits[i][j]);
    }
  }

  for (index = 0; index < flatHits.length; index += 1) {
    hit = flatHits[index];
    tag = tags[index % 2];
    placed = false;

    while (chunk != null && hit >= prevChunksLen + chunk.length) {
      result += chunkChars.slice(chunkCursor);

      if (startInChunk && hit === prevChunksLen + chunkChars.length) {
        result += tag;
        placed = true;
      }

      if (chunks[chunkIndex + 1]) {
        result += "<".concat(chunks[chunkIndex + 1], ">");
      }

      prevChunksLen += chunkChars.length;
      chunkCursor = 0;
      chunkIndex += 2;
      chunk = chunks[chunkIndex];
      chunkChars = chunk;
      startInChunk = false;
    }

    if (!placed && chunk != null) {
      hitSpot = hit - prevChunksLen;
      result += chunkChars.slice(chunkCursor, hitSpot) + tag;
      chunkCursor = hitSpot;

      if (index % 2 === 0) {
        startInChunk = true;
      } else {
        startInChunk = false;
      }
    } else if (!placed) {
      placed = true;
      result += tag;
    }
  }

  if (chunk != null) {
    if (chunkCursor < chunkChars.length) {
      result += chunkChars.slice(chunkCursor);
    }

    for (index = chunkIndex + 1; index < chunks.length; index += 1) {
      result += index % 2 === 0 ? chunks[index] : "<".concat(chunks[index], ">");
    }
  }

  return result;
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperty: __webpack_require__(12).f });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(11), 'Object', { defineProperties: __webpack_require__(345) });


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(8);
var ownKeys = __webpack_require__(594);
var toIObject = __webpack_require__(25);
var gOPD = __webpack_require__(81);
var createProperty = __webpack_require__(351);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(58);
var gOPS = __webpack_require__(112);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(10).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $forEach = __webpack_require__(352)(0);
var STRICT = __webpack_require__(40)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(597);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var isArray = __webpack_require__(106);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $filter = __webpack_require__(352)(2);

$export($export.P + $export.F * !__webpack_require__(40)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(11);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(18);
var META = __webpack_require__(600).KEY;
var $fails = __webpack_require__(13);
var shared = __webpack_require__(52);
var setToStringTag = __webpack_require__(109);
var uid = __webpack_require__(38);
var wks = __webpack_require__(7);
var wksExt = __webpack_require__(353);
var wksDefine = __webpack_require__(601);
var enumKeys = __webpack_require__(602);
var isArray = __webpack_require__(106);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(17);
var toObject = __webpack_require__(20);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(78);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(344);
var gOPNExt = __webpack_require__(603);
var $GOPD = __webpack_require__(81);
var $GOPS = __webpack_require__(112);
var $DP = __webpack_require__(12);
var $keys = __webpack_require__(45);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(58).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(82).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(53)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(38)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(12).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(13)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(30);
var LIBRARY = __webpack_require__(53);
var wksExt = __webpack_require__(353);
var defineProperty = __webpack_require__(12).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(45);
var gOPS = __webpack_require__(112);
var pIE = __webpack_require__(82);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(25);
var gOPN = __webpack_require__(58).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(605);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(354)["default"];
var toPrimitive = __webpack_require__(606);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(354)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractHashtags__ = __webpack_require__(335);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (hashtag) {
  if (!hashtag) {
    return false;
  }

  var extracted = Object(__WEBPACK_IMPORTED_MODULE_0__extractHashtags__["a" /* default */])(hashtag); // Should extract the hashtag minus the # sign, hence the .slice(1)

  return extracted.length === 1 && extracted[0] === hashtag.slice(1);
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_validMentionOrList__ = __webpack_require__(103);

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0


var VALID_LIST_RE = Object(__WEBPACK_IMPORTED_MODULE_1__lib_regexSupplant__["a" /* default */])(/^#{validMentionOrList}$/, {
  validMentionOrList: __WEBPACK_IMPORTED_MODULE_2__regexp_validMentionOrList__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (function (usernameList) {
  var match = usernameList.match(VALID_LIST_RE); // Must have matched and had nothing before or after

  return !!(match && match[1] == '' && match[4]);
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isInvalidTweet__ = __webpack_require__(350);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (text, options) {
  return !Object(__WEBPACK_IMPORTED_MODULE_0__isInvalidTweet__["a" /* default */])(text, options);
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_constructor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regexp_validateUrlAuthority__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__regexp_validateUrlFragment__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp_validateUrlPath__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__regexp_validateUrlQuery__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__regexp_validateUrlScheme__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__regexp_validateUrlUnencoded__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__regexp_validateUrlUnicodeAuthority__ = __webpack_require__(369);


// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0








function isValidMatch(string, regex, optional) {
  if (!optional) {
    // RegExp["$&"] is the text of the last match
    // blank strings are ok, but are falsy, so we check stringiness instead of truthiness
    return typeof string === 'string' && string.match(regex) && RegExp['$&'] === string;
  } // RegExp["$&"] is the text of the last match


  return !string || string.match(regex) && RegExp['$&'] === string;
}

/* harmony default export */ __webpack_exports__["a"] = (function (url, unicodeDomains, requireProtocol) {
  if (unicodeDomains == null) {
    unicodeDomains = true;
  }

  if (requireProtocol == null) {
    requireProtocol = true;
  }

  if (!url) {
    return false;
  }

  var urlParts = url.match(__WEBPACK_IMPORTED_MODULE_7__regexp_validateUrlUnencoded__["a" /* default */]);

  if (!urlParts || urlParts[0] !== url) {
    return false;
  }

  var scheme = urlParts[1],
      authority = urlParts[2],
      path = urlParts[3],
      query = urlParts[4],
      fragment = urlParts[5];

  if (!((!requireProtocol || isValidMatch(scheme, __WEBPACK_IMPORTED_MODULE_6__regexp_validateUrlScheme__["a" /* default */]) && scheme.match(/^https?$/i)) && isValidMatch(path, __WEBPACK_IMPORTED_MODULE_4__regexp_validateUrlPath__["a" /* default */]) && isValidMatch(query, __WEBPACK_IMPORTED_MODULE_5__regexp_validateUrlQuery__["a" /* default */], true) && isValidMatch(fragment, __WEBPACK_IMPORTED_MODULE_3__regexp_validateUrlFragment__["a" /* default */], true))) {
    return false;
  }

  return unicodeDomains && isValidMatch(authority, __WEBPACK_IMPORTED_MODULE_8__regexp_validateUrlUnicodeAuthority__["a" /* default */]) || !unicodeDomains && isValidMatch(authority, __WEBPACK_IMPORTED_MODULE_2__regexp_validateUrlAuthority__["a" /* default */]);
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractMentions__ = __webpack_require__(336);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

/* harmony default export */ __webpack_exports__["a"] = (function (username) {
  if (!username) {
    return false;
  }

  var extracted = Object(__WEBPACK_IMPORTED_MODULE_0__extractMentions__["a" /* default */])(username); // Should extract the username minus the @ sign, hence the .slice(1)

  return extracted.length === 1 && extracted[0] === username.slice(1);
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__astralNumerals__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atSigns__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bmpLetterAndMarks__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bmpNumerals__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cashtag__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__codePoint__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cyrillicLettersAndMarks__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__endHashtagMatch__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__endMentionMatch__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extractUrl__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hashSigns__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hashtagAlpha__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hashtagAlphaNumeric__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hashtagBoundary__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hashtagSpecialChars__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__invalidChars__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__invalidCharsGroup__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__invalidDomainChars__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__invalidUrlWithoutProtocolPrecedingChars__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__latinAccentChars__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__nonBmpCodePairs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__punct__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rtlChars__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__spaces__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__spacesGroup__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__urlHasHttps__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__urlHasProtocol__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__validAsciiDomain__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__validateUrlAuthority__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__validateUrlDecOctet__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__validateUrlDomain__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__validateUrlDomainSegment__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__validateUrlDomainTld__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__validateUrlFragment__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__validateUrlHost__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__validateUrlIp__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__validateUrlIpv4__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__validateUrlIpv6__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__validateUrlPath__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__validateUrlPchar__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__validateUrlPctEncoded__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__validateUrlPort__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__validateUrlQuery__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__validateUrlScheme__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__validateUrlSubDelims__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__validateUrlSubDomainSegment__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__validateUrlUnencoded__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__validateUrlUnicodeAuthority__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__validateUrlUnicodeDomain__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__validateUrlUnicodeDomainSegment__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__validateUrlUnicodeDomainTld__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__validateUrlUnicodeHost__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__validateUrlUnicodeSubDomainSegment__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__validateUrlUnreserved__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__validateUrlUserinfo__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__validCashtag__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__validCCTLD__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__validDomain__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__validDomainChars__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__validDomainName__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__validGeneralUrlPathChars__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__validGTLD__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__validHashtag__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__validMentionOrList__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__validMentionPrecedingChars__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__validPortNumber__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__validPunycode__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__validReply__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__validSubdomain__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__validTcoUrl__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__validUrlBalancedParens__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__validUrlPath__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__validUrlPathEndingChars__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__validUrlPrecedingChars__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__validUrlQueryChars__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__validUrlQueryEndingChars__ = __webpack_require__(96);
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0













































































/* harmony default export */ __webpack_exports__["a"] = ({
  astralLetterAndMarks: __WEBPACK_IMPORTED_MODULE_0__astralLetterAndMarks__["a" /* default */],
  astralNumerals: __WEBPACK_IMPORTED_MODULE_1__astralNumerals__["a" /* default */],
  atSigns: __WEBPACK_IMPORTED_MODULE_2__atSigns__["a" /* default */],
  bmpLetterAndMarks: __WEBPACK_IMPORTED_MODULE_3__bmpLetterAndMarks__["a" /* default */],
  bmpNumerals: __WEBPACK_IMPORTED_MODULE_4__bmpNumerals__["a" /* default */],
  cashtag: __WEBPACK_IMPORTED_MODULE_5__cashtag__["a" /* default */],
  codePoint: __WEBPACK_IMPORTED_MODULE_6__codePoint__["a" /* default */],
  cyrillicLettersAndMarks: __WEBPACK_IMPORTED_MODULE_7__cyrillicLettersAndMarks__["a" /* default */],
  endHashtagMatch: __WEBPACK_IMPORTED_MODULE_8__endHashtagMatch__["a" /* default */],
  endMentionMatch: __WEBPACK_IMPORTED_MODULE_9__endMentionMatch__["a" /* default */],
  extractUrl: __WEBPACK_IMPORTED_MODULE_10__extractUrl__["a" /* default */],
  hashSigns: __WEBPACK_IMPORTED_MODULE_11__hashSigns__["a" /* default */],
  hashtagAlpha: __WEBPACK_IMPORTED_MODULE_12__hashtagAlpha__["a" /* default */],
  hashtagAlphaNumeric: __WEBPACK_IMPORTED_MODULE_13__hashtagAlphaNumeric__["a" /* default */],
  hashtagBoundary: __WEBPACK_IMPORTED_MODULE_14__hashtagBoundary__["a" /* default */],
  hashtagSpecialChars: __WEBPACK_IMPORTED_MODULE_15__hashtagSpecialChars__["a" /* default */],
  invalidChars: __WEBPACK_IMPORTED_MODULE_16__invalidChars__["a" /* default */],
  invalidCharsGroup: __WEBPACK_IMPORTED_MODULE_17__invalidCharsGroup__["a" /* default */],
  invalidDomainChars: __WEBPACK_IMPORTED_MODULE_18__invalidDomainChars__["a" /* default */],
  invalidUrlWithoutProtocolPrecedingChars: __WEBPACK_IMPORTED_MODULE_19__invalidUrlWithoutProtocolPrecedingChars__["a" /* default */],
  latinAccentChars: __WEBPACK_IMPORTED_MODULE_20__latinAccentChars__["a" /* default */],
  nonBmpCodePairs: __WEBPACK_IMPORTED_MODULE_21__nonBmpCodePairs__["a" /* default */],
  punct: __WEBPACK_IMPORTED_MODULE_22__punct__["a" /* default */],
  rtlChars: __WEBPACK_IMPORTED_MODULE_23__rtlChars__["a" /* default */],
  spaces: __WEBPACK_IMPORTED_MODULE_24__spaces__["a" /* default */],
  spacesGroup: __WEBPACK_IMPORTED_MODULE_25__spacesGroup__["a" /* default */],
  urlHasHttps: __WEBPACK_IMPORTED_MODULE_26__urlHasHttps__["a" /* default */],
  urlHasProtocol: __WEBPACK_IMPORTED_MODULE_27__urlHasProtocol__["a" /* default */],
  validAsciiDomain: __WEBPACK_IMPORTED_MODULE_28__validAsciiDomain__["a" /* default */],
  validateUrlAuthority: __WEBPACK_IMPORTED_MODULE_29__validateUrlAuthority__["a" /* default */],
  validateUrlDecOctet: __WEBPACK_IMPORTED_MODULE_30__validateUrlDecOctet__["a" /* default */],
  validateUrlDomain: __WEBPACK_IMPORTED_MODULE_31__validateUrlDomain__["a" /* default */],
  validateUrlDomainSegment: __WEBPACK_IMPORTED_MODULE_32__validateUrlDomainSegment__["a" /* default */],
  validateUrlDomainTld: __WEBPACK_IMPORTED_MODULE_33__validateUrlDomainTld__["a" /* default */],
  validateUrlFragment: __WEBPACK_IMPORTED_MODULE_34__validateUrlFragment__["a" /* default */],
  validateUrlHost: __WEBPACK_IMPORTED_MODULE_35__validateUrlHost__["a" /* default */],
  validateUrlIp: __WEBPACK_IMPORTED_MODULE_36__validateUrlIp__["a" /* default */],
  validateUrlIpv4: __WEBPACK_IMPORTED_MODULE_37__validateUrlIpv4__["a" /* default */],
  validateUrlIpv6: __WEBPACK_IMPORTED_MODULE_38__validateUrlIpv6__["a" /* default */],
  validateUrlPath: __WEBPACK_IMPORTED_MODULE_39__validateUrlPath__["a" /* default */],
  validateUrlPchar: __WEBPACK_IMPORTED_MODULE_40__validateUrlPchar__["a" /* default */],
  validateUrlPctEncoded: __WEBPACK_IMPORTED_MODULE_41__validateUrlPctEncoded__["a" /* default */],
  validateUrlPort: __WEBPACK_IMPORTED_MODULE_42__validateUrlPort__["a" /* default */],
  validateUrlQuery: __WEBPACK_IMPORTED_MODULE_43__validateUrlQuery__["a" /* default */],
  validateUrlScheme: __WEBPACK_IMPORTED_MODULE_44__validateUrlScheme__["a" /* default */],
  validateUrlSubDelims: __WEBPACK_IMPORTED_MODULE_45__validateUrlSubDelims__["a" /* default */],
  validateUrlSubDomainSegment: __WEBPACK_IMPORTED_MODULE_46__validateUrlSubDomainSegment__["a" /* default */],
  validateUrlUnencoded: __WEBPACK_IMPORTED_MODULE_47__validateUrlUnencoded__["a" /* default */],
  validateUrlUnicodeAuthority: __WEBPACK_IMPORTED_MODULE_48__validateUrlUnicodeAuthority__["a" /* default */],
  validateUrlUnicodeDomain: __WEBPACK_IMPORTED_MODULE_49__validateUrlUnicodeDomain__["a" /* default */],
  validateUrlUnicodeDomainSegment: __WEBPACK_IMPORTED_MODULE_50__validateUrlUnicodeDomainSegment__["a" /* default */],
  validateUrlUnicodeDomainTld: __WEBPACK_IMPORTED_MODULE_51__validateUrlUnicodeDomainTld__["a" /* default */],
  validateUrlUnicodeHost: __WEBPACK_IMPORTED_MODULE_52__validateUrlUnicodeHost__["a" /* default */],
  validateUrlUnicodeSubDomainSegment: __WEBPACK_IMPORTED_MODULE_53__validateUrlUnicodeSubDomainSegment__["a" /* default */],
  validateUrlUnreserved: __WEBPACK_IMPORTED_MODULE_54__validateUrlUnreserved__["a" /* default */],
  validateUrlUserinfo: __WEBPACK_IMPORTED_MODULE_55__validateUrlUserinfo__["a" /* default */],
  validCashtag: __WEBPACK_IMPORTED_MODULE_56__validCashtag__["a" /* default */],
  validCCTLD: __WEBPACK_IMPORTED_MODULE_57__validCCTLD__["a" /* default */],
  validDomain: __WEBPACK_IMPORTED_MODULE_58__validDomain__["a" /* default */],
  validDomainChars: __WEBPACK_IMPORTED_MODULE_59__validDomainChars__["a" /* default */],
  validDomainName: __WEBPACK_IMPORTED_MODULE_60__validDomainName__["a" /* default */],
  validGeneralUrlPathChars: __WEBPACK_IMPORTED_MODULE_61__validGeneralUrlPathChars__["a" /* default */],
  validGTLD: __WEBPACK_IMPORTED_MODULE_62__validGTLD__["a" /* default */],
  validHashtag: __WEBPACK_IMPORTED_MODULE_63__validHashtag__["a" /* default */],
  validMentionOrList: __WEBPACK_IMPORTED_MODULE_64__validMentionOrList__["a" /* default */],
  validMentionPrecedingChars: __WEBPACK_IMPORTED_MODULE_65__validMentionPrecedingChars__["a" /* default */],
  validPortNumber: __WEBPACK_IMPORTED_MODULE_66__validPortNumber__["a" /* default */],
  validPunycode: __WEBPACK_IMPORTED_MODULE_67__validPunycode__["a" /* default */],
  validReply: __WEBPACK_IMPORTED_MODULE_68__validReply__["a" /* default */],
  validSubdomain: __WEBPACK_IMPORTED_MODULE_69__validSubdomain__["a" /* default */],
  validTcoUrl: __WEBPACK_IMPORTED_MODULE_70__validTcoUrl__["a" /* default */],
  validUrlBalancedParens: __WEBPACK_IMPORTED_MODULE_71__validUrlBalancedParens__["a" /* default */],
  validUrlPath: __WEBPACK_IMPORTED_MODULE_72__validUrlPath__["a" /* default */],
  validUrlPathEndingChars: __WEBPACK_IMPORTED_MODULE_73__validUrlPathEndingChars__["a" /* default */],
  validUrlPrecedingChars: __WEBPACK_IMPORTED_MODULE_74__validUrlPrecedingChars__["a" /* default */],
  validUrlQueryChars: __WEBPACK_IMPORTED_MODULE_75__validUrlQueryChars__["a" /* default */],
  validUrlQueryEndingChars: __WEBPACK_IMPORTED_MODULE_76__validUrlQueryEndingChars__["a" /* default */]
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = standardizeIndices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_from__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUnicodeTextLength__ = __webpack_require__(348);



function standardizeIndices(text, startIndex, endIndex) {
  var totalUnicodeTextLength = Object(__WEBPACK_IMPORTED_MODULE_2__getUnicodeTextLength__["a" /* default */])(text);
  var encodingDiff = text.length - totalUnicodeTextLength;

  if (encodingDiff > 0) {
    // split the string into codepoints which will map to the API's indices
    var byCodePair = Array.from(text);
    var beforeText = startIndex === 0 ? '' : byCodePair.slice(0, startIndex).join('');
    var actualText = byCodePair.slice(startIndex, endIndex).join('');
    return [beforeText.length, beforeText.length + actualText.length];
  }

  return [startIndex, endIndex];
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(294)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(343)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(55);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(20);
var call = __webpack_require__(616);
var isArrayIter = __webpack_require__(617);
var toLength = __webpack_require__(23);
var createProperty = __webpack_require__(351);
var getIterFn = __webpack_require__(618);

$export($export.S + $export.F * !__webpack_require__(619)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(44);
var ITERATOR = __webpack_require__(7)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(75);
var ITERATOR = __webpack_require__(7)('iterator');
var Iterators = __webpack_require__(44);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(7)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-text-editor', _vm.enabled ? '' : 'disabled'],on:{"dragenter":_vm.onDragEnter}},[(_vm.isDragging)?_c('div',{staticClass:"overlay",on:{"dragleave":_vm.onDragExit,"drop":_vm.onDrop,"dragover":_vm.onDragOver}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showToolbar),expression:"showToolbar"}],staticClass:"le-text-editor-toolbar",attrs:{"id":("le-text-editor-toolbar" + _vm.id)}},[_vm._t("toolbar")],2),_vm._v(" "),_c('div',{staticClass:"editor-container"},[_c('div',{ref:"editorContainer",class:['editor-control-container', {'editor-slot': _vm.isRecording}],style:({ 'max-height': _vm.maxHeight + 'px', 'min-height': _vm.minHeight + 'px', 'line-height': _vm.lineHeight + 'px' }),on:{"click":function($event){return _vm.setFocus()}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRecording),expression:"!isRecording"}],ref:"editor",staticClass:"editor-control",on:{"keypress":_vm.debounceKeyPress,"keyup":_vm.onKeyUp,"keydown":_vm.onKeyDown,"paste":_vm.onPaste}}),_vm._v(" "),_vm._t("editor"),_vm._v(" "),_vm._t("rewrite")],2),_vm._v(" "),(_vm.hasSendButton)?_c('div',{staticClass:"action-container"},[_c('div',{staticClass:"send-action"},[_vm._t("action")],2)]):_vm._e()]),_vm._v(" "),(_vm.splitterSupported)?_c('div',{staticClass:"splitter-container"},[_c('div',{ref:"splitter",staticClass:"splitter resize-up",on:{"mousedown":_vm.onSplitterMouseDown}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop-area"},[_c('div',{staticClass:"drop-area-icon"},[_vm._v("+")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_editor_toolbar_buttons_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326e0004_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_editor_toolbar_buttons_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-326e0004"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_editor_toolbar_buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326e0004_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_editor_toolbar_buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("09d84e58", content, true, {});

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".toolbar-buttons[data-v-326e0004]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 4px 4px rgba(0,0,0,.3);box-shadow:0 4px 4px rgba(0,0,0,.3);border-radius:4px;padding:5px;margin:6px}.theme-dark .toolbar-buttons[data-v-326e0004],.toolbar-buttons.theme-dark[data-v-326e0004]{background-color:#2d3162;border:1px solid #595a80}.theme-light .toolbar-buttons[data-v-326e0004],.toolbar-buttons.theme-light[data-v-326e0004]{background-color:#f9f9f9;border:1px solid #e5e5e5}.toolbar-buttons button[data-v-326e0004]{background:transparent;border:0;padding:0 6px;margin:0 1px;cursor:pointer;line-height:22px;border-radius:2px}.toolbar-buttons button>i[data-v-326e0004]{vertical-align:middle}.theme-dark .toolbar-buttons button.ql-active[data-v-326e0004],.toolbar-buttons button.theme-dark.ql-active[data-v-326e0004]{background-color:#656a7a}.theme-dark .toolbar-buttons button.ql-active[data-v-326e0004]:hover,.toolbar-buttons button.theme-dark.ql-active[data-v-326e0004]:hover{background-color:#535677}.theme-light .toolbar-buttons button.ql-active[data-v-326e0004],.toolbar-buttons button.theme-light.ql-active[data-v-326e0004]{background-color:#ddd}.theme-light .toolbar-buttons button.ql-active[data-v-326e0004]:hover,.toolbar-buttons button.theme-light.ql-active[data-v-326e0004]:hover{background-color:#e5e5e5}.toolbar-buttons button[data-v-326e0004]:disabled{cursor:default}.toolbar-buttons button:disabled>i[data-v-326e0004]{opacity:.5}.break[data-v-326e0004]{width:1px;margin:0 8px;height:24px;position:relative}.break[data-v-326e0004]:after{content:\"\";display:block;position:absolute;font-style:normal;width:0;border-left:1px solid #A8A8A8A1;height:24px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-editor-toolbar-buttons/le-editor-toolbar-buttons.vue"],"names":[],"mappings":"AAIA,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,8BAA+B,AACvB,sBAAuB,AAC/B,4CAAiD,AACzC,oCAAyC,AACjD,kBAAmB,AACnB,YAAa,AACb,UAAY,CACb,AACD,2FAEI,yBAA0B,AAC1B,wBAA0B,CAC7B,AACD,6FAEI,yBAA0B,AAC1B,wBAA0B,CAC7B,AACD,yCACI,uBAAwB,AACxB,SAAU,AACV,cAAe,AACf,aAAc,AACd,eAAgB,AAChB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,2CACM,qBAAuB,CAC5B,AACD,6HAEM,wBAA0B,CAC/B,AACD,yIAEQ,wBAA0B,CACjC,AACD,+HAEM,qBAA0B,CAC/B,AACD,2IAEQ,wBAA0B,CACjC,AACD,kDACM,cAAgB,CACrB,AACD,oDACQ,UAAa,CACpB,AACD,wBACE,UAAW,AACX,aAAc,AACd,YAAa,AACb,iBAAmB,CACpB,AACD,8BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,gCAAiC,AACjC,WAAa,CAChB","file":"le-editor-toolbar-buttons.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.toolbar-buttons[data-v-326e0004] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-shadow: 0 4px 4px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 4px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  padding: 5px;\n  margin: 6px;\n}\n.toolbar-buttons.theme-dark[data-v-326e0004],\n  .theme-dark .toolbar-buttons[data-v-326e0004] {\n    background-color: #2d3162;\n    border: 1px solid #595a80;\n}\n.toolbar-buttons.theme-light[data-v-326e0004],\n  .theme-light .toolbar-buttons[data-v-326e0004] {\n    background-color: #f9f9f9;\n    border: 1px solid #e5e5e5;\n}\n.toolbar-buttons button[data-v-326e0004] {\n    background: transparent;\n    border: 0;\n    padding: 0 6px;\n    margin: 0 1px;\n    cursor: pointer;\n    line-height: 22px;\n    border-radius: 2px;\n}\n.toolbar-buttons button > i[data-v-326e0004] {\n      vertical-align: middle;\n}\n.toolbar-buttons button.theme-dark.ql-active[data-v-326e0004],\n    .theme-dark .toolbar-buttons button.ql-active[data-v-326e0004] {\n      background-color: #656a7a;\n}\n.toolbar-buttons button.theme-dark.ql-active[data-v-326e0004]:hover,\n      .theme-dark .toolbar-buttons button.ql-active[data-v-326e0004]:hover {\n        background-color: #535677;\n}\n.toolbar-buttons button.theme-light.ql-active[data-v-326e0004],\n    .theme-light .toolbar-buttons button.ql-active[data-v-326e0004] {\n      background-color: #dddddd;\n}\n.toolbar-buttons button.theme-light.ql-active[data-v-326e0004]:hover,\n      .theme-light .toolbar-buttons button.ql-active[data-v-326e0004]:hover {\n        background-color: #e5e5e5;\n}\n.toolbar-buttons button[data-v-326e0004]:disabled {\n      cursor: default;\n}\n.toolbar-buttons button:disabled > i[data-v-326e0004] {\n        opacity: 0.5;\n}\n.break[data-v-326e0004] {\n  width: 1px;\n  margin: 0 8px;\n  height: 24px;\n  position: relative;\n}\n.break[data-v-326e0004]:after {\n    content: '';\n    display: block;\n    position: absolute;\n    font-style: normal;\n    width: 0;\n    border-left: 1px solid #A8A8A8A1;\n    height: 24px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-buttons",class:_vm.theme},[(_vm.hasBold)?_c('button',{staticClass:"ql-bold",attrs:{"aria-label":_vm.ariaLabels.bold,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-bold-" + _vm.themeName})]):_vm._e(),_vm._v(" "),(_vm.hasItalic)?_c('button',{staticClass:"ql-italic",attrs:{"aria-label":_vm.ariaLabels.italic,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-italic-" + _vm.themeName})]):_vm._e(),_vm._v(" "),(_vm.hasUnderline)?_c('button',{staticClass:"ql-underline",attrs:{"aria-label":_vm.ariaLabels.underline,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-underline-" + _vm.themeName})]):_vm._e(),_vm._v(" "),(_vm.hasList || _vm.hasBullet)?_c('i',{staticClass:"break",attrs:{"role":"separator"}}):_vm._e(),_vm._v(" "),(_vm.hasBullet)?_c('button',{staticClass:"ql-list",attrs:{"value":"bullet","aria-label":_vm.ariaLabels.bulletedList,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-bullets-list-" + _vm.themeName})]):_vm._e(),_vm._v(" "),(_vm.hasList)?_c('button',{staticClass:"ql-list",attrs:{"value":"ordered","aria-label":_vm.ariaLabels.numberedList,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-ordered-list-" + _vm.themeName})]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"break",attrs:{"role":"separator"}}),_vm._v(" "),_c('button',{staticClass:"ql-clean",attrs:{"aria-label":_vm.ariaLabels.clearFormats,"disabled":_vm.isDisabled}},[_c('i',{staticClass:"ico-16",class:"ico-clear-format-" + _vm.themeName})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_accordion_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ced384_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_accordion_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_accordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ced384_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0f11249e", content, true, {});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"le-accordion.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-accordion"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_accordion_item_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f02d88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_accordion_item_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37f02d88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_accordion_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f02d88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_accordion_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("498eadfe", content, true, {});

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-accordion-item[data-v-37f02d88]{margin-top:1px}.le-accordion-item.theme-dark[data-v-37f02d88],.theme-dark .le-accordion-item[data-v-37f02d88]{border-bottom:1px solid transparent}.le-accordion-item.theme-light[data-v-37f02d88],.theme-light .le-accordion-item[data-v-37f02d88]{border-bottom:1px solid #d8d8d8}.le-accordion-item[data-v-37f02d88]:first-child{margin-top:0}.le-accordion-item .header[data-v-37f02d88]{font-size:13px;cursor:pointer;font-weight:700;line-height:1.4;padding:12px 20px}.le-accordion-item .header.theme-dark[data-v-37f02d88],.theme-dark .le-accordion-item .header[data-v-37f02d88]{color:#fff;background-color:hsla(0,0%,100%,.05)}.le-accordion-item .header.theme-light[data-v-37f02d88],.theme-light .le-accordion-item .header[data-v-37f02d88]{color:#161c4f;background-color:#fff}.le-accordion-item .header .header-content[data-v-37f02d88]{width:calc(100% - 15px);display:inline-block}.le-accordion-item .header.disabled[data-v-37f02d88]{cursor:default}.le-accordion-item .header.disabled .toggle-icon.theme-dark[data-v-37f02d88],.le-accordion-item .header.disabled .toggle-icon.theme-light[data-v-37f02d88],.theme-dark .le-accordion-item .header.disabled .toggle-icon[data-v-37f02d88],.theme-light .le-accordion-item .header.disabled .toggle-icon[data-v-37f02d88]{color:#a9afba}.le-accordion-item .content-container[data-v-37f02d88]{overflow-x:hidden;padding:0 20px}.le-accordion-item .content-container .content[data-v-37f02d88]{margin-bottom:10px}.le-accordion-item .toggle-icon[data-v-37f02d88]{margin-top:2px;float:right;opacity:.9}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-collapse/le-accordion-item.vue"],"names":[],"mappings":"AAIA,oCACE,cAAgB,CACjB,AACD,+FAEI,mCAAqC,CACxC,AACD,iGAEI,+BAAiC,CACpC,AACD,gDACI,YAAc,CACjB,AACD,4CACI,eAAgB,AAChB,eAAgB,AAChB,gBAAkB,AAClB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,+GAEM,WAAe,AACf,oCAA4C,CACjD,AACD,iHAEM,cAAe,AACf,qBAA0B,CAC/B,AACD,4DACM,wBAAyB,AACzB,oBAAsB,CAC3B,AACD,qDACM,cAAgB,CACrB,AAKD,wTAEQ,aAAe,CACtB,AACD,uDACI,kBAAmB,AACnB,cAAgB,CACnB,AACD,gEACM,kBAAoB,CACzB,AACD,iDACI,eAAgB,AAChB,YAAa,AACb,UAAa,CAChB","file":"le-accordion-item.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-accordion-item[data-v-37f02d88] {\n  margin-top: 1px;\n}\n.le-accordion-item.theme-dark[data-v-37f02d88],\n  .theme-dark .le-accordion-item[data-v-37f02d88] {\n    border-bottom: 1px solid transparent;\n}\n.le-accordion-item.theme-light[data-v-37f02d88],\n  .theme-light .le-accordion-item[data-v-37f02d88] {\n    border-bottom: 1px solid #d8d8d8;\n}\n.le-accordion-item[data-v-37f02d88]:first-child {\n    margin-top: 0;\n}\n.le-accordion-item .header[data-v-37f02d88] {\n    font-size: 13px;\n    cursor: pointer;\n    font-weight: bold;\n    line-height: 1.4;\n    padding: 12px 20px;\n}\n.le-accordion-item .header.theme-dark[data-v-37f02d88],\n    .theme-dark .le-accordion-item .header[data-v-37f02d88] {\n      color: #ffffff;\n      background-color: rgba(255, 255, 255, 0.05);\n}\n.le-accordion-item .header.theme-light[data-v-37f02d88],\n    .theme-light .le-accordion-item .header[data-v-37f02d88] {\n      color: #161c4f;\n      background-color: #ffffff;\n}\n.le-accordion-item .header .header-content[data-v-37f02d88] {\n      width: calc(100% - 15px);\n      display: inline-block;\n}\n.le-accordion-item .header.disabled[data-v-37f02d88] {\n      cursor: default;\n}\n.le-accordion-item .header.disabled .toggle-icon.theme-dark[data-v-37f02d88],\n      .theme-dark .le-accordion-item .header.disabled .toggle-icon[data-v-37f02d88] {\n        color: #a9afba;\n}\n.le-accordion-item .header.disabled .toggle-icon.theme-light[data-v-37f02d88],\n      .theme-light .le-accordion-item .header.disabled .toggle-icon[data-v-37f02d88] {\n        color: #a9afba;\n}\n.le-accordion-item .content-container[data-v-37f02d88] {\n    overflow-x: hidden;\n    padding: 0 20px;\n}\n.le-accordion-item .content-container .content[data-v-37f02d88] {\n      margin-bottom: 10px;\n}\n.le-accordion-item .toggle-icon[data-v-37f02d88] {\n    margin-top: 2px;\n    float: right;\n    opacity: 0.9;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





var defaultTransitionDuration = 300;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      collapseFunc: undefined,
      collapsed: !this.expanded,
      $_calculatedMaxHeight: 0
    };
  },

  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    fixedMaxHeight: {
      type: Number,
      required: false
    },
    transitionDuration: {
      type: Number,
      required: false,
      default: defaultTransitionDuration
    },
    toggleDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCollapsed: function isCollapsed() {
      return this.collapsed;
    }
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.style['max-height'] = 0;
      el.style['overflow-y'] = 'hidden';
    },
    setCollapsed: function setCollapsed(collapsed) {
      this.collapsed = collapsed;
    },
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, { 'max-height': this.$refs.content.scrollHeight + 'px' }, { duration: this.transitionDuration,
        complete: done
      });
    },
    afterEnter: function afterEnter(el) {
      el.style['max-height'] = 'unset';
    },
    beforeLeave: function beforeLeave(el) {
      var maxHeight = this.$refs.content.scrollHeight;
      el.style['overflow-y'] = 'hidden';
      el.style['max-height'] = maxHeight + 'px';
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, { 'max-height': 0 }, { duration: this.transitionDuration,
        complete: done
      });
    },
    toggleCollapse: function toggleCollapse(silent) {
      var _this = this;

      if (!this.toggleDisabled) {
        if (!this.collapseFunc) {
          this.collapseFunc = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["throttle"])(function () {
            _this.collapsed = !_this.collapsed;
            if (!silent) {
              _this.$emit(_this.collapsed ? 'collapsed' : 'expanded');
            }
          }, this.transitionDuration, { leading: true, trailing: false });
        }
        this.collapseFunc.call(this);
      }
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.5.2). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */

/*************************
 Velocity jQuery Shim
 *************************/

/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */

/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */

(function(window) {
	"use strict";
	/***************
	 Setup
	 ***************/

	/* If jQuery is already loaded, there's no point in loading this shim. */
	if (window.jQuery) {
		return;
	}

	/* jQuery base. */
	var $ = function(selector, context) {
		return new $.fn.init(selector, context);
	};

	/********************
	 Private Methods
	 ********************/

	/* jQuery */
	$.isWindow = function(obj) {
		/* jshint eqeqeq: false */
		return obj && obj === obj.window;
	};

	/* jQuery */
	$.type = function(obj) {
		if (!obj) {
			return obj + "";
		}

		return typeof obj === "object" || typeof obj === "function" ?
				class2type[toString.call(obj)] || "object" :
				typeof obj;
	};

	/* jQuery */
	$.isArray = Array.isArray || function(obj) {
		return $.type(obj) === "array";
	};

	/* jQuery */
	function isArraylike(obj) {
		var length = obj.length,
				type = $.type(obj);

		if (type === "function" || $.isWindow(obj)) {
			return false;
		}

		if (obj.nodeType === 1 && length) {
			return true;
		}

		return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
	}

	/***************
	 $ Methods
	 ***************/

	/* jQuery: Support removed for IE<9. */
	$.isPlainObject = function(obj) {
		var key;

		if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
			return false;
		}

		try {
			if (obj.constructor &&
					!hasOwn.call(obj, "constructor") &&
					!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
				return false;
			}
		} catch (e) {
			return false;
		}

		for (key in obj) {
		}

		return key === undefined || hasOwn.call(obj, key);
	};

	/* jQuery */
	$.each = function(obj, callback, args) {
		var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike(obj);

		if (args) {
			if (isArray) {
				for (; i < length; i++) {
					value = callback.apply(obj[i], args);

					if (value === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (!obj.hasOwnProperty(i)) {
						continue;
					}
					value = callback.apply(obj[i], args);

					if (value === false) {
						break;
					}
				}
			}

		} else {
			if (isArray) {
				for (; i < length; i++) {
					value = callback.call(obj[i], i, obj[i]);

					if (value === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (!obj.hasOwnProperty(i)) {
						continue;
					}
					value = callback.call(obj[i], i, obj[i]);

					if (value === false) {
						break;
					}
				}
			}
		}

		return obj;
	};

	/* Custom */
	$.data = function(node, key, value) {
		/* $.getData() */
		if (value === undefined) {
			var getId = node[$.expando],
					store = getId && cache[getId];

			if (key === undefined) {
				return store;
			} else if (store) {
				if (key in store) {
					return store[key];
				}
			}
			/* $.setData() */
		} else if (key !== undefined) {
			var setId = node[$.expando] || (node[$.expando] = ++$.uuid);

			cache[setId] = cache[setId] || {};
			cache[setId][key] = value;

			return value;
		}
	};

	/* Custom */
	$.removeData = function(node, keys) {
		var id = node[$.expando],
				store = id && cache[id];

		if (store) {
			// Cleanup the entire store if no keys are provided.
			if (!keys) {
				delete cache[id];
			} else {
				$.each(keys, function(_, key) {
					delete store[key];
				});
			}
		}
	};

	/* jQuery */
	$.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
				target = arguments[0] || {},
				i = 1,
				length = arguments.length,
				deep = false;

		if (typeof target === "boolean") {
			deep = target;

			target = arguments[i] || {};
			i++;
		}

		if (typeof target !== "object" && $.type(target) !== "function") {
			target = {};
		}

		if (i === length) {
			target = this;
			i--;
		}

		for (; i < length; i++) {
			if ((options = arguments[i])) {
				for (name in options) {
					if (!options.hasOwnProperty(name)) {
						continue;
					}
					src = target[name];
					copy = options[name];

					if (target === copy) {
						continue;
					}

					if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && $.isArray(src) ? src : [];

						} else {
							clone = src && $.isPlainObject(src) ? src : {};
						}

						target[name] = $.extend(deep, clone, copy);

					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}

		return target;
	};

	/* jQuery 1.4.3 */
	$.queue = function(elem, type, data) {
		function $makeArray(arr, results) {
			var ret = results || [];

			if (arr) {
				if (isArraylike(Object(arr))) {
					/* $.merge */
					(function(first, second) {
						var len = +second.length,
								j = 0,
								i = first.length;

						while (j < len) {
							first[i++] = second[j++];
						}

						if (len !== len) {
							while (second[j] !== undefined) {
								first[i++] = second[j++];
							}
						}

						first.length = i;

						return first;
					})(ret, typeof arr === "string" ? [arr] : arr);
				} else {
					[].push.call(ret, arr);
				}
			}

			return ret;
		}

		if (!elem) {
			return;
		}

		type = (type || "fx") + "queue";

		var q = $.data(elem, type);

		if (!data) {
			return q || [];
		}

		if (!q || $.isArray(data)) {
			q = $.data(elem, type, $makeArray(data));
		} else {
			q.push(data);
		}

		return q;
	};

	/* jQuery 1.4.3 */
	$.dequeue = function(elems, type) {
		/* Custom: Embed element iteration. */
		$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
			type = type || "fx";

			var queue = $.queue(elem, type),
					fn = queue.shift();

			if (fn === "inprogress") {
				fn = queue.shift();
			}

			if (fn) {
				if (type === "fx") {
					queue.unshift("inprogress");
				}

				fn.call(elem, function() {
					$.dequeue(elem, type);
				});
			}
		});
	};

	/******************
	 $.fn Methods
	 ******************/

	/* jQuery */
	$.fn = $.prototype = {
		init: function(selector) {
			/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
			if (selector.nodeType) {
				this[0] = selector;

				return this;
			} else {
				throw new Error("Not a DOM node.");
			}
		},
		offset: function() {
			/* jQuery altered code: Dropped disconnected DOM node checking. */
			var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};

			return {
				top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
				left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
			};
		},
		position: function() {
			/* jQuery */
			function offsetParentFn(elem) {
				var offsetParent = elem.offsetParent;

				while (offsetParent && (offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position.toLowerCase() === "static")) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || document;
			}

			/* Zepto */
			var elem = this[0],
					offsetParent = offsetParentFn(elem),
					offset = this.offset(),
					parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();

			offset.top -= parseFloat(elem.style.marginTop) || 0;
			offset.left -= parseFloat(elem.style.marginLeft) || 0;

			if (offsetParent.style) {
				parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
				parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
			}

			return {
				top: offset.top - parentOffset.top,
				left: offset.left - parentOffset.left
			};
		}
	};

	/**********************
	 Private Variables
	 **********************/

	/* For $.data() */
	var cache = {};
	$.expando = "velocity" + (new Date().getTime());
	$.uuid = 0;

	/* For $.queue() */
	var class2type = {},
			hasOwn = class2type.hasOwnProperty,
			toString = class2type.toString;

	var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
	for (var i = 0; i < types.length; i++) {
		class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
	}

	/* Makes $(node) possible, without having to call init. */
	$.fn.init.prototype = $.fn;

	/* Globalize Velocity onto the window, and assign its Utilities property. */
	window.Velocity = {Utilities: $};
})(window);

/******************
 Velocity.js
 ******************/

(function(factory) {
	"use strict";
	/* CommonJS module. */
	if (typeof module === "object" && typeof module.exports === "object") {
		module.exports = factory();
		/* AMD module. */
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		/* Browser globals. */
	} else {
		factory();
	}
}(function() {
	"use strict";
	return function(global, window, document, undefined) {

		/***************
		 Summary
		 ***************/

		/*
		 - CSS: CSS stack that works independently from the rest of Velocity.
		 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
		 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
		 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
		 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
		 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
		 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
		 - completeCall(): Handles the cleanup process for each Velocity call.
		 */

		/*********************
		 Helper Functions
		 *********************/

		/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
		var IE = (function() {
			if (document.documentMode) {
				return document.documentMode;
			} else {
				for (var i = 7; i > 4; i--) {
					var div = document.createElement("div");

					div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";

					if (div.getElementsByTagName("span").length) {
						div = null;

						return i;
					}
				}
			}

			return undefined;
		})();

		/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
		var rAFShim = (function() {
			var timeLast = 0;

			return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
				var timeCurrent = (new Date()).getTime(),
						timeDelta;

				/* Dynamically set delay on a per-tick basis to match 60fps. */
				/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
				timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
				timeLast = timeCurrent + timeDelta;

				return setTimeout(function() {
					callback(timeCurrent + timeDelta);
				}, timeDelta);
			};
		})();

		var performance = (function() {
			var perf = window.performance || {};

			if (typeof perf.now !== "function") {
				var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : (new Date()).getTime();

				perf.now = function() {
					return (new Date()).getTime() - nowOffset;
				};
			}
			return perf;
		})();

		/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
		function compactSparseArray(array) {
			var index = -1,
					length = array ? array.length : 0,
					result = [];

			while (++index < length) {
				var value = array[index];

				if (value) {
					result.push(value);
				}
			}

			return result;
		}

		/**
		 * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
		 * on host objects like NamedNodeMap, NodeList, and HTMLCollection
		 * (technically, since host objects have been implementation-dependent,
		 * at least before ES2015, IE hasn't needed to work this way).
		 * Also works on strings, fixes IE < 9 to allow an explicit undefined
		 * for the 2nd argument (as in Firefox), and prevents errors when
		 * called on other DOM objects.
		 */
		var _slice = (function() {
			var slice = Array.prototype.slice;

			try {
				// Can't be used with DOM elements in IE < 9
				slice.call(document.documentElement);
				return slice;
			} catch (e) { // Fails in IE < 9

				// This will work for genuine arrays, array-like objects, 
				// NamedNodeMap (attributes, entities, notations),
				// NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
				// and will not fail on other DOM objects (as do DOM elements in IE < 9)
				return function(begin, end) {
					var len = this.length;

					if (typeof begin !== "number") {
						begin = 0;
					}
					// IE < 9 gets unhappy with an undefined end argument
					if (typeof end !== "number") {
						end = len;
					}
					// For native Array objects, we use the native slice function
					if (this.slice) {
						return slice.call(this, begin, end);
					}
					// For array like object we handle it ourselves.
					var i,
							cloned = [],
							// Handle negative value for "begin"
							start = (begin >= 0) ? begin : Math.max(0, len + begin),
							// Handle negative value for "end"
							upTo = end < 0 ? len + end : Math.min(end, len),
							// Actual expected size of the slice
							size = upTo - start;

					if (size > 0) {
						cloned = new Array(size);
						if (this.charAt) {
							for (i = 0; i < size; i++) {
								cloned[i] = this.charAt(start + i);
							}
						} else {
							for (i = 0; i < size; i++) {
								cloned[i] = this[start + i];
							}
						}
					}
					return cloned;
				};
			}
		})();

		/* .indexOf doesn't exist in IE<9 */
		var _inArray = (function() {
			if (Array.prototype.includes) {
				return function(arr, val) {
					return arr.includes(val);
				};
			}
			if (Array.prototype.indexOf) {
				return function(arr, val) {
					return arr.indexOf(val) >= 0;
				};
			}
			return function(arr, val) {
				for (var i = 0; i < arr.length; i++) {
					if (arr[i] === val) {
						return true;
					}
				}
				return false;
			};
		});

		function sanitizeElements(elements) {
			/* Unwrap jQuery/Zepto objects. */
			if (Type.isWrapped(elements)) {
				elements = _slice.call(elements);
				/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
			} else if (Type.isNode(elements)) {
				elements = [elements];
			}

			return elements;
		}

		var Type = {
			isNumber: function(variable) {
				return (typeof variable === "number");
			},
			isString: function(variable) {
				return (typeof variable === "string");
			},
			isArray: Array.isArray || function(variable) {
				return Object.prototype.toString.call(variable) === "[object Array]";
			},
			isFunction: function(variable) {
				return Object.prototype.toString.call(variable) === "[object Function]";
			},
			isNode: function(variable) {
				return variable && variable.nodeType;
			},
			/* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
			/* NOTE: HTMLFormElements also have a length. */
			isWrapped: function(variable) {
				return variable
						&& variable !== window
						&& Type.isNumber(variable.length)
						&& !Type.isString(variable)
						&& !Type.isFunction(variable)
						&& !Type.isNode(variable)
						&& (variable.length === 0 || Type.isNode(variable[0]));
			},
			isSVG: function(variable) {
				return window.SVGElement && (variable instanceof window.SVGElement);
			},
			isEmptyObject: function(variable) {
				for (var name in variable) {
					if (variable.hasOwnProperty(name)) {
						return false;
					}
				}

				return true;
			}
		};

		/*****************
		 Dependencies
		 *****************/

		var $,
				isJQuery = false;

		if (global.fn && global.fn.jquery) {
			$ = global;
			isJQuery = true;
		} else {
			$ = window.Velocity.Utilities;
		}

		if (IE <= 8 && !isJQuery) {
			throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
		} else if (IE <= 7) {
			/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
			jQuery.fn.velocity = jQuery.fn.animate;

			/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
			return;
		}

		/*****************
		 Constants
		 *****************/

		var DURATION_DEFAULT = 400,
				EASING_DEFAULT = "swing";

		/*************
		 State
		 *************/

		var Velocity = {
			/* Container for page-wide Velocity state data. */
			State: {
				/* Detect mobile devices to determine if mobileHA should be turned on. */
				isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
				/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
				isAndroid: /Android/i.test(window.navigator.userAgent),
				isGingerbread: /Android 2\.3\.[3-7]/i.test(window.navigator.userAgent),
				isChrome: window.chrome,
				isFirefox: /Firefox/i.test(window.navigator.userAgent),
				/* Create a cached element for re-use when checking for CSS property prefixes. */
				prefixElement: document.createElement("div"),
				/* Cache every prefix match to avoid repeating lookups. */
				prefixMatches: {},
				/* Cache the anchor used for animating window scrolling. */
				scrollAnchor: null,
				/* Cache the browser-specific property names associated with the scroll anchor. */
				scrollPropertyLeft: null,
				scrollPropertyTop: null,
				/* Keep track of whether our RAF tick is running. */
				isTicking: false,
				/* Container for every in-progress call to Velocity. */
				calls: [],
				delayedElements: {
					count: 0
				}
			},
			/* Velocity's custom CSS stack. Made global for unit testing. */
			CSS: {/* Defined below. */},
			/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
			Utilities: $,
			/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
			Redirects: {/* Manually registered by the user. */},
			Easings: {/* Defined below. */},
			/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
			Promise: window.Promise,
			/* Velocity option defaults, which can be overriden by the user. */
			defaults: {
				queue: "",
				duration: DURATION_DEFAULT,
				easing: EASING_DEFAULT,
				begin: undefined,
				complete: undefined,
				progress: undefined,
				display: undefined,
				visibility: undefined,
				loop: false,
				delay: false,
				mobileHA: true,
				/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
				_cacheValues: true,
				/* Advanced: Set to false if the promise should always resolve on empty element lists. */
				promiseRejectEmpty: true
			},
			/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
			init: function(element) {
				$.data(element, "velocity", {
					/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
					isSVG: Type.isSVG(element),
					/* Keep track of whether the element is currently being animated by Velocity.
					 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
					isAnimating: false,
					/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					computedStyle: null,
					/* Tween data is cached for each animation on the element so that data can be passed across calls --
					 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
					tweensContainer: null,
					/* The full root property values of each CSS hook being animated on this element are cached so that:
					 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
					 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
					rootPropertyValueCache: {},
					/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
					transformCache: {}
				});
			},
			/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
			hook: null, /* Defined below. */
			/* Velocity-wide animation time remapping for testing purposes. */
			mock: false,
			version: {major: 1, minor: 5, patch: 2},
			/* Set to 1 or 2 (most verbose) to output debug info to console. */
			debug: false,
			/* Use rAF high resolution timestamp when available */
			timestamp: true,
			/* Pause all animations */
			pauseAll: function(queueName) {
				var currentTime = (new Date()).getTime();

				$.each(Velocity.State.calls, function(i, activeCall) {

					if (activeCall) {

						/* If we have a queueName and this call is not on that queue, skip */
						if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
							return true;
						}

						/* Set call to paused */
						activeCall[5] = {
							resume: false
						};
					}
				});

				/* Pause timers on any currently delayed calls */
				$.each(Velocity.State.delayedElements, function(k, element) {
					if (!element) {
						return;
					}
					pauseDelayOnElement(element, currentTime);
				});
			},
			/* Resume all animations */
			resumeAll: function(queueName) {
				var currentTime = (new Date()).getTime();

				$.each(Velocity.State.calls, function(i, activeCall) {

					if (activeCall) {

						/* If we have a queueName and this call is not on that queue, skip */
						if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
							return true;
						}

						/* Set call to resumed if it was paused */
						if (activeCall[5]) {
							activeCall[5].resume = true;
						}
					}
				});
				/* Resume timers on any currently delayed calls */
				$.each(Velocity.State.delayedElements, function(k, element) {
					if (!element) {
						return;
					}
					resumeDelayOnElement(element, currentTime);
				});
			}
		};

		/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
		if (window.pageYOffset !== undefined) {
			Velocity.State.scrollAnchor = window;
			Velocity.State.scrollPropertyLeft = "pageXOffset";
			Velocity.State.scrollPropertyTop = "pageYOffset";
		} else {
			Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
			Velocity.State.scrollPropertyLeft = "scrollLeft";
			Velocity.State.scrollPropertyTop = "scrollTop";
		}

		/* Shorthand alias for jQuery's $.data() utility. */
		function Data(element) {
			/* Hardcode a reference to the plugin name. */
			var response = $.data(element, "velocity");

			/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
			return response === null ? undefined : response;
		}

		/**************
		 Delay Timer
		 **************/

		function pauseDelayOnElement(element, currentTime) {
			/* Check for any delay timers, and pause the set timeouts (while preserving time data)
			 to be resumed when the "resume" command is issued */
			var data = Data(element);
			if (data && data.delayTimer && !data.delayPaused) {
				data.delayRemaining = data.delay - currentTime + data.delayBegin;
				data.delayPaused = true;
				clearTimeout(data.delayTimer.setTimeout);
			}
		}

		function resumeDelayOnElement(element, currentTime) {
			/* Check for any paused timers and resume */
			var data = Data(element);
			if (data && data.delayTimer && data.delayPaused) {
				/* If the element was mid-delay, re initiate the timeout with the remaining delay */
				data.delayPaused = false;
				data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
			}
		}



		/**************
		 Easing
		 **************/

		/* Step easing generator. */
		function generateStep(steps) {
			return function(p) {
				return Math.round(p * steps) * (1 / steps);
			};
		}

		/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
		function generateBezier(mX1, mY1, mX2, mY2) {
			var NEWTON_ITERATIONS = 4,
					NEWTON_MIN_SLOPE = 0.001,
					SUBDIVISION_PRECISION = 0.0000001,
					SUBDIVISION_MAX_ITERATIONS = 10,
					kSplineTableSize = 11,
					kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
					float32ArraySupported = "Float32Array" in window;

			/* Must contain four arguments. */
			if (arguments.length !== 4) {
				return false;
			}

			/* Arguments must be numbers. */
			for (var i = 0; i < 4; ++i) {
				if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
					return false;
				}
			}

			/* X values must be in the [0, 1] range. */
			mX1 = Math.min(mX1, 1);
			mX2 = Math.min(mX2, 1);
			mX1 = Math.max(mX1, 0);
			mX2 = Math.max(mX2, 0);

			var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

			function A(aA1, aA2) {
				return 1.0 - 3.0 * aA2 + 3.0 * aA1;
			}
			function B(aA1, aA2) {
				return 3.0 * aA2 - 6.0 * aA1;
			}
			function C(aA1) {
				return 3.0 * aA1;
			}

			function calcBezier(aT, aA1, aA2) {
				return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
			}

			function getSlope(aT, aA1, aA2) {
				return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
			}

			function newtonRaphsonIterate(aX, aGuessT) {
				for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
					var currentSlope = getSlope(aGuessT, mX1, mX2);

					if (currentSlope === 0.0) {
						return aGuessT;
					}

					var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
					aGuessT -= currentX / currentSlope;
				}

				return aGuessT;
			}

			function calcSampleValues() {
				for (var i = 0; i < kSplineTableSize; ++i) {
					mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
				}
			}

			function binarySubdivide(aX, aA, aB) {
				var currentX, currentT, i = 0;

				do {
					currentT = aA + (aB - aA) / 2.0;
					currentX = calcBezier(currentT, mX1, mX2) - aX;
					if (currentX > 0.0) {
						aB = currentT;
					} else {
						aA = currentT;
					}
				} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

				return currentT;
			}

			function getTForX(aX) {
				var intervalStart = 0.0,
						currentSample = 1,
						lastSample = kSplineTableSize - 1;

				for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
					intervalStart += kSampleStepSize;
				}

				--currentSample;

				var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
						guessForT = intervalStart + dist * kSampleStepSize,
						initialSlope = getSlope(guessForT, mX1, mX2);

				if (initialSlope >= NEWTON_MIN_SLOPE) {
					return newtonRaphsonIterate(aX, guessForT);
				} else if (initialSlope === 0.0) {
					return guessForT;
				} else {
					return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
				}
			}

			var _precomputed = false;

			function precompute() {
				_precomputed = true;
				if (mX1 !== mY1 || mX2 !== mY2) {
					calcSampleValues();
				}
			}

			var f = function(aX) {
				if (!_precomputed) {
					precompute();
				}
				if (mX1 === mY1 && mX2 === mY2) {
					return aX;
				}
				if (aX === 0) {
					return 0;
				}
				if (aX === 1) {
					return 1;
				}

				return calcBezier(getTForX(aX), mY1, mY2);
			};

			f.getControlPoints = function() {
				return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
			};

			var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
			f.toString = function() {
				return str;
			};

			return f;
		}

		/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
		/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
		 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
		var generateSpringRK4 = (function() {
			function springAccelerationForState(state) {
				return (-state.tension * state.x) - (state.friction * state.v);
			}

			function springEvaluateStateWithDerivative(initialState, dt, derivative) {
				var state = {
					x: initialState.x + derivative.dx * dt,
					v: initialState.v + derivative.dv * dt,
					tension: initialState.tension,
					friction: initialState.friction
				};

				return {dx: state.v, dv: springAccelerationForState(state)};
			}

			function springIntegrateState(state, dt) {
				var a = {
					dx: state.v,
					dv: springAccelerationForState(state)
				},
						b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
						c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
						d = springEvaluateStateWithDerivative(state, dt, c),
						dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
						dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);

				state.x = state.x + dxdt * dt;
				state.v = state.v + dvdt * dt;

				return state;
			}

			return function springRK4Factory(tension, friction, duration) {

				var initState = {
					x: -1,
					v: 0,
					tension: null,
					friction: null
				},
						path = [0],
						time_lapsed = 0,
						tolerance = 1 / 10000,
						DT = 16 / 1000,
						have_duration, dt, last_state;

				tension = parseFloat(tension) || 500;
				friction = parseFloat(friction) || 20;
				duration = duration || null;

				initState.tension = tension;
				initState.friction = friction;

				have_duration = duration !== null;

				/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
				if (have_duration) {
					/* Run the simulation without a duration. */
					time_lapsed = springRK4Factory(tension, friction);
					/* Compute the adjusted time delta. */
					dt = time_lapsed / duration * DT;
				} else {
					dt = DT;
				}

				while (true) {
					/* Next/step function .*/
					last_state = springIntegrateState(last_state || initState, dt);
					/* Store the position. */
					path.push(1 + last_state.x);
					time_lapsed += 16;
					/* If the change threshold is reached, break. */
					if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
						break;
					}
				}

				/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
				 computed path and returns a snapshot of the position according to a given percentComplete. */
				return !have_duration ? time_lapsed : function(percentComplete) {
					return path[ (percentComplete * (path.length - 1)) | 0 ];
				};
			};
		}());

		/* jQuery easings. */
		Velocity.Easings = {
			linear: function(p) {
				return p;
			},
			swing: function(p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
			spring: function(p) {
				return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
			}
		};

		/* CSS3 and Robert Penner easings. */
		$.each(
				[
					["ease", [0.25, 0.1, 0.25, 1.0]],
					["ease-in", [0.42, 0.0, 1.00, 1.0]],
					["ease-out", [0.00, 0.0, 0.58, 1.0]],
					["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
					["easeInSine", [0.47, 0, 0.745, 0.715]],
					["easeOutSine", [0.39, 0.575, 0.565, 1]],
					["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
					["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
					["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
					["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
					["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
					["easeOutCubic", [0.215, 0.61, 0.355, 1]],
					["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
					["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
					["easeOutQuart", [0.165, 0.84, 0.44, 1]],
					["easeInOutQuart", [0.77, 0, 0.175, 1]],
					["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
					["easeOutQuint", [0.23, 1, 0.32, 1]],
					["easeInOutQuint", [0.86, 0, 0.07, 1]],
					["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
					["easeOutExpo", [0.19, 1, 0.22, 1]],
					["easeInOutExpo", [1, 0, 0, 1]],
					["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
					["easeOutCirc", [0.075, 0.82, 0.165, 1]],
					["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
				], function(i, easingArray) {
			Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
		});

		/* Determine the appropriate easing type given an easing input. */
		function getEasing(value, duration) {
			var easing = value;

			/* The easing option can either be a string that references a pre-registered easing,
			 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
			if (Type.isString(value)) {
				/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
				if (!Velocity.Easings[value]) {
					easing = false;
				}
			} else if (Type.isArray(value) && value.length === 1) {
				easing = generateStep.apply(null, value);
			} else if (Type.isArray(value) && value.length === 2) {
				/* springRK4 must be passed the animation's duration. */
				/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
				 function generated with default tension and friction values. */
				easing = generateSpringRK4.apply(null, value.concat([duration]));
			} else if (Type.isArray(value) && value.length === 4) {
				/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
				easing = generateBezier.apply(null, value);
			} else {
				easing = false;
			}

			/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
			 if the Velocity-wide default has been incorrectly modified. */
			if (easing === false) {
				if (Velocity.Easings[Velocity.defaults.easing]) {
					easing = Velocity.defaults.easing;
				} else {
					easing = EASING_DEFAULT;
				}
			}

			return easing;
		}

		/*****************
		 CSS Stack
		 *****************/

		/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
		 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
		/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
		var CSS = Velocity.CSS = {
			/*************
			 RegEx
			 *************/

			RegEx: {
				isHex: /^#([A-f\d]{3}){1,2}$/i,
				/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
				valueUnwrap: /^[A-z]+\((.*)\)$/i,
				wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
				/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
				valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
			},
			/************
			 Lists
			 ************/

			Lists: {
				colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
				transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
				transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
				units: [
					"%", // relative
					"em", "ex", "ch", "rem", // font relative
					"vw", "vh", "vmin", "vmax", // viewport relative
					"cm", "mm", "Q", "in", "pc", "pt", "px", // absolute lengths
					"deg", "grad", "rad", "turn", // angles
					"s", "ms" // time
				],
				colorNames: {
					"aliceblue": "240,248,255",
					"antiquewhite": "250,235,215",
					"aquamarine": "127,255,212",
					"aqua": "0,255,255",
					"azure": "240,255,255",
					"beige": "245,245,220",
					"bisque": "255,228,196",
					"black": "0,0,0",
					"blanchedalmond": "255,235,205",
					"blueviolet": "138,43,226",
					"blue": "0,0,255",
					"brown": "165,42,42",
					"burlywood": "222,184,135",
					"cadetblue": "95,158,160",
					"chartreuse": "127,255,0",
					"chocolate": "210,105,30",
					"coral": "255,127,80",
					"cornflowerblue": "100,149,237",
					"cornsilk": "255,248,220",
					"crimson": "220,20,60",
					"cyan": "0,255,255",
					"darkblue": "0,0,139",
					"darkcyan": "0,139,139",
					"darkgoldenrod": "184,134,11",
					"darkgray": "169,169,169",
					"darkgrey": "169,169,169",
					"darkgreen": "0,100,0",
					"darkkhaki": "189,183,107",
					"darkmagenta": "139,0,139",
					"darkolivegreen": "85,107,47",
					"darkorange": "255,140,0",
					"darkorchid": "153,50,204",
					"darkred": "139,0,0",
					"darksalmon": "233,150,122",
					"darkseagreen": "143,188,143",
					"darkslateblue": "72,61,139",
					"darkslategray": "47,79,79",
					"darkturquoise": "0,206,209",
					"darkviolet": "148,0,211",
					"deeppink": "255,20,147",
					"deepskyblue": "0,191,255",
					"dimgray": "105,105,105",
					"dimgrey": "105,105,105",
					"dodgerblue": "30,144,255",
					"firebrick": "178,34,34",
					"floralwhite": "255,250,240",
					"forestgreen": "34,139,34",
					"fuchsia": "255,0,255",
					"gainsboro": "220,220,220",
					"ghostwhite": "248,248,255",
					"gold": "255,215,0",
					"goldenrod": "218,165,32",
					"gray": "128,128,128",
					"grey": "128,128,128",
					"greenyellow": "173,255,47",
					"green": "0,128,0",
					"honeydew": "240,255,240",
					"hotpink": "255,105,180",
					"indianred": "205,92,92",
					"indigo": "75,0,130",
					"ivory": "255,255,240",
					"khaki": "240,230,140",
					"lavenderblush": "255,240,245",
					"lavender": "230,230,250",
					"lawngreen": "124,252,0",
					"lemonchiffon": "255,250,205",
					"lightblue": "173,216,230",
					"lightcoral": "240,128,128",
					"lightcyan": "224,255,255",
					"lightgoldenrodyellow": "250,250,210",
					"lightgray": "211,211,211",
					"lightgrey": "211,211,211",
					"lightgreen": "144,238,144",
					"lightpink": "255,182,193",
					"lightsalmon": "255,160,122",
					"lightseagreen": "32,178,170",
					"lightskyblue": "135,206,250",
					"lightslategray": "119,136,153",
					"lightsteelblue": "176,196,222",
					"lightyellow": "255,255,224",
					"limegreen": "50,205,50",
					"lime": "0,255,0",
					"linen": "250,240,230",
					"magenta": "255,0,255",
					"maroon": "128,0,0",
					"mediumaquamarine": "102,205,170",
					"mediumblue": "0,0,205",
					"mediumorchid": "186,85,211",
					"mediumpurple": "147,112,219",
					"mediumseagreen": "60,179,113",
					"mediumslateblue": "123,104,238",
					"mediumspringgreen": "0,250,154",
					"mediumturquoise": "72,209,204",
					"mediumvioletred": "199,21,133",
					"midnightblue": "25,25,112",
					"mintcream": "245,255,250",
					"mistyrose": "255,228,225",
					"moccasin": "255,228,181",
					"navajowhite": "255,222,173",
					"navy": "0,0,128",
					"oldlace": "253,245,230",
					"olivedrab": "107,142,35",
					"olive": "128,128,0",
					"orangered": "255,69,0",
					"orange": "255,165,0",
					"orchid": "218,112,214",
					"palegoldenrod": "238,232,170",
					"palegreen": "152,251,152",
					"paleturquoise": "175,238,238",
					"palevioletred": "219,112,147",
					"papayawhip": "255,239,213",
					"peachpuff": "255,218,185",
					"peru": "205,133,63",
					"pink": "255,192,203",
					"plum": "221,160,221",
					"powderblue": "176,224,230",
					"purple": "128,0,128",
					"red": "255,0,0",
					"rosybrown": "188,143,143",
					"royalblue": "65,105,225",
					"saddlebrown": "139,69,19",
					"salmon": "250,128,114",
					"sandybrown": "244,164,96",
					"seagreen": "46,139,87",
					"seashell": "255,245,238",
					"sienna": "160,82,45",
					"silver": "192,192,192",
					"skyblue": "135,206,235",
					"slateblue": "106,90,205",
					"slategray": "112,128,144",
					"snow": "255,250,250",
					"springgreen": "0,255,127",
					"steelblue": "70,130,180",
					"tan": "210,180,140",
					"teal": "0,128,128",
					"thistle": "216,191,216",
					"tomato": "255,99,71",
					"turquoise": "64,224,208",
					"violet": "238,130,238",
					"wheat": "245,222,179",
					"whitesmoke": "245,245,245",
					"white": "255,255,255",
					"yellowgreen": "154,205,50",
					"yellow": "255,255,0"
				}
			},
			/************
			 Hooks
			 ************/

			/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
			 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
			/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
			 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
			Hooks: {
				/********************
				 Registration
				 ********************/

				/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
				/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
				templates: {
					"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
					"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
					"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
					"backgroundPosition": ["X Y", "0% 0%"],
					"transformOrigin": ["X Y Z", "50% 50% 0px"],
					"perspectiveOrigin": ["X Y", "50% 50%"]
				},
				/* A "registered" hook is one that has been converted from its template form into a live,
				 tweenable property. It contains data to associate it with its root property. */
				registered: {
					/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
					 which consists of the subproperty's name, the associated root property's name,
					 and the subproperty's position in the root's value. */
				},
				/* Convert the templates into individual hooks then append them to the registered object above. */
				register: function() {
					/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
					 currently set to "transparent" default to their respective template below when color-animated,
					 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
					 which is almost always set closer to black than white. */
					for (var i = 0; i < CSS.Lists.colors.length; i++) {
						var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
						CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
					}

					var rootProperty,
							hookTemplate,
							hookNames;

					/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
					 Thus, we re-arrange the templates accordingly. */
					if (IE) {
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");

							var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);

							if (hookNames[0] === "Color") {
								/* Reposition both the hook's name and its default value to the end of their respective strings. */
								hookNames.push(hookNames.shift());
								defaultValues.push(defaultValues.shift());

								/* Replace the existing template for the hook's root property. */
								CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
							}
						}
					}

					/* Hook registration. */
					for (rootProperty in CSS.Hooks.templates) {
						if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
							continue;
						}
						hookTemplate = CSS.Hooks.templates[rootProperty];
						hookNames = hookTemplate[0].split(" ");

						for (var j in hookNames) {
							if (!hookNames.hasOwnProperty(j)) {
								continue;
							}
							var fullHookName = rootProperty + hookNames[j],
									hookPosition = j;

							/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
							 and the hook's position in its template's default value string. */
							CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
						}
					}
				},
				/*****************************
				 Injection and Extraction
				 *****************************/

				/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
				/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
				getRoot: function(property) {
					var hookData = CSS.Hooks.registered[property];

					if (hookData) {
						return hookData[0];
					} else {
						/* If there was no hook match, return the property name untouched. */
						return property;
					}
				},
				getUnit: function(str, start) {
					var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";

					if (unit && _inArray(CSS.Lists.units, unit)) {
						return unit;
					}
					return "";
				},
				fixColors: function(str) {
					return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function($0, $1, $2) {
						if (CSS.Lists.colorNames.hasOwnProperty($2)) {
							return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
						}
						return $1 + $2;
					});
				},
				/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
				 the targeted hook can be injected or extracted at its standard position. */
				cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
					/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
					if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
						rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
					}

					/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
					 default to the root's default value as defined in CSS.Hooks.templates. */
					/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
					 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
					if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
						rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
					}

					return rootPropertyValue;
				},
				/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
				extractValue: function(fullHookName, rootPropertyValue) {
					var hookData = CSS.Hooks.registered[fullHookName];

					if (hookData) {
						var hookRoot = hookData[0],
								hookPosition = hookData[1];

						rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

						/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
						return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
					} else {
						/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
						return rootPropertyValue;
					}
				},
				/* Inject the hook's value into its root property's value. This is used to piece back together the root property
				 once Velocity has updated one of its individually hooked values through tweening. */
				injectValue: function(fullHookName, hookValue, rootPropertyValue) {
					var hookData = CSS.Hooks.registered[fullHookName];

					if (hookData) {
						var hookRoot = hookData[0],
								hookPosition = hookData[1],
								rootPropertyValueParts,
								rootPropertyValueUpdated;

						rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

						/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
						 then reconstruct the rootPropertyValue string. */
						rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
						rootPropertyValueParts[hookPosition] = hookValue;
						rootPropertyValueUpdated = rootPropertyValueParts.join(" ");

						return rootPropertyValueUpdated;
					} else {
						/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
						return rootPropertyValue;
					}
				}
			},
			/*******************
			 Normalizations
			 *******************/

			/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
			 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
			Normalizations: {
				/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
				 the targeted element (which may need to be queried), and the targeted property value. */
				registered: {
					clip: function(type, element, propertyValue) {
						switch (type) {
							case "name":
								return "clip";
								/* Clip needs to be unwrapped and stripped of its commas during extraction. */
							case "extract":
								var extracted;

								/* If Velocity also extracted this value, skip extraction. */
								if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
									extracted = propertyValue;
								} else {
									/* Remove the "rect()" wrapper. */
									extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);

									/* Strip off commas. */
									extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
								}

								return extracted;
								/* Clip needs to be re-wrapped during injection. */
							case "inject":
								return "rect(" + propertyValue + ")";
						}
					},
					blur: function(type, element, propertyValue) {
						switch (type) {
							case "name":
								return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
							case "extract":
								var extracted = parseFloat(propertyValue);

								/* If extracted is NaN, meaning the value isn't already extracted. */
								if (!(extracted || extracted === 0)) {
									var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);

									/* If the filter string had a blur component, return just the blur value and unit type. */
									if (blurComponent) {
										extracted = blurComponent[1];
										/* If the component doesn't exist, default blur to 0. */
									} else {
										extracted = 0;
									}
								}

								return extracted;
								/* Blur needs to be re-wrapped during injection. */
							case "inject":
								/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
								if (!parseFloat(propertyValue)) {
									return "none";
								} else {
									return "blur(" + propertyValue + ")";
								}
						}
					},
					/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
					opacity: function(type, element, propertyValue) {
						if (IE <= 8) {
							switch (type) {
								case "name":
									return "filter";
								case "extract":
									/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
									 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
									var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);

									if (extracted) {
										/* Convert to decimal value. */
										propertyValue = extracted[1] / 100;
									} else {
										/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
										propertyValue = 1;
									}

									return propertyValue;
								case "inject":
									/* Opacified elements are required to have their zoom property set to a non-zero value. */
									element.style.zoom = 1;

									/* Setting the filter property on elements with certain font property combinations can result in a
									 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
									 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
									if (parseFloat(propertyValue) >= 1) {
										return "";
									} else {
										/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
										return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
									}
							}
							/* With all other browsers, normalization is not required; return the same values that were passed in. */
						} else {
							switch (type) {
								case "name":
									return "opacity";
								case "extract":
									return propertyValue;
								case "inject":
									return propertyValue;
							}
						}
					}
				},
				/*****************************
				 Batched Registrations
				 *****************************/

				/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
				register: function() {

					/*****************
					 Transforms
					 *****************/

					/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
					 so that they can be referenced in a properties map by their individual names. */
					/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
					 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
					 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
					 once when multiple transform subproperties are being animated simultaneously. */
					/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
					 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
					 from being normalized for these browsers so that tweening skips these properties altogether
					 (since it will ignore them as being unsupported by the browser.) */
					if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
						/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
						 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
						CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
					}

					for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
						/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
						 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
						(function() {
							var transformName = CSS.Lists.transformsBase[i];

							CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
								switch (type) {
									/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
									case "name":
										return "transform";
										/* Transform values are cached onto a per-element transformCache object. */
									case "extract":
										/* If this transform has yet to be assigned a value, return its null value. */
										if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
											/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
											return /^scale/i.test(transformName) ? 1 : 0;
											/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
											 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
										}
										return Data(element).transformCache[transformName].replace(/[()]/g, "");
									case "inject":
										var invalid = false;

										/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
										 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
										/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
										switch (transformName.substr(0, transformName.length - 1)) {
											/* Whitelist unit types for each transform. */
											case "translate":
												invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
												break;
												/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
											case "scal":
											case "scale":
												/* Chrome on Android has a bug in which scaled elements blur if their initial scale
												 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
												 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
												if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
													propertyValue = 1;
												}

												invalid = !/(\d)$/i.test(propertyValue);
												break;
											case "skew":
												invalid = !/(deg|\d)$/i.test(propertyValue);
												break;
											case "rotate":
												invalid = !/(deg|\d)$/i.test(propertyValue);
												break;
										}

										if (!invalid) {
											/* As per the CSS spec, wrap the value in parentheses. */
											Data(element).transformCache[transformName] = "(" + propertyValue + ")";
										}

										/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
										return Data(element).transformCache[transformName];
								}
							};
						})();
					}

					/*************
					 Colors
					 *************/

					/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
					 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
					for (var j = 0; j < CSS.Lists.colors.length; j++) {
						/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
						 (Otherwise, all functions would take the final for loop's colorName.) */
						(function() {
							var colorName = CSS.Lists.colors[j];

							/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
							CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
								switch (type) {
									case "name":
										return colorName;
										/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
									case "extract":
										var extracted;

										/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
										if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
											extracted = propertyValue;
										} else {
											var converted,
													colorNames = {
														black: "rgb(0, 0, 0)",
														blue: "rgb(0, 0, 255)",
														gray: "rgb(128, 128, 128)",
														green: "rgb(0, 128, 0)",
														red: "rgb(255, 0, 0)",
														white: "rgb(255, 255, 255)"
													};

											/* Convert color names to rgb. */
											if (/^[A-z]+$/i.test(propertyValue)) {
												if (colorNames[propertyValue] !== undefined) {
													converted = colorNames[propertyValue];
												} else {
													/* If an unmatched color name is provided, default to black. */
													converted = colorNames.black;
												}
												/* Convert hex values to rgb. */
											} else if (CSS.RegEx.isHex.test(propertyValue)) {
												converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
												/* If the provided color doesn't match any of the accepted color formats, default to black. */
											} else if (!(/^rgba?\(/i.test(propertyValue))) {
												converted = colorNames.black;
											}

											/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
											 repeated spaces (in case the value included spaces to begin with). */
											extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
										}

										/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
										if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
											extracted += " 1";
										}

										return extracted;
									case "inject":
										/* If we have a pattern then it might already have the right values */
										if (/^rgb/.test(propertyValue)) {
											return propertyValue;
										}

										/* If this is IE<=8 and an alpha component exists, strip it off. */
										if (IE <= 8) {
											if (propertyValue.split(" ").length === 4) {
												propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
											}
											/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
										} else if (propertyValue.split(" ").length === 3) {
											propertyValue += " 1";
										}

										/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
										 on all values but the fourth (R, G, and B only accept whole numbers). */
										return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
								}
							};
						})();
					}

					/**************
					 Dimensions
					 **************/
					function augmentDimension(name, element, wantInner) {
						var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";

						if (isBorderBox === (wantInner || false)) {
							/* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
							var i,
									value,
									augment = 0,
									sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
									fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];

							for (i = 0; i < fields.length; i++) {
								value = parseFloat(CSS.getPropertyValue(element, fields[i]));
								if (!isNaN(value)) {
									augment += value;
								}
							}
							return wantInner ? -augment : augment;
						}
						return 0;
					}
					function getDimension(name, wantInner) {
						return function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return name;
								case "extract":
									return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
								case "inject":
									return (parseFloat(propertyValue) - augmentDimension(name, element, wantInner)) + "px";
							}
						};
					}
					CSS.Normalizations.registered.innerWidth = getDimension("width", true);
					CSS.Normalizations.registered.innerHeight = getDimension("height", true);
					CSS.Normalizations.registered.outerWidth = getDimension("width");
					CSS.Normalizations.registered.outerHeight = getDimension("height");
				}
			},
			/************************
			 CSS Property Names
			 ************************/

			Names: {
				/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
				 Camelcasing is used to normalize property names between and across calls. */
				camelCase: function(property) {
					return property.replace(/-(\w)/g, function(match, subMatch) {
						return subMatch.toUpperCase();
					});
				},
				/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
				SVGAttribute: function(property) {
					var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";

					/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
					if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
						SVGAttributes += "|transform";
					}

					return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
				},
				/* Determine whether a property should be set with a vendor prefix. */
				/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
				 If the property is not at all supported by the browser, return a false flag. */
				prefixCheck: function(property) {
					/* If this property has already been checked, return the cached value. */
					if (Velocity.State.prefixMatches[property]) {
						return [Velocity.State.prefixMatches[property], true];
					} else {
						var vendors = ["", "Webkit", "Moz", "ms", "O"];

						for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
							var propertyPrefixed;

							if (i === 0) {
								propertyPrefixed = property;
							} else {
								/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
								propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
									return match.toUpperCase();
								});
							}

							/* Check if the browser supports this property as prefixed. */
							if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
								/* Cache the match. */
								Velocity.State.prefixMatches[property] = propertyPrefixed;

								return [propertyPrefixed, true];
							}
						}

						/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
						return [property, false];
					}
				}
			},
			/************************
			 CSS Property Values
			 ************************/

			Values: {
				/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
				hexToRgb: function(hex) {
					var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
							longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
							rgbParts;

					hex = hex.replace(shortformRegex, function(m, r, g, b) {
						return r + r + g + g + b + b;
					});

					rgbParts = longformRegex.exec(hex);

					return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
				},
				isCSSNullValue: function(value) {
					/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
					 Thus, we check for both falsiness and these special strings. */
					/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
					 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
					/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
					return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
				},
				/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
				getUnitType: function(property) {
					if (/^(rotate|skew)/i.test(property)) {
						return "deg";
					} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
						/* The above properties are unitless. */
						return "";
					} else {
						/* Default to px for all other properties. */
						return "px";
					}
				},
				/* HTML elements default to an associated display type when they're not set to display:none. */
				/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
				getDisplayType: function(element) {
					var tagName = element && element.tagName.toString().toLowerCase();

					if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
						return "inline";
					} else if (/^(li)$/i.test(tagName)) {
						return "list-item";
					} else if (/^(tr)$/i.test(tagName)) {
						return "table-row";
					} else if (/^(table)$/i.test(tagName)) {
						return "table";
					} else if (/^(tbody)$/i.test(tagName)) {
						return "table-row-group";
						/* Default to "block" when no match is found. */
					} else {
						return "block";
					}
				},
				/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
				addClass: function(element, className) {
					if (element) {
						if (element.classList) {
							element.classList.add(className);
						} else if (Type.isString(element.className)) {
							// Element.className is around 15% faster then set/getAttribute
							element.className += (element.className.length ? " " : "") + className;
						} else {
							// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
							var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

							element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
						}
					}
				},
				removeClass: function(element, className) {
					if (element) {
						if (element.classList) {
							element.classList.remove(className);
						} else if (Type.isString(element.className)) {
							// Element.className is around 15% faster then set/getAttribute
							// TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
							element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
						} else {
							// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
							var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

							element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
						}
					}
				}
			},
			/****************************
			 Style Getting & Setting
			 ****************************/

			/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
			getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
				/* Get an element's computed property value. */
				/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
				 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
				 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
				function computePropertyValue(element, property) {
					/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
					 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
					 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
					 We subtract border and padding to get the sum of interior + scrollbar. */
					var computedValue = 0;

					/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
					 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
					 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
					 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
					if (IE <= 8) {
						computedValue = $.css(element, property); /* GET */
						/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
						 associated element so that it does not need to be refetched upon every GET. */
					} else {
						/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
						 toggle display to the element type's default value. */
						var toggleDisplay = false;

						if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
							toggleDisplay = true;
							CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
						}

						var revertDisplay = function() {
							if (toggleDisplay) {
								CSS.setPropertyValue(element, "display", "none");
							}
						};

						if (!forceStyleLookup) {
							if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
								var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
								revertDisplay();

								return contentBoxHeight;
							} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
								var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
								revertDisplay();

								return contentBoxWidth;
							}
						}

						var computedStyle;

						/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
						 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
						if (Data(element) === undefined) {
							computedStyle = window.getComputedStyle(element, null); /* GET */
							/* If the computedStyle object has yet to be cached, do so now. */
						} else if (!Data(element).computedStyle) {
							computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
							/* If computedStyle is cached, use it. */
						} else {
							computedStyle = Data(element).computedStyle;
						}

						/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
						 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
						 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
						if (property === "borderColor") {
							property = "borderTopColor";
						}

						/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
						 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
						if (IE === 9 && property === "filter") {
							computedValue = computedStyle.getPropertyValue(property); /* GET */
						} else {
							computedValue = computedStyle[property];
						}

						/* Fall back to the property's style value (if defined) when computedValue returns nothing,
						 which can happen when the element hasn't been painted. */
						if (computedValue === "" || computedValue === null) {
							computedValue = element.style[property];
						}

						revertDisplay();
					}

					/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
					 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
					 effect as being set to 0, so no conversion is necessary.) */
					/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
					 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
					 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
					if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
						var position = computePropertyValue(element, "position"); /* GET */

						/* For absolute positioning, jQuery's $.position() only returns values for top and left;
						 right and bottom will have their "auto" value reverted to 0. */
						/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
						 Not a big deal since we're currently in a GET batch anyway. */
						if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
							/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
							computedValue = $(element).position()[property] + "px"; /* GET */
						}
					}

					return computedValue;
				}

				var propertyValue;

				/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
				 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
				if (CSS.Hooks.registered[property]) {
					var hook = property,
							hookRoot = CSS.Hooks.getRoot(hook);

					/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
					 query the DOM for the root property's value. */
					if (rootPropertyValue === undefined) {
						/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
						rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
					}

					/* If this root has a normalization registered, peform the associated normalization extraction. */
					if (CSS.Normalizations.registered[hookRoot]) {
						rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
					}

					/* Extract the hook's value. */
					propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);

					/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
					 normalize the property's name and value, and handle the special case of transforms. */
					/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
					 numerical and therefore do not require normalization extraction. */
				} else if (CSS.Normalizations.registered[property]) {
					var normalizedPropertyName,
							normalizedPropertyValue;

					normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);

					/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
					 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
					 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
					 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
					if (normalizedPropertyName !== "transform") {
						normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */

						/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
						if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
							normalizedPropertyValue = CSS.Hooks.templates[property][1];
						}
					}

					propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
				}

				/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
				if (!/^[\d-]/.test(propertyValue)) {
					/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
					 their HTML attribute values instead of their CSS style values. */
					var data = Data(element);

					if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
						/* Since the height/width attribute values must be set manually, they don't reflect computed values.
						 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
						if (/^(height|width)$/i.test(property)) {
							/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
							try {
								propertyValue = element.getBBox()[property];
							} catch (error) {
								propertyValue = 0;
							}
							/* Otherwise, access the attribute value directly. */
						} else {
							propertyValue = element.getAttribute(property);
						}
					} else {
						propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
					}
				}

				/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
				 convert CSS null-values to an integer of value 0. */
				if (CSS.Values.isCSSNullValue(propertyValue)) {
					propertyValue = 0;
				}

				if (Velocity.debug >= 2) {
					console.log("Get " + property + ": " + propertyValue);
				}

				return propertyValue;
			},
			/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
			setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
				var propertyName = property;

				/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
				if (property === "scroll") {
					/* If a container option is present, scroll the container instead of the browser window. */
					if (scrollData.container) {
						scrollData.container["scroll" + scrollData.direction] = propertyValue;
						/* Otherwise, Velocity defaults to scrolling the browser window. */
					} else {
						if (scrollData.direction === "Left") {
							window.scrollTo(propertyValue, scrollData.alternateValue);
						} else {
							window.scrollTo(scrollData.alternateValue, propertyValue);
						}
					}
				} else {
					/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
					 Thus, for now, we merely cache transforms being SET. */
					if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
						/* Perform a normalization injection. */
						/* Note: The normalization logic handles the transformCache updating. */
						CSS.Normalizations.registered[property]("inject", element, propertyValue);

						propertyName = "transform";
						propertyValue = Data(element).transformCache[property];
					} else {
						/* Inject hooks. */
						if (CSS.Hooks.registered[property]) {
							var hookName = property,
									hookRoot = CSS.Hooks.getRoot(property);

							/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
							rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */

							propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
							property = hookRoot;
						}

						/* Normalize names and values. */
						if (CSS.Normalizations.registered[property]) {
							propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
							property = CSS.Normalizations.registered[property]("name", element);
						}

						/* Assign the appropriate vendor prefix before performing an official style update. */
						propertyName = CSS.Names.prefixCheck(property)[0];

						/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
						 Try/catch is avoided for other browsers since it incurs a performance overhead. */
						if (IE <= 8) {
							try {
								element.style[propertyName] = propertyValue;
							} catch (error) {
								if (Velocity.debug) {
									console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
								}
							}
							/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
							/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
						} else {
							var data = Data(element);

							if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
								/* Note: For SVG attributes, vendor-prefixed property names are never used. */
								/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
								element.setAttribute(property, propertyValue);
							} else {
								element.style[propertyName] = propertyValue;
							}
						}

						if (Velocity.debug >= 2) {
							console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
						}
					}
				}

				/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
				return [propertyName, propertyValue];
			},
			/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
			/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
			flushTransformCache: function(element) {
				var transformString = "",
						data = Data(element);

				/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
				 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
				if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
					/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
					 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
					var getTransformFloat = function(transformProperty) {
						return parseFloat(CSS.getPropertyValue(element, transformProperty));
					};

					/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
					 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
					var SVGTransforms = {
						translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
						skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
						/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
						 (this behavior mimics the result of animating all these properties at once on HTML elements). */
						scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
						/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
						 defining the rotation's origin point. We ignore the origin values (default them to 0). */
						rotate: [getTransformFloat("rotateZ"), 0, 0]
					};

					/* Iterate through the transform properties in the user-defined property map order.
					 (This mimics the behavior of non-SVG transform animation.) */
					$.each(Data(element).transformCache, function(transformName) {
						/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
						 properties so that they match up with SVG's accepted transform properties. */
						if (/^translate/i.test(transformName)) {
							transformName = "translate";
						} else if (/^scale/i.test(transformName)) {
							transformName = "scale";
						} else if (/^rotate/i.test(transformName)) {
							transformName = "rotate";
						}

						/* Check that we haven't yet deleted the property from the SVGTransforms container. */
						if (SVGTransforms[transformName]) {
							/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
							transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";

							/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
							 re-insert the same master property if we encounter another one of its axis-specific properties. */
							delete SVGTransforms[transformName];
						}
					});
				} else {
					var transformValue,
							perspective;

					/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
					$.each(Data(element).transformCache, function(transformName) {
						transformValue = Data(element).transformCache[transformName];

						/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
						if (transformName === "transformPerspective") {
							perspective = transformValue;
							return true;
						}

						/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
						if (IE === 9 && transformName === "rotateZ") {
							transformName = "rotate";
						}

						transformString += transformName + transformValue + " ";
					});

					/* If present, set the perspective subproperty first. */
					if (perspective) {
						transformString = "perspective" + perspective + " " + transformString;
					}
				}

				CSS.setPropertyValue(element, "transform", transformString);
			}
		};

		/* Register hooks and normalizations. */
		CSS.Hooks.register();
		CSS.Normalizations.register();

		/* Allow hook setting in the same fashion as jQuery's $.css(). */
		Velocity.hook = function(elements, arg2, arg3) {
			var value;

			elements = sanitizeElements(elements);

			$.each(elements, function(i, element) {
				/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
				if (Data(element) === undefined) {
					Velocity.init(element);
				}

				/* Get property value. If an element set was passed in, only return the value for the first element. */
				if (arg3 === undefined) {
					if (value === undefined) {
						value = CSS.getPropertyValue(element, arg2);
					}
					/* Set property value. */
				} else {
					/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
					var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);

					/* Transform properties don't automatically set. They have to be flushed to the DOM. */
					if (adjustedSet[0] === "transform") {
						Velocity.CSS.flushTransformCache(element);
					}

					value = adjustedSet;
				}
			});

			return value;
		};

		/*****************
		 Animation
		 *****************/

		var animate = function() {
			var opts;

			/******************
			 Call Chain
			 ******************/

			/* Logic for determining what to return to the call stack when exiting out of Velocity. */
			function getChain() {
				/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
				 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
				if (isUtility) {
					return promiseData.promise || null;
					/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
				} else {
					return elementsWrapped;
				}
			}

			/*************************
			 Arguments Assignment
			 *************************/

			/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
			 objects are defined on a container object that's passed in as Velocity's sole argument. */
			/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
			var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
					/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
					isUtility,
					/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
					 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
					elementsWrapped,
					argumentIndex;

			var elements,
					propertiesMap,
					options;

			/* Detect jQuery/Zepto elements being animated via the $.fn method. */
			if (Type.isWrapped(this)) {
				isUtility = false;

				argumentIndex = 0;
				elements = this;
				elementsWrapped = this;
				/* Otherwise, raw elements are being animated via the utility function. */
			} else {
				isUtility = true;

				argumentIndex = 1;
				elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
			}

			/***************
			 Promises
			 ***************/

			var promiseData = {
				promise: null,
				resolver: null,
				rejecter: null
			};

			/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
			 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
			 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
			 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
			/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
			 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
			 grouped together for the purposes of resolving and rejecting a promise. */
			if (isUtility && Velocity.Promise) {
				promiseData.promise = new Velocity.Promise(function(resolve, reject) {
					promiseData.resolver = resolve;
					promiseData.rejecter = reject;
				});
			}

			if (syntacticSugar) {
				propertiesMap = arguments[0].properties || arguments[0].p;
				options = arguments[0].options || arguments[0].o;
			} else {
				propertiesMap = arguments[argumentIndex];
				options = arguments[argumentIndex + 1];
			}

			elements = sanitizeElements(elements);

			if (!elements) {
				if (promiseData.promise) {
					if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
						promiseData.rejecter();
					} else {
						promiseData.resolver();
					}
				}
				return;
			}

			/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
			 single raw DOM element is passed in (which doesn't contain a length property). */
			var elementsLength = elements.length,
					elementsIndex = 0;

			/***************************
			 Argument Overloading
			 ***************************/

			/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
			 Overloading is detected by checking for the absence of an object being passed into options. */
			/* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
			if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
				/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
				var startingArgumentPosition = argumentIndex + 1;

				options = {};

				/* Iterate through all options arguments */
				for (var i = startingArgumentPosition; i < arguments.length; i++) {
					/* Treat a number as a duration. Parse it out. */
					/* Note: The following RegEx will return true if passed an array with a number as its first item.
					 Thus, arrays are skipped from this check. */
					if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
						options.duration = arguments[i];
						/* Treat strings and arrays as easings. */
					} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
						options.easing = arguments[i];
						/* Treat a function as a complete callback. */
					} else if (Type.isFunction(arguments[i])) {
						options.complete = arguments[i];
					}
				}
			}

			/*********************
			 Action Detection
			 *********************/

			/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
			 or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
			 first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
			 instead of a properties map. */
			var action;

			switch (propertiesMap) {
				case "scroll":
					action = "scroll";
					break;

				case "reverse":
					action = "reverse";
					break;

				case "pause":

					/*******************
					 Action: Pause
					 *******************/

					var currentTime = (new Date()).getTime();

					/* Handle delay timers */
					$.each(elements, function(i, element) {
						pauseDelayOnElement(element, currentTime);
					});

					/* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
					 single element will cause any calls that containt tweens for that element to be paused/resumed
					 as well. */

					/* Iterate through all calls and pause any that contain any of our elements */
					$.each(Velocity.State.calls, function(i, activeCall) {

						var found = false;
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {

										/* Set call to paused */
										activeCall[5] = {
											resume: false
										};

										/* Once we match an element, we can bounce out to the next call entirely */
										found = true;
										return false;
									}
								});

								/* Proceed to check next call if we have already matched */
								if (found) {
									return false;
								}
							});
						}

					});

					/* Since pause creates no new tweens, exit out of Velocity. */
					return getChain();

				case "resume":

					/*******************
					 Action: Resume
					 *******************/

					/* Handle delay timers */
					$.each(elements, function(i, element) {
						resumeDelayOnElement(element, currentTime);
					});

					/* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
					 single element will cause any calls that containt tweens for that element to be paused/resumed
					 as well. */

					/* Iterate through all calls and pause any that contain any of our elements */
					$.each(Velocity.State.calls, function(i, activeCall) {
						var found = false;
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Skip any calls that have never been paused */
								if (!activeCall[5]) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {

										/* Flag a pause object to be resumed, which will occur during the next tick. In
										 addition, the pause object will at that time be deleted */
										activeCall[5].resume = true;

										/* Once we match an element, we can bounce out to the next call entirely */
										found = true;
										return false;
									}
								});

								/* Proceed to check next call if we have already matched */
								if (found) {
									return false;
								}
							});
						}

					});

					/* Since resume creates no new tweens, exit out of Velocity. */
					return getChain();

				case "finish":
				case "finishAll":
				case "stop":
					/*******************
					 Action: Stop
					 *******************/

					/* Clear the currently-active delay on each targeted element. */
					$.each(elements, function(i, element) {
						if (Data(element) && Data(element).delayTimer) {
							/* Stop the timer from triggering its cached next() function. */
							clearTimeout(Data(element).delayTimer.setTimeout);

							/* Manually call the next() function so that the subsequent queue items can progress. */
							if (Data(element).delayTimer.next) {
								Data(element).delayTimer.next();
							}

							delete Data(element).delayTimer;
						}

						/* If we want to finish everything in the queue, we have to iterate through it
						 and call each function. This will make them active calls below, which will
						 cause them to be applied via the duration setting. */
						if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
							/* Iterate through the items in the element's queue. */
							$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
								/* The queue array can contain an "inprogress" string, which we skip. */
								if (Type.isFunction(item)) {
									item();
								}
							});

							/* Clearing the $.queue() array is achieved by resetting it to []. */
							$.queue(element, Type.isString(options) ? options : "", []);
						}
					});

					var callsToStop = [];

					/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
					 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
					 is stopped, the next item in its animation queue is immediately triggered. */
					/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
					 or a custom queue string can be passed in. */
					/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
					 regardless of the element's current queue state. */

					/* Iterate through every active call. */
					$.each(Velocity.State.calls, function(i, activeCall) {
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
								 clear calls associated with the relevant queue. */
								/* Call stopping logic works as follows:
								 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
								 - options === undefined --> stop current queue:"" call and all queue:false calls.
								 - options === false --> stop only queue:false calls.
								 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {
										/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
										 due to the queue-clearing above. */
										if (options === true || Type.isString(options)) {
											/* Iterate through the items in the element's queue. */
											$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
												/* The queue array can contain an "inprogress" string, which we skip. */
												if (Type.isFunction(item)) {
													/* Pass the item's callback a flag indicating that we want to abort from the queue call.
													 (Specifically, the queue will resolve the call's associated promise then abort.)  */
													item(null, true);
												}
											});

											/* Clearing the $.queue() array is achieved by resetting it to []. */
											$.queue(element, Type.isString(options) ? options : "", []);
										}

										if (propertiesMap === "stop") {
											/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
											 changed to reflect the final value that the elements were actually tweened to. */
											/* Note: If only queue:false/queue:"custom" animations are currently running on an element, it won't have a tweensContainer
											 object. Also, queue:false/queue:"custom" animations can't be reversed. */
											var data = Data(element);
											if (data && data.tweensContainer && (queueName === true || queueName === "")) {
												$.each(data.tweensContainer, function(m, activeTween) {
													activeTween.endValue = activeTween.currentValue;
												});
											}

											callsToStop.push(i);
										} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
											/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
											 they finish upon the next rAf tick then proceed with normal call completion logic. */
											activeCall[2].duration = 1;
										}
									}
								});
							});
						}
					});

					/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
					 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
					if (propertiesMap === "stop") {
						$.each(callsToStop, function(i, j) {
							completeCall(j, true);
						});

						if (promiseData.promise) {
							/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
							promiseData.resolver(elements);
						}
					}

					/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
					return getChain();

				default:
					/* Treat a non-empty plain object as a literal properties map. */
					if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
						action = "start";

						/****************
						 Redirects
						 ****************/

						/* Check if a string matches a registered redirect (see Redirects above). */
					} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
						opts = $.extend({}, options);

						var durationOriginal = opts.duration,
								delayOriginal = opts.delay || 0;

						/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
						if (opts.backwards === true) {
							elements = $.extend(true, [], elements).reverse();
						}

						/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
						$.each(elements, function(elementIndex, element) {
							/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
							if (parseFloat(opts.stagger)) {
								opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
							} else if (Type.isFunction(opts.stagger)) {
								opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
							}

							/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
							 the duration of each element's animation, using floors to prevent producing very short durations. */
							if (opts.drag) {
								/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
								opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);

								/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
								 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
								 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
								opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
							}

							/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
							 reduce the opts checking logic required inside the redirect. */
							Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
						});

						/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
						 (The performance overhead up to this point is virtually non-existant.) */
						/* Note: The jQuery call chain is kept intact by returning the complete element set. */
						return getChain();
					} else {
						var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";

						if (promiseData.promise) {
							promiseData.rejecter(new Error(abortError));
						} else if (window.console) {
							console.log(abortError);
						}

						return getChain();
					}
			}

			/**************************
			 Call-Wide Variables
			 **************************/

			/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
			 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
			 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
			 conversion metrics across Velocity animations that are not immediately consecutively chained. */
			var callUnitConversionData = {
				lastParent: null,
				lastPosition: null,
				lastFontSize: null,
				lastPercentToPxWidth: null,
				lastPercentToPxHeight: null,
				lastEmToPx: null,
				remToPx: null,
				vwToPx: null,
				vhToPx: null
			};

			/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
			 Velocity.State.calls array that is processed during animation ticking. */
			var call = [];

			/************************
			 Element Processing
			 ************************/

			/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
			 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
			 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
			 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 `elementArrayIndex` allows passing index of the element in the original array to value functions.
			 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
			 */
			function processElement(element, elementArrayIndex) {

				/*************************
				 Part I: Pre-Queueing
				 *************************/

				/***************************
				 Element-Wide Variables
				 ***************************/

				var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
						opts = $.extend({}, Velocity.defaults, options),
						/* A container for the processed data associated with each property in the propertyMap.
						 (Each property in the map produces its own "tween".) */
						tweensContainer = {},
						elementUnitConversionData;

				/******************
				 Element Init
				 ******************/

				if (Data(element) === undefined) {
					Velocity.init(element);
				}

				/******************
				 Option: Delay
				 ******************/

				/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
				/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
				 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
				if (parseFloat(opts.delay) && opts.queue !== false) {
					$.queue(element, opts.queue, function(next, clearQueue) {
						if (clearQueue === true) {
							/* Do not continue with animation queueing. */
							return true;
						}

						/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
						Velocity.velocityQueueEntryFlag = true;

						/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
						 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
						 delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */

						/* Temporarily store delayed elements to facilite access for global pause/resume */
						var callIndex = Velocity.State.delayedElements.count++;
						Velocity.State.delayedElements[callIndex] = element;

						var delayComplete = (function(index) {
							return function() {
								/* Clear the temporary element */
								Velocity.State.delayedElements[index] = false;

								/* Finally, issue the call */
								next();
							};
						})(callIndex);


						Data(element).delayBegin = (new Date()).getTime();
						Data(element).delay = parseFloat(opts.delay);
						Data(element).delayTimer = {
							setTimeout: setTimeout(next, parseFloat(opts.delay)),
							next: delayComplete
						};
					});
				}

				/*********************
				 Option: Duration
				 *********************/

				/* Support for jQuery's named durations. */
				switch (opts.duration.toString().toLowerCase()) {
					case "fast":
						opts.duration = 200;
						break;

					case "normal":
						opts.duration = DURATION_DEFAULT;
						break;

					case "slow":
						opts.duration = 600;
						break;

					default:
						/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
						opts.duration = parseFloat(opts.duration) || 1;
				}

				/************************
				 Global Option: Mock
				 ************************/

				if (Velocity.mock !== false) {
					/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
					 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
					if (Velocity.mock === true) {
						opts.duration = opts.delay = 1;
					} else {
						opts.duration *= parseFloat(Velocity.mock) || 1;
						opts.delay *= parseFloat(Velocity.mock) || 1;
					}
				}

				/*******************
				 Option: Easing
				 *******************/

				opts.easing = getEasing(opts.easing, opts.duration);

				/**********************
				 Option: Callbacks
				 **********************/

				/* Callbacks must functions. Otherwise, default to null. */
				if (opts.begin && !Type.isFunction(opts.begin)) {
					opts.begin = null;
				}

				if (opts.progress && !Type.isFunction(opts.progress)) {
					opts.progress = null;
				}

				if (opts.complete && !Type.isFunction(opts.complete)) {
					opts.complete = null;
				}

				/*********************************
				 Option: Display & Visibility
				 *********************************/

				/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
				/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
				if (opts.display !== undefined && opts.display !== null) {
					opts.display = opts.display.toString().toLowerCase();

					/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
					if (opts.display === "auto") {
						opts.display = Velocity.CSS.Values.getDisplayType(element);
					}
				}

				if (opts.visibility !== undefined && opts.visibility !== null) {
					opts.visibility = opts.visibility.toString().toLowerCase();
				}

				/**********************
				 Option: mobileHA
				 **********************/

				/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
				 on animating elements. HA is removed from the element at the completion of its animation. */
				/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
				/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
				opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);

				/***********************
				 Part II: Queueing
				 ***********************/

				/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
				 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
				/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
				 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
				function buildQueue(next) {
					var data, lastTweensContainer;

					/*******************
					 Option: Begin
					 *******************/

					/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
					if (opts.begin && elementsIndex === 0) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.begin.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}

					/*****************************************
					 Tween Data Construction (for Scroll)
					 *****************************************/

					/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
					if (action === "scroll") {
						/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
						var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
								scrollOffset = parseFloat(opts.offset) || 0,
								scrollPositionCurrent,
								scrollPositionCurrentAlternate,
								scrollPositionEnd;

						/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
						 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
						if (opts.container) {
							/* Ensure that either a jQuery object or a raw DOM element was passed in. */
							if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
								/* Extract the raw DOM element from the jQuery wrapper. */
								opts.container = opts.container[0] || opts.container;
								/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
								 (due to the user's natural interaction with the page). */
								scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */

								/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
								 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
								 the scroll container's current scroll position. */
								scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
								/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
							} else {
								opts.container = null;
							}
						} else {
							/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
							 the appropriate cached property names (which differ based on browser type). */
							scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
							/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
							scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */

							/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
							 and therefore end values do not need to be compounded onto current values. */
							scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
						}

						/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
						tweensContainer = {
							scroll: {
								rootPropertyValue: false,
								startValue: scrollPositionCurrent,
								currentValue: scrollPositionCurrent,
								endValue: scrollPositionEnd,
								unitType: "",
								easing: opts.easing,
								scrollData: {
									container: opts.container,
									direction: scrollDirection,
									alternateValue: scrollPositionCurrentAlternate
								}
							},
							element: element
						};

						if (Velocity.debug) {
							console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
						}

						/******************************************
						 Tween Data Construction (for Reverse)
						 ******************************************/

						/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
						 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
						 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
						/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
						/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
						 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
						 as reverting to the element's values as they were prior to the previous *Velocity* call. */
					} else if (action === "reverse") {
						data = Data(element);

						/* Abort if there is no prior animation data to reverse to. */
						if (!data) {
							return;
						}

						if (!data.tweensContainer) {
							/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
							$.dequeue(element, opts.queue);

							return;
						} else {
							/*********************
							 Options Parsing
							 *********************/

							/* If the element was hidden via the display option in the previous call,
							 revert display to "auto" prior to reversal so that the element is visible again. */
							if (data.opts.display === "none") {
								data.opts.display = "auto";
							}

							if (data.opts.visibility === "hidden") {
								data.opts.visibility = "visible";
							}

							/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
							 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
							data.opts.loop = false;
							data.opts.begin = null;
							data.opts.complete = null;

							/* Since we're extending an opts object that has already been extended with the defaults options object,
							 we remove non-explicitly-defined properties that are auto-assigned values. */
							if (!options.easing) {
								delete opts.easing;
							}

							if (!options.duration) {
								delete opts.duration;
							}

							/* The opts object used for reversal is an extension of the options object optionally passed into this
							 reverse call plus the options used in the previous Velocity call. */
							opts = $.extend({}, data.opts, opts);

							/*************************************
							 Tweens Container Reconstruction
							 *************************************/

							/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
							lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);

							/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
							for (var lastTween in lastTweensContainer) {
								/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
								if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
									var lastStartValue = lastTweensContainer[lastTween].startValue;

									lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
									lastTweensContainer[lastTween].endValue = lastStartValue;

									/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
									 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
									 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
									if (!Type.isEmptyObject(options)) {
										lastTweensContainer[lastTween].easing = opts.easing;
									}

									if (Velocity.debug) {
										console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
									}
								}
							}

							tweensContainer = lastTweensContainer;
						}

						/*****************************************
						 Tween Data Construction (for Start)
						 *****************************************/

					} else if (action === "start") {

						/*************************
						 Value Transferring
						 *************************/

						/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
						 while the element was in the process of being animated by Velocity, then this current call is safe to use
						 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
						 process whenever possible in order to avoid requerying the DOM. */
						/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
						 then the DOM is queried for the element's current values as a last resort. */
						/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */

						data = Data(element);

						/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
						 to transfer over end values to use as start values. If it's set to true and there is a previous
						 Velocity call to pull values from, do so. */
						if (data && data.tweensContainer && data.isAnimating === true) {
							lastTweensContainer = data.tweensContainer;
						}

						/***************************
						 Tween Data Calculation
						 ***************************/

						/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
						/* Property map values can either take the form of 1) a single value representing the end value,
						 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
						 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
						 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
						var parsePropertyValue = function(valueData, skipResolvingEasing) {
							var endValue, easing, startValue;

							/* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
							if (Type.isFunction(valueData)) {
								valueData = valueData.call(element, elementArrayIndex, elementsLength);
							}

							/* Handle the array format, which can be structured as one of three potential overloads:
							 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
							if (Type.isArray(valueData)) {
								/* endValue is always the first item in the array. Don't bother validating endValue's value now
								 since the ensuing property cycling logic does that. */
								endValue = valueData[0];

								/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
								 start value since easings can only be non-hex strings or arrays. */
								if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
									startValue = valueData[1];
									/* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
								} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]]) || Type.isArray(valueData[1])) {
									easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);

									/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
									startValue = valueData[2];
								} else {
									startValue = valueData[1] || valueData[2];
								}
								/* Handle the single-value format. */
							} else {
								endValue = valueData;
							}

							/* Default to the call's easing if a per-property easing type was not defined. */
							if (!skipResolvingEasing) {
								easing = easing || opts.easing;
							}

							/* If functions were passed in as values, pass the function the current element as its context,
							 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
							if (Type.isFunction(endValue)) {
								endValue = endValue.call(element, elementArrayIndex, elementsLength);
							}

							if (Type.isFunction(startValue)) {
								startValue = startValue.call(element, elementArrayIndex, elementsLength);
							}

							/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
							return [endValue || 0, easing, startValue];
						};

						var fixPropertyValue = function(property, valueData) {
							/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
							var rootProperty = CSS.Hooks.getRoot(property),
									rootPropertyValue = false,
									/* Parse out endValue, easing, and startValue from the property's data. */
									endValue = valueData[0],
									easing = valueData[1],
									startValue = valueData[2],
									pattern;

							/**************************
							 Start Value Sourcing
							 **************************/

							/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
							 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
							 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
							/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
							 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
							if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
								if (Velocity.debug) {
									console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
								}
								return;
							}

							/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
							 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
							 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
							if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
								startValue = 0;
							}

							/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
							 for all of the current call's properties that were *also* animated in the previous call. */
							/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
							if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
								if (startValue === undefined) {
									startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
								}

								/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
								 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
								 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
								rootPropertyValue = data.rootPropertyValueCache[rootProperty];
								/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
							} else {
								/* Handle hooked properties. */
								if (CSS.Hooks.registered[property]) {
									if (startValue === undefined) {
										rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
										/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
										 getPropertyValue() will extract the hook from rootPropertyValue. */
										startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
										/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
										 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
										 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
										 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
									} else {
										/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
										rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
									}
									/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
								} else if (startValue === undefined) {
									startValue = CSS.getPropertyValue(element, property); /* GET */
								}
							}

							/**************************
							 Value Data Extraction
							 **************************/

							var separatedValue,
									endValueUnitType,
									startValueUnitType,
									operator = false;

							/* Separates a property value into its numeric value and its unit type. */
							var separateValue = function(property, value) {
								var unitType,
										numericValue;

								numericValue = (value || "0")
										.toString()
										.toLowerCase()
										/* Match the unit type at the end of the value. */
										.replace(/[%A-z]+$/, function(match) {
											/* Grab the unit type. */
											unitType = match;

											/* Strip the unit type off of value. */
											return "";
										});

								/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
								if (!unitType) {
									unitType = CSS.Values.getUnitType(property);
								}

								return [numericValue, unitType];
							};

							if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
								pattern = "";
								var iStart = 0, // index in startValue
										iEnd = 0, // index in endValue
										aStart = [], // array of startValue numbers
										aEnd = [], // array of endValue numbers
										inCalc = 0, // Keep track of being inside a "calc()" so we don't duplicate it
										inRGB = 0, // Keep track of being inside an RGB as we can't use fractional values
										inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel

								startValue = CSS.Hooks.fixColors(startValue);
								endValue = CSS.Hooks.fixColors(endValue);
								while (iStart < startValue.length && iEnd < endValue.length) {
									var cStart = startValue[iStart],
											cEnd = endValue[iEnd];

									if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
										var tStart = cStart, // temporary character buffer
												tEnd = cEnd, // temporary character buffer
												dotStart = ".", // Make sure we can only ever match a single dot in a decimal
												dotEnd = "."; // Make sure we can only ever match a single dot in a decimal

										while (++iStart < startValue.length) {
											cStart = startValue[iStart];
											if (cStart === dotStart) {
												dotStart = ".."; // Can never match two characters
											} else if (!/\d/.test(cStart)) {
												break;
											}
											tStart += cStart;
										}
										while (++iEnd < endValue.length) {
											cEnd = endValue[iEnd];
											if (cEnd === dotEnd) {
												dotEnd = ".."; // Can never match two characters
											} else if (!/\d/.test(cEnd)) {
												break;
											}
											tEnd += cEnd;
										}
										var uStart = CSS.Hooks.getUnit(startValue, iStart), // temporary unit type
												uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type

										iStart += uStart.length;
										iEnd += uEnd.length;
										if (uStart === uEnd) {
											// Same units
											if (tStart === tEnd) {
												// Same numbers, so just copy over
												pattern += tStart + uStart;
											} else {
												// Different numbers, so store them
												pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
												aStart.push(parseFloat(tStart));
												aEnd.push(parseFloat(tEnd));
											}
										} else {
											// Different units, so put into a "calc(from + to)" and animate each side to/from zero
											var nStart = parseFloat(tStart),
													nEnd = parseFloat(tEnd);

											pattern += (inCalc < 5 ? "calc" : "") + "("
													+ (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart
													+ " + "
													+ (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd
													+ ")";
											if (nStart) {
												aStart.push(nStart);
												aEnd.push(0);
											}
											if (nEnd) {
												aStart.push(0);
												aEnd.push(nEnd);
											}
										}
									} else if (cStart === cEnd) {
										pattern += cStart;
										iStart++;
										iEnd++;
										// Keep track of being inside a calc()
										if (inCalc === 0 && cStart === "c"
												|| inCalc === 1 && cStart === "a"
												|| inCalc === 2 && cStart === "l"
												|| inCalc === 3 && cStart === "c"
												|| inCalc >= 4 && cStart === "("
												) {
											inCalc++;
										} else if ((inCalc && inCalc < 5)
												|| inCalc >= 4 && cStart === ")" && --inCalc < 5) {
											inCalc = 0;
										}
										// Keep track of being inside an rgb() / rgba()
										if (inRGB === 0 && cStart === "r"
												|| inRGB === 1 && cStart === "g"
												|| inRGB === 2 && cStart === "b"
												|| inRGB === 3 && cStart === "a"
												|| inRGB >= 3 && cStart === "("
												) {
											if (inRGB === 3 && cStart === "a") {
												inRGBA = 1;
											}
											inRGB++;
										} else if (inRGBA && cStart === ",") {
											if (++inRGBA > 3) {
												inRGB = inRGBA = 0;
											}
										} else if ((inRGBA && inRGB < (inRGBA ? 5 : 4))
												|| inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
											inRGB = inRGBA = 0;
										}
									} else {
										inCalc = 0;
										// TODO: changing units, fixing colours
										break;
									}
								}
								if (iStart !== startValue.length || iEnd !== endValue.length) {
									if (Velocity.debug) {
										console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
									}
									pattern = undefined;
								}
								if (pattern) {
									if (aStart.length) {
										if (Velocity.debug) {
											console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
										}
										startValue = aStart;
										endValue = aEnd;
										endValueUnitType = startValueUnitType = "";
									} else {
										pattern = undefined;
									}
								}
							}

							if (!pattern) {
								/* Separate startValue. */
								separatedValue = separateValue(property, startValue);
								startValue = separatedValue[0];
								startValueUnitType = separatedValue[1];

								/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
								separatedValue = separateValue(property, endValue);
								endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
									operator = subMatch;

									/* Strip the operator off of the value. */
									return "";
								});
								endValueUnitType = separatedValue[1];

								/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
								startValue = parseFloat(startValue) || 0;
								endValue = parseFloat(endValue) || 0;

								/***************************************
								 Property-Specific Value Conversion
								 ***************************************/

								/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
								if (endValueUnitType === "%") {
									/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
									 which is identical to the em unit's behavior, so we piggyback off of that. */
									if (/^(fontSize|lineHeight)$/.test(property)) {
										/* Convert % into an em decimal value. */
										endValue = endValue / 100;
										endValueUnitType = "em";
										/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
									} else if (/^scale/.test(property)) {
										endValue = endValue / 100;
										endValueUnitType = "";
										/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
									} else if (/(Red|Green|Blue)$/i.test(property)) {
										endValue = (endValue / 100) * 255;
										endValueUnitType = "";
									}
								}
							}

							/***************************
							 Unit Ratio Calculation
							 ***************************/

							/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
							 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
							 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
							 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
							 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
							 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
							/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
							 setting values with the target unit type then comparing the returned pixel value. */
							/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
							 of batching the SETs and GETs together upfront outweights the potential overhead
							 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
							/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
							var calculateUnitRatios = function() {

								/************************
								 Same Ratio Checks
								 ************************/

								/* The properties below are used to determine whether the element differs sufficiently from this call's
								 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
								 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
								 this is done to minimize DOM querying. */
								var sameRatioIndicators = {
									myParent: element.parentNode || document.body, /* GET */
									position: CSS.getPropertyValue(element, "position"), /* GET */
									fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
								},
										/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
										samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
										/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
										sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);

								/* Store these ratio indicators call-wide for the next element to compare against. */
								callUnitConversionData.lastParent = sameRatioIndicators.myParent;
								callUnitConversionData.lastPosition = sameRatioIndicators.position;
								callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;

								/***************************
								 Element-Specific Units
								 ***************************/

								/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
								 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
								var measurement = 100,
										unitRatios = {};

								if (!sameEmRatio || !samePercentRatio) {
									var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");

									Velocity.init(dummy);
									sameRatioIndicators.myParent.appendChild(dummy);

									/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
									 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
									/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
									$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
										Velocity.CSS.setPropertyValue(dummy, property, "hidden");
									});
									Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
									Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
									Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");

									/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
									$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
										Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
									});
									/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
									Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");

									/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
									unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
									unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
									unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */

									sameRatioIndicators.myParent.removeChild(dummy);
								} else {
									unitRatios.emToPx = callUnitConversionData.lastEmToPx;
									unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
									unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
								}

								/***************************
								 Element-Agnostic Units
								 ***************************/

								/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
								 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
								 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
								 so we calculate it now. */
								if (callUnitConversionData.remToPx === null) {
									/* Default to browsers' default fontSize of 16px in the case of 0. */
									callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
								}

								/* Similarly, viewport units are %-relative to the window's inner dimensions. */
								if (callUnitConversionData.vwToPx === null) {
									callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
									callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
								}

								unitRatios.remToPx = callUnitConversionData.remToPx;
								unitRatios.vwToPx = callUnitConversionData.vwToPx;
								unitRatios.vhToPx = callUnitConversionData.vhToPx;

								if (Velocity.debug >= 1) {
									console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
								}
								return unitRatios;
							};

							/********************
							 Unit Conversion
							 ********************/

							/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
							if (/[\/*]/.test(operator)) {
								endValueUnitType = startValueUnitType;
								/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
								 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
								 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
								 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
								/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
							} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
								/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
								/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
								 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
								 which remains past the point of the animation's completion. */
								if (endValue === 0) {
									endValueUnitType = startValueUnitType;
								} else {
									/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
									 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
									elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();

									/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
									/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
									var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";

									/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
									 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
									switch (startValueUnitType) {
										case "%":
											/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
											 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
											 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
											startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
											break;

										case "px":
											/* px acts as our midpoint in the unit conversion process; do nothing. */
											break;

										default:
											startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
									}

									/* Invert the px ratios to convert into to the target unit. */
									switch (endValueUnitType) {
										case "%":
											startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
											break;

										case "px":
											/* startValue is already in px, do nothing; we're done. */
											break;

										default:
											startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
									}
								}
							}

							/*********************
							 Relative Values
							 *********************/

							/* Operator logic must be performed last since it requires unit-normalized start and end values. */
							/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
							 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
							 50 points is added on top of the current % value. */
							switch (operator) {
								case "+":
									endValue = startValue + endValue;
									break;

								case "-":
									endValue = startValue - endValue;
									break;

								case "*":
									endValue = startValue * endValue;
									break;

								case "/":
									endValue = startValue / endValue;
									break;
							}

							/**************************
							 tweensContainer Push
							 **************************/

							/* Construct the per-property tween object, and push it to the element's tweensContainer. */
							tweensContainer[property] = {
								rootPropertyValue: rootPropertyValue,
								startValue: startValue,
								currentValue: startValue,
								endValue: endValue,
								unitType: endValueUnitType,
								easing: easing
							};
							if (pattern) {
								tweensContainer[property].pattern = pattern;
							}

							if (Velocity.debug) {
								console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
							}
						};

						/* Create a tween out of each property, and append its associated data to tweensContainer. */
						for (var property in propertiesMap) {

							if (!propertiesMap.hasOwnProperty(property)) {
								continue;
							}
							/* The original property name's format must be used for the parsePropertyValue() lookup,
							 but we then use its camelCase styling to normalize it for manipulation. */
							var propertyName = CSS.Names.camelCase(property),
									valueData = parsePropertyValue(propertiesMap[property]);

							/* Find shorthand color properties that have been passed a hex string. */
							/* Would be quicker to use CSS.Lists.colors.includes() if possible */
							if (_inArray(CSS.Lists.colors, propertyName)) {
								/* Parse the value data for each shorthand. */
								var endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2];

								if (CSS.RegEx.isHex.test(endValue)) {
									/* Convert the hex strings into their RGB component arrays. */
									var colorComponents = ["Red", "Green", "Blue"],
											endValueRGB = CSS.Values.hexToRgb(endValue),
											startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;

									/* Inject the RGB component tweens into propertiesMap. */
									for (var i = 0; i < colorComponents.length; i++) {
										var dataArray = [endValueRGB[i]];

										if (easing) {
											dataArray.push(easing);
										}

										if (startValueRGB !== undefined) {
											dataArray.push(startValueRGB[i]);
										}

										fixPropertyValue(propertyName + colorComponents[i], dataArray);
									}
									/* If we have replaced a shortcut color value then don't update the standard property name */
									continue;
								}
							}
							fixPropertyValue(propertyName, valueData);
						}

						/* Along with its property data, store a reference to the element itself onto tweensContainer. */
						tweensContainer.element = element;
					}

					/*****************
					 Call Push
					 *****************/

					/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
					 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
					if (tweensContainer.element) {
						/* Apply the "velocity-animating" indicator class. */
						CSS.Values.addClass(element, "velocity-animating");

						/* The call array houses the tweensContainers for each element being animated in the current call. */
						call.push(tweensContainer);

						data = Data(element);

						if (data) {
							/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
							if (opts.queue === "") {

								data.tweensContainer = tweensContainer;
								data.opts = opts;
							}

							/* Switch on the element's animating flag. */
							data.isAnimating = true;
						}

						/* Once the final element in this call's element set has been processed, push the call array onto
						 Velocity.State.calls for the animation tick to immediately begin processing. */
						if (elementsIndex === elementsLength - 1) {
							/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
							 Anything on this call container is subjected to tick() processing. */
							Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);

							/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
							if (Velocity.State.isTicking === false) {
								Velocity.State.isTicking = true;

								/* Start the tick loop. */
								tick();
							}
						} else {
							elementsIndex++;
						}
					}
				}

				/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
				if (opts.queue === false) {
					/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
					 we manually inject the delay property here with an explicit setTimeout. */
					if (opts.delay) {

						/* Temporarily store delayed elements to facilitate access for global pause/resume */
						var callIndex = Velocity.State.delayedElements.count++;
						Velocity.State.delayedElements[callIndex] = element;

						var delayComplete = (function(index) {
							return function() {
								/* Clear the temporary element */
								Velocity.State.delayedElements[index] = false;

								/* Finally, issue the call */
								buildQueue();
							};
						})(callIndex);

						Data(element).delayBegin = (new Date()).getTime();
						Data(element).delay = parseFloat(opts.delay);
						Data(element).delayTimer = {
							setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
							next: delayComplete
						};
					} else {
						buildQueue();
					}
					/* Otherwise, the call undergoes element queueing as normal. */
					/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
				} else {
					$.queue(element, opts.queue, function(next, clearQueue) {
						/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
						 so it's fine if this is repeatedly triggered for each element in the associated call.) */
						if (clearQueue === true) {
							if (promiseData.promise) {
								promiseData.resolver(elements);
							}

							/* Do not continue with animation queueing. */
							return true;
						}

						/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
						 See completeCall() for further details. */
						Velocity.velocityQueueEntryFlag = true;

						buildQueue(next);
					});
				}

				/*********************
				 Auto-Dequeuing
				 *********************/

				/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
				 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
				 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
				 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
				 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
				/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
				 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
				/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
				 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
				if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
					$.dequeue(element);
				}
			}

			/**************************
			 Element Set Iteration
			 **************************/

			/* If the "nodeType" property exists on the elements variable, we're animating a single element.
			 Place it in an array so that $.each() can iterate over it. */
			$.each(elements, function(i, element) {
				/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
				if (Type.isNode(element)) {
					processElement(element, i);
				}
			});

			/******************
			 Option: Loop
			 ******************/

			/* The loop option accepts an integer indicating how many times the element should loop between the values in the
			 current call's properties map and the element's property values prior to this call. */
			/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
			 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
			 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
			opts = $.extend({}, Velocity.defaults, options);
			opts.loop = parseInt(opts.loop, 10);
			var reverseCallsCount = (opts.loop * 2) - 1;

			if (opts.loop) {
				/* Double the loop count to convert it into its appropriate number of "reverse" calls.
				 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
				for (var x = 0; x < reverseCallsCount; x++) {
					/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
					 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
					 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
					var reverseOptions = {
						delay: opts.delay,
						progress: opts.progress
					};

					/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
					 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
					if (x === reverseCallsCount - 1) {
						reverseOptions.display = opts.display;
						reverseOptions.visibility = opts.visibility;
						reverseOptions.complete = opts.complete;
					}

					animate(elements, "reverse", reverseOptions);
				}
			}

			/***************
			 Chaining
			 ***************/

			/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
			return getChain();
		};

		/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
		Velocity = $.extend(animate, Velocity);
		/* For legacy support, also expose the literal animate method. */
		Velocity.animate = animate;

		/**************
		 Timing
		 **************/

		/* Ticker function. */
		var ticker = window.requestAnimationFrame || rAFShim;

		/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
		 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
		 devices to avoid wasting battery power on inactive tabs. */
		/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
		if (!Velocity.State.isMobile && document.hidden !== undefined) {
			var updateTicker = function() {
				/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
				if (document.hidden) {
					ticker = function(callback) {
						/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
						return setTimeout(function() {
							callback(true);
						}, 16);
					};

					/* The rAF loop has been paused by the browser, so we manually restart the tick. */
					tick();
				} else {
					ticker = window.requestAnimationFrame || rAFShim;
				}
			};

			/* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
			updateTicker();

			/* And then run check again every time visibility changes */
			document.addEventListener("visibilitychange", updateTicker);
		}

		/************
		 Tick
		 ************/

		/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
		function tick(timestamp) {
			/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
			 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
			 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
			 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
			 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
			 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
			if (timestamp) {
				/* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
				 under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
				 We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
				var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();

				/********************
				 Call Iteration
				 ********************/

				var callsLength = Velocity.State.calls.length;

				/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
				 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
				 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
				if (callsLength > 10000) {
					Velocity.State.calls = compactSparseArray(Velocity.State.calls);
					callsLength = Velocity.State.calls.length;
				}

				/* Iterate through each active call. */
				for (var i = 0; i < callsLength; i++) {
					/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
					if (!Velocity.State.calls[i]) {
						continue;
					}

					/************************
					 Call-Wide Variables
					 ************************/

					var callContainer = Velocity.State.calls[i],
							call = callContainer[0],
							opts = callContainer[2],
							timeStart = callContainer[3],
							firstTick = !timeStart,
							tweenDummyValue = null,
							pauseObject = callContainer[5],
							millisecondsEllapsed = callContainer[6];



					/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
					 We assign timeStart now so that its value is as close to the real animation start time as possible.
					 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
					 between that time and now would cause the first few frames of the tween to be skipped since
					 percentComplete is calculated relative to timeStart.) */
					/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
					 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
					 same style value as the element's current value. */
					if (!timeStart) {
						timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
					}

					/* If a pause object is present, skip processing unless it has been set to resume */
					if (pauseObject) {
						if (pauseObject.resume === true) {
							/* Update the time start to accomodate the paused completion amount */
							timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);

							/* Remove pause object after processing */
							callContainer[5] = null;
						} else {
							continue;
						}
					}

					millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;

					/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
					 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
					 Accordingly, we ensure that percentComplete does not exceed 1. */
					var percentComplete = Math.min((millisecondsEllapsed) / opts.duration, 1);

					/**********************
					 Element Iteration
					 **********************/

					/* For every call, iterate through each of the elements in its set. */
					for (var j = 0, callLength = call.length; j < callLength; j++) {
						var tweensContainer = call[j],
								element = tweensContainer.element;

						/* Check to see if this element has been deleted midway through the animation by checking for the
						 continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
						if (!Data(element)) {
							continue;
						}

						var transformPropertyExists = false;

						/**********************************
						 Display & Visibility Toggling
						 **********************************/

						/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
						 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
						if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
							if (opts.display === "flex") {
								var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];

								$.each(flexValues, function(i, flexValue) {
									CSS.setPropertyValue(element, "display", flexValue);
								});
							}

							CSS.setPropertyValue(element, "display", opts.display);
						}

						/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
						if (opts.visibility !== undefined && opts.visibility !== "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}

						/************************
						 Property Iteration
						 ************************/

						/* For every element, iterate through each property. */
						for (var property in tweensContainer) {
							/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
							if (tweensContainer.hasOwnProperty(property) && property !== "element") {
								var tween = tweensContainer[property],
										currentValue,
										/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
										 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
										easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;

								/******************************
								 Current Value Calculation
								 ******************************/

								if (Type.isString(tween.pattern)) {
									var patternReplace = percentComplete === 1 ?
											function($0, index, round) {
												var result = tween.endValue[index];

												return round ? Math.round(result) : result;
											} :
											function($0, index, round) {
												var startValue = tween.startValue[index],
														tweenDelta = tween.endValue[index] - startValue,
														result = startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));

												return round ? Math.round(result) : result;
											};

									currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
								} else if (percentComplete === 1) {
									/* If this is the last tick pass (if we've reached 100% completion for this tween),
									 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
									currentValue = tween.endValue;
								} else {
									/* Otherwise, calculate currentValue based on the current delta from startValue. */
									var tweenDelta = tween.endValue - tween.startValue;

									currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
									/* If no value change is occurring, don't proceed with DOM updating. */
								}
								if (!firstTick && (currentValue === tween.currentValue)) {
									continue;
								}

								tween.currentValue = currentValue;

								/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
								 it can be passed into the progress callback. */
								if (property === "tween") {
									tweenDummyValue = currentValue;
								} else {
									/******************
									 Hooks: Part I
									 ******************/
									var hookRoot;

									/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
									 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
									 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
									 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
									 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
									if (CSS.Hooks.registered[property]) {
										hookRoot = CSS.Hooks.getRoot(property);

										var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];

										if (rootPropertyValueCache) {
											tween.rootPropertyValue = rootPropertyValueCache;
										}
									}

									/*****************
									 DOM Update
									 *****************/

									/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
									/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
									var adjustedSetData = CSS.setPropertyValue(element, /* SET */
											property,
											tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType),
											tween.rootPropertyValue,
											tween.scrollData);

									/*******************
									 Hooks: Part II
									 *******************/

									/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
									if (CSS.Hooks.registered[property]) {
										/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
										if (CSS.Normalizations.registered[hookRoot]) {
											Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
										} else {
											Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
										}
									}

									/***************
									 Transforms
									 ***************/

									/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
									if (adjustedSetData[0] === "transform") {
										transformPropertyExists = true;
									}

								}
							}
						}

						/****************
						 mobileHA
						 ****************/

						/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
						 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
						if (opts.mobileHA) {
							/* Don't set the null transform hack if we've already done so. */
							if (Data(element).transformCache.translate3d === undefined) {
								/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
								Data(element).transformCache.translate3d = "(0px, 0px, 0px)";

								transformPropertyExists = true;
							}
						}

						if (transformPropertyExists) {
							CSS.flushTransformCache(element);
						}
					}

					/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
					 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
					if (opts.display !== undefined && opts.display !== "none") {
						Velocity.State.calls[i][2].display = false;
					}
					if (opts.visibility !== undefined && opts.visibility !== "hidden") {
						Velocity.State.calls[i][2].visibility = false;
					}

					/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
					if (opts.progress) {
						opts.progress.call(callContainer[1],
								callContainer[1],
								percentComplete,
								Math.max(0, (timeStart + opts.duration) - timeCurrent),
								timeStart,
								tweenDummyValue);
					}

					/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
					if (percentComplete === 1) {
						completeCall(i);
					}
				}
			}

			/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
			if (Velocity.State.isTicking) {
				ticker(tick);
			}
		}

		/**********************
		 Call Completion
		 **********************/

		/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
		function completeCall(callIndex, isStopped) {
			/* Ensure the call exists. */
			if (!Velocity.State.calls[callIndex]) {
				return false;
			}

			/* Pull the metadata from the call. */
			var call = Velocity.State.calls[callIndex][0],
					elements = Velocity.State.calls[callIndex][1],
					opts = Velocity.State.calls[callIndex][2],
					resolver = Velocity.State.calls[callIndex][4];

			var remainingCallsExist = false;

			/*************************
			 Element Finalization
			 *************************/

			for (var i = 0, callLength = call.length; i < callLength; i++) {
				var element = call[i].element;

				/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
				/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
				/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
				if (!isStopped && !opts.loop) {
					if (opts.display === "none") {
						CSS.setPropertyValue(element, "display", opts.display);
					}

					if (opts.visibility === "hidden") {
						CSS.setPropertyValue(element, "visibility", opts.visibility);
					}
				}

				/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
				 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
				 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
				 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
				 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
				var data = Data(element);

				if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
					/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
					if (data) {
						data.isAnimating = false;
						/* Clear the element's rootPropertyValueCache, which will become stale. */
						data.rootPropertyValueCache = {};

						var transformHAPropertyExists = false;
						/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
						$.each(CSS.Lists.transforms3D, function(i, transformName) {
							var defaultValue = /^scale/.test(transformName) ? 1 : 0,
									currentValue = data.transformCache[transformName];

							if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
								transformHAPropertyExists = true;

								delete data.transformCache[transformName];
							}
						});

						/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
						if (opts.mobileHA) {
							transformHAPropertyExists = true;
							delete data.transformCache.translate3d;
						}

						/* Flush the subproperty removals to the DOM. */
						if (transformHAPropertyExists) {
							CSS.flushTransformCache(element);
						}

						/* Remove the "velocity-animating" indicator class. */
						CSS.Values.removeClass(element, "velocity-animating");
					}
				}

				/*********************
				 Option: Complete
				 *********************/

				/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
				/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
				if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
					/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
					try {
						opts.complete.call(elements, elements);
					} catch (error) {
						setTimeout(function() {
							throw error;
						}, 1);
					}
				}

				/**********************
				 Promise Resolving
				 **********************/

				/* Note: Infinite loops don't return promises. */
				if (resolver && opts.loop !== true) {
					resolver(elements);
				}

				/****************************
				 Option: Loop (Infinite)
				 ****************************/

				if (data && opts.loop === true && !isStopped) {
					/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
					 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
					$.each(data.tweensContainer, function(propertyName, tweenContainer) {
						if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
							var oldStartValue = tweenContainer.startValue;

							tweenContainer.startValue = tweenContainer.endValue;
							tweenContainer.endValue = oldStartValue;
						}

						if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
							tweenContainer.endValue = 0;
							tweenContainer.startValue = 100;
						}
					});

					Velocity(element, "reverse", {loop: true, delay: opts.delay});
				}

				/***************
				 Dequeueing
				 ***************/

				/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
				 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
				 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
				if (opts.queue !== false) {
					$.dequeue(element, opts.queue);
				}
			}

			/************************
			 Calls Array Cleanup
			 ************************/

			/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
			 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
			Velocity.State.calls[callIndex] = false;

			/* Iterate through the calls array to determine if this was the final in-progress animation.
			 If so, set a flag to end ticking and clear the calls array. */
			for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
				if (Velocity.State.calls[j] !== false) {
					remainingCallsExist = true;

					break;
				}
			}

			if (remainingCallsExist === false) {
				/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
				Velocity.State.isTicking = false;

				/* Clear the calls array so that its length is reset. */
				delete Velocity.State.calls;
				Velocity.State.calls = [];
			}
		}

		/******************
		 Frameworks
		 ******************/

		/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
		 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
		 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
		 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
		 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
		global.Velocity = Velocity;

		if (global !== window) {
			/* Assign the element function to Velocity's core animate() method. */
			global.fn.velocity = animate;
			/* Assign the object function's defaults to Velocity's global defaults object. */
			global.fn.velocity.defaults = Velocity.defaults;
		}

		/***********************
		 Packaged Redirects
		 ***********************/

		/* slideUp, slideDown */
		$.each(["Down", "Up"], function(i, direction) {
			Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
				var opts = $.extend({}, options),
						begin = opts.begin,
						complete = opts.complete,
						inlineValues = {},
						computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""};

				if (opts.display === undefined) {
					/* Show the element before slideDown begins and hide the element after slideUp completes. */
					/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
					opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
				}

				opts.begin = function() {
					/* If the user passed in a begin callback, fire it now. */
					if (elementsIndex === 0 && begin) {
						begin.call(elements, elements);
					}

					/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
					for (var property in computedValues) {
						if (!computedValues.hasOwnProperty(property)) {
							continue;
						}
						inlineValues[property] = element.style[property];

						/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
						 use forcefeeding to start from computed values and animate down to 0. */
						var propertyValue = CSS.getPropertyValue(element, property);
						computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
					}

					/* Force vertical overflow content to clip so that sliding works as expected. */
					inlineValues.overflow = element.style.overflow;
					element.style.overflow = "hidden";
				};

				opts.complete = function() {
					/* Reset element to its pre-slide inline values once its slide animation is complete. */
					for (var property in inlineValues) {
						if (inlineValues.hasOwnProperty(property)) {
							element.style[property] = inlineValues[property];
						}
					}

					/* If the user passed in a complete callback, fire it now. */
					if (elementsIndex === elementsSize - 1) {
						if (complete) {
							complete.call(elements, elements);
						}
						if (promiseData) {
							promiseData.resolver(elements);
						}
					}
				};

				Velocity(element, computedValues, opts);
			};
		});

		/* fadeIn, fadeOut */
		$.each(["In", "Out"], function(i, direction) {
			Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
				var opts = $.extend({}, options),
						complete = opts.complete,
						propertiesMap = {opacity: (direction === "In") ? 1 : 0};

				/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
				 callbacks by firing them only when the final element has been reached. */
				if (elementsIndex !== 0) {
					opts.begin = null;
				}
				if (elementsIndex !== elementsSize - 1) {
					opts.complete = null;
				} else {
					opts.complete = function() {
						if (complete) {
							complete.call(elements, elements);
						}
						if (promiseData) {
							promiseData.resolver(elements);
						}
					};
				}

				/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
				/* Note: We allow users to pass in "null" to skip display setting altogether. */
				if (opts.display === undefined) {
					opts.display = (direction === "In" ? "auto" : "none");
				}

				Velocity(this, propertiesMap, opts);
			};
		});

		return Velocity;
	}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
}));

/******************
 Known Issues
 ******************/

/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showItem),expression:"showItem"}],class:['le-accordion-item', { open: !_vm.collapsed }],attrs:{"aria-level":_vm.showHeading ? _vm.headingLevel : false,"role":_vm.showHeading ? 'heading' : false}},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltip, html: false, autoHide: false }),expression:"{ content: tooltip, html: false, autoHide: false }"}],class:['header', { disabled: _vm.toggleDisabled }],attrs:{"id":_vm.itemId,"tabindex":"0","role":"button","aria-expanded":_vm.collapsed ? 'false' : 'true',"aria-controls":_vm.controlerId},on:{"click":function($event){return _vm.toggleCollapse(false)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.toggleCollapse(false)}}},[_c('div',{staticClass:"header-content"},[_vm._t("title",[_c('le-text-with-highlight',{attrs:{"text":_vm.title,"highlightText":_vm.searchTerm,"headingAriaLevel":"4"}})])],2),_vm._v(" "),_c('i',{class:['ico-10', 'toggle-icon', _vm.collapseIcon]})]),_vm._v(" "),(_vm.transition)?_c('transition',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"leave":_vm.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapsed),expression:"!isCollapsed"}],ref:"content",staticClass:"content-container",attrs:{"id":_vm.controlerId,"role":"region","aria-labelledby":_vm.itemId}},[_c('div',{staticClass:"content"},[_vm._t("content",[_c('le-text-with-highlight',{attrs:{"text":_vm.textContent,"highlightText":_vm.searchTerm}})])],2)])]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapsed),expression:"!isCollapsed"}],ref:"content",staticClass:"content-container",attrs:{"id":_vm.controlerId,"role":"region","aria-labelledby":_vm.itemId}},[_c('div',{staticClass:"content"},[_vm._t("content",[_c('le-text-with-highlight',{attrs:{"text":_vm.textContent,"highlightText":_vm.searchTerm}})])],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_emojies_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be085c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_emojies_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4be085c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_emojies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be085c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_emojies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3ce9466f", content, true, {});

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-emojies[data-v-4be085c0]{padding-left:0;margin:0;list-style:none}.le-emojies .le-emoji[data-v-4be085c0]{display:inline-block;width:25px}.le-emojies .emoji-icon[data-v-4be085c0]{width:25px;font-size:16px;display:inline-block;padding:0;cursor:pointer;background:transparent;border:none;text-align:center}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-emojies/le-emojies.vue"],"names":[],"mappings":"AAIA,6BACE,eAAgB,AAChB,SAAU,AACV,eAAiB,CAClB,AACD,uCACI,qBAAsB,AACtB,UAAY,CACf,AACD,yCACI,WAAY,AACZ,eAAgB,AAChB,qBAAsB,AACtB,UAAW,AACX,eAAgB,AAChB,uBAAwB,AACxB,YAAa,AACb,iBAAmB,CACtB","file":"le-emojies.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-emojies[data-v-4be085c0] {\n  padding-left: 0;\n  margin: 0;\n  list-style: none;\n}\n.le-emojies .le-emoji[data-v-4be085c0] {\n    display: inline-block;\n    width: 25px;\n}\n.le-emojies .emoji-icon[data-v-4be085c0] {\n    width: 25px;\n    font-size: 16px;\n    display: inline-block;\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: none;\n    text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"emojiList",staticClass:"le-emojies",style:({width:((_vm.getContainerWidth()) + "px")}),attrs:{"id":_vm.elementId}},_vm._l((_vm.emojiesList),function(emoji){return _c('li',{key:emoji,staticClass:"le-emoji"},[_c('button',{staticClass:"emoji-icon",attrs:{"aria-label":_vm.getEmojiLabel(emoji.name)},on:{"click":function($event){return _vm.onClick(emoji.value)}}},[_vm._v(_vm._s(emoji.value))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_toggle_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a51c672c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_toggle_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a51c672c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a51c672c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("49f85d88", content, true, {});

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-toggle .toggle-frame[data-v-a51c672c]{display:inline-block;position:relative;cursor:pointer;width:30px;height:14px;border-radius:9.5px;-webkit-transition:border-color .3s,background-color .3s;transition:border-color .3s,background-color .3s}.le-toggle .toggle-frame.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame[data-v-a51c672c]{background-color:rgba(71,74,106,.5)}.le-toggle .toggle-frame.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame[data-v-a51c672c]{background-color:#fff}.le-toggle .toggle-frame .toggle-button[data-v-a51c672c]{width:10px;height:10px;position:absolute;border-radius:50%;margin-top:2px;-webkit-transition:border-color .1s ease,background-color .1s ease,right .1s linear;transition:border-color .1s ease,background-color .1s ease,right .1s linear}.le-toggle .toggle-frame.toggle-active[data-v-a51c672c]{border:1px solid}.le-toggle .toggle-frame.toggle-active.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]{border-color:#5879da}.le-toggle .toggle-frame.toggle-active.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]{border-color:#7691de}.le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c]{right:2px}.le-toggle .toggle-frame.toggle-active .toggle-button.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c]{background-color:#5879da}.le-toggle .toggle-frame.toggle-active .toggle-button.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c]{background-color:#7691de}.le-toggle .toggle-frame.toggle-active:focus.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:focus.theme-light[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:hover.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:hover.theme-light[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:focus,.theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:hover,.theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:focus,.theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:hover{border-color:#4661ae}.le-toggle .toggle-frame.toggle-active:focus .toggle-button.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:focus .toggle-button.theme-light[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:hover .toggle-button.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-active:hover .toggle-button.theme-light[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-active:focus .toggle-button[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-active:hover .toggle-button[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-active:focus .toggle-button[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-active:hover .toggle-button[data-v-a51c672c]{background-color:#4661ae}.le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]{border:1px solid}.le-toggle .toggle-frame.toggle-inactive.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]{border-color:#474a6a}.le-toggle .toggle-frame.toggle-inactive.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]{border-color:#a0a0a0}.le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c]{right:calc(100% - 12px)}.le-toggle .toggle-frame.toggle-inactive .toggle-button.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c]{background-color:#bbc0c9}.le-toggle .toggle-frame.toggle-inactive .toggle-button.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c]{background-color:#a0a0a0}.le-toggle .toggle-frame.toggle-inactive:focus.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-inactive:hover.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:focus,.theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:hover{border-color:#2d3162}.le-toggle .toggle-frame.toggle-inactive:focus.theme-light[data-v-a51c672c],.le-toggle .toggle-frame.toggle-inactive:hover.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:focus,.theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:hover{border-color:#888}.le-toggle .toggle-frame.toggle-inactive:focus .toggle-button.theme-dark[data-v-a51c672c],.le-toggle .toggle-frame.toggle-inactive:hover .toggle-button.theme-dark[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button[data-v-a51c672c],.theme-dark .le-toggle .toggle-frame.toggle-inactive:hover .toggle-button[data-v-a51c672c]{background-color:#bbc0c9}.le-toggle .toggle-frame.toggle-inactive:focus .toggle-button.theme-light[data-v-a51c672c],.le-toggle .toggle-frame.toggle-inactive:hover .toggle-button.theme-light[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button[data-v-a51c672c],.theme-light .le-toggle .toggle-frame.toggle-inactive:hover .toggle-button[data-v-a51c672c]{background-color:#888}.le-toggle.disabled[data-v-a51c672c]{cursor:default;pointer-events:none}.le-toggle.disabled .toggle-frame[data-v-a51c672c]{border:1px solid}.le-toggle.disabled .toggle-frame.theme-dark[data-v-a51c672c],.theme-dark .le-toggle.disabled .toggle-frame[data-v-a51c672c]{background-color:rgba(187,192,201,.5);border-color:#bbc0c9}.le-toggle.disabled .toggle-frame.theme-light[data-v-a51c672c],.theme-light .le-toggle.disabled .toggle-frame[data-v-a51c672c]{background-color:#fff;border-color:#c4c4c4}.le-toggle.disabled .toggle-frame .toggle-button.theme-dark[data-v-a51c672c],.theme-dark .le-toggle.disabled .toggle-frame .toggle-button[data-v-a51c672c]{background-color:rgba(187,192,201,.2)}.le-toggle.disabled .toggle-frame .toggle-button.theme-light[data-v-a51c672c],.theme-light .le-toggle.disabled .toggle-frame .toggle-button[data-v-a51c672c]{background-color:#c4c4c4}.le-toggle.disabled .toggle-frame.toggle-active.theme-dark[data-v-a51c672c],.theme-dark .le-toggle.disabled .toggle-frame.toggle-active[data-v-a51c672c]{border-color:#5879da}.le-toggle.disabled .toggle-frame.toggle-active.theme-light[data-v-a51c672c],.theme-light .le-toggle.disabled .toggle-frame.toggle-active[data-v-a51c672c]{border-color:#bcc9f0}.le-toggle.disabled .toggle-frame.toggle-active .toggle-button.theme-dark[data-v-a51c672c],.theme-dark .le-toggle.disabled .toggle-frame.toggle-active .toggle-button[data-v-a51c672c]{background-color:#5879da}.le-toggle.disabled .toggle-frame.toggle-active .toggle-button.theme-light[data-v-a51c672c],.theme-light .le-toggle.disabled .toggle-frame.toggle-active .toggle-button[data-v-a51c672c]{background-color:#bcc9f0}.le-toggle.disabled .toggle-frame.toggle-inactive.theme-dark[data-v-a51c672c],.theme-dark .le-toggle.disabled .toggle-frame.toggle-inactive[data-v-a51c672c]{background-color:rgba(187,192,201,.5)}.le-toggle.disabled .toggle-frame.toggle-inactive.theme-light[data-v-a51c672c],.theme-light .le-toggle.disabled .toggle-frame.toggle-inactive[data-v-a51c672c]{background-color:#ebecef}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-toggle/le-toggle.vue"],"names":[],"mappings":"AAIA,0CACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,oBAAqB,AACrB,yDAA2D,AAC3D,gDAAmD,CACpD,AACD,2GAEI,mCAAyC,CAC5C,AACD,6GAEI,qBAA0B,CAC7B,AACD,yDACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,oFAAuF,AACvF,2EAA+E,CAClF,AACD,wDACI,gBAAkB,CACrB,AACD,uIAEM,oBAAsB,CAC3B,AACD,yIAEM,oBAAsB,CAC3B,AACD,uEACM,SAAW,CAChB,AACD,qKAEQ,wBAA0B,CACjC,AACD,uKAEQ,wBAA0B,CACjC,AAMD,glBAGM,oBAAsB,CAC3B,AAMD,wsBAGM,wBAA0B,CAC/B,AACD,0DACI,gBAAkB,CACrB,AACD,2IAEM,oBAAsB,CAC3B,AACD,6IAEM,oBAAsB,CAC3B,AACD,yEACM,uBAAyB,CAC9B,AACD,yKAEQ,wBAA0B,CACjC,AACD,2KAEQ,wBAA0B,CACjC,AACD,8SAGM,oBAAsB,CAC3B,AACD,kTAGM,iBAAsB,CAC3B,AACD,0WAGM,wBAA0B,CAC/B,AACD,8WAGM,qBAA0B,CAC/B,AACD,qCACE,eAAgB,AAChB,mBAAqB,CACtB,AACD,mDACI,gBAAkB,CACrB,AACD,6HAEM,sCAA2C,AAC3C,oBAAsB,CAC3B,AACD,+HAEM,sBAA0B,AAC1B,oBAAsB,CAC3B,AACD,2JAEM,qCAA2C,CAChD,AACD,6JAEM,wBAA0B,CAC/B,AACD,yJAEM,oBAAsB,CAC3B,AACD,2JAEM,oBAAsB,CAC3B,AACD,uLAEM,wBAA0B,CAC/B,AACD,yLAEM,wBAA0B,CAC/B,AACD,6JAEM,qCAA2C,CAChD,AACD,+JAEM,wBAA0B,CAC/B","file":"le-toggle.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-toggle .toggle-frame[data-v-a51c672c] {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: 30px;\n  height: 14px;\n  border-radius: 9.5px;\n  -webkit-transition: border-color .3s, background-color .3s;\n  transition: border-color .3s, background-color .3s;\n}\n.le-toggle .toggle-frame.theme-dark[data-v-a51c672c],\n  .theme-dark .le-toggle .toggle-frame[data-v-a51c672c] {\n    background-color: rgba(71, 74, 106, 0.5);\n}\n.le-toggle .toggle-frame.theme-light[data-v-a51c672c],\n  .theme-light .le-toggle .toggle-frame[data-v-a51c672c] {\n    background-color: #ffffff;\n}\n.le-toggle .toggle-frame .toggle-button[data-v-a51c672c] {\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    border-radius: 50%;\n    margin-top: 2px;\n    -webkit-transition: border-color .1s ease, background-color .1s ease, right .1s linear;\n    transition: border-color .1s ease, background-color .1s ease, right .1s linear;\n}\n.le-toggle .toggle-frame.toggle-active[data-v-a51c672c] {\n    border: solid 1px;\n}\n.le-toggle .toggle-frame.toggle-active.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c] {\n      border-color: #5879da;\n}\n.le-toggle .toggle-frame.toggle-active.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c] {\n      border-color: #7691DE;\n}\n.le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c] {\n      right: 2px;\n}\n.le-toggle .toggle-frame.toggle-active .toggle-button.theme-dark[data-v-a51c672c],\n      .theme-dark .le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c] {\n        background-color: #5879da;\n}\n.le-toggle .toggle-frame.toggle-active .toggle-button.theme-light[data-v-a51c672c],\n      .theme-light .le-toggle .toggle-frame.toggle-active .toggle-button[data-v-a51c672c] {\n        background-color: #7691DE;\n}\n.le-toggle .toggle-frame.toggle-active:hover.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:hover, .le-toggle .toggle-frame.toggle-active:focus.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:focus {\n      border-color: #4661ae;\n}\n.le-toggle .toggle-frame.toggle-active:hover.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:hover, .le-toggle .toggle-frame.toggle-active:focus.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-active[data-v-a51c672c]:focus {\n      border-color: #4661ae;\n}\n.le-toggle .toggle-frame.toggle-active:hover .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-active:hover .toggle-button[data-v-a51c672c], .le-toggle .toggle-frame.toggle-active:focus .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-active:focus .toggle-button[data-v-a51c672c] {\n      background-color: #4661ae;\n}\n.le-toggle .toggle-frame.toggle-active:hover .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-active:hover .toggle-button[data-v-a51c672c], .le-toggle .toggle-frame.toggle-active:focus .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-active:focus .toggle-button[data-v-a51c672c] {\n      background-color: #4661ae;\n}\n.le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c] {\n    border: solid 1px;\n}\n.le-toggle .toggle-frame.toggle-inactive.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c] {\n      border-color: #474a6a;\n}\n.le-toggle .toggle-frame.toggle-inactive.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c] {\n      border-color: #A0A0A0;\n}\n.le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c] {\n      right: calc(100% - 12px);\n}\n.le-toggle .toggle-frame.toggle-inactive .toggle-button.theme-dark[data-v-a51c672c],\n      .theme-dark .le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c] {\n        background-color: #bbc0c9;\n}\n.le-toggle .toggle-frame.toggle-inactive .toggle-button.theme-light[data-v-a51c672c],\n      .theme-light .le-toggle .toggle-frame.toggle-inactive .toggle-button[data-v-a51c672c] {\n        background-color: #A0A0A0;\n}\n.le-toggle .toggle-frame.toggle-inactive:hover.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:hover, .le-toggle .toggle-frame.toggle-inactive:focus.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:focus {\n      border-color: #2d3162;\n}\n.le-toggle .toggle-frame.toggle-inactive:hover.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:hover, .le-toggle .toggle-frame.toggle-inactive:focus.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-inactive[data-v-a51c672c]:focus {\n      border-color: #888888;\n}\n.le-toggle .toggle-frame.toggle-inactive:hover .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-inactive:hover .toggle-button[data-v-a51c672c], .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button[data-v-a51c672c] {\n      background-color: #bbc0c9;\n}\n.le-toggle .toggle-frame.toggle-inactive:hover .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-inactive:hover .toggle-button[data-v-a51c672c], .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle .toggle-frame.toggle-inactive:focus .toggle-button[data-v-a51c672c] {\n      background-color: #888888;\n}\n.le-toggle.disabled[data-v-a51c672c] {\n  cursor: default;\n  pointer-events: none;\n}\n.le-toggle.disabled .toggle-frame[data-v-a51c672c] {\n    border: solid 1px;\n}\n.le-toggle.disabled .toggle-frame.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle.disabled .toggle-frame[data-v-a51c672c] {\n      background-color: rgba(187, 192, 201, 0.5);\n      border-color: #bbc0c9;\n}\n.le-toggle.disabled .toggle-frame.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle.disabled .toggle-frame[data-v-a51c672c] {\n      background-color: #ffffff;\n      border-color: #C4C4C4;\n}\n.le-toggle.disabled .toggle-frame .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle.disabled .toggle-frame .toggle-button[data-v-a51c672c] {\n      background-color: rgba(187, 192, 201, 0.2);\n}\n.le-toggle.disabled .toggle-frame .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle.disabled .toggle-frame .toggle-button[data-v-a51c672c] {\n      background-color: #C4C4C4;\n}\n.le-toggle.disabled .toggle-frame.toggle-active.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle.disabled .toggle-frame.toggle-active[data-v-a51c672c] {\n      border-color: #5879da;\n}\n.le-toggle.disabled .toggle-frame.toggle-active.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle.disabled .toggle-frame.toggle-active[data-v-a51c672c] {\n      border-color: #BCC9F0;\n}\n.le-toggle.disabled .toggle-frame.toggle-active .toggle-button.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle.disabled .toggle-frame.toggle-active .toggle-button[data-v-a51c672c] {\n      background-color: #5879da;\n}\n.le-toggle.disabled .toggle-frame.toggle-active .toggle-button.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle.disabled .toggle-frame.toggle-active .toggle-button[data-v-a51c672c] {\n      background-color: #BCC9F0;\n}\n.le-toggle.disabled .toggle-frame.toggle-inactive.theme-dark[data-v-a51c672c],\n    .theme-dark .le-toggle.disabled .toggle-frame.toggle-inactive[data-v-a51c672c] {\n      background-color: rgba(187, 192, 201, 0.5);\n}\n.le-toggle.disabled .toggle-frame.toggle-inactive.theme-light[data-v-a51c672c],\n    .theme-light .le-toggle.disabled .toggle-frame.toggle-inactive[data-v-a51c672c] {\n      background-color: #ebecef;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-toggle', {'disabled': _vm.disabled}],attrs:{"aria-disabled":_vm.disabled}},[_c('div',{class:['toggle-frame', _vm.toggleFrameStateClass],attrs:{"aria-labelledby":_vm.ariaLabelledBy,"disabled":_vm.disabled,"aria-pressed":_vm.isToggled,"role":"button","tabindex":_vm.tabIndex,"data-test":"toggle_btn"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onToggleClick($event)},"click":_vm.onToggleClick}},[_c('div',{staticClass:"toggle-button"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_radio_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86912346_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_radio_vue__ = __webpack_require__(646);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86912346"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86912346_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65400b28", content, true, {});

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-radio[data-v-86912346]{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex}.le-radio.theme-dark[data-v-86912346],.theme-dark .le-radio[data-v-86912346]{color:#fff}.le-radio.theme-light[data-v-86912346],.theme-light .le-radio[data-v-86912346]{color:#494b51}.le-radio:hover .indicator.theme-dark[data-v-86912346],.theme-dark .le-radio:hover .indicator[data-v-86912346]{border:1px solid #666}.le-radio:hover .indicator.theme-light[data-v-86912346],.theme-light .le-radio:hover .indicator[data-v-86912346]{border:1px solid #8c8d8f}.le-radio:hover .indicator.checked.theme-dark[data-v-86912346],.le-radio:hover .indicator.checked.theme-light[data-v-86912346],.theme-dark .le-radio:hover .indicator.checked[data-v-86912346],.theme-light .le-radio:hover .indicator.checked[data-v-86912346]{border:1px solid #349ec3}.le-radio div[data-v-86912346]{-webkit-box-flex:1;-ms-flex:1;flex:1}.le-radio .indicator[data-v-86912346]{position:relative;height:8px;width:8px;border-radius:50%;display:inline-block}.le-radio .indicator.theme-dark[data-v-86912346],.theme-dark .le-radio .indicator[data-v-86912346]{border:1px solid #888}.le-radio .indicator.theme-light[data-v-86912346],.theme-light .le-radio .indicator[data-v-86912346]{border:1px solid #8c8d8f}.le-radio .indicator.checked.theme-dark[data-v-86912346],.theme-dark .le-radio .indicator.checked[data-v-86912346]{border:1px solid #5879da}.le-radio .indicator.checked.theme-dark[data-v-86912346]:before,.theme-dark .le-radio .indicator.checked[data-v-86912346]:before{background-color:#5879da}.le-radio .indicator.checked.theme-light[data-v-86912346],.theme-light .le-radio .indicator.checked[data-v-86912346]{border:1px solid #4661ae}.le-radio .indicator.checked.theme-light[data-v-86912346]:before,.theme-light .le-radio .indicator.checked[data-v-86912346]:before{background-color:#4661ae}.le-radio .indicator.checked[data-v-86912346]:before{position:absolute;height:6px;width:6px;content:\"\";border-radius:50%;top:1px;left:1px}.le-radio .indicator.checked:before.theme-dark[data-v-86912346],.theme-dark .le-radio .indicator.checked[data-v-86912346]:before{background-color:#5879da}.le-radio .indicator.checked:before.theme-light[data-v-86912346],.theme-light .le-radio .indicator.checked[data-v-86912346]:before{background-color:#4661ae}.le-radio.disabled[data-v-86912346]{pointer-events:none;cursor:default}.le-radio.disabled .indicator.theme-dark[data-v-86912346],.theme-dark .le-radio.disabled .indicator[data-v-86912346]{border:1px solid #ddd}.le-radio.disabled .indicator.theme-light[data-v-86912346],.theme-light .le-radio.disabled .indicator[data-v-86912346]{border:1px solid #8c8d8f}.le-radio.disabled .indicator.checked.theme-dark[data-v-86912346],.theme-dark .le-radio.disabled .indicator.checked[data-v-86912346]{border:1px solid #ddd}.le-radio.disabled .indicator.checked.theme-dark[data-v-86912346]:before,.theme-dark .le-radio.disabled .indicator.checked[data-v-86912346]:before{background-color:#ddd}.le-radio.disabled .indicator.checked.theme-light[data-v-86912346],.theme-light .le-radio.disabled .indicator.checked[data-v-86912346]{border:1px solid #8c8d8f}.le-radio.disabled .indicator.checked.theme-light[data-v-86912346]:before,.theme-light .le-radio.disabled .indicator.checked[data-v-86912346]:before{background-color:#8c8d8f}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-radio/le-radio.vue"],"names":[],"mappings":"AAIA,2BACE,eAAgB,AAChB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,6EAEI,UAAe,CAClB,AACD,+EAEI,aAAe,CAClB,AACD,+GAEI,qBAA0B,CAC7B,AACD,iHAEI,wBAA0B,CAC7B,AAKD,gQAEI,wBAA0B,CAC7B,AACD,+BACI,mBAAoB,AAChB,WAAY,AACR,MAAQ,CACnB,AACD,sCACI,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,oBAAsB,CACzB,AACD,mGAEM,qBAA0B,CAC/B,AACD,qGAEM,wBAA0B,CAC/B,AACD,mHAEM,wBAA0B,CAC/B,AACD,iIAEQ,wBAA0B,CACjC,AACD,qHAEM,wBAA0B,CAC/B,AACD,mIAEQ,wBAA0B,CACjC,AACD,qDACM,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,QAAU,CACf,AACD,iIAEQ,wBAA0B,CACjC,AACD,mIAEQ,wBAA0B,CACjC,AACD,oCACI,oBAAqB,AACrB,cAAgB,CACnB,AACD,qHAEM,qBAA0B,CAC/B,AACD,uHAEM,wBAA0B,CAC/B,AACD,qIAEM,qBAA0B,CAC/B,AACD,mJAEQ,qBAA0B,CACjC,AACD,uIAEM,wBAA0B,CAC/B,AACD,qJAEQ,wBAA0B,CACjC","file":"le-radio.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-radio[data-v-86912346] {\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.le-radio.theme-dark[data-v-86912346],\n  .theme-dark .le-radio[data-v-86912346] {\n    color: #ffffff;\n}\n.le-radio.theme-light[data-v-86912346],\n  .theme-light .le-radio[data-v-86912346] {\n    color: #494B51;\n}\n.le-radio:hover .indicator.theme-dark[data-v-86912346],\n  .theme-dark .le-radio:hover .indicator[data-v-86912346] {\n    border: 1px solid #666666;\n}\n.le-radio:hover .indicator.theme-light[data-v-86912346],\n  .theme-light .le-radio:hover .indicator[data-v-86912346] {\n    border: 1px solid #8C8D8F;\n}\n.le-radio:hover .indicator.checked.theme-dark[data-v-86912346],\n  .theme-dark .le-radio:hover .indicator.checked[data-v-86912346] {\n    border: 1px solid #349ec3;\n}\n.le-radio:hover .indicator.checked.theme-light[data-v-86912346],\n  .theme-light .le-radio:hover .indicator.checked[data-v-86912346] {\n    border: 1px solid #349ec3;\n}\n.le-radio div[data-v-86912346] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n}\n.le-radio .indicator[data-v-86912346] {\n    position: relative;\n    height: 8px;\n    width: 8px;\n    border-radius: 50%;\n    display: inline-block;\n}\n.le-radio .indicator.theme-dark[data-v-86912346],\n    .theme-dark .le-radio .indicator[data-v-86912346] {\n      border: 1px solid #888888;\n}\n.le-radio .indicator.theme-light[data-v-86912346],\n    .theme-light .le-radio .indicator[data-v-86912346] {\n      border: 1px solid #8C8D8F;\n}\n.le-radio .indicator.checked.theme-dark[data-v-86912346],\n    .theme-dark .le-radio .indicator.checked[data-v-86912346] {\n      border: 1px solid #5879da;\n}\n.le-radio .indicator.checked.theme-dark[data-v-86912346]:before,\n      .theme-dark .le-radio .indicator.checked[data-v-86912346]:before {\n        background-color: #5879da;\n}\n.le-radio .indicator.checked.theme-light[data-v-86912346],\n    .theme-light .le-radio .indicator.checked[data-v-86912346] {\n      border: 1px solid #4661ae;\n}\n.le-radio .indicator.checked.theme-light[data-v-86912346]:before,\n      .theme-light .le-radio .indicator.checked[data-v-86912346]:before {\n        background-color: #4661ae;\n}\n.le-radio .indicator.checked[data-v-86912346]:before {\n      position: absolute;\n      height: 6px;\n      width: 6px;\n      content: '';\n      border-radius: 50%;\n      top: 1px;\n      left: 1px;\n}\n.le-radio .indicator.checked:before.theme-dark[data-v-86912346],\n      .theme-dark .le-radio .indicator.checked[data-v-86912346]:before {\n        background-color: #5879da;\n}\n.le-radio .indicator.checked:before.theme-light[data-v-86912346],\n      .theme-light .le-radio .indicator.checked[data-v-86912346]:before {\n        background-color: #4661ae;\n}\n.le-radio.disabled[data-v-86912346] {\n    pointer-events: none;\n    cursor: default;\n}\n.le-radio.disabled .indicator.theme-dark[data-v-86912346],\n    .theme-dark .le-radio.disabled .indicator[data-v-86912346] {\n      border: 1px solid #dddddd;\n}\n.le-radio.disabled .indicator.theme-light[data-v-86912346],\n    .theme-light .le-radio.disabled .indicator[data-v-86912346] {\n      border: 1px solid #8C8D8F;\n}\n.le-radio.disabled .indicator.checked.theme-dark[data-v-86912346],\n    .theme-dark .le-radio.disabled .indicator.checked[data-v-86912346] {\n      border: 1px solid #dddddd;\n}\n.le-radio.disabled .indicator.checked.theme-dark[data-v-86912346]:before,\n      .theme-dark .le-radio.disabled .indicator.checked[data-v-86912346]:before {\n        background-color: #dddddd;\n}\n.le-radio.disabled .indicator.checked.theme-light[data-v-86912346],\n    .theme-light .le-radio.disabled .indicator.checked[data-v-86912346] {\n      border: 1px solid #8C8D8F;\n}\n.le-radio.disabled .indicator.checked.theme-light[data-v-86912346]:before,\n      .theme-light .le-radio.disabled .indicator.checked[data-v-86912346]:before {\n        background-color: #8C8D8F;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltip, html: false, autoHide: false }),expression:"{ content: tooltip, html: false, autoHide: false }"}],ref:"radioitem",class:['le-radio', { 'disabled': _vm.disabled }],style:(("align-items: " + _vm.itemsAlignment + ";")),attrs:{"role":"radio","disabled":_vm.disabled,"aria-checked":_vm.checked,"aria-label":_vm.ariaLabel,"tabindex":_vm.tabbableIndex},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onClick($event)},"click":_vm.onClick}},[_c('span',{class:['indicator', {'checked': _vm.checked }],style:(("top: " + _vm.topIndicatorStyle + ";")),attrs:{"data-test":"radio_select_indicator"}}),_vm._v(" "),_vm._t("default",null,{"role":"radio"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_ellipsis_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12c410c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_ellipsis_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c12c410c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_ellipsis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12c410c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_ellipsis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(649);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("109fafc8", content, true, {});

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-ellipsis[data-v-c12c410c]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-ellipsis/le-ellipsis.vue"],"names":[],"mappings":"AAIA,8BACE,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB","file":"le-ellipsis.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-ellipsis[data-v-c12c410c] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],ref:"ellipsis",staticClass:"le-ellipsis"},[_vm._v(_vm._s(_vm.content))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_audio_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5a2b08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_audio_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b5a2b08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_audio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5a2b08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_audio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(653);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b295717c", content, true, {});

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-audio[data-v-2b5a2b08]{white-space:nowrap;display:table-row}.le-audio .loader-wrapper[data-v-2b5a2b08],.le-audio .player-container[data-v-2b5a2b08]{-webkit-box-sizing:border-box;box-sizing:border-box;vertical-align:middle;width:20px;height:16px}.le-audio .player-container .player[data-v-2b5a2b08]{cursor:pointer}.le-audio .time-container[data-v-2b5a2b08]{display:table-cell;vertical-align:middle;padding:0 8px;font-size:11px}.le-audio .time-container .current-time[data-v-2b5a2b08],.le-audio .time-container .duration-time[data-v-2b5a2b08]{padding:0 3px}.le-audio .progress-bar-wrapper[data-v-2b5a2b08]{position:relative;display:table-cell;vertical-align:middle;width:100%}.le-audio .progress-bar-wrapper .progress-bar-duration[data-v-2b5a2b08]{display:block;width:100%;height:8px;border-radius:10px;opacity:.2;background-color:#000}.le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08]{position:absolute;top:5px;width:0;background-color:#000;height:6px;border-radius:10px}.le-audio .progress-bar-wrapper .progress-indication.theme-dark[data-v-2b5a2b08],.le-audio .progress-bar-wrapper .progress-indication.theme-light[data-v-2b5a2b08],.theme-dark .le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08],.theme-light .le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08]{background-color:#fff}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-audio/le-audio.vue"],"names":[],"mappings":"AAIA,2BACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,wFACI,8BAA+B,AACvB,sBAAuB,AAC/B,sBAAuB,AACvB,WAAY,AACZ,WAAa,CAChB,AACD,qDACI,cAAgB,CACnB,AACD,2CACI,mBAAoB,AACpB,sBAAuB,AACvB,cAAe,AACf,cAAgB,CACnB,AACD,mHACM,aAAe,CACpB,AACD,iDACI,kBAAmB,AACnB,mBAAoB,AACpB,sBAAuB,AACvB,UAAY,CACf,AACD,wEACM,cAAe,AACf,WAAY,AACZ,WAAY,AACZ,mBAAoB,AACpB,WAAa,AACb,qBAAwB,CAC7B,AACD,sEACM,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,sBAAwB,AACxB,WAAY,AACZ,kBAAoB,CACzB,AAKD,wUAEQ,qBAA0B,CACjC","file":"le-audio.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-audio[data-v-2b5a2b08] {\n  white-space: nowrap;\n  display: table-row;\n}\n.le-audio .loader-wrapper[data-v-2b5a2b08], .le-audio .player-container[data-v-2b5a2b08] {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    vertical-align: middle;\n    width: 20px;\n    height: 16px;\n}\n.le-audio .player-container .player[data-v-2b5a2b08] {\n    cursor: pointer;\n}\n.le-audio .time-container[data-v-2b5a2b08] {\n    display: table-cell;\n    vertical-align: middle;\n    padding: 0 8px;\n    font-size: 11px;\n}\n.le-audio .time-container .current-time[data-v-2b5a2b08], .le-audio .time-container .duration-time[data-v-2b5a2b08] {\n      padding: 0 3px;\n}\n.le-audio .progress-bar-wrapper[data-v-2b5a2b08] {\n    position: relative;\n    display: table-cell;\n    vertical-align: middle;\n    width: 100%;\n}\n.le-audio .progress-bar-wrapper .progress-bar-duration[data-v-2b5a2b08] {\n      display: block;\n      width: 100%;\n      height: 8px;\n      border-radius: 10px;\n      opacity: 0.2;\n      background-color: black;\n}\n.le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08] {\n      position: absolute;\n      top: 5px;\n      width: 0;\n      background-color: black;\n      height: 6px;\n      border-radius: 10px;\n}\n.le-audio .progress-bar-wrapper .progress-indication.theme-dark[data-v-2b5a2b08],\n      .theme-dark .le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08] {\n        background-color: #ffffff;\n}\n.le-audio .progress-bar-wrapper .progress-indication.theme-light[data-v-2b5a2b08],\n      .theme-light .le-audio .progress-bar-wrapper .progress-indication[data-v-2b5a2b08] {\n        background-color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-audio"},[(_vm.loading)?_c('div',{staticClass:"loader-wrapper"},[_c('le-loader',{staticClass:"loader",attrs:{"size":14}})],1):_c('div',{staticClass:"player-container"},[_c('i',{class:['player', 'ico-16', { 'ico-play': !_vm.playing }, { 'ico-pause': _vm.playing }],attrs:{"role":"button","tabindex":"0","aria-label":_vm.playerButtonAriaLabel},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onPlayClick($event)},"click":_vm.onPlayClick}})]),_vm._v(" "),_c('div',{staticClass:"time-container"},[_c('span',{staticClass:"current-time"},[_vm._v(_vm._s(_vm.currentTime))]),_vm._v("/"),_c('span',{staticClass:"duration-time"},[_vm._v(_vm._s(_vm.durationTime))])]),_vm._v(" "),_c('div',{staticClass:"progress-bar-wrapper",on:{"click":_vm.onSeekClick}},[_c('div',{ref:"progressBarDuration",staticClass:"progress-bar-duration"}),_vm._v(" "),_c('div',{staticClass:"progress-indication",style:(_vm.progressBarIndicationStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_datepicker_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd27b88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_datepicker_vue__ = __webpack_require__(660);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd27b88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("497352b4", content, true, {});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-datepicker .vdp-datepicker .vdp-datepicker__calendar{min-height:310px;border:1px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar{background-color:#141a42;border-color:#474a6a}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar{background-color:#fff;border-color:#ddd}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn{font-size:12px;font-family:Roboto}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn{background:#141a42;color:#fff}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn{background:#fff;color:#666}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev{text-indent:0}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next.theme-light,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev{color:#b1b1b1}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover.theme-dark,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover{background-color:hsla(0,0%,100%,.2)}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover.theme-light,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover{background-color:#f2f2f2}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next.disabled:after,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:after,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev.disabled:after,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:after{display:none}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell{font-size:14px;font-family:Roboto;height:30px;line-height:30px}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell{color:#fff}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell{color:#666}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover{border:1px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover{background-color:hsla(0,0%,100%,.2);border-color:#141a42}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover{background-color:#f2f2f2;border-color:#fff}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today{border-color:hsla(0,0%,100%,.2)}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today{border-color:#ccc}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header{font-size:13px}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header{color:#bbc0c9}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header{color:#757575}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header:hover{background:none}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected{border-radius:1px;border:1px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected{color:#fff;background-color:hsla(0,0%,100%,.1);border-color:#0c5de6}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected{color:#1d2553;background-color:#8ba3ea;border-color:#1d2553}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover{background-color:#595a80;border-color:#141a42}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover{background-color:#c9d3f3;border-color:#1d2553}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted{border:2px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted{background-color:hsla(0,0%,100%,.1);border-color:#0c5de6}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted{background-color:#8ba3ea;border-color:#1d2553}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover{border:2px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover{background-color:#595a80;border-color:#141a42}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover{background-color:#c9d3f3;border-color:#1d2553}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted{border-radius:1px;border:1px solid}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted{color:#fff;border-color:#141a42;background-color:hsla(0,0%,100%,.1)}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted{color:#1d2553;border-color:#fff;background-color:#8ba3ea}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover{border-color:#141a42;background-color:#595a80}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover{border-color:#fff;background-color:#d0d9f2}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled.theme-dark,.theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled{color:#888}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled.theme-light,.theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled{color:#b1b1b1}.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).day:hover,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).month:hover,.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).year:hover{border:none}.le-datepicker .vdp-datepicker.date-input-field .vdp-datepicker__calendar{width:100%;min-width:200px;max-width:400px;padding:0 6px;white-space:pre-line}.le-datepicker .vdp-datepicker.date-input-field .vdp-datepicker__calendar div{clear:both}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input{border:1px solid transparent;background-color:#474a6a;color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input:hover,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:hover{border-color:transparent}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-webkit-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-webkit-input-placeholder{color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-moz-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-moz-placeholder{color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-ms-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::placeholder{color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input:-ms-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input{border:1px solid #8c8d8f;background-color:#ebecef;color:hsla(0,0%,4%,.5)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input:hover,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:hover{border-color:#8c8d8f}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-webkit-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-webkit-input-placeholder{color:hsla(222,6%,46%,.5)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-moz-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-moz-placeholder{color:hsla(222,6%,46%,.5)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-ms-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::placeholder{color:hsla(222,6%,46%,.5)}.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input:-ms-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input{-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border:1px solid #474a6a;background-color:rgba(71,74,106,.5);color:#fff}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:hover,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input:hover{border-color:#2d3162}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:focus,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input:focus{border-color:#5879da}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-webkit-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-webkit-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-moz-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-moz-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-ms-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-ms-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input::placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:-ms-input-placeholder,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-ms-clear,.theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-ms-clear{display:none;width:0;height:0}.le-datepicker .vdp-datepicker.date-input-field.theme-light input,.theme-light .le-datepicker .vdp-datepicker.date-input-field input{-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border:1px solid #8c8d8f;background-color:#fcfcfd;color:#0a0a0a}.le-datepicker .vdp-datepicker.date-input-field.theme-light input:hover,.theme-light .le-datepicker .vdp-datepicker.date-input-field input:hover{border-color:#8c8d8f}.le-datepicker .vdp-datepicker.date-input-field.theme-light input:focus,.theme-light .le-datepicker .vdp-datepicker.date-input-field input:focus{border-color:#666}.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-webkit-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field input::-webkit-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-moz-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field input::-moz-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-ms-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field input::-ms-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-light input::placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field input::placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-light input:-ms-input-placeholder,.theme-light .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-ms-clear,.theme-light .le-datepicker .vdp-datepicker.date-input-field input::-ms-clear{display:none;width:0;height:0}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar{width:220px;border:none;padding:7px 6px 0}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header{width:220px;height:50px;margin-bottom:3px;position:relative;left:-6px}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header header{margin-top:10px}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers{display:inline-block;width:100px;height:30px;border-radius:1px;border:1px}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container{float:left;margin-left:6px}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container.theme-light,.theme-light .le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container{color:#666;background-color:#fff;border-color:#ddd}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container{top:0;float:right;margin-right:6px}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container.theme-light,.theme-light .le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container{color:#666;background-color:#fff;border-color:#ddd}.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container .item-content{padding:0 0 0 12px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-datepicker/le-datepicker.vue"],"names":[],"mappings":"AAIA,yDACE,iBAAkB,AAClB,gBAAkB,CACnB,AACD,yIAEI,yBAA0B,AAC1B,oBAAsB,CACzB,AACD,2IAEI,sBAA0B,AAC1B,iBAAsB,CACzB,AACD,yEACI,eAAgB,AAChB,kBAAoB,CACvB,AACD,yKAEM,mBAAoB,AACpB,UAAe,CACpB,AACD,2KAEM,gBAAoB,AACpB,UAAe,CACpB,AACD,8HACI,aAAe,CAClB,AACD,8SAGM,aAAe,CACpB,AACD,kUAGM,mCAA2C,CAChD,AACD,sUAGM,wBAA0B,CAC/B,AAID,sSACM,YAAc,CACnB,AACD,+DACI,eAAgB,AAChB,mBAAoB,AACpB,YAAa,AACb,gBAAkB,CACrB,AACD,qJAEM,UAAe,CACpB,AACD,uJAEM,UAAe,CACpB,AACD,qEACM,gBAAkB,CACvB,AACD,iKAEQ,oCAA2C,AAC3C,oBAAsB,CAC7B,AACD,mKAEQ,yBAA0B,AAC1B,iBAAsB,CAC7B,AACD,iKAEM,+BAAuC,CAC5C,AACD,mKAEM,iBAAsB,CAC3B,AACD,0EACM,cAAgB,CACrB,AACD,2KAEQ,aAAe,CACtB,AACD,6KAEQ,aAAe,CACtB,AACD,gFACQ,eAAiB,CACxB,AACD,wEACM,kBAAmB,AACnB,gBAAkB,CACvB,AACD,uKAEQ,WAAe,AACf,oCAA2C,AAC3C,oBAAsB,CAC7B,AACD,yKAEQ,cAAe,AACf,yBAA0B,AAC1B,oBAAsB,CAC7B,AACD,mLAEQ,yBAA0B,AAC1B,oBAAsB,CAC7B,AACD,qLAEQ,yBAA0B,AAC1B,oBAAsB,CAC7B,AACD,oFACQ,gBAAkB,CACzB,AACD,+LAEU,oCAA2C,AAC3C,oBAAsB,CAC/B,AACD,iMAEU,yBAA0B,AAC1B,oBAAsB,CAC/B,AACD,0FACU,gBAAkB,CAC3B,AACD,2MAEY,yBAA0B,AAC1B,oBAAsB,CACjC,AACD,6MAEY,yBAA0B,AAC1B,oBAAsB,CACjC,AACD,2EACM,kBAAmB,AACnB,gBAAkB,CACvB,AACD,6KAEQ,WAAe,AACf,qBAAsB,AACtB,mCAA2C,CAClD,AACD,+KAEQ,cAAe,AACf,kBAAsB,AACtB,wBAA0B,CACjC,AACD,yLAEQ,qBAAsB,AACtB,wBAA0B,CACjC,AACD,2LAEQ,kBAAsB,AACtB,wBAA0B,CACjC,AACD,uKAEM,UAAe,CACpB,AACD,yKAEM,aAAe,CACpB,AACD,4VACM,WAAa,CAClB,AACD,0EACE,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,cAAe,AACf,oBAAsB,CACvB,AACD,8EACI,UAAY,CACf,AACD,iKAEE,6BAA8B,AAC9B,yBAA0B,AAC1B,wBAAgC,CACjC,AACD,6KAEI,wBAA0B,CAC7B,AACD,uNAEI,wBAAgC,CACnC,AACD,qMAEI,wBAAgC,CACnC,AACD,+MAEI,wBAAgC,CACnC,AACD,2LAEI,wBAAgC,CACnC,AAMD,6MAGI,wBAAgC,CACnC,AACD,mKAEE,yBAA0B,AAC1B,yBAA0B,AAC1B,sBAA6B,CAC9B,AACD,+KAEI,oBAAsB,CACzB,AACD,yNAEI,yBAAgC,CACnC,AACD,uMAEI,yBAAgC,CACnC,AACD,iNAEI,yBAAgC,CACnC,AACD,6LAEI,yBAAgC,CACnC,AAMD,+MAGI,yBAAgC,CACnC,AACD,mIAEE,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,oCAAyC,AACzC,UAAe,CAChB,AACD,+IAEI,oBAAsB,CACzB,AACD,+IAEI,oBAAsB,CACzB,AACD,yLAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,uKAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,iLAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,6JAEI,kBAAmB,AACnB,wBAAgC,CACnC,AAOD,+KAGI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,yJAGI,aAAc,AACd,QAAS,AACT,QAAU,CACb,AACD,qIAEE,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CAChB,AACD,iJAEI,oBAAsB,CACzB,AACD,iJAEI,iBAAsB,CACzB,AACD,2LAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,yKAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,mLAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,+JAEI,kBAAmB,AACnB,sBAA6B,CAChC,AAOD,iLAGI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,2JAGI,aAAc,AACd,QAAS,AACT,QAAU,CACb,AACD,8EACE,YAAa,AACb,YAAa,AACb,iBAAuB,CACxB,AACD,+FACI,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,SAAW,CACd,AACD,sGACM,eAAiB,CACtB,AACD,8HACM,qBAAsB,AACtB,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,UAAY,CACjB,AACD,oJACQ,WAAY,AACZ,eAAiB,CACxB,AACD,iUAEU,WAAe,AACf,sBAA0B,AAC1B,iBAAsB,CAC/B,AACD,oJACQ,MAAO,AACP,YAAa,AACb,gBAAkB,CACzB,AACD,iUAEU,WAAe,AACf,sBAA0B,AAC1B,iBAAsB,CAC/B,AACD,kKACU,kBAAoB,CAC7B","file":"le-datepicker.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar {\n  min-height: 310px;\n  border: solid 1px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar.theme-dark,\n  .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar {\n    background-color: #141a42;\n    border-color: #474a6a;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar.theme-light,\n  .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar {\n    background-color: #ffffff;\n    border-color: #dddddd;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn {\n    font-size: 12px;\n    font-family: Roboto;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn {\n      background: #141a42;\n      color: #ffffff;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .day__month_btn {\n      background: #ffffff;\n      color: #666666;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next {\n    text-indent: 0;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next {\n      color: #b1b1b1;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:hover, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:hover {\n      background-color: #f2f2f2;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev:after, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next:after {\n      display: none;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .prev.disabled:after, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .next.disabled:after {\n      display: none;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell {\n    font-size: 14px;\n    font-family: Roboto;\n    height: 30px;\n    line-height: 30px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell {\n      color: #ffffff;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell {\n      color: #666666;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover {\n      border: solid 1px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover {\n        background-color: rgba(255, 255, 255, 0.2);\n        border-color: #141a42;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:hover {\n        background-color: #f2f2f2;\n        border-color: #ffffff;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today {\n      border-color: rgba(255, 255, 255, 0.2);\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.today {\n      border-color: #cccccc;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header {\n      font-size: 13px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header {\n        color: #bbc0c9;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header {\n        color: #757575;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.day-header:hover {\n        background: none;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected {\n      border-radius: 1px;\n      border: solid 1px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected {\n        color: #ffffff;\n        background-color: rgba(255, 255, 255, 0.1);\n        border-color: #0c5de6;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected {\n        color: #1D2553;\n        background-color: #8BA3EA;\n        border-color: #1D2553;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover {\n        background-color: #595a80;\n        border-color: #141a42;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected:hover {\n        background-color: #C9D3F3;\n        border-color: #1D2553;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted {\n        border: solid 2px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted.theme-dark,\n        .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted {\n          background-color: rgba(255, 255, 255, 0.1);\n          border-color: #0c5de6;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted.theme-light,\n        .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted {\n          background-color: #8BA3EA;\n          border-color: #1D2553;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover {\n          border: solid 2px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover.theme-dark,\n          .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover {\n            background-color: #595a80;\n            border-color: #141a42;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover.theme-light,\n          .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.selected.highlighted:hover {\n            background-color: #C9D3F3;\n            border-color: #1D2553;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted {\n      border-radius: 1px;\n      border: solid 1px;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted {\n        color: #ffffff;\n        border-color: #141a42;\n        background-color: rgba(255, 255, 255, 0.1);\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted {\n        color: #1D2553;\n        border-color: #ffffff;\n        background-color: #8BA3EA;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover.theme-dark,\n      .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover {\n        border-color: #141a42;\n        background-color: #595a80;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover.theme-light,\n      .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted:hover {\n        border-color: #ffffff;\n        background-color: #d0d9f2;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled.theme-dark,\n    .theme-dark .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled {\n      color: #888888;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled.theme-light,\n    .theme-light .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell.disabled {\n      color: #b1b1b1;\n}\n.le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).day:hover, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).month:hover, .le-datepicker .vdp-datepicker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled):not(.selected).year:hover {\n      border: none;\n}\n.le-datepicker .vdp-datepicker.date-input-field .vdp-datepicker__calendar {\n  width: 100%;\n  min-width: 200px;\n  max-width: 400px;\n  padding: 0 6px;\n  white-space: pre-line;\n}\n.le-datepicker .vdp-datepicker.date-input-field .vdp-datepicker__calendar div {\n    clear: both;\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input,\n.theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input {\n  border: 1px solid transparent;\n  background-color: #474a6a;\n  color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input:hover,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:hover {\n    border-color: transparent;\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-webkit-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-webkit-input-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-moz-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-moz-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-ms-input-placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input::placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input:-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-dark input:-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input,\n.theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input {\n  border: 1px solid #8C8D8F;\n  background-color: #ebecef;\n  color: rgba(10, 10, 10, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input:hover,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:hover {\n    border-color: #8C8D8F;\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-webkit-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-webkit-input-placeholder {\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-moz-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-moz-placeholder {\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::-ms-input-placeholder {\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input::placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input::placeholder {\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input:-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.disabled-input.theme-light input:-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field.disabled-input input:-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: rgba(111, 115, 124, 0.5);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input,\n.theme-dark .le-datepicker .vdp-datepicker.date-input-field input {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n  height: 32px;\n  padding: 0 9px;\n  width: 100%;\n  line-height: 32px;\n  font-size: 12px;\n  font-family: Roboto;\n  border: 1px solid #474a6a;\n  background-color: rgba(71, 74, 106, 0.5);\n  color: #ffffff;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:hover,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input:hover {\n    border-color: #2d3162;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:focus,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input:focus {\n    border-color: #5879da;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-webkit-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-webkit-input-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-moz-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-moz-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-ms-input-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input::placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input:-ms-input-placeholder,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder {\n    /* Microsoft Edge */\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-dark input::-ms-clear,\n  .theme-dark .le-datepicker .vdp-datepicker.date-input-field input::-ms-clear {\n    /* Internet Explorer 10-11 */\n    display: none;\n    width: 0;\n    height: 0;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input,\n.theme-light .le-datepicker .vdp-datepicker.date-input-field input {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n  height: 32px;\n  padding: 0 9px;\n  width: 100%;\n  line-height: 32px;\n  font-size: 12px;\n  font-family: Roboto;\n  border: 1px solid #8C8D8F;\n  background-color: #fcfcfd;\n  color: #0A0A0A;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input:hover,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input:hover {\n    border-color: #8C8D8F;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input:focus,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input:focus {\n    border-color: #666666;\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-webkit-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input::-webkit-input-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-moz-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input::-moz-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input::-ms-input-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input::placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input::placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input:-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input:-ms-input-placeholder,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input:-ms-input-placeholder {\n    /* Microsoft Edge */\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-datepicker .vdp-datepicker.date-input-field.theme-light input::-ms-clear,\n  .theme-light .le-datepicker .vdp-datepicker.date-input-field input::-ms-clear {\n    /* Internet Explorer 10-11 */\n    display: none;\n    width: 0;\n    height: 0;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar {\n  width: 220px;\n  border: none;\n  padding: 7px 6px 0 6px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header {\n    width: 220px;\n    height: 50px;\n    margin-bottom: 3px;\n    position: relative;\n    left: -6px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header header {\n      margin-top: 10px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers {\n      display: inline-block;\n      width: 100px;\n      height: 30px;\n      border-radius: 1px;\n      border: 1px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container {\n        float: left;\n        margin-left: 6px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container.theme-light,\n        .theme-light .le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-date-container {\n          color: #666666;\n          background-color: #ffffff;\n          border-color: #dddddd;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container {\n        top: 0;\n        float: right;\n        margin-right: 6px;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container.theme-light,\n        .theme-light .le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container {\n          color: #666666;\n          background-color: #ffffff;\n          border-color: #dddddd;\n}\n.le-datepicker .vdp-datepicker.date-and-time-picker .vdp-datepicker__calendar .calender-header .selected-date-time-containers.select-time-container .item-content {\n          padding: 0 0 0 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?r(exports):"function"==typeof define&&define.amd?define(["exports"],r):r((e=e||self).vdp_translation_index={})}(this,function(e){"use strict";function r(e,r){for(var a=0;a<r.length;a++){var n=r[a];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var a=function(){function e(r,a,n,u){!function(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}(this,e),this.language=r,this.months=a,this.monthsAbbr=n,this.days=u,this.rtl=!1,this.ymd=!1,this.yearSuffix=""}var a,n,u;return a=e,(n=[{key:"language",get:function(){return this._language},set:function(e){if("string"!=typeof e)throw new TypeError("Language must be a string");this._language=e}},{key:"months",get:function(){return this._months},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 months for ".concat(this.language," language"));this._months=e}},{key:"monthsAbbr",get:function(){return this._monthsAbbr},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 abbreviated months for ".concat(this.language," language"));this._monthsAbbr=e}},{key:"days",get:function(){return this._days},set:function(e){if(7!==e.length)throw new RangeError("There must be 7 days for ".concat(this.language," language"));this._days=e}}])&&r(a.prototype,n),u&&r(a,u),e}(),n=new a("Afrikaans",["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."]),u=new a("Arabic",["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]);u.rtl=!0;var i=new a("Bulgarian",["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),t=new a("Bosnian",["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),o=new a("Catalan",["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"],["Diu","Dil","Dmr","Dmc","Dij","Div","Dis"]),s=new a("Czech",["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"],["ne","po","út","st","čt","pá","so"]),b=new a("Danish",["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sø","Ma","Ti","On","To","Fr","Lø"]),l=new a("German",["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]),m=new a("Estonian",["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],["P","E","T","K","N","R","L"]),M=new a("Greek",["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάϊος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"]),p=new a("English",["January","February","March","April","May","June","July","August","September","October","November","December"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]),J=new a("Spanish",["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]),g=new a("Persian",["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],["فرو","ارد","خرد","تیر","مرد","شهر","مهر","آبا","آذر","دی","بهم","اسف"],["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]),S=new a("Finnish",["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],["su","ma","ti","ke","to","pe","la"]),c=new a("Faroese",["Januar","Februar","Mars","Apríl","Mai","Juni","Juli","August","Septembur","Oktobur","Novembur","Desembur"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sun","Mán","Týs","Mik","Hós","Frí","Ley"]),A=new a("French",["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]),v=new a("Georgia",["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"]),h=new a("Galician",["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"]),k=new a("Hebrew",["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"],["א","ב","ג","ד","ה","ו","ש"]);k.rtl=!0;var w=new a("Croatian",["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),D=new a("Hungarian",["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"],["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]),f=new a("Indonesian",["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],["Min","Sen","Sel","Rab","Kam","Jum","Sab"]),N=new a("Icelandic",["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]),O=new a("Italian",["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]),j=new a("Japanese",["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["日","月","火","水","木","金","土"]);j.yearSuffix="年",j.ymd=!0;var F=new a("Kazakh",["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],["Жк","Дй","Сй","Ср","Бй","Жм","Сн"]),d=new a("Korean",["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["일","월","화","수","목","금","토"]);d.yearSuffix="년",d.ymd=!0;var T=new a("Luxembourgish",["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mé.","Dë.","Më.","Do.","Fr.","Sa."]),y=new a("Lithuanian",["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]);y.ymd=!0;var z=new a("Latvian",["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],["Sv","Pr","Ot","Tr","Ce","Pk","Se"]),L=new a("Macedonian",["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],["Нед","Пон","Вто","Сре","Чет","Пет","Саб"]),P=new a("Mongolia",["1 дүгээр сар","2 дугаар сар","3 дугаар сар","4 дүгээр сар","5 дугаар сар","6 дугаар сар","7 дугаар сар","8 дугаар сар","9 дүгээр сар","10 дугаар сар","11 дүгээр сар","12 дугаар сар"],["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],["Ня","Да","Мя","Лх","Пү","Ба","Бя"]);P.ymd=!0;var G=new a("Norwegian Bokmål",["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sø","Ma","Ti","On","To","Fr","Lø"]),C=new a("Dutch",["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],["zo","ma","di","wo","do","vr","za"]),K=new a("Polish",["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]),R=new a("Brazilian",["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]),E=new a("Romanian",["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],["D","L","Ma","Mi","J","V","S"]),V=new a("Russian",["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"],["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]),_=new a("Slovakian",["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"],["ne","po","ut","st","št","pi","so"]),x=new a("Sloveian",["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]),I=new a("Serbian in Cyrillic script",["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],["Нед","Пон","Уто","Сре","Чет","Пет","Суб"]),B=new a("Serbian",["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sre","Čet","Pet","Sub"]),H=new a("Swedish",["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]),X=new a("Thai",["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],["อา","จ","อ","พ","พฤ","ศ","ส"]),U=new a("Turkish",["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]),W=new a("Ukraine",["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),Q=new a("Urdu",["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"]);Q.rtl=!0;var Y=new a("Vietnamese",["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"],["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]),q=new a("Chinese",["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["日","一","二","三","四","五","六"]);q.yearSuffix="年";var Z=new a("Chinese_HK",["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["日","壹","贰","叁","肆","伍","陆"]);Z.yearSuffix="年",e.af=n,e.ar=u,e.bg=i,e.bs=t,e.ca=o,e.cs=s,e.da=b,e.de=l,e.ee=m,e.el=M,e.en=p,e.es=J,e.fa=g,e.fi=S,e.fo=c,e.fr=A,e.ge=v,e.gl=h,e.he=k,e.hr=w,e.hu=D,e.id=f,e.is=N,e.it=O,e.ja=j,e.kk=F,e.ko=d,e.lb=T,e.lt=y,e.lv=z,e.mk=L,e.mn=P,e.nbNO=G,e.nl=C,e.pl=K,e.ptBR=R,e.ro=E,e.ru=V,e.sk=_,e.slSI=x,e.sr=B,e.srCYRL=I,e.sv=H,e.th=X,e.tr=U,e.uk=W,e.ur=Q,e.vi=Y,e.zh=q,e.zhHK=Z,Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var Language =
/*#__PURE__*/
function () {
  function Language(language, months, monthsAbbr, days) {
    _classCallCheck(this, Language);

    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  _createClass(Language, [{
    key: "language",
    get: function get() {
      return this._language;
    },
    set: function set(language) {
      if (typeof language !== 'string') {
        throw new TypeError('Language must be a string');
      }

      this._language = language;
    }
  }, {
    key: "months",
    get: function get() {
      return this._months;
    },
    set: function set(months) {
      if (months.length !== 12) {
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      }

      this._months = months;
    }
  }, {
    key: "monthsAbbr",
    get: function get() {
      return this._monthsAbbr;
    },
    set: function set(monthsAbbr) {
      if (monthsAbbr.length !== 12) {
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      }

      this._monthsAbbr = monthsAbbr;
    }
  }, {
    key: "days",
    get: function get() {
      return this._days;
    },
    set: function set(days) {
      if (days.length !== 7) {
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      }

      this._days = days;
    }
  }]);

  return Language;
}(); // eslint-disable-next-line

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,

  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }

    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }

    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if (_typeof(date) !== 'object') {
      throw TypeError('Invalid Type');
    }

    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }

    if (_typeof(month) === 'object') {
      return months[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return months[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }

    if (_typeof(month) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return monthsAbbr[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';

      case 2:
      case 22:
        return 'nd';

      case 3:
      case 23:
        return 'rd';

      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var dates = [];

    while (start <= end) {
      dates.push(new Date(start));
      start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
    }

    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};
var makeDateUtils = function makeDateUtils(useUtc) {
  return _objectSpread({}, utils, {
    useUtc: useUtc
  });
};
var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
;

var script = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }

      if (this.typedDate) {
        return this.typedDate;
      }

      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }

        return _objectSpread({
          'form-control': true
        }, this.inputClass);
      }

      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },

    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);

        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
} // eslint-disable-next-line
;

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "input-group": _vm.bootstrapStyling } },
    [
      _vm.calendarButton
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__calendar-button",
              class: { "input-group-prepend": _vm.bootstrapStyling },
              style: { "cursor:not-allowed;": _vm.disabled },
              on: { click: _vm.showCalendar }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.calendarButtonIcon }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calendarButtonIconContent) +
                        "\n        "
                    ),
                    !_vm.calendarButtonIcon
                      ? _c("span", [_vm._v("…")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: _vm.refName,
        class: _vm.computedInputClass,
        attrs: {
          type: _vm.inline ? "hidden" : "text",
          name: _vm.name,
          id: _vm.id,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "clear-button": _vm.clearButton,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: !_vm.typeable,
          autocomplete: "off"
        },
        domProps: { value: _vm.formattedValue },
        on: {
          click: _vm.showCalendar,
          keyup: _vm.parseTypedDate,
          blur: _vm.inputBlurred
        }
      }),
      _vm._v(" "),
      _vm.clearButton && _vm.selectedDate
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__clear-button",
              class: { "input-group-append": _vm.bootstrapStyling },
              on: {
                click: function($event) {
                  return _vm.clearDate()
                }
              }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.clearButtonIcon }, [
                    !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("afterDateInput")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DateInput = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      "default": function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }

      return this.translation.days;
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }

      return this.utils.getDay(dObj);
    },

    /**
     * @return {Object[]}
     */
    days: function days() {
      var d = this.pageDate;
      var days = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isHighlightStart: this.isHighlightStart(dObj),
          isHighlightEnd: this.isHighlightEnd(dObj),
          isToday: this.utils.compareDates(dObj, new Date()),
          isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
          isSaturday: this.utils.getDay(dObj) === 6,
          isSunday: this.utils.getDay(dObj) === 0
        });
        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
      }

      return days;
    },

    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },

    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }

      this.$emit('selectDate', date);
    },

    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },

    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },

    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },

    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },

    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },

    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },

    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var _this = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (_this.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }

      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var _this2 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (_this2.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDayView,
          expression: "showDayView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "day__month_btn",
            class: _vm.allowedToShowView("month") ? "up" : "",
            on: { click: _vm.showMonthCalendar }
          },
          [
            _vm._v(
              _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                " " +
                _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isRtl ? "flex-rtl" : "" },
        [
          _vm._l(_vm.daysOfWeek, function(d) {
            return _c(
              "span",
              { key: d.timestamp, staticClass: "cell day-header" },
              [_vm._v(_vm._s(d))]
            )
          }),
          _vm._v(" "),
          _vm.blankDays > 0
            ? _vm._l(_vm.blankDays, function(d) {
                return _c("span", {
                  key: d.timestamp,
                  staticClass: "cell day blank"
                })
              })
            : _vm._e(),
          _vm._l(_vm.days, function(day) {
            return _c("span", {
              key: day.timestamp,
              staticClass: "cell day",
              class: _vm.dayClasses(day),
              domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
              on: {
                click: function($event) {
                  return _vm.selectDate(day)
                }
              }
            })
          })
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerDay = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
var script$2 = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var d = this.pageDate;
      var months = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 12; i++) {
        months.push({
          month: this.utils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
      }

      return months;
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }

      this.$emit('selectMonth', month);
    },

    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },

    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },

    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },

    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "month__year_btn",
            class: _vm.allowedToShowView("year") ? "up" : "",
            on: { click: _vm.showYearCalendar }
          },
          [_vm._v(_vm._s(_vm.pageYearName))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.months, function(month) {
        return _c(
          "span",
          {
            key: month.timestamp,
            staticClass: "cell month",
            class: { selected: month.isSelected, disabled: month.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectMonth(month)
              }
            }
          },
          [_vm._v(_vm._s(month.month))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerMonth = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var d = this.pageDate;
      var years = []; // set up a new date object to the beginning of the current 'page'7

      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 10; i++) {
        years.push({
          year: this.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
      }

      return years;
    },

    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }

      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }

      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }

      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showYearView,
          expression: "showYearView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.years, function(year) {
        return _c(
          "span",
          {
            key: year.timestamp,
            staticClass: "cell year",
            class: { selected: year.isSelected, disabled: year.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectYear(year)
              }
            }
          },
          [_vm._v(_vm._s(year.year))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerYear = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
var script$4 = {
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      "default": 'dd MMM yyyy'
    },
    language: {
      type: Object,
      "default": function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      "default": 'day'
    },
    maximumView: {
      type: String,
      "default": 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,

      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,

      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,

      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },
    translation: function translation() {
      return this.language;
    },
    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }

      this.setPageDate(this.selectedDate);
    },

    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }

      if (this.isOpen) {
        return this.close(true);
      }

      this.setInitialView();
    },

    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;

      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      }

      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;

        case 'month':
          this.showMonthCalendar();
          break;

        default:
          this.showDayCalendar();
          break;
      }
    },

    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);
      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },

    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }

      this.close();
      this.showDayView = true;
      return true;
    },

    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }

      this.close();
      this.showMonthView = true;
      return true;
    },

    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }

      this.close();
      this.showYearView = true;
      return true;
    },

    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },

    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);

      if (!this.isInline) {
        this.close(true);
      }

      this.resetTypedDate = new Date();
    },

    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },

    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);

      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },

    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);

      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },

    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.setPageDate(date);
    },

    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }

      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },

    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },

    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },

    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;

      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }

        document.removeEventListener('click', this.clickOutside, false);
      }
    },

    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }

      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
} // eslint-disable-next-line
;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
    },
    [
      _c(
        "date-input",
        {
          attrs: {
            selectedDate: _vm.selectedDate,
            resetTypedDate: _vm.resetTypedDate,
            format: _vm.format,
            translation: _vm.translation,
            inline: _vm.inline,
            id: _vm.id,
            name: _vm.name,
            refName: _vm.refName,
            openDate: _vm.openDate,
            placeholder: _vm.placeholder,
            inputClass: _vm.inputClass,
            typeable: _vm.typeable,
            clearButton: _vm.clearButton,
            clearButtonIcon: _vm.clearButtonIcon,
            calendarButton: _vm.calendarButton,
            calendarButtonIcon: _vm.calendarButtonIcon,
            calendarButtonIconContent: _vm.calendarButtonIconContent,
            disabled: _vm.disabled,
            required: _vm.required,
            bootstrapStyling: _vm.bootstrapStyling,
            "use-utc": _vm.useUtc
          },
          on: {
            showCalendar: _vm.showCalendar,
            closeCalendar: _vm.close,
            typedDate: _vm.setTypedDate,
            clearDate: _vm.clearDate
          }
        },
        [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      _vm._v(" "),
      _vm.allowedToShowView("day")
        ? _c(
            "picker-day",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showDayView: _vm.showDayView,
                fullMonthName: _vm.fullMonthName,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                highlighted: _vm.highlighted,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                pageTimestamp: _vm.pageTimestamp,
                isRtl: _vm.isRtl,
                mondayFirst: _vm.mondayFirst,
                dayCellContent: _vm.dayCellContent,
                "use-utc": _vm.useUtc
              },
              on: {
                changedMonth: _vm.handleChangedMonthFromDayPicker,
                selectDate: _vm.selectDate,
                showMonthCalendar: _vm.showMonthCalendar,
                selectedDisabled: _vm.selectDisabledDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("month")
        ? _c(
            "picker-month",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showMonthView: _vm.showMonthView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: {
                selectMonth: _vm.selectMonth,
                showYearCalendar: _vm.showYearCalendar,
                changedYear: _vm.setPageDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("year")
        ? _c(
            "picker-year",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showYearView: _vm.showYearView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  

  
  var Datepicker = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    browser,
    undefined
  );

/* harmony default export */ __webpack_exports__["a"] = (Datepicker);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-datepicker",attrs:{"id":_vm.id}},[_c('datepicker',{attrs:{"inline":_vm.inline,"value":_vm.selectedDate,"disabledDates":_vm.disabled,"highlighted":_vm.highlighted,"minimumView":_vm.minimumView,"maximumView":_vm.maximumView,"bootstrap-styling":true,"language":_vm.languageChosen,"format":_vm.format,"placeholder":_vm.placeholder,"typeable":_vm.isDateInputField,"wrapper-class":_vm.wrapperClass,"disabled":_vm.disabledInput},on:{"selected":_vm.onDateSelected,"input":_vm.updateAccessibilityAttributes,"changedMonth":_vm.updateAccessibilityAttributes}},[(_vm.isDateAndTimePicker)?_c('div',{staticClass:"calender-header",attrs:{"slot":"beforeCalendarHeader"},slot:"beforeCalendarHeader"},[_c('div',[_c('div',{staticClass:"selected-date-time-containers select-date-container"},[_c('span',{attrs:{"id":_vm.getDateId}},[_vm._v(_vm._s(this.dateLabel))]),_vm._v(" "),_c('le-input-field',{attrs:{"enabled":false,"ariaLabelledBy":_vm.getDateId},model:{value:(_vm.dateToDisplay),callback:function ($$v) {_vm.dateToDisplay=$$v},expression:"dateToDisplay"}})],1),_vm._v(" "),_c('div',{staticClass:"selected-date-time-containers select-time-container"},[_c('span',{attrs:{"id":_vm.getTimeId}},[_vm._v(_vm._s(this.timeLabel))]),_vm._v(" "),_c('le-select',{attrs:{"floated":false,"theme":_vm.theme,"type":"dropdown","items":_vm.timeFrameItems,"dropdownDefaultSelection":true,"maxItemsToShow":7,"ariaLabel":_vm.getTimeId},on:{"input":_vm.onTimeSelected},model:{value:(_vm.selectedTime),callback:function ($$v) {_vm.selectedTime=$$v},expression:"selectedTime"}})],1)])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_textarea_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75703f6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_textarea_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75703f6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75703f6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("482fd09b", content, true, {});

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-textarea.theme-dark .input-textarea[data-v-75703f6c],.theme-dark .le-textarea .input-textarea[data-v-75703f6c]{resize:none;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;padding:0 9px;width:100%;font-size:12px;line-height:22px;font-family:Roboto;border:1px solid #474a6a;background-color:rgba(71,74,106,.5);color:#fff}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:hover,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]:hover{border-color:#2d3162}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:focus,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]:focus{border-color:#5879da}.le-textarea.theme-dark .input-textarea.has-error[data-v-75703f6c],.theme-dark .le-textarea .input-textarea.has-error[data-v-75703f6c]{border-color:#ff1820}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-webkit-input-placeholder,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-webkit-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-moz-placeholder,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-moz-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-ms-input-placeholder,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-ms-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::placeholder,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]::placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:-ms-input-placeholder,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]:-ms-input-placeholder{font-style:italic;color:hsla(0,0%,100%,.9)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c],.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]{border:1px solid transparent;background-color:#474a6a;color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder,.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder{color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder,.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder{color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder,.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::placeholder,.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::placeholder{color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder,.theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-ms-clear,.theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-ms-clear{display:none;width:0;height:0}.le-textarea.theme-dark .input-textarea.resizable[data-v-75703f6c],.theme-dark .le-textarea .input-textarea.resizable[data-v-75703f6c]{resize:both}.le-textarea.theme-light .input-textarea[data-v-75703f6c],.theme-light .le-textarea .input-textarea[data-v-75703f6c]{resize:none;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;padding:0 9px;width:100%;font-size:12px;line-height:22px;font-family:Roboto;border:1px solid #8c8d8f;background-color:#fcfcfd;color:#0a0a0a}.le-textarea.theme-light .input-textarea[data-v-75703f6c]:hover,.theme-light .le-textarea .input-textarea[data-v-75703f6c]:hover{border-color:#8c8d8f}.le-textarea.theme-light .input-textarea[data-v-75703f6c]:focus,.theme-light .le-textarea .input-textarea[data-v-75703f6c]:focus{border-color:#666}.le-textarea.theme-light .input-textarea.has-error[data-v-75703f6c],.theme-light .le-textarea .input-textarea.has-error[data-v-75703f6c]{border-color:#d0021b}.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-webkit-input-placeholder,.theme-light .le-textarea .input-textarea[data-v-75703f6c]::-webkit-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-moz-placeholder,.theme-light .le-textarea .input-textarea[data-v-75703f6c]::-moz-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-ms-input-placeholder,.theme-light .le-textarea .input-textarea[data-v-75703f6c]::-ms-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-textarea.theme-light .input-textarea[data-v-75703f6c]::placeholder,.theme-light .le-textarea .input-textarea[data-v-75703f6c]::placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-textarea.theme-light .input-textarea[data-v-75703f6c]:-ms-input-placeholder,.theme-light .le-textarea .input-textarea[data-v-75703f6c]:-ms-input-placeholder{font-style:italic;color:hsla(0,0%,4%,.9)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c],.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]{border:1px solid #8c8d8f;background-color:#ebecef;color:hsla(0,0%,4%,.5)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder,.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder{color:hsla(222,6%,46%,.5)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder,.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder{color:hsla(222,6%,46%,.5)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder,.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::placeholder,.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::placeholder{color:hsla(222,6%,46%,.5)}.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder,.theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-ms-clear,.theme-light .le-textarea .input-textarea[data-v-75703f6c]::-ms-clear{display:none;width:0;height:0}.le-textarea.theme-light .input-textarea.resizable[data-v-75703f6c],.theme-light .le-textarea .input-textarea.resizable[data-v-75703f6c]{resize:both}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-textarea/le-textarea.vue"],"names":[],"mappings":"AAIA,mHAEE,YAAa,AACb,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,cAAe,AACf,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,yBAA0B,AAC1B,oCAAyC,AACzC,UAAe,CAChB,AACD,+HAEI,oBAAsB,CACzB,AACD,+HAEI,oBAAsB,CACzB,AACD,uIAEI,oBAAsB,CACzB,AACD,yKAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,uJAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,iKAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,6IAEI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,+JAGI,kBAAmB,AACnB,wBAAgC,CACnC,AACD,qIAEI,6BAA8B,AAC9B,yBAA0B,AAC1B,wBAAgC,CACnC,AACD,2LAEM,wBAAgC,CACrC,AACD,yKAEM,wBAAgC,CACrC,AACD,mLAEM,wBAAgC,CACrC,AACD,+JAEM,wBAAgC,CACrC,AACD,iLAGM,wBAAgC,CACrC,AACD,yIAGI,aAAc,AACd,QAAS,AACT,QAAU,CACb,AACD,uIAEI,WAAa,CAChB,AACD,qHAEE,YAAa,AACb,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,cAAe,AACf,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,yBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CAChB,AACD,iIAEI,oBAAsB,CACzB,AACD,iIAEI,iBAAsB,CACzB,AACD,yIAEI,oBAAsB,CACzB,AACD,2KAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,yJAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,mKAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,+IAEI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,iKAGI,kBAAmB,AACnB,sBAA6B,CAChC,AACD,uIAEI,yBAA0B,AAC1B,yBAA0B,AAC1B,sBAA6B,CAChC,AACD,6LAEM,yBAAgC,CACrC,AACD,2KAEM,yBAAgC,CACrC,AACD,qLAEM,yBAAgC,CACrC,AACD,iKAEM,yBAAgC,CACrC,AACD,mLAGM,yBAAgC,CACrC,AACD,2IAGI,aAAc,AACd,QAAS,AACT,QAAU,CACb,AACD,yIAEI,WAAa,CAChB","file":"le-textarea.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c],\n.theme-dark .le-textarea .input-textarea[data-v-75703f6c] {\n  resize: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n  padding: 0 9px;\n  width: 100%;\n  font-size: 12px;\n  line-height: 22px;\n  font-family: Roboto;\n  border: 1px solid #474a6a;\n  background-color: rgba(71, 74, 106, 0.5);\n  color: #ffffff;\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:hover,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]:hover {\n    border-color: #2d3162;\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:focus,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]:focus {\n    border-color: #5879da;\n}\n.le-textarea.theme-dark .input-textarea.has-error[data-v-75703f6c],\n  .theme-dark .le-textarea .input-textarea.has-error[data-v-75703f6c] {\n    border-color: #ff1820;\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-webkit-input-placeholder,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-webkit-input-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-moz-placeholder,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-moz-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-ms-input-placeholder,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-ms-input-placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::placeholder,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]::placeholder {\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]:-ms-input-placeholder,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    font-style: italic;\n    color: rgba(255, 255, 255, 0.9);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c],\n  .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c] {\n    border: 1px solid transparent;\n    background-color: #474a6a;\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder,\n    .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder,\n    .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder,\n    .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]::placeholder,\n    .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]::placeholder {\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder,\n    .theme-dark .le-textarea .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      color: rgba(255, 255, 255, 0.6);\n}\n.le-textarea.theme-dark .input-textarea[data-v-75703f6c]::-ms-clear,\n  .theme-dark .le-textarea .input-textarea[data-v-75703f6c]::-ms-clear {\n    /* Internet Explorer 10-11 */\n    display: none;\n    width: 0;\n    height: 0;\n}\n.le-textarea.theme-dark .input-textarea.resizable[data-v-75703f6c],\n  .theme-dark .le-textarea .input-textarea.resizable[data-v-75703f6c] {\n    resize: both;\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c],\n.theme-light .le-textarea .input-textarea[data-v-75703f6c] {\n  resize: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n  padding: 0 9px;\n  width: 100%;\n  font-size: 12px;\n  line-height: 22px;\n  font-family: Roboto;\n  border: 1px solid #8C8D8F;\n  background-color: #fcfcfd;\n  color: #0A0A0A;\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]:hover,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]:hover {\n    border-color: #8C8D8F;\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]:focus,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]:focus {\n    border-color: #666666;\n}\n.le-textarea.theme-light .input-textarea.has-error[data-v-75703f6c],\n  .theme-light .le-textarea .input-textarea.has-error[data-v-75703f6c] {\n    border-color: #d0021b;\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-webkit-input-placeholder,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]::-webkit-input-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-moz-placeholder,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]::-moz-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-ms-input-placeholder,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]::-ms-input-placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]::placeholder,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]::placeholder {\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]:-ms-input-placeholder,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    font-style: italic;\n    color: rgba(10, 10, 10, 0.9);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c],\n  .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c] {\n    border: 1px solid #8C8D8F;\n    background-color: #ebecef;\n    color: rgba(10, 10, 10, 0.5);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder,\n    .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-webkit-input-placeholder {\n      color: rgba(111, 115, 124, 0.5);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder,\n    .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-moz-placeholder {\n      color: rgba(111, 115, 124, 0.5);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder,\n    .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::-ms-input-placeholder {\n      color: rgba(111, 115, 124, 0.5);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]::placeholder,\n    .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]::placeholder {\n      color: rgba(111, 115, 124, 0.5);\n}\n.le-textarea.theme-light .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder,\n    .theme-light .le-textarea .input-textarea.disabled[data-v-75703f6c]:-ms-input-placeholder {\n      /* Internet Explorer 10-11 */\n      color: rgba(111, 115, 124, 0.5);\n}\n.le-textarea.theme-light .input-textarea[data-v-75703f6c]::-ms-clear,\n  .theme-light .le-textarea .input-textarea[data-v-75703f6c]::-ms-clear {\n    /* Internet Explorer 10-11 */\n    display: none;\n    width: 0;\n    height: 0;\n}\n.le-textarea.theme-light .input-textarea.resizable[data-v-75703f6c],\n  .theme-light .le-textarea .input-textarea.resizable[data-v-75703f6c] {\n    resize: both;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-textarea"},[_c('le-bubble',{attrs:{"theme":"dark","trigger":"manual","open":_vm.showError,"placement":_vm.errorPlacement,"hideOnTargetClick":true}},[_c('template',{slot:"target"},[_c('textarea',{ref:"textarea",class:_vm.classes,style:(_vm.inputPaddingStyle),attrs:{"placeholder":_vm.placeholder,"disabled":!_vm.enabled,"maxlength":_vm.maxChars,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"keyup":_vm.onKeyUp}})]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v("\n      "+_vm._s(_vm.bubbleErrorMsg)+"\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_link_editor_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_168b326f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_link_editor_vue__ = __webpack_require__(668);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-168b326f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_link_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_168b326f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_link_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("04e8c0aa", content, true, {});

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-link-editor[data-v-168b326f]{width:300px}.input-label[data-v-168b326f]{font-size:12px;margin-bottom:3px}.input-label.href-label[data-v-168b326f]{margin-top:10px}.title-input[data-v-168b326f]{margin-bottom:10px}.href-input[data-v-168b326f]{margin-bottom:20px}.confirm-button[data-v-168b326f]{float:right}.cancel-button[data-v-168b326f]{float:left}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-text-editor/le-link-editor/le-link-editor.vue"],"names":[],"mappings":"AAIA,iCACE,WAAa,CACd,AACD,8BACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,yCACI,eAAiB,CACpB,AACD,8BACE,kBAAoB,CACrB,AACD,6BACE,kBAAoB,CACrB,AACD,iCACE,WAAa,CACd,AACD,gCACE,UAAY,CACb","file":"le-link-editor.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-link-editor[data-v-168b326f] {\n  width: 300px;\n}\n.input-label[data-v-168b326f] {\n  font-size: 12px;\n  margin-bottom: 3px;\n}\n.input-label.href-label[data-v-168b326f] {\n    margin-top: 10px;\n}\n.title-input[data-v-168b326f] {\n  margin-bottom: 10px;\n}\n.href-input[data-v-168b326f] {\n  margin-bottom: 20px;\n}\n.confirm-button[data-v-168b326f] {\n  float: right;\n}\n.cancel-button[data-v-168b326f] {\n  float: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('le-bubble',{attrs:{"trigger":"manual","auto-hide":true,"open":_vm.linkEditorOpen},on:{"hide":_vm.onBubbleHide}},[_c('template',{slot:"target"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltipLabel, html: false, autoHide: false }),expression:"{ content: tooltipLabel, html: false, autoHide: false }"}],class:['ico-16 ico-link', 'le-link-editor-icon', { 'disabled': _vm.isDisabled }],attrs:{"tabindex":"0","role":"button","aria-label":_vm.tooltipLabel,"aria-haspopup":"dialog","aria-expanded":("" + _vm.linkEditorOpen),"aria-disabled":("" + _vm.isDisabled)},on:{"click":_vm.openLinkEditor,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.openLinkEditor($event)}}})]),_vm._v(" "),_c('template',{slot:"content"},[_c('div',{class:['le-link-editor', _vm.theme]},[(_vm.titleLabel)?_c('label',{staticClass:"input-label title-label",attrs:{"for":"le-link-editor-add-link-title"}},[_vm._v(_vm._s(_vm.titleLabel))]):_vm._e(),_vm._v(" "),_c('le-input-field',{ref:"titleInput",staticClass:"title-input",attrs:{"placeholder":_vm.titlePlaceholder,"id":"le-link-editor-add-link-title"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),(_vm.hrefLabel)?_c('label',{staticClass:"input-label href-label",attrs:{"for":"le-link-editor-add-link-url"}},[_vm._v(_vm._s(_vm.hrefLabel))]):_vm._e(),_vm._v(" "),_c('le-input-field',{ref:"hrefInput",staticClass:"href-input",attrs:{"placeholder":_vm.hrefPlaceholder,"id":"le-link-editor-add-link-url"},model:{value:(_vm.href),callback:function ($$v) {_vm.href=$$v},expression:"href"}}),_vm._v(" "),_c('le-button',{staticClass:"confirm-button",attrs:{"label":_vm.confirmLabel,"variant":_vm.CONSTS.LE_BUTTON.VARIANTS.PRIMARY},on:{"click":_vm.onConfirm}}),_vm._v(" "),_c('le-button',{staticClass:"cancel-button",attrs:{"label":_vm.cancelLabel,"variant":_vm.CONSTS.LE_BUTTON.VARIANTS.CANCEL},on:{"click":_vm.onCancel}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_notifier_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2ca268_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_notifier_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e2ca268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_notifier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2ca268_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_notifier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(671);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2bd80841", content, true, {});

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-notifier[data-v-4e2ca268]{display:inline-table;position:absolute;height:30px;top:0;left:0;right:0;margin:auto;border-radius:3px}.le-notifier.theme-dark[data-v-4e2ca268],.le-notifier.theme-light[data-v-4e2ca268],.theme-dark .le-notifier[data-v-4e2ca268],.theme-light .le-notifier[data-v-4e2ca268]{-webkit-box-shadow:0 2px 2px 0 rgba(0,0,0,.15);box-shadow:0 2px 2px 0 rgba(0,0,0,.15);background-color:#f3f6ff}.le-notifier--success.theme-dark[data-v-4e2ca268],.le-notifier--success.theme-light[data-v-4e2ca268],.theme-dark .le-notifier--success[data-v-4e2ca268],.theme-light .le-notifier--success[data-v-4e2ca268]{color:#2a2b2e;border-radius:4px;background:linear-gradient(180deg,#7d9e1a,#7d9e1a 3px,#fcfcfd 0,#fcfcfd)}.le-notifier--error.theme-dark[data-v-4e2ca268],.le-notifier--error.theme-light[data-v-4e2ca268],.theme-dark .le-notifier--error[data-v-4e2ca268],.theme-light .le-notifier--error[data-v-4e2ca268]{color:#2a2b2e;border-radius:4px;background:linear-gradient(180deg,#ef6161,#ef6161 3px,#fcfcfd 0,#fcfcfd)}.le-notifier .inner-notifier[data-v-4e2ca268]{word-break:break-word;word-wrap:break-word}.le-notifier .inner-notifier .notifier-close[data-v-4e2ca268]{cursor:pointer;display:inline-block;float:right;margin-left:4px;margin-top:12px;margin-right:5px}.le-notifier .inner-notifier .notifier-close.theme-dark[data-v-4e2ca268],.le-notifier .inner-notifier .notifier-close.theme-light[data-v-4e2ca268],.theme-dark .le-notifier .inner-notifier .notifier-close[data-v-4e2ca268],.theme-light .le-notifier .inner-notifier .notifier-close[data-v-4e2ca268]{color:#9b9b9b}.le-notifier .inner-notifier .notifier-content[data-v-4e2ca268]{display:inline-block;font-weight:700;font-size:12px;line-height:1.33;margin-left:15px;margin-top:8px}.le-notifier .inner-notifier .notifier-content .icon[data-v-4e2ca268]{margin-bottom:-2.5px;margin-right:5px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-notifier/le-notifier.vue"],"names":[],"mappings":"AAIA,8BACE,qBAAsB,AACtB,kBAAmB,AACnB,YAAa,AACb,MAAO,AACP,OAAQ,AACR,QAAS,AACT,YAAa,AACb,iBAAmB,CACpB,AAOD,wKAEI,+CAAoD,AAC5C,uCAA4C,AACpD,wBAA0B,CAC7B,AAOD,4MAEI,cAAe,AACf,kBAAmB,AACnB,wEAAwF,CAC3F,AAOD,oMAJI,cAAe,AACf,kBAAmB,AACnB,wEAAwF,CAO3F,AACD,8CACI,sBAAuB,AACvB,oBAAsB,CACzB,AACD,8DACM,eAAgB,AAChB,qBAAsB,AACtB,YAAa,AACb,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,CACvB,AAKD,wSAEQ,aAAe,CACtB,AACD,gEACM,qBAAsB,AACtB,gBAAkB,AAClB,eAAgB,AAChB,iBAAkB,AAClB,iBAAkB,AAClB,cAAgB,CACrB,AACD,sEACQ,qBAAsB,AACtB,gBAAkB,CACzB","file":"le-notifier.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-notifier[data-v-4e2ca268] {\n  display: inline-table;\n  position: absolute;\n  height: 30px;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  border-radius: 3px;\n}\n.le-notifier.theme-dark[data-v-4e2ca268],\n  .theme-dark .le-notifier[data-v-4e2ca268] {\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n    background-color: #f3f6ff;\n}\n.le-notifier.theme-light[data-v-4e2ca268],\n  .theme-light .le-notifier[data-v-4e2ca268] {\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n    background-color: #f3f6ff;\n}\n.le-notifier--success.theme-dark[data-v-4e2ca268],\n  .theme-dark .le-notifier--success[data-v-4e2ca268] {\n    color: #2A2B2E;\n    border-radius: 4px;\n    background: linear-gradient(to bottom, #7D9E1A, #7D9E1A 3px, #fcfcfd 3px, #fcfcfd 100%);\n}\n.le-notifier--success.theme-light[data-v-4e2ca268],\n  .theme-light .le-notifier--success[data-v-4e2ca268] {\n    color: #2A2B2E;\n    border-radius: 4px;\n    background: linear-gradient(to bottom, #7D9E1A, #7D9E1A 3px, #fcfcfd 3px, #fcfcfd 100%);\n}\n.le-notifier--error.theme-dark[data-v-4e2ca268],\n  .theme-dark .le-notifier--error[data-v-4e2ca268] {\n    color: #2A2B2E;\n    border-radius: 4px;\n    background: linear-gradient(to bottom, #EF6161, #EF6161 3px, #fcfcfd 3px, #fcfcfd 100%);\n}\n.le-notifier--error.theme-light[data-v-4e2ca268],\n  .theme-light .le-notifier--error[data-v-4e2ca268] {\n    color: #2A2B2E;\n    border-radius: 4px;\n    background: linear-gradient(to bottom, #EF6161, #EF6161 3px, #fcfcfd 3px, #fcfcfd 100%);\n}\n.le-notifier .inner-notifier[data-v-4e2ca268] {\n    word-break: break-word;\n    word-wrap: break-word;\n}\n.le-notifier .inner-notifier .notifier-close[data-v-4e2ca268] {\n      cursor: pointer;\n      display: inline-block;\n      float: right;\n      margin-left: 4px;\n      margin-top: 12px;\n      margin-right: 5px;\n}\n.le-notifier .inner-notifier .notifier-close.theme-dark[data-v-4e2ca268],\n      .theme-dark .le-notifier .inner-notifier .notifier-close[data-v-4e2ca268] {\n        color: #9b9b9b;\n}\n.le-notifier .inner-notifier .notifier-close.theme-light[data-v-4e2ca268],\n      .theme-light .le-notifier .inner-notifier .notifier-close[data-v-4e2ca268] {\n        color: #9b9b9b;\n}\n.le-notifier .inner-notifier .notifier-content[data-v-4e2ca268] {\n      display: inline-block;\n      font-weight: bold;\n      font-size: 12px;\n      line-height: 1.33;\n      margin-left: 15px;\n      margin-top: 8px;\n}\n.le-notifier .inner-notifier .notifier-content .icon[data-v-4e2ca268] {\n        margin-bottom: -2.5px;\n        margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotifier)?_c('div',{ref:"notifier",class:['le-notifier', ("le-notifier--" + _vm.variant)],style:(("min-width: " + _vm.minWidth + "; max-width: " + _vm.maxWidth + ";"))},[_c('div',{staticClass:"inner-notifier"},[(_vm.showCloseButton)?_c('i',{class:['notifier-close', 'ico-le-notifier-close', ("ico-" + _vm.closeIconSize)],attrs:{"tabindex":"0","role":"button","aria-label":_vm.closeIconLabel},on:{"click":_vm.onCloseClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onCloseClick($event)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notifier-content"},[(_vm.isSuccess)?_c('i',{staticClass:"icon ico-success-notify ico-12"}):_vm._e(),_vm._v(" "),(_vm.isError)?_c('i',{staticClass:"icon ico-error-notify ico-12"}):_vm._e(),_vm._v(" "),_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.contentLabel))])])],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_treeview_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e86091e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_treeview_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e86091e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_treeview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e86091e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_treeview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2554ee83", content, true, {});

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-treeview[data-v-6e86091e]{position:relative;width:100%}.le-treeview .select-list[data-v-6e86091e]{font-size:12px;padding-left:0;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;margin:0;list-style:none;overflow:auto;z-index:999}.le-treeview .select-list.theme-dark[data-v-6e86091e],.theme-dark .le-treeview .select-list[data-v-6e86091e]{color:#fff;background-color:#141a42;border:1px solid #474a6a}.le-treeview .select-list.theme-light[data-v-6e86091e],.theme-light .le-treeview .select-list[data-v-6e86091e]{color:#666;background-color:#fff;border:1px solid #ddd}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-treeview/le-treeview.vue"],"names":[],"mappings":"AAIA,8BACE,kBAAmB,AACnB,UAAY,CACb,AACD,2CACI,eAAgB,AAChB,eAAgB,AAChB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,SAAU,AACV,gBAAiB,AACjB,cAAe,AACf,WAAa,CAChB,AACD,6GAEM,WAAe,AACf,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,+GAEM,WAAe,AACf,sBAA0B,AAC1B,qBAA0B,CAC/B","file":"le-treeview.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-treeview[data-v-6e86091e] {\n  position: relative;\n  width: 100%;\n}\n.le-treeview .select-list[data-v-6e86091e] {\n    font-size: 12px;\n    padding-left: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    outline: none;\n    margin: 0;\n    list-style: none;\n    overflow: auto;\n    z-index: 999;\n}\n.le-treeview .select-list.theme-dark[data-v-6e86091e],\n    .theme-dark .le-treeview .select-list[data-v-6e86091e] {\n      color: #ffffff;\n      background-color: #141a42;\n      border: 1px solid #474a6a;\n}\n.le-treeview .select-list.theme-light[data-v-6e86091e],\n    .theme-light .le-treeview .select-list[data-v-6e86091e] {\n      color: #666666;\n      background-color: #ffffff;\n      border: 1px solid #dddddd;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(677);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("176d0718", content, true, {});

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-tree-item{list-style:none;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.le-tree-item .tree-list{font-size:12px;padding-left:0;margin:0;list-style:none;z-index:999}.le-tree-item .tree-list.theme-dark,.theme-dark .le-tree-item .tree-list{color:#fff;background-color:#141a42}.le-tree-item .tree-list.theme-light,.theme-light .le-tree-item .tree-list{color:#666;background-color:#fff}.le-tree-item .tree-list .le-tree-item{margin-left:20px}.le-tree-item .item-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:content-box;box-sizing:content-box;padding:7px 10px}.le-tree-item .item-container:hover.theme-dark,.theme-dark .le-tree-item .item-container:hover{background-color:#2d3162}.le-tree-item .item-container:hover.theme-light,.theme-light .le-tree-item .item-container:hover{background-color:#f2f2f2}.le-tree-item .item-container .arrow{cursor:pointer;display:inline-block}.le-tree-item .item-container .arrow.ico-plain-down-arrow{margin-right:6px;margin-left:-6px}.le-tree-item .item-container .checkbox-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:content-box;box-sizing:content-box;padding-left:3px}.le-tree-item .item-container .checkbox-container.selected{font-weight:700}.le-tree-item .item-container .checkbox-container.leaf{margin-left:8px}.le-tree-item .item-container .checkbox-container .independent-selection:hover{cursor:pointer;text-decoration:underline;white-space:nowrap}.le-tree-item .item-container .checkbox-container .independent-selection:hover.theme-dark,.theme-dark .le-tree-item .item-container .checkbox-container .independent-selection:hover{-webkit-text-decoration-color:#0c5de6;text-decoration-color:#0c5de6;color:#0c5de6}.le-tree-item .item-container .checkbox-container .independent-selection:hover.theme-light,.theme-light .le-tree-item .item-container .checkbox-container .independent-selection:hover{-webkit-text-decoration-color:#4a90e2;text-decoration-color:#4a90e2;color:#4a90e2}.le-tree-item .item-container .checkbox-container .item-label{margin-left:7px;word-break:normal;word-wrap:normal;white-space:nowrap}.le-tree-item .item-container .checkbox-container .item-label.parent{cursor:pointer}.le-tree-item .item-container .checkbox-container .item-label .text{vertical-align:inherit}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-treeview/le-tree-item.vue"],"names":[],"mappings":"AAIA,cACE,gBAAiB,AACjB,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,yBACI,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,WAAa,CAChB,AACD,yEAEM,WAAe,AACf,wBAA0B,CAC/B,AACD,2EAEM,WAAe,AACf,qBAA0B,CAC/B,AACD,uCACM,gBAAkB,CACvB,AACD,8BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,+BAAgC,AACxB,uBAAwB,AAChC,gBAA2B,CAC9B,AACD,+FAEM,wBAA0B,CAC/B,AACD,iGAEM,wBAA0B,CAC/B,AACD,qCACM,eAAgB,AAChB,oBAAsB,CAC3B,AACD,0DACQ,iBAAkB,AAClB,gBAAkB,CACzB,AACD,kDACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,+BAAgC,AACxB,uBAAwB,AAChC,gBAAkB,CACvB,AACD,2DACQ,eAAkB,CACzB,AACD,uDACQ,eAAiB,CACxB,AACD,+EACQ,eAAgB,AAChB,0BAA2B,AAC3B,kBAAoB,CAC3B,AACD,qLAEU,sCAAuC,AAC/B,8BAA+B,AACvC,aAAe,CACxB,AACD,uLAEU,sCAAuC,AAC/B,8BAA+B,AACvC,aAAe,CACxB,AACD,8DACQ,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CAC3B,AACD,qEACU,cAAgB,CACzB,AACD,oEACU,sBAAwB,CACjC","file":"le-tree-item.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-tree-item {\n  list-style: none;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.le-tree-item .tree-list {\n    font-size: 12px;\n    padding-left: 0;\n    margin: 0;\n    list-style: none;\n    z-index: 999;\n}\n.le-tree-item .tree-list.theme-dark,\n    .theme-dark .le-tree-item .tree-list {\n      color: #ffffff;\n      background-color: #141a42;\n}\n.le-tree-item .tree-list.theme-light,\n    .theme-light .le-tree-item .tree-list {\n      color: #666666;\n      background-color: #ffffff;\n}\n.le-tree-item .tree-list .le-tree-item {\n      margin-left: 20px;\n}\n.le-tree-item .item-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n    padding: 7px 10px 7px 10px;\n}\n.le-tree-item .item-container:hover.theme-dark,\n    .theme-dark .le-tree-item .item-container:hover {\n      background-color: #2d3162;\n}\n.le-tree-item .item-container:hover.theme-light,\n    .theme-light .le-tree-item .item-container:hover {\n      background-color: #f2f2f2;\n}\n.le-tree-item .item-container .arrow {\n      cursor: pointer;\n      display: inline-block;\n}\n.le-tree-item .item-container .arrow.ico-plain-down-arrow {\n        margin-right: 6px;\n        margin-left: -6px;\n}\n.le-tree-item .item-container .checkbox-container {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-sizing: content-box;\n              box-sizing: content-box;\n      padding-left: 3px;\n}\n.le-tree-item .item-container .checkbox-container.selected {\n        font-weight: bold;\n}\n.le-tree-item .item-container .checkbox-container.leaf {\n        margin-left: 8px;\n}\n.le-tree-item .item-container .checkbox-container .independent-selection:hover {\n        cursor: pointer;\n        text-decoration: underline;\n        white-space: nowrap;\n}\n.le-tree-item .item-container .checkbox-container .independent-selection:hover.theme-dark,\n        .theme-dark .le-tree-item .item-container .checkbox-container .independent-selection:hover {\n          -webkit-text-decoration-color: #0c5de6;\n                  text-decoration-color: #0c5de6;\n          color: #0c5de6;\n}\n.le-tree-item .item-container .checkbox-container .independent-selection:hover.theme-light,\n        .theme-light .le-tree-item .item-container .checkbox-container .independent-selection:hover {\n          -webkit-text-decoration-color: #4a90e2;\n                  text-decoration-color: #4a90e2;\n          color: #4a90e2;\n}\n.le-tree-item .item-container .checkbox-container .item-label {\n        margin-left: 7px;\n        word-break: normal;\n        word-wrap: normal;\n        white-space: nowrap;\n}\n.le-tree-item .item-container .checkbox-container .item-label.parent {\n          cursor: pointer;\n}\n.le-tree-item .item-container .checkbox-container .item-label .text {\n          vertical-align: inherit;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"treeItem",staticClass:"le-tree-item"},[_c('div',{staticClass:"item-container"},[(_vm.isParent)?_c('i',{class:['arrow', 'ico-8', 'ico-arrow', _vm.arrowDirectionClass],attrs:{"data-test":("treeview_item_" + (_vm.item[_vm.itemValueAttr]) + "_arrow_icon")},on:{"click":_vm.toggleShowChildren}}):_vm._e(),_vm._v(" "),_c('div',{class:['checkbox-container', {'selected': _vm.isItemSelected}, {'leaf': !_vm.isParent}]},[_c('le-checkbox',{attrs:{"state":_vm.isItemSelected,"aria-label":_vm.item[_vm.itemValueAttr],"data-test":("treeview_item_" + (_vm.item[_vm.itemValueAttr]) + "_checkbox")},on:{"change":_vm.onCheckboxClicked}}),_vm._v(" "),_c('le-text-with-highlight',{class:['item-label', {'independent-selection': _vm.allowIndependentSelection }],attrs:{"text":_vm.item[_vm.itemValueAttr],"highlightText":_vm.getHighlightText,"data-test":("treeview_item_" + (_vm.item[_vm.itemValueAttr]) + "_highlight_txt")},nativeOn:{"click":function($event){return _vm.onItemTextClicked($event)}}})],1)]),_vm._v(" "),(_vm.isParent)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChildren),expression:"showChildren"}],staticClass:"tree-list",attrs:{"data-test":("treeview_item_" + (_vm.item[_vm.itemValueAttr]) + "_list")}},_vm._l((_vm.item[this.itemChildrenAttr]),function(child){return _c('le-tree-item',{key:child[_vm.itemIdAttr],attrs:{"selectedItemsIds":_vm.selectedItemsIds,"item":child,"itemIdAttr":_vm.itemIdAttr,"itemValueAttr":_vm.itemValueAttr,"itemChildrenAttr":_vm.itemChildrenAttr,"searchTerm":_vm.searchTerm,"numberOfCharactersStartSearch":_vm.numberOfCharactersStartSearch,"itemIdToFocus":_vm.itemIdToFocus,"data-test":("treeview_item_" + (child[_vm.itemValueAttr]) + "_main")},on:{"itemValueChanged":_vm.emitItemValueChanged,"scrollToValue":_vm.emitScrollToValue}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:['le-treeview',_vm.theme],style:({'width': ("" + _vm.treeWidth)})},[_c('le-tags',{ref:"tagsInput",attrs:{"tags":_vm.selectedItemsTags,"placeholder":_vm.placeholder,"searchTerm":_vm.searchTerm,"tagIdAttr":_vm.itemIdAttr,"tagValueAttr":_vm.itemValueAttr,"enabled":_vm.enabled,"maxHeight":_vm.tagsMaxHeight,"showVerticalScrollbar":_vm.tagsShowVerticalScrollbar,"clearInputOnTagAdded":false,"clickableTags":true,"data-test":"treeview_tags"},on:{"input":_vm.onSearchInputChange,"unselect":_vm.onUnselectTagsItem,"select":_vm.onSelectTagsItem,"focus":_vm.onInputFocus}}),_vm._v(" "),(_vm.isListOpen && _vm.enabled)?_c('ul',{ref:"treeviewList",class:['select-list', _vm.theme],style:({ 'max-height': (_vm.listHeightLimit + "px"), 'min-width': ("" + _vm.listMinWidth)}),attrs:{"data-test":"treeview_list"},on:{"mousedown":function($event){$event.preventDefault();}},nativeOn:{"focus":function($event){return _vm.onListFocus($event)}}},[(_vm.itemsToShow)?_c('le-tree-item',{attrs:{"item":_vm.searchResults,"selectedItemsIds":_vm.selectedItemsIds,"isRootItem":true,"isArtificialItem":_vm.hasArtificialRoot,"itemIdAttr":_vm.itemIdAttr,"itemValueAttr":_vm.itemValueAttr,"itemChildrenAttr":_vm.itemChildrenAttr,"numberOfCharactersStartSearch":_vm.numberOfCharactersStartSearch,"searchTerm":_vm.searchTerm,"itemIdToFocus":_vm.itemIdToFocus,"data-test":"treeview_list_item"},on:{"itemValueChanged":_vm.onTreeItemValueChanged,"scrollToValue":_vm.onScrollToValueChange}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_treeview_simple_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c7a8f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_treeview_simple_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74c7a8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_treeview_simple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c7a8f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_treeview_simple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5456e0de", content, true, {});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-treeview[data-v-74c7a8f8]{position:relative;width:100%}.le-treeview .select-list[data-v-74c7a8f8]{font-size:12px;padding-left:0;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;margin:0;list-style:none;overflow:auto}.le-treeview .select-list.theme-dark[data-v-74c7a8f8],.theme-dark .le-treeview .select-list[data-v-74c7a8f8]{color:#fff;background-color:#141a42;border:1px solid #474a6a}.le-treeview .select-list.theme-light[data-v-74c7a8f8],.theme-light .le-treeview .select-list[data-v-74c7a8f8]{color:#666;background-color:#fff;border:1px solid #ddd}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-treeview/le-treeview-simple.vue"],"names":[],"mappings":"AAIA,8BACE,kBAAmB,AACnB,UAAY,CACb,AACD,2CACI,eAAgB,AAChB,eAAgB,AAChB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,SAAU,AACV,gBAAiB,AACjB,aAAe,CAClB,AACD,6GAEM,WAAe,AACf,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,+GAEM,WAAe,AACf,sBAA0B,AAC1B,qBAA0B,CAC/B","file":"le-treeview-simple.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-treeview[data-v-74c7a8f8] {\n  position: relative;\n  width: 100%;\n}\n.le-treeview .select-list[data-v-74c7a8f8] {\n    font-size: 12px;\n    padding-left: 0;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    outline: none;\n    margin: 0;\n    list-style: none;\n    overflow: auto;\n}\n.le-treeview .select-list.theme-dark[data-v-74c7a8f8],\n    .theme-dark .le-treeview .select-list[data-v-74c7a8f8] {\n      color: #ffffff;\n      background-color: #141a42;\n      border: 1px solid #474a6a;\n}\n.le-treeview .select-list.theme-light[data-v-74c7a8f8],\n    .theme-light .le-treeview .select-list[data-v-74c7a8f8] {\n      color: #666666;\n      background-color: #ffffff;\n      border: 1px solid #dddddd;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-treeview',_vm.theme],style:({'width': ("" + _vm.treeWidth)})},[_c('ul',{ref:"treeviewList",class:['select-list', _vm.theme],style:({ 'max-height': (_vm.listHeightLimit + "px"), 'min-width': ("" + _vm.listMinWidth)}),attrs:{"data-test":"treeview_simple_list"},on:{"mousedown":function($event){$event.preventDefault();}}},[_c('le-tree-item',{attrs:{"item":_vm.searchResults,"selectedItemsIds":_vm.selectedItemsIds,"isRootItem":true,"isArtificialItem":_vm.hasArtificialRoot,"itemIdAttr":_vm.itemIdAttr,"itemValueAttr":_vm.itemValueAttr,"itemChildrenAttr":_vm.itemChildrenAttr,"numberOfCharactersStartSearch":_vm.numberOfCharactersStartSearch,"data-test":"treeview_simple_list_item"},on:{"itemValueChanged":_vm.onTreeItemValueChanged}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02f1ef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_vue__ = __webpack_require__(706);
function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02f1ef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(686);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5edf8748", content, true, {});

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-transcript{width:430px;height:580px;overflow-y:scroll}.le-transcript .line-separator{margin-top:10px;margin-bottom:10px;position:relative;line-height:21px;font-size:11px;height:21px}.le-transcript .line-separator .date{position:absolute;right:0;left:0;top:0;bottom:0;text-align:center;height:21px}.le-transcript .line-separator .date span.theme-dark,.theme-dark .le-transcript .line-separator .date span{color:#fff}.le-transcript .line-separator .date span.theme-dark:before,.theme-dark .le-transcript .line-separator .date span:before{content:\"\";position:absolute;top:50%;left:0;width:calc(50% - 60px);height:1px;background-color:#fff;opacity:.2}.le-transcript .line-separator .date span.theme-dark:after,.theme-dark .le-transcript .line-separator .date span:after{content:\"\";position:absolute;top:50%;right:0;width:calc(50% - 60px);height:1px;background-color:#fff;opacity:.2}.le-transcript .line-separator .date span.theme-light,.theme-light .le-transcript .line-separator .date span{color:#666}.le-transcript .line-separator .date span.theme-light:before,.theme-light .le-transcript .line-separator .date span:before{content:\"\";position:absolute;top:50%;left:0;width:calc(50% - 60px);height:1px;background-color:#666;opacity:.2}.le-transcript .line-separator .date span.theme-light:after,.theme-light .le-transcript .line-separator .date span:after{content:\"\";position:absolute;top:50%;right:0;width:calc(50% - 60px);height:1px;background-color:#666;opacity:.2}.le-transcript .line-separator .date span.dialog-separator:after,.le-transcript .line-separator .date span.dialog-separator:before{width:calc(50% - 100px)}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-transcript/le-transcript.vue"],"names":[],"mappings":"AAIA,eACE,YAAa,AACb,aAAc,AACd,iBAAmB,CACpB,AACD,+BACI,gBAAiB,AACjB,mBAAoB,AACpB,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,WAAa,CAChB,AACD,qCACM,kBAAmB,AACnB,QAAS,AACT,OAAQ,AACR,MAAO,AACP,SAAU,AACV,kBAAmB,AACnB,WAAa,CAClB,AACD,2GAEQ,UAAe,CACtB,AACD,yHAEU,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,OAAQ,AACR,uBAAwB,AACxB,WAAY,AACZ,sBAA0B,AAC1B,UAAa,CACtB,AACD,uHAEU,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,uBAAwB,AACxB,WAAY,AACZ,sBAA0B,AAC1B,UAAa,CACtB,AACD,6GAEQ,UAAe,CACtB,AACD,2HAEU,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,OAAQ,AACR,uBAAwB,AACxB,WAAY,AACZ,sBAA0B,AAC1B,UAAa,CACtB,AACD,yHAEU,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,uBAAwB,AACxB,WAAY,AACZ,sBAA0B,AAC1B,UAAa,CACtB,AAID,mIACQ,uBAAyB,CAChC","file":"le-transcript.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-transcript {\n  width: 430px;\n  height: 580px;\n  overflow-y: scroll;\n}\n.le-transcript .line-separator {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    position: relative;\n    line-height: 21px;\n    font-size: 11px;\n    height: 21px;\n}\n.le-transcript .line-separator .date {\n      position: absolute;\n      right: 0;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      text-align: center;\n      height: 21px;\n}\n.le-transcript .line-separator .date span.theme-dark,\n      .theme-dark .le-transcript .line-separator .date span {\n        color: #ffffff;\n}\n.le-transcript .line-separator .date span.theme-dark:before,\n        .theme-dark .le-transcript .line-separator .date span:before {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: calc(50% - 60px);\n          height: 1px;\n          background-color: #ffffff;\n          opacity: 0.2;\n}\n.le-transcript .line-separator .date span.theme-dark:after,\n        .theme-dark .le-transcript .line-separator .date span:after {\n          content: '';\n          position: absolute;\n          top: 50%;\n          right: 0;\n          width: calc(50% - 60px);\n          height: 1px;\n          background-color: #ffffff;\n          opacity: 0.2;\n}\n.le-transcript .line-separator .date span.theme-light,\n      .theme-light .le-transcript .line-separator .date span {\n        color: #666666;\n}\n.le-transcript .line-separator .date span.theme-light:before,\n        .theme-light .le-transcript .line-separator .date span:before {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: calc(50% - 60px);\n          height: 1px;\n          background-color: #666666;\n          opacity: 0.2;\n}\n.le-transcript .line-separator .date span.theme-light:after,\n        .theme-light .le-transcript .line-separator .date span:after {\n          content: '';\n          position: absolute;\n          top: 50%;\n          right: 0;\n          width: calc(50% - 60px);\n          height: 1px;\n          background-color: #666666;\n          opacity: 0.2;\n}\n.le-transcript .line-separator .date span.dialog-separator:before {\n        width: calc(50% - 100px);\n}\n.le-transcript .line-separator .date span.dialog-separator:after {\n        width: calc(50% - 100px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_message_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa1f21e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_message_vue__ = __webpack_require__(705);
function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa1f21e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(689);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57cc1e5e", content, true, {});

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-transcript-message .message-meta{font-size:11px;margin-top:5px;margin-bottom:15px;text-align:right}.le-transcript-message .theme-dark.message-meta,.le-transcript-message .theme-dark .message-meta,.theme-dark .le-transcript-message .message-meta{color:#fff}.le-transcript-message .theme-light.message-meta,.le-transcript-message .theme-light .message-meta,.theme-light .le-transcript-message .message-meta{color:#161c4f}.le-transcript-message .message-meta .separator{margin:0 2px}.le-transcript-message .message-meta .originator{max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.le-transcript-message .message-meta .intent-name,.le-transcript-message .message-meta .message-time,.le-transcript-message .message-meta .originator,.le-transcript-message .message-meta .separator{display:inline-block;vertical-align:middle}.le-transcript-message .message-meta .intent-name{text-decoration:underline}.le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.le-transcript-message-bubble:not(.rich-content) a,.le-transcript-message-bubble:not(.rich-content) a:active,.le-transcript-message-bubble:not(.rich-content) a:hover,.le-transcript-message-bubble:not(.rich-content) a:link,.le-transcript-message-bubble:not(.rich-content) a:visited{text-decoration:underline;cursor:pointer}.le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,.le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,.le-transcript-message-bubble:not(.rich-content) a.theme-dark,.le-transcript-message-bubble:not(.rich-content) a.theme-light,.le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,.le-transcript-message-bubble:not(.rich-content) a:active.theme-light,.le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,.le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,.le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,.le-transcript-message-bubble:not(.rich-content) a:link.theme-light,.le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,.le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,.theme-dark .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-dark .le-transcript-message-bubble:not(.rich-content) a,.theme-dark .le-transcript-message-bubble:not(.rich-content) a:active,.theme-dark .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-dark .le-transcript-message-bubble:not(.rich-content) a:link,.theme-dark .le-transcript-message-bubble:not(.rich-content) a:visited,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-light .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-light .le-transcript-message-bubble:not(.rich-content) a,.theme-light .le-transcript-message-bubble:not(.rich-content) a:active,.theme-light .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-light .le-transcript-message-bubble:not(.rich-content) a:link,.theme-light .le-transcript-message-bubble:not(.rich-content) a:visited{color:#fff}.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,.le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,.le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link,.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited{color:#2e59da}.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited{color:#fff}.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link.theme-light,.le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link.theme-light,.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link,.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link,.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited{color:#2e59da}.le-transcript-message{margin-bottom:1.2em;position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.le-transcript-message.theme-dark,.le-transcript-message.theme-light,.theme-dark .le-transcript-message,.theme-light .le-transcript-message{color:#fff}.le-transcript-message.within-closed-conversation{opacity:.5}.le-transcript-message .message-info .le-transcript-message-bubble{display:inline-block;text-align:initial;font-size:13px;max-width:90%;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid transparent;word-break:break-word;word-wrap:break-word;white-space:normal}.le-transcript-message .message-info .le-transcript-message-bubble .ico-suggested-agent{vertical-align:middle;display:inline;margin-right:5px}.le-transcript-message .message-info .le-transcript-message-bubble.quick-replies,.le-transcript-message .message-info .le-transcript-message-bubble.rich-content{min-width:220px}.le-transcript-message .message-info .le-transcript-message-bubble.rtl{padding:10px 10px 10px 15px;text-align:right}.le-transcript-message .message-info .le-transcript-message-bubble.ltr{padding:10px 15px 10px 10px;text-align:left}.le-transcript-message .message-info .le-transcript-message-bubble .plain-text-container .text-content{white-space:pre-wrap;word-break:break-word;word-wrap:break-word}.le-transcript-message .message-info .le-transcript-message-bubble.file-bubble{position:relative}.le-transcript-message .message-info .le-transcript-message-bubble.highlighted.theme-dark,.theme-dark .le-transcript-message .message-info .le-transcript-message-bubble.highlighted{border:1px dashed #fff}.le-transcript-message .message-info .le-transcript-message-bubble.highlighted.theme-light,.theme-light .le-transcript-message .message-info .le-transcript-message-bubble.highlighted{border:1px dashed #000}.le-transcript-message.consumer .message-meta{text-align:left;padding-left:5px}.le-transcript-message.consumer .message-info .le-transcript-message-bubble{border-radius:10px 10px 10px 0}.le-transcript-message.agent,.le-transcript-message.assigned-agent,.le-transcript-message.controller,.le-transcript-message.manager,.le-transcript-message.reader{text-align:right;padding-right:5px}.le-transcript-message.agent .message-info .le-transcript-message-bubble,.le-transcript-message.assigned-agent .message-info .le-transcript-message-bubble,.le-transcript-message.controller .message-info .le-transcript-message-bubble,.le-transcript-message.manager .message-info .le-transcript-message-bubble,.le-transcript-message.reader .message-info .le-transcript-message-bubble{border-radius:10px 10px 0 10px}.le-transcript-message.agent .error .le-transcript-message-bubble.theme-dark,.le-transcript-message.assigned-agent .error .le-transcript-message-bubble.theme-dark,.le-transcript-message.controller .error .le-transcript-message-bubble.theme-dark,.le-transcript-message.manager .error .le-transcript-message-bubble.theme-dark,.le-transcript-message.reader .error .le-transcript-message-bubble.theme-dark,.theme-dark .le-transcript-message.agent .error .le-transcript-message-bubble,.theme-dark .le-transcript-message.assigned-agent .error .le-transcript-message-bubble,.theme-dark .le-transcript-message.controller .error .le-transcript-message-bubble,.theme-dark .le-transcript-message.manager .error .le-transcript-message-bubble,.theme-dark .le-transcript-message.reader .error .le-transcript-message-bubble{background-color:transparent;color:#ff1820;border:1px solid #ff1820}.le-transcript-message.agent .error .le-transcript-message-bubble.theme-light,.le-transcript-message.assigned-agent .error .le-transcript-message-bubble.theme-light,.le-transcript-message.controller .error .le-transcript-message-bubble.theme-light,.le-transcript-message.manager .error .le-transcript-message-bubble.theme-light,.le-transcript-message.reader .error .le-transcript-message-bubble.theme-light,.theme-light .le-transcript-message.agent .error .le-transcript-message-bubble,.theme-light .le-transcript-message.assigned-agent .error .le-transcript-message-bubble,.theme-light .le-transcript-message.controller .error .le-transcript-message-bubble,.theme-light .le-transcript-message.manager .error .le-transcript-message-bubble,.theme-light .le-transcript-message.reader .error .le-transcript-message-bubble{background-color:transparent;color:#d0021b;border:1px solid #d0021b}.le-transcript-message.assigned-agent .le-transcript-message-bubble.theme-dark,.le-transcript-message.assigned-agent .le-transcript-message-bubble.theme-light,.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble,.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble{background-color:#3f5b92}.le-transcript-message.manager .le-transcript-message-bubble.theme-dark,.le-transcript-message.manager .le-transcript-message-bubble.theme-light,.le-transcript-message.reader .le-transcript-message-bubble.theme-dark,.le-transcript-message.reader .le-transcript-message-bubble.theme-light,.theme-dark .le-transcript-message.manager .le-transcript-message-bubble,.theme-dark .le-transcript-message.reader .le-transcript-message-bubble,.theme-light .le-transcript-message.manager .le-transcript-message-bubble,.theme-light .le-transcript-message.reader .le-transcript-message-bubble{background-color:#5b667c}.le-transcript-message.agent .le-transcript-message-bubble.theme-dark,.le-transcript-message.controller .le-transcript-message-bubble.theme-dark,.theme-dark .le-transcript-message.agent .le-transcript-message-bubble,.theme-dark .le-transcript-message.controller .le-transcript-message-bubble{background-color:transparent;color:#fff;border:1px solid #fff}.le-transcript-message.agent .le-transcript-message-bubble.theme-light,.le-transcript-message.controller .le-transcript-message-bubble.theme-light,.theme-light .le-transcript-message.agent .le-transcript-message-bubble,.theme-light .le-transcript-message.controller .le-transcript-message-bubble{background-color:transparent;color:#161c4f;border:1px solid #161c4f}.le-transcript-message .status-indicator{display:inline-block;vertical-align:bottom}.le-transcript-message .status-indicator.theme-dark,.theme-dark .le-transcript-message .status-indicator{color:#fff}.le-transcript-message .status-indicator.theme-light,.theme-light .le-transcript-message .status-indicator{color:#888}.le-transcript-message .status-indicator.ico-message-accepted,.le-transcript-message .status-indicator.ico-message-read{width:14px}.le-transcript-message .status-indicator.ico-message-read.theme-dark,.theme-dark .le-transcript-message .status-indicator.ico-message-read{color:#0c5de6}.le-transcript-message .status-indicator.ico-message-read.theme-light,.theme-light .le-transcript-message .status-indicator.ico-message-read{color:#0b9fcd}.le-transcript-message .message-meta.theme-dark,.theme-dark .le-transcript-message .message-meta{color:#fff}.le-transcript-message .message-meta.theme-light,.theme-light .le-transcript-message .message-meta{color:#666}.message-meta .private-message-indicator{display:inline-block;vertical-align:middle;border-radius:4px;border-style:solid;border-width:.7px;margin-right:5px;padding:2px 8px}.message-meta .private-message-indicator.theme-dark,.message-meta .private-message-indicator.theme-light,.theme-dark .message-meta .private-message-indicator,.theme-light .message-meta .private-message-indicator{background-color:hsla(0,0%,61%,.2);border-color:#9b9b9b}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-transcript/le-transcript-message.vue"],"names":[],"mappings":"AAIA,qCACE,eAAgB,AAChB,eAAgB,AAChB,mBAAoB,AACpB,gBAAkB,CACnB,AACD,kJAGI,UAAe,CAClB,AACD,qJAGI,aAAe,CAClB,AACD,gDACI,YAAc,CACjB,AACD,iDACI,gBAAiB,AACjB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,sMACI,qBAAsB,AACtB,qBAAuB,CAC1B,AACD,kDACI,yBAA2B,CAC9B,AACD,4VACE,0BAA2B,AAC3B,cAAgB,CACjB,AAmBD,09PA+BE,UAAe,CAChB,AACD,s4MA+BE,aAAe,CAChB,AACD,w3EAaE,UAAe,CAChB,AACD,g5EAaE,aAAe,CAChB,AACD,uBACE,oBAAqB,AACrB,kBAAmB,AACnB,WAAY,AACZ,8BAA+B,AACvB,qBAAuB,CAChC,AAKD,4IAEI,UAAe,CAClB,AACD,kDACI,UAAa,CAChB,AACD,mEACI,qBAAsB,AACtB,mBAAoB,AACpB,eAAgB,AAChB,cAAe,AACf,8BAA+B,AACvB,sBAAuB,AAC/B,6BAA8B,AAC9B,sBAAuB,AACvB,qBAAsB,AACtB,kBAAoB,CACvB,AACD,wFACM,sBAAuB,AACvB,eAAgB,AAChB,gBAAkB,CACvB,AAID,iKACM,eAAiB,CACtB,AACD,uEACM,4BAA6B,AAC7B,gBAAkB,CACvB,AACD,uEACM,4BAA6B,AAC7B,eAAiB,CACtB,AACD,uGACM,qBAAsB,AACtB,sBAAuB,AACvB,oBAAsB,CAC3B,AACD,+EACM,iBAAmB,CACxB,AACD,qLAEM,sBAA2B,CAChC,AACD,uLAEM,sBAA2B,CAChC,AACD,8CACI,gBAAiB,AACjB,gBAAkB,CACrB,AACD,4EACI,8BAAgC,CACnC,AACD,kKACI,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8XACM,8BAAgC,CACrC,AACD,yyBAMM,6BAA8B,AAC9B,cAAe,AACf,wBAA0B,CAC/B,AACD,mzBAMM,6BAA8B,AAC9B,cAAe,AACf,wBAA0B,CAC/B,AAKD,gUAEI,wBAA0B,CAC7B,AAMD,okBAGI,wBAA0B,CAC7B,AACD,oSAGI,6BAA8B,AAC9B,WAAe,AACf,qBAA0B,CAC7B,AACD,wSAGI,6BAA8B,AAC9B,cAAe,AACf,wBAA0B,CAC7B,AACD,yCACI,qBAAsB,AACtB,qBAAuB,CAC1B,AACD,yGAEM,UAAe,CACpB,AACD,2GAEM,UAAe,CACpB,AACD,wHACM,UAAY,CACjB,AACD,2IAEM,aAAe,CACpB,AACD,6IAEM,aAAe,CACpB,AACD,iGAEI,UAAe,CAClB,AACD,mGAEI,UAAe,CAClB,AACD,yCACE,qBAAsB,AACtB,sBAAuB,AACvB,kBAAmB,AACnB,mBAAoB,AACpB,kBAAoB,AACpB,iBAAkB,AAClB,eAAiB,CAClB,AAMD,oNAEI,mCAA2C,AAC3C,oBAAsB,CACzB","file":"le-transcript-message.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-transcript-message .message-meta {\n  font-size: 11px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  text-align: right;\n}\n.le-transcript-message .theme-dark.message-meta,\n  .theme-dark .le-transcript-message .message-meta,\n  .le-transcript-message .theme-dark .message-meta {\n    color: #ffffff;\n}\n.le-transcript-message .theme-light.message-meta,\n  .theme-light .le-transcript-message .message-meta,\n  .le-transcript-message .theme-light .message-meta {\n    color: #161c4f;\n}\n.le-transcript-message .message-meta .separator {\n    margin: 0 2px;\n}\n.le-transcript-message .message-meta .originator {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.le-transcript-message .message-meta .separator, .le-transcript-message .message-meta .originator, .le-transcript-message .message-meta .message-time, .le-transcript-message .message-meta .intent-name {\n    display: inline-block;\n    vertical-align: middle;\n}\n.le-transcript-message .message-meta .intent-name {\n    text-decoration: underline;\n}\n.le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message-bubble:not(.rich-content) a {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message-bubble:not(.rich-content) a.theme-dark,\n  .theme-dark .le-transcript-message-bubble:not(.rich-content) a {\n    color: #ffffff;\n}\n.le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message-bubble:not(.rich-content) a:link.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message-bubble:not(.rich-content) a:active.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message-bubble:not(.rich-content) a.theme-light,\n  .theme-light .le-transcript-message-bubble:not(.rich-content) a {\n    color: #ffffff;\n}\n.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,\n.theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,\n.theme-dark .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,\n.theme-dark .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a {\n  color: #ffffff;\n}\n.le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a.theme-light,\n.theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a.theme-light,\n.theme-light .le-transcript-message.manager .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a.theme-light,\n.theme-light .le-transcript-message.reader .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content).error a, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error .le-markdown-link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:visited, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:hover, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a:active, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content).error a {\n  color: #2e59da;\n}\n.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a.theme-dark,\n.theme-dark .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a.theme-dark,\n.theme-dark .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a {\n  color: #ffffff;\n}\n.le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a.theme-light,\n.theme-light .le-transcript-message.controller .le-transcript-message-bubble:not(.rich-content) a, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) .le-markdown-link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:link, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:visited, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:hover, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a:active, .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a.theme-light,\n.theme-light .le-transcript-message.agent .le-transcript-message-bubble:not(.rich-content) a {\n  color: #2e59da;\n}\n.le-transcript-message {\n  margin-bottom: 1.2em;\n  position: relative;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.le-transcript-message.theme-dark,\n  .theme-dark .le-transcript-message {\n    color: #ffffff;\n}\n.le-transcript-message.theme-light,\n  .theme-light .le-transcript-message {\n    color: #ffffff;\n}\n.le-transcript-message.within-closed-conversation {\n    opacity: 0.5;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble {\n    display: inline-block;\n    text-align: initial;\n    font-size: 13px;\n    max-width: 90%;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid transparent;\n    word-break: break-word;\n    word-wrap: break-word;\n    white-space: normal;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble .ico-suggested-agent {\n      vertical-align: middle;\n      display: inline;\n      margin-right: 5px;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.rich-content {\n      min-width: 220px;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.quick-replies {\n      min-width: 220px;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.rtl {\n      padding: 10px 10px 10px 15px;\n      text-align: right;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.ltr {\n      padding: 10px 15px 10px 10px;\n      text-align: left;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble .plain-text-container .text-content {\n      white-space: pre-wrap;\n      word-break: break-word;\n      word-wrap: break-word;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.file-bubble {\n      position: relative;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.highlighted.theme-dark,\n    .theme-dark .le-transcript-message .message-info .le-transcript-message-bubble.highlighted {\n      border: 1px dashed #ffffff;\n}\n.le-transcript-message .message-info .le-transcript-message-bubble.highlighted.theme-light,\n    .theme-light .le-transcript-message .message-info .le-transcript-message-bubble.highlighted {\n      border: 1px dashed #000000;\n}\n.le-transcript-message.consumer .message-meta {\n    text-align: left;\n    padding-left: 5px;\n}\n.le-transcript-message.consumer .message-info .le-transcript-message-bubble {\n    border-radius: 10px 10px 10px 0;\n}\n.le-transcript-message.assigned-agent, .le-transcript-message.manager, .le-transcript-message.reader, .le-transcript-message.controller, .le-transcript-message.agent {\n    text-align: right;\n    padding-right: 5px;\n}\n.le-transcript-message.assigned-agent .message-info .le-transcript-message-bubble, .le-transcript-message.manager .message-info .le-transcript-message-bubble, .le-transcript-message.reader .message-info .le-transcript-message-bubble, .le-transcript-message.controller .message-info .le-transcript-message-bubble, .le-transcript-message.agent .message-info .le-transcript-message-bubble {\n      border-radius: 10px 10px 0 10px;\n}\n.le-transcript-message.assigned-agent .error .le-transcript-message-bubble.theme-dark,\n    .theme-dark .le-transcript-message.assigned-agent .error .le-transcript-message-bubble, .le-transcript-message.manager .error .le-transcript-message-bubble.theme-dark,\n    .theme-dark .le-transcript-message.manager .error .le-transcript-message-bubble, .le-transcript-message.reader .error .le-transcript-message-bubble.theme-dark,\n    .theme-dark .le-transcript-message.reader .error .le-transcript-message-bubble, .le-transcript-message.controller .error .le-transcript-message-bubble.theme-dark,\n    .theme-dark .le-transcript-message.controller .error .le-transcript-message-bubble, .le-transcript-message.agent .error .le-transcript-message-bubble.theme-dark,\n    .theme-dark .le-transcript-message.agent .error .le-transcript-message-bubble {\n      background-color: transparent;\n      color: #ff1820;\n      border: 1px solid #ff1820;\n}\n.le-transcript-message.assigned-agent .error .le-transcript-message-bubble.theme-light,\n    .theme-light .le-transcript-message.assigned-agent .error .le-transcript-message-bubble, .le-transcript-message.manager .error .le-transcript-message-bubble.theme-light,\n    .theme-light .le-transcript-message.manager .error .le-transcript-message-bubble, .le-transcript-message.reader .error .le-transcript-message-bubble.theme-light,\n    .theme-light .le-transcript-message.reader .error .le-transcript-message-bubble, .le-transcript-message.controller .error .le-transcript-message-bubble.theme-light,\n    .theme-light .le-transcript-message.controller .error .le-transcript-message-bubble, .le-transcript-message.agent .error .le-transcript-message-bubble.theme-light,\n    .theme-light .le-transcript-message.agent .error .le-transcript-message-bubble {\n      background-color: transparent;\n      color: #d0021b;\n      border: 1px solid #d0021b;\n}\n.le-transcript-message.assigned-agent .le-transcript-message-bubble.theme-dark,\n  .theme-dark .le-transcript-message.assigned-agent .le-transcript-message-bubble {\n    background-color: #3f5b92;\n}\n.le-transcript-message.assigned-agent .le-transcript-message-bubble.theme-light,\n  .theme-light .le-transcript-message.assigned-agent .le-transcript-message-bubble {\n    background-color: #3f5b92;\n}\n.le-transcript-message.manager .le-transcript-message-bubble.theme-dark,\n  .theme-dark .le-transcript-message.manager .le-transcript-message-bubble, .le-transcript-message.reader .le-transcript-message-bubble.theme-dark,\n  .theme-dark .le-transcript-message.reader .le-transcript-message-bubble {\n    background-color: #5b667c;\n}\n.le-transcript-message.manager .le-transcript-message-bubble.theme-light,\n  .theme-light .le-transcript-message.manager .le-transcript-message-bubble, .le-transcript-message.reader .le-transcript-message-bubble.theme-light,\n  .theme-light .le-transcript-message.reader .le-transcript-message-bubble {\n    background-color: #5b667c;\n}\n.le-transcript-message.controller .le-transcript-message-bubble.theme-dark,\n  .theme-dark .le-transcript-message.controller .le-transcript-message-bubble, .le-transcript-message.agent .le-transcript-message-bubble.theme-dark,\n  .theme-dark .le-transcript-message.agent .le-transcript-message-bubble {\n    background-color: transparent;\n    color: #ffffff;\n    border: 1px solid #ffffff;\n}\n.le-transcript-message.controller .le-transcript-message-bubble.theme-light,\n  .theme-light .le-transcript-message.controller .le-transcript-message-bubble, .le-transcript-message.agent .le-transcript-message-bubble.theme-light,\n  .theme-light .le-transcript-message.agent .le-transcript-message-bubble {\n    background-color: transparent;\n    color: #161c4f;\n    border: 1px solid #161c4f;\n}\n.le-transcript-message .status-indicator {\n    display: inline-block;\n    vertical-align: bottom;\n}\n.le-transcript-message .status-indicator.theme-dark,\n    .theme-dark .le-transcript-message .status-indicator {\n      color: #ffffff;\n}\n.le-transcript-message .status-indicator.theme-light,\n    .theme-light .le-transcript-message .status-indicator {\n      color: #888888;\n}\n.le-transcript-message .status-indicator.ico-message-read, .le-transcript-message .status-indicator.ico-message-accepted {\n      width: 14px;\n}\n.le-transcript-message .status-indicator.ico-message-read.theme-dark,\n    .theme-dark .le-transcript-message .status-indicator.ico-message-read {\n      color: #0c5de6;\n}\n.le-transcript-message .status-indicator.ico-message-read.theme-light,\n    .theme-light .le-transcript-message .status-indicator.ico-message-read {\n      color: #0b9fcd;\n}\n.le-transcript-message .message-meta.theme-dark,\n  .theme-dark .le-transcript-message .message-meta {\n    color: #ffffff;\n}\n.le-transcript-message .message-meta.theme-light,\n  .theme-light .le-transcript-message .message-meta {\n    color: #666666;\n}\n.message-meta .private-message-indicator {\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 0.7px;\n  margin-right: 5px;\n  padding: 2px 8px;\n}\n.message-meta .private-message-indicator.theme-dark,\n  .theme-dark .message-meta .private-message-indicator {\n    background-color: rgba(155, 155, 155, 0.2);\n    border-color: #9b9b9b;\n}\n.message-meta .private-message-indicator.theme-light,\n  .theme-light .message-meta .private-message-indicator {\n    background-color: rgba(155, 155, 155, 0.2);\n    border-color: #9b9b9b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_message_meta_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3357b8a6_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_message_meta_vue__ = __webpack_require__(693);
function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_transcript_message_meta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3357b8a6_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_le_transcript_message_meta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39a8f0f4", content, true, {});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-transcript-message-meta .private-message-indicator{display:inline-block;vertical-align:middle;border-radius:4px;border-style:solid;border-width:.7px;margin-right:5px;padding:2px 8px}.le-transcript-message-meta .private-message-indicator.theme-dark,.le-transcript-message-meta .private-message-indicator.theme-light,.theme-dark .le-transcript-message-meta .private-message-indicator,.theme-light .le-transcript-message-meta .private-message-indicator{background-color:hsla(0,0%,61%,.2);border-color:#9b9b9b}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-transcript/le-transcript-message-meta.vue"],"names":[],"mappings":"AAIA,uDACE,qBAAsB,AACtB,sBAAuB,AACvB,kBAAmB,AACnB,mBAAoB,AACpB,kBAAoB,AACpB,iBAAkB,AAClB,eAAiB,CAClB,AAMD,4QAEI,mCAA2C,AAC3C,oBAAsB,CACzB","file":"le-transcript-message-meta.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-transcript-message-meta .private-message-indicator {\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 0.7px;\n  margin-right: 5px;\n  padding: 2px 8px;\n}\n.le-transcript-message-meta .private-message-indicator.theme-dark,\n  .theme-dark .le-transcript-message-meta .private-message-indicator {\n    background-color: rgba(155, 155, 155, 0.2);\n    border-color: #9b9b9b;\n}\n.le-transcript-message-meta .private-message-indicator.theme-light,\n  .theme-light .le-transcript-message-meta .private-message-indicator {\n    background-color: rgba(155, 155, 155, 0.2);\n    border-color: #9b9b9b;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"le-transcript-message-meta message-meta"},[(!_vm.props.isControllerBot)?[(_vm.props.isPrivateMessage)?_c('div',{staticClass:"private-message-indicator"},[_vm._v(_vm._s(_vm.props.translations.privateMessageIndicator))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"originator"},[_vm._v(_vm._s(_vm.props.originatorName || _vm.props.translations.NA))]),_vm._v(" "),_c('div',{staticClass:"separator"},[_vm._v("|")])]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.props.messageFullTime, html: false, autoHide: false }),expression:"{ content: props.messageFullTime, html: false, autoHide: false }"}],staticClass:"message-time"},[_vm._v(_vm._s(_vm.props.messageTime))]),_vm._v(" "),(_vm.props.intentName && _vm.props.showLink)?[_c('div',{staticClass:"separator"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"le-link intent-name",on:{"click":_vm.listeners['onClickIntentName']}},[_vm._v(_vm._s(_vm.props.intentName))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_json_pollock_component_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddd4162_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_json_pollock_component_vue__ = __webpack_require__(698);
function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_json_pollock_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddd4162_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_json_pollock_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2e490a8e", content, true, {});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"json-pollock-component.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("JsonPollock",[],t):"object"==typeof exports?exports.JsonPollock=t():e.JsonPollock=t()}(this,function(){return function(e){function t(a){if(r[a])return r[a].exports;var o=r[a]={i:a,l:!1,exports:{}};return e[a].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,a){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=84)}([function(e,t,r){"use strict";function a(e,t){t=t||{};for(var r in e)t[r]=e[r];return t}function o(e,t,r){var a=r?" !== ":" === ",o=r?" || ":" && ",s=r?"!":"",n=r?"":"!";switch(e){case"null":return t+a+"null";case"array":return s+"Array.isArray("+t+")";case"object":return"("+s+t+o+"typeof "+t+a+'"object"'+o+n+"Array.isArray("+t+"))";case"integer":return"(typeof "+t+a+'"number"'+o+n+"("+t+" % 1)"+o+t+a+t+")";default:return"typeof "+t+a+'"'+e+'"'}}function s(e,t){switch(e.length){case 1:return o(e[0],t,!0);default:var r="",a=i(e);a.array&&a.object&&(r=a.null?"(":"(!"+t+" || ",r+="typeof "+t+' !== "object")',delete a.null,delete a.array,delete a.object),a.number&&delete a.integer;for(var s in a)r+=(r?" && ":"")+o(s,t,!0);return r}}function n(e,t){if(Array.isArray(t)){for(var r=[],a=0;a<t.length;a++){var o=t[a];k[o]?r[r.length]=o:"array"===e&&"array"===o&&(r[r.length]=o)}if(r.length)return r}else{if(k[t])return[t];if("array"===e&&"array"===t)return["array"]}}function i(e){for(var t={},r=0;r<e.length;r++)t[e[r]]=!0;return t}function l(e){return"number"==typeof e?"["+e+"]":P.test(e)?"."+e:"['"+c(e)+"']"}function c(e){return e.replace(C,"\\$&").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\f/g,"\\f").replace(/\t/g,"\\t")}function p(e,t){t+="[^0-9]";var r=e.match(new RegExp(t,"g"));return r?r.length:0}function u(e,t,r){return t+="([^0-9])",r=r.replace(/\$/g,"$$$$"),e.replace(new RegExp(t,"g"),r+"$1")}function d(e){return e.replace(L,"").replace(I,"").replace(S,"if (!($1))")}function h(e,t){var r=e.match(D);return r&&2==r.length&&(e=t?e.replace(F,"").replace(N,O):e.replace(Q,"").replace(B,R)),r=e.match(M),r&&3===r.length?e.replace(U,""):e}function f(e,t){if("boolean"==typeof e)return!e;for(var r in e)if(t[r])return!0}function m(e,t,r){if("boolean"==typeof e)return!e&&"not"!=r;for(var a in e)if(a!=r&&t[a])return!0}function y(e){return"'"+c(e)+"'"}function v(e,t,r,a){return b(e,r?"'/' + "+t+(a?"":".replace(/~/g, '~0').replace(/\\//g, '~1')"):a?"'[' + "+t+" + ']'":"'[\\'' + "+t+" + '\\']'")}function g(e,t,r){return b(e,y(r?"/"+j(t):l(t)))}function A(e,t,r){var a,o,s,n;if(""===e)return"rootData";if("/"==e[0]){if(!T.test(e))throw new Error("Invalid JSON-pointer: "+e);o=e,s="rootData"}else{if(!(n=e.match(z)))throw new Error("Invalid JSON-pointer: "+e);if(a=+n[1],"#"==(o=n[2])){if(a>=t)throw new Error("Cannot access property/index "+a+" levels up, current level is "+t);return r[t-a]}if(a>t)throw new Error("Cannot access data "+a+" levels up, current level is "+t);if(s="data"+(t-a||""),!o)return s}for(var i=s,c=o.split("/"),p=0;p<c.length;p++){var u=c[p];u&&(s+=l(x(u)),i+=" && "+s)}return i}function b(e,t){return'""'==e?t:(e+" + "+t).replace(/' \+ '/g,"")}function w(e){return x(decodeURIComponent(e))}function E(e){return encodeURIComponent(j(e))}function j(e){return e.replace(/~/g,"~0").replace(/\//g,"~1")}function x(e){return e.replace(/~1/g,"/").replace(/~0/g,"~")}e.exports={copy:a,checkDataType:o,checkDataTypes:s,coerceToTypes:n,toHash:i,getProperty:l,escapeQuotes:c,equal:r(3),ucs2length:r(53),varOccurences:p,varReplace:u,cleanUpCode:d,finalCleanUpCode:h,schemaHasRules:f,schemaHasRulesExcept:m,toQuotedString:y,getPathExpr:v,getPath:g,getData:A,unescapeFragment:w,unescapeJsonPointer:x,escapeFragment:E,escapeJsonPointer:j};var k=i(["string","number","integer","boolean","null"]),P=/^[a-z$_][a-z$_0-9]*$/i,C=/'|\\/g,L=/else\s*{\s*}/g,I=/if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g,S=/if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g,D=/[^v.]errors/g,Q=/var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g,F=/var errors = 0;|var vErrors = null;/g,B="return errors === 0;",R="validate.errors = null; return true;",N=/if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/,O="return data;",M=/[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g,U=/if \(rootData === undefined\) rootData = data;/,T=/^\/(?:[^~]|~0|~1)*$/,z=/^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/},function(e,t,r){"use strict";function a(e){this.message="validation failed",this.errors=e,this.ajv=this.validation=!0}function o(e,t,r){this.message=r||o.message(e,t),this.missingRef=n.url(e,t),this.missingSchema=n.normalizeId(n.fullPath(this.missingRef))}function s(e){return e.prototype=Object.create(Error.prototype),e.prototype.constructor=e,e}var n=r(2);e.exports={Validation:s(a),MissingRef:s(o)},o.message=function(e,t){return"can't resolve reference "+t+" from id "+e}},function(e,t,r){"use strict";function a(e,t,r){var s=this._refs[r];if("string"==typeof s){if(!this._refs[s])return a.call(this,e,t,s);s=this._refs[s]}if((s=s||this._schemas[r])instanceof g)return i(s.schema,this._opts.inlineRefs)?s.schema:s.validate||this._compile(s);var n,l,c,p=o.call(this,t,r);return p&&(n=p.schema,t=p.root,c=p.baseId),n instanceof g?l=n.validate||e.call(this,n.schema,t,void 0,c):void 0!==n&&(l=i(n,this._opts.inlineRefs)?n:e.call(this,n,t,void 0,c)),l}function o(e,t){var r=m.parse(t,!1,!0),a=u(r),o=p(this._getId(e.schema));if(a!==o){var i=d(a),l=this._refs[i];if("string"==typeof l)return s.call(this,e,l,r);if(l instanceof g)l.validate||this._compile(l),e=l;else{if(!((l=this._schemas[i])instanceof g))return;if(l.validate||this._compile(l),i==d(t))return{schema:l,root:e,baseId:o};e=l}if(!e.schema)return;o=p(this._getId(e.schema))}return n.call(this,r,o,e.schema,e)}function s(e,t,r){var a=o.call(this,e,t);if(a){var s=a.schema,i=a.baseId;e=a.root;var l=this._getId(s);return l&&(i=h(i,l)),n.call(this,r,i,s,e)}}function n(e,t,r,a){if(e.hash=e.hash||"","#/"==e.hash.slice(0,2)){for(var s=e.hash.split("/"),n=1;n<s.length;n++){var i=s[n];if(i){if(i=v.unescapeFragment(i),void 0===(r=r[i]))break;var l;if(!b[i]&&(l=this._getId(r),l&&(t=h(t,l)),r.$ref)){var c=h(t,r.$ref),p=o.call(this,a,c);p&&(r=p.schema,a=p.root,t=p.baseId)}}}return void 0!==r&&r!==a.schema?{schema:r,root:a,baseId:t}:void 0}}function i(e,t){return!1!==t&&(void 0===t||!0===t?l(e):t?c(e)<=t:void 0)}function l(e){var t;if(Array.isArray(e)){for(var r=0;r<e.length;r++)if("object"==typeof(t=e[r])&&!l(t))return!1}else for(var a in e){if("$ref"==a)return!1;if("object"==typeof(t=e[a])&&!l(t))return!1}return!0}function c(e){var t,r=0;if(Array.isArray(e)){for(var a=0;a<e.length;a++)if(t=e[a],"object"==typeof t&&(r+=c(t)),r==1/0)return 1/0}else for(var o in e){if("$ref"==o)return 1/0;if(w[o])r++;else if(t=e[o],"object"==typeof t&&(r+=c(t)+1),r==1/0)return 1/0}return r}function p(e,t){return!1!==t&&(e=d(e)),u(m.parse(e,!1,!0))}function u(e){var t=e.protocol||"//"==e.href.slice(0,2)?"//":"";return(e.protocol||"")+t+(e.host||"")+(e.path||"")+"#"}function d(e){return e?e.replace(E,""):""}function h(e,t){return t=d(t),m.resolve(e,t)}function f(e){var t=d(this._getId(e)),r={"":t},a={"":p(t,!1)},o={},s=this;return A(e,{allKeys:!0},function(e,t,n,i,l,c,p){if(""!==t){var u=s._getId(e),h=r[i],f=a[i]+"/"+l;if(void 0!==p&&(f+="/"+("number"==typeof p?p:v.escapeFragment(p))),"string"==typeof u){u=h=d(h?m.resolve(h,u):u);var g=s._refs[u];if("string"==typeof g&&(g=s._refs[g]),g&&g.schema){if(!y(e,g.schema))throw new Error('id "'+u+'" resolves to more than one schema')}else if(u!=d(f))if("#"==u[0]){if(o[u]&&!y(e,o[u]))throw new Error('id "'+u+'" resolves to more than one schema');o[u]=e}else s._refs[u]=f}r[t]=h,a[t]=f}}),o}var m=r(87),y=r(3),v=r(0),g=r(4),A=r(79);e.exports=a,a.normalizeId=d,a.fullPath=p,a.url=h,a.ids=f,a.inlineRef=i,a.schema=o;var b=v.toHash(["properties","patternProperties","enum","dependencies","definitions"]),w=v.toHash(["type","format","pattern","maxLength","minLength","maxProperties","minProperties","maxItems","minItems","maximum","minimum","uniqueItems","multipleOf","required","enum"]),E=/#\/?$/},function(e,t,r){"use strict";var a=Array.isArray,o=Object.keys,s=Object.prototype.hasOwnProperty;e.exports=function e(t,r){if(t===r)return!0;var n,i,l,c=a(t),p=a(r);if(c&&p){if((i=t.length)!=r.length)return!1;for(n=0;n<i;n++)if(!e(t[n],r[n]))return!1;return!0}if(c!=p)return!1;var u=t instanceof Date,d=r instanceof Date;if(u!=d)return!1;if(u&&d)return t.getTime()==r.getTime();var h=t instanceof RegExp,f=r instanceof RegExp;if(h!=f)return!1;if(h&&f)return t.toString()==r.toString();if(t instanceof Object&&r instanceof Object){var m=o(t);if((i=m.length)!==o(r).length)return!1;for(n=0;n<i;n++)if(!s.call(r,m[n]))return!1;for(n=0;n<i;n++)if(l=m[n],!e(t[l],r[l]))return!1;return!0}return!1}},function(e,t,r){"use strict";function a(e){o.copy(e,this)}var o=r(0);e.exports=a},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,u=!e.opts.allErrors,d="data"+(i||""),h=e.opts.$data&&l&&l.$data;h?(s+=" var schema"+n+" = "+e.util.getData(l.$data,i,e.dataPathArr)+"; ",o="schema"+n):o=l;var f="maximum"==t,m=f?"exclusiveMaximum":"exclusiveMinimum",y=e.schema[m],v=e.opts.$data&&y&&y.$data,g=f?"<":">",A=f?">":"<",a=void 0;if(v){var b=e.util.getData(y.$data,i,e.dataPathArr),w="exclusive"+n,E="exclType"+n,j="exclIsNumber"+n,x="op"+n,k="' + "+x+" + '";s+=" var schemaExcl"+n+" = "+b+"; ",b="schemaExcl"+n,s+=" var "+w+"; var "+E+" = typeof "+b+"; if ("+E+" != 'boolean' && "+E+" != 'undefined' && "+E+" != 'number') { ";var a=m,P=P||[];P.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"_exclusiveLimit")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: {} ",!1!==e.opts.messages&&(s+=" , message: '"+m+" should be boolean' "),e.opts.verbose&&(s+=" , schema: validate.schema"+c+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var C=s;s=P.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+C+"]); ":s+=" validate.errors = ["+C+"]; return false; ":s+=" var err = "+C+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",s+=" } else if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),s+=" "+E+" == 'number' ? ( ("+w+" = "+o+" === undefined || "+b+" "+g+"= "+o+") ? "+d+" "+A+"= "+b+" : "+d+" "+A+" "+o+" ) : ( ("+w+" = "+b+" === true) ? "+d+" "+A+"= "+o+" : "+d+" "+A+" "+o+" ) || "+d+" !== "+d+") { var op"+n+" = "+w+" ? '"+g+"' : '"+g+"=';"}else{var j="number"==typeof y,k=g;if(j&&h){var x="'"+k+"'";s+=" if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),s+=" ( "+o+" === undefined || "+y+" "+g+"= "+o+" ? "+d+" "+A+"= "+y+" : "+d+" "+A+" "+o+" ) || "+d+" !== "+d+") { "}else{j&&void 0===l?(w=!0,a=m,p=e.errSchemaPath+"/"+m,o=y,A+="="):(j&&(o=Math[f?"min":"max"](y,l)),y===(!j||o)?(w=!0,a=m,p=e.errSchemaPath+"/"+m,A+="="):(w=!1,k+="="));var x="'"+k+"'";s+=" if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),s+=" "+d+" "+A+" "+o+" || "+d+" !== "+d+") { "}}a=a||t;var P=P||[];P.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"_limit")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { comparison: "+x+", limit: "+o+", exclusive: "+w+" } ",!1!==e.opts.messages&&(s+=" , message: 'should be "+k+" ",s+=h?"' + "+o:o+"'"),e.opts.verbose&&(s+=" , schema:  ",s+=h?"validate.schema"+c:""+l,s+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var C=s;return s=P.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+C+"]); ":s+=" validate.errors = ["+C+"]; return false; ":s+=" var err = "+C+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",s+=" } ",u&&(s+=" else { "),s}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,u=!e.opts.allErrors,d="data"+(i||""),h=e.opts.$data&&l&&l.$data;h?(s+=" var schema"+n+" = "+e.util.getData(l.$data,i,e.dataPathArr)+"; ",o="schema"+n):o=l;var f="maxItems"==t?">":"<";s+="if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),s+=" "+d+".length "+f+" "+o+") { ";var a=t,m=m||[];m.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"_limitItems")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { limit: "+o+" } ",!1!==e.opts.messages&&(s+=" , message: 'should NOT have ",s+="maxItems"==t?"more":"less",s+=" than ",s+=h?"' + "+o+" + '":""+l,s+=" items' "),e.opts.verbose&&(s+=" , schema:  ",s+=h?"validate.schema"+c:""+l,s+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var y=s;return s=m.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+y+"]); ":s+=" validate.errors = ["+y+"]; return false; ":s+=" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",s+="} ",u&&(s+=" else { "),s}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,u=!e.opts.allErrors,d="data"+(i||""),h=e.opts.$data&&l&&l.$data;h?(s+=" var schema"+n+" = "+e.util.getData(l.$data,i,e.dataPathArr)+"; ",o="schema"+n):o=l;var f="maxLength"==t?">":"<";s+="if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),!1===e.opts.unicode?s+=" "+d+".length ":s+=" ucs2length("+d+") ",s+=" "+f+" "+o+") { ";var a=t,m=m||[];m.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"_limitLength")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { limit: "+o+" } ",!1!==e.opts.messages&&(s+=" , message: 'should NOT be ",s+="maxLength"==t?"longer":"shorter",s+=" than ",s+=h?"' + "+o+" + '":""+l,s+=" characters' "),e.opts.verbose&&(s+=" , schema:  ",s+=h?"validate.schema"+c:""+l,s+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var y=s;return s=m.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+y+"]); ":s+=" validate.errors = ["+y+"]; return false; ":s+=" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",s+="} ",u&&(s+=" else { "),s}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,u=!e.opts.allErrors,d="data"+(i||""),h=e.opts.$data&&l&&l.$data;h?(s+=" var schema"+n+" = "+e.util.getData(l.$data,i,e.dataPathArr)+"; ",o="schema"+n):o=l;var f="maxProperties"==t?">":"<";s+="if ( ",h&&(s+=" ("+o+" !== undefined && typeof "+o+" != 'number') || "),s+=" Object.keys("+d+").length "+f+" "+o+") { ";var a=t,m=m||[];m.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"_limitProperties")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { limit: "+o+" } ",!1!==e.opts.messages&&(s+=" , message: 'should NOT have ",s+="maxProperties"==t?"more":"less",s+=" than ",s+=h?"' + "+o+" + '":""+l,s+=" properties' "),e.opts.verbose&&(s+=" , schema:  ",s+=h?"validate.schema"+c:""+l,s+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var y=s;return s=m.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+y+"]); ":s+=" validate.errors = ["+y+"]; return false; ":s+=" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",s+="} ",u&&(s+=" else { "),s}},function(e,t,r){"use strict";e.exports=function(e,t,r){function a(e){for(var t=e.rules,r=0;r<t.length;r++)if(o(t[r]))return!0}function o(t){return void 0!==e.schema[t.keyword]||t.implements&&s(t)}function s(t){for(var r=t.implements,a=0;a<r.length;a++)if(void 0!==e.schema[r[a]])return!0}var n="",i=!0===e.schema.$async,l=e.util.schemaHasRulesExcept(e.schema,e.RULES.all,"$ref"),c=e.self._getId(e.schema);if(e.isTop){if(i){e.async=!0;var p="es7"==e.opts.async;e.yieldAwait=p?"await":"yield"}n+=" var validate = ",i?p?n+=" (async function ":("*"!=e.opts.async&&(n+="co.wrap"),n+="(function* "):n+=" (function ",n+=" (data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ",c&&(e.opts.sourceCode||e.opts.processCode)&&(n+=" /*# sourceURL="+c+" */ ")}if("boolean"==typeof e.schema||!l&&!e.schema.$ref){var u,d=e.level,h=e.dataLevel,f=e.schema["false schema"],m=e.schemaPath+e.util.getProperty("false schema"),y=e.errSchemaPath+"/false schema",v=!e.opts.allErrors,g="data"+(h||""),A="valid"+d;if(!1===e.schema){e.isTop?v=!0:n+=" var "+A+" = false; ";var b=b||[];b.push(n),n="",!1!==e.createErrors?(n+=" { keyword: '"+(u||"false schema")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(y)+" , params: {} ",!1!==e.opts.messages&&(n+=" , message: 'boolean schema is false' "),e.opts.verbose&&(n+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+g+" "),n+=" } "):n+=" {} ";var w=n;n=b.pop(),!e.compositeRule&&v?e.async?n+=" throw new ValidationError(["+w+"]); ":n+=" validate.errors = ["+w+"]; return false; ":n+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "}else e.isTop?n+=i?" return data; ":" validate.errors = null; return true; ":n+=" var "+A+" = true; ";return e.isTop&&(n+=" }); return validate; "),n}if(e.isTop){var E=e.isTop,d=e.level=0,h=e.dataLevel=0,g="data";e.rootId=e.resolve.fullPath(e.self._getId(e.root.schema)),e.baseId=e.baseId||e.rootId,delete e.isTop,e.dataPathArr=[void 0],n+=" var vErrors = null; ",n+=" var errors = 0;     ",n+=" if (rootData === undefined) rootData = data; "}else{var d=e.level,h=e.dataLevel,g="data"+(h||"");if(c&&(e.baseId=e.resolve.url(e.baseId,c)),i&&!e.async)throw new Error("async schema in sync schema");n+=" var errs_"+d+" = errors;"}var u,A="valid"+d,v=!e.opts.allErrors,j="",x="",k=e.schema.type,P=Array.isArray(k);if(P&&1==k.length&&(k=k[0],P=!1),e.schema.$ref&&l){if("fail"==e.opts.extendRefs)throw new Error('$ref: validation keywords used in schema at path "'+e.errSchemaPath+'" (see option extendRefs)');!0!==e.opts.extendRefs&&(l=!1,e.logger.warn('$ref: keywords ignored in schema at path "'+e.errSchemaPath+'"'))}if(k){if(e.opts.coerceTypes)var C=e.util.coerceToTypes(e.opts.coerceTypes,k);var L=e.RULES.types[k];if(C||P||!0===L||L&&!a(L)){var m=e.schemaPath+".type",y=e.errSchemaPath+"/type",m=e.schemaPath+".type",y=e.errSchemaPath+"/type",I=P?"checkDataTypes":"checkDataType";if(n+=" if ("+e.util[I](k,g,!0)+") { ",C){var S="dataType"+d,D="coerced"+d;n+=" var "+S+" = typeof "+g+"; ","array"==e.opts.coerceTypes&&(n+=" if ("+S+" == 'object' && Array.isArray("+g+")) "+S+" = 'array'; "),n+=" var "+D+" = undefined; ";var Q="",F=C;if(F)for(var B,R=-1,N=F.length-1;R<N;)B=F[R+=1],R&&(n+=" if ("+D+" === undefined) { ",Q+="}"),"array"==e.opts.coerceTypes&&"array"!=B&&(n+=" if ("+S+" == 'array' && "+g+".length == 1) { "+D+" = "+g+" = "+g+"[0]; "+S+" = typeof "+g+";  } "),"string"==B?n+=" if ("+S+" == 'number' || "+S+" == 'boolean') "+D+" = '' + "+g+"; else if ("+g+" === null) "+D+" = ''; ":"number"==B||"integer"==B?(n+=" if ("+S+" == 'boolean' || "+g+" === null || ("+S+" == 'string' && "+g+" && "+g+" == +"+g+" ","integer"==B&&(n+=" && !("+g+" % 1)"),n+=")) "+D+" = +"+g+"; "):"boolean"==B?n+=" if ("+g+" === 'false' || "+g+" === 0 || "+g+" === null) "+D+" = false; else if ("+g+" === 'true' || "+g+" === 1) "+D+" = true; ":"null"==B?n+=" if ("+g+" === '' || "+g+" === 0 || "+g+" === false) "+D+" = null; ":"array"==e.opts.coerceTypes&&"array"==B&&(n+=" if ("+S+" == 'string' || "+S+" == 'number' || "+S+" == 'boolean' || "+g+" == null) "+D+" = ["+g+"]; ");n+=" "+Q+" if ("+D+" === undefined) {   ";var b=b||[];b.push(n),n="",!1!==e.createErrors?(n+=" { keyword: '"+(u||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(y)+" , params: { type: '",n+=P?""+k.join(","):""+k,n+="' } ",!1!==e.opts.messages&&(n+=" , message: 'should be ",n+=P?""+k.join(","):""+k,n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+m+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+g+" "),n+=" } "):n+=" {} ";var w=n;n=b.pop(),!e.compositeRule&&v?e.async?n+=" throw new ValidationError(["+w+"]); ":n+=" validate.errors = ["+w+"]; return false; ":n+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } else {  ";var O=h?"data"+(h-1||""):"parentData",M=h?e.dataPathArr[h]:"parentDataProperty";n+=" "+g+" = "+D+"; ",h||(n+="if ("+O+" !== undefined)"),n+=" "+O+"["+M+"] = "+D+"; } "}else{var b=b||[];b.push(n),n="",!1!==e.createErrors?(n+=" { keyword: '"+(u||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(y)+" , params: { type: '",n+=P?""+k.join(","):""+k,n+="' } ",!1!==e.opts.messages&&(n+=" , message: 'should be ",n+=P?""+k.join(","):""+k,n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+m+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+g+" "),n+=" } "):n+=" {} ";var w=n;n=b.pop(),!e.compositeRule&&v?e.async?n+=" throw new ValidationError(["+w+"]); ":n+=" validate.errors = ["+w+"]; return false; ":n+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "}n+=" } "}}if(e.schema.$ref&&!l)n+=" "+e.RULES.all.$ref.code(e,"$ref")+" ",v&&(n+=" } if (errors === ",n+=E?"0":"errs_"+d,n+=") { ",x+="}");else{e.opts.v5&&e.schema.patternGroups&&e.logger.warn('keyword "patternGroups" is deprecated and disabled. Use option patternGroups: true to enable.');var U=e.RULES;if(U)for(var L,T=-1,z=U.length-1;T<z;)if(L=U[T+=1],a(L)){if(L.type&&(n+=" if ("+e.util.checkDataType(L.type,g)+") { "),e.opts.useDefaults&&!e.compositeRule)if("object"==L.type&&e.schema.properties){var f=e.schema.properties,H=Object.keys(f),G=H;if(G)for(var Y,q=-1,K=G.length-1;q<K;){Y=G[q+=1];var J=f[Y];if(void 0!==J.default){var V=g+e.util.getProperty(Y);n+="  if ("+V+" === undefined) "+V+" = ","shared"==e.opts.useDefaults?n+=" "+e.useDefault(J.default)+" ":n+=" "+JSON.stringify(J.default)+" ",n+="; "}}}else if("array"==L.type&&Array.isArray(e.schema.items)){var W=e.schema.items;if(W)for(var J,R=-1,X=W.length-1;R<X;)if(J=W[R+=1],void 0!==J.default){var V=g+"["+R+"]";n+="  if ("+V+" === undefined) "+V+" = ","shared"==e.opts.useDefaults?n+=" "+e.useDefault(J.default)+" ":n+=" "+JSON.stringify(J.default)+" ",n+="; "}}var Z=L.rules;if(Z)for(var $,_=-1,ee=Z.length-1;_<ee;)if($=Z[_+=1],o($)){var te=$.code(e,$.keyword,L.type);te&&(n+=" "+te+" ",v&&(j+="}"))}if(v&&(n+=" "+j+" ",j=""),L.type&&(n+=" } ",k&&k===L.type&&!C)){n+=" else { ";var m=e.schemaPath+".type",y=e.errSchemaPath+"/type",b=b||[];b.push(n),n="",!1!==e.createErrors?(n+=" { keyword: '"+(u||"type")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(y)+" , params: { type: '",n+=P?""+k.join(","):""+k,n+="' } ",!1!==e.opts.messages&&(n+=" , message: 'should be ",n+=P?""+k.join(","):""+k,n+="' "),e.opts.verbose&&(n+=" , schema: validate.schema"+m+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+g+" "),n+=" } "):n+=" {} ";var w=n;n=b.pop(),!e.compositeRule&&v?e.async?n+=" throw new ValidationError(["+w+"]); ":n+=" validate.errors = ["+w+"]; return false; ":n+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } "}v&&(n+=" if (errors === ",n+=E?"0":"errs_"+d,n+=") { ",x+="}")}}return v&&(n+=" "+x+" "),E?(i?(n+=" if (errors === 0) return data;           ",n+=" else throw new ValidationError(vErrors); "):(n+=" validate.errors = vErrors; ",n+=" return errors === 0;       "),n+=" }); return validate;"):n+=" var "+A+" = errors === errs_"+d+";",n=e.util.cleanUpCode(n),E&&(n=e.util.finalCleanUpCode(n,i)),n}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=["vertical","horizontal","carousel"];t.default={styleToCss:function(e){var t="";return e&&(e.color&&(t+="color:"+e.color+";"),e["background-color"]&&(t+="background-color:"+e["background-color"]+";"),e.bold&&(t+="font-weight:bold;"),e.italic&&(t+="font-style:italic;"),e.size&&(t+="font-size:"+this.sizeToPx(e.size)+"px;"),e.fill&&(t+="fill:"+e.fill+";")),t},styleToBorder:function(e){var t="";return e&&(e["border-color"]&&(t+="border-color: "+e["border-color"]+";"),e["border-radius"]&&(t+="border-radius: "+e["border-radius"]+"px;")),t},styleToButton:function(e){var t="";return e&&e.size&&(t+="width: "+this.buttonSizeToPx(e.size)+"px; height: "+this.buttonSizeToPx(e.size)+"px;"),t},extractFromStyles:function(e,t){var r=e,a=r.indexOf(t),o="";return a>-1&&(o=r.substr(a,r.indexOf(";",a)-(a-1)),r=r.replace(o,"")),{extractedStyle:o,style:r}},sizeToPx:function(e){switch(e){case"small":return 11;case"medium":return 13;case"large":return 17;default:return 13}},buttonSizeToPx:function(e){switch(e){case"small":return 27;case"medium":return 36;case"large":return 45;default:return 36}},validateParameters:function(e){if(!e.type)throw new Error("Missing configuration: type");for(var t=arguments.length,r=Array(t>1?t-1:0),a=1;a<t;a++)r[a-1]=arguments[a];r.forEach(function(t){if(void 0===e[t])throw new Error("Missing configuration: "+t+" is a mandatory for element of type "+e.type)})},isString:function(e){return e instanceof String||"string"==typeof e},isObject:function(e){return null!==e&&"object"===(void 0===e?"undefined":a(e))},isLayout:function(e){return o.indexOf(e)>=0},normalizeHtmlText:function(e){var t=e;return e&&(t=t.replace(/(?:\r\n|\r|\n)/g,"<br/>")),t},escapeHtml:function(e){var t={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};return e.replace(/[&<>"'`=/]/g,function(e){return t[e]})},htmlToElement:function(e){var t=document.createElement("template");return t.innerHTML=e.trim(),t.content.firstChild},hasClass:function(e,t){return e.classList&&e.classList.contains?e.classList.contains(t):!!e.className.match(new RegExp("(\\s|^)"+t+"(\\s|$)"))},addClass:function(e,t){e.classList?e.classList.add(t):this.hasClass(e,t)||(e.className+=" "+t)},removeClass:function(e,t){if(e.classList)e.classList.remove(t);else if(this.hasClass(e,t)){var r=new RegExp("(\\s|^)"+t+"(\\s|$)");e.className=e.className.replace(r," ")}},generateRandomId:function(){return Math.random().toString(36).substring(2,15)+Math.random().toString(36).substring(2,15)},appendAttributesFromObject:function(e,t){Object.keys(t).forEach(function(r){e.setAttribute(r,t[r])})}}},function(e,t,r){var a,o,a,s;!function(e,r){"use strict";a=[],o=function(){return r(e,e,!0)}.apply(t,a)}("undefined"==typeof ChronosRoot?this:ChronosRoot,function(e,t,r){"use strict";function a(e,t,r){var a=[];if(e[t]&&e[t].length)for(var o=0;o<e[t].length;o++)r&&"*"!==e[t][o].appName&&e[t][o].appName!==r||a.push(e[t][o]);if(e["*"])for(var s=0;s<e["*"].length;s++)r&&"*"!==e["*"][s].appName&&e["*"][s].appName!==r||a.push(e["*"][s]);return a}function o(t,r,a){e&&"function"==typeof e.log&&e.log(t,r,a)}function s(e){var t,r=e.unbindObj[e.attrName],a=!1;if(!e.unbindObj)return o("CMD listen id not spec for unbind","ERROR",e.loggerName),null;if("string"==typeof e.unbindObj)return c(e.lstnrs,e.unbindObj);if(!e.unbindObj.func&&!e.unbindObj.context&&!e.unbindObj.appName)return!1;var s=e.lstnrs;r&&(s={},s[r]=e.lstnrs[r]);for(var n in s)s.hasOwnProperty(n)&&s[n]&&s[n].length&&(t=p(s[n],e.unbindObj.func,e.unbindObj.context,e.unbindObj.appName),t.length!==s[n].length&&(e.lstnrs[n]=t,a=!0));return a}function n(e){var t={};if(e.constructor===Object)for(var r in e)e.hasOwnProperty(r)&&null!==e[r]&&void 0!==e[r]&&("object"==typeof e[r]&&e[r].constructor!==Array?t[r]=n(e[r]):e[r].constructor===Array?t[r]=e[r].slice(0)||[]:"function"!=typeof e[r]&&(t[r]=null!==e[r]&&void 0!==e[r]?e[r]:""));else e.constructor===Array?t=e.slice(0)||[]:"function"!=typeof e&&(t=e);return t}function i(e,t,r){if((void 0===r||"*"===r)&&"*"===t)return e;for(var a=[],o=0;o<e.length;o++)e[o].eventName!==r&&"*"!==r||(t&&t===e[o].appName||!e[o].appName||"*"===e[o].appName||"*"===t)&&a.push(e[o]);return a}function l(e){if(0===e.eventBufferLimit||e.triggerData.data&&e.triggerData.data.doNotStore)e=null;else{var t={eventName:e.triggerData[e.attrName],appName:e.triggerData.appName};t.data=e.triggerData.passDataByRef?e.triggerData.data:n(e.triggerData.data),e.eventBufferLimit>0?(e.index>=e.eventBufferLimit&&(e.index=0),e.fired[e.index]=t,e.index++):e.fired.push(t),e=null}}function c(e,t){var r=!1;if(!t)return o("Ev listen id not spec for unregister","ERROR","Events"),null;for(var a in e)if(e.hasOwnProperty(a))for(var s=0;s<e[a].length;s++)if(e[a][s].id==t){e[a].splice(s,1),o("Ev listen="+t+" and name="+a+" unregister","DEBUG","Events"),r=!0;break}return r||o("Ev listen not found "+t+" unregister","DEBUG","Events"),r}function p(e,t,r,a){var s=[];if(e&&e.length)for(var n=0;n<e.length;n++)try{var i=!r&&e[n].func===t,l=!t&&r&&e[n].context===r,c=t&&r&&e[n].func===t&&e[n].context===r,p=a&&a===e[n].appName,u="*"===e[n].appName;if(i||l||c){if(p||u)continue;if(l)continue}else if(!t&&!r&&p)continue;s.push(e[n])}catch(e){o("Error in unbind e="+e.message,"ERROR","Events")}return s}var u={getListeners:a,log:o,unbind:s,hasFired:i,cloneEventData:n,storeEventData:l};return r||(t.EventsUtil=t.EventsUtil||u),u}),function(r,n){"use strict";a=[o],void 0!==(s=function(e){return n(r,r,e,!0)}.apply(t,a))&&(e.exports=s)}("undefined"==typeof ChronosRoot?this:ChronosRoot,function(e,t,r,a){"use strict";function o(e){function t(e){return e?(e.triggerOnce=!0,a(e)):null}function a(e,t,o){var s=e;if("string"==typeof e&&(s={appName:e,eventName:t,func:o}),s.appName=s.appName||u,"*"!==u&&("string"!=typeof e||"function"!=typeof t&&void 0!==t||(s.eventName=e)),!s.eventName||!s.func||"function"!=typeof s.func&&s.func.constructor!==Array)return r.log("Ev listen has invalid params: evName=["+s.eventName+"]","ERROR","Events"),null;if(s.func.constructor===Array){for(var n,i,l=[],c=0;c<s.func.length;c++)n=r.cloneEventData(s),n.func=s.func[c],i=a(n),l.push(i);return l}var p=v+f++,d={id:p,func:s.func,context:s.context||null,aSync:!!s.aSync,appName:s.appName,triggerOnce:s.triggerOnce||!1};return m[s.eventName]=m[s.eventName]||[],m[s.eventName].push(d),r.log("Ev listen rgstr: evName=["+s.eventName+"] aSync="+d.aSync+" appName="+d.name,"DEBUG","Events"),s=null,e=null,p}function o(e){return"*"!==u&&(e.appName=e.appName||u),r.unbind({unbindObj:e,attrName:h,loggerName:d,lstnrs:m})}function s(e,t){return void 0===t&&(t=e,e=u),r.hasFired(y,e,t)}function n(e,t,a){var o=e;if("string"==typeof e&&(o={eventName:t,appName:e,data:a}),"*"!==u&&(o.appName=o.appName||u,"string"!=typeof e||"object"!=typeof t&&void 0!==t||(o.eventName=e)),!o||void 0===o.eventName)return r.log("Ev name not spec for publish","ERROR","Events"),o=null,null;o.passDataByRef=o.passDataByRef||!c,l(o);var s=r.getListeners(m,o.eventName,o.appName);if(s.length>0)for(var n=0;n<s.length;n++){var p=o.passDataByRef?o.data:r.cloneEventData(o.data),d={appName:o.appName,eventName:o.eventName},h=s[n];h.aSync||p&&p.aSync?setTimeout(i(h,p,d),0):i(h,p,d)()}return o=null,s.length>0}function i(e,t,a){return function(){try{e.func.call(e.context,t,a),t=null,e.triggerOnce&&o(e),e=null}catch(t){r.log("Error executing "+a.eventName+" eventId: "+e.id+"e="+t.message,"ERROR","Events")}}}function l(e){r.storeEventData({triggerData:e,eventBufferLimit:p,attrName:h,fired:y,index:g})}var c,p,u,d="Events",h="eventName",f=0,m={},y=[],v="evId_",g=0;u=e&&e.appName||"*",c=!(!e||"boolean"!=typeof e.cloneEventData)&&e.cloneEventData,p=e&&!isNaN(e.eventBufferLimit)?e.eventBufferLimit:-1,this.once=t,this.hasFired=s,this.trigger=n,this.publish=n,this.bind=a,this.register=a,this.unbind=o,this.unregister=o}return a||(t.Events=t.Events||o),o})},function(e,t){function r(e){var t=this,r=u.call(arguments,1);return new Promise(function(o,s){function n(t){var r;try{r=e.next(t)}catch(e){return s(e)}c(r)}function l(t){var r;try{r=e.throw(t)}catch(e){return s(e)}c(r)}function c(e){if(e.done)return o(e.value);var r=a.call(t,e.value);return r&&i(r)?r.then(n,l):l(new TypeError('You may only yield a function, promise, generator, array, or object, but the following object was passed: "'+String(e.value)+'"'))}if("function"==typeof e&&(e=e.apply(t,r)),!e||"function"!=typeof e.next)return o(e);n()})}function a(e){return e?i(e)?e:c(e)||l(e)?r.call(this,e):"function"==typeof e?o.call(this,e):Array.isArray(e)?s.call(this,e):p(e)?n.call(this,e):e:e}function o(e){var t=this;return new Promise(function(r,a){e.call(t,function(e,t){if(e)return a(e);arguments.length>2&&(t=u.call(arguments,1)),r(t)})})}function s(e){return Promise.all(e.map(a,this))}function n(e){for(var t=new e.constructor,r=Object.keys(e),o=[],s=0;s<r.length;s++){var n=r[s],l=a.call(this,e[n]);l&&i(l)?function(e,r){t[r]=void 0,o.push(e.then(function(e){t[r]=e}))}(l,n):t[n]=e[n]}return Promise.all(o).then(function(){return t})}function i(e){return"function"==typeof e.then}function l(e){return"function"==typeof e.next&&"function"==typeof e.throw}function c(e){var t=e.constructor;return!!t&&("GeneratorFunction"===t.name||"GeneratorFunction"===t.displayName||l(t.prototype))}function p(e){return Object==e.constructor}var u=Array.prototype.slice;e.exports=r.default=r.co=r,r.wrap=function(e){function t(){return r.call(this,e.apply(this,arguments))}return t.__generatorFunction__=e,t}},function(e,t,r){"use strict";e.exports=function(e,t){t||(t={}),"function"==typeof t&&(t={cmp:t});var r="boolean"==typeof t.cycles&&t.cycles,a=t.cmp&&function(e){return function(t){return function(r,a){var o={key:r,value:t[r]},s={key:a,value:t[a]};return e(o,s)}}}(t.cmp),o=[];return function e(t){if(t&&t.toJSON&&"function"==typeof t.toJSON&&(t=t.toJSON()),void 0!==t){if("number"==typeof t)return isFinite(t)?""+t:"null";if("object"!=typeof t)return JSON.stringify(t);var s,n;if(Array.isArray(t)){for(n="[",s=0;s<t.length;s++)s&&(n+=","),n+=e(t[s])||"null";return n+"]"}if(null===t)return"null";if(-1!==o.indexOf(t)){if(r)return JSON.stringify("__cycle__");throw new TypeError("Converting circular structure to JSON")}var i=o.push(t)-1,l=Object.keys(t).sort(a&&a(t));for(n="",s=0;s<l.length;s++){var c=l[s],p=e(t[c]);p&&(n&&(n+=","),n+=JSON.stringify(c)+":"+p)}return o.splice(i,1),"{"+n+"}"}}(e)}},function(e,t,r){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function n(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),l=r(76),c=a(l),p=r(10),u=a(p),d=r(11),h=function(e){function t(e,r){o(this,t);var a=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a.errors=r,a}return n(t,e),t}(Error),f=function(){function e(t){o(this,e),this.events=new d({cloneEventData:!0,appName:"json-pollock"}),this.provider=new c.default(this.events),this.maxAllowedElements=50,this.schemaValidator=t}return i(e,[{key:"init",value:function(e){e&&(Object.prototype.hasOwnProperty.call(e,"maxAllowedElements")&&(!isNaN(e.maxAllowedElements)&&e.maxAllowedElements>0?this.maxAllowedElements=e.maxAllowedElements:this.maxAllowedElements=50),"function"==typeof e.onAfterElementRendered&&(this.onAfterElementRendered=e.onAfterElementRendered))}},{key:"renderElement",value:function(e,t){var r=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;if(!(a>=this.maxAllowedElements)){var o=a,s=this.provider.get(e.type),n=void 0;s&&(n=s(e),this.onAfterElementRendered&&(n=this.onAfterElementRendered(n,e)),n&&(t.appendChild(n),Array.isArray(e.elements)&&e.elements.forEach(function(e){o+=1,r.renderElement(e,n,o)}),n.afterRender&&n.afterRender.call(n,e,t)))}}},{key:"render",value:function(e){var t=void 0;t=u.default.isString(e)?JSON.parse(e):e,this.validate(t);var r=document.createDocumentFragment(),a=document.createElement("div");return a.className="lp-json-pollock",u.default.isLayout(t.type)||(a.className+=" lp-json-pollock-single-element"),r.appendChild(a),this.renderElement(t,a),r}},{key:"validate",value:function(e){if(!u.default.isObject(e))throw new h("JsonPollock::validte - input is not an object");if(this.schemaValidator){var t=this.schemaValidator.validate(e);if(!t.valid)throw new h("Schema validation error, see 'errors' for more details",t.errors)}}},{key:"registerAction",value:function(e,t){this.events.bind({eventName:e,func:function(e){t(e)}})}},{key:"unregisterAction",value:function(e){this.events.unbind({eventName:e})}},{key:"unregisterAllActions",value:function(){this.events.unbind({})}},{key:"registerElement",value:function(e,t){this.provider.set(e,t)}}]),e}();f.TEMPLATE_TYPES=c.default.TYPES,t.default=f},function(e,t,r){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),n=r(46),i=a(n),l=r(19),c=a(l),p=r(20),u=a(p),d=r(40),h=a(d),f=r(21),m=a(f),y=r(23),v=a(y),g=r(24),A=a(g),b=r(25),w=a(b),E=r(29),j=a(E),x=r(32),k=a(x),P=r(34),C=a(P),L=r(35),I=a(L),S=r(43),D=a(S),Q=r(44),F=a(Q),B=r(26),R=a(B),N=r(33),O=a(N),M=r(27),U=a(M),T=r(41),z=a(T),H=r(37),G=a(H),Y=r(38),q=a(Y),K=r(39),J=a(K),V=r(22),W=a(V),X=r(30),Z=a(X),$=r(28),_=a($),ee=r(17),te=a(ee),re=r(36),ae=a(re),oe=r(31),se=a(oe),ne=r(18),ie=a(ne),le=r(42),ce=a(le),pe=function(){function e(){o(this,e);var t=new i.default({format:"full",unknownFormats:"ignore",verbose:!0,logger:!1});t.addSchema(c.default,"action.json"),t.addSchema(u.default,"basic.json"),t.addSchema(h.default,"style.json"),t.addSchema(m.default,"button.json"),t.addSchema(R.default,"checkbox.json"),t.addSchema(v.default,"card.json"),t.addSchema(A.default,"carousel.json"),t.addSchema(w.default,"carouselSelect.json"),t.addSchema(j.default,"image.json"),t.addSchema(k.default,"linkPreview.json"),t.addSchema(C.default,"map.json"),t.addSchema(I.default,"rich_content.json"),t.addSchema(D.default,"template.json"),t.addSchema(F.default,"text.json"),t.addSchema(O.default,"list.json"),t.addSchema(U.default,"checklist.json"),t.addSchema(z.default,"submitButton.json"),t.addSchema(G.default,"section.json"),t.addSchema(q.default,"sectionList.json"),t.addSchema(W.default,"buttonList.json"),t.addSchema(J.default,"specialAction.json"),t.addSchema(Z.default,"keyValuePair.json"),t.addSchema(_.default,"displaySettings.json"),t.addSchema(te.default,"accessibilityWeb.json"),t.addSchema(ae.default,"scheduleSlot.json"),t.addSchema(se.default,"keyValuePairList.json"),t.addSchema(ie.default,"accordionSelect.json"),t.addSchema(ce.default,"tabs.json"),this.jsonValidator=t.compile(I.default)}return s(e,[{key:"validate",value:function(e){var t=this.jsonValidator(e);return{valid:t,errors:t?this.jsonValidator.errors:void 0}}}]),e}();t.default=pe},function(e,t,r){var a=r(77);"string"==typeof a&&(a=[[e.i,a,""]]);var o={};o.transform=void 0;r(85)(a,o);a.locals&&(e.exports=a.locals)},function(e,t){e.exports={type:"object",additionalProperties:!1,properties:{role:{type:"string",maxLength:100},tabindex:{type:"string",maxLength:20},"aria-activedescendant":{type:"string",maxLength:100},"aria-atomic":{type:"string",maxLength:100},"aria-autocomplete":{type:"string",maxLength:100},"aria-busy":{type:"string",maxLength:100},"aria-checked":{type:"string",maxLength:20},"aria-colcount":{type:"string",maxLength:10},"aria-colindex":{type:"string",maxLength:10},"aria-colspan":{type:"string",maxLength:10},"aria-controls":{type:"string",maxLength:100},"aria-current":{type:"string",maxLength:100},"aria-describedby":{type:"string",maxLength:100},"aria-details":{type:"string",maxLength:100},"aria-disabled":{type:"string",maxLength:100},"aria-errormessage":{type:"string",maxLength:100},"aria-expanded":{type:"string",maxLength:20},"aria-flowto":{type:"string",maxLength:100},"aria-grabbed":{type:"string",maxLength:1e3},"aria-haspopup":{type:"string",maxLength:20},"aria-hidden":{type:"string",maxLength:20},"aria-invalid":{type:"string",maxLength:100},"aria-keyshortcuts":{type:"string",maxLength:1e3},"aria-label":{type:"string",maxLength:1e3},"aria-labelledby":{type:"string",maxLength:100},"aria-level":{type:"string",maxLength:20},"aria-live":{type:"string",maxLength:100},"aria-modal":{type:"string",maxLength:100},"aria-multiline":{type:"string",maxLength:20},"aria-multiselectable":{type:"string",maxLength:20},"aria-orientation":{type:"string",maxLength:100},"aria-owns":{type:"string",maxLength:100},"aria-placeholder":{type:"string",maxLength:1e3},"aria-posinset":{type:"string",maxLength:100},"aria-pressed":{type:"string",maxLength:100},"aria-readonly":{type:"string",maxLength:20},"aria-relevant":{type:"string",maxLength:1e3},"aria-required":{type:"string",maxLength:20},"aria-roledescription":{type:"string",maxLength:1e3},"aria-rowcount":{type:"string",maxLength:20},"aria-rowindex":{type:"string",maxLength:20},"aria-rowspan":{type:"string",maxLength:20},"aria-selected":{type:"string",maxLength:100},"aria-setsize":{type:"string",maxLength:100},"aria-sort":{type:"string",maxLength:100},"aria-valuemax":{type:"string",maxLength:100},"aria-valuemin":{type:"string",maxLength:100},"aria-valuenow":{type:"string",maxLength:100},"aria-valuetext":{type:"string",maxLength:1e3}}}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"accordionSelect",properties:{type:{type:"string",enum:["accordionSelect"],default:"accordionSelect",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},elements:{type:"array",minItems:1,maxItems:20,items:{$ref:"card.json"}},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},display:{$ref:"displaySettings.json"},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}},selectMode:{type:"object",additionalProperties:!1,properties:{name:{type:"string",maxLength:200}},required:["name"]},titles:{type:"array",minItems:1,maxItems:20,items:{type:"object",additionalProperties:!1,properties:{name:{type:"string",maxLength:200},additional:{type:"string",maxLength:200}},required:["name"]}}},required:["type","selectMode","titles","elements"]}},function(e,t){e.exports={oneOf:[{title:"Publish Text",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["publishText"],default:"publishText",readonly:!0},text:{type:"string",maxLength:256}},required:["type","text"]},{title:"Add to Cart",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["addToCart"],default:"addToCart",readonly:!0},items:{type:"array",maxItems:10,items:{type:"object",additionalProperties:!1,properties:{productId:{type:"string",maxLength:256},quantity:{type:"integer"}}}}},required:["type","items"]},{title:"navigate",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["navigate"],default:"navigate",readonly:!0},la:{type:"number"},lo:{type:"number"},name:{type:"string",maxLength:256}},required:["type","la","lo"]},{title:"link",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["link"],default:"link",readonly:!0},uri:{type:"string",format:"uri",maxLength:1024},name:{type:"string",maxLength:256},ios:{type:"object",additionalProperties:!1,properties:{uri:{type:"string",format:"uri",maxLength:1024}}},android:{type:"object",additionalProperties:!1,properties:{uri:{type:"string",format:"uri",maxLength:1024}}},web:{type:"object",additionalProperties:!1,properties:{uri:{type:"string",format:"uri",maxLength:1024}}},target:{type:"string",enum:["self","blank","slideout"],default:"self"},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","uri"]},{title:"Custom Action",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["custom"],default:"custom",readonly:!0},data:{type:"array",maxItems:10,items:{$ref:"keyValuePair.json"}}},required:["type"]},{title:"Date Picker",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["datePicker"],default:"datePicker",readonly:!0},class:{type:"string",enum:["single","range"],default:"single",readonly:!0},title:{type:"string",maxLength:40},minDate:{type:"integer"},maxDate:{type:"integer"},dateFormat:{type:"string",maxLength:100}},required:["type","class"]},{title:"Schedule Slot List",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["scheduleSlotList"],default:"scheduleSlotList",readonly:!0},title:{type:"string",maxLength:40},slots:{type:"array",maxItems:256,items:{$ref:"scheduleSlot.json"}},firstDayOfTheWeek:{type:"string",enum:["sun","mon"],default:"mon",readonly:!0}},required:["type"]}]}},function(e,t){e.exports={oneOf:[{$ref:"text.json"},{$ref:"image.json"},{$ref:"button.json"},{$ref:"map.json"},{$ref:"linkPreview.json"},{$ref:"template.json"},{$ref:"keyValuePairList.json"}]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"button",properties:{type:{type:"string",enum:["button"],default:"button",readonly:!0},class:{type:"string",enum:["text","button"],default:"text",readonly:!0},title:{type:"string",maxLength:128},subtitle:{type:"string",maxLength:128},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},ref:{type:"object",additionalProperties:!1,properties:{name:{type:"string",maxLength:200},type:{type:"string",enum:["carouselSelect","accordionSelect"]}}},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["title"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"buttonList",properties:{type:{type:"string",enum:["buttonList"],default:"buttonList",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},elements:{type:"array",minItems:1,maxItems:2,items:[{$ref:"submitButton.json"},{anyOf:[{$ref:"button.json"}]}]},alt:{type:"string",maxLength:2e3}},required:["type","elements"]}},function(e,t){e.exports={oneOf:[{title:"basic",$ref:"basic.json"},{type:"object",additionalProperties:!1,title:"horizontal",properties:{type:{type:"string",enum:["horizontal"],default:"horizontal",readonly:!0},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},borderLine:{type:"boolean",default:!0},border:{type:"string",enum:["border","borderLess","dropShadow"],default:"border",readonly:!0},percentages:{type:"array",maxItems:256,items:{type:"number"}},elements:{type:"array",maxItems:256,items:{$ref:"rich_content.json"}},alt:{type:"string",maxLength:2e3},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}},metadata:{type:"array"}},required:["type","elements"]},{type:"object",additionalProperties:!1,title:"vertical",properties:{type:{type:"string",enum:["vertical"],default:"vertical",readonly:!0},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},border:{type:"string",enum:["border","borderLess","dropShadow"],default:"border",readonly:!0},scroll:{type:"string",enum:["disable","enable"],default:"disable",readonly:!0},elements:{type:"array",maxItems:256,items:{$ref:"rich_content.json"}},alt:{type:"string",maxLength:2e3},display:{$ref:"displaySettings.json"},style:{$ref:"style.json"},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}},metadata:{type:"array"}},required:["type","elements"]}]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"carousel",properties:{type:{type:"string",enum:["carousel"],default:"carousel",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},elements:{type:"array",minItems:2,maxItems:10,items:{$ref:"card.json"}},alt:{type:"string",maxLength:2e3},display:{$ref:"displaySettings.json"},style:{$ref:"style.json"},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","elements"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"carouselSelect",properties:{type:{type:"string",enum:["carouselSelect"],default:"carouselSelect",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},elements:{type:"array",minItems:1,maxItems:20,items:{$ref:"card.json"}},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},display:{$ref:"displaySettings.json"},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}},selectMode:{type:"object",additionalProperties:!1,properties:{name:{type:"string",maxLength:200},type:{type:"string",enum:["single","multiple"]}},required:["name","type"]}},required:["type","selectMode","elements"]}},function(e,t){e.exports={type:"object",title:"checkbox",additionalProperties:!1,properties:{type:{type:"string",enum:["checkbox"],default:"checkbox",readonly:!0},text:{type:"string",maxLength:5e3},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},borderLine:{type:"boolean",default:!0},borderColor:{type:"string",format:"color",maxLength:256},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"specialAction.json#/definitions/checked"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","text","click"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"checklist",properties:{type:{type:"string",enum:["checklist"],default:"checklist",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},elements:{type:"array",minItems:2,maxItems:256,items:{$ref:"checkbox.json"}},alt:{type:"string",maxLength:2e3}},required:["type","elements"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,properties:{aspectRatio:{type:"string",enum:["rectangle","square","horizontal"]},size:{type:"string",enum:["cover","contain","large","compact","tall","full"]}}}},function(e,t){e.exports={type:"object",title:"image",additionalProperties:!1,properties:{type:{type:"string",enum:["image"],default:"image",readonly:!0},caption:{type:"string",maxLength:128},url:{type:"string",maxLength:2048},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["url"]}},function(e,t){e.exports={type:"object",title:"Key Value Pair",additionalProperties:!1,properties:{key:{type:"string",maxLength:128},value:{type:"string",maxLength:2048}},required:["key"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"keyValuePairList",properties:{type:{type:"string",enum:["keyValuePairList"],default:"keyValuePairList",readonly:!0},elements:{type:"array",minItems:1,maxItems:50,items:{$ref:"keyValuePair.json"}}},required:["type","elements"]}},function(e,t){e.exports={type:"object",title:"linkPreview",additionalProperties:!1,properties:{type:{type:"string",enum:["linkPreview"],default:"linkPreview",readonly:!0},url:{type:"string",maxLength:2048},title:{type:"string",maxLength:128},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["url"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"list",properties:{type:{type:"string",enum:["list"],default:"list",readonly:!0},tooltip:{type:"string",maxLength:256},elements:{type:"array",maxItems:3,minItems:3,items:[{$ref:"text.json"},{$ref:"sectionList.json"},{$ref:"buttonList.json"}]},alt:{type:"string",maxLength:2e3}},required:["type","elements"]}},function(e,t){e.exports={type:"object",title:"map",additionalProperties:!1,properties:{type:{type:"string",enum:["map"],default:"map",readonly:!0},lo:{type:"number"},la:{type:"number"},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["lo","la"]}},function(e,t){e.exports={oneOf:[{title:"card",$ref:"card.json"},{title:"carousel",$ref:"carousel.json"},{title:"carouselSelect",$ref:"carouselSelect.json"},{title:"accordionSelect",$ref:"accordionSelect.json"},{title:"list",$ref:"list.json"},{title:"tabs",$ref:"tabs.json"}]}},function(e,t){e.exports={title:"Schedule slot",description:"Object of an schedule slot",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["scheduleSlot"],default:"scheduleSlot",readonly:!0},id:{type:"string",maxLength:256},start:{type:"integer"},end:{type:"integer"},title:{type:"string",maxLength:40},description:{type:"string",maxLength:40},imageUrl:{type:"string",format:"uri",maxLength:1024}},required:["type","id","start"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"section",properties:{type:{type:"string",enum:["section"],default:"section",readonly:!0},tooltip:{type:"string",maxLength:256},padding:{type:"number",default:0,minimum:0,maximum:10},sectionID:{type:"string",maxLength:256},elements:{oneOf:[{type:"array",minItems:1,maxItems:1,items:[{$ref:"checklist.json"}]},{type:"array",minItems:2,maxItems:2,items:[{$ref:"text.json"},{$ref:"checklist.json"}]}]},alt:{type:"string",maxLength:2e3},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","elements","sectionID"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"sectionList",properties:{type:{type:"string",enum:["sectionList"],default:"sectionList",readonly:!0},tooltip:{type:"string",maxLength:256},elements:{type:"array",minItems:1,maxItems:256,items:{$ref:"section.json"}},alt:{type:"string",maxLength:2e3}},required:["type","elements"]}},function(e,t){e.exports={definitions:{submitAsText:{title:"Submit As Text",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["submitAsText"],default:"submitAsText",readonly:!0},submit:{type:"boolean",default:!1},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","submit"]},checked:{title:"checked",type:"object",additionalProperties:!1,properties:{type:{type:"string",enum:["checked"],default:"checked",readonly:!0},publishText:{type:"string",maxLength:250},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","publishText"]}}}},function(e,t){e.exports={type:"object",additionalProperties:!1,properties:{"background-color":{type:"string",format:"color",maxLength:256},"background-color-active":{type:"string",format:"color",maxLength:256},"background-color-hover":{type:"string",format:"color",maxLength:256},"border-color":{type:"string",format:"color",maxLength:256},"border-color-selected":{type:"string",format:"color",maxLength:256},"border-color-hover":{type:"string",format:"color",maxLength:256},"border-radius":{type:"number"},"font-family":{type:"string",format:"text",maxLength:256},bold:{type:"boolean"},italic:{type:"boolean"},color:{type:"string",format:"color",maxLength:256},"color-hover":{type:"string",format:"color",maxLength:256},"color-active":{type:"string",format:"color",maxLength:256},size:{type:"string",enum:["small","medium","large"]},fill:{type:"string",format:"color",maxLength:256}}}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"submitButton",properties:{type:{type:"string",enum:["submitButton"],default:"submitButton",readonly:!0},title:{type:"string",maxLength:128},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},disabled:{type:"boolean",default:!1},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"specialAction.json#/definitions/submitAsText"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["type","title","click"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"tabs",properties:{type:{type:"string",enum:["tabs"],default:"tabs",readonly:!0},style:{$ref:"style.json"},elements:{type:"array",minItems:1,maxItems:10,items:{$ref:"card.json"}}},required:["type","elements"]}},function(e,t){e.exports={type:"object",title:"template",additionalProperties:!1,properties:{type:{type:"string",enum:["template"],default:"template",readonly:!0},templateType:{type:"string",enum:["quickReply"],default:"quickReply",readonly:!0},title:{type:"string",maxLength:5e3},resp:{type:"array",maxItems:32,minItems:1,items:{type:"string",maxLength:128}},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["templateType","title","resp"]}},function(e,t){e.exports={type:"object",additionalProperties:!1,title:"text",properties:{type:{type:"string",enum:["text"],default:"text",readonly:!0},text:{type:"string",maxLength:5e3},rtl:{type:"boolean"},tooltip:{type:"string",maxLength:256},tag:{type:"string",maxLength:64},tagVersion:{type:"string",maxLength:64},style:{$ref:"style.json"},alt:{type:"string",maxLength:2e3},click:{type:"object",additionalProperties:!1,properties:{actions:{type:"array",maxItems:4,items:{$ref:"action.json"}},metadata:{type:"array"}}},accessibility:{type:"object",additionalProperties:!1,properties:{web:{$ref:"accessibilityWeb.json"}}}},required:["text"]}},function(e,t,r){"use strict";var a=["multipleOf","maximum","exclusiveMaximum","minimum","exclusiveMinimum","maxLength","minLength","pattern","additionalItems","maxItems","minItems","uniqueItems","maxProperties","minProperties","required","additionalProperties","enum","format","const"];e.exports=function(e,t){for(var r=0;r<t.length;r++){e=JSON.parse(JSON.stringify(e));var o,s=t[r].split("/"),n=e;for(o=1;o<s.length;o++)n=n[s[o]];for(o=0;o<a.length;o++){var i=a[o],l=n[i];l&&(n[i]={anyOf:[l,{$ref:"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#"}]})}}return e}},function(e,t,r){"use strict";function a(e){if(!(this instanceof a))return new a(e);e=this._opts=U.copy(e)||{},L(this),this._schemas={},this._refs={},this._fragments={},this._formats=R(e.format);var t=this._schemaUriFormat=this._formats["uri-reference"];this._schemaUriFormatFunc=function(e){return t.test(e)},this._cache=e.cache||new Q,this._loadingSchemas={},this._compilations=[],this.RULES=N(),this._getId=v(e),e.loopRequired=e.loopRequired||1/0,"property"==e.errorDataPath&&(e._errorDataPathProperty=!0),void 0===e.serialize&&(e.serialize=B),this._metaOpts=C(this),e.formats&&k(this),j(this),"object"==typeof e.meta&&this.addMetaSchema(e.meta),x(this),e.patternGroups&&M(this)}function o(e,t){var r;if("string"==typeof e){if(!(r=this.getSchema(e)))throw new Error('no schema with key or ref "'+e+'"')}else{var a=this._addSchema(e);r=a.validate||this._compile(a)}var o=r(t);return!0===r.$async?"*"==this._opts.async?T(o):o:(this.errors=r.errors,o)}function s(e,t){var r=this._addSchema(e,void 0,t);return r.validate||this._compile(r)}function n(e,t,r,a){if(Array.isArray(e)){for(var o=0;o<e.length;o++)this.addSchema(e[o],void 0,r,a);return this}var s=this._getId(e);if(void 0!==s&&"string"!=typeof s)throw new Error("schema id must be string");return t=D.normalizeId(t||s),P(this,t),this._schemas[t]=this._addSchema(e,r,a,!0),this}function i(e,t,r){return this.addSchema(e,t,r,!0),this}function l(e,t){var r=e.$schema;if(void 0!==r&&"string"!=typeof r)throw new Error("$schema must be a string");if(!(r=r||this._opts.defaultMeta||c(this)))return this.logger.warn("meta-schema not available"),this.errors=null,!0;var a=this._formats.uri;this._formats.uri="function"==typeof a?this._schemaUriFormatFunc:this._schemaUriFormat;var o;try{o=this.validate(r,e)}finally{this._formats.uri=a}if(!o&&t){var s="schema is invalid: "+this.errorsText();if("log"!=this._opts.validateSchema)throw new Error(s);this.logger.error(s)}return o}function c(e){var t=e._opts.meta;return e._opts.defaultMeta="object"==typeof t?e._getId(t)||t:e.getSchema(G)?G:void 0,e._opts.defaultMeta}function p(e){var t=d(this,e);switch(typeof t){case"object":return t.validate||this._compile(t);case"string":return this.getSchema(t);case"undefined":return u(this,e)}}function u(e,t){var r=D.schema.call(e,{schema:{}},t);if(r){var a=r.schema,o=r.root,s=r.baseId,n=S.call(e,a,o,void 0,s);return e._fragments[t]=new F({ref:t,fragment:!0,schema:a,root:o,baseId:s,validate:n}),n}}function d(e,t){return t=D.normalizeId(t),e._schemas[t]||e._refs[t]||e._fragments[t]}function h(e){if(e instanceof RegExp)return f(this,this._schemas,e),f(this,this._refs,e),this;switch(typeof e){case"undefined":return f(this,this._schemas),f(this,this._refs),this._cache.clear(),this;case"string":var t=d(this,e);return t&&this._cache.del(t.cacheKey),delete this._schemas[e],delete this._refs[e],this;case"object":var r=this._opts.serialize,a=r?r(e):e;this._cache.del(a);var o=this._getId(e);o&&(o=D.normalizeId(o),delete this._schemas[o],delete this._refs[o])}return this}function f(e,t,r){for(var a in t){var o=t[a];o.meta||r&&!r.test(a)||(e._cache.del(o.cacheKey),delete t[a])}}function m(e,t,r,a){if("object"!=typeof e&&"boolean"!=typeof e)throw new Error("schema should be object or boolean");var o=this._opts.serialize,s=o?o(e):e,n=this._cache.get(s);if(n)return n;a=a||!1!==this._opts.addUsedSchema;var i=D.normalizeId(this._getId(e));i&&a&&P(this,i);var l,c=!1!==this._opts.validateSchema&&!t;c&&!(l=i&&i==D.normalizeId(e.$schema))&&this.validateSchema(e,!0);var p=D.ids.call(this,e),u=new F({id:i,schema:e,localRefs:p,cacheKey:s,meta:r});return"#"!=i[0]&&a&&(this._refs[i]=u),this._cache.put(s,u),c&&l&&this.validateSchema(e,!0),u}function y(e,t){function r(){var t=e.validate,a=t.apply(null,arguments);return r.errors=t.errors,a}if(e.compiling)return e.validate=r,r.schema=e.schema,r.errors=null,r.root=t||r,!0===e.schema.$async&&(r.$async=!0),r;e.compiling=!0;var a;e.meta&&(a=this._opts,this._opts=this._metaOpts);var o;try{o=S.call(this,e.schema,t,e.localRefs)}finally{e.compiling=!1,e.meta&&(this._opts=a)}return e.validate=o,e.refs=o.refs,e.refVal=o.refVal,e.root=o.root,o}function v(e){switch(e.schemaId){case"$id":return A;case"id":return g;default:return b}}function g(e){return e.$id&&this.logger.warn("schema $id ignored",e.$id),e.id}function A(e){return e.id&&this.logger.warn("schema id ignored",e.id),e.$id}function b(e){if(e.$id&&e.id&&e.$id!=e.id)throw new Error("schema $id is different from id");return e.$id||e.id}function w(e,t){if(!(e=e||this.errors))return"No errors";t=t||{};for(var r=void 0===t.separator?", ":t.separator,a=void 0===t.dataVar?"data":t.dataVar,o="",s=0;s<e.length;s++){var n=e[s];n&&(o+=a+n.dataPath+" "+n.message+r)}return o.slice(0,-r.length)}function E(e,t){return"string"==typeof t&&(t=new RegExp(t)),this._formats[e]=t,this}function j(e){var t;if(e._opts.$data&&(t=r(74),e.addMetaSchema(t,t.$id,!0)),!1!==e._opts.meta){var a=r(75);e._opts.$data&&(a=O(a,q)),e.addMetaSchema(a,G,!0),e._refs["http://json-schema.org/schema"]=G}}function x(e){var t=e._opts.schemas;if(t)if(Array.isArray(t))e.addSchema(t);else for(var r in t)e.addSchema(t[r],r)}function k(e){for(var t in e._opts.formats){var r=e._opts.formats[t];e.addFormat(t,r)}}function P(e,t){if(e._schemas[t]||e._refs[t])throw new Error('schema with key or id "'+t+'" already exists')}function C(e){for(var t=U.copy(e._opts),r=0;r<Y.length;r++)delete t[Y[r]];return t}function L(e){var t=e._opts.logger;if(!1===t)e.logger={log:I,warn:I,error:I};else{if(void 0===t&&(t=console),!("object"==typeof t&&t.log&&t.warn&&t.error))throw new Error("logger must implement log, warn and error methods");e.logger=t}}function I(){}var S=r(51),D=r(2),Q=r(47),F=r(4),B=r(13),R=r(50),N=r(52),O=r(45),M=r(73),U=r(0),T=r(12);e.exports=a,a.prototype.validate=o,a.prototype.compile=s,a.prototype.addSchema=n,a.prototype.addMetaSchema=i,a.prototype.validateSchema=l,a.prototype.getSchema=p,a.prototype.removeSchema=h,a.prototype.addFormat=E,a.prototype.errorsText=w,a.prototype._addSchema=m,a.prototype._compile=y,a.prototype.compileAsync=r(49);var z=r(72);a.prototype.addKeyword=z.add,a.prototype.getKeyword=z.get,a.prototype.removeKeyword=z.remove;var H=r(1);a.ValidationError=H.Validation,a.MissingRefError=H.MissingRef,a.$dataMetaSchema=O;var G="http://json-schema.org/draft-06/schema",Y=["removeAdditional","useDefaults","coerceTypes"],q=["/properties"]},function(e,t,r){"use strict";var a=e.exports=function(){this._cache={}};a.prototype.put=function(e,t){this._cache[e]=t},a.prototype.get=function(e){return this._cache[e]},a.prototype.del=function(e){delete this._cache[e]},a.prototype.clear=function(){this._cache={}}},function(e,t,r){"use strict";e.exports={$ref:r(69),allOf:r(54),anyOf:r(55),const:r(56),contains:r(57),dependencies:r(59),enum:r(60),format:r(61),items:r(62),maximum:r(5),minimum:r(5),maxItems:r(6),minItems:r(6),maxLength:r(7),minLength:r(7),maxProperties:r(8),minProperties:r(8),multipleOf:r(63),not:r(64),oneOf:r(65),pattern:r(66),properties:r(67),propertyNames:r(68),required:r(70),uniqueItems:r(71),validate:r(9)}},function(e,t,r){"use strict";function a(e,t,r){function s(e){var t=e.$schema;return t&&!i.getSchema(t)?a.call(i,{$ref:t},!0):Promise.resolve()}function n(e){try{return i._compile(e)}catch(r){if(r instanceof o)return function(r){function a(){delete i._loadingSchemas[l]}function o(e){return i._refs[e]||i._schemas[e]}var l=r.missingSchema;if(o(l))throw new Error("Schema "+l+" is loaded but "+r.missingRef+" cannot be resolved");var c=i._loadingSchemas[l];return c||(c=i._loadingSchemas[l]=i._opts.loadSchema(l),c.then(a,a)),c.then(function(e){if(!o(l))return s(e).then(function(){o(l)||i.addSchema(e,l,void 0,t)})}).then(function(){return n(e)})}(r);throw r}}var i=this;if("function"!=typeof this._opts.loadSchema)throw new Error("options.loadSchema should be a function");"function"==typeof t&&(r=t,t=void 0);var l=s(e).then(function(){var r=i._addSchema(e,void 0,t);return r.validate||n(r)});return r&&l.then(function(e){r(null,e)},r),l}var o=r(1).MissingRef;e.exports=a},function(e,t,r){"use strict";function a(e){return e="full"==e?"full":"fast",p.copy(a[e])}function o(e){var t=e.match(u);if(!t)return!1;var r=+t[1],a=+t[2];return r>=1&&r<=12&&a>=1&&a<=d[r]}function s(e,t){var r=e.match(h);if(!r)return!1;var a=r[1],o=r[2],s=r[3],n=r[5];return a<=23&&o<=59&&s<=59&&(!t||n)}function n(e){var t=e.split(E);return 2==t.length&&o(t[0])&&s(t[1],!0)}function i(e){return e.length<=255&&f.test(e)}function l(e){return j.test(e)&&m.test(e)}function c(e){if(x.test(e))return!1;try{return new RegExp(e),!0}catch(e){return!1}}var p=r(0),u=/^\d\d\d\d-(\d\d)-(\d\d)$/,d=[0,31,29,31,30,31,30,31,31,30,31,30,31],h=/^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i,f=/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i,m=/^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,y=/^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,v=/^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,g=/^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,A=/^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,b=/^(?:\/(?:[^~/]|~0|~1)*)*$|^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,w=/^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;e.exports=a,a.fast={date:/^\d\d\d\d-[0-1]\d-[0-3]\d$/,time:/^[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i,"date-time":/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s][0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i,uri:/^(?:[a-z][a-z0-9+-.]*)(?::|\/)\/?[^\s]*$/i,"uri-reference":/^(?:(?:[a-z][a-z0-9+-.]*:)?\/\/)?[^\s]*$/i,"uri-template":v,url:g,email:/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,hostname:f,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:c,uuid:A,"json-pointer":b,"relative-json-pointer":w},a.full={date:o,time:s,"date-time":n,uri:l,"uri-reference":y,"uri-template":v,url:g,email:/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,hostname:i,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:c,uuid:A,"json-pointer":b,"relative-json-pointer":w};var E=/t|\s/i,j=/\/|:/,x=/[^\\]\\Z/},function(e,t,r){"use strict";function a(e,t,r,n){function w(){var e=z.validate,t=e.apply(null,arguments);return w.errors=e.errors,t}function E(e,r,o,s){var n=!r||r&&r.schema==e;if(r.schema!=t.schema)return a.call(D,e,r,o,s);var m=!0===e.$async,w=y({isTop:!0,schema:e,isRoot:n,baseId:s,root:r,schemaPath:"",errSchemaPath:"#",errorPath:'""',MissingRefError:f.MissingRef,RULES:G,validate:y,util:h,resolve:d,resolveRef:j,usePattern:L,useDefault:I,useCustomRule:S,opts:Q,formats:H,logger:D.logger,self:D});w=u(F,c)+u(R,i)+u(O,l)+u(U,p)+w,Q.processCode&&(w=Q.processCode(w));var E;try{E=new Function("self","RULES","formats","root","refVal","defaults","customRules","co","equal","ucs2length","ValidationError",w)(D,G,H,t,F,O,U,v,A,g,b),F[0]=E}catch(e){throw D.logger.error("Error compiling schema, function code:",w),e}return E.schema=e,E.errors=null,E.refs=B,E.refVal=F,E.root=n?E:r,m&&(E.$async=!0),!0===Q.sourceCode&&(E.source={code:w,patterns:R,defaults:O}),E}function j(e,o,s){o=d.url(e,o);var n,i,l=B[o];if(void 0!==l)return n=F[l],i="refVal["+l+"]",C(n,i);if(!s&&t.refs){var c=t.refs[o];if(void 0!==c)return n=t.refVal[c],i=x(o,n),C(n,i)}i=x(o);var p=d.call(D,E,t,o);if(void 0===p){var u=r&&r[o];u&&(p=d.inlineRef(u,Q.inlineRefs)?u:a.call(D,u,t,r,e))}if(void 0!==p)return P(o,p),C(p,i);k(o)}function x(e,t){var r=F.length;return F[r]=t,B[e]=r,"refVal"+r}function k(e){delete B[e]}function P(e,t){var r=B[e];F[r]=t}function C(e,t){return"object"==typeof e||"boolean"==typeof e?{code:t,schema:e,inline:!0}:{code:t,$async:e&&e.$async}}function L(e){var t=N[e];return void 0===t&&(t=N[e]=R.length,R[t]=e),"pattern"+t}function I(e){switch(typeof e){case"boolean":case"number":return""+e;case"string":return h.toQuotedString(e);case"object":if(null===e)return"null";var t=m(e),r=M[t];return void 0===r&&(r=M[t]=O.length,O[r]=e),"default"+r}}function S(e,t,r,a){var o=e.definition.validateSchema;if(o&&!1!==D._opts.validateSchema){if(!o(t)){var s="keyword schema is invalid: "+D.errorsText(o.errors);if("log"!=D._opts.validateSchema)throw new Error(s);D.logger.error(s)}}var n,i=e.definition.compile,l=e.definition.inline,c=e.definition.macro;if(i)n=i.call(D,t,r,a);else if(c)n=c.call(D,t,r,a),!1!==Q.validateSchema&&D.validateSchema(n,!0);else if(l)n=l.call(D,a,e.keyword,t,r);else if(!(n=e.definition.validate))return;if(void 0===n)throw new Error('custom keyword "'+e.keyword+'"failed to compile');var p=U.length;return U[p]=n,{code:"customRule"+p,validate:n}}var D=this,Q=this._opts,F=[void 0],B={},R=[],N={},O=[],M={},U=[];t=t||{schema:e,refVal:F,refs:B};var T=o.call(this,e,t,n),z=this._compilations[T.index];if(T.compiling)return z.callValidate=w;var H=this._formats,G=this.RULES;try{var Y=E(e,t,r,n);z.validate=Y;var q=z.callValidate;return q&&(q.schema=Y.schema,q.errors=null,q.refs=Y.refs,q.refVal=Y.refVal,q.root=Y.root,q.$async=Y.$async,Q.sourceCode&&(q.source=Y.source)),Y}finally{s.call(this,e,t,n)}}function o(e,t,r){var a=n.call(this,e,t,r);return a>=0?{index:a,compiling:!0}:(a=this._compilations.length,this._compilations[a]={schema:e,root:t,baseId:r},{index:a,compiling:!1})}function s(e,t,r){var a=n.call(this,e,t,r);a>=0&&this._compilations.splice(a,1)}function n(e,t,r){for(var a=0;a<this._compilations.length;a++){var o=this._compilations[a];if(o.schema==e&&o.root==t&&o.baseId==r)return a}return-1}function i(e,t){return"var pattern"+e+" = new RegExp("+h.toQuotedString(t[e])+");"}function l(e){return"var default"+e+" = defaults["+e+"];"}function c(e,t){return void 0===t[e]?"":"var refVal"+e+" = refVal["+e+"];"}function p(e){return"var customRule"+e+" = customRules["+e+"];"}function u(e,t){if(!e.length)return"";for(var r="",a=0;a<e.length;a++)r+=t(a,e);return r}var d=r(2),h=r(0),f=r(1),m=r(13),y=r(9),v=r(12),g=h.ucs2length,A=r(3),b=f.Validation;e.exports=a},function(e,t,r){"use strict";var a=r(48),o=r(0).toHash;e.exports=function(){var e=[{type:"number",rules:[{maximum:["exclusiveMaximum"]},{minimum:["exclusiveMinimum"]},"multipleOf","format"]},{type:"string",rules:["maxLength","minLength","pattern","format"]},{type:"array",rules:["maxItems","minItems","uniqueItems","contains","items"]},{type:"object",rules:["maxProperties","minProperties","required","dependencies","propertyNames",{properties:["additionalProperties","patternProperties"]}]},{rules:["$ref","const","enum","not","anyOf","oneOf","allOf"]}],t=["type"],r=["additionalItems","$schema","$id","id","title","description","default","definitions"],s=["number","integer","string","array","object","boolean","null"];return e.all=o(t),e.types=o(s),e.forEach(function(r){r.rules=r.rules.map(function(r){var o;if("object"==typeof r){var s=Object.keys(r)[0];o=r[s],r=s,o.forEach(function(r){t.push(r),e.all[r]=!0})}return t.push(r),e.all[r]={keyword:r,code:a[r],implements:o}}),r.type&&(e.types[r.type]=r)}),e.keywords=o(t.concat(r)),e.custom={},e}},function(e,t,r){"use strict";e.exports=function(e){for(var t,r=0,a=e.length,o=0;o<a;)r++,(t=e.charCodeAt(o++))>=55296&&t<=56319&&o<a&&56320==(64512&(t=e.charCodeAt(o)))&&o++;return r}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),n=e.errSchemaPath+"/"+t,i=!e.opts.allErrors,l=e.util.copy(e),c="";l.level++;var p="valid"+l.level,u=l.baseId,d=!0,h=o;if(h)for(var f,m=-1,y=h.length-1;m<y;)f=h[m+=1],e.util.schemaHasRules(f,e.RULES.all)&&(d=!1,l.schema=f,l.schemaPath=s+"["+m+"]",l.errSchemaPath=n+"/"+m,a+="  "+e.validate(l)+" ",l.baseId=u,i&&(a+=" if ("+p+") { ",c+="}"));return i&&(a+=d?" if (true) { ":" "+c.slice(0,-1)+" "),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d="errs__"+o,h=e.util.copy(e),f="";h.level++;var m="valid"+h.level;if(n.every(function(t){return e.util.schemaHasRules(t,e.RULES.all)})){var y=h.baseId;a+=" var "+d+" = errors; var "+u+" = false;  ";var v=e.compositeRule;e.compositeRule=h.compositeRule=!0;var g=n;if(g)for(var A,b=-1,w=g.length-1;b<w;)A=g[b+=1],h.schema=A,h.schemaPath=i+"["+b+"]",h.errSchemaPath=l+"/"+b,a+="  "+e.validate(h)+" ",h.baseId=y,a+=" "+u+" = "+u+" || "+m+"; if (!"+u+") { ",f+="}";e.compositeRule=h.compositeRule=v,a+=" "+f+" if (!"+u+") {   var err =   ",!1!==e.createErrors?(a+=" { keyword: 'anyOf' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should match some schema in anyOf' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&c&&(e.async?a+=" throw new ValidationError(vErrors); ":a+=" validate.errors = vErrors; return false; "),a+=" } else {  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; } ",e.opts.allErrors&&(a+=" } "),a=e.util.cleanUpCode(a)}else c&&(a+=" if (true) { ");return a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d=e.opts.$data&&n&&n.$data;d&&(a+=" var schema"+o+" = "+e.util.getData(n.$data,s,e.dataPathArr)+"; "),d||(a+=" var schema"+o+" = validate.schema"+i+";"),a+="var "+u+" = equal("+p+", schema"+o+"); if (!"+u+") {   ";var h=h||[];h.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'const' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should be equal to constant' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var f=a;return a=h.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+f+"]); ":a+=" validate.errors = ["+f+"]; return false; ":a+=" var err = "+f+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" }",c&&(a+=" else { "),a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d="errs__"+o,h=e.util.copy(e);h.level++;var f="valid"+h.level,m="i"+o,y=h.dataLevel=e.dataLevel+1,v="data"+y,g=e.baseId,A=e.util.schemaHasRules(n,e.RULES.all);if(a+="var "+d+" = errors;var "+u+";",A){var b=e.compositeRule;e.compositeRule=h.compositeRule=!0,h.schema=n,h.schemaPath=i,h.errSchemaPath=l,a+=" var "+f+" = false; for (var "+m+" = 0; "+m+" < "+p+".length; "+m+"++) { ",h.errorPath=e.util.getPathExpr(e.errorPath,m,e.opts.jsonPointers,!0);var w=p+"["+m+"]";h.dataPathArr[y]=m;var E=e.validate(h);h.baseId=g,e.util.varOccurences(E,v)<2?a+=" "+e.util.varReplace(E,v,w)+" ":a+=" var "+v+" = "+w+"; "+E+" ",a+=" if ("+f+") break; }  ",e.compositeRule=h.compositeRule=b,a+="  if (!"+f+") {"}else a+=" if ("+p+".length == 0) {";var j=j||[];j.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'contains' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should contain a valid item' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var x=a;return a=j.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+x+"]); ":a+=" validate.errors = ["+x+"]; return false; ":a+=" var err = "+x+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } else { ",A&&(a+="  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; } "),e.opts.allErrors&&(a+=" } "),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,u=!e.opts.allErrors,d="data"+(i||""),h="valid"+n,f="errs__"+n,m=e.opts.$data&&l&&l.$data;m?(s+=" var schema"+n+" = "+e.util.getData(l.$data,i,e.dataPathArr)+"; ",o="schema"+n):o=l;var y,v,g,A,b,w=this,E="definition"+n,j=w.definition,x="";if(m&&j.$data){b="keywordValidate"+n;var k=j.validateSchema;s+=" var "+E+" = RULES.custom['"+t+"'].definition; var "+b+" = "+E+".validate;"}else{if(!(A=e.useCustomRule(w,l,e.schema,e)))return;o="validate.schema"+c,b=A.code,y=j.compile,v=j.inline,g=j.macro}var P=b+".errors",C="i"+n,L="ruleErr"+n,I=j.async;if(I&&!e.async)throw new Error("async keyword in sync schema");if(v||g||(s+=P+" = null;"),s+="var "+f+" = errors;var "+h+";",m&&j.$data&&(x+="}",s+=" if ("+o+" === undefined) { "+h+" = true; } else { ",k&&(x+="}",s+=" "+h+" = "+E+".validateSchema("+o+"); if ("+h+") { ")),v)j.statements?s+=" "+A.validate+" ":s+=" "+h+" = "+A.validate+"; ";else if(g){var S=e.util.copy(e),x="";S.level++;var D="valid"+S.level;S.schema=A.validate,S.schemaPath="";var Q=e.compositeRule;e.compositeRule=S.compositeRule=!0;var F=e.validate(S).replace(/validate\.schema/g,b);e.compositeRule=S.compositeRule=Q,s+=" "+F}else{var B=B||[];B.push(s),s="",s+="  "+b+".call( ",e.opts.passContext?s+="this":s+="self",y||!1===j.schema?s+=" , "+d+" ":s+=" , "+o+" , "+d+" , validate.schema"+e.schemaPath+" ",s+=" , (dataPath || '')",'""'!=e.errorPath&&(s+=" + "+e.errorPath);var R=i?"data"+(i-1||""):"parentData",N=i?e.dataPathArr[i]:"parentDataProperty";s+=" , "+R+" , "+N+" , rootData )  ";var O=s;s=B.pop(),!1===j.errors?(s+=" "+h+" = ",I&&(s+=""+e.yieldAwait),s+=O+"; "):I?(P="customErrors"+n,s+=" var "+P+" = null; try { "+h+" = "+e.yieldAwait+O+"; } catch (e) { "+h+" = false; if (e instanceof ValidationError) "+P+" = e.errors; else throw e; } "):s+=" "+P+" = null; "+h+" = "+O+"; "}if(j.modifying&&(s+=" if ("+R+") "+d+" = "+R+"["+N+"];"),s+=""+x,j.valid)u&&(s+=" if (true) { ");else{s+=" if ( ",void 0===j.valid?(s+=" !",s+=g?""+D:""+h):s+=" "+!j.valid+" ",s+=") { ",a=w.keyword;var B=B||[];B.push(s),s="";var B=B||[];B.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '"+(a||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { keyword: '"+w.keyword+"' } ",!1!==e.opts.messages&&(s+=" , message: 'should pass \""+w.keyword+"\" keyword validation' "),e.opts.verbose&&(s+=" , schema: validate.schema"+c+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ";var M=s;s=B.pop(),!e.compositeRule&&u?e.async?s+=" throw new ValidationError(["+M+"]); ":s+=" validate.errors = ["+M+"]; return false; ":s+=" var err = "+M+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";var U=s;s=B.pop(),v?j.errors?"full"!=j.errors&&(s+="  for (var "+C+"="+f+"; "+C+"<errors; "+C+"++) { var "+L+" = vErrors["+C+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+"; if ("+L+".schemaPath === undefined) { "+L+'.schemaPath = "'+p+'"; } ',e.opts.verbose&&(s+=" "+L+".schema = "+o+"; "+L+".data = "+d+"; "),s+=" } "):!1===j.errors?s+=" "+U+" ":(s+=" if ("+f+" == errors) { "+U+" } else {  for (var "+C+"="+f+"; "+C+"<errors; "+C+"++) { var "+L+" = vErrors["+C+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+"; if ("+L+".schemaPath === undefined) { "+L+'.schemaPath = "'+p+'"; } ',e.opts.verbose&&(s+=" "+L+".schema = "+o+"; "+L+".data = "+d+"; "),s+=" } } "):g?(s+="   var err =   ",!1!==e.createErrors?(s+=" { keyword: '"+(a||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { keyword: '"+w.keyword+"' } ",!1!==e.opts.messages&&(s+=" , message: 'should pass \""+w.keyword+"\" keyword validation' "),e.opts.verbose&&(s+=" , schema: validate.schema"+c+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+d+" "),s+=" } "):s+=" {} ",s+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&u&&(e.async?s+=" throw new ValidationError(vErrors); ":s+=" validate.errors = vErrors; return false; ")):!1===j.errors?s+=" "+U+" ":(s+=" if (Array.isArray("+P+")) { if (vErrors === null) vErrors = "+P+"; else vErrors = vErrors.concat("+P+"); errors = vErrors.length;  for (var "+C+"="+f+"; "+C+"<errors; "+C+"++) { var "+L+" = vErrors["+C+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+";  "+L+'.schemaPath = "'+p+'";  ',e.opts.verbose&&(s+=" "+L+".schema = "+o+"; "+L+".data = "+d+"; "),s+=" } } else { "+U+" } "),s+=" } ",u&&(s+=" else { ")}return s}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="errs__"+o,d=e.util.copy(e),h="";d.level++;var f="valid"+d.level,m={},y={},v=e.opts.ownProperties;for(w in n){var g=n[w],A=Array.isArray(g)?y:m;A[w]=g}a+="var "+u+" = errors;";var b=e.errorPath;a+="var missing"+o+";";for(var w in y)if(A=y[w],A.length){if(a+=" if ( "+p+e.util.getProperty(w)+" !== undefined ",v&&(a+=" && Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(w)+"') "),c){a+=" && ( ";var E=A;if(E)for(var j,x=-1,k=E.length-1;x<k;){j=E[x+=1],x&&(a+=" || ");var P=e.util.getProperty(j),C=p+P;a+=" ( ( "+C+" === undefined ",v&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(j)+"') "),a+=") && (missing"+o+" = "+e.util.toQuotedString(e.opts.jsonPointers?j:P)+") ) "}a+=")) {  ";var L="missing"+o,I="' + "+L+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(b,L,!0):b+" + "+L);var S=S||[];S.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'dependencies' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { property: '"+e.util.escapeQuotes(w)+"', missingProperty: '"+I+"', depsCount: "+A.length+", deps: '"+e.util.escapeQuotes(1==A.length?A[0]:A.join(", "))+"' } ",!1!==e.opts.messages&&(a+=" , message: 'should have ",1==A.length?a+="property "+e.util.escapeQuotes(A[0]):a+="properties "+e.util.escapeQuotes(A.join(", ")),a+=" when property "+e.util.escapeQuotes(w)+" is present' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var D=a;a=S.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+D+"]); ":a+=" validate.errors = ["+D+"]; return false; ":a+=" var err = "+D+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "}else{a+=" ) { ";var Q=A;if(Q)for(var j,F=-1,B=Q.length-1;F<B;){j=Q[F+=1];var P=e.util.getProperty(j),I=e.util.escapeQuotes(j),C=p+P;e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(b,j,e.opts.jsonPointers)),a+=" if ( "+C+" === undefined ",v&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(j)+"') "),a+=") {  var err =   ",!1!==e.createErrors?(a+=" { keyword: 'dependencies' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { property: '"+e.util.escapeQuotes(w)+"', missingProperty: '"+I+"', depsCount: "+A.length+", deps: '"+e.util.escapeQuotes(1==A.length?A[0]:A.join(", "))+"' } ",!1!==e.opts.messages&&(a+=" , message: 'should have ",1==A.length?a+="property "+e.util.escapeQuotes(A[0]):a+="properties "+e.util.escapeQuotes(A.join(", ")),a+=" when property "+e.util.escapeQuotes(w)+" is present' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } "}}a+=" }   ",c&&(h+="}",a+=" else { ")}e.errorPath=b;var R=d.baseId;for(var w in m){var g=m[w];e.util.schemaHasRules(g,e.RULES.all)&&(a+=" "+f+" = true; if ( "+p+e.util.getProperty(w)+" !== undefined ",v&&(a+=" && Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(w)+"') "),a+=") { ",d.schema=g,d.schemaPath=i+e.util.getProperty(w),d.errSchemaPath=l+"/"+e.util.escapeFragment(w),a+="  "+e.validate(d)+" ",d.baseId=R,a+=" }  ",c&&(a+=" if ("+f+") { ",h+="}"))}return c&&(a+="   "+h+" if ("+u+" == errors) {"),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d=e.opts.$data&&n&&n.$data;d&&(a+=" var schema"+o+" = "+e.util.getData(n.$data,s,e.dataPathArr)+"; ");var h="i"+o,f="schema"+o;d||(a+=" var "+f+" = validate.schema"+i+";"),a+="var "+u+";",d&&(a+=" if (schema"+o+" === undefined) "+u+" = true; else if (!Array.isArray(schema"+o+")) "+u+" = false; else {"),a+=u+" = false;for (var "+h+"=0; "+h+"<"+f+".length; "+h+"++) if (equal("+p+", "+f+"["+h+"])) { "+u+" = true; break; }",d&&(a+="  }  "),a+=" if (!"+u+") {   ";var m=m||[];m.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'enum' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { allowedValues: schema"+o+" } ",!1!==e.opts.messages&&(a+=" , message: 'should be equal to one of the allowed values' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var y=a;return a=m.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+y+"]); ":a+=" validate.errors = ["+y+"]; return false; ":a+=" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" }",c&&(a+=" else { "),a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||"");if(!1===e.opts.format)return c&&(a+=" if (true) { "),a;var u,d=e.opts.$data&&n&&n.$data;d?(a+=" var schema"+o+" = "+e.util.getData(n.$data,s,e.dataPathArr)+"; ",u="schema"+o):u=n;var h=e.opts.unknownFormats,f=Array.isArray(h);if(d){var m="format"+o,y="isObject"+o,v="formatType"+o;a+=" var "+m+" = formats["+u+"]; var "+y+" = typeof "+m+" == 'object' && !("+m+" instanceof RegExp) && "+m+".validate; var "+v+" = "+y+" && "+m+".type || 'string'; if ("+y+") { ",e.async&&(a+=" var async"+o+" = "+m+".async; "),a+=" "+m+" = "+m+".validate; } if (  ",d&&(a+=" ("+u+" !== undefined && typeof "+u+" != 'string') || "),a+=" (","ignore"!=h&&(a+=" ("+u+" && !"+m+" ",f&&(a+=" && self._opts.unknownFormats.indexOf("+u+") == -1 "),a+=") || "),a+=" ("+m+" && "+v+" == '"+r+"' && !(typeof "+m+" == 'function' ? ",e.async?a+=" (async"+o+" ? "+e.yieldAwait+" "+m+"("+p+") : "+m+"("+p+")) ":a+=" "+m+"("+p+") ",a+=" : "+m+".test("+p+"))))) {"}else{var m=e.formats[n];if(!m){if("ignore"==h)return e.logger.warn('unknown format "'+n+'" ignored in schema at path "'+e.errSchemaPath+'"'),c&&(a+=" if (true) { "),a;if(f&&h.indexOf(n)>=0)return c&&(a+=" if (true) { "),a;throw new Error('unknown format "'+n+'" is used in schema at path "'+e.errSchemaPath+'"')}var y="object"==typeof m&&!(m instanceof RegExp)&&m.validate,v=y&&m.type||"string";if(y){var g=!0===m.async;m=m.validate}if(v!=r)return c&&(a+=" if (true) { "),a;if(g){if(!e.async)throw new Error("async format in sync schema");var A="formats"+e.util.getProperty(n)+".validate";a+=" if (!("+e.yieldAwait+" "+A+"("+p+"))) { "}else{a+=" if (! ";var A="formats"+e.util.getProperty(n);y&&(A+=".validate"),a+="function"==typeof m?" "+A+"("+p+") ":" "+A+".test("+p+") ",a+=") { "}}var b=b||[];b.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'format' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { format:  ",a+=d?""+u:""+e.util.toQuotedString(n),a+="  } ",!1!==e.opts.messages&&(a+=" , message: 'should match format \"",a+=d?"' + "+u+" + '":""+e.util.escapeQuotes(n),a+="\"' "),e.opts.verbose&&(a+=" , schema:  ",a+=d?"validate.schema"+i:""+e.util.toQuotedString(n),a+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var w=a;return a=b.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+w+"]); ":a+=" validate.errors = ["+w+"]; return false; ":a+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } ",c&&(a+=" else { "),a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d="errs__"+o,h=e.util.copy(e),f="";h.level++;var m="valid"+h.level,y="i"+o,v=h.dataLevel=e.dataLevel+1,g="data"+v,A=e.baseId;if(a+="var "+d+" = errors;var "+u+";",Array.isArray(n)){var b=e.schema.additionalItems;if(!1===b){a+=" "+u+" = "+p+".length <= "+n.length+"; ";var w=l;l=e.errSchemaPath+"/additionalItems",a+="  if (!"+u+") {   ";var E=E||[];E.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'additionalItems' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { limit: "+n.length+" } ",!1!==e.opts.messages&&(a+=" , message: 'should NOT have more than "+n.length+" items' "),e.opts.verbose&&(a+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var j=a;a=E.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+j+"]); ":a+=" validate.errors = ["+j+"]; return false; ":a+=" var err = "+j+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } ",l=w,c&&(f+="}",a+=" else { ")}var x=n;if(x)for(var k,P=-1,C=x.length-1;P<C;)if(k=x[P+=1],e.util.schemaHasRules(k,e.RULES.all)){a+=" "+m+" = true; if ("+p+".length > "+P+") { ";var L=p+"["+P+"]";h.schema=k,h.schemaPath=i+"["+P+"]",h.errSchemaPath=l+"/"+P,h.errorPath=e.util.getPathExpr(e.errorPath,P,e.opts.jsonPointers,!0),h.dataPathArr[v]=P;var I=e.validate(h);h.baseId=A,e.util.varOccurences(I,g)<2?a+=" "+e.util.varReplace(I,g,L)+" ":a+=" var "+g+" = "+L+"; "+I+" ",a+=" }  ",c&&(a+=" if ("+m+") { ",f+="}")}if("object"==typeof b&&e.util.schemaHasRules(b,e.RULES.all)){h.schema=b,h.schemaPath=e.schemaPath+".additionalItems",h.errSchemaPath=e.errSchemaPath+"/additionalItems",a+=" "+m+" = true; if ("+p+".length > "+n.length+") {  for (var "+y+" = "+n.length+"; "+y+" < "+p+".length; "+y+"++) { ",h.errorPath=e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers,!0);var L=p+"["+y+"]";h.dataPathArr[v]=y;var I=e.validate(h);h.baseId=A,e.util.varOccurences(I,g)<2?a+=" "+e.util.varReplace(I,g,L)+" ":a+=" var "+g+" = "+L+"; "+I+" ",c&&(a+=" if (!"+m+") break; "),a+=" } }  ",c&&(a+=" if ("+m+") { ",f+="}")}}else if(e.util.schemaHasRules(n,e.RULES.all)){h.schema=n,h.schemaPath=i,h.errSchemaPath=l,a+="  for (var "+y+" = 0; "+y+" < "+p+".length; "+y+"++) { ",h.errorPath=e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers,!0);var L=p+"["+y+"]";h.dataPathArr[v]=y;var I=e.validate(h);h.baseId=A,e.util.varOccurences(I,g)<2?a+=" "+e.util.varReplace(I,g,L)+" ":a+=" var "+g+" = "+L+"; "+I+" ",c&&(a+=" if (!"+m+") break; "),a+=" }"}return c&&(a+=" "+f+" if ("+d+" == errors) {"),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o=" ",s=e.level,n=e.dataLevel,i=e.schema[t],l=e.schemaPath+e.util.getProperty(t),c=e.errSchemaPath+"/"+t,p=!e.opts.allErrors,u="data"+(n||""),d=e.opts.$data&&i&&i.$data;d?(o+=" var schema"+s+" = "+e.util.getData(i.$data,n,e.dataPathArr)+"; ",a="schema"+s):a=i,o+="var division"+s+";if (",d&&(o+=" "+a+" !== undefined && ( typeof "+a+" != 'number' || "),o+=" (division"+s+" = "+u+" / "+a+", ",e.opts.multipleOfPrecision?o+=" Math.abs(Math.round(division"+s+") - division"+s+") > 1e-"+e.opts.multipleOfPrecision+" ":o+=" division"+s+" !== parseInt(division"+s+") ",o+=" ) ",d&&(o+="  )  "),o+=" ) {   ";var h=h||[];h.push(o),o="",!1!==e.createErrors?(o+=" { keyword: 'multipleOf' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(c)+" , params: { multipleOf: "+a+" } ",!1!==e.opts.messages&&(o+=" , message: 'should be multiple of ",o+=d?"' + "+a:a+"'"),e.opts.verbose&&(o+=" , schema:  ",o+=d?"validate.schema"+l:""+i,o+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+u+" "),o+=" } "):o+=" {} ";var f=o;return o=h.pop(),!e.compositeRule&&p?e.async?o+=" throw new ValidationError(["+f+"]); ":o+=" validate.errors = ["+f+"]; return false; ":o+=" var err = "+f+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",o+="} ",p&&(o+=" else { "),o}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="errs__"+o,d=e.util.copy(e);d.level++;var h="valid"+d.level;if(e.util.schemaHasRules(n,e.RULES.all)){d.schema=n,d.schemaPath=i,d.errSchemaPath=l,a+=" var "+u+" = errors;  ";var f=e.compositeRule;e.compositeRule=d.compositeRule=!0,d.createErrors=!1;var m;d.opts.allErrors&&(m=d.opts.allErrors,d.opts.allErrors=!1),a+=" "+e.validate(d)+" ",d.createErrors=!0,m&&(d.opts.allErrors=m),e.compositeRule=d.compositeRule=f,a+=" if ("+h+") {   ";var y=y||[];y.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'not' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should NOT be valid' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var v=a;a=y.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+v+"]); ":a+=" validate.errors = ["+v+"]; return false; ":a+=" var err = "+v+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } else {  errors = "+u+"; if (vErrors !== null) { if ("+u+") vErrors.length = "+u+"; else vErrors = null; } ",e.opts.allErrors&&(a+=" } ")}else a+="  var err =   ",!1!==e.createErrors?(a+=" { keyword: 'not' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should NOT be valid' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",c&&(a+=" if (false) { ");return a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d="errs__"+o,h=e.util.copy(e),f="";h.level++;var m="valid"+h.level;a+="var "+d+" = errors;var prevValid"+o+" = false;var "+u+" = false;";var y=h.baseId,v=e.compositeRule;e.compositeRule=h.compositeRule=!0;var g=n;if(g)for(var A,b=-1,w=g.length-1;b<w;)A=g[b+=1],e.util.schemaHasRules(A,e.RULES.all)?(h.schema=A,h.schemaPath=i+"["+b+"]",h.errSchemaPath=l+"/"+b,a+="  "+e.validate(h)+" ",h.baseId=y):a+=" var "+m+" = true; ",b&&(a+=" if ("+m+" && prevValid"+o+") "+u+" = false; else { ",f+="}"),a+=" if ("+m+") "+u+" = prevValid"+o+" = true;";return e.compositeRule=h.compositeRule=v,a+=f+"if (!"+u+") {   var err =   ",!1!==e.createErrors?(a+=" { keyword: 'oneOf' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: {} ",!1!==e.opts.messages&&(a+=" , message: 'should match exactly one schema in oneOf' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&c&&(e.async?a+=" throw new ValidationError(vErrors); ":a+=" validate.errors = vErrors; return false; "),a+="} else {  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; }",e.opts.allErrors&&(a+=" } "),a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o=" ",s=e.level,n=e.dataLevel,i=e.schema[t],l=e.schemaPath+e.util.getProperty(t),c=e.errSchemaPath+"/"+t,p=!e.opts.allErrors,u="data"+(n||""),d=e.opts.$data&&i&&i.$data;d?(o+=" var schema"+s+" = "+e.util.getData(i.$data,n,e.dataPathArr)+"; ",a="schema"+s):a=i;var h=d?"(new RegExp("+a+"))":e.usePattern(i);o+="if ( ",d&&(o+=" ("+a+" !== undefined && typeof "+a+" != 'string') || "),o+=" !"+h+".test("+u+") ) {   ";var f=f||[];f.push(o),o="",!1!==e.createErrors?(o+=" { keyword: 'pattern' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(c)+" , params: { pattern:  ",o+=d?""+a:""+e.util.toQuotedString(i),o+="  } ",!1!==e.opts.messages&&(o+=" , message: 'should match pattern \"",o+=d?"' + "+a+" + '":""+e.util.escapeQuotes(i),o+="\"' "),e.opts.verbose&&(o+=" , schema:  ",o+=d?"validate.schema"+l:""+e.util.toQuotedString(i),o+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+u+" "),o+=" } "):o+=" {} ";var m=o;return o=f.pop(),!e.compositeRule&&p?e.async?o+=" throw new ValidationError(["+m+"]); ":o+=" validate.errors = ["+m+"]; return false; ":o+=" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",o+="} ",p&&(o+=" else { "),o}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d="errs__"+o,h=e.util.copy(e),f="";h.level++;var m="valid"+h.level,y="key"+o,v="idx"+o,g=h.dataLevel=e.dataLevel+1,A="data"+g,b="dataProperties"+o,w=Object.keys(n||{}),E=e.schema.patternProperties||{},j=Object.keys(E),x=e.schema.additionalProperties,k=w.length||j.length,P=!1===x,C="object"==typeof x&&Object.keys(x).length,L=e.opts.removeAdditional,I=P||C||L,S=e.opts.ownProperties,D=e.baseId,Q=e.schema.required;if(Q&&(!e.opts.v5||!Q.$data)&&Q.length<e.opts.loopRequired)var F=e.util.toHash(Q);if(e.opts.patternGroups)var B=e.schema.patternGroups||{},R=Object.keys(B);if(a+="var "+d+" = errors;var "+m+" = true;",S&&(a+=" var "+b+" = undefined;"),I){if(a+=S?" "+b+" = "+b+" || Object.keys("+p+"); for (var "+v+"=0; "+v+"<"+b+".length; "+v+"++) { var "+y+" = "+b+"["+v+"]; ":" for (var "+y+" in "+p+") { ",k){if(a+=" var isAdditional"+o+" = !(false ",w.length)if(w.length>5)a+=" || validate.schema"+i+"["+y+"] ";else{var N=w;if(N)for(var O,M=-1,U=N.length-1;M<U;)O=N[M+=1],a+=" || "+y+" == "+e.util.toQuotedString(O)+" "}if(j.length){var T=j;if(T)for(var z,H=-1,G=T.length-1;H<G;)z=T[H+=1],a+=" || "+e.usePattern(z)+".test("+y+") "}if(e.opts.patternGroups&&R.length){var Y=R;if(Y)for(var q,H=-1,K=Y.length-1;H<K;)q=Y[H+=1],a+=" || "+e.usePattern(q)+".test("+y+") "}a+=" ); if (isAdditional"+o+") { "}if("all"==L)a+=" delete "+p+"["+y+"]; ";else{var J=e.errorPath,V="' + "+y+" + '";if(e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers)),P)if(L)a+=" delete "+p+"["+y+"]; ";else{a+=" "+m+" = false; ";var W=l;l=e.errSchemaPath+"/additionalProperties";var X=X||[];X.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'additionalProperties' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { additionalProperty: '"+V+"' } ",!1!==e.opts.messages&&(a+=" , message: 'should NOT have additional properties' "),e.opts.verbose&&(a+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var Z=a;a=X.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+Z+"]); ":a+=" validate.errors = ["+Z+"]; return false; ":a+=" var err = "+Z+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",l=W,c&&(a+=" break; ")}else if(C)if("failing"==L){a+=" var "+d+" = errors;  ";var $=e.compositeRule;e.compositeRule=h.compositeRule=!0,h.schema=x,h.schemaPath=e.schemaPath+".additionalProperties",h.errSchemaPath=e.errSchemaPath+"/additionalProperties",h.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers);var _=p+"["+y+"]";h.dataPathArr[g]=y;var ee=e.validate(h);h.baseId=D,e.util.varOccurences(ee,A)<2?a+=" "+e.util.varReplace(ee,A,_)+" ":a+=" var "+A+" = "+_+"; "+ee+" ",a+=" if (!"+m+") { errors = "+d+"; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete "+p+"["+y+"]; }  ",e.compositeRule=h.compositeRule=$}else{h.schema=x,h.schemaPath=e.schemaPath+".additionalProperties",h.errSchemaPath=e.errSchemaPath+"/additionalProperties",h.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers);var _=p+"["+y+"]";h.dataPathArr[g]=y;var ee=e.validate(h);h.baseId=D,e.util.varOccurences(ee,A)<2?a+=" "+e.util.varReplace(ee,A,_)+" ":a+=" var "+A+" = "+_+"; "+ee+" ",c&&(a+=" if (!"+m+") break; ")}e.errorPath=J}k&&(a+=" } "),a+=" }  ",c&&(a+=" if ("+m+") { ",f+="}")}var te=e.opts.useDefaults&&!e.compositeRule;if(w.length){var re=w;if(re)for(var O,ae=-1,oe=re.length-1;ae<oe;){O=re[ae+=1];var se=n[O];if(e.util.schemaHasRules(se,e.RULES.all)){var ne=e.util.getProperty(O),_=p+ne,ie=te&&void 0!==se.default;h.schema=se,h.schemaPath=i+ne,h.errSchemaPath=l+"/"+e.util.escapeFragment(O),h.errorPath=e.util.getPath(e.errorPath,O,e.opts.jsonPointers),h.dataPathArr[g]=e.util.toQuotedString(O);var ee=e.validate(h);if(h.baseId=D,e.util.varOccurences(ee,A)<2){ee=e.util.varReplace(ee,A,_);var le=_}else{var le=A;a+=" var "+A+" = "+_+"; "}if(ie)a+=" "+ee+" ";else{if(F&&F[O]){a+=" if ( "+le+" === undefined ",S&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(O)+"') "),a+=") { "+m+" = false; ";var J=e.errorPath,W=l,ce=e.util.escapeQuotes(O);e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(J,O,e.opts.jsonPointers)),l=e.errSchemaPath+"/required";var X=X||[];X.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+ce+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+ce+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var Z=a;a=X.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+Z+"]); ":a+=" validate.errors = ["+Z+"]; return false; ":a+=" var err = "+Z+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",l=W,e.errorPath=J,a+=" } else { "}else c?(a+=" if ( "+le+" === undefined ",S&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(O)+"') "),a+=") { "+m+" = true; } else { "):(a+=" if ("+le+" !== undefined ",S&&(a+=" &&   Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(O)+"') "),a+=" ) { ");a+=" "+ee+" } "}}c&&(a+=" if ("+m+") { ",f+="}")}}if(j.length){var pe=j;if(pe)for(var z,ue=-1,de=pe.length-1;ue<de;){z=pe[ue+=1];var se=E[z];if(e.util.schemaHasRules(se,e.RULES.all)){h.schema=se,h.schemaPath=e.schemaPath+".patternProperties"+e.util.getProperty(z),h.errSchemaPath=e.errSchemaPath+"/patternProperties/"+e.util.escapeFragment(z),a+=S?" "+b+" = "+b+" || Object.keys("+p+"); for (var "+v+"=0; "+v+"<"+b+".length; "+v+"++) { var "+y+" = "+b+"["+v+"]; ":" for (var "+y+" in "+p+") { ",a+=" if ("+e.usePattern(z)+".test("+y+")) { ",h.errorPath=e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers);var _=p+"["+y+"]";h.dataPathArr[g]=y;var ee=e.validate(h);h.baseId=D,e.util.varOccurences(ee,A)<2?a+=" "+e.util.varReplace(ee,A,_)+" ":a+=" var "+A+" = "+_+"; "+ee+" ",c&&(a+=" if (!"+m+") break; "),a+=" } ",c&&(a+=" else "+m+" = true; "),a+=" }  ",c&&(a+=" if ("+m+") { ",f+="}")}}}if(e.opts.patternGroups&&R.length){var he=R;if(he)for(var q,fe=-1,me=he.length-1;fe<me;){q=he[fe+=1];var ye=B[q],se=ye.schema;if(e.util.schemaHasRules(se,e.RULES.all)){h.schema=se,h.schemaPath=e.schemaPath+".patternGroups"+e.util.getProperty(q)+".schema",h.errSchemaPath=e.errSchemaPath+"/patternGroups/"+e.util.escapeFragment(q)+"/schema",a+=" var pgPropCount"+o+" = 0;  ",a+=S?" "+b+" = "+b+" || Object.keys("+p+"); for (var "+v+"=0; "+v+"<"+b+".length; "+v+"++) { var "+y+" = "+b+"["+v+"]; ":" for (var "+y+" in "+p+") { ",a+=" if ("+e.usePattern(q)+".test("+y+")) { pgPropCount"+o+"++; ",h.errorPath=e.util.getPathExpr(e.errorPath,y,e.opts.jsonPointers);var _=p+"["+y+"]";h.dataPathArr[g]=y;var ee=e.validate(h);h.baseId=D,e.util.varOccurences(ee,A)<2?a+=" "+e.util.varReplace(ee,A,_)+" ":a+=" var "+A+" = "+_+"; "+ee+" ",c&&(a+=" if (!"+m+") break; "),a+=" } ",c&&(a+=" else "+m+" = true; "),a+=" }  ",c&&(a+=" if ("+m+") { ",f+="}");var ve=ye.minimum,ge=ye.maximum;if(void 0!==ve||void 0!==ge){a+=" var "+u+" = true; ";var W=l;if(void 0!==ve){var Ae=ve,be="minimum",we="less";a+=" "+u+" = pgPropCount"+o+" >= "+ve+"; ",l=e.errSchemaPath+"/patternGroups/minimum",a+="  if (!"+u+") {   ";var X=X||[];X.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'patternGroups' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { reason: '"+be+"', limit: "+Ae+", pattern: '"+e.util.escapeQuotes(q)+"' } ",!1!==e.opts.messages&&(a+=" , message: 'should NOT have "+we+" than "+Ae+' properties matching pattern "'+e.util.escapeQuotes(q)+"\"' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var Z=a;a=X.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+Z+"]); ":a+=" validate.errors = ["+Z+"]; return false; ":a+=" var err = "+Z+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } ",void 0!==ge&&(a+=" else ")}if(void 0!==ge){var Ae=ge,be="maximum",we="more";a+=" "+u+" = pgPropCount"+o+" <= "+ge+"; ",l=e.errSchemaPath+"/patternGroups/maximum",a+="  if (!"+u+") {   ";var X=X||[];X.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'patternGroups' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { reason: '"+be+"', limit: "+Ae+", pattern: '"+e.util.escapeQuotes(q)+"' } ",!1!==e.opts.messages&&(a+=" , message: 'should NOT have "+we+" than "+Ae+' properties matching pattern "'+e.util.escapeQuotes(q)+"\"' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var Z=a;a=X.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+Z+"]); ":a+=" validate.errors = ["+Z+"]; return false; ":a+=" var err = "+Z+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } "}l=W,c&&(a+=" if ("+u+") { ",f+="}")}}}}return c&&(a+=" "+f+" if ("+d+" == errors) {"),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="errs__"+o,d=e.util.copy(e);d.level++;var h="valid"+d.level;if(e.util.schemaHasRules(n,e.RULES.all)){d.schema=n,d.schemaPath=i,d.errSchemaPath=l;var f="key"+o,m="idx"+o,y="i"+o,v="' + "+f+" + '",g=d.dataLevel=e.dataLevel+1,A="data"+g,b="dataProperties"+o,w=e.opts.ownProperties,E=e.baseId;a+=" var "+u+" = errors; ",w&&(a+=" var "+b+" = undefined; "),a+=w?" "+b+" = "+b+" || Object.keys("+p+"); for (var "+m+"=0; "+m+"<"+b+".length; "+m+"++) { var "+f+" = "+b+"["+m+"]; ":" for (var "+f+" in "+p+") { ",a+=" var startErrs"+o+" = errors; ";var j=f,x=e.compositeRule;e.compositeRule=d.compositeRule=!0;var k=e.validate(d);d.baseId=E,e.util.varOccurences(k,A)<2?a+=" "+e.util.varReplace(k,A,j)+" ":a+=" var "+A+" = "+j+"; "+k+" ",e.compositeRule=d.compositeRule=x,a+=" if (!"+h+") { for (var "+y+"=startErrs"+o+"; "+y+"<errors; "+y+"++) { vErrors["+y+"].propertyName = "+f+"; }   var err =   ",!1!==e.createErrors?(a+=" { keyword: 'propertyNames' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { propertyName: '"+v+"' } ",!1!==e.opts.messages&&(a+=" , message: 'property name \\'"+v+"\\' is invalid' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&c&&(e.async?a+=" throw new ValidationError(vErrors); ":a+=" validate.errors = vErrors; return false; "),c&&(a+=" break; "),a+=" } }"}return c&&(a+="  if ("+u+" == errors) {"),a=e.util.cleanUpCode(a)}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o,s=" ",n=e.level,i=e.dataLevel,l=e.schema[t],c=e.errSchemaPath+"/"+t,p=!e.opts.allErrors,u="data"+(i||""),d="valid"+n;if("#"==l||"#/"==l)e.isRoot?(a=e.async,o="validate"):(a=!0===e.root.schema.$async,o="root.refVal[0]");else{var h=e.resolveRef(e.baseId,l,e.isRoot);if(void 0===h){var f=e.MissingRefError.message(e.baseId,l);if("fail"==e.opts.missingRefs){e.logger.error(f);var m=m||[];m.push(s),s="",!1!==e.createErrors?(s+=" { keyword: '$ref' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(c)+" , params: { ref: '"+e.util.escapeQuotes(l)+"' } ",!1!==e.opts.messages&&(s+=" , message: 'can\\'t resolve reference "+e.util.escapeQuotes(l)+"' "),e.opts.verbose&&(s+=" , schema: "+e.util.toQuotedString(l)+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+u+" "),s+=" } "):s+=" {} ";var y=s;s=m.pop(),!e.compositeRule&&p?e.async?s+=" throw new ValidationError(["+y+"]); ":s+=" validate.errors = ["+y+"]; return false; ":s+=" var err = "+y+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",p&&(s+=" if (false) { ")}else{if("ignore"!=e.opts.missingRefs)throw new e.MissingRefError(e.baseId,l,f);e.logger.warn(f),p&&(s+=" if (true) { ")}}else if(h.inline){var v=e.util.copy(e);v.level++;var g="valid"+v.level;v.schema=h.schema,v.schemaPath="",v.errSchemaPath=l;var A=e.validate(v).replace(/validate\.schema/g,h.code);s+=" "+A+" ",p&&(s+=" if ("+g+") { ")}else a=!0===h.$async,o=h.code}if(o){var m=m||[];m.push(s),s="",e.opts.passContext?s+=" "+o+".call(this, ":s+=" "+o+"( ",s+=" "+u+", (dataPath || '')",'""'!=e.errorPath&&(s+=" + "+e.errorPath);s+=" , "+(i?"data"+(i-1||""):"parentData")+" , "+(i?e.dataPathArr[i]:"parentDataProperty")+", rootData)  ";var b=s;if(s=m.pop(),a){if(!e.async)throw new Error("async schema referenced by sync schema");p&&(s+=" var "+d+"; "),s+=" try { "+e.yieldAwait+" "+b+"; ",p&&(s+=" "+d+" = true; "),s+=" } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ",p&&(s+=" "+d+" = false; "),s+=" } ",p&&(s+=" if ("+d+") { ")}else s+=" if (!"+b+") { if (vErrors === null) vErrors = "+o+".errors; else vErrors = vErrors.concat("+o+".errors); errors = vErrors.length; } ",p&&(s+=" else { ")}return s}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a=" ",o=e.level,s=e.dataLevel,n=e.schema[t],i=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,p="data"+(s||""),u="valid"+o,d=e.opts.$data&&n&&n.$data;d&&(a+=" var schema"+o+" = "+e.util.getData(n.$data,s,e.dataPathArr)+"; ");var h="schema"+o;if(!d)if(n.length<e.opts.loopRequired&&e.schema.properties&&Object.keys(e.schema.properties).length){var f=[],m=n;if(m)for(var y,v=-1,g=m.length-1;v<g;){y=m[v+=1];var A=e.schema.properties[y];A&&e.util.schemaHasRules(A,e.RULES.all)||(f[f.length]=y)}}else var f=n;if(d||f.length){var b=e.errorPath,w=d||f.length>=e.opts.loopRequired,E=e.opts.ownProperties;if(c)if(a+=" var missing"+o+"; ",w){d||(a+=" var "+h+" = validate.schema"+i+"; ");var j="i"+o,x="schema"+o+"["+j+"]",k="' + "+x+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(b,x,e.opts.jsonPointers)),a+=" var "+u+" = true; ",d&&(a+=" if (schema"+o+" === undefined) "+u+" = true; else if (!Array.isArray(schema"+o+")) "+u+" = false; else {"),a+=" for (var "+j+" = 0; "+j+" < "+h+".length; "+j+"++) { "+u+" = "+p+"["+h+"["+j+"]] !== undefined ",E&&(a+=" &&   Object.prototype.hasOwnProperty.call("+p+", "+h+"["+j+"]) "),a+="; if (!"+u+") break; } ",d&&(a+="  }  "),a+="  if (!"+u+") {   ";var P=P||[];P.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+k+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+k+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var C=a;a=P.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+C+"]); ":a+=" validate.errors = ["+C+"]; return false; ":a+=" var err = "+C+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } else { "}else{a+=" if ( ";var L=f;if(L)for(var I,j=-1,S=L.length-1;j<S;){I=L[j+=1],j&&(a+=" || ");var D=e.util.getProperty(I),Q=p+D;a+=" ( ( "+Q+" === undefined ",E&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(I)+"') "),a+=") && (missing"+o+" = "+e.util.toQuotedString(e.opts.jsonPointers?I:D)+") ) "}a+=") {  ";var x="missing"+o,k="' + "+x+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(b,x,!0):b+" + "+x);var P=P||[];P.push(a),a="",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+k+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+k+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ";var C=a;a=P.pop(),!e.compositeRule&&c?e.async?a+=" throw new ValidationError(["+C+"]); ":a+=" validate.errors = ["+C+"]; return false; ":a+=" var err = "+C+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } else { "}else if(w){d||(a+=" var "+h+" = validate.schema"+i+"; ");var j="i"+o,x="schema"+o+"["+j+"]",k="' + "+x+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(b,x,e.opts.jsonPointers)),d&&(a+=" if ("+h+" && !Array.isArray("+h+")) {  var err =   ",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+k+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+k+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if ("+h+" !== undefined) { "),a+=" for (var "+j+" = 0; "+j+" < "+h+".length; "+j+"++) { if ("+p+"["+h+"["+j+"]] === undefined ",E&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", "+h+"["+j+"]) "),a+=") {  var err =   ",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+k+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+k+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ",d&&(a+="  }  ")}else{var F=f;if(F)for(var I,B=-1,R=F.length-1;B<R;){I=F[B+=1];var D=e.util.getProperty(I),k=e.util.escapeQuotes(I),Q=p+D;e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(b,I,e.opts.jsonPointers)),a+=" if ( "+Q+" === undefined ",E&&(a+=" || ! Object.prototype.hasOwnProperty.call("+p+", '"+e.util.escapeQuotes(I)+"') "),a+=") {  var err =   ",!1!==e.createErrors?(a+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { missingProperty: '"+k+"' } ",!1!==e.opts.messages&&(a+=" , message: '",e.opts._errorDataPathProperty?a+="is a required property":a+="should have required property \\'"+k+"\\'",a+="' "),e.opts.verbose&&(a+=" , schema: validate.schema"+i+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",a+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } "}}e.errorPath=b}else c&&(a+=" if (true) {");return a}},function(e,t,r){"use strict";e.exports=function(e,t,r){var a,o=" ",s=e.level,n=e.dataLevel,i=e.schema[t],l=e.schemaPath+e.util.getProperty(t),c=e.errSchemaPath+"/"+t,p=!e.opts.allErrors,u="data"+(n||""),d="valid"+s,h=e.opts.$data&&i&&i.$data;if(h?(o+=" var schema"+s+" = "+e.util.getData(i.$data,n,e.dataPathArr)+"; ",a="schema"+s):a=i,(i||h)&&!1!==e.opts.uniqueItems){h&&(o+=" var "+d+"; if ("+a+" === false || "+a+" === undefined) "+d+" = true; else if (typeof "+a+" != 'boolean') "+d+" = false; else { "),o+=" var "+d+" = true; if ("+u+".length > 1) { var i = "+u+".length, j; outer: for (;i--;) { for (j = i; j--;) { if (equal("+u+"[i], "+u+"[j])) { "+d+" = false; break outer; } } } } ",h&&(o+="  }  "),o+=" if (!"+d+") {   ";var f=f||[];f.push(o),o="",!1!==e.createErrors?(o+=" { keyword: 'uniqueItems' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(c)+" , params: { i: i, j: j } ",!1!==e.opts.messages&&(o+=" , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "),e.opts.verbose&&(o+=" , schema:  ",o+=h?"validate.schema"+l:""+i,o+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+u+" "),o+=" } "):o+=" {} ";var m=o;o=f.pop(),!e.compositeRule&&p?e.async?o+=" throw new ValidationError(["+m+"]); ":o+=" validate.errors = ["+m+"]; return false; ":o+=" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",o+=" } ",p&&(o+=" else { ")}else p&&(o+=" if (true) { ");return o}},function(e,t,r){"use strict";function a(e,t){function r(e,t,r){for(var a,s=0;s<o.length;s++){var n=o[s];if(n.type==t){a=n;break}}a||(a={type:t,rules:[]},o.push(a));var l={keyword:e,definition:r,custom:!0,code:i,implements:r.implements};a.rules.push(l),o.custom[e]=l}function a(e){if(!o.types[e])throw new Error("Unknown type "+e)}var o=this.RULES;if(o.keywords[e])throw new Error("Keyword "+e+" is already defined");if(!n.test(e))throw new Error("Keyword "+e+" is not a valid identifier");if(t){if(t.macro&&void 0!==t.valid)throw new Error('"valid" option cannot be used with macro keywords');var s=t.type;if(Array.isArray(s)){var l,c=s.length;for(l=0;l<c;l++)a(s[l]);for(l=0;l<c;l++)r(e,s[l],t)}else s&&a(s),r(e,s,t);var p=!0===t.$data&&this._opts.$data;if(p&&!t.validate)throw new Error('$data support: "validate" function is not defined');var u=t.metaSchema;u&&(p&&(u={anyOf:[u,{$ref:"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#"}]}),t.validateSchema=this.compile(u,!0))}return o.keywords[e]=o.all[e]=!0,this}function o(e){var t=this.RULES.custom[e];return t?t.definition:this.RULES.keywords[e]||!1}function s(e){var t=this.RULES;delete t.keywords[e],delete t.all[e],delete t.custom[e];for(var r=0;r<t.length;r++)for(var a=t[r].rules,o=0;o<a.length;o++)if(a[o].keyword==e){a.splice(o,1);break}return this}var n=/^[a-z_$][a-z0-9_$-]*$/i,i=r(58);e.exports={add:a,get:o,remove:s}},function(e,t,r){"use strict";e.exports=function(e){var t=e._opts.defaultMeta,r="string"==typeof t?{$ref:t}:e.getSchema("http://json-schema.org/draft-06/schema")?{$ref:"http://json-schema.org/draft-06/schema"}:{};e.addKeyword("patternGroups",{metaSchema:{type:"object",additionalProperties:{type:"object",required:["schema"],properties:{maximum:{type:"integer",minimum:0},minimum:{type:"integer",minimum:0},schema:r},additionalProperties:!1}}}),e.RULES.all.properties.implements.push("patternGroups")}},function(e,t){e.exports={$schema:"http://json-schema.org/draft-06/schema#",$id:"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#",description:"Meta-schema for $data reference (JSON-schema extension proposal)",type:"object",required:["$data"],properties:{$data:{type:"string",anyOf:[{format:"relative-json-pointer"},{format:"json-pointer"}]}},additionalProperties:!1}},function(e,t){e.exports={$schema:"http://json-schema.org/draft-06/schema#",$id:"http://json-schema.org/draft-06/schema#",title:"Core schema meta-schema",definitions:{schemaArray:{type:"array",minItems:1,items:{$ref:"#"}},nonNegativeInteger:{type:"integer",minimum:0},nonNegativeIntegerDefault0:{allOf:[{$ref:"#/definitions/nonNegativeInteger"},{default:0}]},simpleTypes:{enum:["array","boolean","integer","null","number","object","string"]},stringArray:{type:"array",items:{type:"string"},uniqueItems:!0,default:[]}},type:["object","boolean"],properties:{$id:{type:"string",format:"uri-reference"},$schema:{type:"string",format:"uri"},$ref:{type:"string",format:"uri-reference"},title:{type:"string"},description:{type:"string"},default:{},examples:{type:"array",items:{}},multipleOf:{type:"number",exclusiveMinimum:0},maximum:{type:"number"},exclusiveMaximum:{type:"number"},minimum:{type:"number"},exclusiveMinimum:{type:"number"},maxLength:{$ref:"#/definitions/nonNegativeInteger"},minLength:{$ref:"#/definitions/nonNegativeIntegerDefault0"},pattern:{type:"string",format:"regex"},additionalItems:{$ref:"#"},items:{anyOf:[{$ref:"#"},{$ref:"#/definitions/schemaArray"}],default:{}},maxItems:{$ref:"#/definitions/nonNegativeInteger"},minItems:{$ref:"#/definitions/nonNegativeIntegerDefault0"},uniqueItems:{type:"boolean",default:!1},contains:{$ref:"#"},maxProperties:{$ref:"#/definitions/nonNegativeInteger"},minProperties:{$ref:"#/definitions/nonNegativeIntegerDefault0"},required:{$ref:"#/definitions/stringArray"},additionalProperties:{$ref:"#"},definitions:{type:"object",additionalProperties:{$ref:"#"},default:{}},properties:{type:"object",additionalProperties:{$ref:"#"},default:{}},patternProperties:{type:"object",additionalProperties:{$ref:"#"},default:{}},dependencies:{type:"object",additionalProperties:{anyOf:[{$ref:"#"},{$ref:"#/definitions/stringArray"}]}},propertyNames:{$ref:"#"},const:{},enum:{type:"array",minItems:1,uniqueItems:!0},type:{anyOf:[{$ref:"#/definitions/simpleTypes"},{type:"array",items:{$ref:"#/definitions/simpleTypes"},minItems:1,uniqueItems:!0}]},format:{type:"string"},allOf:{$ref:"#/definitions/schemaArray"},anyOf:{$ref:"#/definitions/schemaArray"},oneOf:{$ref:"#/definitions/schemaArray"},not:{$ref:"#"}},default:{}}},function(e,t,r){"use strict";function a(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},n=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),i=r(10),l=function(e){return e&&e.__esModule?e:{default:e}}(i),c=(r(11),{TEXT:"text",BUTTON:"button",IMAGE:"image",MAP:"map",VERTICAL:"vertical",HORIZONTAL:"horizontal",CAROUSEL:"carousel",CAROUSELSELECT:"carouselSelect",ACCORDIONSELECT:"accordionSelect",SUBMITBUTTON:"submitButton",CHECKBOX:"checkbox",CHECKLIST:"checklist",LIST:"list",SECTION:"section",SECTIONLIST:"sectionList",BUTTONLIST:"buttonList",TABS:"tabs"}),p="data-section-id",u=function(){function e(t){var r=this;o(this,e),this.elements={},this.events=t,this.set(c.TEXT,function(e){var t=document.createElement("div"),r=document.createElement("span"),a=e.tooltip?l.default.escapeHtml(e.tooltip):"";t.className="lp-json-pollock-element-text",e.rtl&&(t.dir="rtl",l.default.addClass(t,"direction-rtl"));var o=l.default.styleToCss(e.style),s=l.default.extractFromStyles(o,"background-color");return t.setAttribute("style",s.extractedStyle),r.innerHTML=l.default.normalizeHtmlText(e.text),r.setAttribute("style",s.style),r.setAttribute("title",a),e.accessibility&&e.accessibility.web?l.default.appendAttributesFromObject(r,e.accessibility.web):r.setAttribute("aria-label",a),t.appendChild(r),t}),this.set(c.BUTTON,function(e){function t(e){if(e){return e.classList.contains("lp-json-pollock")?e:t(e.parentNode)}}var o=document.createElement("div");o.className="lp-json-pollock-element-button",e.rtl&&(o.dir="rtl",l.default.addClass(o,"direction-rtl"));var n=document.createElement("button");if(n.innerHTML=l.default.normalizeHtmlText(e.title),e.subtitle){var i=document.createElement("span");i.className="lp-json-pollock-element-button-subtitle",i.innerHTML=l.default.normalizeHtmlText(e.subtitle),n.appendChild(i)}e.tooltip&&(n.title=e.tooltip,n.setAttribute("aria-label",e.tooltip)),e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(n,e.accessibility.web);var c=e.click;if(c&&c.actions&&(e.ref?n.onclick=function(o,i){var l=[],p=t(n);if(!p)throw new Error("Cannot find root element selected!");var u=void 0;switch(e.ref.type){case"carouselSelect":u="[data-carousel-name="+e.ref.name+"] [data-selected]";break;case"accordionSelect":u="[data-accordion-name="+e.ref.name+"] [data-accordion-body][data-selected]";break;default:throw new Error("Invalid config ref type is used for the button! Type: "+e.ref.type)}var d=Array.from(p.querySelectorAll(u));if(0===d.length)throw new Error("No items has selected!");var h=d.map(function(e){return JSON.parse(e.getAttribute("data-metadata")||"[]")}).reduce(function(e,t){return[].concat(a(e),a(t))},[]);return l.push.apply(l,a(h)),r.wrapAction(s({},c,{metadata:l}))(o,i)}:n.onclick=r.wrapAction(e.click)),"button"!==e.class){if(e.style){var p=l.default.styleToCss(e.style),u=l.default.extractFromStyles(p,"background-color");n.style.cssText=u.style,o.setAttribute("style",u.extractedStyle)}o.appendChild(n)}else{var d=document.createElement("div");if(d.className="lp-json-pollock-element-button-button",l.default.addClass(d,"class-button"),e.style){var h=l.default.styleToCss(e.style),f=l.default.extractFromStyles(h,"background-color");n.style.cssText=f.style,d.setAttribute("style",f.extractedStyle);var m=l.default.styleToBorder(e.style);""!==m&&d.setAttribute("style",f.extractedStyle+" "+m)}d.appendChild(n),o.appendChild(d)}return o}),this.set(c.SUBMITBUTTON,function(e){var t=document.createElement("div");t.className="lp-json-pollock-element-submit-button",e.rtl&&(t.dir="rtl",l.default.addClass(t,"direction-rtl"));var a=document.createElement("input");if(a.type="submit",a.value=l.default.normalizeHtmlText(e.title),e.disabled&&(a.disabled=!0,a.classList.add("lp-json-pollock-element-submit-button-disabled")),e.tooltip&&(a.title=e.tooltip,a.setAttribute("aria-label",e.tooltip)),e.style){var o=l.default.styleToCss(e.style),s=l.default.extractFromStyles(o,"background-color");t.setAttribute("style",s.extractedStyle),a.style.cssText=s.style}return e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(a,e.accessibility.web),e.click&&e.click.actions&&(a.onclick=r.wrapAction(e.click,!0)),t.appendChild(a),t}),this.set(c.CHECKBOX,function(e){var t=l.default.generateRandomId(),a=document.createElement("div");a.className="lp-json-pollock-element-checkbox";var o=document.createElement("input"),s=l.default.normalizeHtmlText(e.text);o.type="checkbox",o.className="lp-json-pollock-element-checkbox-input",o.id=t;var n=document.createElement("label");if(n.className="lp-json-pollock-element-checkbox-label",n.innerHTML+=s,n.setAttribute("for",t),e.rtl&&(n.dir="rtl",l.default.addClass(n,"direction-rtl")),e.tooltip&&(n.title=e.tooltip,n.setAttribute("aria-label",e.tooltip)),e.borderLine){var i=document.createElement("div");i.className="lp-json-pollock-border-element",e.borderColor&&(i.style.borderColor=e.borderColor),a.appendChild(i)}e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(n,e.accessibility.web);var c=document.createElement("div");if(c.className="lp-json-pollock-element-checkbox-wrapper",e.rtl&&(c.dir="rtl",l.default.addClass(c,"direction-rtl")),e.style){var u=l.default.styleToCss(e.style),d=l.default.extractFromStyles(u,"background-color");n.style.cssText=u,c.setAttribute("style",d.extractedStyle)}return c.appendChild(o),c.appendChild(n),a.appendChild(c),a.afterRender=function(e,t){var o=a.getElementsByTagName("input")[0];e.click&&e.click.actions&&(o.onclick=r.wrapAction(e.click,!1,t.parentElement.getAttribute(p)))},a}),this.set(c.CHECKLIST,function(e){var t=document.createElement("div");if(t.className="lp-json-pollock-layout-checklist",t.setAttribute("role","group"),e.padding){var r=e.padding;t.style.margin=r/2+"px 0px"}return t}),this.set(c.SECTION,function(e){var t=document.createElement("div");if(t.className="lp-json-pollock-layout-section",e.padding){var r=e.padding;t.style.margin=r/2+"px 0px"}return e.sectionID&&t.setAttribute(p,e.sectionID),e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(t,e.accessibility.web),t}),this.set(c.SECTIONLIST,function(){var e=document.createElement("div");return e.className="lp-json-pollock-layout-sectionList",e}),this.set(c.BUTTONLIST,function(){var e=document.createElement("div");return e.className="lp-json-pollock-layout-buttonList",e}),this.set(c.LIST,function(){var e=document.createElement("form");return e.className="lp-json-pollock-layout lp-json-pollock-layout-form",e.afterRender=function(){var t=e.querySelectorAll("input");if(t.length>0)for(var a=0;a<t.length;a+=1){var o=t[a];o.onclick&&function(){var t=o.onclick;o.onclick=function(a){t.call(r,a,e)}}()}var s=e.querySelectorAll("button");if(s.length>0)for(var n=0;n<s.length;n+=1){var i=s[n];i.getAttribute("type")||i.setAttribute("type","button")}},e}),this.set(c.IMAGE,function(e){var t=document.createElement("div");t.className="lp-json-pollock-element-image loading",e.rtl&&(t.dir="rtl",l.default.addClass(t,"direction-rtl"));var a=document.createElement("img");return a.src=e.url,e.tooltip&&e.tooltip.length&&(t.title=e.tooltip),e.alt&&e.alt.length?a.setAttribute("alt",e.alt):(a.setAttribute("alt",""),a.setAttribute("role","presentation")),e.style&&(a.style.cssText=l.default.styleToCss(e.style)),e.caption&&(t.innerHTML+="<span>"+e.caption+"</span>"),e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(a,e.accessibility.web),a.onload=function(){l.default.removeClass(t,"loading")},a.onerror=function(){l.default.removeClass(t,"loading"),l.default.addClass(t,"error"),t.title="fail to load image",a.style.display="none"},e.click&&e.click.actions&&(a.onclick=r.wrapAction(e.click)),t.appendChild(a),t}),this.set(c.MAP,function(e){var t=e.accessibility&&e.accessibility.web,a=document.createElement("div");return a.className="lp-json-pollock-element-map",e.tooltip&&(a.title=e.tooltip,a.setAttribute("aria-label",e.tooltip)),e.style&&(a.style.cssText=l.default.styleToCss(e.style)),t&&l.default.appendAttributesFromObject(a,e.accessibility.web),t&&t.tabindex||a.setAttribute("tabindex","0"),a.onkeydown=function(t){13!==t.keyCode&&32!==t.keyCode||(t.preventDefault(),window.open("https://www.google.com/maps/search/?api=1&query="+e.la+","+e.lo,"_blank"))},e.click&&e.click.actions?a.onclick=r.wrapAction(e.click):a.onclick=function(){window.open("https://www.google.com/maps/search/?api=1&query="+e.la+","+e.lo,"_blank")},a}),this.set(c.VERTICAL,function(e){var t=document.createElement("div");if(t.className="lp-json-pollock-layout lp-json-pollock-layout-vertical","borderLess"===e.border?l.default.addClass(t,"lp-json-pollock-layout-borderLess"):"dropShadow"===e.border&&l.default.addClass(t,"lp-json-pollock-layout-dropShadow"),"enable"===e.scroll)if(l.default.addClass(t,"lp-json-pollock-layout-vertical-scroll"),e.style&&e.style.size){var r=e.style.size,a=100;"medium"===r?a=300:"large"===r&&(a=500),t.setAttribute("style","height: "+a+"px")}else t.setAttribute("style","height: 100px");return e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(t,e.accessibility.web),e.metadata&&t.setAttribute("data-metadata",JSON.stringify(e.metadata)),t}),this.set(c.TABS,function(e){var t=e.elements,a=document.createElement("div"),o=document.createElement("div");a.appendChild(o);var s="",n="",i="",l="";if(e.style){var c=e.style.color,p=e.style["background-color"],u=e.style["color-active"],d=e.style["background-color-active"],h=e.style["color-hover"],f=e.style["background-color-hover"],m=1;e.style.size&&("small"===e.style.size?m=1:"medium"===e.style.size?m=2:"large"===e.style.size&&(m=3)),s+=c?"color: "+c+"; ":"",s+=c?"border-bottom: "+m+"px solid "+c+"; ":"",s+=p?"background-color: "+p+"; ":"",n+=u?"color: "+u+"; ":"",n+=u?"border-bottom: "+m+"px solid "+u+"; ":"",n+=d?"background-color: "+d+"; ":"",i+=h?"color: "+h+"; ":"",i+=h?"border-bottom: "+m+"px solid "+h+"; ":"",i+=f?"background-color: "+f+"; ":""}var y=function(e){for(var t=a.children,r=t[0].children,o=[],i=1;i<t.length;i++)o.push(t[i]);if(o.length&&o.forEach(function(e){e.style.display="none"}),!e)return s&&n?(r[0].style.cssText=n,l=n):r[0].className+=" active",void(o[0].style.display="block");for(var c=0;c<r.length;c++){var p=r[c];s&&n?p.style.cssText=s:p.className=p.className.replace(" active","")}s&&n?(e.currentTarget.style.cssText=n,l=n):e.currentTarget.className+=" active";for(var u=0;u<r.length;u++)r[u].style.cssText.trim().toLowerCase()===n.trim().toLowerCase()&&n?o[u].style.display="block":r[u].className.includes("active")&&(o[u].style.display="block")};return o.className="lp-json-pollock-element-tab",t.forEach(function(t){var a=t.tag,n=document.createElement("button");n.className="lp-json-pollock-element-tab-button",e.style&&e.style.size?n.className+=" lp-json-pollock-element-tab-button-size-"+e.style.size:n.className+=" lp-json-pollock-element-tab-button-size-small",s&&(n.style.cssText=s),i&&(l=n.style.cssText,n.addEventListener("mouseover",function(){l=n.style.cssText,n.style.cssText=i},!1),n.addEventListener("mouseout",function(){n.style.cssText=l},!1)),n.id=a,n.textContent=a,n.onclick=function(e){y.call(r,e)},o.appendChild(n)}),a.afterRender=function(){y()},a}),this.set(c.CAROUSEL,function(e){function t(e){A&&A[v]&&(p=-1*A[v].offsetLeft+"px",v===A.length-1&&(p=-1*(A[v].offsetLeft-(h.offsetWidth-A[v].offsetWidth))+"px"),this&&this.events&&this.events.trigger({eventName:y,data:{offset:p,prevOffset:m.style.left,uiEvent:e}}),m.style.left=p)}function a(){var e="Item "+(v+1)+" of "+A.length;f.setAttribute("aria-label",e)}function o(e){v===A.length-1?v=0:v+=1,a(),t.call(this,e)}function s(e){0===v?v=A.length-1:v-=1,a(),t.call(this,e)}function n(e){if(e){var t=e.getAttribute("data-carousel-index");return t||n(e.parentNode)}}function i(e){var r=e.target,a=n(r);a&&(h.scrollLeft=0,a&&v!==parseInt(a,10)&&(v=parseInt(a,10),t.call(this,e)))}var c=e.padding||0,p=0,u=document.createElement("button"),d=document.createElement("button"),h=document.createElement("div"),f=document.createElement("div"),m=document.createElement("div"),y="carouselOffsetChange",v=0,g=!1,A=void 0;if(u.setAttribute("type","button"),u.setAttribute("aria-label","Previous"),d.setAttribute("type","button"),d.setAttribute("aria-label","Next"),f.setAttribute("aria-live","polite"),f.setAttribute("aria-atomic","true"),u.innerHTML='<svg aria-hidden="true" class="lp-json-pollock-layout-carousel-arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 14"><path d="M0 0 L2 0 L9 7 L2 14 L0 14 L0 13 L6 7 L0 1"/></svg>',d.innerHTML='<svg aria-hidden="true" class="lp-json-pollock-layout-carousel-arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 14"><path d="M0 0 L2 0 L9 7 L2 14 L0 14 L0 13 L6 7 L0 1"/></svg>',e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(h,e.accessibility.web),e.style){var b=l.default.styleToCss(e.style),w=l.default.extractFromStyles(b,"background-color"),E=""+w.extractedStyle,j=l.default.styleToBorder(e.style);""!==j&&(E+=" "+j);var x=l.default.styleToButton(e.style);""!==x&&(E+=" "+x),d.setAttribute("style",""+E),u.setAttribute("style",""+E);var k=d.querySelector(".lp-json-pollock-layout-carousel-arrow-icon"),P=u.querySelector(".lp-json-pollock-layout-carousel-arrow-icon");k&&k.setAttribute("style",w.style),P&&P.setAttribute("style",w.style)}return u.style.visibility="visible",h.afterRender=function(){if(h.childNodes.length){for(var e=0;e<h.childNodes.length;e+=1){var t=h.childNodes[e];t.addEventListener("focus",i.bind(r),!0),t.style.margin="0 "+c/2+"px",t.setAttribute("data-carousel-index",e),t.setAttribute("role","listitem")}for(d.className="lp-json-pollock-component-action lp-json-pollock-layout-carousel-arrow",u.className="lp-json-pollock-component-action lp-json-pollock-layout-carousel-arrow left";h.hasChildNodes();)m.insertBefore(h.lastChild,m.firstChild);h.appendChild(m),m.className="lp-json-pollock-layout-carousel",h.setAttribute("aria-label","Carousel with buttons"),h.className="lp-json-pollock-layout-carousel-wrapper",m.setAttribute("role","list"),h.appendChild(u),h.appendChild(d),h.appendChild(m),h.appendChild(f),setTimeout(function(){h.offsetWidth>m.offsetWidth&&(u.style.visibility="hidden",d.style.visibility="hidden"),A=m.children,(g="rtl"===window.getComputedStyle(d).direction)&&(u.style.visibility="visible",d.style.visibility="visible",v=A.length-1,A=[].slice.call(A,0).reverse(),p=-1*(A[v].offsetLeft-(h.offsetWidth-A[v].offsetWidth))+"px",m.style.left=p)},0),d.onclick=function(e){o.call(r,e)},u.onclick=function(e){s.call(r,e)}}},h}),this.set(c.CAROUSELSELECT,function(e){function t(e){if(e&&"BUTTON"!==e.tagName){return null!==e.getAttribute("data-carousel-index")?e:t(e.parentNode)}}function a(t,r){r?(t.setAttribute("data-selected","true"),t.classList.add("lp-json-pollock-layout-selected"),e.style&&e.style["border-color-selected"]&&(t.style.borderColor=e.style["border-color-selected"])):(t.removeAttribute("data-selected"),t.classList.remove("lp-json-pollock-layout-selected"),t.style.borderColor="")}function o(r){var o=r.target,s=t(o);s&&("single"===e.selectMode.type&&s.parentNode&&Array.from(s.parentNode.querySelectorAll("[data-carousel-index][data-selected]")).filter(function(e){return e!==s}).forEach(function(e){a(e,!1)}),a(s,"true"!==s.dataset.selected))}var s=e.padding||0,n=document.createElement("div"),i=document.createElement("div");if(e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(n,e.accessibility.web),e.style){var c=l.default.styleToCss(e.style),p=l.default.extractFromStyles(c,"background-color");i.style.cssText=p.style,i.setAttribute("style",p.extractedStyle)}return n.afterRender=function(){var t=n.children.length;if(t){for(var a=0;a<t;a+=1){var l=n.children[a];l.addEventListener("click",o.bind(r),!0),l.style.margin="0 "+s/2+"px",l.setAttribute("data-carousel-index",a.toString()),l.setAttribute("role","listitem")}for(;n.hasChildNodes()&&n.lastChild;)i.insertBefore(n.lastChild,i.firstChild);i.className="lp-json-pollock-layout-carousel lp-json-pollock-layout-carousel-select",n.className="lp-json-pollock-layout-carousel-wrapper",n.appendChild(i),n.setAttribute("data-carousel-name",e.selectMode.name)}},n}),this.set(c.ACCORDIONSELECT,function(e){function t(e){return null!==e.getAttribute("data-accordion-index")?e:t(e.parentNode)}function a(e,t){t?(e.removeAttribute("data-selected"),e.checked=!1):(e.setAttribute("data-selected","true"),e.checked=!0)}function o(e,t){t?e.removeAttribute("data-selected"):e.setAttribute("data-selected","true")}function s(e,t){t?(e.setAttribute("data-open","true"),e.classList.remove("lp-json-pollock-layout-accordion-folded")):(e.setAttribute("data-open","false"),e.classList.add("lp-json-pollock-layout-accordion-folded"))}function n(e,t){t?(e.classList.add("open"),e.classList.remove("close")):(e.classList.add("close"),e.classList.remove("open"))}function i(e){var r=e.target,i="INPUT"===r.tagName,l=t(r);if(l){var c=l.querySelector(".lp-json-pollock-layout-accordion-checkbox"),p=l.querySelector(".lp-json-pollock-layout-accordion-header"),u=l.querySelector(".lp-json-pollock-layout-accordion"),d=l.querySelector(".lp-json-pollock-layout-accordion-arrow");if(i){if(!c||!u)return;var h="true"===c.dataset.selected;return a(c,h),void o(u,h)}if(p&&u){var f="true"===u.dataset.open;s(u,!f),n(d,!f)}}}var c=e.padding||0,p=document.createElement("div"),u=document.createElement("div"),d=l.default.htmlToElement('<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 14"><path d="M0 0 L2 0 L9 7 L2 14 L0 14 L0 13 L6 7 L0 1"/></svg>');if(e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(p,e.accessibility.web),e.style){var h=l.default.styleToCss(e.style),f=l.default.extractFromStyles(h,"background-color");u.style.cssText=f.style,u.setAttribute("style",f.extractedStyle)}return p.afterRender=function(){var t=p.children.length;if(t){for(var a=0;a<t;a+=1){var o=p.children[0],s=e.titles[a],n=document.createElement("section"),l=document.createElement("div"),h=document.createElement("input"),f=document.createElement("h3"),m=document.createElement("span"),y=d.cloneNode(!0);n.classList.add("lp-json-pollock-layout-accordion-tab"),l.classList.add("lp-json-pollock-layout-accordion-header"),h.classList.add("lp-json-pollock-layout-accordion-checkbox"),f.classList.add("lp-json-pollock-layout-accordion-title"),m.classList.add("lp-json-pollock-layout-accordion-additional"),y.classList.add("lp-json-pollock-layout-accordion-arrow","close"),o.classList.add("lp-json-pollock-layout-accordion-folded"),o.classList.add("lp-json-pollock-layout-accordion"),o.setAttribute("data-open","false"),o.setAttribute("data-accordion-body",""),h.type="checkbox",f.innerText=s.name,s.additional&&(m.innerText=s.additional),l.addEventListener("click",i.bind(r),!0),n.style.margin="0 "+c/2+"px",n.setAttribute("data-accordion-index",a.toString()),n.setAttribute("role","listitem"),l.appendChild(h),l.appendChild(f),l.appendChild(m),l.appendChild(y),n.appendChild(l),n.appendChild(o),p.appendChild(n)}for(;p.hasChildNodes()&&p.lastChild;)u.insertBefore(p.lastChild,u.firstChild);u.className="lp-json-pollock-layout-accordion lp-json-pollock-layout-accordion-select",p.className="lp-json-pollock-layout-accordion-wrapper",p.appendChild(u),p.setAttribute("data-accordion-name",e.selectMode.name)}},p}),this.set(c.HORIZONTAL,function(e){var t=document.createElement("div");return t.className="lp-json-pollock-layout lp-json-pollock-layout-horizontal","borderLess"===e.border?l.default.addClass(t,"lp-json-pollock-layout-borderLess"):"dropShadow"===e.border?l.default.addClass(t,"lp-json-pollock-layout-dropShadow"):void 0!==e.borderLine&&!1===e.borderLine&&"border"!==e.border&&l.default.addClass(t,"lp-json-pollock-layout-borderLess"),e.accessibility&&e.accessibility.web&&l.default.appendAttributesFromObject(t,e.accessibility.web),e.metadata&&t.setAttribute("data-metadata",JSON.stringify(e.metadata)),t.afterRender=function(){if(t.childNodes.length){var r=e.percentages,a=100/t.childNodes.length;if(r&&r.length>0&&r.length<t.childNodes.length){var o=r.reduce(function(e,t){return e+t},0);a=(100-o)/(t.childNodes.length-r.length)}Array.prototype.forEach.call(t.childNodes,function(e,t){var o=e,s=r&&r[t]||a;o.style.width=s+"%"})}},t})}return n(e,[{key:"get",value:function(e){return this.elements[e]}},{key:"set",value:function(e,t){this.elements[e]=t}},{key:"wrapAction",value:function(e,t,r){var a=this;return function(o,s){t&&o&&o.preventDefault&&o.preventDefault(),e.actions instanceof Array&&e.actions.forEach(function(t){var n={actionData:t,metadata:e.metadata,uiEvent:o};r&&(n.groupID=r),s&&(n.formEl=s),a.events.trigger({eventName:t.type,data:n})})}}}]),e}();u.TYPES=c,t.default=u},function(e,t,r){t=e.exports=r(78)(!1),t.push([e.i,'/**\n*   The following styles are given by the json pollock library\n*   In order to override it use a different css file\n*   PLEASE DO NOT MAKE ANY CHANGE IN THIS FILE\n**/\n.lp-json-pollock {\n  position: relative; }\n  .lp-json-pollock.lp-json-pollock-single-element {\n    border: solid 1px #d4d4d5;\n    border-collapse: collapse;\n    max-width: 200px;\n    background: white; }\n  .lp-json-pollock .lp-json-pollock-layout {\n    border: solid 1px #d4d4d5;\n    border-collapse: collapse;\n    width: 100%;\n    max-width: 200px;\n    background: white; }\n  .lp-json-pollock .lp-json-pollock-layout-borderLess {\n    border: none; }\n  .lp-json-pollock .lp-json-pollock-layout-dropShadow {\n    border: none;\n    filter: drop-shadow(0px 5px 5px #aaa); }\n  .lp-json-pollock .lp-json-pollock-layout-vertical-scroll {\n    overflow-y: scroll; }\n  .lp-json-pollock .lp-json-pollock-layout-vertical {\n    display: grid; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical > .lp-json-pollock-layout {\n      border: none; }\n      .lp-json-pollock .lp-json-pollock-layout-vertical > .lp-json-pollock-layout:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess):not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-dropShadow):not(:first-child) {\n        border-top: solid 1px #d4d4d5; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical.lp-json-pollock-layout-borderLess > .lp-json-pollock-layout:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess):not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-dropShadow) {\n      border: solid 1px #d4d4d5; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical:not(.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-button:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-vertical:not(.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-image:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-vertical:not(.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-map:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-vertical:not(.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-text:not(:first-child) {\n      border-top: solid 1px #d4d4d5; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical:not(.lp-json-pollock-layout-borderLess) .lp-json-pollock-element-text + .lp-json-pollock-element-text {\n      border-top: none; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical .lp-json-pollock-element-text + .lp-json-pollock-element-text {\n      border-top: none; }\n    .lp-json-pollock .lp-json-pollock-layout-vertical > *:first-child {\n      border-top: none; }\n  .lp-json-pollock .lp-json-pollock-layout-horizontal {\n    display: table; }\n    .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-layout {\n      border: none; }\n      .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-layout:not(:first-child) {\n        border-left: solid 1px #d4d4d5; }\n    .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-button:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-text:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-image:not(:first-child), .lp-json-pollock .lp-json-pollock-layout-horizontal:not(.lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess) > .lp-json-pollock-element-map:not(:first-child) {\n      border-left: solid 1px #d4d4d5; }\n    .lp-json-pollock .lp-json-pollock-layout-horizontal > * {\n      display: table-cell;\n      table-layout: fixed;\n      vertical-align: middle; }\n    .lp-json-pollock .lp-json-pollock-layout-horizontal > *:first-child {\n      border-left: none; }\n  .lp-json-pollock .lp-json-pollock-layout-horizontal.lp-json-pollock-layout-borderLess {\n    border: none; }\n  .lp-json-pollock .lp-json-pollock-layout-form {\n    border: none;\n    border-collapse: collapse; }\n    .lp-json-pollock .lp-json-pollock-layout-form > .lp-json-pollock-element-text {\n      padding-top: 5%;\n      padding-left: 12px;\n      color: #000000;\n      font-size: 17px;\n      word-wrap: break-word;\n      word-break: break-word; }\n    .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section {\n      border: none;\n      margin-bottom: 1%; }\n      .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section .lp-json-pollock-element-text {\n        padding-left: 12px;\n        color: #000000;\n        font-size: 13px;\n        word-wrap: break-word;\n        word-break: break-word; }\n      .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section .lp-json-pollock-layout-checklist > .lp-json-pollock-element-checkbox > .lp-json-pollock-border-element {\n        border-top: solid 1px #d4d4d5;\n        width: 90%;\n        margin: 0px 5%;\n        padding: 0.5px 0px; }\n      .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section .lp-json-pollock-layout-checklist > .lp-json-pollock-element-checkbox .lp-json-pollock-element-checkbox-wrapper {\n        padding: 3px 12px 3px 12px; }\n        .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section .lp-json-pollock-layout-checklist > .lp-json-pollock-element-checkbox .lp-json-pollock-element-checkbox-wrapper .lp-json-pollock-element-checkbox-label {\n          padding: 0px 6px;\n          color: #000000;\n          font-size: 13px;\n          word-wrap: break-word;\n          word-break: break-word;\n          display: inline-block;\n          vertical-align: top;\n          width: 85%; }\n        .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-sectionList .lp-json-pollock-layout-section .lp-json-pollock-layout-checklist > .lp-json-pollock-element-checkbox .lp-json-pollock-element-checkbox-wrapper .lp-json-pollock-element-checkbox-input {\n          display: inline-block;\n          vertical-align: 1.5px;\n          font-size: 13px;\n          width: 13px;\n          height: 13px;\n          margin: 0; }\n    .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList {\n      margin: 8% 20% 5% 20%; }\n      .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-submit-button {\n        margin: 6% 0%;\n        word-break: break-word;\n        word-wrap: break-word;\n        background-color: #0363ad; }\n        .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-submit-button input[type="submit"] {\n          border: solid 1px #d4d4d5;\n          background: none;\n          width: 100%;\n          min-height: 32px;\n          text-align: center;\n          color: #ffffff; }\n          .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-submit-button input[type="submit"]:disabled.lp-json-pollock-element-submit-button-disabled {\n            background-color: #f0f0f0;\n            color: #aaaaaa; }\n      .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-button {\n        margin: 6% 0%;\n        word-break: break-word;\n        word-wrap: break-word; }\n        .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-button button {\n          border: solid 1px #d4d4d5;\n          background: none;\n          width: 100%;\n          min-height: 32px;\n          text-align: center;\n          color: #0363ad;\n          padding: 0px; }\n          .lp-json-pollock .lp-json-pollock-layout-form .lp-json-pollock-layout-buttonList .lp-json-pollock-element-button button:active {\n            background: #f0f0f0; }\n  .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper {\n    overflow: hidden;\n    position: relative;\n    direction: ltr; }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper:hover .lp-json-pollock-layout-carousel-arrow {\n      opacity: 1; }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow {\n      opacity: 0.8;\n      z-index: 1;\n      right: 0px;\n      cursor: pointer;\n      position: absolute;\n      width: 36px;\n      height: 36px;\n      top: calc(50% - 18px);\n      border-radius: 50%;\n      border: solid 1px #d4d4d5;\n      background-color: #ffffff;\n      text-align: center;\n      padding: 0;\n      fill: #025494; }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow.left {\n        visibility: hidden;\n        left: 0px; }\n        .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow.left .lp-json-pollock-layout-carousel-arrow-icon {\n          transform: rotate(180deg);\n          left: calc(50% - 5px); }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow:active {\n        outline: none;\n        border: solid 1px #0363ad; }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow:hover {\n        outline: none;\n        fill: #ffffff;\n        border: solid 1px #0363ad;\n        background-color: #0363ad; }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow:focus {\n        outline: none;\n        border: solid 1px #0363ad; }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper > .lp-json-pollock-layout-carousel-arrow .lp-json-pollock-layout-carousel-arrow-icon {\n        width: 9px;\n        height: 14px;\n        position: absolute;\n        left: calc(50% - 4px);\n        top: calc(50% - 7px); }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper .lp-json-pollock-layout-carousel {\n      left: 0px;\n      transition: left .5s;\n      -webkit-transition: left .5s;\n      -moz-transition: left .5s;\n      -ms-transition: left .5s;\n      -o-transition: left .5s;\n      white-space: nowrap;\n      position: relative; }\n      .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper .lp-json-pollock-layout-carousel > * {\n        border: solid 1px #d4d4d5;\n        display: inline-block;\n        width: 180px;\n        vertical-align: top; }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper .lp-json-pollock-layout-carousel-select {\n      position: initial;\n      overflow: auto; }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper .lp-json-pollock-element-text {\n      white-space: normal; }\n    .lp-json-pollock .lp-json-pollock-layout-carousel-wrapper .lp-json-pollock-layout.lp-json-pollock-layout-selected {\n      border-color: #1aad12; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-tab {\n    border-bottom: 1px solid solid 1px #d4d4d5; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-header {\n    display: flex;\n    align-items: center; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-checkbox {\n    margin-right: 8px; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-title {\n    font-weight: bold; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-additional {\n    margin-left: auto; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-folded {\n    display: none; }\n  .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-arrow {\n    width: 12px;\n    height: 12px;\n    margin-left: 8px; }\n    .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-arrow.close {\n      transform: rotate(90deg); }\n    .lp-json-pollock .lp-json-pollock-layout-accordion-wrapper .lp-json-pollock-layout-accordion-arrow.open {\n      transform: rotate(270deg); }\n  .lp-json-pollock .lp-json-pollock-element-text {\n    padding: 5px 10px;\n    color: #000000;\n    font-size: 13px;\n    word-wrap: break-word;\n    word-break: break-word; }\n  .lp-json-pollock .lp-json-pollock-element-button {\n    width: 100%;\n    word-break: break-word;\n    word-wrap: break-word; }\n    .lp-json-pollock .lp-json-pollock-element-button .lp-json-pollock-element-button-button.class-button {\n      border-radius: 50px;\n      border: solid 1px #d4d4d5;\n      width: calc(100% - 20px);\n      margin: 10px auto;\n      overflow: hidden; }\n      .lp-json-pollock .lp-json-pollock-element-button .lp-json-pollock-element-button-button.class-button:focus-within {\n        border: 2px solid #0363ad; }\n        .lp-json-pollock .lp-json-pollock-element-button .lp-json-pollock-element-button-button.class-button:focus-within button {\n          outline: none; }\n    .lp-json-pollock .lp-json-pollock-element-button button {\n      border: none;\n      background: none;\n      width: 100%;\n      min-height: 32px;\n      margin-bottom: 2px;\n      text-align: center;\n      color: #0363ad;\n      padding: 10px;\n      white-space: pre-wrap;\n      cursor: pointer; }\n      .lp-json-pollock .lp-json-pollock-element-button button:active {\n        background: #f0f0f0; }\n      .lp-json-pollock .lp-json-pollock-element-button button .lp-json-pollock-element-button-subtitle {\n        font-style: italic;\n        clear: both;\n        display: inline-block;\n        width: 100%; }\n  .lp-json-pollock .lp-json-pollock-element-image.loading {\n    background-image: url("data:image/gif;base64,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");\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 154px; }\n  .lp-json-pollock .lp-json-pollock-element-image.error {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAYAAABpRpp6AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QUYCiwdGyEQJgAAA/BJREFUWMPNmL+LXFUUxz8zbCESdQUrC9lGxSpj/AO819qESSdJxCGNjcHNriCisBOCTTRhgpIihU4kbkRQHo7Yybm7EruQQbQJiMMKi4XimAjaafN98nJz78ybyU7wNI99c++73/M93/PjboM9NrPQAtrA2HvX2+vvL+0BwGUBdHo+BPwBrLAAW7pLFtvAfmALKIC+nh3v3XgRgBtzsjgGgsCFEpxZKAC8d20WZEtTWHRAJ2Kx570bJtaXDq3MGK0O8GGNpeeBbiNi0VWYJMXihAiMJIViBrA9EeJSJFTWrQjHsFHxsqdD+wI4nOHgmaQgB/uKRtt7N6q55/eG0P8EeO9dmCMB2+XhdRJNBwflQXuW5DQLwyWF5NKcYEumOjXBtkqZee86c+TcuEy6eUtQVw2iqJlcPWDVe9dP/N4FVlXHt7TuDlk2gWElyWa1HrBsFvpTwK5qbScDtldJ9ofLRJdcbwcsdvYrvDOZksUBbYHKmZMMikwFeLWsFN67sqUXYvwOhlEI5ir2CpsDugp7ylaBl1KMqVJsJXKgD7RygMNdyKIKupcCrUiclyxiGwHPJiLckVyTgIscYLOwkmEmBTpMiFQXcGbBZZz5T7OSVzvlYLNy2HIG2CfAd2bhdI16XLbylENjAehmnAnA0Cz8U+l+o+zwo24VqjOsWTgKvKMPrgP3Ay/GNVuODqe1ZtXh68DTs3TSyv7QrPx9myykqTPAWeAacAT4FBiYhc1Ic32gPwVsRyyenAdsaloLkWbeAH7R+9I2gYEY3zELa8C+ciaoMeS05+mo2XnYLIz04ZHmi0PAbmbvM8DbwCO5ECsKBbAcDzlm4ThwGDhRZ/hJSaJa3jaBixPAIpmMgTMZsC1gB7gZJ5DA9oBbSui1ugzHgAvgBYX4ypS968Df3rvXE2CPA9vAt/FQXwH7svLjNWDdLHxZp9umGH4SuCDvmSCH54GDCbCnBegU8CZwDtg2C60I7I1KpI4qF3biOj3xiuS9G5uFH4C/Jux5ANjQNDWK9HoZeDwCNNBzW8/qb6XdUsQOAl+YhUveuxN173QmBsOEjnXde/dBpNfLwK8CFEdnoHe7CbDxumvAu2bhe+BYnB/NxKbPgAMTpq4DwLGow20DV8VSTkphCtjSdlXzr0pKa1Ov+WqPcUl7FPgYOFTWUrNwCjgpnQ4WcKt/Qon5o+QyzF3zv5IsqoA3gI+8d0F6fR94LqPJvbIbYnsd+BnY18ws/FqASzsC3Ae8pbnhG+ApvV8U2GpCXgR+A67kGP5coSjb8Zq62Vij34PAY0rQe2E39c+WbmNCG3wPeAX4Ezjnvdvg/25mwU25q91z+xfs9+kVfxd53AAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 154px; }\n  .lp-json-pollock .lp-json-pollock-element-image img {\n    display: block;\n    width: 100%;\n    height: auto; }\n  .lp-json-pollock .lp-json-pollock-element-map {\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: cover;\n    height: 154px;\n    background-image: url("data:image/png;base64,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"); }\n  .lp-json-pollock .direction-rtl {\n    direction: rtl;\n    float: none;\n    text-align: right; }\n  .lp-json-pollock .lp-json-pollock-element-tab {\n    overflow: hidden; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button {\n    background-color: inherit;\n    color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 0.4rem 0.4rem; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button-size-small {\n    font-size: 11px; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button-size-medium {\n    font-size: 13px; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button-size-large {\n    font-size: 14px; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button:hover {\n    background-color: #ddd; }\n  .lp-json-pollock .lp-json-pollock-element-tab-button.active {\n    background-color: #ccc;\n    border-bottom: 1px solid #555; }\n',""])},function(e,t){function r(e,t){var r=e[1]||"",o=e[3];if(!o)return r;if(t&&"function"==typeof btoa){var s=a(o);return[r].concat(o.sources.map(function(e){return"/*# sourceURL="+o.sourceRoot+e+" */"})).concat([s]).join("\n")}return[r].join("\n")}function a(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var a=r(t,e);return t[2]?"@media "+t[2]+"{"+a+"}":a}).join("")},t.i=function(e,r){"string"==typeof e&&(e=[[null,e,""]]);for(var a={},o=0;o<this.length;o++){var s=this[o][0];"number"==typeof s&&(a[s]=!0)}for(o=0;o<e.length;o++){var n=e[o];"number"==typeof n[0]&&a[n[0]]||(r&&!n[2]?n[2]=r:r&&(n[2]="("+n[2]+") and ("+r+")"),t.push(n))}},t}},function(e,t,r){"use strict";function a(e,t,r,n,i,l,c,p,u){if(r&&"object"==typeof r&&!Array.isArray(r)){t(r,n,i,l,c,p,u);for(var d in r){var h=r[d];if(Array.isArray(h)){if(d in s.arrayKeywords)for(var f=0;f<h.length;f++)a(e,t,h[f],n+"/"+d+"/"+f,i,n,d,r,f)}else if(d in s.propsKeywords){if(h&&"object"==typeof h)for(var m in h)a(e,t,h[m],n+"/"+d+"/"+o(m),i,n,d,r,m)}else(d in s.keywords||e.allKeys&&!(d in s.skipKeywords))&&a(e,t,h,n+"/"+d,i,n,d,r)}}}function o(e){return e.replace(/~/g,"~0").replace(/\//g,"~1")}var s=e.exports=function(e,t,r){"function"==typeof t&&(r=t,t={}),a(t,r,e,"",e)};s.keywords={additionalItems:!0,items:!0,contains:!0,additionalProperties:!0,propertyNames:!0,not:!0},s.arrayKeywords={items:!0,allOf:!0,anyOf:!0,oneOf:!0},s.propsKeywords={definitions:!0,properties:!0,patternProperties:!0,dependencies:!0},s.skipKeywords={enum:!0,const:!0,required:!0,maximum:!0,minimum:!0,exclusiveMaximum:!0,exclusiveMinimum:!0,multipleOf:!0,maxLength:!0,minLength:!0,pattern:!0,format:!0,maxItems:!0,minItems:!0,uniqueItems:!0,maxProperties:!0,minProperties:!0}},function(e,t,r){(function(e,a){var o;!function(s){function n(e){throw new RangeError(Q[e])}function i(e,t){for(var r=e.length,a=[];r--;)a[r]=t(e[r]);return a}function l(e,t){var r=e.split("@"),a="";return r.length>1&&(a=r[0]+"@",e=r[1]),e=e.replace(D,"."),a+i(e.split("."),t).join(".")}function c(e){for(var t,r,a=[],o=0,s=e.length;o<s;)t=e.charCodeAt(o++),t>=55296&&t<=56319&&o<s?(r=e.charCodeAt(o++),56320==(64512&r)?a.push(((1023&t)<<10)+(1023&r)+65536):(a.push(t),o--)):a.push(t);return a}function p(e){return i(e,function(e){var t="";return e>65535&&(e-=65536,t+=R(e>>>10&1023|55296),e=56320|1023&e),t+=R(e)}).join("")}function u(e){return e-48<10?e-22:e-65<26?e-65:e-97<26?e-97:w}function d(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function h(e,t,r){var a=0;for(e=r?B(e/k):e>>1,e+=B(e/t);e>F*j>>1;a+=w)e=B(e/F);return B(a+(F+1)*e/(e+x))}function f(e){var t,r,a,o,s,i,l,c,d,f,m=[],y=e.length,v=0,g=C,A=P;for(r=e.lastIndexOf(L),r<0&&(r=0),a=0;a<r;++a)e.charCodeAt(a)>=128&&n("not-basic"),m.push(e.charCodeAt(a));for(o=r>0?r+1:0;o<y;){for(s=v,i=1,l=w;o>=y&&n("invalid-input"),c=u(e.charCodeAt(o++)),(c>=w||c>B((b-v)/i))&&n("overflow"),v+=c*i,d=l<=A?E:l>=A+j?j:l-A,!(c<d);l+=w)f=w-d,i>B(b/f)&&n("overflow"),i*=f;t=m.length+1,A=h(v-s,t,0==s),B(v/t)>b-g&&n("overflow"),g+=B(v/t),v%=t,m.splice(v++,0,g)}return p(m)}function m(e){var t,r,a,o,s,i,l,p,u,f,m,y,v,g,A,x=[];for(e=c(e),y=e.length,t=C,r=0,s=P,i=0;i<y;++i)(m=e[i])<128&&x.push(R(m));for(a=o=x.length,o&&x.push(L);a<y;){for(l=b,i=0;i<y;++i)(m=e[i])>=t&&m<l&&(l=m);for(v=a+1,l-t>B((b-r)/v)&&n("overflow"),r+=(l-t)*v,t=l,i=0;i<y;++i)if(m=e[i],m<t&&++r>b&&n("overflow"),m==t){for(p=r,u=w;f=u<=s?E:u>=s+j?j:u-s,!(p<f);u+=w)A=p-f,g=w-f,x.push(R(d(f+A%g,0))),p=B(A/g);x.push(R(d(p,0))),s=h(r,v,a==o),r=0,++a}++r,++t}return x.join("")}function y(e){return l(e,function(e){return I.test(e)?f(e.slice(4).toLowerCase()):e})}function v(e){return l(e,function(e){return S.test(e)?"xn--"+m(e):e})}var g=("object"==typeof t&&t&&t.nodeType,"object"==typeof e&&e&&e.nodeType,"object"==typeof a&&a);var A,b=2147483647,w=36,E=1,j=26,x=38,k=700,P=72,C=128,L="-",I=/^xn--/,S=/[^\x20-\x7E]/,D=/[\x2E\u3002\uFF0E\uFF61]/g,Q={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},F=w-E,B=Math.floor,R=String.fromCharCode;A={version:"1.4.1",ucs2:{decode:c,encode:p},decode:f,encode:m,toASCII:v,toUnicode:y},void 0!==(o=function(){return A}.call(t,r,t,e))&&(e.exports=o)}()}).call(t,r(90)(e),r(89))},function(e,t,r){"use strict";function a(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,r,s){t=t||"&",r=r||"=";var n={};if("string"!=typeof e||0===e.length)return n;var i=/\+/g;e=e.split(t);var l=1e3;s&&"number"==typeof s.maxKeys&&(l=s.maxKeys);var c=e.length;l>0&&c>l&&(c=l);for(var p=0;p<c;++p){var u,d,h,f,m=e[p].replace(i,"%20"),y=m.indexOf(r);y>=0?(u=m.substr(0,y),d=m.substr(y+1)):(u=m,d=""),h=decodeURIComponent(u),f=decodeURIComponent(d),a(n,h)?o(n[h])?n[h].push(f):n[h]=[n[h],f]:n[h]=f}return n};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,r){"use strict";function a(e,t){if(e.map)return e.map(t);for(var r=[],a=0;a<e.length;a++)r.push(t(e[a],a));return r}var o=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,r,i){return t=t||"&",r=r||"=",null===e&&(e=void 0),"object"==typeof e?a(n(e),function(n){var i=encodeURIComponent(o(n))+r;return s(e[n])?a(e[n],function(e){return i+encodeURIComponent(o(e))}).join(t):i+encodeURIComponent(o(e[n]))}).join(t):i?encodeURIComponent(o(i))+r+encodeURIComponent(o(e)):""};var s=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)},n=Object.keys||function(e){var t=[];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.push(r);return t}},function(e,t,r){"use strict";t.decode=t.parse=r(81),t.encode=t.stringify=r(82)},function(e,t,r){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.TEMPLATE_TYPES=t.version=t.validate=t.unregisterAllActions=t.unregisterAction=t.registerAction=t.render=t.init=void 0;var o=r(16),s=(a(o),r(14)),n=a(s),i=r(15),l=a(i),c=new n.default(new l.default),p=c.init.bind(c),u=c.render.bind(c),d=c.registerAction.bind(c),h=c.unregisterAction.bind(c),f=c.unregisterAllActions.bind(c),m=c.validate.bind(c),y=n.default.TEMPLATE_TYPES;t.init=p,t.render=u,t.registerAction=d,t.unregisterAction=h,t.unregisterAllActions=f,t.validate=m,t.version="1.7.7",t.TEMPLATE_TYPES=y},function(e,t,r){function a(e,t){for(var r=0;r<e.length;r++){var a=e[r],o=f[a.id];if(o){o.refs++;for(var s=0;s<o.parts.length;s++)o.parts[s](a.parts[s]);for(;s<a.parts.length;s++)o.parts.push(p(a.parts[s],t))}else{for(var n=[],s=0;s<a.parts.length;s++)n.push(p(a.parts[s],t));f[a.id]={id:a.id,refs:1,parts:n}}}}function o(e,t){for(var r=[],a={},o=0;o<e.length;o++){var s=e[o],n=t.base?s[0]+t.base:s[0],i=s[1],l=s[2],c=s[3],p={css:i,media:l,sourceMap:c};a[n]?a[n].parts.push(p):r.push(a[n]={id:n,parts:[p]})}return r}function s(e,t){var r=y(e.insertInto);if(!r)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var a=A[A.length-1];if("top"===e.insertAt)a?a.nextSibling?r.insertBefore(t,a.nextSibling):r.appendChild(t):r.insertBefore(t,r.firstChild),A.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");r.appendChild(t)}}function n(e){e.parentNode.removeChild(e);var t=A.indexOf(e);t>=0&&A.splice(t,1)}function i(e){var t=document.createElement("style");return e.attrs.type="text/css",c(t,e.attrs),s(e,t),t}function l(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",c(t,e.attrs),s(e,t),t}function c(e,t){Object.keys(t).forEach(function(r){e.setAttribute(r,t[r])})}function p(e,t){var r,a,o,s;if(t.transform&&e.css){if(!(s=t.transform(e.css)))return function(){};e.css=s}if(t.singleton){var c=g++;r=v||(v=i(t)),a=u.bind(null,r,c,!1),o=u.bind(null,r,c,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(r=l(t),a=h.bind(null,r,t),o=function(){n(r),r.href&&URL.revokeObjectURL(r.href)}):(r=i(t),a=d.bind(null,r),o=function(){n(r)});return a(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;a(e=t)}else o()}}function u(e,t,r,a){var o=r?"":a.css;if(e.styleSheet)e.styleSheet.cssText=w(t,o);else{var s=document.createTextNode(o),n=e.childNodes;n[t]&&e.removeChild(n[t]),n.length?e.insertBefore(s,n[t]):e.appendChild(s)}}function d(e,t){var r=t.css,a=t.media;if(a&&e.setAttribute("media",a),e.styleSheet)e.styleSheet.cssText=r;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r))}}function h(e,t,r){var a=r.css,o=r.sourceMap,s=void 0===t.convertToAbsoluteUrls&&o;(t.convertToAbsoluteUrls||s)&&(a=b(a)),o&&(a+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");var n=new Blob([a],{type:"text/css"}),i=e.href;e.href=URL.createObjectURL(n),i&&URL.revokeObjectURL(i)}var f={},m=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return window&&document&&document.all&&!window.atob}),y=function(e){var t={};return function(r){return void 0===t[r]&&(t[r]=e.call(this,r)),t[r]}}(function(e){return document.querySelector(e)}),v=null,g=0,A=[],b=r(86);e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");t=t||{},t.attrs="object"==typeof t.attrs?t.attrs:{},void 0===t.singleton&&(t.singleton=m()),void 0===t.insertInto&&(t.insertInto="head"),void 0===t.insertAt&&(t.insertAt="bottom");var r=o(e,t);return a(r,t),function(e){for(var s=[],n=0;n<r.length;n++){var i=r[n],l=f[i.id];l.refs--,s.push(l)}if(e){a(o(e,t),t)}for(var n=0;n<s.length;n++){var l=s[n];if(0===l.refs){for(var c=0;c<l.parts.length;c++)l.parts[c]();delete f[l.id]}}}};var w=function(){var e=[];return function(t,r){return e[t]=r,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var r=t.protocol+"//"+t.host,a=r+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var o=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o))return e;var s;return s=0===o.indexOf("//")?o:0===o.indexOf("/")?r+o:a+o.replace(/^\.\//,""),"url("+JSON.stringify(s)+")"})}},function(e,t,r){"use strict";function a(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function o(e,t,r){if(e&&c.isObject(e)&&e instanceof a)return e;var o=new a;return o.parse(e,t,r),o}function s(e){return c.isString(e)&&(e=o(e)),e instanceof a?e.format():a.prototype.format.call(e)}function n(e,t){return o(e,!1,!0).resolve(t)}function i(e,t){return e?o(e,!1,!0).resolveObject(t):t}var l=r(80),c=r(88);t.parse=o,t.resolve=n,t.resolveObject=i,t.format=s,t.Url=a;var p=/^([a-z0-9.+-]+:)/i,u=/:[0-9]*$/,d=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,h=["<",">",'"',"`"," ","\r","\n","\t"],f=["{","}","|","\\","^","`"].concat(h),m=["'"].concat(f),y=["%","/","?",";","#"].concat(m),v=["/","?","#"],g=/^[+a-z0-9A-Z_-]{0,63}$/,A=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,b={javascript:!0,"javascript:":!0},w={javascript:!0,"javascript:":!0},E={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},j=r(83);a.prototype.parse=function(e,t,r){if(!c.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var a=e.indexOf("?"),o=-1!==a&&a<e.indexOf("#")?"?":"#",s=e.split(o),n=/\\/g;s[0]=s[0].replace(n,"/"),e=s.join(o);var i=e;if(i=i.trim(),!r&&1===e.split("#").length){var u=d.exec(i);if(u)return this.path=i,this.href=i,this.pathname=u[1],u[2]?(this.search=u[2],this.query=t?j.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var h=p.exec(i);if(h){h=h[0];var f=h.toLowerCase();this.protocol=f,i=i.substr(h.length)}if(r||h||i.match(/^\/\/[^@\/]+@[^@\/]+/)){var x="//"===i.substr(0,2);!x||h&&w[h]||(i=i.substr(2),this.slashes=!0)}if(!w[h]&&(x||h&&!E[h])){for(var k=-1,P=0;P<v.length;P++){var C=i.indexOf(v[P]);-1!==C&&(-1===k||C<k)&&(k=C)}var L,I;I=-1===k?i.lastIndexOf("@"):i.lastIndexOf("@",k),-1!==I&&(L=i.slice(0,I),i=i.slice(I+1),this.auth=decodeURIComponent(L)),k=-1;for(var P=0;P<y.length;P++){var C=i.indexOf(y[P]);-1!==C&&(-1===k||C<k)&&(k=C)}-1===k&&(k=i.length),this.host=i.slice(0,k),i=i.slice(k),this.parseHost(),this.hostname=this.hostname||"";var S="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!S)for(var D=this.hostname.split(/\./),P=0,Q=D.length;P<Q;P++){var F=D[P];if(F&&!F.match(g)){for(var B="",R=0,N=F.length;R<N;R++)F.charCodeAt(R)>127?B+="x":B+=F[R];if(!B.match(g)){var O=D.slice(0,P),M=D.slice(P+1),U=F.match(A);U&&(O.push(U[1]),M.unshift(U[2])),M.length&&(i="/"+M.join(".")+i),this.hostname=O.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),S||(this.hostname=l.toASCII(this.hostname));var T=this.port?":"+this.port:"",z=this.hostname||"";this.host=z+T,this.href+=this.host,S&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==i[0]&&(i="/"+i))}if(!b[f])for(var P=0,Q=m.length;P<Q;P++){var H=m[P];if(-1!==i.indexOf(H)){var G=encodeURIComponent(H);G===H&&(G=escape(H)),i=i.split(H).join(G)}}var Y=i.indexOf("#");-1!==Y&&(this.hash=i.substr(Y),i=i.slice(0,Y));var q=i.indexOf("?");if(-1!==q?(this.search=i.substr(q),this.query=i.substr(q+1),t&&(this.query=j.parse(this.query)),i=i.slice(0,q)):t&&(this.search="",this.query={}),i&&(this.pathname=i),E[f]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var T=this.pathname||"",K=this.search||"";this.path=T+K}return this.href=this.format(),this},a.prototype.format=function(){var e=this.auth||"";e&&(e=encodeURIComponent(e),e=e.replace(/%3A/i,":"),e+="@");var t=this.protocol||"",r=this.pathname||"",a=this.hash||"",o=!1,s="";this.host?o=e+this.host:this.hostname&&(o=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(o+=":"+this.port)),this.query&&c.isObject(this.query)&&Object.keys(this.query).length&&(s=j.stringify(this.query));var n=this.search||s&&"?"+s||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||E[t])&&!1!==o?(o="//"+(o||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):o||(o=""),a&&"#"!==a.charAt(0)&&(a="#"+a),n&&"?"!==n.charAt(0)&&(n="?"+n),r=r.replace(/[?#]/g,function(e){return encodeURIComponent(e)}),n=n.replace("#","%23"),t+o+r+n+a},a.prototype.resolve=function(e){return this.resolveObject(o(e,!1,!0)).format()},a.prototype.resolveObject=function(e){if(c.isString(e)){var t=new a;t.parse(e,!1,!0),e=t}for(var r=new a,o=Object.keys(this),s=0;s<o.length;s++){var n=o[s];r[n]=this[n]}if(r.hash=e.hash,""===e.href)return r.href=r.format(),r;if(e.slashes&&!e.protocol){for(var i=Object.keys(e),l=0;l<i.length;l++){var p=i[l];"protocol"!==p&&(r[p]=e[p])}return E[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(e.protocol&&e.protocol!==r.protocol){if(!E[e.protocol]){for(var u=Object.keys(e),d=0;d<u.length;d++){var h=u[d];r[h]=e[h]}return r.href=r.format(),r}if(r.protocol=e.protocol,e.host||w[e.protocol])r.pathname=e.pathname;else{for(var f=(e.pathname||"").split("/");f.length&&!(e.host=f.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==f[0]&&f.unshift(""),f.length<2&&f.unshift(""),r.pathname=f.join("/")}if(r.search=e.search,r.query=e.query,r.host=e.host||"",r.auth=e.auth,r.hostname=e.hostname||e.host,r.port=e.port,r.pathname||r.search){var m=r.pathname||"",y=r.search||"";r.path=m+y}return r.slashes=r.slashes||e.slashes,r.href=r.format(),r}var v=r.pathname&&"/"===r.pathname.charAt(0),g=e.host||e.pathname&&"/"===e.pathname.charAt(0),A=g||v||r.host&&e.pathname,b=A,j=r.pathname&&r.pathname.split("/")||[],f=e.pathname&&e.pathname.split("/")||[],x=r.protocol&&!E[r.protocol];if(x&&(r.hostname="",r.port=null,r.host&&(""===j[0]?j[0]=r.host:j.unshift(r.host)),r.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===f[0]?f[0]=e.host:f.unshift(e.host)),e.host=null),A=A&&(""===f[0]||""===j[0])),g)r.host=e.host||""===e.host?e.host:r.host,r.hostname=e.hostname||""===e.hostname?e.hostname:r.hostname,r.search=e.search,r.query=e.query,j=f;else if(f.length)j||(j=[]),j.pop(),j=j.concat(f),r.search=e.search,r.query=e.query;else if(!c.isNullOrUndefined(e.search)){if(x){r.hostname=r.host=j.shift();var k=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@");k&&(r.auth=k.shift(),r.host=r.hostname=k.shift())}return r.search=e.search,r.query=e.query,c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!j.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var P=j.slice(-1)[0],C=(r.host||e.host||j.length>1)&&("."===P||".."===P)||""===P,L=0,I=j.length;I>=0;I--)P=j[I],"."===P?j.splice(I,1):".."===P?(j.splice(I,1),L++):L&&(j.splice(I,1),L--);if(!A&&!b)for(;L--;L)j.unshift("..");!A||""===j[0]||j[0]&&"/"===j[0].charAt(0)||j.unshift(""),C&&"/"!==j.join("/").substr(-1)&&j.push("");var S=""===j[0]||j[0]&&"/"===j[0].charAt(0);if(x){r.hostname=r.host=S?"":j.length?j.shift():"";var k=!!(r.host&&r.host.indexOf("@")>0)&&r.host.split("@");k&&(r.auth=k.shift(),r.host=r.hostname=k.shift())}return A=A||r.host&&j.length,A&&!S&&j.unshift(""),j.length?r.pathname=j.join("/"):(r.pathname=null,r.path=null),c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=e.auth||r.auth,r.slashes=r.slashes||e.slashes,r.href=r.format(),r},a.prototype.parseHost=function(){var e=this.host,t=u.exec(e);t&&(t=t[0],":"!==t&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,r){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}}])});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"jsonPollock",staticClass:"json-pollock-component"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chips_component_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248fac42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chips_component_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chips_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248fac42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chips_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("70a326a6", content, true, {});

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports
exports.i(__webpack_require__(702), "");

// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"chips-component.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".chips-wrapper{position:relative;overflow:hidden;padding:0 10px}.chips-wrapper.chips-readonly .chips-slider .chips-row .chips-item{cursor:default}.chips-wrapper .chips-slider{position:relative;transition:left .14s}.chips-wrapper .chips-row{display:flex;height:32px;margin:10px 0}.chips-wrapper .chips-row>.chips-item{flex-shrink:0;margin:0 10px 0 0;padding:0 10px;border:1px solid #d6d6d6;border-radius:16px;line-height:30px;font-size:12px;white-space:nowrap;outline:0 none;color:#4d4e4e;background:transparent none;cursor:pointer}.chips-wrapper .chips-row>.chips-item:focus{outline:2px solid #3a61d4}.chips-wrapper .chips-row>.chips-item:last-of-type{margin-right:0}.chips-wrapper .chips-nav{position:absolute;top:calc(50% - 20px);z-index:1;display:block;width:30px;height:40px;background-color:#e0e0e0;cursor:pointer}.chips-wrapper .chips-nav.chips-nav-left{left:0;border-top-right-radius:3.75px;border-bottom-right-radius:3.75px}.chips-wrapper .chips-nav.chips-nav-right{right:0;border-top-left-radius:3.75px;border-bottom-left-radius:3.75px}.chips-wrapper .chips-nav:after,.chips-wrapper .chips-nav:before{content:\"\";position:absolute;width:1px;height:12px;background-color:#525050}.chips-wrapper .chips-nav:before{top:8px;transform-origin:.5px 100%}.chips-wrapper .chips-nav:after{bottom:8px;transform-origin:.5px 0}.chips-wrapper .chips-nav.chips-nav-left:after,.chips-wrapper .chips-nav.chips-nav-left:before{left:10px}.chips-wrapper .chips-nav.chips-nav-right:after,.chips-wrapper .chips-nav.chips-nav-right:before{right:10px}.chips-wrapper .chips-nav.chips-nav-left:before,.chips-wrapper .chips-nav.chips-nav-right:after{transform:rotate(45deg)}.chips-wrapper .chips-nav.chips-nav-left:after,.chips-wrapper .chips-nav.chips-nav-right:before{transform:rotate(-45deg)}@keyframes nodeInserted{0%{opacity:.99}to{opacity:1}}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/node_modules/@liveperson/chips/dist/lib/chips.min.css"],"names":[],"mappings":"AAAA,eAAe,kBAAkB,gBAAgB,cAAc,CAAC,mEAAmE,cAAc,CAAC,6BAA6B,kBAAkB,oBAAoB,CAAC,0BAA0B,aAAa,YAAY,aAAa,CAAC,sCAAsC,cAAc,kBAAkB,eAAe,yBAAyB,mBAAmB,iBAAiB,eAAe,mBAAmB,eAAe,cAAc,4BAA4B,cAAc,CAAC,4CAA4C,yBAAyB,CAAC,mDAAmD,cAAc,CAAC,0BAA0B,kBAAkB,qBAAqB,UAAU,cAAc,WAAW,YAAY,yBAAyB,cAAc,CAAC,yCAAyC,OAAO,+BAA+B,iCAAiC,CAAC,0CAA0C,QAAQ,8BAA8B,gCAAgC,CAAC,iEAAiE,WAAW,kBAAkB,UAAU,YAAY,wBAAwB,CAAC,iCAAiC,QAAQ,0BAA0B,CAAC,gCAAgC,WAAW,uBAAuB,CAAC,+FAA+F,SAAS,CAAC,iGAAiG,UAAU,CAAC,gGAAgG,uBAAuB,CAAC,gGAAgG,wBAAwB,CAAC,wBAAwB,GAAG,WAAW,CAAC,GAAG,SAAS,CAAC,CAAC","file":"chips.min.css","sourcesContent":[".chips-wrapper{position:relative;overflow:hidden;padding:0 10px}.chips-wrapper.chips-readonly .chips-slider .chips-row .chips-item{cursor:default}.chips-wrapper .chips-slider{position:relative;transition:left .14s}.chips-wrapper .chips-row{display:flex;height:32px;margin:10px 0}.chips-wrapper .chips-row>.chips-item{flex-shrink:0;margin:0 10px 0 0;padding:0 10px;border:1px solid #d6d6d6;border-radius:16px;line-height:30px;font-size:12px;white-space:nowrap;outline:0 none;color:#4d4e4e;background:transparent none;cursor:pointer}.chips-wrapper .chips-row>.chips-item:focus{outline:2px solid #3a61d4}.chips-wrapper .chips-row>.chips-item:last-of-type{margin-right:0}.chips-wrapper .chips-nav{position:absolute;top:calc(50% - 20px);z-index:1;display:block;width:30px;height:40px;background-color:#e0e0e0;cursor:pointer}.chips-wrapper .chips-nav.chips-nav-left{left:0;border-top-right-radius:3.75px;border-bottom-right-radius:3.75px}.chips-wrapper .chips-nav.chips-nav-right{right:0;border-top-left-radius:3.75px;border-bottom-left-radius:3.75px}.chips-wrapper .chips-nav:after,.chips-wrapper .chips-nav:before{content:\"\";position:absolute;width:1px;height:12px;background-color:#525050}.chips-wrapper .chips-nav:before{top:8px;transform-origin:.5px 100%}.chips-wrapper .chips-nav:after{bottom:8px;transform-origin:.5px 0}.chips-wrapper .chips-nav.chips-nav-left:after,.chips-wrapper .chips-nav.chips-nav-left:before{left:10px}.chips-wrapper .chips-nav.chips-nav-right:after,.chips-wrapper .chips-nav.chips-nav-right:before{right:10px}.chips-wrapper .chips-nav.chips-nav-left:before,.chips-wrapper .chips-nav.chips-nav-right:after{transform:rotate(45deg)}.chips-wrapper .chips-nav.chips-nav-left:after,.chips-wrapper .chips-nav.chips-nav-right:before{transform:rotate(-45deg)}@keyframes nodeInserted{0%{opacity:.99}to{opacity:1}}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.chips=n():t.chips=n()}(this,function(){return function(t){function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var e={};return n.m=t,n.c=e,n.i=function(t){return t},n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="/pages/ve-le-lp/chips/dist/",n(n.s=71)}([function(t,n){var e=t.exports={version:"2.6.11"};"number"==typeof __e&&(__e=e)},function(t,n,e){var r=e(5),o=e(0),i=e(9),u=e(8),c=e(11),f=function(t,n,e){var s,a,l,p=t&f.F,d=t&f.G,v=t&f.S,h=t&f.P,y=t&f.B,b=t&f.W,g=d?o:o[n]||(o[n]={}),m=g.prototype,_=d?r:v?r[n]:(r[n]||{}).prototype;d&&(e=n);for(s in e)(a=!p&&_&&void 0!==_[s])&&c(g,s)||(l=a?_[s]:e[s],g[s]=d&&"function"!=typeof _[s]?e[s]:y&&a?i(l,r):b&&_[s]==l?function(t){var n=function(n,e,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(n);case 2:return new t(n,e)}return new t(n,e,r)}return t.apply(this,arguments)};return n.prototype=t.prototype,n}(l):h&&"function"==typeof l?i(Function.call,l):l,h&&((g.virtual||(g.virtual={}))[s]=l,t&f.R&&m&&!m[s]&&u(m,s,l)))};f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,e){var r=e(37)("wks"),o=e(24),i=e(5).Symbol,u="function"==typeof i;(t.exports=function(t){return r[t]||(r[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=r},function(t,n,e){t.exports=!e(10)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(7),o=e(53),i=e(39),u=Object.defineProperty;n.f=e(3)?Object.defineProperty:function(t,n,e){if(r(t),n=i(n,!0),r(e),o)try{return u(t,n,e)}catch(t){}if("get"in e||"set"in e)throw TypeError("Accessors not supported!");return"value"in e&&(t[n]=e.value),t}},function(t,n){var e=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,e){var r=e(6);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,n,e){var r=e(4),o=e(17);t.exports=e(3)?function(t,n,e){return r.f(t,n,o(1,e))}:function(t,n,e){return t[n]=e,t}},function(t,n,e){var r=e(50);t.exports=function(t,n,e){if(r(t),void 0===n)return t;switch(e){case 1:return function(e){return t.call(n,e)};case 2:return function(e,r){return t.call(n,e,r)};case 3:return function(e,r,o){return t.call(n,e,r,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var e={}.hasOwnProperty;t.exports=function(t,n){return e.call(t,n)}},function(t,n,e){var r=e(32),o=e(30);t.exports=function(t){return r(o(t))}},function(t,n){t.exports={}},function(t,n,e){var r=e(30);t.exports=function(t){return Object(r(t))}},function(t,n,e){var r=e(61),o=e(31);t.exports=Object.keys||function(t){return r(t,o)}},function(t,n){n.f={}.propertyIsEnumerable},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,e){"use strict";var r=e(122)(!0);e(33)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,n=this._t,e=this._i;return e>=n.length?{value:void 0,done:!0}:(t=r(n,e),this._i+=t.length,{value:t,done:!1})})},function(t,n,e){var r=e(9),o=e(56),i=e(54),u=e(7),c=e(23),f=e(42),s={},a={},n=t.exports=function(t,n,e,l,p){var d,v,h,y,b=p?function(){return t}:f(t),g=r(e,l,n?2:1),m=0;if("function"!=typeof b)throw TypeError(t+" is not iterable!");if(i(b)){for(d=c(t.length);d>m;m++)if((y=n?g(u(v=t[m])[0],v[1]):g(t[m]))===s||y===a)return y}else for(h=b.call(t);!(v=h.next()).done;)if((y=o(h,g,v.value,n))===s||y===a)return y};n.BREAK=s,n.RETURN=a},function(t,n){t.exports=!0},function(t,n,e){var r=e(7),o=e(114),i=e(31),u=e(36)("IE_PROTO"),c=function(){},f=function(){var t,n=e(52)("iframe"),r=i.length;for(n.style.display="none",e(109).appendChild(n),n.src="javascript:",t=n.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),f=t.F;r--;)delete f.prototype[i[r]];return f()};t.exports=Object.create||function(t,n){var e;return null!==t?(c.prototype=r(t),e=new c,c.prototype=null,e[u]=t):e=f(),void 0===n?e:o(e,n)}},function(t,n,e){var r=e(4).f,o=e(11),i=e(2)("toStringTag");t.exports=function(t,n,e){t&&!o(t=e?t:t.prototype,i)&&r(t,i,{configurable:!0,value:n})}},function(t,n,e){var r=e(38),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,n){var e=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++e+r).toString(36))}},function(t,n,e){e(127);for(var r=e(5),o=e(8),i=e(13),u=e(2)("toStringTag"),c="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),f=0;f<c.length;f++){var s=c[f],a=r[s],l=a&&a.prototype;l&&!l[u]&&o(l,u,s),i[s]=i.Array}},function(t,n,e){"use strict";n.__esModule=!0,n.default=function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}},function(t,n,e){"use strict";n.__esModule=!0;var r=e(78),o=function(t){return t&&t.__esModule?t:{default:t}}(r);n.default=function(){function t(t,n){for(var e=0;e<n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(t,r.key,r)}}return function(n,e,r){return e&&t(n.prototype,e),r&&t(n,r),n}}()},function(t,n,e){var r=e(29),o=e(2)("toStringTag"),i="Arguments"==r(function(){return arguments}()),u=function(t,n){try{return t[n]}catch(t){}};t.exports=function(t){var n,e,c;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(e=u(n=Object(t),o))?e:i?r(n):"Object"==(c=r(n))&&"function"==typeof n.callee?"Arguments":c}},function(t,n){var e={}.toString;t.exports=function(t){return e.call(t).slice(8,-1)}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,n,e){var r=e(29);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,n,e){"use strict";var r=e(20),o=e(1),i=e(63),u=e(8),c=e(13),f=e(111),s=e(22),a=e(60),l=e(2)("iterator"),p=!([].keys&&"next"in[].keys()),d=function(){return this};t.exports=function(t,n,e,v,h,y,b){f(e,n,v);var g,m,_,x=function(t){if(!p&&t in j)return j[t];switch(t){case"keys":case"values":return function(){return new e(this,t)}}return function(){return new e(this,t)}},w=n+" Iterator",O="values"==h,S=!1,j=t.prototype,M=j[l]||j["@@iterator"]||h&&j[h],E=M||x(h),k=h?O?x("entries"):E:void 0,L="Array"==n?j.entries||M:M;if(L&&(_=a(L.call(new t)))!==Object.prototype&&_.next&&(s(_,w,!0),r||"function"==typeof _[l]||u(_,l,d)),O&&M&&"values"!==M.name&&(S=!0,E=function(){return M.call(this)}),r&&!b||!p&&!S&&j[l]||u(j,l,E),c[n]=E,c[w]=d,h)if(g={values:O?E:x("values"),keys:y?E:x("keys"),entries:k},b)for(m in g)m in j||i(j,m,g[m]);else o(o.P+o.F*(p||S),n,g);return g}},function(t,n,e){var r=e(24)("meta"),o=e(6),i=e(11),u=e(4).f,c=0,f=Object.isExtensible||function(){return!0},s=!e(10)(function(){return f(Object.preventExtensions({}))}),a=function(t){u(t,r,{value:{i:"O"+ ++c,w:{}}})},l=function(t,n){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!f(t))return"F";if(!n)return"E";a(t)}return t[r].i},p=function(t,n){if(!i(t,r)){if(!f(t))return!0;if(!n)return!1;a(t)}return t[r].w},d=function(t){return s&&v.NEED&&f(t)&&!i(t,r)&&a(t),t},v=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:p,onFreeze:d}},function(t,n){n.f=Object.getOwnPropertySymbols},function(t,n,e){var r=e(37)("keys"),o=e(24);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,n,e){var r=e(0),o=e(5),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(t.exports=function(t,n){return i[t]||(i[t]=void 0!==n?n:{})})("versions",[]).push({version:r.version,mode:e(20)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,n){var e=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:e)(t)}},function(t,n,e){var r=e(6);t.exports=function(t,n){if(!r(t))return t;var e,o;if(n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;if("function"==typeof(e=t.valueOf)&&!r(o=e.call(t)))return o;if(!n&&"function"==typeof(e=t.toString)&&!r(o=e.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n,e){var r=e(5),o=e(0),i=e(20),u=e(41),c=e(4).f;t.exports=function(t){var n=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in n||c(n,t,{value:u.f(t)})}},function(t,n,e){n.f=e(2)},function(t,n,e){var r=e(28),o=e(2)("iterator"),i=e(13);t.exports=e(0).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,n,e){"use strict";e.d(n,"d",function(){return s}),e.d(n,"a",function(){return a}),e.d(n,"c",function(){return l}),e.d(n,"b",function(){return p}),e.d(n,"e",function(){return d}),e.d(n,"f",function(){return v});var r=e(84),o=e.n(r),i=e(79),u=e.n(i),c=e(44),f=e.n(c),s=function(){var t=arguments.length<=0?void 0:arguments[0],n=void 0,e=void 0;Array.isArray(arguments.length<=1?void 0:arguments[1])?(n={},e=(arguments.length<=1?void 0:arguments[1])||[]):(n=(arguments.length<=1?void 0:arguments[1])||{},e=(arguments.length<=2?void 0:arguments[2])||[]);var r=document.createElement(t);return f()(r.style,n.style||{}),f()(r,n.domProps||{}),u()(n.attrs||[]).forEach(function(t){var n=o()(t,2),e=n[0],i=n[1];return r.setAttribute(e,i)}),u()(n.on||[]).forEach(function(t){var n=o()(t,2),e=n[0],i=n[1];return r.addEventListener(e,i,!1)}),e.forEach(function(t){return r.appendChild(t)}),r},a=function(t,n,e){if(t){var r=t.classList.contains(n);e?r||t.classList.add(n):r&&t.classList.remove(n)}},l=function(t){var n=document.createDocumentFragment();return n.appendChild(t),n},p=function(t,n){t.style.animationName="nodeInserted",t.style.animationDuration="0.001s";var e=function e(r){r.target===t&&"nodeInserted"===r.animationName&&(n(),document.removeEventListener("animationstart",e,!1))};document.addEventListener("animationstart",e,!1)},d=function(t,n){var e=t.getBoundingClientRect(),r=n.getBoundingClientRect();return e.left<r.left||e.right>r.right||e.top<r.top||e.bottom>r.bottom},v=function(t,n,e){var r=t.getBoundingClientRect(),o=n.getBoundingClientRect(),i=o.width*e,u=void 0,c=void 0;return r.left<o.left?(u=r.left-o.left,c=Math.floor):r.right>o.right&&(u=r.right-o.right,c=Math.ceil),-1*c(u/i)}},function(t,n,e){t.exports={default:e(90),__esModule:!0}},function(t,n,e){t.exports={default:e(94),__esModule:!0}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var o=e(80),i=r(o),u=e(77),c=r(u),f=e(49),s=r(f);n.default=function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+(void 0===n?"undefined":(0,s.default)(n)));t.prototype=(0,c.default)(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(i.default?(0,i.default)(t,n):t.__proto__=n)}},function(t,n,e){"use strict";n.__esModule=!0;var r=e(49),o=function(t){return t&&t.__esModule?t:{default:t}}(r);n.default=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!==(void 0===n?"undefined":(0,o.default)(n))&&"function"!=typeof n?t:n}},function(t,n,e){"use strict";n.__esModule=!0;var r=e(72),o=function(t){return t&&t.__esModule?t:{default:t}}(r);n.default=function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return(0,o.default)(t)}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var o=e(82),i=r(o),u=e(81),c=r(u),f="function"==typeof c.default&&"symbol"==typeof i.default?function(t){return typeof t}:function(t){return t&&"function"==typeof c.default&&t.constructor===c.default&&t!==c.default.prototype?"symbol":typeof t};n.default="function"==typeof c.default&&"symbol"===f(i.default)?function(t){return void 0===t?"undefined":f(t)}:function(t){return t&&"function"==typeof c.default&&t.constructor===c.default&&t!==c.default.prototype?"symbol":void 0===t?"undefined":f(t)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){t.exports=function(t,n,e,r){if(!(t instanceof n)||void 0!==r&&r in t)throw TypeError(e+": incorrect invocation!");return t}},function(t,n,e){var r=e(6),o=e(5).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,e){t.exports=!e(3)&&!e(10)(function(){return 7!=Object.defineProperty(e(52)("div"),"a",{get:function(){return 7}}).a})},function(t,n,e){var r=e(13),o=e(2)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,n,e){var r=e(29);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,n,e){var r=e(7);t.exports=function(t,n,e,o){try{return o?n(r(e)[0],e[1]):n(e)}catch(n){var i=t.return;throw void 0!==i&&r(i.call(t)),n}}},function(t,n){t.exports=function(t,n){return{value:n,done:!!t}}},function(t,n,e){var r=e(16),o=e(17),i=e(12),u=e(39),c=e(11),f=e(53),s=Object.getOwnPropertyDescriptor;n.f=e(3)?s:function(t,n){if(t=i(t),n=u(n,!0),f)try{return s(t,n)}catch(t){}if(c(t,n))return o(!r.f.call(t,n),t[n])}},function(t,n,e){var r=e(61),o=e(31).concat("length","prototype");n.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,n,e){var r=e(11),o=e(14),i=e(36)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,n,e){var r=e(11),o=e(12),i=e(100)(!1),u=e(36)("IE_PROTO");t.exports=function(t,n){var e,c=o(t),f=0,s=[];for(e in c)e!=u&&r(c,e)&&s.push(e);for(;n.length>f;)r(c,e=n[f++])&&(~i(s,e)||s.push(e));return s}},function(t,n,e){var r=e(8);t.exports=function(t,n,e){for(var o in n)e&&t[o]?t[o]=n[o]:r(t,o,n[o]);return t}},function(t,n,e){t.exports=e(8)},function(t,n,e){var r=e(6);t.exports=function(t,n){if(!r(t)||t._t!==n)throw TypeError("Incompatible receiver, "+n+" required!");return t}},function(t,n){},function(t,n,e){"use strict";var r=e(68);n.a=r.a},function(t,n){},function(t,n,e){"use strict";var r=e(48),o=e.n(r),i=e(45),u=e.n(i),c=e(26),f=e.n(c),s=e(27),a=e.n(s),l=e(47),p=e.n(l),d=e(46),v=e.n(d),h=e(69),y=e(70),b=e(43),g=function(t,n){var e=void 0;e=+n?+n:1;for(var r=[],o=0;o<t.length;o+=e)r.push(t.slice(o,o+e));return r},m=function(t){function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.el,r=void 0===e?document.body:e,o=t.items,i=void 0===o?[]:o,c=t.rowSize,s=t.rowLimit,a=void 0===s?3:s,l=t.itemCharLimit,d=void 0===l?25:l,v=t.rowWrap,h=void 0!==v&&v,y=t.lazy,b=void 0!==y&&y,g=t.accessibility,m=void 0===g?{web:{}}:g,_=t.renderer;f()(this,n);var x=p()(this,(n.__proto__||u()(n)).call(this));if(!_)throw new Error('"renderer" must be passed');return x.el=r,x.items=i,x.rowWrap=!c&&h,x.rowSize=c||i.length||1,x.rowLimit=a,x.itemCharLimit=d,x.accessibility=m,x.RendererClass=_,b||x.render(),x}return v()(n,t),a()(n,[{key:"render",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.items,e=void 0===n?this.items:n,r=t.rowSize,i=void 0===r?this.rowSize:r,u=t.rowLimit,c=void 0===u?this.rowLimit:u,f=t.rowWrap,s=void 0===f?this.rowWrap:f,a=t.itemCharLimit,l=void 0===a?this.itemCharLimit:a,p=t.accessibility,d=void 0===p?this.accessibility:p,v=s?[e]:g(e,i);if(v.length>c){var h,y=v.slice(0,c-1),b=(h=[]).concat.apply(h,o()(v.slice(c-1)));y.push(b),v=y}this.renderer=new this.RendererClass({events:this,rows:v,itemCharLimit:l,rowWrap:s,accessibility:d}),this.detach(),this.attach(this.renderer.render())}},{key:"attach",value:function(t){this.el.appendChild(t)}},{key:"detach",value:function(){var t=this.el.querySelector(".chips-wrapper");t&&this.el.removeChild(t)}},{key:"dispose",value:function(){this.clear(),this.detach()}},{key:"readonly",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];e.i(b.a)(this.el.querySelector(".chips-wrapper"),"chips-readonly",t),this.renderer.isReadOnly=t}}]),n}(h.a);m.Renderer=y.a,n.a=m},function(t,n,e){"use strict";var r=e(75),o=e.n(r),i=e(26),u=e.n(i),c=e(27),f=e.n(c),s=function(){function t(){u()(this,t),this.listeners=new o.a}return f()(t,[{key:"on",value:function(t,n){this.listeners.set(t,n)}},{key:"off",value:function(t){this.listeners.delete(t)}},{key:"clear",value:function(){this.listeners=new o.a}},{key:"dispatch",value:function(t){var n=this.listeners.get(t);if(n){for(var e=arguments.length,r=Array(e>1?e-1:0),o=1;o<e;o++)r[o-1]=arguments[o];n.apply(void 0,r)}}}]),t}();n.a=s},function(t,n,e){"use strict";var r=e(48),o=e.n(r),i=e(76),u=e.n(i),c=e(45),f=e.n(c),s=e(47),a=e.n(s),l=e(46),p=e.n(l),d=e(83),v=e.n(d),h=e(26),y=e.n(h),b=e(27),g=e.n(b),m=e(43),_=function(){function t(n){var e=n.events,r=n.rows,o=n.itemCharLimit,i=n.rowWrap,u=n.accessibility,c=void 0===u?{web:{}}:u;y()(this,t),this.events=e,this.rows=r,this.itemCharLimit=o,this.rowWrap=i,this.accessibility=c,this.stepRatio=.7,this.refs={wrapper:null,slider:null,navLeft:null,navRight:null}}return g()(t,[{key:"render",value:function(){var t=this.buildDomTree();return this.refs={wrapper:t,slider:t.querySelector(".chips-slider"),navLeft:t.querySelector(".chips-nav-left"),navRight:t.querySelector(".chips-nav-right")},e.i(m.b)(this.refs.slider,this.renderNav.bind(this)),e.i(m.c)(t)}},{key:"buildDomTree",value:function(){var t=this;return e.i(m.d)("div",{attrs:v()({class:"chips-wrapper"},this.accessibility.web)},[e.i(m.d)("div",{attrs:{class:"chips-nav chips-nav-left",role:"button","aria-hidden":"true",tabindex:"-1"},style:{visibility:"hidden"},on:{click:function(){t.renderOffset(1),t.events.dispatch("nav:left")}}}),e.i(m.d)("div",{attrs:{class:"chips-nav chips-nav-right",role:"button","aria-hidden":"true",tabindex:"-1"},style:{visibility:"hidden"},on:{click:function(){t.renderOffset(-1),t.events.dispatch("nav:right")}}}),e.i(m.d)("div",{attrs:{class:"chips-slider"},style:{left:0}},this.rows.map(function(n){return e.i(m.d)("div",{attrs:{class:"chips-row"},style:v()({"flex-wrap":t.rowWrap?"wrap":"nowrap"},t.rowWrap&&{height:"auto"})},n.map(t.renderItem.bind(t)))}))])}},{key:"renderOffset",value:function(t){var n=this.refs.slider,e=n.offsetWidth*this.stepRatio*t,r=n.offsetLeft+e,o=void 0;o=r>0?0:r<n.offsetWidth-n.scrollWidth?n.offsetWidth-n.scrollWidth:r;var i=Math.round(o);n.style.left=i+"px",this.renderNav(o)}},{key:"renderNav",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=this.refs.slider,e=this.refs.navLeft,r=this.refs.navRight;this.rowWrap||0===t?e.style.visibility="hidden":e.style.visibility="visible",this.rowWrap||t<=n.offsetWidth-n.scrollWidth?r.style.visibility="hidden":r.style.visibility="visible"}},{key:"renderItem",value:function(){throw new Error("abstract method not implemented!")}}]),t}(),x=function(t){function n(){return y()(this,n),a()(this,(n.__proto__||f()(n)).apply(this,arguments))}return p()(n,t),g()(n,[{key:"renderItem",value:function(t){var n=this,r=t.title,i=t.tooltip,c=t.style,f=void 0===c?{}:c,s=t.accessibility,a=void 0===s?{web:{}}:s,l=t.click,p=this.itemCharLimit,d="string"==typeof r&&r.length>p;return e.i(m.d)("button",{attrs:v()({class:"chips-item",role:"button"},a.web),domProps:v()({},"string"==typeof r&&{textContent:d?""+r.substr(0,p):r},"string"==typeof i&&{title:i}),style:v()({},"string"==typeof f.color&&{color:f.color},"string"==typeof f["background-color"]&&{backgroundColor:f["background-color"]},"string"==typeof f["border-color"]&&{borderColor:f["border-color"]},u()(f["border-radius"])&&{borderRadius:f["border-radius"]+"px"},f.bold&&{fontWeight:"bold"},f.italic&&{fontStyle:"italic"},-1!==["small","medium","large"].indexOf(f.size)&&{fontSize:{small:"10px",medium:"12px",large:"15px"}[f.size]},{"margin-top":this.rowWrap?"10px":0}),on:v()({},l&&{click:function(t){if(n.isReadOnly)return void t.preventDefault();l.actions.forEach(function(t){return n.events.dispatch("action:"+t.type,{action:t,metadata:l.metadata})})},focus:function(t){var r=t.target,o=n.refs.wrapper;if(o.scrollLeft=0,e.i(m.e)(r,o)){var i=e.i(m.f)(r,o,n.stepRatio);n.renderOffset(i)}}})},[].concat(o()(d&&[e.i(m.d)("span",{domProps:{innerHTML:"&hellip;"}})])))}}]),n}(_);n.a={StructuredContentButton:x}},function(t,n,e){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var r=e(67),o=(e.n(r),e(66));n.default=o.a},function(t,n,e){t.exports={default:e(85),__esModule:!0}},function(t,n,e){t.exports={default:e(86),__esModule:!0}},function(t,n,e){t.exports={default:e(87),__esModule:!0}},function(t,n,e){t.exports={default:e(88),__esModule:!0}},function(t,n,e){t.exports={default:e(89),__esModule:!0}},function(t,n,e){t.exports={default:e(91),__esModule:!0}},function(t,n,e){t.exports={default:e(92),__esModule:!0}},function(t,n,e){t.exports={default:e(93),__esModule:!0}},function(t,n,e){t.exports={default:e(95),__esModule:!0}},function(t,n,e){t.exports={default:e(96),__esModule:!0}},function(t,n,e){t.exports={default:e(97),__esModule:!0}},function(t,n,e){"use strict";n.__esModule=!0;var r=e(44),o=function(t){return t&&t.__esModule?t:{default:t}}(r);n.default=o.default||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t}},function(t,n,e){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}n.__esModule=!0;var o=e(74),i=r(o),u=e(73),c=r(u);n.default=function(){function t(t,n){var e=[],r=!0,o=!1,i=void 0;try{for(var u,f=(0,c.default)(t);!(r=(u=f.next()).done)&&(e.push(u.value),!n||e.length!==n);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&f.return&&f.return()}finally{if(o)throw i}}return e}return function(n,e){if(Array.isArray(n))return n;if((0,i.default)(Object(n)))return t(n,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}()},function(t,n,e){e(18),e(126),t.exports=e(0).Array.from},function(t,n,e){e(25),e(18),t.exports=e(124)},function(t,n,e){e(25),e(18),t.exports=e(125)},function(t,n,e){e(65),e(18),e(25),e(128),e(138),e(137),e(136),t.exports=e(0).Map},function(t,n,e){e(129),t.exports=e(0).Number.isInteger},function(t,n,e){e(130),t.exports=e(0).Object.assign},function(t,n,e){e(131);var r=e(0).Object;t.exports=function(t,n){return r.create(t,n)}},function(t,n,e){e(132);var r=e(0).Object;t.exports=function(t,n,e){return r.defineProperty(t,n,e)}},function(t,n,e){e(139),t.exports=e(0).Object.entries},function(t,n,e){e(133),t.exports=e(0).Object.getPrototypeOf},function(t,n,e){e(134),t.exports=e(0).Object.setPrototypeOf},function(t,n,e){e(135),e(65),e(140),e(141),t.exports=e(0).Symbol},function(t,n,e){e(18),e(25),t.exports=e(41).f("iterator")},function(t,n){t.exports=function(){}},function(t,n,e){var r=e(19);t.exports=function(t,n){var e=[];return r(t,!1,e.push,e,n),e}},function(t,n,e){var r=e(12),o=e(23),i=e(123);t.exports=function(t){return function(n,e,u){var c,f=r(n),s=o(f.length),a=i(u,s);if(t&&e!=e){for(;s>a;)if((c=f[a++])!=c)return!0}else for(;s>a;a++)if((t||a in f)&&f[a]===e)return t||a||0;return!t&&-1}}},function(t,n,e){var r=e(9),o=e(32),i=e(14),u=e(23),c=e(103);t.exports=function(t,n){var e=1==t,f=2==t,s=3==t,a=4==t,l=6==t,p=5==t||l,d=n||c;return function(n,c,v){for(var h,y,b=i(n),g=o(b),m=r(c,v,3),_=u(g.length),x=0,w=e?d(n,_):f?d(n,0):void 0;_>x;x++)if((p||x in g)&&(h=g[x],y=m(h,x,b),t))if(e)w[x]=y;else if(y)switch(t){case 3:return!0;case 5:return h;case 6:return x;case 2:w.push(h)}else if(a)return!1;return l?-1:s||a?a:w}}},function(t,n,e){var r=e(6),o=e(55),i=e(2)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),r(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,e){var r=e(102);t.exports=function(t,n){return new(r(t))(n)}},function(t,n,e){"use strict";var r=e(4).f,o=e(21),i=e(62),u=e(9),c=e(51),f=e(19),s=e(33),a=e(57),l=e(121),p=e(3),d=e(34).fastKey,v=e(64),h=p?"_s":"size",y=function(t,n){var e,r=d(n);if("F"!==r)return t._i[r];for(e=t._f;e;e=e.n)if(e.k==n)return e};t.exports={getConstructor:function(t,n,e,s){var a=t(function(t,r){c(t,a,n,"_i"),t._t=n,t._i=o(null),t._f=void 0,t._l=void 0,t[h]=0,void 0!=r&&f(r,e,t[s],t)});return i(a.prototype,{clear:function(){for(var t=v(this,n),e=t._i,r=t._f;r;r=r.n)r.r=!0,r.p&&(r.p=r.p.n=void 0),delete e[r.i];t._f=t._l=void 0,t[h]=0},delete:function(t){var e=v(this,n),r=y(e,t);if(r){var o=r.n,i=r.p;delete e._i[r.i],r.r=!0,i&&(i.n=o),o&&(o.p=i),e._f==r&&(e._f=o),e._l==r&&(e._l=i),e[h]--}return!!r},forEach:function(t){v(this,n);for(var e,r=u(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.n:this._f;)for(r(e.v,e.k,this);e&&e.r;)e=e.p},has:function(t){return!!y(v(this,n),t)}}),p&&r(a.prototype,"size",{get:function(){return v(this,n)[h]}}),a},def:function(t,n,e){var r,o,i=y(t,n);return i?i.v=e:(t._l=i={i:o=d(n,!0),k:n,v:e,p:r=t._l,n:void 0,r:!1},t._f||(t._f=i),r&&(r.n=i),t[h]++,"F"!==o&&(t._i[o]=i)),t},getEntry:y,setStrong:function(t,n,e){s(t,n,function(t,e){this._t=v(t,n),this._k=e,this._l=void 0},function(){for(var t=this,n=t._k,e=t._l;e&&e.r;)e=e.p;return t._t&&(t._l=e=e?e.n:t._t._f)?"keys"==n?a(0,e.k):"values"==n?a(0,e.v):a(0,[e.k,e.v]):(t._t=void 0,a(1))},e?"entries":"values",!e,!0),l(n)}}},function(t,n,e){var r=e(28),o=e(99);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+"#toJSON isn't generic");return o(this)}}},function(t,n,e){"use strict";var r=e(5),o=e(1),i=e(34),u=e(10),c=e(8),f=e(62),s=e(19),a=e(51),l=e(6),p=e(22),d=e(4).f,v=e(101)(0),h=e(3);t.exports=function(t,n,e,y,b,g){var m=r[t],_=m,x=b?"set":"add",w=_&&_.prototype,O={};return h&&"function"==typeof _&&(g||w.forEach&&!u(function(){(new _).entries().next()}))?(_=n(function(n,e){a(n,_,t,"_c"),n._c=new m,void 0!=e&&s(e,b,n[x],n)}),v("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","),function(t){var n="add"==t||"set"==t;t in w&&(!g||"clear"!=t)&&c(_.prototype,t,function(e,r){if(a(this,_,t),!n&&g&&!l(e))return"get"==t&&void 0;var o=this._c[t](0===e?0:e,r);return n?this:o})}),g||d(_.prototype,"size",{get:function(){return this._c.size}})):(_=y.getConstructor(n,t,b,x),f(_.prototype,e),i.NEED=!0),p(_,t),O[t]=_,o(o.G+o.W+o.F,O),g||y.setStrong(_,t,b),_}},function(t,n,e){"use strict";var r=e(4),o=e(17);t.exports=function(t,n,e){n in t?r.f(t,n,o(0,e)):t[n]=e}},function(t,n,e){var r=e(15),o=e(35),i=e(16);t.exports=function(t){var n=r(t),e=o.f;if(e)for(var u,c=e(t),f=i.f,s=0;c.length>s;)f.call(t,u=c[s++])&&n.push(u);return n}},function(t,n,e){var r=e(5).document;t.exports=r&&r.documentElement},function(t,n,e){var r=e(6),o=Math.floor;t.exports=function(t){return!r(t)&&isFinite(t)&&o(t)===t}},function(t,n,e){"use strict";var r=e(21),o=e(17),i=e(22),u={};e(8)(u,e(2)("iterator"),function(){return this}),t.exports=function(t,n,e){t.prototype=r(u,{next:o(1,e)}),i(t,n+" Iterator")}},function(t,n,e){var r=e(2)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(t){}t.exports=function(t,n){if(!n&&!o)return!1;var e=!1;try{var i=[7],u=i[r]();u.next=function(){return{done:e=!0}},i[r]=function(){return u},t(i)}catch(t){}return e}},function(t,n,e){"use strict";var r=e(3),o=e(15),i=e(35),u=e(16),c=e(14),f=e(32),s=Object.assign;t.exports=!s||e(10)(function(){var t={},n={},e=Symbol(),r="abcdefghijklmnopqrst";return t[e]=7,r.split("").forEach(function(t){n[t]=t}),7!=s({},t)[e]||Object.keys(s({},n)).join("")!=r})?function(t,n){for(var e=c(t),s=arguments.length,a=1,l=i.f,p=u.f;s>a;)for(var d,v=f(arguments[a++]),h=l?o(v).concat(l(v)):o(v),y=h.length,b=0;y>b;)d=h[b++],r&&!p.call(v,d)||(e[d]=v[d]);return e}:s},function(t,n,e){var r=e(4),o=e(7),i=e(15);t.exports=e(3)?Object.defineProperties:function(t,n){o(t);for(var e,u=i(n),c=u.length,f=0;c>f;)r.f(t,e=u[f++],n[e]);return t}},function(t,n,e){var r=e(12),o=e(59).f,i={}.toString,u="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],c=function(t){try{return o(t)}catch(t){return u.slice()}};t.exports.f=function(t){return u&&"[object Window]"==i.call(t)?c(t):o(r(t))}},function(t,n,e){var r=e(1),o=e(0),i=e(10);t.exports=function(t,n){var e=(o.Object||{})[t]||Object[t],u={};u[t]=n(e),r(r.S+r.F*i(function(){e(1)}),"Object",u)}},function(t,n,e){var r=e(3),o=e(15),i=e(12),u=e(16).f;t.exports=function(t){return function(n){for(var e,c=i(n),f=o(c),s=f.length,a=0,l=[];s>a;)e=f[a++],r&&!u.call(c,e)||l.push(t?[e,c[e]]:c[e]);return l}}},function(t,n,e){"use strict";var r=e(1),o=e(50),i=e(9),u=e(19);t.exports=function(t){r(r.S,t,{from:function(t){var n,e,r,c,f=arguments[1];return o(this),n=void 0!==f,n&&o(f),void 0==t?new this:(e=[],n?(r=0,c=i(f,arguments[2],2),u(t,!1,function(t){e.push(c(t,r++))})):u(t,!1,e.push,e),new this(e))}})}},function(t,n,e){"use strict";var r=e(1);t.exports=function(t){r(r.S,t,{of:function(){for(var t=arguments.length,n=new Array(t);t--;)n[t]=arguments[t];return new this(n)}})}},function(t,n,e){var r=e(6),o=e(7),i=function(t,n){if(o(t),!r(n)&&null!==n)throw TypeError(n+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,n,r){try{r=e(9)(Function.call,e(58).f(Object.prototype,"__proto__").set,2),r(t,[]),n=!(t instanceof Array)}catch(t){n=!0}return function(t,e){return i(t,e),n?t.__proto__=e:r(t,e),t}}({},!1):void 0),check:i}},function(t,n,e){"use strict";var r=e(5),o=e(0),i=e(4),u=e(3),c=e(2)("species");t.exports=function(t){var n="function"==typeof o[t]?o[t]:r[t];u&&n&&!n[c]&&i.f(n,c,{configurable:!0,get:function(){return this}})}},function(t,n,e){var r=e(38),o=e(30);t.exports=function(t){return function(n,e){var i,u,c=String(o(n)),f=r(e),s=c.length;return f<0||f>=s?t?"":void 0:(i=c.charCodeAt(f),i<55296||i>56319||f+1===s||(u=c.charCodeAt(f+1))<56320||u>57343?t?c.charAt(f):i:t?c.slice(f,f+2):u-56320+(i-55296<<10)+65536)}}},function(t,n,e){var r=e(38),o=Math.max,i=Math.min;t.exports=function(t,n){return t=r(t),t<0?o(t+n,0):i(t,n)}},function(t,n,e){var r=e(7),o=e(42);t.exports=e(0).getIterator=function(t){var n=o(t);if("function"!=typeof n)throw TypeError(t+" is not iterable!");return r(n.call(t))}},function(t,n,e){var r=e(28),o=e(2)("iterator"),i=e(13);t.exports=e(0).isIterable=function(t){var n=Object(t);return void 0!==n[o]||"@@iterator"in n||i.hasOwnProperty(r(n))}},function(t,n,e){"use strict";var r=e(9),o=e(1),i=e(14),u=e(56),c=e(54),f=e(23),s=e(107),a=e(42);o(o.S+o.F*!e(112)(function(t){Array.from(t)}),"Array",{from:function(t){var n,e,o,l,p=i(t),d="function"==typeof this?this:Array,v=arguments.length,h=v>1?arguments[1]:void 0,y=void 0!==h,b=0,g=a(p);if(y&&(h=r(h,v>2?arguments[2]:void 0,2)),void 0==g||d==Array&&c(g))for(n=f(p.length),e=new d(n);n>b;b++)s(e,b,y?h(p[b],b):p[b]);else for(l=g.call(p),e=new d;!(o=l.next()).done;b++)s(e,b,y?u(l,h,[o.value,b],!0):o.value);return e.length=b,e}})},function(t,n,e){"use strict";var r=e(98),o=e(57),i=e(13),u=e(12);t.exports=e(33)(Array,"Array",function(t,n){this._t=u(t),this._i=0,this._k=n},function(){var t=this._t,n=this._k,e=this._i++;return!t||e>=t.length?(this._t=void 0,o(1)):"keys"==n?o(0,e):"values"==n?o(0,t[e]):o(0,[e,t[e]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,n,e){"use strict";var r=e(104),o=e(64);t.exports=e(106)("Map",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var n=r.getEntry(o(this,"Map"),t);return n&&n.v},set:function(t,n){return r.def(o(this,"Map"),0===t?0:t,n)}},r,!0)},function(t,n,e){var r=e(1);r(r.S,"Number",{isInteger:e(110)})},function(t,n,e){var r=e(1);r(r.S+r.F,"Object",{assign:e(113)})},function(t,n,e){var r=e(1);r(r.S,"Object",{create:e(21)})},function(t,n,e){var r=e(1);r(r.S+r.F*!e(3),"Object",{defineProperty:e(4).f})},function(t,n,e){var r=e(14),o=e(60);e(116)("getPrototypeOf",function(){return function(t){return o(r(t))}})},function(t,n,e){var r=e(1);r(r.S,"Object",{setPrototypeOf:e(120).set})},function(t,n,e){"use strict";var r=e(5),o=e(11),i=e(3),u=e(1),c=e(63),f=e(34).KEY,s=e(10),a=e(37),l=e(22),p=e(24),d=e(2),v=e(41),h=e(40),y=e(108),b=e(55),g=e(7),m=e(6),_=e(14),x=e(12),w=e(39),O=e(17),S=e(21),j=e(115),M=e(58),E=e(35),k=e(4),L=e(15),P=M.f,A=k.f,T=j.f,C=r.Symbol,R=r.JSON,N=R&&R.stringify,F=d("_hidden"),W=d("toPrimitive"),I={}.propertyIsEnumerable,D=a("symbol-registry"),z=a("symbols"),G=a("op-symbols"),B=Object.prototype,q="function"==typeof C&&!!E.f,J=r.QObject,V=!J||!J.prototype||!J.prototype.findChild,H=i&&s(function(){return 7!=S(A({},"a",{get:function(){return A(this,"a",{value:7}).a}})).a})?function(t,n,e){var r=P(B,n);r&&delete B[n],A(t,n,e),r&&t!==B&&A(B,n,r)}:A,K=function(t){var n=z[t]=S(C.prototype);return n._k=t,n},U=q&&"symbol"==typeof C.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof C},Y=function(t,n,e){return t===B&&Y(G,n,e),g(t),n=w(n,!0),g(e),o(z,n)?(e.enumerable?(o(t,F)&&t[F][n]&&(t[F][n]=!1),e=S(e,{enumerable:O(0,!1)})):(o(t,F)||A(t,F,O(1,{})),t[F][n]=!0),H(t,n,e)):A(t,n,e)},Q=function(t,n){g(t);for(var e,r=y(n=x(n)),o=0,i=r.length;i>o;)Y(t,e=r[o++],n[e]);return t},X=function(t,n){return void 0===n?S(t):Q(S(t),n)},Z=function(t){var n=I.call(this,t=w(t,!0));return!(this===B&&o(z,t)&&!o(G,t))&&(!(n||!o(this,t)||!o(z,t)||o(this,F)&&this[F][t])||n)},$=function(t,n){if(t=x(t),n=w(n,!0),t!==B||!o(z,n)||o(G,n)){var e=P(t,n);return!e||!o(z,n)||o(t,F)&&t[F][n]||(e.enumerable=!0),e}},tt=function(t){for(var n,e=T(x(t)),r=[],i=0;e.length>i;)o(z,n=e[i++])||n==F||n==f||r.push(n);return r},nt=function(t){for(var n,e=t===B,r=T(e?G:x(t)),i=[],u=0;r.length>u;)!o(z,n=r[u++])||e&&!o(B,n)||i.push(z[n]);return i};q||(C=function(){if(this instanceof C)throw TypeError("Symbol is not a constructor!");var t=p(arguments.length>0?arguments[0]:void 0),n=function(e){this===B&&n.call(G,e),o(this,F)&&o(this[F],t)&&(this[F][t]=!1),H(this,t,O(1,e))};return i&&V&&H(B,t,{configurable:!0,set:n}),K(t)},c(C.prototype,"toString",function(){return this._k}),M.f=$,k.f=Y,e(59).f=j.f=tt,e(16).f=Z,E.f=nt,i&&!e(20)&&c(B,"propertyIsEnumerable",Z,!0),v.f=function(t){return K(d(t))}),u(u.G+u.W+u.F*!q,{Symbol:C});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),rt=0;et.length>rt;)d(et[rt++]);for(var ot=L(d.store),it=0;ot.length>it;)h(ot[it++]);u(u.S+u.F*!q,"Symbol",{for:function(t){return o(D,t+="")?D[t]:D[t]=C(t)},keyFor:function(t){if(!U(t))throw TypeError(t+" is not a symbol!");for(var n in D)if(D[n]===t)return n},useSetter:function(){V=!0},useSimple:function(){V=!1}}),u(u.S+u.F*!q,"Object",{create:X,defineProperty:Y,defineProperties:Q,getOwnPropertyDescriptor:$,getOwnPropertyNames:tt,getOwnPropertySymbols:nt});var ut=s(function(){E.f(1)});u(u.S+u.F*ut,"Object",{getOwnPropertySymbols:function(t){return E.f(_(t))}}),R&&u(u.S+u.F*(!q||s(function(){var t=C();return"[null]"!=N([t])||"{}"!=N({a:t})||"{}"!=N(Object(t))})),"JSON",{stringify:function(t){for(var n,e,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(e=n=r[1],(m(n)||void 0!==t)&&!U(t))return b(n)||(n=function(t,n){if("function"==typeof e&&(n=e.call(this,t,n)),!U(n))return n}),r[1]=n,N.apply(R,r)}}),C.prototype[W]||e(8)(C.prototype,W,C.prototype.valueOf),l(C,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,n,e){e(118)("Map")},function(t,n,e){e(119)("Map")},function(t,n,e){var r=e(1);r(r.P+r.R,"Map",{toJSON:e(105)("Map")})},function(t,n,e){var r=e(1),o=e(117)(!0);r(r.S,"Object",{entries:function(t){return o(t)}})},function(t,n,e){e(40)("asyncIterator")},function(t,n,e){e(40)("observable")}])});
//# sourceMappingURL=chips.min.js.map

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chips",staticClass:"chips-component"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['le-transcript-message', 'message', _vm.message.originator.originatorClass],attrs:{"id":_vm.containerId}},[_c('div',{staticClass:"message-info"},[(!_vm.isConsumer && !_vm.isPrivateMessage)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.indicatorTooltipConfiguration),expression:"indicatorTooltipConfiguration"}],class:['status-indicator', _vm.message.messageStatusClass],attrs:{"role":"img","aria-label":_vm.indicatorTooltipConfiguration.content}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"le-transcript-message-bubble",class:[_vm.consumerMessageClassName, _vm.message.textDirection, {highlighted: _vm.isHighlighted}],attrs:{"dir":_vm.message.textDirection}},[(_vm.isTypePlainText)?_c('span',{staticClass:"plain-text-container"},[_c('span',{staticClass:"text-content",domProps:{"innerHTML":_vm._s(_vm.htmlMessageText)}})]):(_vm.isTypeSecureFormInvitation)?_c('span',{staticClass:"secure-form-container"},[_vm._v("\n        "+_vm._s(_vm.secureFormInvitationMessage)+"\n      ")]):(_vm.isRichContent)?_c('div',{class:_vm.richContentContainerClass},[_c('json-pollock-component',{attrs:{"content":_vm.message.content}})],1):_c('span',[_vm._v("***"+_vm._s(_vm.notSupportedTypeText)+"***\n        "),(_vm.messageNotSupportedActionText)?[_c('br'),_vm._v(" "),_c('a',{staticClass:"not-supported-action-link",on:{"click":_vm.onNotSupportedActionClick}},[_vm._v(" "+_vm._s(_vm.messageNotSupportedActionText))])]:_vm._e()],2),_vm._v(" "),(_vm.isQuickReplies)?_c('div',[_c('chips-component',{attrs:{"quickReplies":_vm.message.quickReplies}},[_vm._v(_vm._s(_vm.message.quickReplies.toString()))])],1):_vm._e()])]),_vm._v(" "),(_vm.showMetaData)?_vm._m(0):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('le-transcript-message-meta',_vm._b({attrs:{"translations":_vm.translations,"originatorName":_vm.originatorName,"isPrivateMessage":_vm.isPrivateMessage,"isControllerBot":_vm.isControllerBot,"messageTime":_vm.messageTime,"messageFullTime":_vm.messageFullTime,"intent-name":_vm.intentName,"showLink":_vm.showLink},on:{"onClickIntentName":_vm.onClickIntentName}},'le-transcript-message-meta',_vm.metaDataParams,false))}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-transcript"},_vm._l((_vm.messages),function(message,index){return _c('div',{key:message.id,staticClass:"message-container"},[(_vm.isDateSeparatorNeeded(index))?_c('div',{staticClass:"line-separator"},[_c('div',{staticClass:"date"},[_c('span',[_vm._v(_vm._s(_vm.getMessageDate(message)))])])]):_vm._e(),_vm._v(" "),_c('le-transcript-message',{ref:("message-" + (message.id)),refInFor:true,attrs:{"consumerMessageClassName":_vm.transcript.consumerMessageClassName,"showMetaData":_vm.needToShowMetaData(index),"message":message,"translations":_vm.translationsMap,"isHighlighted":_vm.focusedMessageId === message.id,"showLink":_vm.showLink},on:{"onNotSupportedActionClick":_vm.onNotSupportedActionClick,"onClickIntentName":_vm.onClickIntentName}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_combobox_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69816bfe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_combobox_vue__ = __webpack_require__(714);
function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_combobox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69816bfe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_combobox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(709);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("64e15f7a", content, true, {});

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-combobox{width:100%}.le-combobox .le-combobox-input-container{display:inline-block;margin-left:5px;width:calc(100% - 9px)}.le-combobox .le-combobox-input-container .input.selected{font-weight:700}.le-combobox .le-combobox-input-container .ico-arrow-down{padding-top:13px}.le-combobox .le-combobox-input-container .ico-input-field-reset{padding-top:12px}.le-combobox .le-combobox-menu{padding:0;border-top:0;z-index:999;margin:0 5px;min-width:200px;width:calc(100% - 11px)}.le-combobox .le-combobox-menu .le-combobox-menu-inner-container{max-height:180px;overflow-x:hidden;overflow-y:auto}.le-combobox .le-combobox-menu.theme-dark,.theme-dark .le-combobox .le-combobox-menu{color:#fff;background-color:#141a42;border:1px solid #474a6a}.le-combobox .le-combobox-menu.theme-light,.theme-light .le-combobox .le-combobox-menu{color:#666;background-color:#fff;border:1px solid #ddd}.le-combobox .le-combobox-nothing-found-item{font-style:italic}.le-combobox.theme-dark .right-icon.disabled,.theme-dark .le-combobox .right-icon.disabled{cursor:default;color:hsla(0,0%,100%,.6)}.le-combobox.theme-light .right-icon.disabled,.theme-light .le-combobox .right-icon.disabled{cursor:default;color:#888}.le-combobox .le-combobox-input-container,.le-combobox .le-input-field{position:relative}.le-combobox .le-combobox-input-container .reset-button,.le-combobox .le-combobox-input-container .right-icon,.le-combobox .le-input-field .reset-button,.le-combobox .le-input-field .right-icon{cursor:pointer;position:absolute;right:0;padding:10px;top:0;bottom:0;margin:auto}.le-combobox .le-combobox-input-container .reset-button.theme-dark,.le-combobox .le-combobox-input-container .right-icon.theme-dark,.le-combobox .le-input-field .reset-button.theme-dark,.le-combobox .le-input-field .right-icon.theme-dark,.theme-dark .le-combobox .le-combobox-input-container .reset-button,.theme-dark .le-combobox .le-combobox-input-container .right-icon,.theme-dark .le-combobox .le-input-field .reset-button,.theme-dark .le-combobox .le-input-field .right-icon{color:#a9afba}.le-combobox .le-combobox-input-container .reset-button.theme-light,.le-combobox .le-combobox-input-container .right-icon.theme-light,.le-combobox .le-input-field .reset-button.theme-light,.le-combobox .le-input-field .right-icon.theme-light,.theme-light .le-combobox .le-combobox-input-container .reset-button,.theme-light .le-combobox .le-combobox-input-container .right-icon,.theme-light .le-combobox .le-input-field .reset-button,.theme-light .le-combobox .le-input-field .right-icon{color:#888}.le-combobox .le-combobox-input-container .left-icon,.le-combobox .le-combobox-input-container .search-icon,.le-combobox .le-input-field .left-icon,.le-combobox .le-input-field .search-icon{position:absolute;left:9px;top:1px;bottom:0;margin:auto}.le-combobox .le-combobox-input-container .left-icon.theme-dark,.le-combobox .le-combobox-input-container .search-icon.theme-dark,.le-combobox .le-input-field .left-icon.theme-dark,.le-combobox .le-input-field .search-icon.theme-dark,.theme-dark .le-combobox .le-combobox-input-container .left-icon,.theme-dark .le-combobox .le-combobox-input-container .search-icon,.theme-dark .le-combobox .le-input-field .left-icon,.theme-dark .le-combobox .le-input-field .search-icon{color:#a9afba}.le-combobox .le-combobox-input-container .left-icon.theme-light,.le-combobox .le-combobox-input-container .search-icon.theme-light,.le-combobox .le-input-field .left-icon.theme-light,.le-combobox .le-input-field .search-icon.theme-light,.theme-light .le-combobox .le-combobox-input-container .left-icon,.theme-light .le-combobox .le-combobox-input-container .search-icon,.theme-light .le-combobox .le-input-field .left-icon,.theme-light .le-combobox .le-input-field .search-icon{color:#888}.le-combobox .le-combobox-input-container.theme-dark .input,.le-combobox .le-input-field.theme-dark .input,.theme-dark .le-combobox .le-combobox-input-container .input,.theme-dark .le-combobox .le-input-field .input{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border-radius:2px;border:1px solid #474a6a;background-color:rgba(71,74,106,.5);color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input:hover,.le-combobox .le-input-field.theme-dark .input:hover,.theme-dark .le-combobox .le-combobox-input-container .input:hover,.theme-dark .le-combobox .le-input-field .input:hover{border-color:#2d3162}.le-combobox .le-combobox-input-container.theme-dark .input:focus,.le-combobox .le-input-field.theme-dark .input:focus,.theme-dark .le-combobox .le-combobox-input-container .input:focus,.theme-dark .le-combobox .le-input-field .input:focus{border-color:#5879da}.le-combobox .le-combobox-input-container.theme-dark .input.has-left-icon,.le-combobox .le-input-field.theme-dark .input.has-left-icon,.theme-dark .le-combobox .le-combobox-input-container .input.has-left-icon,.theme-dark .le-combobox .le-input-field .input.has-left-icon{padding-left:25px}.le-combobox .le-combobox-input-container.theme-dark .input.has-right-icon,.le-combobox .le-input-field.theme-dark .input.has-right-icon,.theme-dark .le-combobox .le-combobox-input-container .input.has-right-icon,.theme-dark .le-combobox .le-input-field .input.has-right-icon{padding-right:25px}.le-combobox .le-combobox-input-container.theme-dark .input.has-error,.le-combobox .le-input-field.theme-dark .input.has-error,.theme-dark .le-combobox .le-combobox-input-container .input.has-error,.theme-dark .le-combobox .le-input-field .input.has-error{border-color:#ff1820}.le-combobox .le-combobox-input-container.theme-dark .input::-webkit-input-placeholder,.le-combobox .le-input-field.theme-dark .input::-webkit-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input::-webkit-input-placeholder,.theme-dark .le-combobox .le-input-field .input::-webkit-input-placeholder{font-style:italic;color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input::-moz-placeholder,.le-combobox .le-input-field.theme-dark .input::-moz-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input::-moz-placeholder,.theme-dark .le-combobox .le-input-field .input::-moz-placeholder{font-style:italic;color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input::-ms-input-placeholder,.le-combobox .le-input-field.theme-dark .input::-ms-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input::-ms-input-placeholder,.theme-dark .le-combobox .le-input-field .input::-ms-input-placeholder{font-style:italic;color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input::placeholder,.le-combobox .le-input-field.theme-dark .input::placeholder,.theme-dark .le-combobox .le-combobox-input-container .input::placeholder,.theme-dark .le-combobox .le-input-field .input::placeholder{font-style:italic;color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input:-ms-input-placeholder,.le-combobox .le-input-field.theme-dark .input:-ms-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input:-ms-input-placeholder,.theme-dark .le-combobox .le-input-field .input:-ms-input-placeholder{font-style:italic;color:#fff}.le-combobox .le-combobox-input-container.theme-dark .input.disabled,.le-combobox .le-input-field.theme-dark .input.disabled,.theme-dark .le-combobox .le-combobox-input-container .input.disabled,.theme-dark .le-combobox .le-input-field .input.disabled{border:1px solid transparent;background-color:#474a6a;color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input.disabled::-webkit-input-placeholder,.le-combobox .le-input-field.theme-dark .input.disabled::-webkit-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input.disabled::-webkit-input-placeholder,.theme-dark .le-combobox .le-input-field .input.disabled::-webkit-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input.disabled::-moz-placeholder,.le-combobox .le-input-field.theme-dark .input.disabled::-moz-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input.disabled::-moz-placeholder,.theme-dark .le-combobox .le-input-field .input.disabled::-moz-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input.disabled::-ms-input-placeholder,.le-combobox .le-input-field.theme-dark .input.disabled::-ms-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input.disabled::-ms-input-placeholder,.theme-dark .le-combobox .le-input-field .input.disabled::-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input.disabled::placeholder,.le-combobox .le-input-field.theme-dark .input.disabled::placeholder,.theme-dark .le-combobox .le-combobox-input-container .input.disabled::placeholder,.theme-dark .le-combobox .le-input-field .input.disabled::placeholder{color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input.disabled:-ms-input-placeholder,.le-combobox .le-input-field.theme-dark .input.disabled:-ms-input-placeholder,.theme-dark .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder,.theme-dark .le-combobox .le-input-field .input.disabled:-ms-input-placeholder{color:hsla(0,0%,100%,.6)}.le-combobox .le-combobox-input-container.theme-dark .input::-ms-clear,.le-combobox .le-input-field.theme-dark .input::-ms-clear,.theme-dark .le-combobox .le-combobox-input-container .input::-ms-clear,.theme-dark .le-combobox .le-input-field .input::-ms-clear{display:none;width:0;height:0}.le-combobox .le-combobox-input-container.theme-light .input,.le-combobox .le-input-field.theme-light .input,.theme-light .le-combobox .le-combobox-input-container .input,.theme-light .le-combobox .le-input-field .input{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:border-box;box-sizing:border-box;outline:none;height:32px;padding:0 9px;width:100%;line-height:32px;font-size:12px;font-family:Roboto;border-radius:2px;border:1px solid #8c8d8f;background-color:#fcfcfd;color:#0a0a0a}.le-combobox .le-combobox-input-container.theme-light .input:hover,.le-combobox .le-input-field.theme-light .input:hover,.theme-light .le-combobox .le-combobox-input-container .input:hover,.theme-light .le-combobox .le-input-field .input:hover{border-color:#8c8d8f}.le-combobox .le-combobox-input-container.theme-light .input:focus,.le-combobox .le-input-field.theme-light .input:focus,.theme-light .le-combobox .le-combobox-input-container .input:focus,.theme-light .le-combobox .le-input-field .input:focus{border-color:#666}.le-combobox .le-combobox-input-container.theme-light .input.has-left-icon,.le-combobox .le-input-field.theme-light .input.has-left-icon,.theme-light .le-combobox .le-combobox-input-container .input.has-left-icon,.theme-light .le-combobox .le-input-field .input.has-left-icon{padding-left:25px}.le-combobox .le-combobox-input-container.theme-light .input.has-right-icon,.le-combobox .le-input-field.theme-light .input.has-right-icon,.theme-light .le-combobox .le-combobox-input-container .input.has-right-icon,.theme-light .le-combobox .le-input-field .input.has-right-icon{padding-right:25px}.le-combobox .le-combobox-input-container.theme-light .input.has-error,.le-combobox .le-input-field.theme-light .input.has-error,.theme-light .le-combobox .le-combobox-input-container .input.has-error,.theme-light .le-combobox .le-input-field .input.has-error{border-color:#d0021b}.le-combobox .le-combobox-input-container.theme-light .input::-webkit-input-placeholder,.le-combobox .le-input-field.theme-light .input::-webkit-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input::-webkit-input-placeholder,.theme-light .le-combobox .le-input-field .input::-webkit-input-placeholder{font-style:italic;color:#6f737c}.le-combobox .le-combobox-input-container.theme-light .input::-moz-placeholder,.le-combobox .le-input-field.theme-light .input::-moz-placeholder,.theme-light .le-combobox .le-combobox-input-container .input::-moz-placeholder,.theme-light .le-combobox .le-input-field .input::-moz-placeholder{font-style:italic;color:#6f737c}.le-combobox .le-combobox-input-container.theme-light .input::-ms-input-placeholder,.le-combobox .le-input-field.theme-light .input::-ms-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input::-ms-input-placeholder,.theme-light .le-combobox .le-input-field .input::-ms-input-placeholder{font-style:italic;color:#6f737c}.le-combobox .le-combobox-input-container.theme-light .input::placeholder,.le-combobox .le-input-field.theme-light .input::placeholder,.theme-light .le-combobox .le-combobox-input-container .input::placeholder,.theme-light .le-combobox .le-input-field .input::placeholder{font-style:italic;color:#6f737c}.le-combobox .le-combobox-input-container.theme-light .input:-ms-input-placeholder,.le-combobox .le-input-field.theme-light .input:-ms-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input:-ms-input-placeholder,.theme-light .le-combobox .le-input-field .input:-ms-input-placeholder{font-style:italic;color:#6f737c}.le-combobox .le-combobox-input-container.theme-light .input.disabled,.le-combobox .le-input-field.theme-light .input.disabled,.theme-light .le-combobox .le-combobox-input-container .input.disabled,.theme-light .le-combobox .le-input-field .input.disabled{border:1px solid #8c8d8f;background-color:#ebecef;color:hsla(0,0%,4%,.5)}.le-combobox .le-combobox-input-container.theme-light .input.disabled::-webkit-input-placeholder,.le-combobox .le-input-field.theme-light .input.disabled::-webkit-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input.disabled::-webkit-input-placeholder,.theme-light .le-combobox .le-input-field .input.disabled::-webkit-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox .le-combobox-input-container.theme-light .input.disabled::-moz-placeholder,.le-combobox .le-input-field.theme-light .input.disabled::-moz-placeholder,.theme-light .le-combobox .le-combobox-input-container .input.disabled::-moz-placeholder,.theme-light .le-combobox .le-input-field .input.disabled::-moz-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox .le-combobox-input-container.theme-light .input.disabled::-ms-input-placeholder,.le-combobox .le-input-field.theme-light .input.disabled::-ms-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input.disabled::-ms-input-placeholder,.theme-light .le-combobox .le-input-field .input.disabled::-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox .le-combobox-input-container.theme-light .input.disabled::placeholder,.le-combobox .le-input-field.theme-light .input.disabled::placeholder,.theme-light .le-combobox .le-combobox-input-container .input.disabled::placeholder,.theme-light .le-combobox .le-input-field .input.disabled::placeholder{color:hsla(222,6%,46%,.5)}.le-combobox .le-combobox-input-container.theme-light .input.disabled:-ms-input-placeholder,.le-combobox .le-input-field.theme-light .input.disabled:-ms-input-placeholder,.theme-light .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder,.theme-light .le-combobox .le-input-field .input.disabled:-ms-input-placeholder{color:hsla(222,6%,46%,.5)}.le-combobox .le-combobox-input-container.theme-light .input::-ms-clear,.le-combobox .le-input-field.theme-light .input::-ms-clear,.theme-light .le-combobox .le-combobox-input-container .input::-ms-clear,.theme-light .le-combobox .le-input-field .input::-ms-clear{display:none;width:0;height:0}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-combobox/le-combobox.vue"],"names":[],"mappings":"AAIA,aACE,UAAY,CACb,AACD,0CACI,qBAAsB,AACtB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,0DACM,eAAkB,CACvB,AACD,0DACM,gBAAkB,CACvB,AACD,iEACM,gBAAkB,CACvB,AACD,+BACI,UAAW,AACX,aAAc,AACd,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,uBAAyB,CAC5B,AACD,iEACM,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CACtB,AACD,qFAEM,WAAe,AACf,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,uFAEM,WAAe,AACf,sBAA0B,AAC1B,qBAA0B,CAC/B,AACD,6CACI,iBAAmB,CACtB,AACD,2FAEI,eAAgB,AAChB,wBAAgC,CACnC,AACD,6FAEI,eAAgB,AAChB,UAAe,CAClB,AACD,uEAEI,iBAAmB,CACtB,AACD,kMAIM,eAAgB,AAChB,kBAAmB,AACnB,QAAS,AACT,aAAc,AACd,MAAO,AACP,SAAU,AACV,WAAa,CAClB,AACD,geAWQ,aAAe,CACtB,AACD,weAWQ,UAAe,CACtB,AACD,8LAIM,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,SAAU,AACV,WAAa,CAClB,AACD,wdAWQ,aAAe,CACtB,AACD,geAWQ,UAAe,CACtB,AACD,wNAKM,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,yBAA0B,AAC1B,oCAAyC,AACzC,UAAe,CACpB,AACD,gPAKQ,oBAAsB,CAC7B,AACD,gPAKQ,oBAAsB,CAC7B,AACD,gRAKQ,iBAAmB,CAC1B,AACD,oRAKQ,kBAAoB,CAC3B,AACD,gQAKQ,oBAAsB,CAC7B,AACD,oUAKQ,kBAAmB,AACnB,UAAe,CACtB,AACD,gSAKQ,kBAAmB,AACnB,UAAe,CACtB,AACD,oTAKQ,kBAAmB,AACnB,UAAe,CACtB,AACD,4QAKQ,kBAAmB,AACnB,UAAe,CACtB,AAUD,gTAMQ,kBAAmB,AACnB,UAAe,CACtB,AACD,4PAKQ,6BAA8B,AAC9B,yBAA0B,AAC1B,wBAAgC,CACvC,AACD,wWAKU,wBAAgC,CACzC,AACD,oUAKU,wBAAgC,CACzC,AACD,wVAKU,wBAAgC,CACzC,AACD,gTAKU,wBAAgC,CACzC,AASD,oVAMU,wBAAgC,CACzC,AACD,oQAMQ,aAAc,AACd,QAAS,AACT,QAAU,CACjB,AACD,4NAKM,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,aAAc,AACd,YAAa,AACb,cAAe,AACf,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,yBAA0B,AAC1B,yBAA0B,AAC1B,aAAe,CACpB,AACD,oPAKQ,oBAAsB,CAC7B,AACD,oPAKQ,iBAAsB,CAC7B,AACD,oRAKQ,iBAAmB,CAC1B,AACD,wRAKQ,kBAAoB,CAC3B,AACD,oQAKQ,oBAAsB,CAC7B,AACD,wUAKQ,kBAAmB,AACnB,aAAe,CACtB,AACD,oSAKQ,kBAAmB,AACnB,aAAe,CACtB,AACD,wTAKQ,kBAAmB,AACnB,aAAe,CACtB,AACD,gRAKQ,kBAAmB,AACnB,aAAe,CACtB,AAUD,oTAMQ,kBAAmB,AACnB,aAAe,CACtB,AACD,gQAKQ,yBAA0B,AAC1B,yBAA0B,AAC1B,sBAA6B,CACpC,AACD,4WAKU,yBAAgC,CACzC,AACD,wUAKU,yBAAgC,CACzC,AACD,4VAKU,yBAAgC,CACzC,AACD,oTAKU,yBAAgC,CACzC,AASD,wVAMU,yBAAgC,CACzC,AACD,wQAMQ,aAAc,AACd,QAAS,AACT,QAAU,CACjB","file":"le-combobox.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-combobox {\n  width: 100%;\n}\n.le-combobox .le-combobox-input-container {\n    display: inline-block;\n    margin-left: 5px;\n    width: calc(100% - 9px);\n}\n.le-combobox .le-combobox-input-container .input.selected {\n      font-weight: bold;\n}\n.le-combobox .le-combobox-input-container .ico-arrow-down {\n      padding-top: 13px;\n}\n.le-combobox .le-combobox-input-container .ico-input-field-reset {\n      padding-top: 12px;\n}\n.le-combobox .le-combobox-menu {\n    padding: 0;\n    border-top: 0;\n    z-index: 999;\n    margin: 0 5px;\n    min-width: 200px;\n    width: calc(100% - 11px);\n}\n.le-combobox .le-combobox-menu .le-combobox-menu-inner-container {\n      max-height: 180px;\n      overflow-x: hidden;\n      overflow-y: auto;\n}\n.le-combobox .le-combobox-menu.theme-dark,\n    .theme-dark .le-combobox .le-combobox-menu {\n      color: #ffffff;\n      background-color: #141a42;\n      border: 1px solid #474a6a;\n}\n.le-combobox .le-combobox-menu.theme-light,\n    .theme-light .le-combobox .le-combobox-menu {\n      color: #666666;\n      background-color: #ffffff;\n      border: 1px solid #dddddd;\n}\n.le-combobox .le-combobox-nothing-found-item {\n    font-style: italic;\n}\n.le-combobox.theme-dark .right-icon.disabled,\n  .theme-dark .le-combobox .right-icon.disabled {\n    cursor: default;\n    color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox.theme-light .right-icon.disabled,\n  .theme-light .le-combobox .right-icon.disabled {\n    cursor: default;\n    color: #888888;\n}\n.le-combobox .le-input-field,\n  .le-combobox .le-combobox-input-container {\n    position: relative;\n}\n.le-combobox .le-input-field .right-icon,\n    .le-combobox .le-input-field .reset-button,\n    .le-combobox .le-combobox-input-container .right-icon,\n    .le-combobox .le-combobox-input-container .reset-button {\n      cursor: pointer;\n      position: absolute;\n      right: 0;\n      padding: 10px;\n      top: 0;\n      bottom: 0;\n      margin: auto;\n}\n.le-combobox .le-input-field .right-icon.theme-dark,\n      .theme-dark .le-combobox .le-input-field .right-icon,\n      .le-combobox .le-input-field .reset-button.theme-dark,\n      .theme-dark\n      .le-combobox .le-input-field .reset-button,\n      .le-combobox .le-combobox-input-container .right-icon.theme-dark,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .right-icon,\n      .le-combobox .le-combobox-input-container .reset-button.theme-dark,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .reset-button {\n        color: #a9afba;\n}\n.le-combobox .le-input-field .right-icon.theme-light,\n      .theme-light .le-combobox .le-input-field .right-icon,\n      .le-combobox .le-input-field .reset-button.theme-light,\n      .theme-light\n      .le-combobox .le-input-field .reset-button,\n      .le-combobox .le-combobox-input-container .right-icon.theme-light,\n      .theme-light\n      .le-combobox .le-combobox-input-container .right-icon,\n      .le-combobox .le-combobox-input-container .reset-button.theme-light,\n      .theme-light\n      .le-combobox .le-combobox-input-container .reset-button {\n        color: #888888;\n}\n.le-combobox .le-input-field .left-icon,\n    .le-combobox .le-input-field .search-icon,\n    .le-combobox .le-combobox-input-container .left-icon,\n    .le-combobox .le-combobox-input-container .search-icon {\n      position: absolute;\n      left: 9px;\n      top: 1px;\n      bottom: 0;\n      margin: auto;\n}\n.le-combobox .le-input-field .left-icon.theme-dark,\n      .theme-dark .le-combobox .le-input-field .left-icon,\n      .le-combobox .le-input-field .search-icon.theme-dark,\n      .theme-dark\n      .le-combobox .le-input-field .search-icon,\n      .le-combobox .le-combobox-input-container .left-icon.theme-dark,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .left-icon,\n      .le-combobox .le-combobox-input-container .search-icon.theme-dark,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .search-icon {\n        color: #a9afba;\n}\n.le-combobox .le-input-field .left-icon.theme-light,\n      .theme-light .le-combobox .le-input-field .left-icon,\n      .le-combobox .le-input-field .search-icon.theme-light,\n      .theme-light\n      .le-combobox .le-input-field .search-icon,\n      .le-combobox .le-combobox-input-container .left-icon.theme-light,\n      .theme-light\n      .le-combobox .le-combobox-input-container .left-icon,\n      .le-combobox .le-combobox-input-container .search-icon.theme-light,\n      .theme-light\n      .le-combobox .le-combobox-input-container .search-icon {\n        color: #888888;\n}\n.le-combobox .le-input-field.theme-dark .input,\n    .theme-dark .le-combobox .le-input-field .input,\n    .le-combobox .le-combobox-input-container.theme-dark .input,\n    .theme-dark\n    .le-combobox .le-combobox-input-container .input {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: none;\n      height: 32px;\n      padding: 0 9px;\n      width: 100%;\n      line-height: 32px;\n      font-size: 12px;\n      font-family: Roboto;\n      border-radius: 2px;\n      border: 1px solid #474a6a;\n      background-color: rgba(71, 74, 106, 0.5);\n      color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input:hover,\n      .theme-dark .le-combobox .le-input-field .input:hover,\n      .le-combobox .le-combobox-input-container.theme-dark .input:hover,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input:hover {\n        border-color: #2d3162;\n}\n.le-combobox .le-input-field.theme-dark .input:focus,\n      .theme-dark .le-combobox .le-input-field .input:focus,\n      .le-combobox .le-combobox-input-container.theme-dark .input:focus,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input:focus {\n        border-color: #5879da;\n}\n.le-combobox .le-input-field.theme-dark .input.has-left-icon,\n      .theme-dark .le-combobox .le-input-field .input.has-left-icon,\n      .le-combobox .le-combobox-input-container.theme-dark .input.has-left-icon,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input.has-left-icon {\n        padding-left: 25px;\n}\n.le-combobox .le-input-field.theme-dark .input.has-right-icon,\n      .theme-dark .le-combobox .le-input-field .input.has-right-icon,\n      .le-combobox .le-combobox-input-container.theme-dark .input.has-right-icon,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input.has-right-icon {\n        padding-right: 25px;\n}\n.le-combobox .le-input-field.theme-dark .input.has-error,\n      .theme-dark .le-combobox .le-input-field .input.has-error,\n      .le-combobox .le-combobox-input-container.theme-dark .input.has-error,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input.has-error {\n        border-color: #ff1820;\n}\n.le-combobox .le-input-field.theme-dark .input::-webkit-input-placeholder,\n      .theme-dark .le-combobox .le-input-field .input::-webkit-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input::-webkit-input-placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input::-webkit-input-placeholder {\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input::-moz-placeholder,\n      .theme-dark .le-combobox .le-input-field .input::-moz-placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input::-moz-placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input::-moz-placeholder {\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input::-ms-input-placeholder,\n      .theme-dark .le-combobox .le-input-field .input::-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input::-ms-input-placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input::-ms-input-placeholder {\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input::placeholder,\n      .theme-dark .le-combobox .le-input-field .input::placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input::placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input::placeholder {\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input:-ms-input-placeholder,\n      .theme-dark .le-combobox .le-input-field .input:-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input:-ms-input-placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input:-ms-input-placeholder {\n        /* Internet Explorer 10-11 */\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input:-ms-input-placeholder,\n      .theme-dark .le-combobox .le-input-field .input:-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-dark .input:-ms-input-placeholder,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input:-ms-input-placeholder {\n        /* Microsoft Edge */\n        font-style: italic;\n        color: #ffffff;\n}\n.le-combobox .le-input-field.theme-dark .input.disabled,\n      .theme-dark .le-combobox .le-input-field .input.disabled,\n      .le-combobox .le-combobox-input-container.theme-dark .input.disabled,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input.disabled {\n        border: 1px solid transparent;\n        background-color: #474a6a;\n        color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled::-webkit-input-placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled::-webkit-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled::-webkit-input-placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled::-webkit-input-placeholder {\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled::-moz-placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled::-moz-placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled::-moz-placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled::-moz-placeholder {\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled::-ms-input-placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled::-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled::-ms-input-placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled::-ms-input-placeholder {\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled::placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled::placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled::placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled::placeholder {\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled:-ms-input-placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled:-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled:-ms-input-placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder {\n          /* Internet Explorer 10-11 */\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input.disabled:-ms-input-placeholder,\n        .theme-dark .le-combobox .le-input-field .input.disabled:-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-dark .input.disabled:-ms-input-placeholder,\n        .theme-dark\n        .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder {\n          /* Microsoft Edge */\n          color: rgba(255, 255, 255, 0.6);\n}\n.le-combobox .le-input-field.theme-dark .input::-ms-clear,\n      .theme-dark .le-combobox .le-input-field .input::-ms-clear,\n      .le-combobox .le-combobox-input-container.theme-dark .input::-ms-clear,\n      .theme-dark\n      .le-combobox .le-combobox-input-container .input::-ms-clear {\n        /* Internet Explorer 10-11 */\n        display: none;\n        width: 0;\n        height: 0;\n}\n.le-combobox .le-input-field.theme-light .input,\n    .theme-light .le-combobox .le-input-field .input,\n    .le-combobox .le-combobox-input-container.theme-light .input,\n    .theme-light\n    .le-combobox .le-combobox-input-container .input {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      outline: none;\n      height: 32px;\n      padding: 0 9px;\n      width: 100%;\n      line-height: 32px;\n      font-size: 12px;\n      font-family: Roboto;\n      border-radius: 2px;\n      border: 1px solid #8C8D8F;\n      background-color: #fcfcfd;\n      color: #0A0A0A;\n}\n.le-combobox .le-input-field.theme-light .input:hover,\n      .theme-light .le-combobox .le-input-field .input:hover,\n      .le-combobox .le-combobox-input-container.theme-light .input:hover,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input:hover {\n        border-color: #8C8D8F;\n}\n.le-combobox .le-input-field.theme-light .input:focus,\n      .theme-light .le-combobox .le-input-field .input:focus,\n      .le-combobox .le-combobox-input-container.theme-light .input:focus,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input:focus {\n        border-color: #666666;\n}\n.le-combobox .le-input-field.theme-light .input.has-left-icon,\n      .theme-light .le-combobox .le-input-field .input.has-left-icon,\n      .le-combobox .le-combobox-input-container.theme-light .input.has-left-icon,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input.has-left-icon {\n        padding-left: 25px;\n}\n.le-combobox .le-input-field.theme-light .input.has-right-icon,\n      .theme-light .le-combobox .le-input-field .input.has-right-icon,\n      .le-combobox .le-combobox-input-container.theme-light .input.has-right-icon,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input.has-right-icon {\n        padding-right: 25px;\n}\n.le-combobox .le-input-field.theme-light .input.has-error,\n      .theme-light .le-combobox .le-input-field .input.has-error,\n      .le-combobox .le-combobox-input-container.theme-light .input.has-error,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input.has-error {\n        border-color: #d0021b;\n}\n.le-combobox .le-input-field.theme-light .input::-webkit-input-placeholder,\n      .theme-light .le-combobox .le-input-field .input::-webkit-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input::-webkit-input-placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input::-webkit-input-placeholder {\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input::-moz-placeholder,\n      .theme-light .le-combobox .le-input-field .input::-moz-placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input::-moz-placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input::-moz-placeholder {\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input::-ms-input-placeholder,\n      .theme-light .le-combobox .le-input-field .input::-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input::-ms-input-placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input::-ms-input-placeholder {\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input::placeholder,\n      .theme-light .le-combobox .le-input-field .input::placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input::placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input::placeholder {\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input:-ms-input-placeholder,\n      .theme-light .le-combobox .le-input-field .input:-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input:-ms-input-placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input:-ms-input-placeholder {\n        /* Internet Explorer 10-11 */\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input:-ms-input-placeholder,\n      .theme-light .le-combobox .le-input-field .input:-ms-input-placeholder,\n      .le-combobox .le-combobox-input-container.theme-light .input:-ms-input-placeholder,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input:-ms-input-placeholder {\n        /* Microsoft Edge */\n        font-style: italic;\n        color: #6F737C;\n}\n.le-combobox .le-input-field.theme-light .input.disabled,\n      .theme-light .le-combobox .le-input-field .input.disabled,\n      .le-combobox .le-combobox-input-container.theme-light .input.disabled,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input.disabled {\n        border: 1px solid #8C8D8F;\n        background-color: #ebecef;\n        color: rgba(10, 10, 10, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled::-webkit-input-placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled::-webkit-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled::-webkit-input-placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled::-webkit-input-placeholder {\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled::-moz-placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled::-moz-placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled::-moz-placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled::-moz-placeholder {\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled::-ms-input-placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled::-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled::-ms-input-placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled::-ms-input-placeholder {\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled::placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled::placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled::placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled::placeholder {\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled:-ms-input-placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled:-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled:-ms-input-placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder {\n          /* Internet Explorer 10-11 */\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input.disabled:-ms-input-placeholder,\n        .theme-light .le-combobox .le-input-field .input.disabled:-ms-input-placeholder,\n        .le-combobox .le-combobox-input-container.theme-light .input.disabled:-ms-input-placeholder,\n        .theme-light\n        .le-combobox .le-combobox-input-container .input.disabled:-ms-input-placeholder {\n          /* Microsoft Edge */\n          color: rgba(111, 115, 124, 0.5);\n}\n.le-combobox .le-input-field.theme-light .input::-ms-clear,\n      .theme-light .le-combobox .le-input-field .input::-ms-clear,\n      .le-combobox .le-combobox-input-container.theme-light .input::-ms-clear,\n      .theme-light\n      .le-combobox .le-combobox-input-container .input::-ms-clear {\n        /* Internet Explorer 10-11 */\n        display: none;\n        width: 0;\n        height: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_combobox_option_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5143cb85_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_combobox_option_vue__ = __webpack_require__(713);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_combobox_option_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5143cb85_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_combobox_option_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1147e069", content, true, {});

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-combobox-menu-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;padding:8px 10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.le-combobox-menu-item.theme-dark,.theme-dark .le-combobox-menu-item{color:#fff}.le-combobox-menu-item.theme-light,.theme-light .le-combobox-menu-item{color:#666}.le-combobox-menu-item.theme-dark.highlighted,.theme-dark .le-combobox-menu-item.highlighted{cursor:pointer;background-color:#2d3162}.le-combobox-menu-item.theme-light.highlighted,.theme-light .le-combobox-menu-item.highlighted{cursor:pointer;background-color:#f2f2f2}.le-combobox-menu-item.selected{font-weight:700}.le-combobox-menu-item.default-item{width:calc(100% + 2px);margin-left:-1px}.le-combobox-menu-item.default-item.theme-dark,.theme-dark .le-combobox-menu-item.default-item{border:1px solid #474a6a;background-color:#141a42}.le-combobox-menu-item.default-item.theme-dark.highlighted,.le-combobox-menu-item.default-item.theme-dark:hover,.theme-dark .le-combobox-menu-item.default-item.highlighted,.theme-dark .le-combobox-menu-item.default-item:hover{background-color:#2d3162}.le-combobox-menu-item.default-item.theme-light,.theme-light .le-combobox-menu-item.default-item{border:1px solid #ddd;background-color:#fff}.le-combobox-menu-item.default-item.theme-light.highlighted,.le-combobox-menu-item.default-item.theme-light:hover,.theme-light .le-combobox-menu-item.default-item.highlighted,.theme-light .le-combobox-menu-item.default-item:hover{background-color:#f2f2f2}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-combobox/le-combobox-option.vue"],"names":[],"mappings":"AAIA,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,8BAA+B,AACvB,sBAAuB,AAC/B,iBAA2B,AAE3B,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,qEAEI,UAAe,CAClB,AACD,uEAEI,UAAe,CAClB,AACD,6FAEI,eAAgB,AAChB,wBAA0B,CAC7B,AACD,+FAEI,eAAgB,AAChB,wBAA0B,CAC7B,AACD,gCACI,eAAkB,CACrB,AACD,oCACI,uBAAwB,AACxB,gBAAkB,CACrB,AACD,+FAEM,yBAA0B,AAC1B,wBAA0B,CAC/B,AACD,kOAGQ,wBAA0B,CACjC,AACD,iGAEM,sBAA0B,AAC1B,qBAA0B,CAC/B,AACD,sOAGQ,wBAA0B,CACjC","file":"le-combobox-option.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-combobox-menu-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 8px 10px 8px 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.le-combobox-menu-item.theme-dark,\n  .theme-dark .le-combobox-menu-item {\n    color: #ffffff;\n}\n.le-combobox-menu-item.theme-light,\n  .theme-light .le-combobox-menu-item {\n    color: #666666;\n}\n.le-combobox-menu-item.theme-dark.highlighted,\n  .theme-dark .le-combobox-menu-item.highlighted {\n    cursor: pointer;\n    background-color: #2d3162;\n}\n.le-combobox-menu-item.theme-light.highlighted,\n  .theme-light .le-combobox-menu-item.highlighted {\n    cursor: pointer;\n    background-color: #f2f2f2;\n}\n.le-combobox-menu-item.selected {\n    font-weight: bold;\n}\n.le-combobox-menu-item.default-item {\n    width: calc(100% + 2px);\n    margin-left: -1px;\n}\n.le-combobox-menu-item.default-item.theme-dark,\n    .theme-dark .le-combobox-menu-item.default-item {\n      border: 1px solid #474a6a;\n      background-color: #141a42;\n}\n.le-combobox-menu-item.default-item.theme-dark.highlighted, .le-combobox-menu-item.default-item.theme-dark:hover,\n      .theme-dark .le-combobox-menu-item.default-item.highlighted,\n      .theme-dark .le-combobox-menu-item.default-item:hover {\n        background-color: #2d3162;\n}\n.le-combobox-menu-item.default-item.theme-light,\n    .theme-light .le-combobox-menu-item.default-item {\n      border: 1px solid #dddddd;\n      background-color: #ffffff;\n}\n.le-combobox-menu-item.default-item.theme-light.highlighted, .le-combobox-menu-item.default-item.theme-light:hover,\n      .theme-light .le-combobox-menu-item.default-item.highlighted,\n      .theme-light .le-combobox-menu-item.default-item:hover {\n        background-color: #f2f2f2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'le-combobox-menu-item',
    {
      highlighted: _vm.index === _vm.highlightedIndex,
      selected: _vm.inputValue === _vm.item.value,
      'default-item': _vm.isDefaultItem,
    }
  ],attrs:{"id":(_vm.baseId + "-" + _vm.index),"role":"option","aria-selected":_vm.index === _vm.highlightedIndex ? 'true' : 'false'},on:{"mouseover":_vm.onMouseover,"click":_vm.onClick}},[_vm._t("comboboxOption",[_c('le-text-with-highlight',{attrs:{"text":_vm.item.value,"highlightText":_vm.highlightRegex}})],{"item":_vm.item})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:['le-combobox', _vm.theme]},[_c('div',{staticClass:"le-combobox-input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"comboboxInput",class:[
        'input',
          {
            selected: _vm.selectedItem.value === _vm.inputValue,
            disabled: _vm.disabled
          }
      ],attrs:{"id":_vm.inputId,"role":"combobox","type":"text","aria-haspopup":"listbox","aria-owns":_vm.menuId,"aria-expanded":_vm.ariaExpanded,"aria-autocomplete":"list","aria-controls":_vm.isOpen ? _vm.menuId : '',"aria-activedescendant":_vm.activeDescendant,"aria-label":_vm.translations.comboboxLabel,"placeholder":_vm.translations.comboboxPlaceholder,"autocomplete":"off","disabled":_vm.disabled},domProps:{"value":(_vm.inputValue)},on:{"keydown":[_vm.debounceKeydown,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onDownKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onUpKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onEnterKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.preventDefault();return _vm.onEscKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTabKey($event)}],"focus":_vm.onFocus,"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputValue),expression:"inputValue"}],class:['ico-10 ico-input-field-reset right-icon', { disabled: _vm.disabled }],attrs:{"id":_vm.clearButtonId,"tabindex":"0","role":"button","type":"button","aria-label":_vm.translations.clearButtonLabel},on:{"click":_vm.onClearClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onClearClick($event)}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inputValue),expression:"!inputValue"}],class:['ico-10 ico-arrow-down right-icon', { disabled: _vm.disabled }],attrs:{"id":_vm.expandButtonId,"tabindex":"-1","role":"button","type":"button","aria-label":_vm.translations.expandButtonLabel,"aria-controls":_vm.isOpen ? _vm.menuId : '',"aria-expanded":_vm.ariaExpanded},on:{"click":_vm.onExpandClick}})]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"le-combobox-menu",attrs:{"id":_vm.menuId,"role":"listbox","aria-label":_vm.translations.comboboxLabel,"tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onDownKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onUpKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onEnterKey($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.preventDefault();return _vm.onEscKey($event)}]}},[_c('div',{ref:"comboboxMenu",staticClass:"le-combobox-menu-inner-container"},[_vm._l((_vm.filteredItems),function(item,index){return _c('le-combobox-option',{key:item.value,attrs:{"item":item,"index":index,"baseId":_vm.baseMenuItemId,"inputValue":_vm.inputValue,"highlightedIndex":_vm.highlightedIndex,"minSearchCharacters":_vm.minSearchCharacters},on:{"mouseover":_vm.onItemMouseover,"click":_vm.onItemClick},scopedSlots:_vm._u([{key:"comboboxOption",fn:function(ref){
      var item = ref.item;
return [_vm._t("comboboxOption",null,{"item":item})]}}],null,true)})}),_vm._v(" "),(_vm.isNothingFound)?_c('span',{staticClass:"le-combobox-menu-item le-combobox-nothing-found-item",attrs:{"aria-disabled":"true","role":"option","aria-selected":false}},[_vm._t("nothingFoundOption",[_vm._v(" "+_vm._s(_vm.translations.nothingFoundLabel)+" ")])],2):_vm._e()],2),_vm._v(" "),(_vm.defaultItem)?_c('le-combobox-option',{attrs:{"item":_vm.defaultItem,"index":_vm.defaultItemIndex,"baseId":_vm.baseMenuItemId,"inputValue":_vm.inputValue,"highlightedIndex":_vm.highlightedIndex,"minSearchCharacters":_vm.minSearchCharacters,"isDefaultItem":true},on:{"mouseover":_vm.onItemMouseover,"click":_vm.onItemClick},scopedSlots:_vm._u([{key:"comboboxOption",fn:function(ref){
      var item = ref.item;
return [_vm._t("defaultItem",null,{"item":item})]}}],null,true)}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0846fcb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0846fcb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0846fcb2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5347fb00", content, true, {});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-stepper[data-v-0846fcb2]{height:100vh}.le-stepper.theme-dark[data-v-0846fcb2],.theme-dark .le-stepper[data-v-0846fcb2]{background-color:#0d1149}.le-stepper.theme-light[data-v-0846fcb2],.theme-light .le-stepper[data-v-0846fcb2]{background-color:#fcfcfd}.le-stepper .footer[data-v-0846fcb2]{position:absolute;bottom:0;z-index:10}.le-stepper .header[data-v-0846fcb2]{top:0;z-index:10;width:100%}.le-stepper .timeline[data-v-0846fcb2]{padding-top:10px;padding-right:21px;width:300px;padding-left:65px}.le-stepper .timeline__wrap[data-v-0846fcb2]{margin:30px 0 -30px 7px}.le-stepper .timeline__wrap.theme-dark[data-v-0846fcb2],.theme-dark .le-stepper .timeline__wrap[data-v-0846fcb2]{border-width:0 0 0 3px;border-style:solid;border-radius:2px;-o-border-image:linear-gradient(0deg,#8493d6,rgba(132,147,214,0)) 1 100%;border-image:-webkit-gradient(linear,left bottom,left top,from(#8493d6),to(rgba(132,147,214,0))) 1 100%;border-image:linear-gradient(0deg,#8493d6,rgba(132,147,214,0)) 1 100%}.le-stepper .timeline__wrap.theme-light[data-v-0846fcb2],.theme-light .le-stepper .timeline__wrap[data-v-0846fcb2]{border-width:0 0 0 3px;border-style:solid;border-radius:2px;-o-border-image:linear-gradient(0deg,#5970ab,rgba(89,112,171,0)) 1 100%;border-image:-webkit-gradient(linear,left bottom,left top,from(#5970ab),to(rgba(89,112,171,0))) 1 100%;border-image:linear-gradient(0deg,#5970ab,rgba(89,112,171,0)) 1 100%}.le-stepper .timeline__wrap2[data-v-0846fcb2]{margin:30px 0 -30px 10px;border-width:3px;border-radius:2px}.le-stepper .timeline__wrapper[data-v-0846fcb2]{margin-top:-35px;padding-bottom:4px;text-align:left;margin-left:20px}.le-stepper .timeline__container[data-v-0846fcb2]{margin-left:32px}.le-stepper .timeline__container[data-v-0846fcb2],.le-stepper .timeline__steps.theme-dark[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps[data-v-0846fcb2]{display:-webkit-box;display:-ms-flexbox;display:flex}.le-stepper .timeline__steps.theme-dark__index[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__index[data-v-0846fcb2]{margin:11px 25px auto -85px;font-style:normal;font-weight:500;font-size:14px;color:#4667c8}.le-stepper .timeline__steps.theme-dark__index.active__index[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__index.active__index[data-v-0846fcb2]{color:#c9d3f3}.le-stepper .timeline__steps.theme-dark__icon__active[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]{width:20px;height:20px;border-radius:50%;border:2px solid #3955a7;position:relative;margin-left:-13.5px;margin-top:5px;background:#131952;-webkit-box-shadow:0 10px 5px 0 #0d1149;box-shadow:0 10px 5px 0 #0d1149}.le-stepper .timeline__steps.theme-dark__icon__active[data-v-0846fcb2]:before,.theme-dark .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]:before{content:\"\";width:12px;height:12px;background:#fcfcfd;border-radius:50%;display:block;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.le-stepper .timeline__steps.theme-dark__icon__done[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]{display:inline-block;width:20px;height:20px;border-radius:50%;border:2px solid #4667c8;position:relative;margin-left:-13.5px;margin-top:5px;background:#131952;-webkit-box-shadow:0 10px 5px 0 #0d1149;box-shadow:0 10px 5px 0 #0d1149}.le-stepper .timeline__steps.theme-dark__icon__done[data-v-0846fcb2]:after,.theme-dark .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]:after{content:\"\";position:absolute;width:5px;height:10px;left:14px;top:5px;border:solid #4667c8;border-width:0 2px 2px 0;-webkit-transform:translateY(-20%) translateX(-100%) rotate(45deg);transform:translateY(-20%) translateX(-100%) rotate(45deg)}.le-stepper .timeline__steps.theme-dark__icon__inactive[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__icon__inactive[data-v-0846fcb2]{width:20px;height:20px;border:2px solid #8ba3ea;border-radius:50%;margin-left:-13.5px;margin-top:5px;-webkit-box-shadow:0 10px 5px 0 #0d1149;box-shadow:0 10px 5px #0d1149;background:#131952}.le-stepper .timeline__steps.theme-dark__icon__edit[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__icon__edit[data-v-0846fcb2]{margin-left:-12px;margin-top:5px;height:24px;width:24px;-webkit-box-shadow:0 10px 5px 0 #0d1149;box-shadow:0 10px 5px 0 #0d1149}.le-stepper .timeline__steps.theme-dark__text[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text[data-v-0846fcb2]{margin-left:18px;padding-top:7px}.le-stepper .timeline__steps.theme-dark__text__child[data-v-0846fcb2],.le-stepper .timeline__steps.theme-dark__text__main[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text__child[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text__main[data-v-0846fcb2]{font-size:14px;line-height:16px;font-weight:500;color:#c9d3f3;cursor:pointer;margin:3px auto 16px}.le-stepper .timeline__steps.theme-dark__text__child[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text__child[data-v-0846fcb2]{font-weight:400;margin-left:10px}.le-stepper .timeline__steps.theme-dark__text .completed__text[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text .completed__text[data-v-0846fcb2]{color:#4667c8}.le-stepper .timeline__steps.theme-dark__text .active__text[data-v-0846fcb2],.theme-dark .le-stepper .timeline__steps__text .active__text[data-v-0846fcb2]{color:#c9d3f3;background:#3955a7;padding:10px;border-radius:6px;margin:-8px auto 16px}.le-stepper .timeline__steps.theme-light[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps[data-v-0846fcb2]{display:-webkit-box;display:-ms-flexbox;display:flex}.le-stepper .timeline__steps.theme-light__index[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__index[data-v-0846fcb2]{margin:11px 25px auto -85px;font-style:normal;font-weight:500;font-size:14px;color:#30437e}.le-stepper .timeline__steps.theme-light__index.active__index[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__index.active__index[data-v-0846fcb2]{color:#3955a7}.le-stepper .timeline__steps.theme-light__icon__active[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]{width:20px;height:20px;border-radius:50%;border:2px solid #3955a7;position:relative;margin-left:-13.5px;margin-top:5px;background:#fcfcfd;-webkit-box-shadow:0 10px 5px 0 #fcfcfd;box-shadow:0 10px 5px 0 #fcfcfd}.le-stepper .timeline__steps.theme-light__icon__active[data-v-0846fcb2]:before,.theme-light .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]:before{content:\"\";width:12px;height:12px;background:#4667c8;border-radius:50%;display:block;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.le-stepper .timeline__steps.theme-light__icon__done[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]{display:inline-block;width:20px;height:20px;border-radius:50%;border:2px solid #4667c8;position:relative;margin-left:-13.5px;margin-top:5px;background:#fcfcfd;-webkit-box-shadow:0 10px 5px 0 #fcfcfd;box-shadow:0 10px 5px 0 #fcfcfd}.le-stepper .timeline__steps.theme-light__icon__done[data-v-0846fcb2]:after,.theme-light .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]:after{content:\"\";position:absolute;width:5px;height:10px;left:14px;top:5px;border:solid #4667c8;border-width:0 2px 2px 0;-webkit-transform:translateY(-20%) translateX(-100%) rotate(45deg);transform:translateY(-20%) translateX(-100%) rotate(45deg)}.le-stepper .timeline__steps.theme-light__icon__inactive[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__icon__inactive[data-v-0846fcb2]{width:20px;height:20px;border:2px solid #8ba3ea;border-radius:50%;margin-left:-13.5px;margin-top:5px;-webkit-box-shadow:0 10px 5px 0 #fcfcfd;box-shadow:0 10px 5px #fcfcfd;background:#fcfcfd}.le-stepper .timeline__steps.theme-light__icon__edit[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__icon__edit[data-v-0846fcb2]{margin-left:-12px;margin-top:5px;height:24px;width:24px;-webkit-box-shadow:0 10px 5px 0 #fcfcfd;box-shadow:0 10px 5px 0 #fcfcfd}.le-stepper .timeline__steps.theme-light__text[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text[data-v-0846fcb2]{margin-left:18px;padding-top:7px}.le-stepper .timeline__steps.theme-light__text__child[data-v-0846fcb2],.le-stepper .timeline__steps.theme-light__text__main[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text__child[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text__main[data-v-0846fcb2]{font-size:14px;line-height:16px;font-weight:500;cursor:pointer;margin:3px auto 16px}.le-stepper .timeline__steps.theme-light__text__child[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text__child[data-v-0846fcb2]{font-weight:400;margin-left:10px}.le-stepper .timeline__steps.theme-light__text .completed__text[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text .completed__text[data-v-0846fcb2]{color:#30437e}.le-stepper .timeline__steps.theme-light__text .active__text[data-v-0846fcb2],.theme-light .le-stepper .timeline__steps__text .active__text[data-v-0846fcb2]{color:#3955a7;background:#c9d3f3;padding:10px;border-radius:6px;margin:-8px auto 16px}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-stepper/le-stepper.vue"],"names":[],"mappings":"AAIA,6BACE,YAAc,CACf,AACD,iFAEI,wBAA0B,CAC7B,AACD,mFAEI,wBAA0B,CAC7B,AACD,qCACI,kBAAmB,AACnB,SAAU,AACV,UAAY,CACf,AACD,qCACI,MAAO,AACP,WAAY,AACZ,UAAY,CACf,AACD,uCACI,iBAAkB,AAClB,mBAAoB,AACpB,YAAa,AACb,iBAAmB,CACtB,AACD,6CACM,uBAAyB,CAC9B,AACD,iHAEQ,uBAAwB,AACxB,mBAAoB,AACpB,kBAAmB,AACnB,yEAAiF,AAC9E,wGAAgH,AAChH,qEAA8E,CACxF,AACD,mHAEQ,uBAAwB,AACxB,mBAAoB,AACpB,kBAAmB,AACnB,wEAAgF,AAC7E,uGAA+G,AAC/G,oEAA6E,CACvF,AACD,8CACM,yBAA0B,AAC1B,iBAAkB,AAClB,iBAAmB,CACxB,AACD,gDACM,iBAAkB,AAClB,mBAAoB,AACpB,gBAAiB,AACjB,gBAAkB,CACvB,AACD,kDAIM,gBAAkB,CACvB,AACD,qKALM,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAQnB,AACD,iIAEQ,4BAA6B,AAC7B,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,aAAe,CACtB,AACD,6JAEQ,aAAe,CACtB,AACD,+IAEQ,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,mBAAoB,AACpB,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,6JAEU,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAClD,AACD,2IAEQ,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,mBAAoB,AACpB,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,uJAEU,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,UAAW,AACX,QAAS,AACT,qBAAsB,AACtB,yBAA0B,AAC1B,mEAAoE,AAC5D,0DAA4D,CAC7E,AACD,mJAEQ,WAAY,AACZ,YAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,wCAA6C,AAC7C,8BAAiC,AACjC,kBAAoB,CAC3B,AACD,2IAEQ,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,+HAEQ,iBAAkB,AAClB,eAAiB,CACxB,AACD,wRAGU,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,eAAgB,AAChB,oBAA2B,CACpC,AACD,6IAEU,gBAAiB,AACjB,gBAAkB,CAC3B,AACD,iKAEU,aAAe,CACxB,AACD,2JAEU,cAAe,AACf,mBAAoB,AACpB,aAAc,AACd,kBAAmB,AACnB,qBAA4B,CACrC,AACD,qHAEM,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACnB,AACD,mIAEQ,4BAA6B,AAC7B,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,aAAe,CACtB,AACD,+JAEQ,aAAe,CACtB,AACD,iJAEQ,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,mBAAoB,AACpB,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,+JAEU,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAClD,AACD,6IAEQ,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,mBAAoB,AACpB,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,yJAEU,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,YAAa,AACb,UAAW,AACX,QAAS,AACT,qBAAsB,AACtB,yBAA0B,AAC1B,mEAAoE,AAC5D,0DAA4D,CAC7E,AACD,qJAEQ,WAAY,AACZ,YAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,wCAA6C,AAC7C,8BAAiC,AACjC,kBAAoB,CAC3B,AACD,6IAEQ,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,wCAA6C,AAC7C,+BAAqC,CAC5C,AACD,iIAEQ,iBAAkB,AAClB,eAAiB,CACxB,AACD,4RAGU,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,eAAgB,AAChB,oBAA2B,CACpC,AACD,+IAEU,gBAAiB,AACjB,gBAAkB,CAC3B,AACD,mKAEU,aAAe,CACxB,AACD,6JAEU,cAAe,AACf,mBAAoB,AACpB,aAAc,AACd,kBAAmB,AACnB,qBAA4B,CACrC","file":"le-stepper.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-stepper[data-v-0846fcb2] {\n  height: 100vh;\n}\n.le-stepper.theme-dark[data-v-0846fcb2],\n  .theme-dark .le-stepper[data-v-0846fcb2] {\n    background-color: #0d1149;\n}\n.le-stepper.theme-light[data-v-0846fcb2],\n  .theme-light .le-stepper[data-v-0846fcb2] {\n    background-color: #fcfcfd;\n}\n.le-stepper .footer[data-v-0846fcb2] {\n    position: absolute;\n    bottom: 0;\n    z-index: 10;\n}\n.le-stepper .header[data-v-0846fcb2] {\n    top: 0;\n    z-index: 10;\n    width: 100%;\n}\n.le-stepper .timeline[data-v-0846fcb2] {\n    padding-top: 10px;\n    padding-right: 21px;\n    width: 300px;\n    padding-left: 65px;\n}\n.le-stepper .timeline__wrap[data-v-0846fcb2] {\n      margin: 30px 0 -30px 7px;\n}\n.le-stepper .timeline__wrap.theme-dark[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__wrap[data-v-0846fcb2] {\n        border-width: 0 0 0 3px;\n        border-style: solid;\n        border-radius: 2px;\n        -o-border-image: linear-gradient(to top, #8493d6, rgba(132, 147, 214, 0)) 1 100%;\n           border-image: -webkit-gradient(linear, left bottom, left top, from(#8493d6), to(rgba(132, 147, 214, 0))) 1 100%;\n           border-image: linear-gradient(to top, #8493d6, rgba(132, 147, 214, 0)) 1 100%;\n}\n.le-stepper .timeline__wrap.theme-light[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__wrap[data-v-0846fcb2] {\n        border-width: 0 0 0 3px;\n        border-style: solid;\n        border-radius: 2px;\n        -o-border-image: linear-gradient(to top, #5970ab, rgba(89, 112, 171, 0)) 1 100%;\n           border-image: -webkit-gradient(linear, left bottom, left top, from(#5970ab), to(rgba(89, 112, 171, 0))) 1 100%;\n           border-image: linear-gradient(to top, #5970ab, rgba(89, 112, 171, 0)) 1 100%;\n}\n.le-stepper .timeline__wrap2[data-v-0846fcb2] {\n      margin: 30px 0 -30px 10px;\n      border-width: 3px;\n      border-radius: 2px;\n}\n.le-stepper .timeline__wrapper[data-v-0846fcb2] {\n      margin-top: -35px;\n      padding-bottom: 4px;\n      text-align: left;\n      margin-left: 20px;\n}\n.le-stepper .timeline__container[data-v-0846fcb2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin-left: 32px;\n}\n.le-stepper .timeline__steps.theme-dark[data-v-0846fcb2],\n    .theme-dark .le-stepper .timeline__steps[data-v-0846fcb2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.le-stepper .timeline__steps.theme-dark__index[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__index[data-v-0846fcb2] {\n        margin: 11px 25px auto -85px;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        color: #4667C8;\n}\n.le-stepper .timeline__steps.theme-dark__index.active__index[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__index.active__index[data-v-0846fcb2] {\n        color: #C9D3F3;\n}\n.le-stepper .timeline__steps.theme-dark__icon__active[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__icon__active[data-v-0846fcb2] {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        border: 2px solid #3955a7;\n        position: relative;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        background: #131952;\n        -webkit-box-shadow: 0px 10px 5px 0px #0d1149;\n        box-shadow: 0px 10px 5px 0px #0d1149;\n}\n.le-stepper .timeline__steps.theme-dark__icon__active[data-v-0846fcb2]:before,\n        .theme-dark .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]:before {\n          content: '';\n          width: 12px;\n          height: 12px;\n          background: #fcfcfd;\n          border-radius: 50%;\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          -webkit-transform: translate(-50%, -50%);\n                  transform: translate(-50%, -50%);\n}\n.le-stepper .timeline__steps.theme-dark__icon__done[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__icon__done[data-v-0846fcb2] {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        border: 2px solid #4667C8;\n        position: relative;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        background: #131952;\n        -webkit-box-shadow: 0px 10px 5px 0px #0d1149;\n        box-shadow: 0px 10px 5px 0px #0d1149;\n}\n.le-stepper .timeline__steps.theme-dark__icon__done[data-v-0846fcb2]:after,\n        .theme-dark .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]:after {\n          content: '';\n          position: absolute;\n          width: 5px;\n          height: 10px;\n          left: 14px;\n          top: 5px;\n          border: solid #4667C8;\n          border-width: 0 2px 2px 0;\n          -webkit-transform: translateY(-20%) translateX(-100%) rotate(45deg);\n                  transform: translateY(-20%) translateX(-100%) rotate(45deg);\n}\n.le-stepper .timeline__steps.theme-dark__icon__inactive[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__icon__inactive[data-v-0846fcb2] {\n        width: 20px;\n        height: 20px;\n        border: 2px solid #8BA3EA;\n        border-radius: 50%;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        -webkit-box-shadow: 0px 10px 5px 0px #0d1149;\n        box-shadow: 0px 10px 5px #0d1149;\n        background: #131952;\n}\n.le-stepper .timeline__steps.theme-dark__icon__edit[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__icon__edit[data-v-0846fcb2] {\n        margin-left: -12px;\n        margin-top: 5px;\n        height: 24px;\n        width: 24px;\n        -webkit-box-shadow: 0px 10px 5px 0px #0d1149;\n        box-shadow: 0px 10px 5px 0px #0d1149;\n}\n.le-stepper .timeline__steps.theme-dark__text[data-v-0846fcb2],\n      .theme-dark .le-stepper .timeline__steps__text[data-v-0846fcb2] {\n        margin-left: 18px;\n        padding-top: 7px;\n}\n.le-stepper .timeline__steps.theme-dark__text__main[data-v-0846fcb2], .le-stepper .timeline__steps.theme-dark__text__child[data-v-0846fcb2],\n        .theme-dark .le-stepper .timeline__steps__text__main[data-v-0846fcb2],\n        .theme-dark .le-stepper .timeline__steps__text__child[data-v-0846fcb2] {\n          font-size: 14px;\n          line-height: 16px;\n          font-weight: 500;\n          color: #C9D3F3;\n          cursor: pointer;\n          margin: 3px auto 16px auto;\n}\n.le-stepper .timeline__steps.theme-dark__text__child[data-v-0846fcb2],\n        .theme-dark .le-stepper .timeline__steps__text__child[data-v-0846fcb2] {\n          font-weight: 400;\n          margin-left: 10px;\n}\n.le-stepper .timeline__steps.theme-dark__text .completed__text[data-v-0846fcb2],\n        .theme-dark .le-stepper .timeline__steps__text .completed__text[data-v-0846fcb2] {\n          color: #4667C8;\n}\n.le-stepper .timeline__steps.theme-dark__text .active__text[data-v-0846fcb2],\n        .theme-dark .le-stepper .timeline__steps__text .active__text[data-v-0846fcb2] {\n          color: #C9D3F3;\n          background: #3955a7;\n          padding: 10px;\n          border-radius: 6px;\n          margin: -8px auto 16px auto;\n}\n.le-stepper .timeline__steps.theme-light[data-v-0846fcb2],\n    .theme-light .le-stepper .timeline__steps[data-v-0846fcb2] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n}\n.le-stepper .timeline__steps.theme-light__index[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__index[data-v-0846fcb2] {\n        margin: 11px 25px auto -85px;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        color: #30437e;\n}\n.le-stepper .timeline__steps.theme-light__index.active__index[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__index.active__index[data-v-0846fcb2] {\n        color: #3955a7;\n}\n.le-stepper .timeline__steps.theme-light__icon__active[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__icon__active[data-v-0846fcb2] {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        border: 2px solid #3955a7;\n        position: relative;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        background: #fcfcfd;\n        -webkit-box-shadow: 0px 10px 5px 0px #fcfcfd;\n        box-shadow: 0px 10px 5px 0px #fcfcfd;\n}\n.le-stepper .timeline__steps.theme-light__icon__active[data-v-0846fcb2]:before,\n        .theme-light .le-stepper .timeline__steps__icon__active[data-v-0846fcb2]:before {\n          content: '';\n          width: 12px;\n          height: 12px;\n          background: #4667C8;\n          border-radius: 50%;\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          -webkit-transform: translate(-50%, -50%);\n                  transform: translate(-50%, -50%);\n}\n.le-stepper .timeline__steps.theme-light__icon__done[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__icon__done[data-v-0846fcb2] {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        border: 2px solid #4667C8;\n        position: relative;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        background: #fcfcfd;\n        -webkit-box-shadow: 0px 10px 5px 0px #fcfcfd;\n        box-shadow: 0px 10px 5px 0px #fcfcfd;\n}\n.le-stepper .timeline__steps.theme-light__icon__done[data-v-0846fcb2]:after,\n        .theme-light .le-stepper .timeline__steps__icon__done[data-v-0846fcb2]:after {\n          content: '';\n          position: absolute;\n          width: 5px;\n          height: 10px;\n          left: 14px;\n          top: 5px;\n          border: solid #4667C8;\n          border-width: 0 2px 2px 0;\n          -webkit-transform: translateY(-20%) translateX(-100%) rotate(45deg);\n                  transform: translateY(-20%) translateX(-100%) rotate(45deg);\n}\n.le-stepper .timeline__steps.theme-light__icon__inactive[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__icon__inactive[data-v-0846fcb2] {\n        width: 20px;\n        height: 20px;\n        border: 2px solid #8BA3EA;\n        border-radius: 50%;\n        margin-left: -13.5px;\n        margin-top: 5px;\n        -webkit-box-shadow: 0px 10px 5px 0px #fcfcfd;\n        box-shadow: 0px 10px 5px #fcfcfd;\n        background: #fcfcfd;\n}\n.le-stepper .timeline__steps.theme-light__icon__edit[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__icon__edit[data-v-0846fcb2] {\n        margin-left: -12px;\n        margin-top: 5px;\n        height: 24px;\n        width: 24px;\n        -webkit-box-shadow: 0px 10px 5px 0px #fcfcfd;\n        box-shadow: 0px 10px 5px 0px #fcfcfd;\n}\n.le-stepper .timeline__steps.theme-light__text[data-v-0846fcb2],\n      .theme-light .le-stepper .timeline__steps__text[data-v-0846fcb2] {\n        margin-left: 18px;\n        padding-top: 7px;\n}\n.le-stepper .timeline__steps.theme-light__text__main[data-v-0846fcb2], .le-stepper .timeline__steps.theme-light__text__child[data-v-0846fcb2],\n        .theme-light .le-stepper .timeline__steps__text__main[data-v-0846fcb2],\n        .theme-light .le-stepper .timeline__steps__text__child[data-v-0846fcb2] {\n          font-size: 14px;\n          line-height: 16px;\n          font-weight: 500;\n          cursor: pointer;\n          margin: 3px auto 16px auto;\n}\n.le-stepper .timeline__steps.theme-light__text__child[data-v-0846fcb2],\n        .theme-light .le-stepper .timeline__steps__text__child[data-v-0846fcb2] {\n          font-weight: 400;\n          margin-left: 10px;\n}\n.le-stepper .timeline__steps.theme-light__text .completed__text[data-v-0846fcb2],\n        .theme-light .le-stepper .timeline__steps__text .completed__text[data-v-0846fcb2] {\n          color: #30437e;\n}\n.le-stepper .timeline__steps.theme-light__text .active__text[data-v-0846fcb2],\n        .theme-light .le-stepper .timeline__steps__text .active__text[data-v-0846fcb2] {\n          color: #3955a7;\n          background: #C9D3F3;\n          padding: 10px;\n          border-radius: 6px;\n          margin: -8px auto 16px auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_header_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3db0bce7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_header_vue__ = __webpack_require__(721);
function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3db0bce7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3db0bce7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(720);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0c81304e", content, true, {});

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-stepper-header[data-v-3db0bce7]{padding:10px 20px 10px 40px;text-align:left}.le-stepper-header.theme-dark[data-v-3db0bce7],.theme-dark .le-stepper-header[data-v-3db0bce7]{font-family:Roboto;color:#fff}.le-stepper-header.theme-light[data-v-3db0bce7],.theme-light .le-stepper-header[data-v-3db0bce7]{font-family:Roboto;color:#0a0a0a}.le-stepper-header p[data-v-3db0bce7]{font-family:Roboto;font-style:normal;font-weight:700;font-size:20px;line-height:120%}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-stepper/le-stepper-header.vue"],"names":[],"mappings":"AAIA,oCACE,4BAA6B,AAC7B,eAAiB,CAClB,AACD,+FAEI,mBAAoB,AACpB,UAAe,CAClB,AACD,iGAEI,mBAAoB,AACpB,aAAe,CAClB,AACD,sCACI,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACrB","file":"le-stepper-header.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-stepper-header[data-v-3db0bce7] {\n  padding: 10px 20px 10px 40px;\n  text-align: left;\n}\n.le-stepper-header.theme-dark[data-v-3db0bce7],\n  .theme-dark .le-stepper-header[data-v-3db0bce7] {\n    font-family: Roboto;\n    color: #ffffff;\n}\n.le-stepper-header.theme-light[data-v-3db0bce7],\n  .theme-light .le-stepper-header[data-v-3db0bce7] {\n    font-family: Roboto;\n    color: #0A0A0A;\n}\n.le-stepper-header p[data-v-3db0bce7] {\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 120%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',{staticClass:"le-stepper-header"},[_c('p',[_vm._v(_vm._s(_vm.title))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_footer_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0295747a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_footer_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_le_stepper_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0295747a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_le_stepper_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("503a2061", content, true, {});

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".le-stepper-footer{padding:26px 60px 26px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.le-stepper-footer.theme-dark,.theme-dark .le-stepper-footer{background-color:#090c43;color:#fff}.le-stepper-footer.theme-light,.theme-light .le-stepper-footer{background-color:#f8fbff;color:#0a0a0a}.le-stepper-footer .right__content{display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:30px}.le-stepper-footer .right__content .next.theme-dark,.theme-dark .le-stepper-footer .right__content .next{background-color:#9a4709;color:#fff;font-weight:700;border-radius:16px;font-family:Roboto;border:0;cursor:pointer;margin-right:32px}.le-stepper-footer .right__content .next.theme-dark:hover,.theme-dark .le-stepper-footer .right__content .next:hover{background:#c1570a;border:1px solid #c1570a;color:#fff;text-shadow:none}.le-stepper-footer .right__content .next.theme-dark:disabled,.theme-dark .le-stepper-footer .right__content .next:disabled{background:#813418;border:1px solid #813418;color:hsla(0,0%,61%,.5);text-shadow:none;cursor:not-allowed}.le-stepper-footer .right__content .next.theme-dark:disabled:hover,.theme-dark .le-stepper-footer .right__content .next:disabled:hover{background:#813418;border:1px solid #813418;color:hsla(0,0%,61%,.5);text-shadow:none}.le-stepper-footer .right__content .next.theme-light,.theme-light .le-stepper-footer .right__content .next{background-color:#9a4709;color:#fff;font-weight:700;border-radius:16px;font-family:Roboto;border:0;cursor:pointer;margin-right:32px}.le-stepper-footer .right__content .next.theme-light:hover,.theme-light .le-stepper-footer .right__content .next:hover{background:#c1570a;border:1px solid #c1570a;color:#fff;text-shadow:none}.le-stepper-footer .right__content .next.theme-light:disabled,.theme-light .le-stepper-footer .right__content .next:disabled{background:#e79a7e;border:1px solid #e79a7e;color:rgba(252,252,253,.5);text-shadow:none;cursor:not-allowed}.le-stepper-footer .right__content .next.theme-light:disabled:hover,.theme-light .le-stepper-footer .right__content .next:disabled:hover{background:#e79a7e;border:1px solid #e79a7e;color:rgba(252,252,253,.5);text-shadow:none}.le-stepper-footer .right__content .skip.theme-dark,.theme-dark .le-stepper-footer .right__content .skip{background-color:#fff;font-weight:700;border-radius:16px;font-family:Roboto;border:0;margin:auto 10px;cursor:pointer}.le-stepper-footer .right__content .skip.theme-dark:hover,.theme-dark .le-stepper-footer .right__content .skip:hover{border:1px solid #fff;background-color:#535677;text-shadow:none}.le-stepper-footer .right__content .skip.theme-dark:hover .button-label,.theme-dark .le-stepper-footer .right__content .skip:hover .button-label{color:#f0f0f0}.le-stepper-footer .right__content .skip.theme-dark:disabled,.theme-dark .le-stepper-footer .right__content .skip:disabled{background:#666;text-shadow:none;cursor:not-allowed}.le-stepper-footer .right__content .skip.theme-dark:disabled .button-label,.theme-dark .le-stepper-footer .right__content .skip:disabled .button-label{color:#adadad}.le-stepper-footer .right__content .skip.theme-dark:disabled:hover,.theme-dark .le-stepper-footer .right__content .skip:disabled:hover{border:1px solid #666;color:#adadad}.le-stepper-footer .right__content .skip.theme-dark .button-label,.theme-dark .le-stepper-footer .right__content .skip .button-label{color:#30437e}.le-stepper-footer .right__content .skip.theme-light,.theme-light .le-stepper-footer .right__content .skip{background-color:#c9d3f3;font-weight:700;border-radius:16px;font-family:Roboto;border:0;margin:auto 10px;cursor:pointer}.le-stepper-footer .right__content .skip.theme-light:hover,.theme-light .le-stepper-footer .right__content .skip:hover{border:1px solid #666;background-color:#ebecef;text-shadow:none}.le-stepper-footer .right__content .skip.theme-light:hover .button-label,.theme-light .le-stepper-footer .right__content .skip:hover .button-label{color:#575757}.le-stepper-footer .right__content .skip.theme-light:disabled,.theme-light .le-stepper-footer .right__content .skip:disabled{background:#bbc0c9;text-shadow:none;cursor:not-allowed}.le-stepper-footer .right__content .skip.theme-light:disabled .button-label,.theme-light .le-stepper-footer .right__content .skip:disabled .button-label{color:#c1c1c1}.le-stepper-footer .right__content .skip.theme-light:disabled:hover,.theme-light .le-stepper-footer .right__content .skip:disabled:hover{border:1px solid #bbc0c9;color:#c1c1c1}.le-stepper-footer .right__content .skip.theme-light .button-label,.theme-light .le-stepper-footer .right__content .skip .button-label{color:#30437e}.le-stepper-footer .back.theme-dark,.theme-dark .le-stepper-footer .back{background-color:rgba(104,112,146,.62);border:1px solid #8894bc;color:#bdc4dc;text-shadow:.5px .5px 0 rgba(0,0,0,.2),0 0 16px rgba(0,0,0,.6);font-weight:700;border-radius:16px;border:none;font-family:Roboto;cursor:pointer}.le-stepper-footer .back.theme-dark:hover,.theme-dark .le-stepper-footer .back:hover{color:#f0f0f0}.le-stepper-footer .back.theme-dark:disabled,.theme-dark .le-stepper-footer .back:disabled{color:#adadad;cursor:not-allowed}.le-stepper-footer .back.theme-dark:disabled:hover,.theme-dark .le-stepper-footer .back:disabled:hover{color:#adadad}.le-stepper-footer .back.theme-light,.theme-light .le-stepper-footer .back{background-color:hsla(0,0%,100%,.08);border:1px solid #8894bc;color:#30437e;text-shadow:.5px .5px 0 rgba(0,0,0,.2),0 0 16px rgba(0,0,0,.6);font-weight:700;border-radius:16px;border:none;font-family:Roboto;cursor:pointer}.le-stepper-footer .back.theme-light:hover,.theme-light .le-stepper-footer .back:hover{color:#242424}.le-stepper-footer .back.theme-light:disabled,.theme-light .le-stepper-footer .back:disabled{color:#adadad;cursor:not-allowed}.le-stepper-footer .back.theme-light:disabled:hover,.theme-light .le-stepper-footer .back:disabled:hover{color:#adadad}", "", {"version":3,"sources":["/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-vue-components/src/components/vue-components/le-stepper/le-stepper-footer.vue"],"names":[],"mappings":"AAIA,mBACE,4BAA6B,AAC7B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,UAAY,CACb,AACD,6DAEI,yBAA0B,AAC1B,UAAe,CAClB,AACD,+DAEI,yBAA0B,AAC1B,aAAe,CAClB,AACD,mCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAoB,CACvB,AACD,yGAEM,yBAA0B,AAC1B,WAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,SAAU,AACV,eAAgB,AAChB,iBAAmB,CACxB,AACD,qHAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AACD,2HAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,wBAAgC,AAChC,iBAAkB,AAClB,kBAAoB,CAC3B,AACD,uIAEU,mBAAoB,AACpB,yBAA0B,AAC1B,wBAAgC,AAChC,gBAAkB,CAC3B,AACD,2GAEM,yBAA0B,AAC1B,WAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,SAAU,AACV,eAAgB,AAChB,iBAAmB,CACxB,AACD,uHAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,CACzB,AACD,6HAEQ,mBAAoB,AACpB,yBAA0B,AAC1B,2BAAgC,AAChC,iBAAkB,AAClB,kBAAoB,CAC3B,AACD,yIAEU,mBAAoB,AACpB,yBAA0B,AAC1B,2BAAgC,AAChC,gBAAkB,CAC3B,AACD,yGAEM,sBAA0B,AAC1B,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,SAAU,AACV,iBAAkB,AAClB,cAAgB,CACrB,AACD,qHAEQ,sBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,CACzB,AACD,iJAEU,aAAe,CACxB,AACD,2HAEQ,gBAAoB,AACpB,iBAAkB,AAClB,kBAAoB,CAC3B,AACD,uJAEU,aAAe,CACxB,AACD,uIAEU,sBAA0B,AAC1B,aAAe,CACxB,AACD,qIAEQ,aAAe,CACtB,AACD,2GAEM,yBAA0B,AAC1B,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,SAAU,AACV,iBAAkB,AAClB,cAAgB,CACrB,AACD,uHAEQ,sBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,CACzB,AACD,mJAEU,aAAe,CACxB,AACD,6HAEQ,mBAAoB,AACpB,iBAAkB,AAClB,kBAAoB,CAC3B,AACD,yJAEU,aAAe,CACxB,AACD,yIAEU,yBAA0B,AAC1B,aAAe,CACxB,AACD,uIAEQ,aAAe,CACtB,AACD,yEAEI,uCAA4C,AAC5C,yBAA0B,AAC1B,cAAe,AACf,+DAAiF,AACjF,gBAAiB,AACjB,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,cAAgB,CACnB,AACD,qFAEM,aAAe,CACpB,AACD,2FAEM,cAAe,AACf,kBAAoB,CACzB,AACD,uGAEQ,aAAe,CACtB,AACD,2EAEI,qCAA4C,AAC5C,yBAA0B,AAC1B,cAAe,AACf,+DAAiF,AACjF,gBAAiB,AACjB,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,cAAgB,CACnB,AACD,uFAEM,aAAe,CACpB,AACD,6FAEM,cAAe,AACf,kBAAoB,CACzB,AACD,yGAEQ,aAAe,CACtB","file":"le-stepper-footer.vue","sourcesContent":["/******************************************/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/** DO NOT ADD COLORS WITHOUT UX/UI TEAM **/\n/******************************************/\n.le-stepper-footer {\n  padding: 26px 60px 26px 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n}\n.le-stepper-footer.theme-dark,\n  .theme-dark .le-stepper-footer {\n    background-color: #090c43;\n    color: #ffffff;\n}\n.le-stepper-footer.theme-light,\n  .theme-light .le-stepper-footer {\n    background-color: #F8FBFF;\n    color: #0A0A0A;\n}\n.le-stepper-footer .right__content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding-right: 30px;\n}\n.le-stepper-footer .right__content .next.theme-dark,\n    .theme-dark .le-stepper-footer .right__content .next {\n      background-color: #9a4709;\n      color: #ffffff;\n      font-weight: 700;\n      border-radius: 16px;\n      font-family: Roboto;\n      border: 0;\n      cursor: pointer;\n      margin-right: 32px;\n}\n.le-stepper-footer .right__content .next.theme-dark:hover,\n      .theme-dark .le-stepper-footer .right__content .next:hover {\n        background: #C1570A;\n        border: 1px solid #C1570A;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-stepper-footer .right__content .next.theme-dark:disabled,\n      .theme-dark .le-stepper-footer .right__content .next:disabled {\n        background: #813418;\n        border: 1px solid #813418;\n        color: rgba(155, 155, 155, 0.5);\n        text-shadow: none;\n        cursor: not-allowed;\n}\n.le-stepper-footer .right__content .next.theme-dark:disabled:hover,\n        .theme-dark .le-stepper-footer .right__content .next:disabled:hover {\n          background: #813418;\n          border: 1px solid #813418;\n          color: rgba(155, 155, 155, 0.5);\n          text-shadow: none;\n}\n.le-stepper-footer .right__content .next.theme-light,\n    .theme-light .le-stepper-footer .right__content .next {\n      background-color: #9a4709;\n      color: #ffffff;\n      font-weight: 700;\n      border-radius: 16px;\n      font-family: Roboto;\n      border: 0;\n      cursor: pointer;\n      margin-right: 32px;\n}\n.le-stepper-footer .right__content .next.theme-light:hover,\n      .theme-light .le-stepper-footer .right__content .next:hover {\n        background: #C1570A;\n        border: 1px solid #C1570A;\n        color: #ffffff;\n        text-shadow: none;\n}\n.le-stepper-footer .right__content .next.theme-light:disabled,\n      .theme-light .le-stepper-footer .right__content .next:disabled {\n        background: #e79a7e;\n        border: 1px solid #e79a7e;\n        color: rgba(252, 252, 253, 0.5);\n        text-shadow: none;\n        cursor: not-allowed;\n}\n.le-stepper-footer .right__content .next.theme-light:disabled:hover,\n        .theme-light .le-stepper-footer .right__content .next:disabled:hover {\n          background: #e79a7e;\n          border: 1px solid #e79a7e;\n          color: rgba(252, 252, 253, 0.5);\n          text-shadow: none;\n}\n.le-stepper-footer .right__content .skip.theme-dark,\n    .theme-dark .le-stepper-footer .right__content .skip {\n      background-color: #ffffff;\n      font-weight: 700;\n      border-radius: 16px;\n      font-family: Roboto;\n      border: 0;\n      margin: auto 10px;\n      cursor: pointer;\n}\n.le-stepper-footer .right__content .skip.theme-dark:hover,\n      .theme-dark .le-stepper-footer .right__content .skip:hover {\n        border: 1px solid #ffffff;\n        background-color: #535677;\n        text-shadow: none;\n}\n.le-stepper-footer .right__content .skip.theme-dark:hover .button-label,\n        .theme-dark .le-stepper-footer .right__content .skip:hover .button-label {\n          color: #f0f0f0;\n}\n.le-stepper-footer .right__content .skip.theme-dark:disabled,\n      .theme-dark .le-stepper-footer .right__content .skip:disabled {\n        background: #666666;\n        text-shadow: none;\n        cursor: not-allowed;\n}\n.le-stepper-footer .right__content .skip.theme-dark:disabled .button-label,\n        .theme-dark .le-stepper-footer .right__content .skip:disabled .button-label {\n          color: #adadad;\n}\n.le-stepper-footer .right__content .skip.theme-dark:disabled:hover,\n        .theme-dark .le-stepper-footer .right__content .skip:disabled:hover {\n          border: 1px solid #666666;\n          color: #adadad;\n}\n.le-stepper-footer .right__content .skip.theme-dark .button-label,\n      .theme-dark .le-stepper-footer .right__content .skip .button-label {\n        color: #30437e;\n}\n.le-stepper-footer .right__content .skip.theme-light,\n    .theme-light .le-stepper-footer .right__content .skip {\n      background-color: #C9D3F3;\n      font-weight: 700;\n      border-radius: 16px;\n      font-family: Roboto;\n      border: 0;\n      margin: auto 10px;\n      cursor: pointer;\n}\n.le-stepper-footer .right__content .skip.theme-light:hover,\n      .theme-light .le-stepper-footer .right__content .skip:hover {\n        border: 1px solid #666666;\n        background-color: #ebecef;\n        text-shadow: none;\n}\n.le-stepper-footer .right__content .skip.theme-light:hover .button-label,\n        .theme-light .le-stepper-footer .right__content .skip:hover .button-label {\n          color: #575757;\n}\n.le-stepper-footer .right__content .skip.theme-light:disabled,\n      .theme-light .le-stepper-footer .right__content .skip:disabled {\n        background: #bbc0c9;\n        text-shadow: none;\n        cursor: not-allowed;\n}\n.le-stepper-footer .right__content .skip.theme-light:disabled .button-label,\n        .theme-light .le-stepper-footer .right__content .skip:disabled .button-label {\n          color: #c1c1c1;\n}\n.le-stepper-footer .right__content .skip.theme-light:disabled:hover,\n        .theme-light .le-stepper-footer .right__content .skip:disabled:hover {\n          border: 1px solid #bbc0c9;\n          color: #c1c1c1;\n}\n.le-stepper-footer .right__content .skip.theme-light .button-label,\n      .theme-light .le-stepper-footer .right__content .skip .button-label {\n        color: #30437e;\n}\n.le-stepper-footer .back.theme-dark,\n  .theme-dark .le-stepper-footer .back {\n    background-color: rgba(104, 112, 146, 0.62);\n    border: 1px solid #8894bc;\n    color: #bdc4dc;\n    text-shadow: 0.5px 0.5px 0px rgba(0, 0, 0, 0.2), 0px 0px 16px rgba(0, 0, 0, 0.6);\n    font-weight: 700;\n    border-radius: 16px;\n    border: none;\n    font-family: Roboto;\n    cursor: pointer;\n}\n.le-stepper-footer .back.theme-dark:hover,\n    .theme-dark .le-stepper-footer .back:hover {\n      color: #f0f0f0;\n}\n.le-stepper-footer .back.theme-dark:disabled,\n    .theme-dark .le-stepper-footer .back:disabled {\n      color: #adadad;\n      cursor: not-allowed;\n}\n.le-stepper-footer .back.theme-dark:disabled:hover,\n      .theme-dark .le-stepper-footer .back:disabled:hover {\n        color: #adadad;\n}\n.le-stepper-footer .back.theme-light,\n  .theme-light .le-stepper-footer .back {\n    background-color: rgba(255, 255, 255, 0.08);\n    border: 1px solid #8894bc;\n    color: #30437e;\n    text-shadow: 0.5px 0.5px 0px rgba(0, 0, 0, 0.2), 0px 0px 16px rgba(0, 0, 0, 0.6);\n    font-weight: 700;\n    border-radius: 16px;\n    border: none;\n    font-family: Roboto;\n    cursor: pointer;\n}\n.le-stepper-footer .back.theme-light:hover,\n    .theme-light .le-stepper-footer .back:hover {\n      color: #242424;\n}\n.le-stepper-footer .back.theme-light:disabled,\n    .theme-light .le-stepper-footer .back:disabled {\n      color: #adadad;\n      cursor: not-allowed;\n}\n.le-stepper-footer .back.theme-light:disabled:hover,\n      .theme-light .le-stepper-footer .back:disabled:hover {\n        color: #adadad;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"le-stepper-footer"},[_c('le-button',{staticClass:"back",attrs:{"disabled":_vm.disableBack},on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v(_vm._s(_vm.translations.back))]),_vm._v(" "),_c('main',{staticClass:"right__content"},[(_vm.canSkip)?_c('le-button',{staticClass:"skip",attrs:{"disabled":_vm.disableSkip},on:{"click":function($event){return _vm.$emit('skip')}}},[_vm._v("\n      "+_vm._s(_vm.translations.skip)+"\n    ")]):_vm._e(),_vm._v(" "),_c('le-button',{staticClass:"next",attrs:{"disabled":_vm.disableNext,"variant":"primary"},on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(_vm._s(_vm.translations.next))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"le-stepper"},[_c('Header',{staticClass:"headers",attrs:{"translations":_vm.translations}}),_vm._v(" "),(_vm.items)?_c('div',{staticClass:"timeline"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,class:("" + (i != _vm.items.length - 1 ? 'timeline__wrap' : 'timeline__wrap2'))},[_c('section',{staticClass:"timeline__wrapper"},[_c('div',{staticClass:"timeline__container"},[_c('div',{staticClass:"timeline__steps"},[_c('div',{staticClass:"timeline__steps__index",class:{ 'active__index': _vm.currentIndex === i }},[_c('p',[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('div',{class:("timeline__steps__icon__" + (_vm.iconState(i)))}),_vm._v(" "),_c('div',{staticClass:"timeline__steps__text"},[_c('div',{staticClass:"timeline__steps__text__main",class:{
                  'active__text': _vm.currentIndex == i && !item.isMultiple,
                  'completed__text':
                   item.isActive ||
                   _vm.completeIndex > i ||
                   (_vm.completeIndex == i &&
                   item.isMultiple &&
                   item.children &&
                   item.children.length > _vm.completeChildIndex)
                },on:{"click":function($event){$event.preventDefault();return _vm.handleNavigation(item, i)}}},[_c('h5',[_vm._v(_vm._s(_vm.editMode ? item.editName || item.name : item.name))])]),_vm._v(" "),(item.children && item.isMultiple)?_c('span',{staticClass:"timeline__steps__text__children"},_vm._l((item.children),function(child,j){return _c('h5',{key:j,staticClass:"timeline__steps__text__child",class:{
                    'active__text': _vm.currentIndex == i && _vm.currentChildIndex == j,
                    'completed__text': child.isActive || _vm.completeIndex > i || (_vm.completeIndex == i && _vm.completeChildIndex >= j)
                  },on:{"click":function($event){$event.preventDefault();return _vm.handleNavigation(child, i, j)}}},[_c('span',[_vm._v(_vm._s(_vm.editMode ? child.editName || child.name : child.name))])])}),0):_vm._e()])])])])])}),0):_vm._e(),_vm._v(" "),_c('Footer',{staticClass:"footer",attrs:{"canGoNext":_vm.canGoNext,"canSkip":_vm.canSkip,"nextLoading":_vm.nextLoading,"backLoading":_vm.backLoading,"skipLoading":_vm.skipLoading,"translations":_vm.translations},on:{"skip":_vm.skip,"next":_vm.next,"back":_vm.back}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__incaTransformer__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__umsTransformer__ = __webpack_require__(729);



/* harmony default export */ __webpack_exports__["a"] = ({
  INCA: __WEBPACK_IMPORTED_MODULE_0__incaTransformer__,
  UMS: __WEBPACK_IMPORTED_MODULE_1__umsTransformer__
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["transform"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_LeTranscriptMessageModel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptMessageOriginatorModel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_LeTranscriptModel__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_consts__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function getMessageTypeAndMetadata(message) {
  var contentType = '';
  var metadata = void 0;
  var content = void 0;

  switch (message.type) {
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].LINK:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].EXTERNAL_FILE;
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].HOSTED_FILE:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].HOSTED_FILE;
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].PLAIN_TEXT:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].PLAIN_TEXT;
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].SECURE_FORM_INVITATION:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].SECURE_FORM_INVITATION;
        var secureFormData = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'messageData.secureForm');
        metadata = {
          formId: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(secureFormData, 'formId'),
          invitationId: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(secureFormData, 'invitationId'),
          title: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(secureFormData, 'formName')
        };
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].SECURE_FORM_SUBMISSION:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].SECURE_FORM_SUBMISSION;
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["b" /* HISTORY_MESSAGE_TYPES */].RICH_CONTENT:
      {
        metadata = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'contextData.structuredMetadata');
        try {
          content = JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'messageData.richContent.content'));
          contentType = content.type;
        } catch (e) {
          content = undefined;

          contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_VERTICAL;
        }
        break;
      }
    default:
      {
        contentType = __WEBPACK_IMPORTED_MODULE_2__consts__["g" /* UNKNOWN_CONTENT_TYPE */];
        break;
      }
  }

  return {
    type: contentType,
    metadata: metadata,
    content: content
  };
}

function getMessages2statusesMap(messageStatuses) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(messageStatuses, function (messageStatus) {
    if (messageStatus.participantType === __WEBPACK_IMPORTED_MODULE_2__consts__["f" /* PARTICIPANT_TYPES */].CONSUMER) {
      res[messageStatus.messageId] = messageStatus.messageDeliveryStatus;
    }
  });
  return res;
}

function getOriginator(message, participants) {
  var dialogId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'dialogId');
  var participantId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'participantId');
  var originatorData = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(participants, [dialogId, participantId]);

  return new __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptMessageOriginatorModel__["a" /* default */]({ id: originatorData.id, role: originatorData.role, nameForDisplay: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* getOriginatorNameForDisplay */])(originatorData) });
}

function getParticipants(conversationHistoryRecords) {
  var participants = {};
  var consumerParticipantDetails = {};

  Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(conversationHistoryRecords.consumerParticipants, function (consumerParticipant) {
    participants[consumerParticipant.dialogId] = participants[consumerParticipant.dialogId] || {};
    if (consumerParticipant.timeL > Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(participants, [consumerParticipant.dialogId, consumerParticipant.participantId, 'timeL'], 0)) {
      participants[consumerParticipant.dialogId][consumerParticipant.participantId] = _extends({}, consumerParticipant, {
        id: consumerParticipant.participantId,
        timeL: consumerParticipant.timeL,
        role: __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].ROLES.CONSUMER
      });
      consumerParticipantDetails = participants[consumerParticipant.dialogId][consumerParticipant.participantId];
    }
  });

  Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(conversationHistoryRecords.agentParticipants, function (agentParticipant) {
    participants[agentParticipant.dialogId] = participants[agentParticipant.dialogId] || {};
    if (agentParticipant.timeL > Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(participants, [agentParticipant.dialogId, agentParticipant.agentId, 'timeL'], 0)) {
      participants[agentParticipant.dialogId][agentParticipant.agentId] = _extends({}, agentParticipant, {
        id: agentParticipant.agentId,
        timeL: agentParticipant.timeL,
        role: agentParticipant.permission
      });

      participants[agentParticipant.dialogId][consumerParticipantDetails.id] = consumerParticipantDetails;
    }
  });

  return participants;
}

function getQuickReplies(message) {
  var quickReplies = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'messageData.quickReplies');
  try {
    if (quickReplies) {
      quickReplies = JSON.parse(quickReplies.content);
      return quickReplies;
    }
  } catch (e) {
    return undefined;
  }
  return undefined;
}

function getIntentData(message) {
  return message.intentData;
}

function transformMessages(conversationHistoryRecords, _ref) {
  var hoursSettings = _ref.hoursSettings;

  var messages = [];
  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(conversationHistoryRecords.messageRecords, 'length')) {
    var messages2statusesMap = getMessages2statusesMap(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(conversationHistoryRecords.messageStatuses, ['timeL'], ['asc']));
    var participants = getParticipants(conversationHistoryRecords);
    messages = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(conversationHistoryRecords.messageRecords, ['timeL'], ['asc']), function (message) {
      var params = _extends({
        id: message.messageId,
        audience: message.audience,
        text: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(message, 'messageData.msg.text', ''),
        time: message.time,
        status: messages2statusesMap[message.messageId] || __WEBPACK_IMPORTED_MODULE_2__consts__["d" /* MESSAGE_STATUSES */].SENT,
        originator: getOriginator(message, participants),
        quickReplies: getQuickReplies(message)
      }, getMessageTypeAndMetadata(message), {
        intentData: getIntentData(message)
      });
      return new __WEBPACK_IMPORTED_MODULE_1__models_LeTranscriptMessageModel__["a" /* default */](params, { hoursSettings: hoursSettings });
    });
  }
  return messages;
}

function transform(conversationHistoryRecords, _ref2) {
  var hoursSettings = _ref2.hoursSettings;

  var messages = transformMessages(conversationHistoryRecords, { hoursSettings: hoursSettings });
  var conversationId = conversationHistoryRecords.info.conversationId;
  return new __WEBPACK_IMPORTED_MODULE_4__models_LeTranscriptModel__["a" /* default */]({
    consumerMessageClassName: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getConsumerMessageClassName */])(conversationId),
    hoursSettings: hoursSettings,
    messages: messages,
    conversationId: conversationId
  });
}

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["transformParticipants"] = transformParticipants;
/* harmony export (immutable) */ __webpack_exports__["transform"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_LeTranscriptMessageModel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptModel__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_LeTranscriptMessageOriginatorModel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__consts_consts__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function getMessageId(seq, conversationId) {
  return 'ms::dialog:' + conversationId + '::msg:' + seq;
}

function getMessageAdditionalData(type, data) {
  var quickReplies = void 0;
  var metadata = void 0;
  var content = void 0;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].EXTERNAL_FILE:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].HOSTED_FILE:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].PLAIN_TEXT:
      {
        quickReplies = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(data, 'event.quickReplies');
        metadata = data.metadata;
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].SECURE_FORM_SUBMISSION:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].SECURE_FORM_INVITATION:
      {
        metadata = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(data, 'event.message');
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].IMAGE:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].CAROUSEL:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].LIST:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_VERTICAL:
    case __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].CARD_HORIZONTAL:
      {
        content = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(data, 'event.content');
        quickReplies = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(data, 'event.quickReplies');
        metadata = data.metadata;
        break;
      }
    default:
      {
        break;
      }
  }

  return {
    metadata: metadata,
    content: content,
    quickReplies: quickReplies
  };
}

function getMessages(events, originators, messages2statusesMap, _ref) {
  var hoursSettings = _ref.hoursSettings;

  var res = [];
  Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(events, function (event) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.type') === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].EVENT_TYPES.CONTENT || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.type') === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].EVENT_TYPES.RICH_CONTENT) {
      var id = getMessageId(event.sequence, event.dialogId);
      var type = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.contentType') || Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.content.type');
      var originator = originators[event.originatorId] || new __WEBPACK_IMPORTED_MODULE_5__models_LeTranscriptMessageOriginatorModel__["a" /* default */]({ id: event.originatorId, role: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'originatorMetadata.role') });
      res.push(new __WEBPACK_IMPORTED_MODULE_1__models_LeTranscriptMessageModel__["a" /* default */](_extends({
        id: id,
        audience: event.messageAudience,
        text: type === __WEBPACK_IMPORTED_MODULE_2__consts__["a" /* CONTENT_MESSAGE_TYPES */].PLAIN_TEXT ? Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.message', '') : '',
        time: event.serverTimestamp,
        type: type,
        status: messages2statusesMap[id] || __WEBPACK_IMPORTED_MODULE_2__consts__["d" /* MESSAGE_STATUSES */].SENT,
        originator: originator
      }, getMessageAdditionalData(type, event)), { hoursSettings: hoursSettings }));
    }
  });
  return res.sort(function (a, b) {
    return a.time - b.time;
  });
}
function getMessageStatuses(events) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(events, function (event) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.type') === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].EVENT_TYPES.ACCEPT_STATUS && Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'originatorMetadata.role') === __WEBPACK_IMPORTED_MODULE_6__consts_consts__["a" /* default */].ROLES.CONSUMER) {
      Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"])(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.sequenceList'), function (sequence) {
        res[getMessageId(sequence, event.dialogId)] = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(event, 'event.status');
      });
    }
  });
  return res;
}

function transformParticipants(participantsMap) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["reduce"])(participantsMap, function (acc, value, key) {
    acc[key] = new __WEBPACK_IMPORTED_MODULE_5__models_LeTranscriptMessageOriginatorModel__["a" /* default */]({
      id: value.userId,
      role: value.role,
      nameForDisplay: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* getOriginatorNameForDisplay */])(value)
    });
    return acc;
  }, {});
}

function transform(queryMessagesResponseBody, participantsMap, _ref2) {
  var hoursSettings = _ref2.hoursSettings;

  var sortedEvents = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["orderBy"])(queryMessagesResponseBody, ['serverTimestamp'], ['asc']);
  var conversationId = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(sortedEvents, '[0].dialogId');
  var messages2statusesMap = getMessageStatuses(sortedEvents);
  var participants = transformParticipants(participantsMap);
  var messages = getMessages(sortedEvents, participants, messages2statusesMap, { hoursSettings: hoursSettings });
  return new __WEBPACK_IMPORTED_MODULE_3__models_LeTranscriptModel__["a" /* default */]({ consumerMessageClassName: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getConsumerMessageClassName */])(conversationId), messages: messages, hoursSettings: hoursSettings, conversationId: conversationId });
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map